'use strict';

angular.module(
    'nfseApp',
    [
        'LocalStorageModule',
        'tmh.dynamicLocale',
        'pascalprecht.translate',
        'ui.bootstrap',
        'ngResource',
        'ui.router',
        'ngCookies',
        'ngCacheBuster',
        'infinite-scroll',
        'ui.utils.masks',
        'ncy-angular-breadcrumb',
        'cgNotify',
        'oitozero.ngSweetAlert',
        'idf.br-filters',
        'summernote',
        'ngIdle',
        'ngImgCrop',
        'AngularPrint',
        'ui.codemirror',
        'ngFileUpload',
        'vcRecaptcha',
        'angularMoment',
        'ngSanitize'
    ])

    .run(function ($rootScope, $location, $window, $http, $state, $translate, Language, Auth, Principal, VERSION) {
        $rootScope.VERSION = VERSION;
        $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams) {
            $rootScope.toState = toState;
            $rootScope.toStateParams = toStateParams;

            if (Principal.isIdentityResolved()) {
                Auth.authorize();
            }

            // Update the language
            //Language.getCurrent().then(function (language) {
            $translate.use("pt-br");
            // });

        });
        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams, localStorageService) {
            var titleKey = 'global.title';
            $rootScope.previousStateName = fromState.name;
            $rootScope.previousStateParams = fromParams;
            // Set the page title key to the one configured in state or use default one
            if (toState.data.pageTitle) {
                titleKey = toState.data.pageTitle;
            }
            $translate(titleKey).then(function (title) {
                // Change window title with translated one
                $window.document.title = title;
            });

            if (toState.name === 'credenciamento' || toState.name === 'documentacaoCredenciamento') {
                if (localStorageService && localStorageService.get("prestadorPrincipal") && localStorageService.get('prestadorPrincipal').prestador) {
                    $state.go('home');
                }
            }

            if ((fromState.name === 'login' && (toState.name === 'password'))) {
                $state.go('home');
            }

            if (fromState.name === 'login' && toState.name === 'finishReset') {
                $state.go('home');
            }

            document.body.scrollTop = document.documentElement.scrollTop = 0;

        });

        $rootScope.back = function () {
            // If previous state is 'activate' or do not exist go to 'home'
            if ($rootScope.previousStateName === 'activate' || $state.get($rootScope.previousStateName) === null) {
                $state.go('home', {}, {reload: true});
            } else {
                $state.go($rootScope.previousStateName, $rootScope.previousStateParams, {reload: true});
            }
        };
    })
    .factory('authInterceptor', function ($rootScope, $q, $location, localStorageService) {
        return {
            // Add authorization token to headers
            request: function (config) {
                config.headers = config.headers || {};
                var token = localStorageService.get('token');
                if (token && token.expires_at && token.expires_at > new Date().getTime()) {
                    config.headers.Authorization = 'Bearer ' + token.access_token;
                }
                if (localStorageService.get('prestadorPrincipal') && localStorageService.get('prestadorPrincipal').prestador) {
                    config.headers.Prestador = localStorageService.get('prestadorPrincipal').prestador.id;
                }
                return config;
            }
        };
    })
    .factory('authExpiredInterceptor', function ($rootScope, $q, $injector, localStorageService) {
        return {
            responseError: function (response) {
                var status = response.status;
                var Notificacao = $injector.get('Notificacao');
                var $filter = $injector.get('$filter');
                var $state = $injector.get('$state');
                if (status == 400) {
                    if (response.data && response.data.mensagens) {
                        var valor = "";
                        for (var i = 0; i < response.data.mensagens.length; i++) {
                            valor += $filter("translate")(response.data.mensagens[i]);
                            valor += "<br/>";
                        }
                        Notificacao.error(response.data.message, valor);
                    } else if (response.data.fieldErrors && response.data.fieldErrors.length > 0) {
                        var campos = "";
                        for (var i = 0; i < response.data.fieldErrors.length; i++) {
                            var field = response.data.fieldErrors[i];
                            var error = $filter("translate")('entity.errorCode.' + field.codigo);
                            var campo = "<b>" + $filter("translate")('nfseApp.' + field.entidade + '.' + field.campo) + "</b>";
                            campos = campos + " " + (campo + " - " + error + "</br>");
                        }
                        Notificacao.error("Atenção", campos);
                    } else if (response.data.message) {
                        Notificacao.error($filter("translate")('entity.errorCode.' + response.data.title), response.data.message);
                    } else if (response.data.error == 'invalid_grant') {
                        //Notificacao.error("Error - " + [status]);
                        console.log("Usuário inválido")
                    }
                    else {
                        Notificacao.error("Error - " + [status]);
                    }
                }
                if (status == 500) {
                    Notificacao.error(" Error - " + [status]);
                }
                if (response.status === 401 && (response.data.error == 'invalid_token' || response.data.error == 'Unauthorized')) {
                    localStorageService.remove('token');
                    var Principal = $injector.get('Principal');
                    if (Principal.isAuthenticated()) {
                        var Auth = $injector.get('Auth');
                        Auth.authorize(true);
                    }
                } else if (response.status === 401) {
                    $state.go("home");
                }
                return $q.reject(response);
            }
        };
    })

    .config(function ($stateProvider, $urlRouterProvider, $httpProvider, $locationProvider, $translateProvider, tmhDynamicLocaleProvider, httpRequestInterceptorCacheBusterProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);
        $urlRouterProvider.otherwise('/login');

        $stateProvider.state('out', {
            'abstract': true,
            views: {
                'navbar@': {
                    templateUrl: 'app/components/navbar/navbar.html',
                    controller: 'NavbarController'
                },
                'menu@': {
                    templateUrl: 'app/components/menu/navigation.html',
                },
                'footer@': {
                    templateUrl: 'app/components/footer/no-footer.html',
                }
            },
            data: {
                specialClass: "white-bg"
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    // $translatePartialLoader.addPart('global');
                }]
            }
        });

        $stateProvider.state('site', {
            'abstract': true,
            'parent': 'out',
            data: {
                specialClass: "white-bg"
            },
            views: {
                'navbar@': {
                    templateUrl: 'app/components/navbar/navbar.html',
                    controller: 'NavbarController'
                },
                'menu@': {
                    templateUrl: 'app/components/menu/navigation.html',
                    controller: 'NavbarController'
                },
                'footer@': {
                    templateUrl: 'app/components/footer/no-footer.html',
                    controller: 'NavbarController'
                }
            }
        });
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });
        $translateProvider.preferredLanguage('pt-br');
        $translateProvider.useCookieStorage();
        $translateProvider.useSanitizeValueStrategy('escaped');
        tmhDynamicLocaleProvider.localeLocationPattern('bower_components/angular-i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');

    }).config(function (IdleProvider, KeepaliveProvider, $breadcrumbProvider) {
    // configure Idle settings
    // IdleProvider.idle(1500); // in seconds
    // IdleProvider.timeout(300); // in seconds
    //KeepaliveProvider.interval(10); // in seconds
    $breadcrumbProvider.setOptions({
        template: '<ol class="breadcrumb">' +
        '<li>' +
        '<a ui-sref="home">Home</a>' +
        '</li>' +
        '<li ng-repeat="step in steps" ng-class="{active: $last}" ng-switch="$last || !!step.abstract">' +
        '<a ng-switch-when="false" href="{{step.ncyBreadcrumbLink}}">{{step.ncyBreadcrumbLabel}}</a>' +
        '<span ng-switch-when="true">{{step.ncyBreadcrumbLabel}}</span>' +
        '</li>' +
        '</ol>'
    });
})
    .filter("sanitize", ['$sce', function ($sce) {
        return function (htmlCode) {
            return $sce.trustAsHtml(htmlCode);
        }
    }])
    .run(function ($rootScope, $state, notify) {
        $rootScope.$state = $state;
        notify.config({
            duration: 10000
        });
    })
    .component('home', {
        template: '<h1>Home</h1><p>Hello!</p>',
        controller: function () {
            this.user = {name: 'world'};
        }
    });
;

(function () {
    'use strict';

    angular.module('nfseApp')
        .factory('Util', function ($resource, $window) {
            var service = this;
            service.apenasNumeros = function (valor) {
                return valor.replace(/[^0-9]+/g, '');
            };
            service.getMeses = function () {
                return [
                    {name: "JANEIRO", descricao: "Janeiro", numeroMes: 1},
                    {name: "FEVEREIRO", descricao: "Fevereiro", numeroMes: 2},
                    {name: "MARCO", descricao: "Março", numeroMes: 3},
                    {name: "ABRIL", descricao: "Abril", numeroMes: 4},
                    {name: "MAIO", descricao: "Maio", numeroMes: 5},
                    {name: "JUNHO", descricao: "Junho", numeroMes: 6},
                    {name: "JULHO", descricao: "Julho", numeroMes: 7},
                    {name: "AGOSTO", descricao: "Agosto", numeroMes: 8},
                    {name: "SETEMBRO", descricao: "Setembro", numeroMes: 9},
                    {name: "OUTUBRO", descricao: "Outubro", numeroMes: 10},
                    {name: "NOVEMBRO", descricao: "Novembro", numeroMes: 11},
                    {name: "DEZEMBRO", descricao: "Dezembro", numeroMes: 12}
                ];
            };
            service.getExercicioAtual = function () {
                return new Date().getFullYear();
            };
            service.getMesAtual = function () {
                var dataAtual = new Date();
                var meses = service.getMeses();
                for (var i = 0; i < meses.length; i++) {
                    if (meses[i].numeroMes == dataAtual.getMonth() + 1) {
                        return meses[i];
                    }
                }
            };
            service.getExercicios = function () {
                var primeiroExercicio = new Date().getFullYear();
                var exercicios = [];
                for (var i = primeiroExercicio; i >= (primeiroExercicio - 20); i--) {
                    exercicios.push(i);
                }
                return exercicios;
            };
            service.copyToClipboard = function (toCopy) {
                var body = angular.element($window.document.body);
                var textarea = angular.element('<textarea/>');
                textarea.css({
                    position: 'fixed',
                    opacity: '0'
                });

                textarea.val(toCopy);
                body.append(textarea);
                textarea[0].select();

                document.execCommand('copy');

                textarea.remove();
            };
            service.getNameMesFromNumero = function (numeroMes) {
                var meses = service.getMeses();
                for (var i = 0; i < meses.length; i++) {
                    if (meses[i].numeroMes === numeroMes) {
                        return meses[i].name;
                    }
                }
                return null;
            }
            service.roundToX = function (num, X) {
                return +(Math.round(num + "e+" + X) + "e-" + X);
            }
            service.roundTo2 = function (num) {
                return service.roundToX(num, 2);
            }
            return service;
        });
})();

function soAlfaNumerico(v) {
    if (v != undefined) {
        v = v.replace(/[^a-zA-Z0-9]/g, "");
    }
    return v;
}

(function () {
    'use strict';

angular.module('nfseApp')
    .factory('DataUtil', function ($resource) {
        var service = this;
        service.dateWithOutHoursMinutesSeconds = function dateWithOutHoursMinutesSeconds(date) {
            date = new Date(date);
            date.setHours(0);
            date.setMinutes(0);
            date.setSeconds(0);
            return date;
        };
        return service;
    });})();

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('home', {
                parent: 'site',
                url: '/',
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'Gráficos e Atividades'
                },
                ncyBreadcrumb: {
                    label: 'DashBoard'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/main/main.html',
                        controller: 'MainController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('mes');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
                });
    });

'use strict';

angular.module('nfseApp')
    .controller('MainController', function ($rootScope, $scope, $filter, Principal, localStorageService, $state, NotaFiscal, DeclaracaoMensalServico,
                                            TrocaEmpresa, MensagemContribuinteUsuarioService, $modal) {

        $scope.competencias = [];
        $scope.competenciaAtual = {};
        $scope.compenteciaAnterior = {};
        $scope.hoje = new Date();
        $scope.abrirTrocarEmpresa = abrirTrocarEmpresa;

        $scope.loadNotas = function () {
            DeclaracaoMensalServico.getEstatisticasDeclaradas({}, function (data) {
                $scope.competencias = data;
                for (var i = 0; i < $scope.competencias.length; i++) {
                    var competencia = $scope.competencias[i];
                    if (competencia.mes === $scope.hoje.getMonth() + 1) {
                        $scope.competenciaAtual = competencia;
                    }
                    if (competencia.mes === $scope.hoje.getMonth()) {
                        $scope.compenteciaAnterior = competencia;
                    }
                }
                if ($scope.prestadorPrincipal.prestador.enquadramentoFiscal &&
                    !$scope.prestadorPrincipal.prestador.enquadramentoFiscal.simplesNacional) {
                    $scope.montarGraficoFaturamento();
                } else {
                    $scope.montarGraficoRbt12();
                }
            });
        };

        $scope.role = function (role) {
            return Principal.isInRole(role);
        };


        $scope.calculaCompetencia = function () {
            if ($scope.competenciaAtual && $scope.compenteciaAnterior) {
                $scope.competenciaAtual.porcentagemEmissao =
                    $scope.calculaCrescimento($scope.compenteciaAnterior.emitidas, $scope.competenciaAtual.emitidas);
                $scope.competenciaAtual.porcentagemRetencao =
                    $scope.calculaCrescimento($scope.compenteciaAnterior.retidas, $scope.competenciaAtual.retidas);
                $scope.competenciaAtual.porcentagemCancelamento =
                    $scope.calculaCrescimento($scope.compenteciaAnterior.canceladas, $scope.competenciaAtual.canceladas);
                $scope.competenciaAtual.porcentagemValor =
                    $scope.calculaCrescimento($scope.compenteciaAnterior.totalServicos, $scope.competenciaAtual.totalServicos);
                $scope.competenciaAtual.porcentagemIss =
                    $scope.calculaCrescimento($scope.compenteciaAnterior.iss, $scope.competenciaAtual.iss);
            } else {
                $scope.competenciaAtual.porcentagemEmissao = 0;
                $scope.competenciaAtual.porcentagemCancelamento = 0;
                $scope.competenciaAtual.porcentagemRetencao = 0;
                $scope.competenciaAtual.porcentagemValor = 0;
                $scope.competenciaAtual.porcentagemIss = 0;
            }
        };

        $scope.calculaCrescimento = function (anterior, atual) {
            var diferenca = atual - anterior;
            if (diferenca !== 0) {
                diferenca = diferenca / anterior;
                return diferenca * 100;
            } else {
                return 0;
            }
        }

        $scope.valorMedioMensal = 0;
        $scope.quantidadeMediaMensal = 0;

        $scope.montarGraficoFaturamento = function () {
            var meses = [], valorServicos = [], valorIss = [];

            var valorTotal = 0;
            var quantidadeTotal = 0;
            var mesesQueTemNota = 0;
            angular.forEach($scope.competencias, function (nota) {
                meses.push(nota.ano + '/'+ $filter('translate')('nfseApp.Mes.' + nota.mes));

                valorServicos.push(nota.totalServicos);
                valorIss.push(nota.iss);
                if (nota.totalServicos && nota.totalServicos > 0) {
                    valorTotal = valorTotal + nota.totalServicos;
                    quantidadeTotal = quantidadeTotal + nota.emitidas;
                    mesesQueTemNota = mesesQueTemNota + 1;
                }
            });
            $scope.valorMedioMensal = valorTotal / mesesQueTemNota;
            $scope.quantidadeMediaMensal = quantidadeTotal / mesesQueTemNota;

            $scope.lineData = {
                labels: meses,
                datasets: [
                    {
                        label: "Faturamento",
                        fillColor: "rgba(26,179,148,0.5)",
                        strokeColor: "rgba(26,179,148,0.7)",
                        pointColor: "rgba(26,179,148,1)",
                        pointStrokeColor: "#fff",
                        pointHighlightFill: "#fff",
                        pointHighlightStroke: "rgba(26,179,148,1)",
                        data: valorServicos
                    },
                    {
                        label: "ISS",
                        fillColor: "rgba(26, 123, 185, 1)",
                        strokeColor: "rgba(26,123,148,0.7)",
                        pointColor: "rgba(26,123,148,1)",
                        pointStrokeColor: "#fff",
                        pointHighlightFill: "#fff",
                        pointHighlightStroke: "rgba(26,123,148,1)",
                        data: valorIss
                    }
                ]
            };

            $scope.calculaCompetencia();
        };

        $scope.montarGraficoRbt12 = function () {
            var receitas = $scope.prestadorPrincipal.prestador.ultimasReceitasTributariaBruta;

            var meses = [], valorRbt = [];

            angular.forEach(receitas, function (receita) {
                meses.push(receita.ano + '/' + $filter('translate')('nfseApp.Mes.' + receita.mes));
                valorRbt.push(receita.valorBruto);
            });

            $scope.lineData = {
                labels: meses,
                datasets: [
                    {
                        label: "Receita Bruta",
                        fillColor: "rgba(26,179,148,0.5)",
                        strokeColor: "rgba(26,179,148,0.7)",
                        pointColor: "rgba(26,179,148,1)",
                        pointStrokeColor: "#fff",
                        pointHighlightFill: "#fff",
                        pointHighlightStroke: "rgba(26,179,148,1)",
                        data: valorRbt
                    }
                ]
            };
        };

        $scope.lineOptions = {
            scaleShowGridLines: true,
            scaleGridLineColor: "rgba(0,0,0,.05)",
            scaleGridLineWidth: 1,
            bezierCurve: true,
            bezierCurveTension: 0.4,
            pointDot: true,
            pointDotRadius: 4,
            pointDotStrokeWidth: 1,
            pointHitDetectionRadius: 20,
            datasetStroke: true,
            datasetStrokeWidth: 2,
            datasetFill: true
        };


        function abrirTrocarEmpresa() {
            TrocaEmpresa.open();
        }

        $scope.init = function () {
            Principal.identity().then(function (account) {
                $scope.account = account;
                $scope.isAuthenticated = Principal.isAuthenticated;
                $scope.prestadorPrincipal = localStorageService.get("prestadorPrincipal");
                if ($scope.prestadorPrincipal && !$scope.prestadorPrincipal.permitido && $scope.prestadorPrincipal.prestador) {
                    $state.go("documentacaoCredenciamento", {id: $scope.prestadorPrincipal.prestador.id});
                } else if ($scope.prestadorPrincipal) {
                    $scope.loadNotas();
                }
            });
        }

        $scope.init();
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('reciboRetencaoIss', {
                parent: 'out',
                url: '/recibo-retencao-iss',
                ncyBreadcrumb: {
                    label: 'Recibo de Retenção de Iss'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/externo/reciboRetencaoIss/reciboRetencaoIss.html',
                        controller: 'ReciboRetencaoIssController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('situacaoParcela');
                        return $translate.refresh();
                    }]
                }
            })
    });

'use strict';

angular.module('nfseApp')
    .controller('ReciboRetencaoIssController',
        function ($scope, NotaFiscal, ParseLinks, Notificacao, ImpressaoPdf) {
            $scope.notaFiscals = [];
            $scope.per_page = 20;
            $scope.cpfCnpj = null;
            $scope.pesquisou = false;
            $scope.recaptcha = null;

            $scope.loadAll = function () {
                if (!$scope.cpfCnpj) {
                    Notificacao.warn('Atenção', 'Informe o CPF/CNPJ.');
                    return;
                }
                if (!$scope.recaptcha) {
                    Notificacao.error('Erro', 'Captcha Inválido.');
                    return;
                }
                NotaFiscal.getServicosDeclaradosIssRetido({
                    page: $scope.page ? $scope.page - 1 : 0,
                    per_page: $scope.per_page,
                    cpfCnpj: $scope.cpfCnpj
                }, function (result, headers) {
                    if (headers)
                        $scope.links = ParseLinks.parse(headers('link'));
                    $scope.notaFiscals = result;
                    $scope.pesquisou = true;
                });
            };

            $scope.loadPage = function (page) {
                $scope.page = page;
                $scope.loadAll();
            };

            $scope.novaConsulta = function () {
                $scope.pesquisou = false;
                $scope.cpfCnpj = null;
            };

            $scope.imprimirRecibo = function (id) {
                ImpressaoPdf.imprimirPdfViaUrl('/api/notaFiscals/imprime-recibo-retencao/' + id);
            };
        });


'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('pesquisa-cnae', {
                parent: 'out',
                url: '/pequisa-cnae',
                ncyBreadcrumb: {
                    label: 'Pesquisa CNAE'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/externo/pesquisa-cnae/pesquisa-cnae.html',
                        controller: 'PesquisaCnaeController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('PesquisaCnaeController', function ($scope, Cnae, Servico, ParseLinks, ExportarXls) {

        $scope.links = null;
        $scope.page = null;
        $scope.filtro = "";
        $scope.cnaes = null;
        $scope.per_page = 10;
        $scope.pesquisarPorCnae = true;

        $scope.buscarCneaOrServico = function () {
            $scope.cnaes = null;
            if ($scope.pesquisarPorCnae)
                Cnae.buscarPorServico({
                    page: $scope.page,
                    per_page: $scope.per_page,
                    filtro: $scope.filtro
                }, function (result, headers) {
                    $scope.links = ParseLinks.parse(headers('link'));
                    $scope.cnaes = result;
                });
            else
                Servico.buscarPorCnae({
                    page: $scope.page,
                    per_page: $scope.per_page,
                    filtro: $scope.filtro
                }, function (result, headers) {
                    $scope.links = ParseLinks.parse(headers('link'));
                    $scope.cnaes = result;
                });
        };

        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.buscarCneaOrServico();
        };

        $scope.baixar = function (parametro) {
            var conteudo = {
                colunas: [
                    {descricao: 'Código', valor: 'codigo'},
                    {descricao: 'Descrição', valor: 'descricao'}
                ],
                linhas: $scope.cnaes
            };
            switch (parametro) {
                case 'pdf':
                    ExportarXls.getPdf(conteudo);
                    break;
                case 'xls':
                    ExportarXls.getXls(conteudo);
            }

        };
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('perguntas-respostas', {
                parent: 'out',
                url: '/perguntas-respostas',
                ncyBreadcrumb: {
                    label: 'Perguntas e Respostas'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/externo/perguntas-respostas/perguntas-respostas.html',
                        controller: 'PerguntasRespostasController'
                    }
                },
                resolve: {}
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('PerguntasRespostasController', function ($scope, PerguntasRespostasService) {

        $scope.perguntasPorAssunto = [];
        $scope.perguntasAndRespostas = [];

        function indexOfAssunto(assunto) {
            var indexOf = -1;
            angular.forEach($scope.perguntasPorAssunto, function (data) {
                if (data.assunto.id == assunto.id) {
                    indexOf = $scope.perguntasPorAssunto.indexOf(data);
                }
            });
            return indexOf;
        }

        function agruparPorAssunto(perguntas) {
            angular.forEach(perguntas, function (data) {
                var indexOf = indexOfAssunto(data.assuntoNfseDTO);
                if (indexOf == -1) {
                    $scope.perguntasPorAssunto.push({'assunto': data.assuntoNfseDTO, 'perguntas': []});
                    indexOf = 0;
                }
                $scope.perguntasPorAssunto[indexOf].perguntas.push(data);
            });
        }

        function buscarPerguntasRespostasParaExibicao() {
            PerguntasRespostasService.perguntasRespostasParaExibicao(function (data) {
                $scope.perguntasAndRespostas = data;
            });
        }

        buscarPerguntasRespostasParaExibicao();
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('nota-premiada', {
                parent: 'out',
                url: '/notas-premiadas',
                ncyBreadcrumb: {
                    label: 'Nota Premiada'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/externo/nota-premiada/nota-premiada.html',
                        controller: 'NotaPremiadaController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('NotaPremiadaController', function ($scope, NotaPremiadaService, $modal, SweetAlert, Principal) {

        $scope.notas = [];
        $scope.premios = [];
        $scope.account = {};

        function buscarUsuarioLogado() {
            Principal.identity().then(function (account) {
                if (account) {
                    $scope.account = account;
                }
            });
        }

        buscarUsuarioLogado();

        function buscarNotaPremiadaParaExibicao() {
            NotaPremiadaService.notaPremiadaParaExibicao(function (data) {
                $scope.notas = data;
            });
        }

        buscarNotaPremiadaParaExibicao();

        function buscarTodosPremios() {
            NotaPremiadaService.buscarTodosPremios(function (data) {
                $scope.premios = data;
            });
        }

        buscarTodosPremios();


        $scope.verDetalhes = function (nota) {
            var modalInstance = $modal.open({
                templateUrl: 'app/externo/nota-premiada/nota-premiada-detalhes.html',
                controller: 'NotaPremiadaDetalhesController',
                size: 'lg',
                resolve: {
                    nota: function () {
                        return nota;
                    }
                }
            });

        };

        $scope.verBilhetes = function (nota) {
            var modalInstance = $modal.open({
                templateUrl: 'app/externo/nota-premiada/nota-premiada-detalhes-bilhete.html',
                controller: 'NotaPremiadaDetalhesBilheteController',
                size: 'lg',
                resolve: {
                    nota: function () {
                        return nota;
                    },

                }
            });
        };

        $scope.anularParticipacaoCampanha = function (nota) {
            SweetAlert.swal({
                    title: "Confirme a operação",
                    text: "Você tem certeza que não quer participar dessa campanha?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55", confirmButtonText: "Sim, Não quero participar!",
                    cancelButtonText: "Não, Cancelar",
                    closeOnConfirm: false,
                    closeOnCancel: false
                },
                function (isConfirm) {
                    if (isConfirm) {
                        anularParticipacao(nota);
                    } else {
                        SweetAlert.info("Cancelado", "Operação Cancelada", "error");
                    }
                });
        };

        function anularParticipacao(nota) {
            var notaPremiadaPessoa = {
                login: $scope.account.login,
                id: nota.id
            };
            NotaPremiadaService.anularParticipacaoCampanha(notaPremiadaPessoa, function () {
                SweetAlert.info("Tudo Certo!", "Participação na campanha cancelada!", "success");
            });
        }

        $scope.verBilhetesPremiados = function (nota) {
            var modalInstance = $modal.open({
                templateUrl: 'app/externo/nota-premiada/nota-premiada-detalhes-bilhete-premiado.html',
                controller: 'NotaPremiadaDetalhesBilhetePremiadoController',
                size: 'lg',
                resolve: {
                    nota: function () {
                        return nota;
                    }
                }
            });

        };

    });

angular.module('nfseApp')
    .controller('NotaPremiadaDetalhesController', function ($scope, $modalInstance, nota, NotaPremiadaService) {

        $scope.nota = nota;

        $scope.premios = [];

        function buscarPremios() {
            NotaPremiadaService.buscarPremios(
                {id: $scope.nota.id}, function (result) {
                    $scope.premios = result;
                }
            );
        }

        buscarPremios();

        $scope.ok = function (nota) {
            $modalInstance.close(nota);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    });

angular.module('nfseApp')
    .controller('NotaPremiadaDetalhesBilheteController', function ($scope, $modalInstance, nota, NotaPremiadaService, Principal) {

        $scope.nota = nota;

        $scope.bilhetes = [];

        $scope.account = {};

        function buscarUsuarioLogado() {
            Principal.identity().then(function (account) {
                if (account) {
                    $scope.account = account;
                    buscarBilhetes();
                }
            });
        }

        buscarUsuarioLogado();

        function buscarBilhetes() {
            NotaPremiadaService.buscarBilhetes(
                {
                    login: $scope.account.login,
                    id: nota.id
                }, function (result) {
                    $scope.bilhetes = result;
                }
            );
        }


        $scope.ok = function (nota) {
            $modalInstance.close(nota);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    });

angular.module('nfseApp')
    .controller('NotaPremiadaDetalhesBilhetePremiadoController', function ($scope, $modalInstance, nota, NotaPremiadaService) {

        $scope.nota = nota;

        $scope.bilhetes = [];

        function buscarBilhetesPremiados() {
            NotaPremiadaService.buscarBilhetesPremiados(
                {id: $scope.nota.id}, function (result) {
                    $scope.bilhetes = result;
                }
            );
        }

        buscarBilhetesPremiados();

        $scope.ok = function (nota) {
            $modalInstance.close(nota);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('manual', {
                parent: 'out',
                url: '/manuais',
                ncyBreadcrumb: {
                    label: 'Manuais'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/externo/manual/manual.html',
                        controller: 'ManualController'
                    }
                },
                resolve: {}
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('ManualController', function ($scope, ManualService, $modal) {

        $scope.manuais = [];

        function buscarManuaisParaExibicao() {
            ManualService.manuaisParaExibicao(function (data) {
                $scope.manuais = data;
            });
        }

        buscarManuaisParaExibicao();


        $scope.verDetalhes = function (manual) {
            var modalInstance = $modal.open({
                templateUrl: 'app/externo/manual/manual-detalhes.html',
                controller: 'ManualDetalhesController',
                size: 'lg',
                resolve: {
                    manual: function () {
                        return manual;
                    }
                }
            });

        };

    });

angular.module('nfseApp')
    .controller('ManualDetalhesController', function ($scope, $modalInstance, manual) {

        $scope.manual = manual;

        $scope.ok = function (manual) {
            $modalInstance.close(manual);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('legislacao', {
                parent: 'out',
                url: '/legislacoes',
                ncyBreadcrumb: {
                    label: 'Legislações'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/externo/legislacao/legislacao.html',
                        controller: 'LegislacaoController'
                    }
                },
                resolve: {

                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('LegislacaoController', function ($scope, LegislacaoService, $modal) {

        $scope.legislacoes = [];

        function buscarLegislacoesParaExibicao() {
            LegislacaoService.legislacoesParaExibicao(function (data) {
                $scope.legislacoes = data;
            });
        }

        buscarLegislacoesParaExibicao();


        $scope.verDetalhes = function (legislacao) {
            var modalInstance = $modal.open({
                templateUrl: 'app/externo/legislacao/legislacao-detalhes.html',
                controller: 'LegislacaoDetalhesController',
                size: 'lg',
                resolve: {
                    legislacao: function () {
                      return legislacao;
                    }
                }
            });

        };

    });

angular.module('nfseApp')
    .controller('LegislacaoDetalhesController', function ($scope, $modalInstance, legislacao) {

        $scope.legislacao = legislacao;

        $scope.ok = function (legislacao) {
            $modalInstance.close(legislacao);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('faleconosco', {
                parent: 'out',
                url: '/fale-conosco',
                ncyBreadcrumb: {
                    label: 'Fale Conosco'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/externo/fale-conosco/fale-conosco.html',
                        controller: 'FaleConoscoController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('register');
                        $translatePartialLoader.addPart('global');

                        return $translate.refresh();
                    }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('FaleConoscoController',
        function ($scope, $state, $http, $translate, $timeout, FaleConoscoService, Notificacao) {

            $scope.faleConosco = {};

            $scope.loadAll = function () {
            };

            $scope.loadAll();


            $scope.save = function () {
                console.log('retorno..: ' + JSON.stringify($scope.faleConosco));
                FaleConoscoService.save($scope.faleConosco, function (data) {
                    console.log('retorno..: ' + JSON.stringify(data));
                    if (data.id) {
                        $state.go("home", {}, {reload: true});
                        Notificacao.info("Operação Realizada", "Sua solicitação foi encaminhada para o departamento responsável. Entraremos em contato o mais breve possível.");
                    } else {
                        Notificacao.error("Algo inesperado aconteceu!", "Entre em contato com o suporte da prefeitura.");
                    }
                });
            };

            $scope.atribuirTipo = function (tipo) {
                $scope.faleConosco.tipo = tipo;
            }

        });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'site',
                url: '/error',
                data: {
                    roles: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'site',
                url: '/accessdenied',
                data: {
                    roles: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    });

(function () {
    'use strict';

    angular.module('nfseApp')
        .controller('WaitReportController', function ($scope, $modalInstance, $timeout, uuid, Report,
                                                      ImpressaoPdf) {
            $scope.uuid = uuid;
            $scope.webReport = null;
            $scope.timeout = null;

            $scope.getWebReport = function () {
                console.log('get uuid', $scope.uuid);
                Report.getByUuid({uuid: $scope.uuid}, function (data) {
                    $scope.webReport = data;
                    if (!$scope.webReport.finalizadoEm) {
                        $scope.timeout = $timeout(function () {
                            $scope.getWebReport();
                        }, 5000)
                    } else {
                        $timeout.cancel($scope.timeout);
                    }
                });
            }

            $scope.getWebReport();

            $scope.imprimir = function () {
                $modalInstance.close(false);
                ImpressaoPdf.imprimirPdfViaUrl('/spring/report/imprimir/' + $scope.webReport.uuid);
            }

            $scope.cancel = function () {
                $modalInstance.close(false);
            }

            $scope.$on("$destroy", function (event) {
                $timeout.cancel($scope.timeout);
            });
        });
})();

'use strict';

angular.module('nfseApp')
    .controller('TomadorSearchController', function ($scope, $timeout, Tomador, TomadorSearch, ParseLinks, SweetAlert, $modalInstance) {
        $scope.tomadors = [];
        $scope.page = 1;
        $scope.per_page = 5;

        $timeout(function () {
            angular.element('[name="searchQuery"]').focus();
        });


        $scope.loadAll = function () {
            Tomador.query({
                page: $scope.page,
                per_page: $scope.per_page
            }, function (result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.tomadors = result;
            });
        };

        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };

        $scope.loadAll();

        $scope.search = function () {
            if(!$scope.searchQuery){
                $scope.searchQuery = '';
            }
            Tomador.query({query: $scope.searchQuery},
                function (result) {
                    $scope.tomadors = result;
                }, function (response) {
                    if (response.status === 404) {
                        $scope.loadAll();
                    }
                });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.tomador = {codigo: null, descricao: null, ativo: null, id: null};
        };

        $scope.ok = function (tomador) {
            $modalInstance.close(tomador);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    });

'use strict';

angular.module('nfseApp').controller('TomadorEditController',
    ['$scope', '$state', '$modal', '$stateParams', 'entity', 'Tomador', 'PrestadorServicos', 'Notificacao', 'localStorageService',
        'Municipio', 'CEP',
        function ($scope, $state, $modal, $stateParams, entity, Tomador, PrestadorServicos, Notificacao, localStorageService,
                  Municipio, CEP) {

            $scope.tomador = entity;
            // $scope.prestadorservicoss = PrestadorServicos.query();

            $scope.load = function (id) {
                Tomador.get({id: id}, function (result) {
                    $scope.tomador = result;
                });
            };

            $scope.loadEnderecoByCEP = function (cep) {
                if (cep) {
                    CEP.getByCep({cep: cep}, function (endereco) {
                        console.log(endereco);
                        if (endereco.municipio) {
                            $scope.tomador.dadosPessoais.cep = endereco.cep;
                            $scope.tomador.dadosPessoais.municipio = endereco.municipio;
                            $scope.tomador.dadosPessoais.logradouro = endereco.logradouro;
                            $scope.tomador.dadosPessoais.bairro = endereco.bairro;
                        }
                    });
                }
            };


            $scope.searchMunicipio = function () {
                var modalInstance = $modal.open({
                    templateUrl: 'app/entities/municipio/municipio-search.html',
                    controller: 'MunicipioSearchController',
                    size: 'lg'
                });
                modalInstance.result.then(function (municipio) {
                    $scope.tomador.dadosPessoais.municipio = municipio;
                }, function () {
                    //$log.info('Modal dismissed at: ' + new Date());
                });
            };

            $scope.loadInPessoaRepoByCpfCnpj = function () {
                if ($scope.tomador && $scope.tomador.dadosPessoais) {
                    Tomador.getTomadorPorCpfCnpj({cpfCnpj: $scope.tomador.dadosPessoais.cpfCnpj}, function (result) {
                        if (!result.dadosPessoais) {
                            Tomador.getInPessoRepoByCpfCnpj({cpfCnpj: $scope.tomador.dadosPessoais.cpfCnpj}, function (result) {
                                if (result.dadosPessoais && result.dadosPessoais.cpfCnpj) {
                                    $scope.tomador = result;
                                }
                            });
                        } else {
                            $scope.tomador = result;
                            Notificacao.error("Atenção", "Já existe um Tomador com o CPF ou CNPJ informado");
                            $scope.editForm.cpfCnpj.$setValidity("exists", false);
                        }
                    });
                }
            };

            var onSaveFinished = function (result) {
                $scope.$emit('nfseApp:tomadorUpdate', result);
                $state.go("tomador");
                Notificacao.info("Tomador salvo com sucesso")
            };

            $scope.save = function () {
                $scope.tomador.prestador = localStorageService.get("prestadorPrincipal").prestador;

                if ($scope.tomador.id != null) {
                    Tomador.update($scope.tomador, onSaveFinished);
                } else {
                    Tomador.save($scope.tomador, onSaveFinished);
                }
            };

            $scope.clear = function () {
                console.log("clear");
            };
        }]);

'use strict';

angular.module('nfseApp')
    .controller('TomadorDetailController', function ($scope, $rootScope, $stateParams, entity, Tomador) {
        $scope.tomador = entity;
        $scope.load = function (id) {
            Tomador.get({id: id}, function(result) {
                $scope.tomador = result;
            });
        };
        $rootScope.$on('nfseApp:tomadorUpdate', function(event, result) {
            $scope.tomador = result;
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('Tomador', function ($resource, DateUtils) {
        return $resource('api/tomadors/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getInPessoRepoByCpfCnpj': {
                method: 'GET',
                url: "api/tomador_pessoa_repo/:cpfCnpj",
                transformResponse: function (data) {
                    if (data)
                        data = angular.fromJson(data);
                    return data;
                }
            },
            'getTomadorPorCpfCnpj': {
                method: 'GET',
                url: "api/tomador_por_cpfCnpj/:cpfCnpj",
                transformResponse: function (data) {
                    if (data)
                        data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('TomadorSearch', function ($resource) {
        return $resource('api/_search/tomadors/:query', {}, {
            'query': { method: 'GET', isArray: true}
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('tomador', {
                parent: 'entity',
                url: '/tomador',
                data: {
                    roles: ['ROLE_EMPRESA_TOMADOR'],
                    pageTitle: 'Tomador de Serviços'
                },
                ncyBreadcrumb: {
                    label: 'Consulta de Tomadores de Serviço '
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tomador/tomadors.html',
                        controller: 'TomadorController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tomador');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('dadosPessoais');
                        return $translate.refresh();
                    }]
                }
            })
            .state('tomador.detail', {
                parent: 'tomador',
                url: '/detalhes/{id}',
                data: {
                    roles: ['ROLE_EMPRESA_TOMADOR'],
                    pageTitle: 'Tomador de Serviços'
                },
                ncyBreadcrumb: {
                    label: 'Detalhes do Tomador de Serviço'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tomador/tomador-detail.html',
                        controller: 'TomadorDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tomador');
                        $translatePartialLoader.addPart('dadosPessoais');
                        $translatePartialLoader.addPart('endereco');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Tomador', function ($stateParams, Tomador) {
                        return Tomador.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tomador.new', {
                parent: 'tomador',
                url: '/novo',
                data: {
                    roles: ['ROLE_EMPRESA_TOMADOR'],
                    pageTitle: 'Tomador de Serviços'
                },
                ncyBreadcrumb: {
                    label: 'Novo Tomador de Serviço'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tomador/tomador-edit.html',
                        controller: 'TomadorEditController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tomador');
                        $translatePartialLoader.addPart('dadosPessoais');
                        $translatePartialLoader.addPart('endereco');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['localStorageService', function (localStorageService) {
                        return {id: null, prestador: localStorageService.get("prestadorPrincipal")};
                    }]
                }
            })
            .state('tomador.edit', {
                parent: 'tomador',
                url: '/edicao/{id}',
                data: {
                    roles: ['ROLE_EMPRESA_TOMADOR'],
                    pageTitle: 'Tomador de Serviços'
                },
                ncyBreadcrumb: {
                    label: 'Edição do Tomador de Serviço'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tomador/tomador-edit.html',
                        controller: 'TomadorEditController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tomador');
                        $translatePartialLoader.addPart('dadosPessoais');
                        $translatePartialLoader.addPart('endereco');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['Tomador', '$stateParams', function (Tomador, $stateParams) {
                        return Tomador.get({id: $stateParams.id});
                    }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('TomadorController', function ($scope, $filter, Tomador, TomadorSearch, ParseLinks, Notificacao, ExportarXls) {
        $scope.tomadors = [];
        $scope.page = 1;
        $scope.per_page = 10;
        $scope.loadAll = function () {
            Tomador.query({
                page: $scope.page,
                per_page: $scope.per_page
            }, function (result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.tomadors = result;
            });
        };
        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            Tomador.get({id: id}, function (result) {
                $scope.tomador = result;

                Notificacao.confirmDelete(
                    function () {
                        $scope.confirmDelete(id);
                    });

            });
        };

        $scope.confirmDelete = function (id) {
            Tomador.delete({id: id},
                function () {
                    $scope.loadAll();
                    Notificacao.info("Removido!", "O Tomador foi removido com sucesso.");
                }, function (error) {
                    Notificacao.warn("Atenção!", "O Tomador possúi vinculo com nota fiscal. Por isso não pode ser excluído.");
                });
        };

        $scope.search = function () {
            Tomador.query({query: $scope.searchQuery}, function (result) {
                $scope.tomadors = result;
            }, function (response) {
                if (response.status === 404) {
                    $scope.loadAll();
                }
            });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.tomador = {id: null};
        };


        var colunas = [
            {descricao: 'Apelido', valor: 'apelido'},
            {descricao: 'Cpf/Cnpj', valor: 'cpfCnpj'},
            {descricao: 'Nome/Razão Social', valor: 'nomeRazaoSocial'},
            {descricao: 'Email', valor: 'email'},
        ];

        function getLinhas() {
            var linhas = [];
            for (var i = 0; i < $scope.tomadors.length; i++) {
                var tomador = $scope.tomadors[i];
                tomador.apelido =
                    linhas.push({
                        apelido: tomador.dadosPessoais.apelido,
                        cpfCnpj: tomador.dadosPessoais.cpfCnpj,
                        nomeRazaoSocial: tomador.dadosPessoais.nomeRazaoSocial,
                        email: tomador.dadosPessoais.email
                    });
            }
            return linhas;
        }

        $scope.baixarXls = function () {
            var xls = {
                colunas: colunas,
                linhas: getLinhas()
            };
            ExportarXls.getXls(xls);
        };

        $scope.baixarPDF = function () {
            var xls = {
                colunas: colunas,
                linhas: getLinhas()
            };
            ExportarXls.getPdf(xls);
        };
    });

'use strict';

angular.module('nfseApp')
    .factory('TipoLegislacaoService', function ($resource) {
        return $resource('api/tipo-legislacao/:id', {}, {
            'tiposLegislacaoWithlegislacoes': {
                method: 'GET',
                url: "api/tipo-legislacao-com-legislacoes",
                isArray: true

            }
        });
    });

'use strict';

angular.module('nfseApp').controller('TemplateDialogController',
    ['$scope','$state', '$stateParams',  'entity', 'Template',"Notificacao",
        function($scope,$state, $stateParams, entity, Template, Notificacao) {

        $scope.template = entity;
        $scope.load = function(id) {
            Template.get({id : id}, function(result) {
                $scope.template = result;
            });
        };

        var onSaveFinished = function (result) {
            $scope.$emit('nfseApp:templateUpdate', result);
            $state.go("template");
            Notificacao.info("Template salvo com sucesso.");
        };

        $scope.save = function () {
            if ($scope.template.id != null) {
                Template.update($scope.template, onSaveFinished);
            } else {
                Template.save($scope.template, onSaveFinished);
            }
        };

        $scope.clear = function() {
            //$modalInstance.dismiss('cancel');
        };
}]);

'use strict';

angular.module('nfseApp')
    .controller('TemplateDetailController', function ($sce, $scope, $rootScope, $stateParams, entity, Template) {
        $scope.template = entity;
        $scope.load = function (id) {
            Template.get({id: id}, function(result) {
                $scope.template = result;
                $scope.conteudoTemplate = $sce.trustAsHtml(template.template);
            });
        };

        $rootScope.$on('nfseApp:templateUpdate', function(event, result) {
            $scope.template = result;
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('Template', function ($resource, DateUtils) {
        return $resource('api/templates/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('TemplateSearch', function ($resource) {
        return $resource('api/_search/templates/:query', {}, {
            'query': { method: 'GET', isArray: true}
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('template', {
                parent: 'entity',
                url: '/templates',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'nfseApp.template.home.title'
                },
                ncyBreadcrumb: {
                    label: 'Consulta de Template'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/template/templates.html',
                        controller: 'TemplateController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('template');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('template.detail', {
                parent: 'template',
                url: '/detalhes/{id}',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'nfseApp.template.detail.title'
                },
                ncyBreadcrumb: {
                    label: 'Detalhes do Template'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/template/template-detail.html',
                        controller: 'TemplateDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('template');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Template', function($stateParams, Template) {
                        return Template.get({id : $stateParams.id});
                    }]
                }
            })
            .state('template.new', {
                parent: 'template',
                url: '/novo',
                data: {
                    roles: ['ROLE_ADMIN'],
                },
                ncyBreadcrumb: {
                    label: 'Novo Template'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/template/template-dialog.html',
                        controller: 'TemplateDialogController'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('template');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {codigo: null, descricao: null, ativo: true, id: null};
                    }
                }
            })
            .state('template.edit', {
                parent: 'template',
                url: '/edicao/{id}',
                data: {
                    roles: ['ROLE_ADMIN'],
                },
                ncyBreadcrumb: {
                    label: 'Edição de Template'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/template/template-dialog.html',
                        controller: 'TemplateDialogController'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('template');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Template', function($stateParams, Template) {
                        return Template.get({id : $stateParams.id});
                    }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('TemplateController', function ($scope, Template, TemplateSearch, ParseLinks, SweetAlert) {
        $scope.templates = [];
        $scope.page = 1;
        $scope.loadAll = function () {
            Template.query({page: $scope.page, per_page: 20}, function (result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.templates = result;
            });
        };
        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            Template.get({id: id}, function (result) {
                $scope.template = result;
                SweetAlert.swal({
                        title: "Confirme a exclusão",
                        text: "Você tem certeza que quer excluir o registro selecionado?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55", confirmButtonText: "Sim, Excluir",
                        cancelButtonText: "Não, Cancelar",
                        closeOnConfirm: false,
                        closeOnCancel: false
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            $scope.confirmDelete(id);
                        } else {
                            SweetAlert.error("Cancelado", "O registro não foi removido :)");
                        }
                    });
            });
        };

        $scope.confirmDelete = function (id) {
            Template.delete({id: id},
                function () {
                    $scope.loadAll();
                    SweetAlert.success("Removido!", "O registro foi removido com sucesso.");
                    $scope.clear();
                });
        };

        $scope.search = function () {
            TemplateSearch.query({query: $scope.searchQuery}, function (result) {
                $scope.templates = result;
            }, function (response) {
                if (response.status === 404) {
                    $scope.loadAll();
                }
            });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.template = {codigo: null, descricao: null, ativo: null, id: null};
        };
    });

(function () {
    'use strict';

    angular.module('nfseApp').controller('TarifaBancariaSearchController',
        function ($scope, $state, $modalInstance, TarifaBancaria, ParseLinks) {

            $scope.tarifas = [];
            $scope.filtro = {
                codigo: '',
                descricao: ''
            };
            $scope.page;
            $scope.per_page = 10;

            $scope.ok = function (tarifa) {
                $modalInstance.close(tarifa);
            };

            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };

            $scope.montarConsulta = function () {
                var campos = [];

                if ($scope.filtro.codigo) {
                    campos.push({
                        campo: "obj.codigo",
                        operador: "LIKE",
                        valorString: '%' + $scope.filtro.codigo + '%'
                    });
                }

                if ($scope.filtro.descricao) {
                    campos.push({
                        campo: "obj.descricao",
                        operador: "LIKE",
                        valorString: '%' + $scope.filtro.descricao + '%'
                    });
                }

                return {
                    offset: $scope.page,
                    limit: $scope.per_page,
                    parametrosQuery: [{
                        juncao: " and ",
                        parametroQueryCampos: campos
                    }]
                };
            };

            $scope.loadAll = function () {
                var consulta = $scope.montarConsulta();
                TarifaBancaria.consultar(consulta,
                    function (result, headers) {
                        if (headers)
                            $scope.links = ParseLinks.parse(headers('link'));
                        $scope.tarifas = result;
                    });
            };

            $scope.loadAll();
        });
})();
(function () {
    'use strict';

    angular.module('nfseApp')
        .factory('TarifaBancaria', function ($resource) {
            return $resource('api/tarifa-bancaria/:id', {}, {
                'consultar': {
                    url: 'api/tarifa-bancaria/consultar',
                    method: 'POST',
                    isArray: true
                },
                'buscarPorCodigo': {
                    method: 'GET',
                    url: 'api/tarifa-bancaria/buscar-por-codigo'
                }
            });
        });
})();
'use strict';

angular.module('nfseApp')
    .factory('SyncElasticSearch', function ($resource) {
        return $resource('api/sync/elasticsearch', {}, {
            'update': {method: 'PUT'}
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('sync-data-base', {
                parent: 'site',
                url: '/sync-data-base',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'Sincronização Entre os Banco de Dados'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/syncElasticSearch/sync.html',
                        controller: 'SyncController'
                    }
                }
            })
    });

'use strict';

angular.module('nfseApp')
    .controller('SyncController', function ($scope, SyncElasticSearch) {
        $scope.sync = function () {
            SyncElasticSearch.update();
        }
    });

'use strict';

angular.module('nfseApp').controller('SubstituicaoRPSDialogController',
    ['$scope', '$stateParams', '$modalInstance', 'entity', 'SubstituicaoRPS', 'RPS',
        function($scope, $stateParams, $modalInstance, entity, SubstituicaoRPS, RPS) {

        $scope.substituicaoRPS = entity;
        $scope.rpss = RPS.query();
        $scope.load = function(id) {
            SubstituicaoRPS.get({id : id}, function(result) {
                $scope.substituicaoRPS = result;
            });
        };

        var onSaveFinished = function (result) {
            $scope.$emit('nfseApp:substituicaoRPSUpdate', result);
            $modalInstance.close(result);
        };

        $scope.save = function () {
            if ($scope.substituicaoRPS.id != null) {
                SubstituicaoRPS.update($scope.substituicaoRPS, onSaveFinished);
            } else {
                SubstituicaoRPS.save($scope.substituicaoRPS, onSaveFinished);
            }
        };

        $scope.clear = function() {
            $modalInstance.dismiss('cancel');
        };
}]);

'use strict';

angular.module('nfseApp')
    .controller('SubstituicaoRPSDetailController', function ($scope, $rootScope, $stateParams, entity, SubstituicaoRPS, RPS) {
        $scope.substituicaoRPS = entity;
        $scope.load = function (id) {
            SubstituicaoRPS.get({id: id}, function(result) {
                $scope.substituicaoRPS = result;
            });
        };
        $rootScope.$on('nfseApp:substituicaoRPSUpdate', function(event, result) {
            $scope.substituicaoRPS = result;
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('SubstituicaoRPS', function ($resource, DateUtils) {
        return $resource('api/substituicaoRPSs/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('SubstituicaoRPSSearch', function ($resource) {
        return $resource('api/_search/substituicaoRPSs/:query', {}, {
            'query': { method: 'GET', isArray: true}
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('substituicaoRPS', {
                parent: 'entity',
                url: '/substituicaoRPSs',
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'nfseApp.substituicaoRPS.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/substituicaoRPS/substituicaoRPSs.html',
                        controller: 'SubstituicaoRPSController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('substituicaoRPS');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('substituicaoRPS.detail', {
                parent: 'entity',
                url: '/substituicaoRPS/{id}',
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'nfseApp.substituicaoRPS.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/substituicaoRPS/substituicaoRPS-detail.html',
                        controller: 'SubstituicaoRPSDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('substituicaoRPS');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'SubstituicaoRPS', function($stateParams, SubstituicaoRPS) {
                        return SubstituicaoRPS.get({id : $stateParams.id});
                    }]
                }
            })
            .state('substituicaoRPS.new', {
                parent: 'substituicaoRPS',
                url: '/new',
                data: {
                    roles: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$modal', function($stateParams, $state, $modal) {
                    $modal.open({
                        templateUrl: 'app/entities/substituicaoRPS/substituicaoRPS-dialog.html',
                        controller: 'SubstituicaoRPSDialogController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {id: null};
                            }
                        }
                    }).result.then(function(result) {
                        $state.go('substituicaoRPS', null, { reload: true });
                    }, function() {
                        $state.go('substituicaoRPS');
                    })
                }]
            })
            .state('substituicaoRPS.edit', {
                parent: 'substituicaoRPS',
                url: '/{id}/edit',
                data: {
                    roles: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$modal', function($stateParams, $state, $modal) {
                    $modal.open({
                        templateUrl: 'app/entities/substituicaoRPS/substituicaoRPS-dialog.html',
                        controller: 'SubstituicaoRPSDialogController',
                        size: 'lg',
                        resolve: {
                            entity: ['SubstituicaoRPS', function(SubstituicaoRPS) {
                                return SubstituicaoRPS.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('substituicaoRPS', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
                }]
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('SubstituicaoRPSController', function ($scope, SubstituicaoRPS, SubstituicaoRPSSearch, ParseLinks) {
        $scope.substituicaoRPSs = [];
        $scope.page = 1;
        $scope.loadAll = function() {
            SubstituicaoRPS.query({page: $scope.page, per_page: 20}, function(result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.substituicaoRPSs = result;
            });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            SubstituicaoRPS.get({id: id}, function(result) {
                $scope.substituicaoRPS = result;
                $('#deleteSubstituicaoRPSConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            SubstituicaoRPS.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deleteSubstituicaoRPSConfirmation').modal('hide');
                    $scope.clear();
                });
        };

        $scope.search = function () {
            SubstituicaoRPSSearch.query({query: $scope.searchQuery}, function(result) {
                $scope.substituicaoRPSs = result;
            }, function(response) {
                if(response.status === 404) {
                    $scope.loadAll();
                }
            });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.substituicaoRPS = {id: null};
        };
    });

'use strict';

angular.module('nfseApp').controller('SubstituicaoNotaFiscalDialogController',
    ['$scope', '$stateParams', '$modalInstance', 'entity', 'SubstituicaoNotaFiscal', 'NotaFiscal',
        function($scope, $stateParams, $modalInstance, entity, SubstituicaoNotaFiscal, NotaFiscal) {

        $scope.substituicaoNotaFiscal = entity;
        $scope.notafiscals = NotaFiscal.query();
        $scope.load = function(id) {
            SubstituicaoNotaFiscal.get({id : id}, function(result) {
                $scope.substituicaoNotaFiscal = result;
            });
        };

        var onSaveFinished = function (result) {
            $scope.$emit('nfseApp:substituicaoNotaFiscalUpdate', result);
            $modalInstance.close(result);
        };

        $scope.save = function () {
            if ($scope.substituicaoNotaFiscal.id != null) {
                SubstituicaoNotaFiscal.update($scope.substituicaoNotaFiscal, onSaveFinished);
            } else {
                SubstituicaoNotaFiscal.save($scope.substituicaoNotaFiscal, onSaveFinished);
            }
        };

        $scope.clear = function() {
            $modalInstance.dismiss('cancel');
        };
}]);

'use strict';

angular.module('nfseApp')
    .controller('SubstituicaoNotaFiscalDetailController', function ($scope, $rootScope, $stateParams, entity, SubstituicaoNotaFiscal, NotaFiscal) {
        $scope.substituicaoNotaFiscal = entity;
        $scope.load = function (id) {
            SubstituicaoNotaFiscal.get({id: id}, function(result) {
                $scope.substituicaoNotaFiscal = result;
            });
        };
        $rootScope.$on('nfseApp:substituicaoNotaFiscalUpdate', function(event, result) {
            $scope.substituicaoNotaFiscal = result;
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('SubstituicaoNotaFiscal', function ($resource, DateUtils) {
        return $resource('api/substituicaoNotaFiscals/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('SubstituicaoNotaFiscalSearch', function ($resource) {
        return $resource('api/_search/substituicaoNotaFiscals/:query', {}, {
            'query': { method: 'GET', isArray: true}
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('substituicaoNotaFiscal', {
                parent: 'entity',
                url: '/substituicaoNotaFiscals',
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'nfseApp.substituicaoNotaFiscal.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/substituicaoNotaFiscal/substituicaoNotaFiscals.html',
                        controller: 'SubstituicaoNotaFiscalController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('substituicaoNotaFiscal');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('substituicaoNotaFiscal.detail', {
                parent: 'entity',
                url: '/substituicaoNotaFiscal/{id}',
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'nfseApp.substituicaoNotaFiscal.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/substituicaoNotaFiscal/substituicaoNotaFiscal-detail.html',
                        controller: 'SubstituicaoNotaFiscalDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('substituicaoNotaFiscal');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'SubstituicaoNotaFiscal', function($stateParams, SubstituicaoNotaFiscal) {
                        return SubstituicaoNotaFiscal.get({id : $stateParams.id});
                    }]
                }
            })
            .state('substituicaoNotaFiscal.new', {
                parent: 'substituicaoNotaFiscal',
                url: '/new',
                data: {
                    roles: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$modal', function($stateParams, $state, $modal) {
                    $modal.open({
                        templateUrl: 'app/entities/substituicaoNotaFiscal/substituicaoNotaFiscal-dialog.html',
                        controller: 'SubstituicaoNotaFiscalDialogController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {id: null};
                            }
                        }
                    }).result.then(function(result) {
                        $state.go('substituicaoNotaFiscal', null, { reload: true });
                    }, function() {
                        $state.go('substituicaoNotaFiscal');
                    })
                }]
            })
            .state('substituicaoNotaFiscal.edit', {
                parent: 'substituicaoNotaFiscal',
                url: '/{id}/edit',
                data: {
                    roles: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$modal', function($stateParams, $state, $modal) {
                    $modal.open({
                        templateUrl: 'app/entities/substituicaoNotaFiscal/substituicaoNotaFiscal-dialog.html',
                        controller: 'SubstituicaoNotaFiscalDialogController',
                        size: 'lg',
                        resolve: {
                            entity: ['SubstituicaoNotaFiscal', function(SubstituicaoNotaFiscal) {
                                return SubstituicaoNotaFiscal.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('substituicaoNotaFiscal', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
                }]
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('SubstituicaoNotaFiscalController', function ($scope, SubstituicaoNotaFiscal, SubstituicaoNotaFiscalSearch, ParseLinks) {
        $scope.substituicaoNotaFiscals = [];
        $scope.page = 1;
        $scope.loadAll = function() {
            SubstituicaoNotaFiscal.query({page: $scope.page, per_page: 20}, function(result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.substituicaoNotaFiscals = result;
            });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            SubstituicaoNotaFiscal.get({id: id}, function(result) {
                $scope.substituicaoNotaFiscal = result;
                $('#deleteSubstituicaoNotaFiscalConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            SubstituicaoNotaFiscal.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deleteSubstituicaoNotaFiscalConfirmation').modal('hide');
                    $scope.clear();
                });
        };

        $scope.search = function () {
            SubstituicaoNotaFiscalSearch.query({query: $scope.searchQuery}, function(result) {
                $scope.substituicaoNotaFiscals = result;
            }, function(response) {
                if(response.status === 404) {
                    $scope.loadAll();
                }
            });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.substituicaoNotaFiscal = {id: null};
        };
    });

'use strict';

angular.module('nfseApp')
    .controller('SolicitacaoRPSEditarController', function ($scope, $state, Solicitacaorps, Notificacao, Principal, $filter, ParseLinks, SweetAlert, localStorageService) {

        $scope.per_page = 10;
        $scope.searchQuery = "";

        $scope.loadAll = function () {
            $scope.prestador = localStorageService.get("prestadorPrincipal");

            Principal.identity().then(function (account) {
                if (account) {
                    $scope.account = account;
                }
            });
        };

        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };

        $scope.loadAll();


        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clean();
        };

        $scope.clear = function () {
            $scope.solicitacaorps = {id: null};
        };

        $scope.save = function () {
            if ($scope.validar()) {

                var solicitacaoRPSDTO = {
                    prestador: $scope.prestador.prestador,
                    userEmpresa: $scope.account,
                    solicitadoEm: $scope.solicitacaorps.solicitadoEm,
                    quantidadeSolicitada: $scope.solicitacaorps.quantidadeSolicitada,
                    observacaoSolicitacao: $scope.solicitacaorps.observacaoSolicitacao,
                    observacaoAnalise: $scope.solicitacaorps.observacaoAnalise,
                    situacaosolicitacaorps: $scope.solicitacaorps.situacaosolicitacaorps,
                    situacao: $scope.solicitacaorps.situacao
                };

                console.log(JSON.stringify(solicitacaoRPSDTO))

                Solicitacaorps.save(solicitacaoRPSDTO, onSaveFinished, function () {
                    $state.go("solicitacaorps");
                });

            }
        };

        var onSaveFinished = function (result) {
            $state.go("solicitacaorps");
            Notificacao.priority("Solicitação de RPS salva com sucesso!")
        };

        $scope.validar = function () {
            $scope.mensagemCamposObrigatorios = [];
            if ($scope.solicitacaorps.quantidadeSolicitada <= 0 || $scope.solicitacaorps.quantidadeSolicitada === undefined) {
                $scope.mensagemCamposObrigatorios.push("O campo Quantidade Solicitada de RPS é obrigatória e deve ser maior que zero.")
                Notificacao.camposObrigatorios($scope.mensagemCamposObrigatorios, "warning");
                return false;
            }
            if ($scope.solicitacaorps.quantidadeSolicitada >= 999999) {
                $scope.mensagemCamposObrigatorios.push("Quantidade Solicitada deve ser inferior a 999999.")
                Notificacao.camposObrigatorios($scope.mensagemCamposObrigatorios, "warning");
                return false;
            } else {
                return true;
            }
            return true;
        };
    });

'use strict';

angular.module('nfseApp')
    .factory('Solicitacaorps', function ($resource) {
        return $resource('api/solicitacao-rps/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'queryPorSituacao': {
                url: 'api/solicitacao-rps/por-situacao',
                method: 'GET', isArray: true
            },
            'buscarTodasDoPrestador': {
                method: 'GET',
                url: 'api/solicitacao-rps/por-prestador',
                isArray: true
            },
            'update': {method: 'PUT'},
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('solicitacaorps', {
                parent: 'entity',
                url: '/solicitacaorps',
                data: {
                    roles: ['ROLE_EMPRESA_RPS'],
                    pageTitle: 'RPS'
                },
                ncyBreadcrumb: {
                    label: 'Consulta de RPS '
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/solicitacao-rps/solicitacao-rps.html',
                        controller: 'SolicitacaoRPSController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('solicitacaoRps');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('dadosPessoais');
                        $translatePartialLoader.addPart('prestadorServicos');
                        return $translate.refresh();
                    }]
                }
            })
            .state('solicitacaorps.new', {
                parent: 'solicitacaorps',
                url: '/novo',
                data: {
                    roles: ['ROLE_EMPRESA_RPS'],
                    pageTitle: 'RPS'
                },
                ncyBreadcrumb: {
                    label: 'Solicitar RPS'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/solicitacao-rps/solicitacao-rps-edit.html',
                        controller: 'SolicitacaoRPSEditarController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('solicitacaoRps');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('dadosPessoais');
                        $translatePartialLoader.addPart('prestadorServicos');
                        return $translate.refresh();
                    }],
                    entity: ['localStorageService', function (localStorageService) {
                        return {id: null, prestador: localStorageService.get("prestadorPrincipal")};
                    }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('SolicitacaoRPSController', function ($scope, $state, Solicitacaorps, $filter, ParseLinks, SweetAlert, localStorageService) {

        $scope.aidfes = [];
        $scope.per_page = 10;
        $scope.searchQuery = "";

        $scope.loadAll = function () {
            var prestador = localStorageService.get("prestadorPrincipal");
            Solicitacaorps.buscarTodasDoPrestador({
                prestador: prestador.id,
                page: $scope.page,
                per_page: $scope.per_page
            }, function (result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.solicitacoes = result;
            });
        };

        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };

        $scope.loadAll();

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clean();
        };

        $scope.clear = function () {
            $scope.solicitacaorps = {id: null};
        };
    });

(function () {
    'use strict';

    angular.module('nfseApp')
        .factory('Sistema', function ($resource) {

            var resource = $resource('', {}, {
                'getVersaoSistema': {
                    url: '/api/sistema/versao',
                    responseType: 'text'
                }
            });

            return resource;
        })
    ;
})();
'use strict';

angular.module('nfseApp').controller('ServicoDeclaradoImportController',
    ['$scope', '$stateParams', 'entity', 'DeclaracaoServicoTomado', 'localStorageService', '$state',
        function ($scope, $stateParams, entity, DeclaracaoServicoTomado, localStorageService, $state) {

            $scope.lote = {file: '', prestador: localStorageService.get("prestadorPrincipal").prestador};

            $scope.uploadXmlFile = function (file) {
                console.log(file);
                var reader = new FileReader();
                reader.onload = function (evt) {
                    console.log(evt);
                    $scope.$apply(function ($scope) {
                        $scope.arquivoSelecionado = file;
                        $scope.lote.file = evt.target.result;
                    });
                };
                reader.readAsDataURL(file);
            };


            $scope.enviarArquivo = function () {
                DeclaracaoServicoTomado.importar($scope.lote, function (lote) {
                    $state.go("loteServicoTomado.detail", {id: lote.id})
                });
            }

        }]);

'use strict';

angular.module('nfseApp').controller('ServicoDeclaradoEditController',
    ['$rootScope', '$scope', '$modal', '$state', '$filter', '$stateParams', 'entity', 'ServicoDeclarado',
        'localStorageService', 'Notificacao',
        'Tomador', 'Servico', 'Municipio', 'CEP', 'Pais', 'Configuracao', 'PrestadorServicos', 'ImpressaoPdf',
        function ($rootScope, $scope, $modal, $state, $filter, $stateParams, entity, ServicoDeclarado,
                  localStorageService, Notificacao,
                  Tomador, Servico, Municipio, CEP, Pais, Configuracao, PrestadorServicos, ImpressaoPdf) {

            $scope.mensagemCamposObrigatorios = [];
            $scope.itensDeclaracaoServico = [];
            $scope.aliquotas = [0.00, 2.00, 2.79, 3.00, 3.50, 3.84, 3.87, 4.23, 4.26, 4.31, 4.61, 4.65, 5.00];
            $scope.permiteExigibilidade = true;
            $scope.bloqueiaAliquota = false;
            $scope.mostraFormServicos = true;
            $scope.tiposServicosDeclarados = ServicoDeclarado.getAllTiposDocumentosServicoDeclarado();
            $scope.empresa = localStorageService.get("prestadorPrincipal");

            Configuracao.get({}, function (data) {
                $scope.municipio = data.municipio;
                $scope.permiteAlterarCompetenciaServicoDeclarado = data.permiteAlterarCompetenciaServicoDeclarado;
                $scope.clearServico();


                if ($scope.empresa.prestador.foraMunicipio) {
                    $scope.cpfCnpjDoTomador = $scope.empresa.prestador.pessoa.dadosPessoais.cpfCnpj;

                    if (entity.$promise) {
                        entity.$promise.then(function (nota) {
                            $scope.servicoDeclarado = nota;
                            $scope.calculaValoresDaNota();
                        });
                    } else {
                        $scope.servicoDeclarado = entity;
                        $scope.calculaValoresDaNota();
                    }

                } else {
                    PrestadorServicos.get({id: $scope.empresa.prestador.id}, function (data) {
                        $scope.tomador = data;
                        $scope.cpfCnpjDoTomador = $scope.tomador.pessoa.dadosPessoais.cpfCnpj;

                        if (entity.$promise) {
                            entity.$promise.then(function (nota) {
                                $scope.servicoDeclarado = nota;
                                $scope.calculaValoresDaNota();
                            });
                        } else {
                            $scope.servicoDeclarado = entity;
                            $scope.calculaValoresDaNota();
                        }
                    });
                }


            });


            $scope.$watch('editForm.cpfCnpj.$valid', function (newVal) {
                $scope.preLoadPrestador();
            });

            $scope.preLoadPrestador = function () {
                if ($scope.temCpfOuCnpj()) {
                    var cpfCnpj = $scope.servicoDeclarado.dadosPessoais.cpfCnpj;
                    $scope.servicoDeclarado.dadosPessoais = {};
                    $scope.servicoDeclarado.dadosPessoais.cpfCnpj = cpfCnpj;
                    if ($scope.cpfDigitadoIgualTomador()) {
                        Notificacao.error("Atenção", "Não é permitido que o Prestador de Serviços seja o próprio Tomador de Serviços.");
                    } else {
                        Tomador.getTomadorPorCpfCnpj({cpfCnpj: cpfCnpj}, function (result) {
                            if (!result.dadosPessoais) {
                                Tomador.getInPessoRepoByCpfCnpj({cpfCnpj: cpfCnpj}, function (result) {
                                    if (result.dadosPessoais && result.dadosPessoais.cpfCnpj) {
                                        result.prestador = localStorageService.get("prestadorPrincipal").prestador;
                                        $scope.servicoDeclarado.dadosPessoais = result.dadosPessoais;
                                    }
                                });
                            } else {
                                $scope.servicoDeclarado.dadosPessoais = result.dadosPessoais;
                            }
                        });
                    }
                }
            };


            $scope.searchPrestadorServico = function () {
                var modalInstance = $modal.open({
                    templateUrl: 'app/entities/tomador/tomador-search.html',
                    controller: 'TomadorSearchController',
                    size: 'lg'
                });
                modalInstance.result.then(function (tomador) {

                    Tomador.get({id: tomador.id}, function (data) {
                        if (data && data.dadosPessoais) {
                            $scope.servicoDeclarado.dadosPessoais = {};
                            $scope.servicoDeclarado.dadosPessoais = data.dadosPessoais;
                            $scope.servicoDeclarado.dadosPessoais.id = null;
                            if ($scope.servicoDeclarado.dadosPessoais.endereco) {
                                $scope.servicoDeclarado.dadosPessoais.endereco.id = null;
                            }
                        }
                    });


                }, function () {
                    //$log.info('Modal dismissed at: ' + new Date());
                });
            };


            var onSaveFinished = function (result) {
                Notificacao.info("Registro salvo com sucesso!");
                $state.go("servicoDeclarado");
            };

            $scope.saveAndFinalize = function () {
                if ($scope.validarCamposObrigatorios()) {
                    if ($scope.servicoDeclarado.tipoServicoDeclarado == 'SERVICO_PRESTADO') {
                        $scope.servicoDeclarado.dadosPessoaisTomador = $scope.servicoDeclarado.dadosPessoais;
                    } else {
                        $scope.servicoDeclarado.dadosPessoaisPrestador = $scope.servicoDeclarado.dadosPessoais;
                    }
                    $scope.save();
                }
            };

            $scope.save = function () {
                if ($scope.validarCamposObrigatorios()) {
                    if ($scope.servicoDeclarado.id != null) {
                        ServicoDeclarado.update($scope.servicoDeclarado, onSaveFinished, function () {
                            $state.go('servicoDeclarado');
                        });
                    } else {
                        ServicoDeclarado.save($scope.servicoDeclarado, onSaveFinished, function () {
                            $state.go('servicoDeclarado');
                        });
                    }
                }
            };

            $scope.openCompetencia = function ($event) {
                $scope.status.openedCompetencia = true;
            };

            $scope.status = {openedCompetencia: false};

            $scope.clear = function () {
            };

            $scope.calculaValoresServico = function (servico) {
                servico.total = servico.valorServico * servico.quantidade;
                servico.baseCalculo = servico.total;

                if (servico.deducoes && servico.deducoes > 0) {
                    servico.baseCalculo = servico.baseCalculo - servico.deducoes;
                }
                servico.iss = servico.baseCalculo * (servico.aliquotaServico / 100);
            };

            $scope.clearServico = function () {
                $scope.servico = {
                    baseCalculo: 0.0,
                    valorServico: 0.0,
                    quantidade: 1,
                    iss: 0.0,
                    descontosCondicionados: 0.0,
                    descontosIncondicionados: 0.0,
                    deducoes: 0.0,
                    prestadoNoPais: true,
                    municipio: $scope.municipio
                };

            };


            $scope.validarAddServico = function () {
                $scope.mensagemCamposObrigatorios = [];
                if (!$scope.servico.nomeServico) {
                    $scope.mensagemCamposObrigatorios.push("O Serviço é obrigatório, informe o serviço prestado para continuar.");
                }
                if (!$scope.servico.descricao) {
                    $scope.mensagemCamposObrigatorios.push("O campo descrição do serviço é obrigatório.");
                }
                if (!$scope.servico.aliquotaServico || $scope.servico.aliquotaServico <= 0) {
                    $scope.mensagemCamposObrigatorios.push("O campo Alíquota é obrigatório e deve ser maior que zero.");
                }
                if ($scope.servico.deducoes > $scope.servico.total) {
                    $scope.mensagemCamposObrigatorios.push("Os valores de desconto não podem ser maiores que o valor total dos serviços.");
                }
                if (!$scope.servico.valorServico || $scope.servico.valorServico <= 0) {
                    $scope.mensagemCamposObrigatorios.push("O campo Valor do Serviço é obrigatório e deve ser maior que zero.");
                }
                if ($scope.mensagemCamposObrigatorios.length > 0) {
                    Notificacao.camposObrigatorios($scope.mensagemCamposObrigatorios, "warning");
                    return false;
                }
                return true;
            };


            $scope.continuarServico = function () {
                if ($scope.mostraFormServicos) {
                    $scope.addServico(true);
                } else {
                    $scope.calculaValoresDaNota();
                }
            };

            $scope.novoServico = function () {
                if ($scope.mostraFormServicos) {
                    $scope.addServico(false);
                } else {
                    $scope.mostraFormServicos = true
                }
            };

            $scope.addServico = function (continua) {
                if ($scope.validarAddServico()) {
                    if (!$scope.servicoDeclarado.itens) {
                        $scope.servicoDeclarado.itens = [];
                    }
                    $scope.servicoDeclarado.itens.push($scope.servico);
                    $scope.clearServico();
                    $scope.calculaValoresDaNota();
                    if (continua) {
                        $scope.mostrarValoresFinais = !$scope.mostrarValoresFinais;
                    }
                }

            };

            $scope.calculaValoresDaNota = function () {
                $scope.servicoDeclarado.totalServicos = 0.0;
                $scope.servicoDeclarado.baseCalculo = 0.0;
                $scope.servicoDeclarado.issCalculado = 0.0;
                $scope.servicoDeclarado.deducoes = 0.0;
                $scope.servicoDeclarado.valorLiquido = 0.0;
                if ($scope.servicoDeclarado.itens) {
                    angular.forEach($scope.servicoDeclarado.itens, function (servico) {
                        $scope.calculaValoresServico(servico);
                        $scope.servicoDeclarado.totalServicos = Number($scope.servicoDeclarado.totalServicos) + Number(servico.total);
                        $scope.servicoDeclarado.baseCalculo = Number($scope.servicoDeclarado.baseCalculo) + Number(servico.baseCalculo);
                        $scope.servicoDeclarado.issCalculado = Number($scope.servicoDeclarado.issCalculado) + Number(servico.iss);
                        $scope.servicoDeclarado.deducoes = Number($scope.servicoDeclarado.deducoes) + Number(servico.deducoes);
                    });
                    if ($scope.servicoDeclarado.issRetido) {
                        $scope.servicoDeclarado.valorLiquido = $scope.servicoDeclarado.totalServicos
                            - $scope.servicoDeclarado.issCalculado - $scope.servicoDeclarado.deducoes;
                        $scope.servicoDeclarado.issPagar = $scope.servicoDeclarado.issCalculado;
                    } else {
                        $scope.servicoDeclarado.valorLiquido = $scope.servicoDeclarado.totalServicos
                            - $scope.servicoDeclarado.deducoes;
                    }
                }
            };


            $scope.removeServico = function (index) {
                $scope.mostrarValoresFinais = false;
                $scope.servicoDeclarado.itens.splice(index, 1);
            };

            $scope.editaServico = function (index) {
                $scope.mostrarValoresFinais = false;
                $scope.servico = $scope.servicoDeclarado.itens[index];
                $scope.removeServico(index);
            };


            $scope.selecionouServico = function () {
                $scope.bloqueiaAliquota = false;
                if ($scope.servico && $scope.servico.servico) {
                    $scope.servico.nomeServico = $scope.servico.servico.descricao;
                    if (($scope.temExigibilidade() || $scope.exigibilidadeSuspensa()) && $scope.tomador.enquadramentoFiscal.tipoIss === "MENSAL") {
                        $scope.bloqueiaAliquota = true;
                        $scope.servico.aliquotaServico = $scope.servico.servico.aliquota;
                        $scope.calculaValoresServico($scope.servico);
                        return;
                    }
                    if ($scope.exigibilidadeNaoIncide()
                        || ($scope.tomador && $scope.tomador.enquadramentoFiscal.tipoIss === "MEI")
                        || (($scope.temExigibilidade() || $scope.exigibilidadeSuspensa())
                            && ($scope.tomador.enquadramentoFiscal.tipoIss === "FIXO" || $scope.tomador.enquadramentoFiscal.tipoIss === "ESTIMADO"))) {
                        $scope.bloqueiaAliquota = true;
                        $scope.servico.aliquotaServico = $scope.aliquotas[0];
                        $scope.calculaValoresServico($scope.servico);
                        return;
                    }
                    if ($scope.aliquotas.indexOf($scope.servico.servico.aliquota) >= 0) {
                        $scope.servico.aliquotaServico = $scope.servico.servico.aliquota;
                        $scope.calculaValoresServico($scope.servico);
                    }
                }
            };

            $scope.searchServico = function () {
                var modalInstance = $modal.open({
                    templateUrl: 'app/entities/servico/servico-search.html',
                    controller: 'ServicoSearchController',
                    size: 'lg'
                });
                modalInstance.result.then(function (result) {
                    $scope.servico.servico = result;
                    $scope.selecionouServico();
                }, function () {
                    //$log.info('Modal dismissed at: ' + new Date());
                });
            };

            $scope.validarCamposObrigatorios = function () {
                $scope.mensagemCamposObrigatorios = [];

                if ($scope.servicoDeclarado.tipoDocumentoServicoDeclarado === null) {
                    $scope.mensagemCamposObrigatorios.push("O campo Tipo de Documento é obrigatório.");
                }
                if ($scope.servicoDeclarado.dadosPessoais.cpfCnpj === null) {
                    $scope.mensagemCamposObrigatorios.push("O campo CPF ou CNPJ do Prestador de Serviço é obrigatório.");
                }
                if ($scope.servicoDeclarado.dadosPessoais.nomeRazaoSocial === null) {
                    $scope.mensagemCamposObrigatorios.push("O campo Nome ou Razão do Prestador Social é obrigatório.");
                }

                if ($scope.servicoDeclarado.itens.length === 0) {
                    $scope.mensagemCamposObrigatorios.push("É necessário adicionar ao menos um serviço.");
                }
                if ($scope.mensagemCamposObrigatorios.length > 0) {
                    Notificacao.camposObrigatorios($scope.mensagemCamposObrigatorios, "warning");
                    return false;
                } else {
                    return true;
                }
            };


            $scope.loadEnderecoByCEP = function (cep) {
                if (cep) {
                    CEP.getByCep({cep: cep}, function (endereco) {
                        if (endereco.municipio) {
                            $scope.servicoDeclarado.dadosPessoais.cep = endereco.cep;
                            $scope.servicoDeclarado.dadosPessoais.municipio = endereco.municipio;
                            $scope.servicoDeclarado.dadosPessoais.logradouro = endereco.logradouro;
                            $scope.servicoDeclarado.dadosPessoais.bairro = endereco.bairro;
                        }
                    });
                }
            };

            $scope.loadPaisByCodigo = function (codigo, donoDoServico) {
                if (codigo) {
                    Pais.getByCodigo({codigo: codigo}, function (pais) {
                        if (pais.id) {
                            donoDoServico.pais = pais;
                            donoDoServico.municipio = {};
                        } else {
                            Notificacao.warn("Atenção", "Não foi encontrado nenhum País com o código " + codigo);
                            donoDoServico.pais = {};
                        }
                    });
                }
            };

            $scope.searchMunicipio = function (caraQueTemMunicipio) {
                var modalInstance = $modal.open({
                    templateUrl: 'app/entities/municipio/municipio-search.html',
                    controller: 'MunicipioSearchController',
                    size: 'lg'
                });
                modalInstance.result.then(function (municipio) {
                    caraQueTemMunicipio.municipio = municipio;
                    caraQueTemMunicipio.pais = {};
                }, function () {
                    //$log.info('Modal dismissed at: ' + new Date());
                });
            };

            $scope.searchPais = function (donoDoServico) {
                var modalInstance = $modal.open({
                    templateUrl: 'app/entities/pais/pais-search.html',
                    controller: 'PaisSearchController',
                    size: 'lg'
                });
                modalInstance.result.then(function (pais) {
                    donoDoServico.pais = pais;
                    if ($scope.servicoDeclarado.modalidade && $scope.servicoDeclarado.modalidade != 'SEM_CPF')
                        donoDoServico.municipio = {};
                }, function () {
                    //$log.info('Modal dismissed at: ' + new Date());
                });
            };

            $scope.temCpfOuCnpj = function () {
                return $scope.servicoDeclarado
                    && $scope.servicoDeclarado.dadosPessoais
                    && $scope.servicoDeclarado.dadosPessoais.cpfCnpj;
            };

            $scope.cpfDigitadoIgualTomador = function () {
                return $scope.temCpfOuCnpj()
                    && $scope.cpfCnpjDoTomador
                    && $scope.servicoDeclarado.dadosPessoais.cpfCnpj.replace(/[^\w\s]/gi, '')
                    === $scope.cpfCnpjDoTomador.replace(/[^\w\s]/gi, '');
            }

            $scope.temExigibilidade = function () {
                return $scope.notaFiscal
                    && $scope.servicoDeclarado
                    && $scope.servicoDeclarado.naturezaOperacao
                    && $scope.servicoDeclarado.naturezaOperacao === "TRIBUTACAO_MUNICIPAL";
            }

            $scope.exigibilidadeSuspensa = function () {
                return $scope.notaFiscal
                    && $scope.servicoDeclarado
                    && $scope.servicoDeclarado.naturezaOperacao
                    && ($scope.servicoDeclarado.naturezaOperacao === "EXIGIBILIDADE_SUSPENSA_DECISAO_JUDICIAL"
                        || $scope.servicoDeclarado.naturezaOperacao === "EXIGIBILIDADE_SUSPENSA_PROCESSO_ADMINISTRATIVO");
            };

            $scope.exigibilidadeNaoIncide = function () {
                return $scope.servicoDeclarado
                    && $scope.servicoDeclarado
                    && $scope.servicoDeclarado.naturezaOperacao
                    && ($scope.servicoDeclarado.naturezaOperacao === "NAO_INCIDENCIA"
                        || $scope.servicoDeclarado.naturezaOperacao === "ISENCAO"
                        || $scope.servicoDeclarado.naturezaOperacao === "IMUNIDADE"
                        || $scope.servicoDeclarado.naturezaOperacao === "EXPORTACAO");
            };

            $scope.isFisica = function () {
                return $scope.servicoDeclarado
                    && (($scope.servicoDeclarado.modalidade == 'SEM_CPF') ||
                        ($scope.servicoDeclarado.dadosPessoais
                            && $scope.servicoDeclarado.dadosPessoais.cpfCnpj
                            && $scope.servicoDeclarado.dadosPessoais.cpfCnpj.replace(/[^\w\s]/gi, '').length == 11));

            };

            $scope.isJuridica = function () {
                return $scope.servicoDeclarado
                    && $scope.servicoDeclarado.dadosPessoais
                    && $scope.servicoDeclarado.dadosPessoais.cpfCnpj
                    && $scope.servicoDeclarado.dadosPessoais.cpfCnpj.replace(/[^\w\s]/gi, '').length == 14

            };

            $scope.seleciouTipoServicoDeclarado = function (tipoServicoDeclarado) {
                if (!$scope.servicoDeclarado.tipoServicoDeclarado) {
                    ServicoDeclarado.new({
                            tipoServicoDeclarado: tipoServicoDeclarado,
                            empresaId: $scope.empresa.prestador.id,
                            foraMunicipio: $scope.empresa.prestador.foraMunicipio
                        },
                        function (data) {
                            $scope.servicoDeclarado = data;
                        });
                } else {
                    Notificacao.confirm('Atenção!', 'Tem certeza que deseja alterar o tipo de serviço, os dados digitados serão apagados!', 'warning',
                        function () {
                            ServicoDeclarado.new({
                                tipoServicoDeclarado: tipoServicoDeclarado,
                                empresaId: $scope.empresa.prestador.id,
                                foraMunicipio: $scope.empresa.prestador.foraMunicipio
                            }, function (data) {
                                $scope.servicoDeclarado = data;
                            });
                        })
                }
            };

            $scope.mudouIdentificacao = function (modalidade) {
                $scope.servicoDeclarado.modalidade = modalidade;
                $scope.servicoDeclarado.dadosPessoais = {};
            };

            $scope.atribuirCompetencia = function () {
                if (!$scope.permiteAlterarCompetenciaServicoDeclarado)
                    $scope.servicoDeclarado.competencia = $scope.servicoDeclarado.emissao;
            };
        }]);

angular.module('nfseApp')
    .controller('ServicoDeclaradoDetailController',
        function ($scope, $rootScope, $stateParams, entity) {
            $scope.servicoDeclarado = entity;

            $scope.definirDadosPessoais = function () {
                if (entity.$promise) {
                    entity.$promise.then(function (data) {
                        if (data.tipoServicoDeclarado == 'SERVICO_PRESTADO') {
                            $scope.servicoDeclarado.dadosPessoais = data.dadosPessoaisTomador;
                        } else {
                            $scope.servicoDeclarado.dadosPessoais = data.dadosPessoaisPrestador;
                        }
                    });
                }
            };

            $scope.definirDadosPessoais();

            $scope.isFisica = function () {
                return $scope.servicoDeclarado
                    && $scope.servicoDeclarado.dadosPessoais
                    && $scope.servicoDeclarado.dadosPessoais.cpfCnpj
                    && $scope.servicoDeclarado.dadosPessoais.cpfCnpj.replace(/[^\w\s]/gi, '').length == 11

            };
        });

'use strict';

angular.module('nfseApp')
    .factory('ServicoDeclarado', function ($resource, DateUtils) {

        function convertDateFromServer(data) {
            if (data.emissao) {
                data.emissao = DateUtils.convertLocaleDateFromServer(data.emissao);
            }
            if (data.competencia) {
                data.competencia =
                    DateUtils.convertLocaleDateFromServer(data.competencia);
            }
        }


        return $resource('api/servico-declarado/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    for (var i = 0; i < data.length; i++) {
                        var nota = data[i];
                        convertDateFromServer(nota);
                    }
                    return data;
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    convertDateFromServer(data)
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'new': {
                method: 'GET',
                url: 'api/servico-declarado/new',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    convertDateFromServer(data);
                    return data;
                }
            },
            'cancelar': {
                method: 'POST',
                url: 'api/servico-declarado/cancelar',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;

                }

            },
            'importar': {
                url: 'api/servico-declarado/importar-xml',
                method: 'POST',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'getAllTiposDocumentosServicoDeclarado': {
                url: '/api/servico-declarado/tipos-documentos-servico-declarado',
                method: 'GET',
                isArray: true
            },
            'buscarServicosDeclarados': {
                method: 'POST',
                url: 'api/servico-declarado/buscar-servicos-declarados',
                isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    for (var i = 0; i < data.length; i++) {
                        var nota = data[i];
                        convertDateFromServer(nota);
                    }
                    return data;
                }
            },
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('servicoDeclarado', {
                parent: 'entity',
                url: '/servicos-declarados',
                data: {
                    roles: ['ROLE_CONTRIBUINTE'],
                    pageTitle: 'Serviços Declarados'
                },
                ncyBreadcrumb: {
                    label: 'Consulta de Serviços Declarados'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/servico-declarado/servico-declarado.html',
                        controller: 'ServicoDeclaradoController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('notaFiscal');
                        $translatePartialLoader.addPart('tipoDocumento');
                        $translatePartialLoader.addPart('declaracaoPrestacaoServico');
                        $translatePartialLoader.addPart('situacaoNota');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('localExecucao');
                        $translatePartialLoader.addPart('regimeTributario');
                        $translatePartialLoader.addPart('naturezaOperacao');
                        $translatePartialLoader.addPart('tipoServicoDeclarado');

                        return $translate.refresh();
                    }]
                }
            })
            .state('servicoDeclarado.new', {
                parent: 'servicoDeclarado',
                url: '/novo-servico-declarado',
                data: {
                    roles: ['ROLE_CONTRIBUINTE'],
                    pageTitle: 'Serviço Declarado'
                },
                ncyBreadcrumb: {
                    label: 'Serviço Declarado'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/servico-declarado/servico-declarado-edit.html',
                        controller: 'ServicoDeclaradoEditController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('declaracaoPrestacaoServico');
                        $translatePartialLoader.addPart('tomador');
                        $translatePartialLoader.addPart('dadosPessoais');
                        $translatePartialLoader.addPart('endereco');
                        $translatePartialLoader.addPart('servico');
                        $translatePartialLoader.addPart('modalidadeNota');
                        $translatePartialLoader.addPart('regimeTributario');
                        $translatePartialLoader.addPart('localExecucao');
                        $translatePartialLoader.addPart('naturezaOperacao');

                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServicoDeclarado', 'localStorageService', '$state', function ($stateParams, ServicoDeclarado, localStorageService, $state) {
                        return {};
                    }]
                }
            })
            .state('servicoDeclarado.detail', {
                parent: 'servicoDeclarado',
                url: '/detalhes-servico-declarado/{id}',
                data: {
                    roles: ['ROLE_EMPRESA_DOC_RECEBIDO'],
                    pageTitle: 'Serviço Declarado'
                },
                ncyBreadcrumb: {
                    label: 'Detalhes do Serviço Declarado'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/servico-declarado/servico-declarado-detail.html',
                        controller: 'ServicoDeclaradoDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('declaracaoPrestacaoServico');
                        $translatePartialLoader.addPart('tomador');
                        $translatePartialLoader.addPart('dadosPessoais');
                        $translatePartialLoader.addPart('endereco');
                        $translatePartialLoader.addPart('servico');
                        $translatePartialLoader.addPart('modalidadeNota');
                        $translatePartialLoader.addPart('localExecucao');
                        $translatePartialLoader.addPart('regimeTributario');
                        $translatePartialLoader.addPart('naturezaOperacao');

                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServicoDeclarado', '$state', function ($stateParams, ServicoDeclarado, $state) {
                        return ServicoDeclarado.get({id: $stateParams.id},
                            function (sucess) {
                                return sucess;
                            }, function (error) {
                                $state.go('servicoDeclarado');
                            });
                    }]
                }
            })
            .state('servicoDeclarado.import', {
                parent: 'servicoDeclarado',
                url: '/importacao-servico-declarado',
                data: {
                    roles: ['ROLE_EMPRESA_DOC_RECEBIDO'],
                    pageTitle: 'Serviço Declarado'
                },
                ncyBreadcrumb: {
                    label: 'Importação de Serviço Declarado via XML'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/servicoDeclarado/servico-declarado-import.html',
                        controller: 'ServicoDeclaradoImportController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('rPS');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {numero: null, serie: null, dataEmissao: null, id: null};
                    }
                }

            })
    });

'use strict';

angular.module('nfseApp')
    .controller('ServicoDeclaradoController',
        function ($scope, $window, ServicoDeclarado, NotaFiscalSearch, ImpressaoPdf, $modal, ParseLinks, ExportarXls,
                  localStorageService, $http, SweetAlert) {
            $scope.per_page = 10;
            $scope.empresa = localStorageService.get("prestadorPrincipal");

            $scope.buscarOperacoes = function (tipo) {
                var operacoes = [];
                operacoes.push({nome: 'Igual', value: 'IGUAL'});
                if (tipo === 'inteiro' || tipo === 'decimal' || tipo === 'data') {
                    operacoes.push({nome: 'Maior ou igual', value: 'MAIOR_IGUAL'});
                }
                if (tipo === 'inteiro' || tipo === 'decimal' || tipo === 'data') {
                    operacoes.push({nome: 'Menor ou igual', value: 'MENOR_IGUAL'});
                }
                if (tipo === 'inteiro' || tipo === 'decimal' || tipo === 'data') {
                    operacoes.push({nome: 'Menor', value: 'MENOR'});
                }
                if (tipo === 'inteiro' || tipo === 'decimal' || tipo === 'data') {
                    operacoes.push({nome: 'Maior', value: 'MAIOR'});
                }
                if (tipo === 'texto') {
                    operacoes.push({nome: 'Contém', value: 'LIKE'});
                }
                return operacoes;
            };

            $scope.filtrosDisponiveis = [
                {
                    nomeAtributo: 'lower(dadospessoaistomador.nomerazaosocial)',
                    tipo: 'texto',
                    descricao: 'Tomador - Nome/Razão Social',
                    operacoes: $scope.buscarOperacoes('texto')
                },
                {
                    nomeAtributo: 'dadospessoaistomador.cpfcnpj',
                    tipo: 'texto',
                    descricao: 'Tomador - CPF/CNPJ',
                    operacoes: $scope.buscarOperacoes('texto')
                },
                {
                    nomeAtributo: 'lower(dadospessoaisprestador.nomerazaosocial)',
                    tipo: 'texto',
                    descricao: 'Prestador - Nome/Razão Social',
                    operacoes: $scope.buscarOperacoes('texto')
                },
                {
                    nomeAtributo: 'dadospessoaisprestador.cpfcnpj',
                    tipo: 'texto',
                    descricao: 'Prestador - CPF/CNPJ',
                    operacoes: $scope.buscarOperacoes('texto')
                },
                {
                    nomeAtributo: 'coalesce(nota.numero, sd.numero)',
                    tipo: 'inteiro',
                    descricao: 'Número da Nota',
                    operacoes: $scope.buscarOperacoes('inteiro')
                },
                {
                    nomeAtributo: 'coalesce(nota.homologacao, false)',
                    tipo: 'logico',
                    descricao: 'Homologação',
                    operacoes: $scope.buscarOperacoes('logico')
                },
                {
                    nomeAtributo: 'dec.totalservicos',
                    tipo: 'decimal',
                    descricao: 'Valor dos Serviços',
                    operacoes: $scope.buscarOperacoes('decimal')
                },
                {
                    nomeAtributo: 'round(dec.isscalculado, 2)',
                    tipo: 'decimal',
                    descricao: 'Valor do Iss',
                    operacoes: $scope.buscarOperacoes('decimal')
                },
                {
                    nomeAtributo: "date_trunc('day', coalesce(nota.emissao, sd.emissao))",
                    tipo: 'data',
                    descricao: 'Emissão',
                    operacoes: $scope.buscarOperacoes('data')
                },
                {
                    nomeAtributo: "case when nota.id is not null then 'SERVICO_PRESTADO' else sd.tiposervicodeclarado end",
                    tipo: 'enum',
                    descricao: 'Tipo',
                    operacoes: $scope.buscarOperacoes('enum')
                }
            ];

            $scope.filtrosSelecionados = [];

            $scope.validarFiltros = function () {
                for (var i = 0; i < $scope.filtrosSelecionados.length; i++) {
                    if ($scope.filtrosSelecionados[i].atributo == null) {
                        SweetAlert.warning("Filtro Personalizado inválido!", "Selecione uma opção de filtro.");
                        return false;
                    }
                    if (!$scope.filtrosSelecionados[i].operacao) {
                        SweetAlert.warning("Filtro Personalizado inválido!", "Selecione um operador de filtro.");
                        return false;
                    }
                    if (!$scope.filtrosSelecionados[i].valorString && $scope.filtrosSelecionados[i].atributo.tipo === 'texto'
                     || !$scope.filtrosSelecionados[i].valorData && $scope.filtrosSelecionados[i].atributo.tipo === 'data'
                     || !$scope.filtrosSelecionados[i].valorDecimal && $scope.filtrosSelecionados[i].atributo.tipo === 'decimal'
                     || !$scope.filtrosSelecionados[i].valorInteger && $scope.filtrosSelecionados[i].atributo.tipo === 'inteiro') {
                        SweetAlert.warning("Filtro Personalizado inválido!", "Selecione um valor de filtro.");
                        return false;
                    }
                }
                return true;
            };

            $scope.montarConsultaServicoDeclarado = function () {
                var campos = [];

                if (!$scope.empresa.prestador.foraMunicipio) {
                    campos.push({
                        campo: "coalesce(nota.prestador_id, sd.cadastroeconomico_id)",
                        operador: "IGUAL",
                        valorLong: $scope.empresa.prestador.id
                    });
                } else {
                    campos.push({
                        campo: "coalesce(dadospessoaisprestador.pessoa_id, dadospessoaistomador.pessoa_id)",
                        operador: "IGUAL",
                        valorLong: $scope.empresa.prestador.id
                    });
                }
                var contemHomologacao = false;
                angular.forEach($scope.filtrosSelecionados, function (filtro) {
                    if (filtro.atributo.nomeAtributo === 'coalesce(nota.homologacao, false)')
                        contemHomologacao = true;
                    if (filtro.atributo.tipo === 'texto' && !filtro.valorString)
                        filtro.valorString = "";
                    campos.push(
                        {
                            operador: filtro.operacao,
                            campo: filtro.atributo.nomeAtributo,
                            valorString: (filtro.valorString ? filtro.atributo.tipo === 'enum' ? filtro.valorString.trim() : filtro.operacao !== 'LIKE' ? filtro.valorString.trim().toLowerCase() : '%' + filtro.valorString.trim().toLowerCase() + '%' : null),
                            valorDate: filtro.valorData,
                            valorLogico: filtro.valorLogico,
                            valorDecimal: filtro.valorDecimal,
                            valorInteger: filtro.valorInteger
                        }
                    );
                });

                if (!contemHomologacao)
                    campos.push({
                        operador: 'IGUAL',
                        campo: 'coalesce(nota.homologacao, false)',
                        valorLogico: false
                    });

                if (!$scope.orderBy) {
                    $scope.orderBy = "nota.numero";
                    $scope.sortReverse = true;
                }

                return {
                    offset: $scope.page,
                    limit: $scope.per_page,
                    parametrosQuery: [{
                        juncao: " and ",
                        parametroQueryCampos: campos
                    }],
                    orderBy: " order by " + $scope.orderBy + " " + ($scope.sortReverse ? 'desc' : 'asc')
                };
            };

            $scope.montarConsultaServicoDeclaradoRelatorios = function () {
                var campos = [];

                if (!$scope.empresa.prestador.foraMunicipio) {
                    campos.push({
                        campo: "coalesce(nota.prestador_id, sd.cadastroeconomico_id)",
                        operador: "IGUAL",
                        valorLong: $scope.empresa.prestador.id
                    });
                } else {
                    campos.push({
                        campo: "coalesce(dadospessoaisprestador.pessoa_id, dadospessoaistomador.pessoa_id)",
                        operador: "IGUAL",
                        valorLong: $scope.empresa.prestador.id
                    });
                }

                var contemHomologacao = false;
                angular.forEach($scope.filtrosSelecionados, function (filtro) {
                    if (filtro.atributo.nomeAtributo === 'coalesce(nota.homologacao, false)')
                        contemHomologacao = true;
                    if (filtro.atributo.tipo === 'texto' && !filtro.valorString)
                        filtro.valorString = "";
                    campos.push(
                        {
                            operador: filtro.operacao,
                            campo: filtro.atributo.nomeAtributo,
                            valorString: (filtro.valorString ? filtro.atributo.tipo === 'enum' ? filtro.valorString.trim() : filtro.operacao !== 'LIKE' ? filtro.valorString.trim().toLowerCase() : '%' + filtro.valorString.trim().toLowerCase() + '%' : null),
                            valorDate: filtro.valorData,
                            valorLogico: filtro.valorLogico,
                            valorDecimal: filtro.valorDecimal,
                            valorInteger: filtro.valorInteger
                        }
                    );
                });

                if (!contemHomologacao)
                    campos.push({
                        operador: 'IGUAL',
                        campo: 'coalesce(nota.homologacao, false)',
                        valorLogico: false
                    });
                return {
                    foraMunicipio: $scope.empresa.prestador.foraMunicipio,
                    idEmpresa: $scope.empresa.prestador.id,
                    parametros: [{
                        juncao: " and ",
                        parametroQueryCampos: campos
                    }]
                };
            };

            $scope.adicionarFiltro = function () {
                var filtro = {};
                $scope.filtrosSelecionados.push(filtro);
            };

            $scope.removerFiltro = function (index) {
                $scope.filtrosSelecionados.splice(index, 1);
                $scope.loadAll();
            };

            $scope.selecionouCampo = function (filtro) {
                filtro.valorString = null;
                filtro.valorDecimal = null;
                filtro.valorInteger = null;
                filtro.valorLogico = false;
                filtro.valorData = null;
            };


            $scope.loadAll = function () {
                if (!$scope.validarFiltros()) {
                    return;
                }
                var consultaServicos = $scope.montarConsultaServicoDeclarado();
                ServicoDeclarado.buscarServicosDeclarados(consultaServicos, function (result, headers) {
                    if (headers)
                        $scope.links = ParseLinks.parse(headers('link'));
                    $scope.servicosDeclarados = result;
                });
            };

            $scope.loadPage = function (page) {
                $scope.page = page;
                $scope.loadAll();
            };

            $scope.loadAll();

            $scope.imprimirNota = function (id) {
                ImpressaoPdf.imprimirPdfViaUrl('/publico/notaFiscal/imprime/' + id);
            };

            $scope.refresh = function () {
                $scope.loadAll();
                $scope.clear();
            };

            $scope.cancelarServicoDeclarado = function (servicoDeclarado) {
                var modalInstance = $modal.open({
                    templateUrl: 'app/entities/servico-declarado/cancelamento-servico-declarado.html',
                    controller: 'CancelamentoServicoDeclaradoController',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return ServicoDeclarado.get({id: servicoDeclarado.id}).$promise;
                        }
                    }
                });
                modalInstance.result.then(function () {
                    $scope.loadAll();
                }, function () {
                    //$log.info('Modal dismissed at: ' + new Date());
                });
            };

            $scope.baixarPDF = function () {
                $scope.sortReverse = false;
                var consultaServicos = $scope.montarConsultaServicoDeclaradoRelatorios();
                ImpressaoPdf.imprimirPdfViaPost('/api/servico-declarado/relatorio-pdf', consultaServicos);
            };

            $scope.baixarXls = function () {
                var consultaServicos = $scope.montarConsultaServicoDeclaradoRelatorios();
                $http.post('api/servico-declarado/relatorio-xls', consultaServicos, {responseType: 'arraybuffer'}).then(function (response) {
                    if (response.data.byteLength == 0) {
                        Notificacao.warn('Atenção', 'Nenhum registro para ser impresso.');
                    } else {
                        var blob = new Blob([response.data], {
                            type: "application/excel"
                        });
                        saveAs(blob, "ServicosDeclarados.xls");
                    }
                });
            };
        });

angular.module('nfseApp')
    .controller('CancelamentoServicoDeclaradoController',
        function ($scope, ServicoDeclarado, entity, SweetAlert, $modalInstance, Account) {

            $scope.servicoDeclarado = entity;
            $scope.podeSolicitar = false;
            $scope.cancelando = false;

            console.log($scope.servicoDeclarado);

            if (!$scope.servicoDeclarado.declaracaoPrestacaoServico.cancelamento ||
                !$scope.servicoDeclarado.declaracaoPrestacaoServico.cancelamento.situacaoFiscal ||
                $scope.servicoDeclarado.declaracaoPrestacaoServico.cancelamento.situacaoFiscal == 'NAO_DEFERIDO') {
                $scope.podeSolicitar = true;
                $scope.cancelamento = {servicoDeclarado: entity};
                Account.get().$promise
                    .then(function (account) {
                        $scope.cancelamento.usuarioTomador = account.data;
                    });
            }

            $scope.cancelarServicoDeclarado = function () {
                SweetAlert.swal({
                        title: "Confirme o cancelamento",
                        text: "Você tem certeza que quer cancelar o Serviço Declarado?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55", confirmButtonText: "Sim",
                        cancelButtonText: "Não",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm && !$scope.cancelando) {
                            $scope.cancelando = true;
                            ServicoDeclarado.cancelar($scope.cancelamento, function (data) {
                                $modalInstance.close(data);
                            });
                        }
                    });
            };

            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };
        });


'use strict';

angular.module('nfseApp')
    .controller('ServicoSearchController', function ($scope, Servico, ServicoSearch, ParseLinks, SweetAlert, $modalInstance) {
        $scope.servicos = [];
        $scope.page = 1;
        $scope.loadAll = function () {
            Servico.query({page: $scope.page, per_page: 5}, function (result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.servicos = result;
            });
        };
        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.search = function () {
            ServicoSearch.query({query: $scope.searchQuery}, function (result) {
                $scope.servicos = result;
            }, function (response) {
                if (response.status === 404) {
                    $scope.loadAll();
                }
            });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.servico = {codigo: null, descricao: null, ativo: null, id: null};
        };

        $scope.ok = function (servico) {
            $modalInstance.close(servico);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    });

'use strict';

angular.module('nfseApp').controller('ServicoDialogController',
    ['$scope', '$state', '$stateParams', 'entity', 'Servico', 'Cnae', 'ParseLinks', 'Notificacao',
        function ($scope, $state, $stateParams, entity, Servico, Cnae, ParseLinks, Notificacao) {

            $scope.loadAllCnaes = function () {
                Cnae.query({page: $scope.page, per_page: 1000}, function (result, headers) {
                    $scope.cnaes = result;
                });
            };

            $scope.servico = entity;
            $scope.load = function (id) {
                Servico.get({id: id}, function (result) {
                    $scope.servico = result;
                });
            };

            $scope.loadAllCnaes();

            var onSaveFinished = function (result) {
                $state.go("servico");
                Notificacao.info("Serviço salvo com sucesso.");
            };

            $scope.save = function () {
                if ($scope.servico.id != null) {
                    Servico.update($scope.servico, onSaveFinished);
                } else {
                    Servico.save($scope.servico, onSaveFinished);
                }
            };

            $scope.clear = function () {

            };
        }]);

'use strict';

angular.module('nfseApp')
    .controller('ServicoDetailController', function ($scope, $rootScope, $stateParams, entity, Servico) {
        $scope.servico = entity;
        $scope.load = function (id) {
            Servico.get({id: id}, function(result) {
                $scope.servico = result;
            });
        };
        $rootScope.$on('nfseApp:servicoUpdate', function(event, result) {
            $scope.servico = result;
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('Servico', function ($resource, DateUtils) {
        return $resource('api/servicos/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'queryByPrestador': {method: 'GET', isArray: true, url: '/api/servicos-prestador'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getPorCodigo': {
                method: 'GET',
                url: "api/servico_por_codigo/:codigo"
            },
            'getPorCnae': {
                method: 'GET',
                isArray: true,
                url: "api/servicos-por-cnae/:id",
            },
            'getPorCnaePrestador': {
                method: 'GET',
                isArray: true,
                url: "api/servicos-por-cnae-prestador",
            },
            'getPorCodigoPorPrestador': {
                method: 'GET',
                url: "api/servico_por_codigo_prestador/:codigo",
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'buscarPorCnae': {
                method: 'GET',
                url: "api/servico-por-cnae",
                isArray: true
            },
            'update': {method: 'PUT'}
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('ServicoSearch', function ($resource) {
        return $resource('api/_search/servicos/:query', {}, {
            'query': {method: 'GET', isArray: true},
            'queryByPrestador': {method: 'GET', isArray: true, url: '/api/servicos-prestador'},
            'queryByPrestadorAndCnae': {method: 'GET', isArray: true, url: '/api/servicos-prestador-cnae'}
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('servico', {
                parent: 'entity',
                url: '/servicos',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'Serviços'
                },
                ncyBreadcrumb: {
                    label: 'Consulta de Serviço'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/servico/servicos.html',
                        controller: 'ServicoController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('servico');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('servico.detail', {
                parent: 'servico',
                url: '/detalhes/{id}',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'nfseApp.servico.detail.title'
                },
                ncyBreadcrumb: {
                    label: 'Detalhes do Serviço'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/servico/servico-detail.html',
                        controller: 'ServicoDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('servico');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Servico', function ($stateParams, Servico) {
                        return Servico.get({id: $stateParams.id});
                    }]
                }
            })
            .state('servico.new', {
                parent: 'servico',
                url: '/novo',
                data: {
                    roles: ['ROLE_ADMIN'],
                },
                ncyBreadcrumb: {
                    label: 'Novo Serviço'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/servico/servico-dialog.html',
                        controller: 'ServicoDialogController'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('servico');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {codigo: null, descricao: null, ativo: true, id: null};
                    }
                }
            })
            .state('servico.edit', {
                parent: 'servico',
                url: '/edicao/{id}',
                data: {
                    roles: ['ROLE_ADMIN'],
                },
                ncyBreadcrumb: {
                    label: 'Edição de Serviço'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/servico/servico-dialog.html',
                        controller: 'ServicoDialogController'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('servico');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Servico', function ($stateParams, Servico) {
                        return Servico.get({id: $stateParams.id});
                    }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('ServicoController', function ($scope, Servico, ServicoSearch, ParseLinks, SweetAlert) {
        $scope.servicos = [];
        $scope.page = 1;
        $scope.loadAll = function() {
            Servico.query({page: $scope.page, per_page: 20}, function(result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.servicos = result;
            });
        };

        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();


        $scope.confirmDelete = function (id) {
            Servico.delete({id: id},
                function () {
                    $scope.loadAll();
                    SweetAlert.info("Removido!", "O registro foi removido com sucesso.", "success");
                    $scope.clear();
                });
        };

        $scope.search = function () {
            ServicoSearch.query({query: $scope.searchQuery}, function(result) {
                $scope.servicos = result;
            }, function(response) {
                if(response.status === 404) {
                    $scope.loadAll();
                }
            });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.servico = {codigo: null, descricao: null, aliquota: null, id: null};
        };

        $scope.delete = function (id) {
            Servico.get({id: id}, function (result) {
                $scope.servico = result;
                SweetAlert.swal({
                        title: "Confirme a exclusão",
                        text: "Você tem certeza que quer excluir o registro selecionado?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55", confirmButtonText: "Sim, Excluir",
                        cancelButtonText: "Não, Cancelar",
                        closeOnConfirm: false,
                        closeOnCancel: false
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            $scope.confirmDelete(id);
                        } else {
                            SweetAlert.info("Cancelado", "O registro não foi removido :)", "error");
                        }
                    });
            });
        };
    });

'use strict';

angular.module('nfseApp').controller('RPSImportController',
    ['$scope', '$stateParams', 'entity', 'RPS', 'localStorageService', '$state',
        function ($scope, $stateParams, entity, RPS, localStorageService, $state) {

            $scope.lote = {file: '', prestador: localStorageService.get("prestadorPrincipal").prestador};

            $scope.uploadXmlFile = function (file) {
                console.log(file);
                var reader = new FileReader();
                reader.onload = function (evt) {
                    console.log(evt);
                    $scope.$apply(function ($scope) {
                        $scope.arquivoSelecionado = file;
                        $scope.lote.file = evt.target.result;
                    });
                };
                reader.readAsDataURL(file);
            };


            $scope.enviarArquivo = function () {
                RPS.importar($scope.lote, function (lote) {
                    $state.go("loteRPS.detail", {id: lote.id})
                });
            }

        }]);

'use strict';

angular.module('nfseApp').controller('RPSEditController',
    ['$scope', '$stateParams', 'entity', 'RPS',
        function ($scope, $stateParams, entity, RPS) {

            $scope.rPS = entity;
            $scope.load = function (id) {
                RPS.get({id: id}, function (result) {
                    $scope.rPS = result;
                });
            };

            var onSaveFinished = function (result) {
                $scope.$emit('nfseApp:rPSUpdate', result);
            };

            $scope.save = function () {
                if ($scope.rPS.id != null) {
                    RPS.update($scope.rPS, onSaveFinished);
                } else {
                    RPS.save($scope.rPS, onSaveFinished);
                }
            };

        }]);

'use strict';

angular.module('nfseApp')
    .controller('RPSDetailController', function ($scope, $rootScope, $stateParams, entity, RPS) {
        $scope.rPS = entity;
        $scope.load = function (id) {
            RPS.get({id: id}, function(result) {
                $scope.rPS = result;
            });
        };
        $rootScope.$on('nfseApp:rPSUpdate', function(event, result) {
            $scope.rPS = result;
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('RPS', function ($resource, DateUtils) {
        return $resource('api/rps/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'queryComFiltros': {
                method: 'POST',
                url: 'api/buscar-rps-filtro',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'autenticar': {
                url: 'api/rps-por-cnpj-numero-serie',
                method: 'GET',
                transformRequest: function (data) {
                    return angular.toJson(data);
                },
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'importar': {
                url: 'api/rps/importar-xml',
                method: 'POST',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            }
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('RPSSearch', function ($resource) {
        return $resource('api/_search/rps/:query', {}, {
            'query': { method: 'GET', isArray: true},
            'queryComFiltros': {
                method: 'POST',
                url: 'api/buscar-rps-filtro',
                isArray: true
            },
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('rPS', {
                parent: 'entity',
                url: '/rps',
                data: {
                    roles: ['ROLE_EMPRESA_RPS'],
                    pageTitle: 'Recibo provisório de serviço'
                },
                ncyBreadcrumb: {
                    label: 'Consulta de RPS'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rPS/rPSs.html',
                        controller: 'RPSController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('rPS');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('rPS.detail', {
                parent: 'entity',
                url: '/rps/{id}',
                data: {
                    roles: ['ROLE_EMPRESA_RPS'],
                    pageTitle: 'Recibo provisório de serviço'
                },
                ncyBreadcrumb: {
                    label: 'Detalhes do RPS'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rPS/rPS-detail.html',
                        controller: 'RPSDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('rPS');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'RPS', function ($stateParams, RPS) {
                        return RPS.get({id: $stateParams.id});
                    }]
                }
            })
            .state('rPS.autenticar', {
                parent: 'entity',
                url: '/rps-autenticar',
                data: {
                    roles: [],
                    pageTitle: 'Consulte a Substituição de RPS em NFS-e'
                },
                ncyBreadcrumb: {
                    label: 'Autenticar RPS'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rPS/autenticar-rps.html',
                        controller: 'AutenticarRpsController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('rPS');
                        return $translate.refresh();
                    }]
                }
            })
            .state('rPS.new', {
                parent: 'rPS',
                url: '/new',
                data: {
                    roles: ['ROLE_EMPRESA_RPS'],
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rPS/rPS-edit.html',
                        controller: 'RPSEditController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('rPS');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {numero: null, serie: null, dataEmissao: null, id: null};
                    }
                }

            })
            .state('rPS.import', {
                parent: 'entity',
                url: '/importacao',
                data: {
                    roles: ['ROLE_EMPRESA_RPS'],
                    pageTitle: 'Recibo provisório de serviço'
                },
                ncyBreadcrumb: {
                    label: 'Importação de RPS via xml'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rPS/rPS-import.html',
                        controller: 'RPSImportController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('rPS');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {numero: null, serie: null, dataEmissao: null, id: null};
                    }
                }

            })
            .state('rPS.edit', {
                parent: 'rPS',
                url: '/{id}/edit',
                data: {
                    roles: ['ROLE_EMPRESA_RPS'],
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rPS/rPS-edit.html',
                        controller: 'RPSEditController',
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('rPS');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'RPS', function ($stateParams, RPS) {
                        return RPS.get({id: $stateParams.id});
                    }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('RPSController', function ($scope, $state, RPS, RPSSearch, ParseLinks, SweetAlert, ExportarXls) {
        $scope.listaRps = [];
        $scope.page = 0;
        $scope.searchQuery = "";
        $scope.per_page = 20;

        $scope.buscarOperacoes = function (tipo) {
            var operacoes = [];
            operacoes.push({nome: 'Igual', value: 'IGUAL'});
            if (tipo === 'inteiro' || tipo === 'decimal' || tipo === 'data') {
                operacoes.push({nome: 'Maior ou igual', value: 'MAIOR_IGUAL'});
            }
            if (tipo === 'inteiro' || tipo === 'decimal' || tipo === 'data') {
                operacoes.push({nome: 'Menor ou igual', value: 'MENOR_IGUAL'});
            }
            if (tipo === 'inteiro' || tipo === 'decimal' || tipo === 'data') {
                operacoes.push({nome: 'Menor', value: 'MENOR'});
            }
            if (tipo === 'inteiro' || tipo === 'decimal' || tipo === 'data') {
                operacoes.push({nome: 'Maior', value: 'MAIOR'});
            }
            if (tipo === 'texto') {
                operacoes.push({nome: 'Contém', value: 'LIKE'});
            }
            console.log('operacoes', operacoes);
            return operacoes;
        };

        $scope.filtrosDisponiveis = [
            {
                nomeAtributo: 'cast(a.numero as integer)',
                tipo: 'inteiro',
                descricao: 'Número do RPS',
                operacoes: $scope.buscarOperacoes('inteiro')
            },
            {
                nomeAtributo: 'a.totalServicos',
                tipo: 'decimal',
                descricao: 'Valor dos Serviços',
                operacoes: $scope.buscarOperacoes('decimal')
            },
            {
                nomeAtributo: 'a.issPagar',
                tipo: 'decimal',
                descricao: 'Valor do Iss',
                operacoes: $scope.buscarOperacoes('decimal')

            },
            {
                nomeAtributo: 'nota.numero',
                tipo: 'decimal',
                descricao: 'Número da Nfse',
                operacoes: $scope.buscarOperacoes('decimal')
            },
            {
                nomeAtributo: 'cast(lote.numero as varchar)',
                tipo: 'inteiro',
                descricao: 'Número do Lote',
                operacoes: $scope.buscarOperacoes('inteiro')
            }
        ];

        $scope.filtrosSelecionados = [];

        $scope.selecionouCampo = function (filtro) {
            filtro.valorTexto = null;
            filtro.valorDecimal = null;
            filtro.valorInteiro = null;
            filtro.valorLogico = false;
            filtro.valorData = null;
        };

        $scope.validarFiltros = function () {
            for (var i = 0; i < $scope.filtrosSelecionados.length; i++) {
                if ($scope.filtrosSelecionados[i].atributo == null) {
                    SweetAlert.warning("Filtro Personalizado inválido!", "Selecione uma opção de filtro.");
                    return false;
                }
                if (!$scope.filtrosSelecionados[i].operacao) {
                    SweetAlert.warning("Filtro Personalizado inválido!", "Selecione um operador de filtro.");
                    return false;
                }
                if ($scope.filtrosSelecionados[i].atributo.tipo != 'logico' &&
                    !$scope.filtrosSelecionados[i].valorTexto &&
                    !$scope.filtrosSelecionados[i].valorData &&
                    !$scope.filtrosSelecionados[i].valorDecimal &&
                    !$scope.filtrosSelecionados[i].valorInteiro) {
                    SweetAlert.warning("Filtro Personalizado inválido!", "Defina um valor para o filtro.");
                    return false;
                }
            }
            return true;
        };

        $scope.montarFiltros = function () {
            var lista = [];

            angular.forEach($scope.filtrosSelecionados, function (filtro, index) {

                lista.push(
                    {
                        operacao: filtro.operacao,
                        campo: filtro.atributo.nomeAtributo,
                        valorTexto: (filtro.operacao !== 'LIKE' ? filtro.valorTexto : '%' + filtro.valorTexto.trim().toLowerCase() + '%'),
                        valorData: filtro.valorData,
                        valorLogico: filtro.valorLogico,
                        valorDecimal: filtro.valorDecimal,
                        valorInteiro: filtro.valorInteiro
                    }
                );
            });
            return lista;
        };

        $scope.loadAll = function () {
            if (!$scope.validarFiltros()) {
                return;
            }

            var lista = $scope.montarFiltros();

            RPS.queryComFiltros({
                page: $scope.page ? $scope.page : 0,
                per_page: $scope.per_page,
                filtros: lista
            }, function (result, headers) {
                if (headers)
                    $scope.links = ParseLinks.parse(headers('link'));
                $scope.listaRps = result;
            });
        };

        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };

        $scope.loadAll();

        $scope.delete = function (id) {
            RPS.get({id: id}, function (result) {
                $scope.aidfe = result;

                SweetAlert.swal({
                        title: "Confirme a exclusão",
                        text: "Você tem certeza que quer excluir esse RPS?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55", confirmButtonText: "Sim, Excluir",
                        cancelButtonText: "Não, Cancelar",
                        closeOnConfirm: false,
                        closeOnCancel: false
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            $scope.confirmDelete(id);
                        } else {
                            SweetAlert.info("Cancelado", "O RPS não foi removido :)", "error");
                        }
                    });
            });
        };

        $scope.confirmDelete = function (id) {
            RPS.delete({id: id},
                function () {
                    SweetAlert.info("Removido!", "O RPS foi removido com sucesso.", "success");
                    $state.reload();
                });
        };

        $scope.refresh = function () {
            $scope.loadAll();
        };

        $scope.gerarNota = function (rps) {
            SweetAlert.swal({
                    title: "Confirme para gerar a Nota Fiscal",
                    text: "Tem certeza que quer gerar a nota fiscal  do RPS de N° " + rps.numero + " para a competência atual? ",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#F7A54A", confirmButtonText: "Sim, Copiar Nota Fiscal",
                    cancelButtonText: "Não, Cancelar",
                    closeOnConfirm: false,
                    closeOnCancel: false
                },
                function (isConfirm) {
                    if (isConfirm) {
                        $state.go('notaFiscal.byRps', ({numeroRps: rps.numero}));
                        SweetAlert.info("Nota Fiscal Copiada!", "Prossiga para a emissão da Nota Fiscal.", "success");
                    } else {
                        SweetAlert.info("Cancelado", "A Nota Fiscal não foi copiada.", "error");
                    }
                }
            )
        };

        $scope.adicionarFiltro = function () {
            var filtro = {
                campo1: ":param" + ($scope.filtrosSelecionados.length + 1),
                operacao: 'LIKE',
                local: 1,
                ehData: false
            };
            $scope.filtrosSelecionados.push(filtro);
        };

        $scope.removerFiltro = function (index) {
            $scope.filtrosSelecionados.splice(index, 1);
        };

        var colunas = [
            {descricao: 'Número', valor: 'numero'},
            {descricao: 'Série', valor: 'serie'},
            {descricao: 'Emissão', valor: 'dataEmissao'},
            {descricao: 'Valor Serviços', valor: 'totalServicos'},
            {descricao: 'Valor ISS', valor: 'iss'},
            {descricao: 'Núemro da Nfse', valor: 'numeroNotaFiscal'},
            {descricao: 'Núemro do Lote', valor: 'numeroLote'},
        ];

        $scope.baixarXls = function () {
            var xls = {
                colunas: colunas,
                linhas: $scope.listaRps
            };
            ExportarXls.getXls(xls);
        };
        $scope.baixarPDF = function () {
            var xls = {
                colunas: colunas,
                linhas: $scope.listaRps
            };
            ExportarXls.getPdf(xls);
        };


    });

'use strict';

angular.module('nfseApp').controller('AutenticarRpsController',
    ['$rootScope', '$scope', '$modal', '$state', '$filter', '$stateParams', 'RPS', 'Notificacao', 'ImpressaoPdf',
        function ($rootScope, $scope, $modal, $state, $filter, $stateParams, RPS, Notificacao, ImpressaoPdf) {

            $scope.limpar = function () {
                $scope.autenticar = {cpfCnpj: "", numero: "", serie: ""};
                $scope.valido = null;
                $scope.rps = null;
            };
            $scope.limpar();

            $scope.autenticarRps = function () {
                console.log("Autenticar", $scope.autenticar);
                RPS.autenticar($scope.autenticar,
                    function (data) {
                        if (data.idNotaFiscal) {
                            Notificacao.info("Válido", "Os valores representam um RPS emitido e válido");
                        } else {
                            Notificacao.info("Válido", "Os valores representam um RPS emitido e válido, porém o RPS ainda não foi substituído por uma Nota Fiscal");
                        }
                        $scope.valido = true;
                        $scope.rps = data;
                    }, function (error) {
                        Notificacao.error("Inválido", "Ainda não existe nenhum RPS com os campos informados");
                        $scope.valido = false;
                    });
            };

            $scope.imprimirNota = function (id) {
                ImpressaoPdf.imprimirPdfViaUrl('/publico/notaFiscal/imprime/' + id);
            };


        }])
;

(function () {
    'use strict';

    angular.module('nfseApp')
        .factory('Report', function ($resource) {
            return $resource('spring/report/:id', {}, {
                'getByUuid': {
                    url: 'spring/report/get-by-uuid',
                    method: 'GET'
                }
            });
        });
})();

(function () {
    'use strict';

    angular.module('nfseApp')
        .controller('RelatorioResumidoDetalhadoController', function ($scope, $modalInstance) {

            $scope.resumido = function () {
                $modalInstance.close(false);
            };

            $scope.detalhado = function () {
                $modalInstance.close(true);
            };

            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };
        });
})();
(function () {
    'use strict';

    angular.module('nfseApp').controller('ProdutoServicoSearchController',
        function ($scope, $state, $modalInstance, ProdutoServico, ParseLinks) {

            $scope.registros = [];
            $scope.filtro = {
                codigo: '',
                descricao: ''
            };
            $scope.page;
            $scope.per_page = 10;

            $scope.ok = function (registro) {
                $modalInstance.close(registro);
            };

            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };

            $scope.montarConsulta = function () {
                var campos = [];

                if ($scope.filtro.codigo) {
                    campos.push({
                        campo: "obj.codigo",
                        operador: "LIKE",
                        valorString: '%' + $scope.filtro.codigo + '%'
                    });
                }

                if ($scope.filtro.descricao) {
                    campos.push({
                        campo: "obj.descricao",
                        operador: "LIKE",
                        valorString: '%' + $scope.filtro.descricao + '%'
                    });
                }

                return {
                    offset: $scope.page,
                    limit: $scope.per_page,
                    parametrosQuery: [{
                        juncao: " and ",
                        parametroQueryCampos: campos
                    }]
                };
            };

            $scope.loadAll = function () {
                var consulta = $scope.montarConsulta();
                ProdutoServico.consultar(consulta,
                    function (result, headers) {
                        if (headers)
                            $scope.links = ParseLinks.parse(headers('link'));
                        $scope.registros = result;
                    });
            };

            $scope.loadAll();
        });
})();
(function () {
    'use strict';

    angular.module('nfseApp')
        .factory('ProdutoServico', function ($resource) {
            return $resource('api/produto-servico/:id', {}, {
                'consultar': {
                    url: 'api/produto-servico/consultar',
                    method: 'POST',
                    isArray: true
                },
                'buscarPorCodigo': {
                    method: 'GET',
                    url: 'api/produto-servico/buscar-por-codigo'
                }
            });
        });
})();
'use strict';

angular.module('nfseApp')
    .controller('ServicoPrestadorSearchController', function ($scope, Servico, ServicoSearch, ParseLinks, SweetAlert, $modalInstance) {
        $scope.servicos = [];
        $scope.page = 1;
        $scope.loadAll = function () {
            Servico.queryByPrestador({page: $scope.page, per_page: 5}, function (result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.servicos = result;
            });
        };
        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };

        $scope.search = function () {
            if(!$scope.searchQuery){
                $scope.searchQuery = '';
            }
            ServicoSearch.queryByPrestador({query: $scope.searchQuery}, function (result) {
                $scope.servicos = result;
            }, function (response) {
                if (response.status === 404) {
                    $scope.loadAll();
                }
            });
        };

        $scope.search();


        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.servico = {codigo: null, descricao: null, ativo: null, id: null};
        };

        $scope.ok = function (servico) {
            $modalInstance.close(servico);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    });

'use strict';

angular.module('nfseApp').controller('PrestadorServicosEditController',
    ['$scope', '$log', '$state', '$stateParams', '$modal', '$window', '$timeout', 'entity',
        'PrestadorServicos', 'Notificacao', 'Pessoa', 'Cnae', 'Servico', 'CEP', 'Municipio', 'SweetAlert', 'Configuracao', 'Upload', 'Blob',
        function ($scope, $log, $state, $stateParams, $modal, $window, $timeout, entity,
                  PrestadorServicos, Notificacao, Pessoa, Cnae, Servico, CEP, Municipio, SweetAlert, Configuracao, Upload, Blob) {

            $scope.prestadorServicos = entity;

            $scope.TIPO_PROCESSO = {
                PROCESSO_ADMINISTRATIVO: {descricao: "Processo Administrativo"},
                DECISAO_JUDICIAL: {descricao: "Decisão Judicial"}
            };

            $scope.TIPO_ISS = {
                HOMOLOGADO: {descricao: "Mensal (Homologado)"},
                FIXO: {descricao: "Anual (Fixo)"},
                ESTIMADO: {descricao: "Estimado"}
            };

            $scope.REGIME_TRIBUTACAO = {
                MICROEMPRESA_MUNICIPAL: {descricao: "Microempresa Municipal"},
                ESTIMATIVA: {descricao: "Estimativa"},
                SOCIEDADE_PROFISSIONAIS: {descricao: "Sociedade de Profissionais"},
                MICROEMPRESARIO_INDIVIDUAL: {descricao: "Microempresário Individual (MEI)"},
                MICROEMPRESÁRIO_EMPRESA_PEQUENO_PORTE: {descricao: "Microempresário e Empresa de Pequeno Porte (ME EPP)"}
            };

            $scope.loadByCpfCnpj = function () {
                PrestadorServicos.getPorCpfCnpj(
                    {cpfCnpj: $scope.prestadorServicos.pessoa.dadosPessoais.cpfCnpj}, function (result) {
                        $scope.editForm.cpfCnpj.$setValidity("exists", true);
                        if (result.pessoa) {
                            $scope.prestadorServicos = result;
                            Notificacao.error("Atenção", "Já existe um Prestador de Servicos com o CPF ou CNPJ informado," +
                                " você não pode solicitar o credenciamente de uma empresa já credenciada");
                            $scope.editForm.cpfCnpj.$setValidity("exists", false);
                        } else {
                            Pessoa.getPorCpfCnpj(
                                {cpfCnpj: $scope.prestadorServicos.pessoa.dadosPessoais.cpfCnpj}, function (result) {
                                    if (result.id) {
                                        $scope.prestadorServicos.pessoa = result;
                                    }
                                });
                        }
                    });
            };

            $scope.loadByCpfCnpjSocio = function (cpfCnpj, socio) {
                Pessoa.getPorCpfCnpj(
                    {cpfCnpj: cpfCnpj}, function (result) {
                        if (result.id) {
                            socio.pessoa = result;
                        }
                    });
            };

            var onSaveFinished = function (result) {
                $state.go("prestadorServicos");
                Notificacao.info("Prestador de Servicos salvo com sucesso")
            };


            $scope.save = function () {
                if ($scope.prestadorServicos.id != null) {
                    PrestadorServicos.update($scope.prestadorServicos, onSaveFinished);
                } else {
                    PrestadorServicos.save($scope.prestadorServicos, onSaveFinished);
                }
            };


            $scope.loadServicoByCodigo = function (codigo, index) {
                if (codigo) {
                    Servico.getPorCodigo(
                        {codigo: codigo}, function (result) {
                            if (result.id) {
                                $scope.prestadorServicos.servicos[index].servico = result;
                            } else {
                                Notificacao.warn("Atenção", "Não foi encontrado nenhum Servico com o código " + codigo);
                                $scope.prestadorServicos.servicos[index] = {};
                            }
                        });
                }
            };

            $scope.searchServico = function (index) {
                var modalInstance = $modal.open({
                    templateUrl: 'app/entities/servico/servico-search.html',
                    controller: 'ServicoSearchController',
                    size: 'lg'
                });
                modalInstance.result.then(function (servico) {
                    $scope.prestadorServicos.servicos[index].servico = servico;
                }, function () {
                    $log.info('Modal dismissed at: ' + new Date());
                });
            };

            $scope.addSituacao = function () {
                if (!$scope.prestadorServicos.situacoesTributaria) {
                    $scope.prestadorServicos.situacoesTributaria = [];
                }
                $scope.definirAtributoVigenteParaSituacao($scope.situacao);
                var nenhumaVigente = true;
                angular.forEach($scope.prestadorServicos.situacoesTributaria, function (situacao) {
                    $scope.definirAtributoVigenteParaSituacao(situacao);
                    if (situacao.vigente) {
                        SweetAlert.info("Operação não permitida!", "Já existe uma situação vigente, encerre as vigências de todas as situações para inserir uma nova!", "warning");
                        nenhumaVigente = false;
                    }
                });
                if (nenhumaVigente == true) {
                    $scope.prestadorServicos.situacoesTributaria.push($scope.situacao);
                    $scope.mostraSituacao = false;
                    $scope.situacao = {};
                }
            };

            $scope.addIsencao = function () {
                if (!$scope.prestadorServicos.isencoes) {
                    $scope.prestadorServicos.isencoes = [];
                }
                $scope.definirAtributoVigenteParaSituacao($scope.isencao);
                var nenhumaVigente = true;
                angular.forEach($scope.prestadorServicos.isencoes, function (isencao) {
                    $scope.definirAtributoVigenteParaSituacao(isencao);
                    if (isencao.vigente && isencao.servico.id == $scope.isencao.servico.id) {
                        SweetAlert.info("Operação não permitida!", "Já existe uma isênção vigente, encerre as vigências de todas as isenções para inserir uma nova!", "warning");
                        nenhumaVigente = false;
                    }
                });
                if (nenhumaVigente == true) {
                    $scope.prestadorServicos.isencoes.push($scope.isencao);
                    $scope.mostraIsencao = false;
                    $scope.isencao = {};
                }
            };

            $scope.addSuspensao = function () {
                if (!$scope.prestadorServicos.suspensoes) {
                    $scope.prestadorServicos.suspensoes = [];
                }
                $scope.definirAtributoVigenteParaSituacao($scope.suspensao);
                var nenhumaVigente = true;
                angular.forEach($scope.prestadorServicos.suspensoes, function (suspensao) {
                    $scope.definirAtributoVigenteParaSituacao(suspensao);
                    if (suspensao.vigente && suspensao.servico.id == $scope.suspensao.servico.id) {
                        SweetAlert.info("Operação não permitida!", "Já existe uma suspensão vigente, encerre as vigências de todas as suspensões para inserir uma nova!", "warning");
                        nenhumaVigente = false;
                    }
                });
                if (nenhumaVigente == true) {
                    $scope.prestadorServicos.suspensoes.push($scope.suspensao);
                    $scope.mostraSuspensao = false;
                    $scope.suspensao = {};
                }
            };

            $scope.limparSituacao = function () {
                $scope.situacao = {};
                if ($scope.prestadorServicos.situacoesTributaria.length > 0) {
                    $scope.mostraSituacao = false;
                }
            };

            $scope.limparIsencao = function () {
                $scope.isencao = {};
                $scope.mostraIsencao = false;
            };

            $scope.limparSuspensao = function () {
                $scope.suspensao = {};
                $scope.mostraSuspensao = false;
            };


            $scope.removeSituacao = function (index) {
                $scope.prestadorServicos.situacoesTributaria.splice(index, 1);
                if ($scope.prestadorServicos.situacoesTributaria.length == 0) {
                    $scope.mostraSituacao = true;
                }
            };

            $scope.removeIsencao = function (index) {
                $scope.prestadorServicos.isencoes.splice(index, 1);
            };

            $scope.removeSuspensao = function (index) {
                $scope.prestadorServicos.suspensoes.splice(index, 1);
            };

            $scope.editarSituacao = function (index) {
                $scope.situacao = $scope.prestadorServicos.situacoesTributaria[index];
                $scope.removeSituacao(index);
                $scope.mostraSituacao = true;
            };

            $scope.editarIsencao = function (index) {
                $scope.isencao = $scope.prestadorServicos.isencoes[index];
                $scope.removeIsencao(index);
                $scope.mostraIsencao = true;
            };

            $scope.editarSuspensao = function (index) {
                $scope.suspensao = $scope.prestadorServicos.suspensoes[index];
                $scope.removeSuspensao(index);
                $scope.mostraSuspensao = true;
            };

            $scope.removeServico = function (index) {
                $scope.prestadorServicos.servicos.splice(index, 1);
                if ($scope.prestadorServicos.servicos.length == 0) {
                    $scope.addServico();
                }
            };

            $scope.removeSocio = function (index) {
                $scope.prestadorServicos.socios.splice(index, 1);
                if ($scope.prestadorServicos.socios.length == 0) {
                    $scope.addSocio();
                }
            };

            $scope.addServico = function () {
                if (!$scope.prestadorServicos.servicos) {
                    $scope.prestadorServicos.servicos = [];
                }
                $scope.prestadorServicos.servicos.push({servico: {}});
            };

            $scope.addSocio = function () {
                if (!$scope.prestadorServicos.socios) {
                    $scope.prestadorServicos.socios = [];
                }
                $scope.prestadorServicos.socios.push({pessoa: {id: null}});
            };

            $scope.addUsuario = function () {
                if (!$scope.prestadorServicos.usuarios) {
                    $scope.prestadorServicos.usuarios = [];
                }
                $scope.prestadorServicos.usuarios.push({usuario: {}});
            };
            $scope.removeUsuario = function (index) {
                $scope.prestadorServicos.usuarios.splice(index, 1);
            };

            $scope.loadEnderecoByCEP = function (cep) {
                if (cep) {
                    CEP.getByCep({cep: cep}, function (endereco) {
                        if (endereco.municipio) {
                            $scope.prestadorServicos.pessoa.dadosPessoais.endereco.cep = endereco.cep;
                            $scope.prestadorServicos.pessoa.dadosPessoais.endereco.municipio = endereco.municipio;
                            $scope.prestadorServicos.pessoa.dadosPessoais.endereco.logradouro = endereco.logradouro;
                            $scope.prestadorServicos.pessoa.dadosPessoais.endereco.bairro = endereco.bairro;
                        }
                    });
                }
            };

            $scope.loadMunicipioByCodigo = function (codigo) {
                if (codigo) {
                    Municipio.getByCodigo({codigo: codigo}, function (municipio) {
                        if (municipio.id) {
                            $scope.prestadorServicos.pessoa.dadosPessoais.endereco.municipio = municipio;
                        } else {
                            Notificacao.warn("Atenção", "Não foi encontrado nenhum Municipio com o código " + codigo);
                            $scope.prestadorServicos.pessoa.dadosPessoais.endereco.municipio = {};
                        }
                    });
                }
            };

            $scope.searchMunicipio = function () {
                var modalInstance = $modal.open({
                    templateUrl: 'app/entities/municipio/municipio-search.html',
                    controller: 'MunicipioSearchController',
                    size: 'lg'
                });
                modalInstance.result.then(function (municipio) {
                    $scope.prestadorServicos.pessoa.dadosPessoais.endereco.municipio = municipio;
                }, function () {
                    //$log.info('Modal dismissed at: ' + new Date());
                });
            };

            $scope.definirAtributoVigenteParaSituacao = function (vigencia) {
                var hoje = new Date();
                vigencia.vigente = false;
                if (vigencia.inicioVigencia) {
                    var inicio = new Date(vigencia.inicioVigencia);
                    var final;
                    if (vigencia.finalVigencia) {
                        var final = new Date(vigencia.finalVigencia);
                    }
                    if (inicio <= hoje.getTime()
                        && (!final || final >= hoje.getTime())) {
                        vigencia.vigente = true;
                    }
                }
            };

            $scope.isFormValid = function () {
                if ($scope.prestadorServicos &&
                    $scope.prestadorServicos.situacoesTributaria && $scope.prestadorServicos.situacoesTributaria > 0
                    && $scope.editForm.$valid) {
                    return true;
                } else {
                    console.log($scope.prestadorServicos);
                    console.log($scope.prestadorServicos.situacoesTributaria);
                    console.log($scope.editForm.$valid);
                    return false;
                }
            };

            $scope.searchUser = function () {
                var modalInstance = $modal.open({
                    templateUrl: 'app/admin/user-management/user-management-search.html',
                    controller: 'UserManagementSearchController',
                    size: 'lg'
                });
                modalInstance.result.then(function (user) {
                    var usuarioEmpresa = {usuario: user}
                    if (!$scope.prestadorServicos.usuarios) {
                        $scope.prestadorServicos.usuarios = [];
                    }
                    $scope.prestadorServicos.usuarios.push(usuarioEmpresa);
                }, function () {
                    $log.info('Modal dismissed at: ' + new Date());
                });
            };

            if (!$scope.prestadorServicos.usuarios || $scope.prestadorServicos.usuarios == 0) {
                //$scope.addUsuario();
            }
            if (!$scope.prestadorServicos.isencoes) {
                $scope.prestadorServicos.isencoes = [];
            }
            if (!$scope.prestadorServicos.suspensoes) {
                $scope.prestadorServicos.suspensoes = [];
            }
            if (!$scope.prestadorServicos.situacoesTributaria || $scope.prestadorServicos.situacoesTributaria == 0) {
                $scope.prestadorServicos.situacoesTributaria = [];
                $scope.mostraSituacao = true;
            } else {
                angular.forEach($scope.prestadorServicos.situacoesTributaria, function (situacao) {
                    $scope.definirAtributoVigenteParaSituacao(situacao);
                });
            }
            if (!$scope.prestadorServicos.servicos || $scope.prestadorServicos.servicos.length == 0) {
                $scope.addServico();
            }

            if (!$scope.prestadorServicos.socios || $scope.prestadorServicos.socios.length == 0) {
                $scope.addSocio();
            }
            if (!$scope.prestadorServicos.documentosApresentados || $scope.prestadorServicos.documentosApresentados.length == 0) {
                $scope.prestadorServicos.documentosApresentados = [];
                Configuracao.get(function (data) {
                    for (var i = 0; i < data.documentosObrigatorios.length; i++) {
                        $scope.prestadorServicos.documentosApresentados.push({
                            apresentado: false,
                            documentoObrigatorio: data.documentosObrigatorios[i]
                        });
                    }
                });
            }

            $scope.situacao = {};
            $scope.isencao = {};
            $scope.suspensao = {};

            $scope.mostraFormDocumento = false;
            $scope.documentoApresentado = {};

            $scope.adicionarDocumento = function () {
                $scope.prestadorServicos.documentosApresentados.push($scope.documentoApresentado);
                $scope.documentoApresentado = {};
                $scope.mostraFormDocumento = false;
            };

            $scope.limparDocumento = function () {
                $scope.mostraFormDocumento = false;
                $scope.documentoApresentado = {};
            };

            $scope.removerDocumento = function (index) {
                $scope.prestadorServicos.documentosApresentados.splice(index, 1);
            };

            function getBlobFromBase64(arquivo) {
                /*data:{{vm.arquivo.contentType}};base64,{{vm.arquivo.bytes}}*/
                var byteCharacters = atob(arquivo.conteudo);
                var byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                var byteArray = new Uint8Array(byteNumbers);
                var blob = new Blob([byteArray], {type: arquivo.contentType});
                return blob;
            }

            $scope.baixarArquivo = function (index) {
                var documentoApresentado = $scope.prestadorServicos.documentosApresentados[index];
                if (documentoApresentado.arquivo) {
                    var fileName = documentoApresentado.arquivo.nome;
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";

                    var file = getBlobFromBase64(documentoApresentado.arquivo);
                    var fileURL = window.URL.createObjectURL(file);
                    a.href = fileURL;
                    a.download = fileName;
                    a.click();
                }
            };

            $scope.removerArquivo = function (index) {
                var documentoApresentado = $scope.prestadorServicos.documentosApresentados[index];
                if (documentoApresentado.arquivo) {
                    documentoApresentado.arquivo = null;
                }
            };

            $scope.novoDocumento = function () {
                $scope.mostraFormDocumento = true;
                $scope.documentoApresentado = {};
                $scope.documentoApresentado.apresentado = true;
                $timeout(function () {
                    angular.element('[ng-model="documentoApresentado.descricao"]').focus();
                });
            };

            $scope.upload = function (file) {
                if (file) {
                    var modalInstance = $modal.open({
                        animation: true,
                        ariaLabelledBy: 'modal-title',
                        ariaDescribedBy: 'modal-body',
                        templateUrl: 'myModalContent.html',
                        controller: 'ModalInstanceCtrl',
                        controllerAs: '$ctrl',
                        resolve: {
                            documentosApresentados: function () {
                                return $scope.prestadorServicos.documentosApresentados;
                            },
                            file: function () {
                                return file;
                            }
                        }
                    });
                    modalInstance.result.then(function (documentoApresentado) {
                        Upload.base64DataUrl(documentoApresentado.arquivo).then(function (url) {
                                documentoApresentado.arquivo.nome = documentoApresentado.arquivo.name;
                                documentoApresentado.arquivo.contentType = documentoApresentado.arquivo.type;
                                var arquivo = {};
                                var arr = url.split(',');
                                var base64 = arr[arr.length - 1];
                                arquivo = base64;
                                documentoApresentado.arquivo.conteudo = arquivo;
                            }, function (resp) {
                                console.log('Error status: ' + resp.status);
                            }, function (evt) {
                                console.log("evt", evt.total);
                            }
                        );
                        //$log.info(documentoApresentado);
                    }, function () {
                        $log.info('Modal dismissed at: ' + new Date());
                    });
                    file = null;
                }
            };

        }]);

angular.module('nfseApp').
    controller('ModalInstanceCtrl', function ($modalInstance, documentosApresentados, file) {
        var $ctrl = this;
        $ctrl.documentosApresentados = documentosApresentados;

        $ctrl.ok = function (documentoApresentado) {
            documentoApresentado.arquivo = file;
            documentoApresentado.apresentado = true;
            $modalInstance.close(documentoApresentado);
        };

        $ctrl.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    });


'use strict';

angular.module('nfseApp')
    .controller('PrestadorServicosDetailController', function ($scope, $rootScope, $stateParams, entity, PrestadorServicos) {
        $scope.prestadorServicos = entity;
        $scope.load = function (id) {
            PrestadorServicos.get({id: id}, function (result) {
                $scope.prestadorServicos = result;
            });
        };
        $rootScope.$on('nfseApp:prestadorServicosUpdate', function (event, result) {
            $scope.prestadorServicos = result;
        });

        function getBlobFromBase64(arquivo) {
            /*data:{{vm.arquivo.contentType}};base64,{{vm.arquivo.bytes}}*/
            var byteCharacters = atob(arquivo.conteudo);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var blob = new Blob([byteArray], {type: arquivo.contentType});
            return blob;
        }

        $scope.baixarArquivo = function (index) {
            var documentoApresentado = $scope.prestadorServicos.documentosApresentados[index];
            if (documentoApresentado.arquivo) {
                var fileName = documentoApresentado.arquivo.nome;
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var file = getBlobFromBase64(documentoApresentado.arquivo);
                var fileURL = window.URL.createObjectURL(file);
                a.href = fileURL;
                a.download = fileName;
                a.click();
            }
        };
    });

'use strict';

angular.module('nfseApp')
    .factory('PrestadorServicos', function ($resource) {
        return $resource('api/prestadorServicos/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'trocarChaveAcesso': {
                url: '/api/prestadorServicos/gerar-chave-acesso/:id',
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'fromUser': {
                method: 'GET',
                url: 'api/prestadores/usuario/',
                isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getPorCpfCnpj': {
                method: 'GET',
                url: "api/prestadorServicos_por_cpfCnpj/:cpfCnpj",
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        return data;
                    }
                }
            },
            'buscarPorCpfCnpj': {
                method: 'GET',
                url: "api/buscar_prestadorServicos_por_cpfCnpj/:cpfCnpj",
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        return data;
                    }
                }
            },
            'getNaReceitaPorCpfCnpj': {
                method: 'GET',
                url: "api/prestadorServicos_receita_por_cpfCnpj/:cpfCnpj",
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'enviarEmailSolicitandoCadastro': {
                method: 'POST',
                url: 'api/prestador-servico/solicitacao-cadastro-usuario'
            },
            'vincularUsuarioEmpresa': {
                method: 'POST',
                url: 'api/prestador-servico/vincular-usuario-empresa'
            },
            'vincularNovoUsuarioEmpresa': {
                method: 'GET',
                url: 'api/prestador-servico/vincular-novo-usuario-empresa/:login'
            },
            'ativarOuDesativarUsuarioEmpresa': {
                method: 'GET',
                url: 'api/prestador-servico/ativar-desativar-usuario/:login'
            },
            'permitirAcessoAoUsuario': {
                method: 'POST',
                url: 'api/prestador-servico/adionar-remover-permissoes-usuario'
            },
            'removerUsuarioEmpresa': {
                method: 'DELETE',
                url: 'api/remove-usuario-empresa/:id',
            },
            'getDebitos': {
                method: 'POST',
                url: 'api/debitos-prestador/',
                isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'buscarDamDaParcela': {
                method: 'POST',
                url: 'api/dam-parcela/',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'enviarDamDaParcela': {
                method: 'POST',
                url: 'api/enviar-dam'
            },
            'salvar': {
                method: 'POST',
                url: 'api/prestador-servico/salvar-novo'
            },
            'getUsuariosPrestador': {
                method: 'GET',
                url: 'api/prestador-servico/usuarios',
                isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'salvarTributosFederais': {
                method: 'POST',
                url: 'api/prestador-servico/tributosFederais',
            },
            'getTributosFederais': {
                method: 'GET',
                url: "api/cadastro-economico/buscar-tributos-federais",
                transformResponse: function (data) {
                    if (data)
                        data = angular.fromJson(data);
                    return data;
                }
            },
            'getPrestadoresUsuario': {
                method: 'GET',
                url: 'api/prestador-servico/por-login/:login',
                isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'trocarEmpresa': {
                method: 'GET',
                url: 'api/prestador-servico/trocar-empresa'
            },
            'getAnexosLei1232006': {
                method: 'GET',
                url: 'api/anexos-lei-123-2006',
                isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'salvarFaixaAndRbt12': {
                method: 'POST',
                url: 'api/prestador-servico/salvar-faixa-rbt12'
            },
            'buscarServicosCartorio': {
                method: 'GET',
                url: 'api/prestador-servico/servicos-cartorio',
                isArray: true
            }
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('PrestadorServicosSearch', function ($resource) {
        return $resource('api/_search/prestadorServicos/:query', {}, {
            'query': { method: 'GET', isArray: true}
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('prestadorServicos', {
                parent: 'entity',
                url: '/prestadorServicos',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'nfseApp.prestadorServicos.home.title'
                },
                ncyBreadcrumb: {
                    label: 'Consulta de Prestadores de Serviços'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/prestadorServicos/prestadorServicoss.html',
                        controller: 'PrestadorServicosController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('prestadorServicos');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('dadosPessoais');
                        return $translate.refresh();
                    }]
                }
            })
            .state('prestadorServicos.detail', {
                parent: 'prestadorServicos',
                url: '/detalhes/{id}',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'nfseApp.prestadorServicos.home.title'
                },
                ncyBreadcrumb: {
                    label: 'Detalhes do Prestadores de Serviços'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/prestadorServicos/prestadorServicos-detail.html',
                        controller: 'PrestadorServicosDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('prestadorServicos');
                        $translatePartialLoader.addPart('dadosPessoais');
                        $translatePartialLoader.addPart('endereco');
                        $translatePartialLoader.addPart('cnae');
                        $translatePartialLoader.addPart('servico');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'PrestadorServicos', function ($stateParams, PrestadorServicos) {
                        return PrestadorServicos.get({id: $stateParams.id});
                    }]
                }
            })
            .state('prestadorServicos.new', {
                parent: 'prestadorServicos',
                url: '/novo',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'nfseApp.prestadorServicos.home.title'
                },
                ncyBreadcrumb: {
                    label: 'Novo Prestadores de Serviços'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/prestadorServicos/prestadorServicos-edit.html',
                        controller: 'PrestadorServicosEditController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('prestadorServicos');
                        $translatePartialLoader.addPart('dadosPessoais');
                        $translatePartialLoader.addPart('endereco');
                        $translatePartialLoader.addPart('cnae');
                        $translatePartialLoader.addPart('servico');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['localStorageService', function (localStorageService) {
                        return {id: null, pessoa: {dadosPessoais: {}}, cnaes: [], usuarios: []};
                    }]
                }
            })
            .state('prestadorServicos.edit', {
                parent: 'prestadorServicos',
                url: '/edicao/{id}',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'nfseApp.prestadorServicos.home.title'
                },
                ncyBreadcrumb: {
                    label: 'Edição do Prestadores de Serviços'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/prestadorServicos/prestadorServicos-edit.html',
                        controller: 'PrestadorServicosEditController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('prestadorServicos');
                        $translatePartialLoader.addPart('dadosPessoais');
                        $translatePartialLoader.addPart('endereco');
                        $translatePartialLoader.addPart('cnae');
                        $translatePartialLoader.addPart('servico');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['PrestadorServicos', '$stateParams', function (PrestadorServicos, $stateParams) {
                        return PrestadorServicos.get({id: $stateParams.id}).$promise;
                    }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('PrestadorServicosController', function ($scope, PrestadorServicos, PrestadorServicosSearch, ParseLinks, SweetAlert) {
        $scope.prestadorServicoss = [];
        $scope.page = 1;
        $scope.loadAll = function() {
            PrestadorServicos.query({page: $scope.page, per_page: 20}, function(result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.prestadorServicoss = result;
            });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            PrestadorServicos.get({id: id}, function(result) {
                $scope.prestadorServicos = result;
                SweetAlert.swal({
                        title: "Confirme a exclusão",
                        text: "Você tem certeza que quer excluir o registro selecionado?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55", confirmButtonText: "Sim, Excluir",
                        cancelButtonText: "Não, Cancelar",
                        closeOnConfirm: false,
                        closeOnCancel: false
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            $scope.confirmDelete(id);
                        } else {
                            SweetAlert.error("Cancelado", "O registro não foi removido :)");
                        }
                    });
            });
        };

        $scope.confirmDelete = function (id) {
            PrestadorServicos.delete({id: id},
                function () {
                    $scope.loadAll();
                    SweetAlert.success("Removido!", "O registro foi removido com sucesso.");
                    $scope.clear();
                });
        };

        $scope.search = function () {
            PrestadorServicosSearch.query({query: $scope.searchQuery}, function(result) {
                $scope.prestadorServicoss = result;
            }, function(response) {
                if(response.status === 404) {
                    $scope.loadAll();
                }
            });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.prestadorServicos = {id: null};
        };
    });

(function () {
    'use strict';

    angular.module('nfseApp')
        .controller('PlanoGeralContasComentadoSearchController', function ($scope, $modalInstance, PlanoGeralContasComentado,
                                                                           ParseLinks, localStorageService, $filter) {

            $scope.contas = [];
            $scope.filtro = {
                conta: '',
                desdobramento: '',
                nome: ''
            };
            $scope.page;
            $scope.per_page = 10;
            $scope.prestadorPrincipal = localStorageService.get("prestadorPrincipal");

            $scope.ok = function (conta) {
                $modalInstance.close(conta);
            };

            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };

            $scope.montarConsulta = function () {
                var campos = [];
                campos.push({
                    campo: "obj.cadastroeconomico_id",
                    operador: "IGUAL",
                    valorLong: $scope.prestadorPrincipal.prestador.id
                });

                campos.push({
                    campo: "trunc(obj.iniciovigencia)",
                    operador: "MENOR_IGUAL",
                    valorDateString: $filter('date')(new Date(), 'dd/MM/yyyy')
                });

                campos.push({
                    campo: "trunc(coalesce(obj.fimvigencia, current_date))",
                    operador: "MAIOR_IGUAL",
                    valorDateString: $filter('date')(new Date(), 'dd/MM/yyyy')
                });

                if ($scope.filtro.conta) {
                    campos.push({
                        campo: "obj.conta",
                        operador: "LIKE",
                        valorString: '%' + $scope.filtro.conta + '%'
                    });
                }

                if ($scope.filtro.desdobramento) {
                    campos.push({
                        campo: "obj.desdobramento",
                        operador: "LIKE",
                        valorString: '%' + $scope.filtro.desdobramento + '%'
                    });
                }

                if ($scope.filtro.nome) {
                    campos.push({
                        campo: "obj.nome",
                        operador: "LIKE",
                        valorString: '%' + $scope.filtro.nome + '%'
                    });
                }
                return {
                    offset: $scope.page,
                    limit: $scope.per_page,
                    parametrosQuery: [{
                        juncao: " and ",
                        parametroQueryCampos: campos
                    }]
                };
            };

            $scope.loadAll = function () {
                var consulta = $scope.montarConsulta();
                PlanoGeralContasComentado.consultar(consulta,
                    function (result, headers) {
                        if (headers)
                            $scope.links = ParseLinks.parse(headers('link'));
                        $scope.contas = result;
                    });
            };

            $scope.loadAll();
        });
})();
(function () {
    'use strict';

    angular.module('nfseApp')
        .controller('PlanoGeralContasComentadoEditController', function ($state, $scope, entity,
                                                                         PlanoGeralContasComentado, PrestadorServicos,
                                                                         localStorageService, Cosif, Notificacao, $modal,
                                                                         Servico, CodigoTributacao, TarifaBancaria,
                                                                         ProdutoServico) {
            $scope.entity = entity;
            $scope.cosif;
            $scope.codigoServico;
            $scope.codigoTributacao;
            $scope.tarifaBancaria;
            $scope.produtoServico;
            $scope.tipoVinculo;

            if (!$scope.entity.id) {
                PrestadorServicos.get({id: localStorageService.get("prestadorPrincipal").prestador.id}, function (data) {
                    $scope.entity.prestador = data;
                });
            } else {
                if ($scope.entity.cosif) {
                    $scope.cosif = $scope.entity.cosif.conta;
                }
                if ($scope.entity.servico) {
                    $scope.codigoServico = $scope.entity.servico.codigo;
                }
                if ($scope.entity.codigoTributacao) {
                    $scope.codigoTributacao = $scope.entity.codigoTributacao.codigo;
                }
                if ($scope.entity.tarifaBancaria) {
                    $scope.tipoVinculo = 'TARIFA_BANCARIA';
                    $scope.tarifaBancaria = $scope.entity.tarifaBancaria.tarifaBancaria.codigo;
                }
                if ($scope.entity.produtoServico) {
                    $scope.tipoVinculo = 'PRODUTO_SERVICO';
                    $scope.produtoServico = $scope.entity.produtoServico.produtoServico.codigo;
                }
            }

            $scope.preSave = function () {
                if ($scope.entity.prestador.enquadramentoFiscal.versaoDesif == 'VERSAO_ABRASF_3_1') {
                    $scope.entity.servico = null;
                    if ($scope.tipoVinculo == 'TARIFA_BANCARIA') {
                        $scope.entity.produtoServico = null;
                    } else {
                        $scope.entity.tarifaBancaria = null;
                    }
                } else {
                    $scope.entity.codigoTributacao = null;
                    $scope.entity.tarifaBancaria = null;
                    $scope.entity.produtoServico = null;
                }
            }

            $scope.save = function (editForm) {
                $scope.preSave();
                PlanoGeralContasComentado.save($scope.entity, function () {
                    $state.go('planoGeralContasComentado');
                });
            }

            $scope.buscarCosif = function () {
                console.log($scope.cosif);
                $scope.entity.cosif = null;
                if ($scope.cosif) {
                    Cosif.buscarPorConta({conta: $scope.cosif}, function (data) {
                        if (data && data.id) {
                            $scope.entity.cosif = data;
                        } else {
                            Notificacao.warn('Atenção', 'Conta Cosif não encontrada.');
                        }
                    });
                }
            }

            $scope.pesquisarCosif = function () {
                var modal = $modal.open({
                    templateUrl: 'app/entities/cosif/cosif-search.html',
                    controller: 'CosifSearchController',
                    size: 'lg'
                });
                modal.result.then(function (data) {
                    $scope.cosif = data.conta;
                    if (data) {
                        $scope.entity.cosif = data;
                    }
                });
            }

            $scope.buscarCodigoTributacao = function () {
                $scope.entity.codigoTributacao = null;
                if ($scope.codigoTributacao) {
                    CodigoTributacao.buscarPorCodigo({codigo: $scope.codigoTributacao}, function (data) {
                        if (data && data.id) {
                            $scope.entity.codigoTributacao = data;
                        } else {
                            Notificacao.warn('Atenção', 'Código de Tributação não encontrado.');
                        }
                    });
                }
            }

            $scope.pesquisarCodigoTributacao = function () {
                var modal = $modal.open({
                    templateUrl: 'app/entities/codigo-tributacao/codigo-tributacao-search.html',
                    controller: 'CodigoTributacaoSearchController',
                    size: 'lg'
                });
                modal.result.then(function (data) {
                    $scope.codigoTributacao = data.codigo;
                    if (data) {
                        $scope.entity.codigoTributacao = data;
                    }
                });
            }

            $scope.buscarServico = function () {
                console.log('codigo: ', $scope.codigoServico);
                $scope.entity.servico = null;
                if ($scope.codigoServico) {
                    Servico.getPorCodigo({codigo: $scope.codigoServico}, function (data) {
                        if (data && data.id) {
                            $scope.entity.servico = data;
                        } else {
                            Notificacao.warn('Atenção', 'Serviço não encontrado.');
                        }
                    });
                }
            }

            $scope.pesquisarServico = function () {
                var modal = $modal.open({
                    templateUrl: 'app/entities/servico/servico-search.html',
                    controller: 'ServicoSearchController',
                    size: 'lg'
                });
                modal.result.then(function (data) {
                    if (data) {
                        $scope.codigoServico = data.codigo;
                        $scope.entity.servico = data;
                    }
                });
            }

            $scope.buscarTarifaBancaria = function () {
                $scope.entity.tarifaBancaria = null;
                if ($scope.tarifaBancaria) {
                    TarifaBancaria.buscarPorCodigo({codigo: $scope.tarifaBancaria}, function (data) {
                        if (data && data.id) {
                            $scope.entity.tarifaBancaria = {
                                tarifaBancaria: data,
                                valorUnitario: 0,
                                valorPercentual: 0
                            };
                        } else {
                            Notificacao.warn('Atenção', 'Tarifa Bancária não encontrada.');
                        }
                    });
                }
            }

            $scope.pesquisarTarifaBancaria = function () {
                var modal = $modal.open({
                    templateUrl: 'app/entities/tarifa-bancaria/tarifa-bancaria-search.html',
                    controller: 'TarifaBancariaSearchController',
                    size: 'lg'
                });
                modal.result.then(function (data) {
                    if (data) {
                        $scope.tarifaBancaria = data.codigo;
                        $scope.entity.tarifaBancaria = {
                            tarifaBancaria: data,
                            valorUnitario: 0,
                            valorPercentual: 0
                        };
                    }
                });
            }

            $scope.buscarProdutoServico = function () {
                $scope.entity.produtoServico = null;
                if ($scope.produtoServico) {
                    ProdutoServico.buscarPorCodigo({codigo: $scope.produtoServico}, function (data) {
                        if (data && data.id) {
                            $scope.entity.produtoServico = {
                                produtoServico: data
                            };
                        } else {
                            Notificacao.warn('Atenção', 'Produto/Serviço não encontrado.');
                        }
                    });
                }
            }

            $scope.pesquisarProdutoServico = function () {
                var modal = $modal.open({
                    templateUrl: 'app/entities/produto-servico/produto-servico-search.html',
                    controller: 'ProdutoServicoSearchController',
                    size: 'lg'
                });
                modal.result.then(function (data) {
                    if (data) {
                        $scope.produtoServico = data.codigo;
                        $scope.entity.produtoServico = {
                            produtoServico: data
                        };
                    }
                });
            }

            $scope.changeTipoVinculo = function (tipoVinculo) {
                if (tipoVinculo == $scope.tipoVinculo) {
                    return;
                }
                $scope.tipoVinculo = tipoVinculo;
                if ($scope.tipoVinculo == 'TARIFA_BANCARIA') {
                    $scope.produtoServico = null;
                    $scope.entity.produtoServico = null;
                } else {
                    $scope.tarifaBancaria = null;
                    $scope.entity.tarifaBancaria = null;
                }
            }
        });
})();

(function () {
    'use strict';

    angular.module('nfseApp')
        .controller('PlanoGeralContasComentadoDetailController', function ($state, $scope,
                                                                           entity, Notificacao,
                                                                           PlanoGeralContasComentado,
                                                                           PrestadorServicos,
                                                                           localStorageService) {
            $scope.entity = entity;

            $scope.remove = function () {
                Notificacao.confirmDelete(function () {
                    PlanoGeralContasComentado.delete({id: $scope.entity.id}, function () {
                        $state.go('planoGeralContasComentado');
                    })
                })
            }

            $scope.init = function () {
                PrestadorServicos.get({id: localStorageService.get("prestadorPrincipal").prestador.id}, function (data) {
                    $scope.prestador = data;
                })
            }

            $scope.init();
        });
})();

(function () {
    'use strict';

    angular.module('nfseApp')
        .factory('PlanoGeralContasComentado', function ($resource, DateUtils) {
            function transformResponseList(data) {
                data = angular.fromJson(data);
                for (var i = 0; i < data.length; i++) {
                    var item = data[i];
                    transformResponse(item);
                }
                return data;
            }

            function transformResponse(data) {
                data = angular.fromJson(data);
                if (data.inicioVigencia) {
                    data.inicioVigencia = DateUtils.convertLocaleDateFromServer(data.inicioVigencia);
                }
                if (data.fimVigencia) {
                    data.fimVigencia = DateUtils.convertLocaleDateFromServer(data.fimVigencia);
                }
                if (data.tarifaBancaria) {
                    data.tarifaBancaria.inicioVigencia = DateUtils.convertLocaleDateFromServer(data.tarifaBancaria.inicioVigencia);
                }
                return data;
            }

            var resource = $resource('api/plano-geral-contas-comentado/:id', {}, {
                'get': {
                    url: 'api/plano-geral-contas-comentado/:id',
                    method: 'GET',
                    transformResponse: function (data) {
                        return transformResponse(data);
                    }
                },
                'consultar': {
                    url: 'api/plano-geral-contas-comentado/consultar',
                    method: 'POST',
                    isArray: true,
                    transformResponse: function (data) {
                        return transformResponseList(data);
                    }
                },
                'buscarPorConta': {
                    url: 'api/plano-geral-contas-comentado/buscar-por-conta',
                    method: 'GET'
                },
                'buscarPorPrestador': {
                    url: 'api/plano-geral-contas-comentado/buscar-por-prestador',
                    method: 'GET',
                    isArray: true,
                    transformResponse: function (data) {
                        return transformResponseList(data);
                    }
                }
            });

            return resource;
        });
})();

(function () {
    'use strict';

    angular.module('nfseApp')
        .config(function ($stateProvider) {
            $stateProvider
                .state('planoGeralContasComentado', {
                    parent: 'entity',
                    url: '/plano-geral-contas-comentado/consultar',
                    ncyBreadcrumb: {
                        label: 'Consultar Plano Geral de Contas Comentado'
                    },
                    data: {
                        roles: ['ROLE_EMPRESA_PLANO_GERAL_CONTAS_COMENTADO'],
                        pageTitle: 'Plano Geral de Contas Comentado'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/plano-geral-contas-comentado/plano-geral-contas-comentado.html',
                            controller: 'PlanoGeralContasComentadoController'
                        }
                    },
                    resolve: {}
                })
                .state('planoGeralContasComentado.detail', {
                    parent: 'entity',
                    url: '/plano-geral-contas-comentado/detalhe-conta/{id}',
                    ncyBreadcrumb: {
                        label: 'Detalhe da Conta do PGCC'
                    },
                    data: {
                        roles: ['ROLE_EMPRESA_PLANO_GERAL_CONTAS_COMENTADO'],
                        pageTitle: 'Plano Geral de Contas Comentado'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/plano-geral-contas-comentado/plano-geral-contas-comentado-detail.html',
                            controller: 'PlanoGeralContasComentadoDetailController'
                        }
                    },
                    resolve: {
                        entity: ['PlanoGeralContasComentado', '$stateParams', function (PlanoGeralContasComentado, $stateParams) {
                            return PlanoGeralContasComentado.get({id: $stateParams.id}, function (data) {
                                return data;
                            }, function (error) {
                                $state.go('planoGeralContasComentado');
                            }).$promise;
                        }]
                    }
                })
                .state('planoGeralContasComentado.insert', {
                    parent: 'entity',
                    url: '/plano-geral-contas-comentado/inserir-conta',
                    ncyBreadcrumb: {
                        label: 'Inserir Conta do PGCC'
                    },
                    data: {
                        roles: ['ROLE_EMPRESA_PLANO_GERAL_CONTAS_COMENTADO'],
                        pageTitle: 'Plano Geral de Contas Comentado'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/plano-geral-contas-comentado/plano-geral-contas-comentado-edit.html',
                            controller: 'PlanoGeralContasComentadoEditController'
                        }
                    },
                    resolve: {
                        entity: function () {
                            return {};
                        }
                    }
                })
                .state('planoGeralContasComentado.edit', {
                    parent: 'entity',
                    url: '/plano-geral-contas-comentado/editar-conta/{id}',
                    ncyBreadcrumb: {
                        label: 'Editar Conta do PGCC'
                    },
                    data: {
                        roles: ['ROLE_EMPRESA_PLANO_GERAL_CONTAS_COMENTADO'],
                        pageTitle: 'Plano Geral de Contas Comentado'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/plano-geral-contas-comentado/plano-geral-contas-comentado-edit.html',
                            controller: 'PlanoGeralContasComentadoEditController'
                        }
                    },
                    resolve: {
                        entity: ['PlanoGeralContasComentado', '$stateParams', function (PlanoGeralContasComentado, $stateParams) {
                            return PlanoGeralContasComentado.get({id: $stateParams.id}, function (data) {
                                return data;
                            }, function () {
                                $state.go('planoGeralContasComentado');
                            }).$promise;
                        }]
                    }
                })
        });
})();

(function () {
    'use strict';

    angular.module('nfseApp')
        .controller('PlanoGeralContasComentadoController', function ($state, $scope, $filter, localStorageService,
                                                                     PlanoGeralContasComentado, ParseLinks, Notificacao,
                                                                     PrestadorServicos) {
            $scope.contas = [];
            $scope.filtro = {
                conta: '',
                desdobramento: '',
                nome: ''
            };
            $scope.page;
            $scope.per_page = 20;
            $scope.prestador = null;

            $scope.montarConsulta = function () {
                var campos = [];
                campos.push({
                    campo: "obj.cadastroeconomico_id",
                    operador: "IGUAL",
                    valorLong: $scope.prestador.id
                });

                campos.push({
                    campo: "date_trunc('day', obj.iniciovigencia)",
                    operador: "MENOR_IGUAL",
                    valorDateString: $filter('date')(new Date(), 'dd/MM/yyyy')
                });

                campos.push({
                    campo: "date_trunc('day', coalesce(obj.fimvigencia, current_date))",
                    operador: "MAIOR_IGUAL",
                    valorDateString: $filter('date')(new Date(), 'dd/MM/yyyy')
                });

                if ($scope.filtro.conta) {
                    campos.push({
                        campo: "obj.conta",
                        operador: "LIKE",
                        valorString: '%' + $scope.filtro.conta + '%'
                    });
                }

                if ($scope.filtro.desdobramento) {
                    campos.push({
                        campo: "obj.desdobramento",
                        operador: "LIKE",
                        valorString: '%' + $scope.filtro.desdobramento + '%'
                    });
                }

                if ($scope.filtro.nome) {
                    campos.push({
                        campo: "lower(obj.nome)",
                        operador: "LIKE",
                        valorString: '%' + $scope.filtro.nome.toLowerCase() + '%'
                    });
                }
                return {
                    offset: $scope.page,
                    limit: $scope.per_page,
                    parametrosQuery: [{
                        juncao: " and ",
                        parametroQueryCampos: campos
                    }]
                };
            };

            $scope.loadAll = function () {
                var consulta = $scope.montarConsulta();
                PlanoGeralContasComentado.consultar(consulta,
                    function (result, headers) {
                        if (headers) {
                            $scope.links = ParseLinks.parse(headers('link'));
                            $scope.totalItens = headers('x-total-count');
                        }
                        $scope.contas = result;
                    });
            };

            $scope.loadPage = function (page) {
                $scope.page = page;
                $scope.loadAll();
            };

            $scope.remove = function (conta) {
                Notificacao.confirmDelete(function () {
                    PlanoGeralContasComentado.delete({id: conta.id}, function () {
                        $scope.loadAll();
                    })
                })
            }

            $scope.init = function () {
                PrestadorServicos.get({id: localStorageService.get("prestadorPrincipal").prestador.id}, function (data) {
                    $scope.prestador = data;
                    $scope.loadAll();
                })
            }

            $scope.init();
        })
    ;
})();

'use strict';

angular.module('nfseApp').controller('PessoaEditController',
    ['$scope', '$state', '$modal', '$stateParams', 'entity', 'Pessoa', 'Notificacao', 'CEP', 'Municipio',
        function ($scope, $state, $modal, $stateParams, entity, Pessoa, Notificacao, CEP, Municipio) {

            $scope.pessoa = entity;

            $scope.load = function (id) {
                Pessoa.get({id: id}, function (result) {
                    $scope.pessoa = result;
                });
            };

            $scope.loadByCpfCnpj = function () {
                Pessoa.getPorCpfCnpj(
                    {cpfCnpj: $scope.pessoa.dadosPessoais.cpfCnpj}, function (result) {
                        $scope.editForm.cpfCnpj.$setValidity("exists", true);
                        if (result.dadosPessoais) {
                            $scope.pessoa = result;
                            Notificacao.error("Atenção", "Já existe uma Pessoa com o CPF ou CNPJ informado");
                            $scope.editForm.cpfCnpj.$setValidity("exists", false);
                        }
                    });
            };

            var onSaveFinished = function (result) {
                $scope.$emit('nfseApp:pessoaUpdate', result);
                $state.go("pessoa");
                Notificacao.info("Pessoa salva com sucesso")
            };

            $scope.save = function () {
                if ($scope.pessoa.id != null) {
                    Pessoa.update($scope.pessoa, onSaveFinished);
                } else {
                    Pessoa.save($scope.pessoa, onSaveFinished);
                }
            };

            $scope.loadEnderecoByCEP = function (cep) {
                if (cep) {
                    CEP.getByCep({cep: cep}, function (endereco) {
                        if (endereco.municipio) {
                            $scope.pessoa.dadosPessoais.endereco.cep = endereco.cep;
                            $scope.pessoa.dadosPessoais.endereco.municipio = endereco.municipio;
                            $scope.pessoa.dadosPessoais.endereco.logradouro = endereco.logradouro;
                            $scope.pessoa.dadosPessoais.endereco.bairro = endereco.bairro;
                        }
                    });
                }
            };

            $scope.loadMunicipioByCodigo = function (codigo) {
                if (codigo) {
                    Municipio.getByCodigo({codigo: codigo}, function (municipio) {
                        if (municipio.id) {
                            $scope.pessoa.dadosPessoais.endereco.municipio = municipio;
                        } else {
                            Notificacao.warn("Atenção", "Não foi encontrado nenhum Municipio com o código " + codigo);
                            $scope.pessoa.dadosPessoais.endereco.municipio = {};
                        }
                    });
                }
            };

            $scope.searchMunicipio = function () {
                var modalInstance = $modal.open({
                    templateUrl: 'app/entities/municipio/municipio-search.html',
                    controller: 'MunicipioSearchController',
                    size: 'lg'
                });
                modalInstance.result.then(function (municipio) {
                    $scope.pessoa.dadosPessoais.endereco.municipio = municipio;
                }, function () {
                    //$log.info('Modal dismissed at: ' + new Date());
                });
            };
        }]);

'use strict';

angular.module('nfseApp')
    .controller('PessoaDetailController', function ($scope, $rootScope, $stateParams, entity, Pessoa) {
        $scope.pessoa = entity;
        $scope.load = function (id) {
            Pessoa.get({id: id}, function(result) {
                $scope.pessoa = result;
            });
        };
        $rootScope.$on('nfseApp:pessoaUpdate', function(event, result) {
            $scope.pessoa = result;
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('Pessoa', function ($resource, DateUtils) {
        return $resource('api/pessoas/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getPorCpfCnpj': {
                method: 'GET',
                url: "api/pessoa_por_cpfCnpj/:cpfCnpj",
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getPessoaDoUsuario': {
                method: 'GET',
                url: "api/pessoa_do_usuario",
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getPessoaDoLogin': {
                method: 'GET',
                url: "api/pessoa_do_usuario/login/:login",
            },
            'update': {method: 'PUT'}
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('PessoaSearch', function ($resource) {
        return $resource('api/_search/pessoas/:query', {}, {
            'query': { method: 'GET', isArray: true}
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('pessoa', {
                parent: 'entity',
                url: '/pessoa',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'nfseApp.pessoa.home.title'
                },
                ncyBreadcrumb: {
                    label: 'Consulta de Pessoas'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/pessoa/pessoas.html',
                        controller: 'PessoaController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('pessoa');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('dadosPessoais');
                        return $translate.refresh();
                    }]
                }
            })
            .state('pessoa.detail', {
                parent: 'pessoa',
                url: '/detalhes/{id}',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'nfseApp.pessoa.home.title'
                },
                ncyBreadcrumb: {
                    label: 'Detalhes da Pessoa'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/pessoa/pessoa-detail.html',
                        controller: 'PessoaDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('pessoa');
                        $translatePartialLoader.addPart('dadosPessoais');
                        $translatePartialLoader.addPart('endereco');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Pessoa', function ($stateParams, Pessoa) {
                        return Pessoa.get({id: $stateParams.id});
                    }]
                }
            })
            .state('pessoa.new', {
                parent: 'pessoa',
                url: '/novo',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'nfseApp.pessoa.home.title'
                },
                ncyBreadcrumb: {
                    label: 'Nova Pessoa'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/pessoa/dados-pessoais-edit.html',
                        controller: 'PessoaEditController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('pessoa');
                        $translatePartialLoader.addPart('dadosPessoais');
                        $translatePartialLoader.addPart('endereco');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['localStorageService', function (localStorageService) {
                        return {id: null, dadosPessoais: {}};
                    }]
                }
            })
            .state('pessoa.edit', {
                parent: 'pessoa',
                url: '/edicao/{id}',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'nfseApp.pessoa.home.title'
                },
                ncyBreadcrumb: {
                    label: 'Edição da Pessoa'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/pessoa/dados-pessoais-edit.html',
                        controller: 'PessoaEditController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('pessoa');
                        $translatePartialLoader.addPart('dadosPessoais');
                        $translatePartialLoader.addPart('endereco');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['Pessoa', '$stateParams', function (Pessoa, $stateParams) {
                        return Pessoa.get({id: $stateParams.id});
                    }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('PessoaController', function ($scope, Pessoa, PessoaSearch, ParseLinks, SweetAlert, Notificacao) {
        $scope.pessoas = [];
        $scope.page = 1;
        $scope.loadAll = function () {
            Pessoa.query({page: $scope.page, per_page: 10}, function (result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.pessoas = result;
            });
        };
        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            Pessoa.get({id: id}, function (result) {
                $scope.pessoa = result;
                SweetAlert.swal({
                        title: "Confirme a exclusão",
                        text: "Você tem certeza que quer excluir o registro selecionado?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55", confirmButtonText: "Sim, Excluir",
                        cancelButtonText: "Não, Cancelar",
                        closeOnConfirm: false,
                        closeOnCancel: false
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            $scope.confirmDelete(id);
                        } else {
                            SweetAlert.info("Cancelado", "O registro não foi removido :)", "error");
                        }
                    });
            });
        };

        $scope.confirmDelete = function (id) {
            Pessoa.delete({id: id},
                function () {
                    SweetAlert.info("Removido!", "O registro foi removido com sucesso.", "success");
                    $scope.loadAll();
                    $scope.clear();

                });
        };

        $scope.search = function () {
            PessoaSearch.query({query: $scope.searchQuery}, function (result) {
                $scope.pessoas = result;
            }, function (response) {
                if (response.status === 404) {
                    $scope.loadAll();
                }
            });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.pessoa = {id: null};
        };
    });

'use strict';

angular.module('nfseApp')
    .factory('PerguntasRespostasService', function ($resource) {
        return $resource('api/externo/perguntas-respostas/:id', {}, {
            'perguntasRespostasParaExibicao': {
                url: 'api/externo/perguntas-repostas-para-exibicao',
                method: 'GET',
                isArray: true
            }
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('perfilUsuario', {
                parent: 'entity',
                url: '/perfil-usuario',
                data: {
                    roles: ['ROLE_CONTRIBUINTE'],
                    pageTitle: 'Perfil do Usuário'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/perfilUsuario/perfilUsuario.html',
                        controller: 'SettingsController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('settings');
                        return $translate.refresh();
                    }],
                    entity: ['Pessoa', function(Pessoa) {
                        return Pessoa.getPessoaDoUsuario().$promise;
                    }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('SettingsController', function ($state, $scope, $modal, $timeout, entity, Principal, Pessoa, CEP, Municipio, Notificacao, Imagem) {


        $scope.pessoa = entity;

        $scope.myCroppedImage = "";


        Imagem.getImageFromUsuario({}, function (imagem) {
            if (imagem && imagem.conteudo) {
                $scope.imagemUsuario = imagem.conteudo;
            }
        });

        $scope.loadEnderecoByCEP = function (cep) {
            if (cep) {
                CEP.getByCep({cep: cep}, function (endereco) {
                    $scope.pessoa.dadosPessoais.cep = endereco.cep;
                    $scope.pessoa.dadosPessoais.municipio = endereco.municipio;
                    $scope.pessoa.dadosPessoais.logradouro = endereco.logradouro;
                    $scope.pessoa.dadosPessoais.bairro = endereco.bairro;
                });
            }
        };

        $scope.loadMunicipioByCodigo = function (codigo) {
            if (codigo) {
                Municipio.getByCodigo({codigo: codigo}, function (municipio) {
                    if (municipio.id) {
                        $scope.pessoa.dadosPessoais.municipio = municipio;
                    } else {
                        Notificacao.warn("Atenção", "Não foi encontrado nenhum Municipio com o código " + codigo);
                        $scope.pessoa.dadosPessoais.municipio = {};
                    }
                });
            }
        };

        $scope.searchMunicipio = function () {
            var modalInstance = $modal.open({
                templateUrl: 'app/entities/municipio/municipio-search.html',
                controller: 'MunicipioSearchController',
                size: 'lg'
            });
            modalInstance.result.then(function (municipio) {
                $scope.pessoa.dadosPessoais.municipio = municipio;
            }, function () {
                //$log.info('Modal dismissed at: ' + new Date());
            });
        };

        $scope.save = function () {

            Pessoa.save($scope.pessoa, onSuccess, onError);

            function onSuccess(data) {
                $state.reload();

                if ($scope.myImage && $scope.myCroppedImage) {
                    var imagem = {conteudo: $scope.myCroppedImage, pessoa: data};
                    Imagem.updateImagemUsuario(imagem, function (data) {
                        Notificacao.priority("Configurações salvas com sucesso!");
                        $scope.$emit('nfseApp:navbarUpdate', data);
                    });
                } else {
                    Notificacao.priority("Configurações salvas com sucesso!");
                    $scope.$emit('nfseApp:navbarUpdate', data);
                }
            };
            function onError() {
                Notificacao.error("Ocorreu um erro!", "As configurações não foram salvas.");
            };
        };


        $scope.upload = function (file) {
            var reader = new FileReader();
            reader.onload = function (evt) {
                $scope.$apply(function ($scope) {
                    $scope.myImage = evt.target.result;
                });
            };
            reader.readAsDataURL(file);
        }
    });

'use strict';

angular.module('nfseApp')
    .controller('UploadImagemEmpresaController', function ($scope, $state, $modalInstance, prestadorServicos, imagemPrestador, Imagem) {

        $scope.myCroppedImage = "";
        $scope.prestadorServicos = prestadorServicos;
        $scope.imagemPrestador = imagemPrestador;

        $scope.ok = function () {
            $modalInstance.close();
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

        $scope.upload = function (file) {
            $scope.imagemPrestador = null
            var reader = new FileReader();
            reader.onload = function (evt) {
                $scope.$apply(function ($scope) {
                    $scope.myImage = evt.target.result;
                });
            };
            reader.readAsDataURL(file);
        };

        $scope.updateImagem = function () {

            var imagem = {conteudo: $scope.myCroppedImage, pessoa: $scope.prestadorServicos.pessoa};

            Imagem.updateImagem(imagem, onSuccess, onError);

            function onSuccess(data) {
                $modalInstance.close();
                $state.reload();
                Notificacao.priority("Upload da logo realizado com sucesso.");
                $scope.$emit('nfseApp:navbarUpdate', data);
            };

            function onError(data) {
                Notificacao.error("Ocorreu um erro!", data);
            };
        };

    });

'use strict';

angular.module('nfseApp')
    .controller('PerfilEmpresaEditController',
        function ($scope, $rootScope, $stateParams, PrestadorServicos, localStorageService, Principal, $log,
                  Imagem, Notificacao, SweetAlert, $modal, $state, EnumeradoJsonService) {

            $scope.rolesEmpresa = EnumeradoJsonService.getEnumValues("roles")

            $scope.load = function () {
                var prestador = localStorageService.get("prestadorPrincipal").prestador;
                PrestadorServicos.get({id: prestador.id}, function (result) {
                    $scope.prestadorServicos = result;
                    $scope.prestadorServicos.usuarios = [];
                    Imagem.getImageFromPessoa({id: $scope.prestadorServicos.pessoa.id}, function (imagem) {
                        if (imagem && imagem.conteudo) {
                            $scope.imagemPrestador = imagem.conteudo;
                        }
                    });

                    PrestadorServicos.getUsuariosPrestador({}, function (data) {
                        $scope.prestadorServicos.usuarios = data;
                    });

                    PrestadorServicos.getTributosFederais({prestadorId: $scope.prestadorServicos.id},
                        function (result) {
                            $scope.prestadorServicos.tributosFederais = result;
                        });

                });
            };

            $scope.load();

            $scope.trocarChaveAcesso = function () {
                PrestadorServicos.trocarChaveAcesso({id: $scope.prestadorServicos.id}, function (result) {
                    $scope.load();
                });
            };


            $scope.permitirAcessoAoUsuario = function (user) {
                var usuarioEmpresa = {
                    login: user.login,
                    prestador: $scope.prestadorServicos,
                    roles: user.roles,
                    contador: user.contador,
                    descricao: user.descricao
                };
                PrestadorServicos.permitirAcessoAoUsuario(usuarioEmpresa, function () {
                    $scope.load();
                });
            };

            $scope.ativarOuDesativarUsuario = function (user) {
                SweetAlert.swal({
                        title: "Confirme a alteração de situação do usuário",
                        text: "Você tem certeza que quer " + (user.activated ? "Desativar" : "Ativar") + " esse usuário?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55", confirmButtonText: "Sim",
                        cancelButtonText: "Não, Cancelar",
                        closeOnConfirm: false,
                        closeOnCancel: false
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            PrestadorServicos.ativarOuDesativarUsuarioEmpresa({login: user.login}, function () {
                                Notificacao.info("Informação", "Usuário alterado com sucesso.");
                                $scope.load();
                            });
                        } else {
                            SweetAlert.info("Cancelado", "O usuário não foi removido", "error");
                        }
                    });
            };

            $scope.searchUser = function () {
                var modalInstance = $modal.open({
                    templateUrl: 'app/admin/user-management/user-management-search-by-cpf.html',
                    controller: 'UserManagementSearchCpfController',
                    size: 'lg'
                });
                modalInstance.result.then(function (user) {
                    if (hasUsuarioAdicionado(user)) {
                        Notificacao.warn('Atenção', 'Usuário já adicionado para essa empresa.')
                    } else {
                        PrestadorServicos.vincularNovoUsuarioEmpresa({login: user.login}, function () {
                            Notificacao.info("Informação", "Usuário vinculado com sucesso.");
                            $scope.load();
                        });

                    }

                }, function () {
                    $log.info('Modal dismissed at: ' + new Date());
                });
            };

            function hasUsuarioAdicionado(user) {
                if ($scope.prestadorServicos.usuarios) {
                    for (var i = 0; i < $scope.prestadorServicos.usuarios.length; i++) {
                        if ($scope.prestadorServicos.usuarios[i].login == user.login) {
                            return true;
                        }
                    }
                }
                return false;
            }

            $scope.getNomeEscritorio = function () {
                var nome = "";
                if ($scope.prestadorServicos && $scope.prestadorServicos.escritorioContabil) {
                    if ($scope.prestadorServicos.escritorioContabil.dadosPessoais) {
                        nome = $scope.prestadorServicos.escritorioContabil.dadosPessoais.nomeRazaoSocial;
                        nome += "(" + $scope.prestadorServicos.escritorioContabil.dadosPessoais.cpfCnpj + ")";
                    } else if ($scope.prestadorServicos.escritorioContabil.responsavel) {
                        nome = $scope.prestadorServicos.escritorioContabil.responsavel.nomeRazaoSocial;
                        nome += "(" + $scope.prestadorServicos.escritorioContabil.responsavel.cpfCnpj + ")";
                    }
                }
                return nome;
            }

            $scope.getEnderecoCompleto = function () {
                var endereco = "";
                if ($scope.prestadorServicos && $scope.prestadorServicos.pessoa && $scope.prestadorServicos.pessoa.dadosPessoais) {
                    if ($scope.prestadorServicos.pessoa.dadosPessoais.logradouro) {
                        endereco += $scope.prestadorServicos.pessoa.dadosPessoais.logradouro;
                    }
                    endereco = adicionarVirgulaAoEndereco(endereco);
                    if ($scope.prestadorServicos.pessoa.dadosPessoais.numero) {
                        endereco += $scope.prestadorServicos.pessoa.dadosPessoais.numero;
                    }
                    endereco = adicionarVirgulaAoEndereco(endereco);
                    if ($scope.prestadorServicos.pessoa.dadosPessoais.complemento) {
                        endereco += $scope.prestadorServicos.pessoa.dadosPessoais.complemento;
                    }
                    endereco = adicionarVirgulaAoEndereco(endereco);
                    if ($scope.prestadorServicos.pessoa.dadosPessoais.bairro) {
                        endereco += $scope.prestadorServicos.pessoa.dadosPessoais.bairro;
                    }
                    endereco = adicionarVirgulaAoEndereco(endereco);
                    if ($scope.prestadorServicos.pessoa.dadosPessoais.cep) {
                        endereco += 'Cep: ' + $scope.prestadorServicos.pessoa.dadosPessoais.cep;
                    }
                    endereco = adicionarVirgulaAoEndereco(endereco);
                    if ($scope.prestadorServicos.pessoa.dadosPessoais.municipio) {
                        endereco += $scope.prestadorServicos.pessoa.dadosPessoais.municipio.nome;
                    }
                    endereco = adicionarVirgulaAoEndereco(endereco);
                    if ($scope.prestadorServicos.pessoa.dadosPessoais.municipio) {
                        endereco += $scope.prestadorServicos.pessoa.dadosPessoais.municipio.estado;
                    }
                }
                return endereco;
            };

            function adicionarVirgulaAoEndereco(endereco) {
                if (endereco !== null && endereco !== '' && !endereco.trim().endsWith(",")) {
                    endereco = endereco.trim() + ", ";
                }
                return endereco;
            }

            $scope.trocarImagemEmpresa = function () {
                var modalInstance = $modal.open({
                    templateUrl: 'app/entities/perfilEmpresa/uploadImagemEmpresa.html',
                    controller: 'UploadImagemEmpresaController',
                    size: 'lg',
                    resolve: {
                        imagemPrestador: function () {
                            return $scope.imagemPrestador;
                        },
                        prestadorServicos: function () {
                            return $scope.prestadorServicos;
                        }
                    }
                });
            };

            $scope.searchEscritorioContabil = function () {
                var modalInstance = $modal.open({
                    templateUrl: 'app/entities/escritorioContabil/escritorioContabil-search.html',
                    controller: 'EscritorioContabilSearchController',
                    size: 'lg'
                });
                modalInstance.result.then(function (result) {
                    $scope.prestadorServicos.escritorioContabil = result;
                }, function () {
                    //$log.info('Modal dismissed at: ' + new Date());
                });
            };

            $scope.save = function () {
                PrestadorServicos.update($scope.prestadorServicos, function (data) {
                    $scope.$emit('nfseApp:prestadorServicosUpdate', data);
                    $scope.load();
                    Notificacao.info("Perfil Salvo com sucesso.");
                });
            };

            $scope.ajustaNomeEnum = function (nome) {
                if (!nome) {
                    return "";
                }
                try {
                    nome = nome.charAt(0).toUpperCase() + nome.slice(1).toLowerCase();
                    return nome.replace(/_/g, ' ');
                } catch (e) {
                    return "";
                }
            }

            $scope.salvarTributosFederais = function () {
                $scope.prestadorServicos.tributosFederais.prestadorServicosId = $scope.prestadorServicos.id;
                PrestadorServicos.salvarTributosFederais($scope.prestadorServicos.tributosFederais, function () {
                    $scope.load();
                });
            };
        });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('perfilEmpresa', {
                parent: 'entity',
                url: '/perfil-empresa',
                data: {
                    roles: ['ROLE_EMPRESA_ADM'],
                    pageTitle: 'Perfil da Empresa'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/perfilEmpresa/perfilEmpresa-edit.html',
                        controller: 'PerfilEmpresaEditController'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Perfil da Empresa'
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('prestadorServicos');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('dadosPessoais');
                        $translatePartialLoader.addPart('endereco');
                        $translatePartialLoader.addPart('cnae');
                        $translatePartialLoader.addPart('servico');
                        $translatePartialLoader.addPart('settings');
                        return $translate.refresh();
                    }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('PaisSearchController', function ($scope, Pais, PaisSearch, ParseLinks, SweetAlert, $modalInstance) {
        $scope.paises = [];
        $scope.page = 1;
        $scope.loadAll = function () {
            Pais.query({page: $scope.page, per_page: 5}, function (result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.paises = result;
            });
        };
        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.search = function () {
            PaisSearch.query({query: $scope.searchQuery}, function (result) {
                $scope.paises = result;
            }, function (response) {
                if (response.status === 404) {
                    $scope.loadAll();
                }
            });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.pais = { id: null, codigo: null, nome: null, sigla: null};
        };

        $scope.ok = function (pais) {
            $modalInstance.close(pais);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    });

'use strict';

angular.module('nfseApp').controller('PaisDialogController',
    ['$scope','$state', '$stateParams',  'entity', 'Pais',"Notificacao",
        function($scope,$state, $stateParams, entity, Pais, Notificacao) {

        $scope.pais = entity;
        $scope.load = function(id) {
            Pais.get({id : id}, function(result) {
                $scope.pais = result;
            });
        };

        var onSaveFinished = function (result) {
            $scope.$emit('nfseApp:paisUpdate', result);
            $state.go("pais");
            Notificacao.info("Pais Salvo com sucesso.");
        };

        $scope.save = function () {
            if ($scope.pais.id != null) {
                Pais.update($scope.pais, onSaveFinished);
            } else {
                Pais.save($scope.pais, onSaveFinished);
            }
        };

        $scope.clear = function() {
            //$modalInstance.dismiss('cancel');
        };
}]);

'use strict';

angular.module('nfseApp')
    .controller('PaisDetailController', function ($scope, $rootScope, $stateParams, entity, Pais) {
        $scope.pais = entity;
        $scope.load = function (id) {
            Pais.get({id: id}, function(result) {
                $scope.pais = result;
            });
        };
        $rootScope.$on('nfseApp:paisUpdate', function(event, result) {
            $scope.pais = result;
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('Pais', function ($resource, DateUtils) {
        return $resource('api/paises/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getByCodigo': {
                url: 'api/paises_por_codigo/:codigo',
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {method: 'PUT'},
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('PaisSearch', function ($resource) {
        return $resource('api/_search/paises/:query', {}, {
            'query': { method: 'GET', isArray: true}
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('pais', {
                parent: 'entity',
                url: '/paises',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'nfseApp.pais.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/pais/paises.html',
                        controller: 'PaisController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('pais');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('pais.detail', {
                parent: 'entity',
                url: '/detalhes/{id}',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'nfseApp.pais.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/pais/pais-detail.html',
                        controller: 'PaisDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('pais');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Pais', function($stateParams, Pais) {
                        return Pais.get({id : $stateParams.id});
                    }]
                }
            })
            .state('pais.new', {
                parent: 'pais',
                url: '/novo',
                data: {
                    roles: ['ROLE_ADMIN'],
                },
                ncyBreadcrumb: {
                    label: 'Novo País'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/pais/pais-dialog.html',
                        controller: 'PaisDialogController'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('pais');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {id: null, codigo: "", nome: ""};
                    }
                }
            })
            .state('pais.edit', {
                parent: 'pais',
                url: '/edicao/{id}',
                data: {
                    roles: ['ROLE_ADMIN'],
                },
                ncyBreadcrumb: {
                    label: 'Edição de País'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/pais/pais-dialog.html',
                        controller: 'PaisDialogController'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('pais');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Pais', function($stateParams, Pais) {
                        return Pais.get({id : $stateParams.id});
                    }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('PaisController', function ($scope, Pais, PaisSearch, ParseLinks, SweetAlert) {
        $scope.paises = [];
        $scope.page = 1;
        $scope.per_page = 10;
        $scope.mostraBotaoLoadInicial = false;
        $scope.loadAll = function () {
            Pais.query({page: $scope.page, per_page: $scope.per_page}, function (result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.paises = result;
                $scope.mostraBotaoLoadInicial = 1;
            });
        };
        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            Pais.get({id: id}, function (result) {
                $scope.pais = result;
                SweetAlert.swal({
                        title: "Confirme a exclusão",
                        text: "Você tem certeza que quer excluir o registro selecionado?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55", confirmButtonText: "Sim, Excluir",
                        cancelButtonText: "Não, Cancelar",
                        closeOnConfirm: false,
                        closeOnCancel: false
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            $scope.confirmDelete(id);
                        } else {
                            SweetAlert.info("Cancelado", "O registro não foi removido :)", "error");
                        }
                    });
            });
        };

        $scope.confirmDelete = function (id) {
            Pais.delete({id: id},
                function () {
                    $scope.loadAll();
                    SweetAlert.info("Removido!", "O País foi removido com sucesso.", "success");
                });
        };

        $scope.search = function () {
            PaisSearch.query({query: $scope.searchQuery}, function (result) {
                $scope.paises = result;
            }, function (response) {
                if (response.status === 404) {
                    $scope.loadAll();
                }
            });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.pais = {codigo: null, nome: null, id: null, sigla: null};
        };

        $scope.loadInitialData = function () {
            Pais.loadInitialData();
            $scope.loadAll();
        }
    });

'use strict';

angular.module('nfseApp')
    .controller('NotaFiscalAvulsaEditController',
        function ($rootScope, $state, $scope, entity, NotaFiscalAvulsa, Account, Notificacao, Pessoa, CEP, $modal) {

            $scope.notaFiscalAvulsa = entity;
            $scope.item = {};

            $scope.atribuirUsuarioNfse = function () {
                Account.get().$promise
                    .then(function (account) {
                        $scope.notaFiscalAvulsa.user = account.data;
                        Pessoa.getPessoaDoLogin({login: account.data.login}).$promise.then(function (prestador) {
                            console.log(prestador);
                            $scope.notaFiscalAvulsa.prestador = prestador;
                        })
                    });
            };

            $scope.atribuirUsuarioNfse();


            $scope.validarCamposObrigatorios = function () {
                if (!$scope.notaFiscalAvulsa.dataNota) {
                    Notificacao.warn('Informe a Data da Nota', 'Atenção');
                    return false;
                }
                if (!$scope.notaFiscalAvulsa.tomador) {
                    Notificacao.warn('Informe o Tomador', 'Atenção');
                    return false;
                }
                if (!$scope.notaFiscalAvulsa.itens ||
                    $scope.notaFiscalAvulsa.itens.length == 0) {
                    Notificacao.warn('Informe o Serviço Prestado', 'Atenção');
                    return false;
                }
                return true;
            };

            $scope.salvar = function () {
                if ($scope.validarCamposObrigatorios()) {
                    NotaFiscalAvulsa.save($scope.notaFiscalAvulsa,
                        function (data) {
                            $state.go('notaFiscalAvulsa');
                        },
                        function (error) {
                            console.log(error);
                            $state.go('notaFiscalAvulsa');
                        });
                }
            }

            $scope.$watch('editForm.cpfCnpj.$valid', function (newVal) {
                $scope.preLoadTomador();
            });

            $scope.preLoadTomador = function () {
                if ($scope.temCpfOuCnpj()) {

                    var cpfCnpj = $scope.notaFiscalAvulsa.tomador.dadosPessoais.cpfCnpj;
                    Pessoa.getPorCpfCnpj({cpfCnpj: cpfCnpj}, function (result) {
                        if (result.id) {
                            $scope.notaFiscalAvulsa.tomador = result;
                        } else {
                            $scope.notaFiscalAvulsa.tomador.id = null;
                            $scope.notaFiscalAvulsa.tomador.dadosPessoais = {};
                            $scope.notaFiscalAvulsa.tomador.dadosPessoais.cpfCnpj = cpfCnpj;
                        }
                    });
                }
            };

            $scope.temCpfOuCnpj = function () {
                return $scope.notaFiscalAvulsa &&
                    $scope.notaFiscalAvulsa.tomador &&
                    $scope.notaFiscalAvulsa.tomador.dadosPessoais &&
                    $scope.notaFiscalAvulsa.tomador.dadosPessoais.cpfCnpj;
            };

            $scope.isFisica = function () {
                return $scope.notaFiscalAvulsa &&
                    $scope.notaFiscalAvulsa.tomador &&
                    $scope.notaFiscalAvulsa.tomador.dadosPessoais &&
                    $scope.notaFiscalAvulsa.tomador.dadosPessoais.cpfCnpj &&
                    $scope.notaFiscalAvulsa.tomador.dadosPessoais.cpfCnpj.replace(/[^\w\s]/gi, '').length == 11

            };

            $scope.isJuridica = function () {
                return $scope.notaFiscalAvulsa &&
                    $scope.notaFiscalAvulsa.tomador &&
                    $scope.notaFiscalAvulsa.tomador.dadosPessoais &&
                    $scope.notaFiscalAvulsa.tomador.dadosPessoais.cpfCnpj &&
                    $scope.notaFiscalAvulsa.tomador.dadosPessoais.cpfCnpj.replace(/[^\w\s]/gi, '').length == 14

            };

            $scope.loadEnderecoByCEP = function (cep) {
                if (cep) {
                    CEP.getByCep({cep: cep}, function (endereco) {
                        if (endereco.municipio) {
                            $scope.notaFiscalAvulsa.tomador.dadosPessoais.cep = endereco.cep;
                            $scope.notaFiscalAvulsa.tomador.dadosPessoais.municipio = endereco.municipio;
                            $scope.notaFiscalAvulsa.tomador.dadosPessoais.logradouro = endereco.logradouro;
                            $scope.notaFiscalAvulsa.tomador.dadosPessoais.bairro = endereco.bairro;
                        }
                    });
                }
            };

            $scope.searchMunicipio = function (caraQueTemMunicipio) {
                var modalInstance = $modal.open({
                    templateUrl: 'app/entities/municipio/municipio-search.html',
                    controller: 'MunicipioSearchController',
                    size: 'lg'
                });
                modalInstance.result.then(function (municipio) {
                    caraQueTemMunicipio.municipio = municipio;
                    caraQueTemMunicipio.pais = {};
                }, function () {
                    //$log.info('Modal dismissed at: ' + new Date());
                });
            };

            $scope.searchServico = function () {
                var modalInstance = $modal.open({
                    templateUrl: 'app/entities/servico/servico-search.html',
                    controller: 'ServicoSearchController',
                    size: 'lg'
                });
                modalInstance.result.then(function (result) {
                    $scope.item.servico = result;
                    $scope.item.aliquota = $scope.item.servico.aliquota;
                }, function () {

                });
            };

            $scope.validarCamposObrigatoriosServico = function () {
                if (!$scope.item) {
                    return false;
                }
                if (!$scope.item.servico) {
                    Notificacao.warn('Informe um serviço.');
                    return false;
                }
                if (!$scope.item.descricao) {
                    Notificacao.warn('Informe a discriminação do serviço.');
                    return false;
                }
                if (!$scope.item.quantidade || $scope.item.quantidade <= 0) {
                    Notificacao.warn('Informe uma quantidade maior que 0.');
                    return false;
                }
                if (!$scope.item.valorUnitario || $scope.item.valorUnitario <= 0) {
                    Notificacao.warn('Informe um valor unitário maior que 0.');
                    return false;
                }
                return true;
            };

            $scope.addServico = function () {
                if ($scope.validarCamposObrigatoriosServico()) {
                    $scope.notaFiscalAvulsa.itens.push($scope.item);
                    $scope.notaFiscalAvulsa.valorIss = $scope.item.aliquota;
                    $scope.notaFiscalAvulsa.valorServicos = $scope.item.valorTotal;
                    $scope.notaFiscalAvulsa.valorTotalIss = $scope.item.valorIss;
                    $scope.item = {};
                }
            };

            $scope.delServico = function (index) {
                $scope.notaFiscalAvulsa.itens.splice(index, 1);
            };

            $scope.editServico = function (index) {
                $scope.item = $scope.notaFiscalAvulsa.itens[index];
                $scope.delServico(index);
            };

            $scope.calcularValoresServico = function () {
                if ($scope.item.quantidade && $scope.item.valorUnitario) {
                    $scope.item.valorTotal = $scope.item.quantidade * $scope.item.valorUnitario;
                    $scope.item.valorIss = $scope.item.valorTotal * ($scope.item.aliquota / 100);
                }
            }
        }
    );

'use strict';

angular.module('nfseApp')
    .controller('NotaFiscalAvulsaDetailController',
        function ($scope, entity) {
            $scope.notaFiscalAvulsa = entity;
        }
    );

'use strict';

angular.module('nfseApp')
    .factory('NotaFiscalAvulsa', function ($resource) {
        return $resource('api/notaFiscalAvulsa/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            }
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('notaFiscalAvulsa', {
                parent: 'entity',
                url: '/nota-fiscal-avulsa',
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'Nota Fiscal Avulsa'
                },
                ncyBreadcrumb: {
                    label: 'Consulta de Nota Fiscal Avulsa'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/notaFiscalAvulsa/notaFiscalAvulsa.html',
                        controller: 'NotaFiscalAvulsaController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('notaFiscalAvulsa.new', {
                parent: 'entity',
                url: '/nova-nota-fiscal-avulsa',
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'Nota Fiscal Avulsa'
                },
                ncyBreadcrumb: {
                    label: 'Emissão de Nota Fiscal Avulsa'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/notaFiscalAvulsa/notaFiscalAvulsa-edit.html',
                        controller: 'NotaFiscalAvulsaEditController'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            dataNota: new Date(),
                            tomador: {},
                            itens: []
                        };
                    }
                }
            })
            .state('notaFiscalAvulsa.detail', {
                parent: 'entity',
                url: '/visualizacao-nota-fiscal-avulsa/{id}',
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'Nota Fiscal Avulsa'
                },
                ncyBreadcrumb: {
                    label: 'Visualização de Nota Fiscal Avulsa'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/notaFiscalAvulsa/notaFiscalAvulsa-detail.html',
                        controller: 'NotaFiscalAvulsaDetailController'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'NotaFiscalAvulsa', '$state', function ($stateParams, NotaFiscalAvulsa, $state) {
                        return NotaFiscalAvulsa.get({id: $stateParams.id},
                            function (sucess) {
                                return sucess;
                            }, function (error) {
                                $state.go('notaFiscalAvulsa');
                            });
                    }]
                }
            })
    });

'use strict';

angular.module('nfseApp')
    .controller('NotaFiscalAvulsaController',
        function ($rootScope, $scope, NotaFiscalAvulsa, ParseLinks, ImpressaoPdf) {

            $scope.notasFiscaisAvulsa = [];
            $scope.per_page = 10;
            $scope.searchQuery = "";

            $scope.loadAll = function () {
                NotaFiscalAvulsa.query({
                    page: $scope.page,
                    per_page: $scope.per_page,
                    filtro: $scope.searchQuery
                }, function (result, headers) {
                    if (headers)
                        $scope.links = ParseLinks.parse(headers('link'));
                    $scope.notasFiscaisAvulsa = result;
                });
            };

            $scope.loadPage = function (page) {
                $scope.page = page;
                $scope.loadAll();
            };

            $scope.loadAll();

            $scope.newNotaFiscalAvulsa = function () {
                $state.go("notaFiscalAvulsa.new");
            };

            $scope.imprimeNFSAvulsa = function (id) {
                console.log('veio aqui');
                ImpressaoPdf.imprimirPdfViaUrl('/api/imprimir-nota-fiscal-avulsa/' + id);
            };
        }
    );

'use strict';

angular.module('nfseApp').controller('NotaFiscalEditController',
    ['$rootScope', '$scope', '$modal', '$state', '$filter', '$stateParams', 'entity', 'NotaFiscal',
        'localStorageService', 'Notificacao', 'Tomador', 'Servico', 'Municipio', 'CEP', 'Pais',
        'Configuracao', 'PrestadorServicos', 'ImpressaoPdf', 'Cnae', 'SweetAlert', 'ConstrucaoCivil', 'Util',

        function ($rootScope, $scope, $modal, $state, $filter, $stateParams, entity, NotaFiscal,
                  localStorageService, Notificacao, Tomador, Servico, Municipio, CEP, Pais,
                  Configuracao, PrestadorServicos, ImpressaoPdf, Cnae, SweetAlert, ConstrucaoCivil,
                  Util) {

            $scope.mensagemCamposObrigatorios = [];
            $scope.mostraFormServicos = true;
            $scope.itensDeclaracaoServico = [];
            $scope.aliquotas = [0.00, 2.00, 2.79, 3.00, 3.50, 3.84, 3.87, 4.23, 4.26, 4.31, 4.61, 4.65, 5.00];
            $scope.mostrarDadosNota = false;
            $scope.permiteExigibilidade = true;
            $scope.bloqueiaAliquota = false;
            $scope.passos = {tipoTomador: 1, servico: 2, itensNota: 3, outrasInfos: 4, resumo: 5};
            $scope.passoAtual = $scope.passos.tipoTomador;
            $scope.cpfCnpjTomadorAnterior = "";
            $scope.emissaoRetroativa = false;
            $scope.emissaoRetroativaUltimaEmissao = false;
            $scope.ultimaDataEmissao = null;
            $scope.naturezasOperacao = [];
            $scope.art;
            $scope.aliquotaServicoExcedente;

            Configuracao.get({}, function (data) {

                $scope.municipio = data.municipio;
                $scope.configuracao = data;
                $scope.emissaoRetroativa = data.emissaoRetroativa;
                $scope.emissaoRetroativaUltimaEmissao = data.emissaoRetroativaUltimaEmitida;

                PrestadorServicos.get({id: localStorageService.get("prestadorPrincipal").prestador.id}, function (data) {
                    $scope.prestador = data;
                    $scope.cpfCnpjDoPrestador = $scope.prestador.pessoa.dadosPessoais.cpfCnpj;
                    if (!$scope.prestador.enquadramentoFiscal || !$scope.prestador.enquadramentoFiscal.regimeTributario || !$scope.prestador.emiteNfs) {
                        SweetAlert.error("Atenção", $scope.prestador.pessoa.dadosPessoais.nomeRazaoSocial + " Não tem permissão para emissão de NFS-e");
                        $state.go("notaFiscal");

                    }

                    if (entity.$promise) {
                        entity.$promise.then(function (nota) {
                            $scope.notaFiscal = nota;
                            $scope.notaFiscal.emails = "";
                            if (!$scope.notaFiscal.id) {
                                $scope.notaFiscal.municipio = $scope.municipio;
                                $scope.notaFiscal.prestadoNoPais = true;
                            }
                            if ($scope.temCpfOuCnpj()) {
                                $scope.cpfCnpjTomadorAnterior = $scope.notaFiscal.tomador.dadosPessoais.cpfCnpj;
                            }

                            if ($scope.notaFiscal.copiada) {
                                $scope.tratarNotaFiscalCopiada();
                            }
                            $scope.verificarExigibilidadeIss();
                            $scope.verificarRetencaoIss();
                            $scope.verificarDadosSimplesNacional();
                            $scope.calculaValoresDaNota(true);
                        });
                    } else {
                        $scope.notaFiscal = entity;
                        $scope.notaFiscal.declaracaoPrestacaoServico.modalidade = "IDENTIFICADO";
                        $scope.verificarExigibilidadeIss();
                        $scope.verificarRetencaoIss();
                        $scope.verificarDadosSimplesNacional();
                        $scope.calculaValoresDaNota(true);
                    }


                    Cnae.teByPrestador({id: $scope.prestador.id}, function (data) {
                        $scope.cnaes = data;
                    });

                    ConstrucaoCivil.buscarConstrucaoCivilFromPrestador({
                        prestador: $scope.prestador.id,
                        page: 0,
                        per_page: 999,
                        filtro: ""
                    }, function (result) {
                        $scope.obras = result;
                    });

                });
            });

            $scope.tratarNotaFiscalCopiada = function () {
                if ($scope.notaFiscal &&
                    $scope.notaFiscal.declaracaoPrestacaoServico &&
                    $scope.notaFiscal.declaracaoPrestacaoServico.itens &&
                    $scope.notaFiscal.declaracaoPrestacaoServico.itens.length > 0) {
                    $scope.codigoCnae = $scope.notaFiscal.declaracaoPrestacaoServico.itens[0].cnae.codigo;
                    $scope.notaFiscal.cnae = $scope.notaFiscal.declaracaoPrestacaoServico.itens[0].cnae;
                    $scope.loadServico();
                    $scope.codigoServico = $scope.notaFiscal.declaracaoPrestacaoServico.itens[0].servico.codigo;
                    $scope.notaFiscal.servico = $scope.notaFiscal.declaracaoPrestacaoServico.itens[0].servico;
                    $scope.notaFiscal.aliquotaServico = $scope.notaFiscal.declaracaoPrestacaoServico.itens[0].aliquotaServico;
                    $scope.notaFiscal.prestadoNoPais = $scope.notaFiscal.declaracaoPrestacaoServico.itens[0].prestadoNoPais;
                    $scope.notaFiscal.municipio = $scope.notaFiscal.declaracaoPrestacaoServico.itens[0].municipio;
                    $scope.notaFiscal.pais = $scope.notaFiscal.declaracaoPrestacaoServico.itens[0].pais;
                    $scope.notaFiscal.nomeServico = $scope.notaFiscal.declaracaoPrestacaoServico.itens[0].nomeServico;
                }
                if ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais) {
                    $scope.mostrarTributosFederais = true;
                }
                if ($scope.notaFiscal.declaracaoPrestacaoServico.intermediario) {
                    $scope.mostrarIntermediario = true;
                }
                if ($scope.notaFiscal.declaracaoPrestacaoServico.construcaoCivil) {
                    $scope.mostrarConstrucaoCivil = true;
                }
                if ($scope.notaFiscal.rps && $scope.notaFiscal.rps.numero) {
                    $scope.possuiRps = true;
                }
                $scope.passoAtual = $scope.passos.resumo;
            }

            $scope.calcularAliquotaServicoSNA = function () {

                $scope.aliquotaEfetiva = (($scope.notaFiscal.prestador.rbt12
                    * ($scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa.aliquota / 100)) - $scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa.valorDeduzir) / $scope.notaFiscal.prestador.rbt12;
                if ($scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa.iss) {
                    $scope.notaFiscal.aliquotaServico = ($scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa.iss / 100) * $scope.aliquotaEfetiva;
                } else if ($scope.notaFiscal.servico) {
                    $scope.notaFiscal.aliquotaServico = $scope.notaFiscal.servico.aliquota / 100;
                }
                $scope.aliquotaServicoExcedente = 0;
                if ($scope.notaFiscal.aliquotaServico > 0) {
                    if ($scope.notaFiscal.aliquotaServico > 0.05) {
                        $scope.aliquotaServicoExcedente = $scope.notaFiscal.aliquotaServico - 0.05;
                        $scope.notaFiscal.aliquotaServico = 0.05;
                    } else if ($scope.notaFiscal.aliquotaServico < 0.02) {
                        $scope.notaFiscal.aliquotaServico = 0.02;
                    }
                }
                $scope.notaFiscal.aliquotaServico = Number(parseFloat($scope.notaFiscal.aliquotaServico * 100).toFixed(2));

            };

            $scope.verificarDadosSimplesNacional = function () {
                if ($scope.isPrestadorSimplesNacional()) {
                    if ($scope.notaFiscal.prestador.rbt12 &&
                        $scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006 &&
                        $scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa) {
                        $scope.calcularAliquotaServicoSNA();
                    }
                }
            };

            $scope.buscarAnexoLei1232006FaixaDoPrestador = function () {
                $scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006.faixas.sort(function (a, b) {
                    return a.valorMaximo - b.valorMaximo;
                });

                for (var i = 0; i < $scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006.faixas.length; i++) {
                    if ($scope.notaFiscal.prestador.rbt12 < $scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006.faixas[i].valorMaximo) {
                        return $scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006.faixas[i];
                    }
                }
                return null;
            };

            $scope.isPrestadorSimplesNacional = function () {
                return $scope.prestador && $scope.prestador.enquadramentoFiscal &&
                    $scope.prestador.enquadramentoFiscal.simplesNacional;
            };

            $scope.isMei = function () {
                return $scope.prestador && $scope.prestador.enquadramentoFiscal &&
                    $scope.prestador.enquadramentoFiscal.mei;
            };

            $scope.proximoPasso = function () {
                $scope.passoAtual = $scope.passoAtual + 1;
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                if ($scope.passoAtual === $scope.passos.outrasInfos) {
                    $scope.calculaValoresDaNota(true);
                }
            };

            $scope.passoAnterior = function () {
                $scope.passoAtual = $scope.passoAtual - 1;
                document.body.scrollTop = document.documentElement.scrollTop = 0;

            };

            $scope.adicionarEmail = function (email) {
                if (!$scope.notaFiscal.emails) {
                    $scope.notaFiscal.emails = "";
                }
                if ($scope.notaFiscal.emails.length > 0) {
                    $scope.notaFiscal.emails += ', ';
                }
                $scope.notaFiscal.emails += email;
            };

            $scope.searchItemDeclaracaoServico = function () {
                var modalDescriminacaoServico = $modal.open({
                    templateUrl: 'app/entities/notaFiscal/item-declaracao-servico-search.html',
                    controller: 'ItemDeclaracaoServicoController',
                    size: 'lg'
                });
                modalDescriminacaoServico.result.then(function (data) {
                    if (data) {
                        $scope.notaFiscal.descriminacaoServico = data;
                    }
                });
            };

            $scope.preLoadIntermediario = function () {
                if ($scope.notaFiscal && $scope.notaFiscal.declaracaoPrestacaoServico && $scope.notaFiscal.declaracaoPrestacaoServico.intermediario) {
                    var cpfCnpj = $scope.notaFiscal.declaracaoPrestacaoServico.intermediario.cpfCnpj;
                    $scope.notaFiscal.declaracaoPrestacaoServico.intermediario = {};
                    $scope.notaFiscal.declaracaoPrestacaoServico.intermediario.cpfCnpj = cpfCnpj;
                    Tomador.getTomadorPorCpfCnpj({cpfCnpj: cpfCnpj}, function (result) {
                        if (!result.dadosPessoais) {
                            Tomador.getInPessoRepoByCpfCnpj({cpfCnpj: cpfCnpj}, function (result) {
                                if (result.dadosPessoais && result.dadosPessoais.cpfCnpj) {
                                    $scope.notaFiscal.declaracaoPrestacaoServico.intermediario.nomeRazaoSocial = result.dadosPessoais.nomeRazaoSocial;
                                }
                            });
                        } else {
                            $scope.notaFiscal.declaracaoPrestacaoServico.intermediario.nomeRazaoSocial = result.dadosPessoais.nomeRazaoSocial;
                        }
                    });
                }
            };

            $scope.$watch('editForm.cpfCnpjIntermediario.$valid', function (newVal) {
                $scope.preLoadIntermediario();
            });

            $scope.preLoadTomador = function () {
                if ($scope.temCpfOuCnpj() && $scope.notaFiscal.tomador.dadosPessoais.cpfCnpj !== $scope.cpfCnpjTomadorAnterior) {
                    var cpfCnpj = $scope.notaFiscal.tomador.dadosPessoais.cpfCnpj;
                    $scope.cpfCnpjTomadorAnterior = cpfCnpj;
                    $scope.notaFiscal.tomador = {dadosPessoais: {}};
                    $scope.notaFiscal.tomador.dadosPessoais.cpfCnpj = cpfCnpj;
                    if ($scope.cpfDigitadoIgualPrestador()) {
                        Notificacao.error("Atenção", "Não é permitido que o Tomador de Serviços seja o próprio Prestador de Serviços.");
                    } else {

                        Tomador.getTomadorPorCpfCnpj({cpfCnpj: cpfCnpj}, function (result) {
                            if (!result.dadosPessoais) {
                                Tomador.getInPessoRepoByCpfCnpj({cpfCnpj: cpfCnpj}, function (data) {
                                    if (data.dadosPessoais && data.dadosPessoais.cpfCnpj) {
                                        $scope.notaFiscal.tomador = data;
                                    }
                                });
                                $scope.notaFiscal.tomador.prestador = $scope.prestador;
                            } else {
                                $scope.notaFiscal.tomador = result;
                            }
                        });
                    }
                    $scope.verificarRetencaoIss();
                }
            };


            $scope.selecionouObra = function () {
                if ($scope.notaFiscal.servico.construcaoCivil &&
                    $scope.notaFiscal.declaracaoPrestacaoServico.construcaoCivil &&
                    $scope.notaFiscal.declaracaoPrestacaoServico.construcaoCivil.incorporacao &&
                    $scope.notaFiscal.declaracaoPrestacaoServico.modalidade === 'NAO_IDENTIFICADO') {
                    SweetAlert.error("Atenção", "É necessário identificar o tomador para selecionar uma obra de incorporação");
                    $scope.notaFiscal.declaracaoPrestacaoServico.construcaoCivil = null;
                    return;
                } else {
                    $scope.verificarExigibilidadeIss();
                }
            };

            $scope.verificarExigibilidadeIss = function () {
                $scope.naturezasOperacao = [];

                $scope.permiteExigibilidade = true;
                $scope.permiteMudarPais = false;
                $scope.permiteMudarCidade = true;

                if (!$scope.notaFiscal.servico) {
                    return;
                }

                if (!$scope.notaFiscal.servico.localExecucaoTrabalho) {
                    $scope.notaFiscal.servico.localExecucaoTrabalho = 'LOCAL';
                }

                if ($scope.notaFiscal.servico.permiteExportacao) {
                    $scope.permiteExigibilidade = true;
                    $scope.permiteMudarPais = true;
                }

                if ($scope.notaFiscal.servico.localExecucaoTrabalho === 'DOMICIO_PRESTADOR'
                    || $scope.notaFiscal.declaracaoPrestacaoServico.modalidade === 'NAO_IDENTIFICADO') {
                    $scope.permiteMudarCidade = false;
                    $scope.notaFiscal.municipio = $scope.municipio;
                }

                if ($scope.notaFiscal.servico.localExecucaoTrabalho === 'LOCAL' && $scope.notaFiscal.declaracaoPrestacaoServico.construcaoCivil != null) {
                    $scope.notaFiscal.municipio = $scope.notaFiscal.declaracaoPrestacaoServico.construcaoCivil.localizacao.municipio;
                    $scope.permiteMudarCidade = false;
                }

                if ($scope.notaFiscal.servico.exigibilidade && $scope.notaFiscal.servico.exigibilidade !== 'TRIBUTACAO_MUNICIPAL') {
                    $scope.permiteExigibilidade = false;
                    $scope.naturezasOperacao.push($scope.notaFiscal.servico.exigibilidade);
                    $scope.notaFiscal.declaracaoPrestacaoServico.naturezaOperacao = $scope.notaFiscal.servico.exigibilidade;
                    return;
                }

                if ($scope.notaFiscal.servico.vetadoLC1162003) {
                    $scope.permiteExigibilidade = false;
                    $scope.naturezasOperacao.push("IMUNIDADE")
                    $scope.notaFiscal.declaracaoPrestacaoServico.naturezaOperacao = "IMUNIDADE";
                    return;
                }

                if (!$scope.notaFiscal.prestadoNoPais) {
                    $scope.permiteExigibilidade = false;
                    $scope.naturezasOperacao.push("EXPORTACAO");
                    $scope.notaFiscal.declaracaoPrestacaoServico.naturezaOperacao = "EXPORTACAO";
                    return;
                }

                if ($scope.prestador.enquadramentoFiscal.regimeTributario === 'COOPERATIVA') {
                    $scope.permiteExigibilidade = true;
                    $scope.naturezasOperacao.push("ISENCAO");
                }

                if ($scope.notaFiscal.servico.construcaoCivil &&
                    $scope.notaFiscal.declaracaoPrestacaoServico.construcaoCivil &&
                    $scope.notaFiscal.declaracaoPrestacaoServico.construcaoCivil.incorporacao) {
                    $scope.permiteExigibilidade = false;
                    $scope.naturezasOperacao.push("ISENCAO");
                    $scope.notaFiscal.declaracaoPrestacaoServico.naturezaOperacao = "ISENCAO";
                    return
                }

                if ($scope.notaFiscal.declaracaoPrestacaoServico.modalidade === 'NAO_IDENTIFICADO') {
                    $scope.naturezasOperacao.push("TRIBUTACAO_MUNICIPAL");
                    $scope.notaFiscal.declaracaoPrestacaoServico.naturezaOperacao = "TRIBUTACAO_MUNICIPAL";
                }

                if ($scope.notaFiscal.declaracaoPrestacaoServico.modalidade !== 'NAO_IDENTIFICADO'
                    && $scope.notaFiscal.servico.localExecucaoTrabalho === 'DOMICIO_PRESTADOR') {
                    $scope.naturezasOperacao.push("TRIBUTACAO_MUNICIPAL");
                    $scope.notaFiscal.declaracaoPrestacaoServico.naturezaOperacao = "TRIBUTACAO_MUNICIPAL";
                }

                if ($scope.notaFiscal.declaracaoPrestacaoServico.modalidade !== 'NAO_IDENTIFICADO'
                    && $scope.notaFiscal.servico.localExecucaoTrabalho === 'LOCAL'
                    && $scope.notaFiscal.municipio.id === $scope.municipio.id) {
                    $scope.naturezasOperacao.push("TRIBUTACAO_MUNICIPAL");
                    $scope.notaFiscal.declaracaoPrestacaoServico.naturezaOperacao = "TRIBUTACAO_MUNICIPAL";
                }

                if ($scope.notaFiscal.declaracaoPrestacaoServico.modalidade !== 'NAO_IDENTIFICADO'
                    && $scope.notaFiscal.servico.localExecucaoTrabalho === 'LOCAL'
                    && $scope.notaFiscal.municipio.id !== $scope.municipio.id) {
                    $scope.naturezasOperacao.push("TRIBUTACAO_FORA_MUNICIPIO");
                    $scope.notaFiscal.declaracaoPrestacaoServico.naturezaOperacao = "TRIBUTACAO_FORA_MUNICIPIO";
                }

                if ($scope.notaFiscal.declaracaoPrestacaoServico.modalidade !== 'NAO_IDENTIFICADO'
                    && $scope.notaFiscal.servico.localExecucaoTrabalho === 'ESTABELECIMENTO_PRESTADOR') {
                    $scope.naturezasOperacao.push("TRIBUTACAO_MUNICIPAL");
                    $scope.notaFiscal.declaracaoPrestacaoServico.naturezaOperacao = "TRIBUTACAO_MUNICIPAL";
                }

                if ($scope.naturezasOperacao.length === 0) {
                    $scope.naturezasOperacao.push("TRIBUTACAO_MUNICIPAL");
                    if (!$scope.notaFiscal.declaracaoPrestacaoServico.naturezaOperacao) {
                        $scope.notaFiscal.declaracaoPrestacaoServico.naturezaOperacao = "TRIBUTACAO_MUNICIPAL";
                    }
                }

                if ($scope.naturezasOperacao.length === 1) {
                    $scope.permiteExigibilidade = false;
                }
            };


            $scope.verificarRetencaoIss = function () {
                $scope.permiteRetencao = true;

                var regimeTributario = $scope.prestador.enquadramentoFiscal.regimeTributario;
                if (regimeTributario === "MICROEMPRESARIO_INDIVIDUAL" || regimeTributario === "ISS_FIXO_PESSOA_JURIDICA" || regimeTributario === "ISS_FIXO_PESSOA_FISICA"
                    || regimeTributario === "ESTIMATIVA") {
                    $scope.permiteRetencao = false;
                    $scope.notaFiscal.declaracaoPrestacaoServico.issRetido = false;
                }
                if ($scope.temCpfOuCnpj() && $scope.isFisica()) {
                    $scope.permiteRetencao = false;
                    $scope.notaFiscal.declaracaoPrestacaoServico.issRetido = false;
                }

                if ($scope.notaFiscal.declaracaoPrestacaoServico.modalidade === 'NAO_IDENTIFICADO') {
                    $scope.permiteRetencao = false;
                    $scope.notaFiscal.declaracaoPrestacaoServico.issRetido = false;
                }

                if ($scope.notaFiscal.declaracaoPrestacaoServico.modalidade !== 'NAO_IDENTIFICADO'
                    && $scope.notaFiscal.servico
                    && $scope.notaFiscal.servico.localExecucaoTrabalho === 'LOCAL'
                    && $scope.notaFiscal.municipio.id === $scope.municipio.id) {
                    $scope.permiteRetencao = false;
                    $scope.notaFiscal.declaracaoPrestacaoServico.issRetido = false;
                }

                if (!$scope.notaFiscal.prestadoNoPais) {
                    $scope.permiteRetencao = false;
                    $scope.notaFiscal.declaracaoPrestacaoServico.issRetido = false;
                }

                if ($scope.temCpfOuCnpj() && !$scope.isFisica()) {
                    if ($scope.notaFiscal.tomador.cadastroEconomico) {
                        if ($scope.notaFiscal.tomador.cadastroEconomico.enquadramentoFiscal.substitutoTributario) {
                            $scope.permiteRetencao = false;
                            $scope.notaFiscal.declaracaoPrestacaoServico.issRetido = true;
                        }
                    } else {
                        PrestadorServicos.buscarPorCpfCnpj({cpfCnpj: $scope.notaFiscal.tomador.dadosPessoais.cpfCnpj.replace(/[^\w\s]/gi, '')}, function (result) {
                            if (result && result.length > 1) {
                                $scope.selecionarcadastroEconomico(result);
                            } else {
                                $scope.notaFiscal.tomador.cadastroEconomico = result[0];
                                if ($scope.notaFiscal.tomador.cadastroEconomico)
                                    $scope.notaFiscal.tomador.dadosPessoais.inscricaoMunicipal = $scope.notaFiscal.tomador.cadastroEconomico.inscricaoMunicipal;

                                if ($scope.notaFiscal.tomador.cadastroEconomico && $scope.notaFiscal.tomador.cadastroEconomico.pessoa) {
                                    $scope.notaFiscal.tomador.dadosPessoais.pessoaId = $scope.notaFiscal.tomador.cadastroEconomico.pessoa.id;
                                }
                                if ($scope.notaFiscal.tomador &&
                                    $scope.notaFiscal.tomador.cadastroEconomico &&
                                    $scope.notaFiscal.tomador.cadastroEconomico.enquadramentoFiscal &&
                                    $scope.notaFiscal.tomador.cadastroEconomico.enquadramentoFiscal.substitutoTributario) {
                                    $scope.permiteRetencao = false;
                                    $scope.notaFiscal.declaracaoPrestacaoServico.issRetido = true;
                                }
                            }
                        })
                    }
                }
            };

            $scope.selecionarcadastroEconomico = function (cadastrosEconomico) {
                var modalInstance = $modal.open({
                    templateUrl: 'app/entities/cadastro-economico-dlg/cadastro-economico-dlg.html',
                    controller: 'CadastroEconomicoDialogController',
                    size: 'lg',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        cadastrosEconomico: function () {
                            return cadastrosEconomico;
                        }
                    }
                });
                modalInstance.result.then(function (cadastroEconomicoSelecionado) {
                    $scope.notaFiscal.tomador.cadastroEconomico = cadastroEconomicoSelecionado;
                    $scope.notaFiscal.tomador.dadosPessoais.inscricaoMunicipal = cadastroEconomicoSelecionado.inscricaoMunicipal;
                    $scope.verificarRetencaoIss();
                });
            };

            $scope.searchTomadorServico = function () {
                var modalInstance = $modal.open({
                    templateUrl: 'app/entities/tomador/tomador-search.html',
                    controller: 'TomadorSearchController',
                    size: 'lg'
                });
                modalInstance.result.then(function (tomador) {

                    Tomador.get({id: tomador.id}, function (data) {
                        if (data && data.dadosPessoais) {
                            $scope.notaFiscal.tomador = {};
                            $scope.notaFiscal.tomador.dadosPessoais = data.dadosPessoais;
                            $scope.notaFiscal.tomador.dadosPessoais.id = null;
                            if ($scope.notaFiscal.tomador.dadosPessoais.endereco) {
                                $scope.notaFiscal.tomador.dadosPessoais.endereco.id = null;
                            }
                            $scope.notaFiscal.tomador.tomador = data;
                        }
                    });


                }, function () {
                });
            };

            $scope.searchIntermediarioServico = function () {
                var modalInstance = $modal.open({
                    templateUrl: 'app/entities/tomador/tomador-search.html',
                    controller: 'TomadorSearchController',
                    size: 'lg'
                });
                modalInstance.result.then(function (tomador) {
                    if (tomador && tomador.dadosPessoais) {
                        $scope.notaFiscal.declaracaoPrestacaoServico.intermediario = {};
                        $scope.notaFiscal.declaracaoPrestacaoServico.intermediario.dadosPessoais = tomador.dadosPessoais;
                        $scope.notaFiscal.declaracaoPrestacaoServico.intermediario.dadosPessoais.id = null;
                        if ($scope.notaFiscal.declaracaoPrestacaoServico.intermediario.dadosPessoais.endereco) {
                            $scope.notaFiscal.declaracaoPrestacaoServico.intermediario.dadosPessoais.endereco.id = null;
                        }
                        $scope.notaFiscal.declaracaoPrestacaoServico.intermediario.tomador = tomador;
                    }
                }, function () {
                });
            };

            var onSaveFinished = function (result) {
                if (result.declaracaoPrestacaoServico.situacao == 'EMITIDA' && result && result.id) {
                    $state.go("notaFiscal");
                    ImpressaoPdf.imprimirPdfViaUrl('/publico/notaFiscal/imprime/' + result.id);
                }
            };

            $scope.emitir = function () {
                if ($scope.notaFiscal.declaracaoPrestacaoServico.itens) {
                    for (var i = 0; i < $scope.notaFiscal.declaracaoPrestacaoServico.itens.length; i++) {
                        $scope.notaFiscal.declaracaoPrestacaoServico.itens[i].aliquotaServico = $scope.notaFiscal.aliquotaServico;
                    }
                }
                if ($scope.validarCamposObrigatorios()) {
                    $scope.notaFiscal.declaracaoPrestacaoServico.situacao = 'EMITIDA';
                    NotaFiscal.save($scope.notaFiscal, onSaveFinished, function (error) {
                        Notificacao.error("Erro", "Erro ao emitir a Nfs-e " + error.data.error + ". Por favor entre em contato com o suporte.");
                    });
                }
            };

            $scope.openCompetencia = function ($event) {
                $scope.status.openedCompetencia = true;
            };

            $scope.status = {openedCompetencia: false};

            $scope.clear = function () {
            };

            $scope.getSomaDescontosServico = function () {
                if ($scope.servico) {
                    return $scope.servico.descontosCondicionados + $scope.servico.descontosIncondicionados + $scope.servico.deducoes;
                }
            };

            $scope.calculaValoresServico = function (servico) {
                servico.total = servico.valorServico * servico.quantidade
                    - (servico.descontosIncondicionados && servico.descontosIncondicionados > 0 ?
                        servico.descontosIncondicionados : 0);
                servico.baseCalculo = servico.total;
                if (servico.deducoes > 0) {
                    servico.baseCalculo = servico.baseCalculo - servico.deducoes;
                }
                servico.iss = servico.baseCalculo * Util.roundToX($scope.notaFiscal.aliquotaServico / 100, 8);
                servico.total = Util.roundTo2(servico.total);
                servico.baseCalculo = Util.roundTo2(servico.baseCalculo);
                servico.iss = Util.roundTo2(servico.iss);
            };

            $scope.clearServico = function () {
                $scope.servico = {
                    baseCalculo: 0.0,
                    valorServico: 0.0,
                    quantidade: 1,
                    iss: 0.0,
                    descontosCondicionados: 0.0,
                    descontosIncondicionados: 0.0,
                    deducoes: 0.0,
                    cnae: $scope.notaFiscal.cnae,
                    servico: $scope.notaFiscal.servico,
                    aliquotaServico: $scope.notaFiscal.aliquotaServico,
                    prestadoNoPais: $scope.notaFiscal.prestadoNoPais,
                    municipio: $scope.notaFiscal.municipio,
                    pais: $scope.notaFiscal.pais,
                    nomeServico: $scope.notaFiscal.nomeServico,
                    deducao: false
                };
            };

            $scope.clearCnaeServicoSelecionado = function () {
                $scope.codigoServico = null;
                $scope.notaFiscal.servico = null;
                $scope.codigoCnae = null;
                $scope.notaFiscal.cnae = null;
                $scope.notaFiscal.declaracaoPrestacaoServico.naturezaOperacao = null;
            };


            $scope.validarAddServico = function () {
                $scope.mensagemCamposObrigatorios = [];
                if (!$scope.servico.nomeServico) {
                    $scope.mensagemCamposObrigatorios.push("O campo serviço deve ser informado.");
                }
                if (!$scope.servico.descricao) {
                    $scope.mensagemCamposObrigatorios.push("O campo descrição do serviço deve ser informado.");
                }
                if ($scope.getSomaDescontosServico() > $scope.servico.total) {
                    $scope.mensagemCamposObrigatorios.push("Os valores de desconto não podem ser maiores que o valor total dos serviços.");
                }
                if (!$scope.servico.valorServico || $scope.servico.valorServico === 0) {
                    $scope.mensagemCamposObrigatorios.push("O campo valor do serviço deve ser maior que zero.");
                }
                if ($scope.servico.deducao && $scope.configuracao.validarDadosDeducaoNfse) {
                    if (!$scope.servico.tipoDeducao) {
                        $scope.mensagemCamposObrigatorios.push("O campo tipo de dedução deve ser informado");
                    }
                    if (!$scope.servico.tipoOperacao) {
                        $scope.mensagemCamposObrigatorios.push("O campo tipo de operação deve ser informado");
                    }
                    if (!$scope.servico.numeroDocumentoFiscal) {
                        $scope.mensagemCamposObrigatorios.push("O campo número do documento fiscal deve ser informado");
                    }
                    if (!$scope.servico.cpfCnpjDeducao) {
                        $scope.mensagemCamposObrigatorios.push("O campo CPF/CNPJ deve ser informado");
                    }
                    if (!$scope.servico.cpfCnpjDeducao) {
                        $scope.mensagemCamposObrigatorios.push("O campo CPF/CNPJ deve ser informado");
                    }
                }
                if ($scope.mensagemCamposObrigatorios.length > 0) {
                    Notificacao.camposObrigatorios($scope.mensagemCamposObrigatorios, "warning");
                    return false;
                }
                return true;
            };


            $scope.continuarServico = function () {
                if ($scope.mostraFormServicos) {
                    $scope.addServico(true);
                } else {
                    $scope.proximoPasso();
                }
            };

            $scope.novoServico = function () {
                if ($scope.mostraFormServicos) {
                    $scope.addServico(false);
                } else {
                    $scope.mostraFormServicos = true
                }
            };

            $scope.addServico = function (continua) {
                if ($scope.validarAddServico()) {
                    if ($scope.servico.deducao) {
                        $scope.servico.deducoes = $scope.servico.total;
                    }
                    if (!$scope.notaFiscal.declaracaoPrestacaoServico.itens) {
                        $scope.notaFiscal.declaracaoPrestacaoServico.itens = [];
                    }
                    $scope.notaFiscal.declaracaoPrestacaoServico.itens.push($scope.servico);
                    $scope.clearServico();
                    if (continua) {
                        $scope.mostraFormServicos = !$scope.mostraFormServicos;
                        $scope.proximoPasso();
                    }
                }

            };

            function isFixoOuEstimado() {
                return ($scope.prestador.enquadramentoFiscal.regimeTributario === "ISS_FIXO_PESSOA_JURIDICA"
                    || $scope.prestador.enquadramentoFiscal.regimeTributario === "ISS_FIXO_PESSOA_FISICA"
                    || $scope.prestador.enquadramentoFiscal.regimeTributario === "ESTIMATIVA");
            }

            $scope.validarAliquotaNota = function () {
                if (!$scope.notaFiscal.servico) {
                    $scope.bloqueiaAliquota = false;
                    return
                }

                $scope.bloqueiaAliquota = false;

                if (($scope.exigibilidadeNaoIncide() &&
                    !($scope.prestador.enquadramentoFiscal.regimeTributario === "LUCRO_PRESUMIDO" ||
                        $scope.prestador.enquadramentoFiscal.regimeTributario === "LUCRO_REAL" ||
                        $scope.prestador.enquadramentoFiscal.regimeTributario === "SEM_REGIME_FISCAL"))
                    || $scope.prestador.enquadramentoFiscal.regimeTributario === "MICROEMPRESARIO_INDIVIDUAL"
                    || (($scope.temExigibilidade() || $scope.exigibilidadeSuspensa())
                        && isFixoOuEstimado())) {
                    $scope.bloqueiaAliquota = true;
                    $scope.notaFiscal.aliquotaServico = 0;
                    return;
                }

                if (!$scope.isPrestadorSimplesNacional()
                    && !$scope.notaFiscal.servico.vetadoLC1162003
                    && $scope.notaFiscal.servico.aliquota &&
                    $scope.notaFiscal.municipio.id === $scope.municipio.id) {
                    $scope.bloqueiaAliquota = true;
                    $scope.notaFiscal.aliquotaServico = $scope.notaFiscal.servico.aliquota;
                }

                if ($scope.isPrestadorSimplesNacional() && !$scope.isMei() && (!$scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa
                    || !$scope.notaFiscal.prestador.rbt12)) {
                    $scope.bloqueiaAliquota = true;
                    $scope.notaFiscal.aliquotaServico = 0;
                    return;
                }

                if ($scope.isPrestadorSimplesNacional() && !$scope.isMei() && $scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa) {
                    $scope.bloqueiaAliquota = true;
                    $scope.calcularAliquotaServicoSNA();
                    return;
                }

                if ((!$scope.notaFiscal.aliquotaServico || $scope.notaFiscal.aliquotaServico <= 0) &&
                    !($scope.prestador.enquadramentoFiscal.regimeTributario === "LUCRO_PRESUMIDO" ||
                        $scope.prestador.enquadramentoFiscal.regimeTributario === "LUCRO_REAL" ||
                        $scope.prestador.enquadramentoFiscal.regimeTributario === "SEM_REGIME_FISCAL")) {
                    $scope.bloqueiaAliquota = false;
                    SweetAlert.error("Atenção", "Não foi possível encontrar alíquota.");
                }
            };


            $scope.continuarParaResumo = function () {
                if ($scope.isPrestadorSimplesNacional() && !$scope.isMei() && (!$scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa
                    || !$scope.notaFiscal.prestador.rbt12)) {
                    $scope.bloqueiaAliquota = true;
                    $scope.notaFiscal.aliquotaServico = 0;

                    SweetAlert.swal({
                            title: "Atenção",
                            text: "Para continuar é necessário informar o  ANEXO III DA LEI COMPLEMENTAR Nº 123 e o RBT12",
                            type: "error",
                            showCancelButton: false,
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: "Continuar",
                            closeOnConfirm: false,
                            closeOnCancel: false
                        },
                        function () {
                            SweetAlert.close();
                            $scope.alterarAliquotaSimples();
                        });
                    return;
                }
                if ($scope.notaFiscal.retencoesFederais > $scope.notaFiscal.declaracaoPrestacaoServico.totalServicos) {
                    SweetAlert.error("Atenção", "O valor total das retenções (" + $scope.notaFiscal.retencoesFederais + ") não pode ser superior ao valo total dos serviços (" + $scope.notaFiscal.declaracaoPrestacaoServico.totalServicos + ")");
                    return;
                }
                if (!$scope.isMei() && !isFixoOuEstimado() &&
                    !$scope.notaFiscal.servico.vetadoLC1162003 &&
                    !$scope.notaFiscal.aliquotaServico && !$scope.exigibilidadeNaoIncide()) {
                    SweetAlert.error("Atenção", "A Alíquota do ISS deve ser informada");
                    return;
                }
                if ($scope.notaFiscal.aliquotaServico && $scope.notaFiscal.aliquotaServico != 0 &&
                    ($scope.notaFiscal.aliquotaServico < 2 || $scope.notaFiscal.aliquotaServico > 5)) {
                    SweetAlert.error("Atenção", "Alíquota do ISS deve ser entre 2% e 5%");
                    return;
                }
                $scope.calculaValoresDaNota(false);
                $scope.proximoPasso();
            };

            $scope.calculaValoresDaNota = function (calcularRetencoes) {
                $scope.validarAliquotaNota();

                $scope.notaFiscal.declaracaoPrestacaoServico.totalServicos = 0.0;
                $scope.notaFiscal.declaracaoPrestacaoServico.baseCalculo = 0.0;
                $scope.notaFiscal.declaracaoPrestacaoServico.issCalculado = 0.0;
                $scope.notaFiscal.declaracaoPrestacaoServico.deducoesLegais = 0.0;
                $scope.notaFiscal.declaracaoPrestacaoServico.descontosIncondicionais = 0.0;
                $scope.notaFiscal.declaracaoPrestacaoServico.descontosCondicionais = 0.0;
                $scope.notaFiscal.declaracaoPrestacaoServico.issPagar = 0.0;
                $scope.notaFiscal.declaracaoPrestacaoServico.valorLiquido = 0.0;

                if ($scope.notaFiscal.declaracaoPrestacaoServico.itens) {
                    angular.forEach($scope.notaFiscal.declaracaoPrestacaoServico.itens, function (servico) {
                        $scope.calculaValoresServico(servico);
                        $scope.notaFiscal.declaracaoPrestacaoServico.totalServicos = Number($scope.notaFiscal.declaracaoPrestacaoServico.totalServicos) + Number(servico.total);
                        $scope.notaFiscal.declaracaoPrestacaoServico.baseCalculo = Number($scope.notaFiscal.declaracaoPrestacaoServico.baseCalculo) + Number(servico.baseCalculo);
                        $scope.notaFiscal.declaracaoPrestacaoServico.issCalculado = Number($scope.notaFiscal.declaracaoPrestacaoServico.issCalculado) + Number(servico.iss);
                        $scope.notaFiscal.declaracaoPrestacaoServico.deducoesLegais = Number($scope.notaFiscal.declaracaoPrestacaoServico.deducoesLegais) + Number(servico.deducoes);
                        $scope.notaFiscal.declaracaoPrestacaoServico.descontosIncondicionais = Number($scope.notaFiscal.declaracaoPrestacaoServico.descontosIncondicionais) + Number(servico.descontosIncondicionados);
                        $scope.notaFiscal.declaracaoPrestacaoServico.descontosCondicionais = Number($scope.notaFiscal.declaracaoPrestacaoServico.descontosCondicionais) + Number(servico.descontosCondicionados);
                    });


                    if (calcularRetencoes) {
                        if ($scope.isPrestadorSimplesNacional()) {
                            $scope.calcularRetencoesFederais($scope.notaFiscal.declaracaoPrestacaoServico.baseCalculo);
                        } else {
                            $scope.criarRetencoesFederais($scope.notaFiscal.declaracaoPrestacaoServico.baseCalculo);
                        }
                    }

                    $scope.notaFiscal.declaracaoPrestacaoServico.retencoesFederais = getTotalRetencoesFederais();
                    $scope.notaFiscal.aliquotaRetencoesFederais = getTotalAliquotaRetencoesFederais();

                    var valorRetido = getTotalRetencoesFederaisRetidas();
                    if ($scope.notaFiscal.declaracaoPrestacaoServico.issRetido) {
                        valorRetido = valorRetido + $scope.notaFiscal.declaracaoPrestacaoServico.issCalculado;
                    }
                    if ($scope.notaFiscal.declaracaoPrestacaoServico.naturezaOperacao === 'TRIBUTACAO_MUNICIPAL' &&
                        !$scope.notaFiscal.declaracaoPrestacaoServico.issRetido &&
                        !$scope.isPrestadorSimplesNacional()) {
                        $scope.notaFiscal.declaracaoPrestacaoServico.issPagar = $scope.notaFiscal.declaracaoPrestacaoServico.issCalculado;
                    }
                    $scope.notaFiscal.declaracaoPrestacaoServico.valorLiquido = $scope.notaFiscal.declaracaoPrestacaoServico.totalServicos - valorRetido;
                }

                $scope.notaFiscal.totalServicos = Util.roundTo2($scope.notaFiscal.totalServicos);
                $scope.notaFiscal.baseCalculo = Util.roundTo2($scope.notaFiscal.baseCalculo);
                $scope.notaFiscal.issCalculado = Util.roundTo2($scope.notaFiscal.issCalculado);
                $scope.notaFiscal.deducoesLegais = Util.roundTo2($scope.notaFiscal.deducoesLegais);
                $scope.notaFiscal.descontosIncondicionais = Util.roundTo2($scope.notaFiscal.descontosIncondicionais);
                $scope.notaFiscal.descontosCondicionais = Util.roundTo2($scope.notaFiscal.descontosCondicionais);
                $scope.notaFiscal.issPagar = Util.roundTo2($scope.notaFiscal.issPagar);
                $scope.notaFiscal.valorLiquido = Util.roundTo2($scope.notaFiscal.valorLiquido);
            };

            $scope.criarRetencoesFederais = function (valor) {
                if (getTotalRetencoesFederais()) {
                    return;
                }
                var tributosFederais = {};
                PrestadorServicos.getTributosFederais({prestadorId: $scope.prestador.id},
                    function (result) {
                        tributosFederais = result;
                        tributosFederais.percentualPis = tributosFederais.pis ? tributosFederais.pis : 0;
                        tributosFederais.pis = tributosFederais.percentualPis ? ((tributosFederais.percentualPis / 100) * valor) : 0;
                        tributosFederais.percentualCofins = tributosFederais.cofins ? tributosFederais.cofins : 0;
                        tributosFederais.cofins = tributosFederais.percentualCofins ? ((tributosFederais.percentualCofins / 100) * valor) : 0;
                        tributosFederais.percentualInss = tributosFederais.inss ? tributosFederais.inss : 0;
                        tributosFederais.inss = tributosFederais.percentualInss ? ((tributosFederais.percentualInss / 100) * valor) : 0;
                        tributosFederais.percentualIrrf = tributosFederais.irrf ? tributosFederais.irrf : 0;
                        tributosFederais.irrf = tributosFederais.percentualIrrf ? ((tributosFederais.percentualIrrf / 100) * valor) : 0;
                        tributosFederais.percentualCsll = tributosFederais.csll ? tributosFederais.csll : 0;
                        tributosFederais.csll = tributosFederais.percentualCsll ? ((tributosFederais.percentualCsll / 100) * valor) : 0;
                        tributosFederais.percentualCpp = tributosFederais.cpp ? tributosFederais.cpp : 0;
                        tributosFederais.cpp = tributosFederais.percentualCpp ? ((tributosFederais.percentualCpp / 100) * valor) : 0;
                        tributosFederais.percentualInss = tributosFederais.inss ? tributosFederais.inss : 0;
                        tributosFederais.inss = tributosFederais.percentualInss ? ((tributosFederais.percentualInss / 100) * valor) : 0;
                        tributosFederais.percentualOutrasRetencoes = tributosFederais.outrasRetencoes ? tributosFederais.outrasRetencoes : 0;
                        tributosFederais.outrasRetencoes = tributosFederais.percentualOutrasRetencoes ? ((tributosFederais.percentualOutrasRetencoes / 100) * valor) : 0;
                        $scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais = tributosFederais;
                    });
            };

            $scope.calcularValoresPorAliquota = function (aliquota, valor) {
                $scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais[valor]
                    = ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais[aliquota] / 100)
                    * $scope.notaFiscal.declaracaoPrestacaoServico.totalServicos;
                atualizarRentencaoFederal();
            };

            $scope.calcularAliquotaPorValor = function (valor, aliquota) {
                $scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais[aliquota]
                    = ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais[valor] * 100)
                    / $scope.notaFiscal.declaracaoPrestacaoServico.totalServicos;
                atualizarRentencaoFederal();
            };

            function atualizarRentencaoFederal() {
                $scope.notaFiscal.retencoesFederais = getTotalRetencoesFederais();
            }

            $scope.calcularRetencoesFederais = function (valor) {
                if (!$scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais) {
                    $scope.criarRetencoesFederais(valor);
                }

                tributosFederais = $scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais;

                if ($scope.notaFiscal.declaracaoPrestacaoServico.totalServicos && $scope.notaFiscal.declaracaoPrestacaoServico.totalServicos > 0 && $scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa) {

                    var tributosFederais = $scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais;

                    tributosFederais.percentualPis = 0;
                    tributosFederais.pis = 0;
                    if ($scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa.pisPasep) {
                        tributosFederais.percentualPis = ($scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa.pisPasep / 100) * $scope.aliquotaEfetiva;
                        if ($scope.aliquotaServicoExcedente > 0) {
                            tributosFederais.percentualPis = tributosFederais.percentualPis + (($scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa.pisPasep / 100) * $scope.aliquotaServicoExcedente);
                        }
                        tributosFederais.percentualPis = tributosFederais.percentualPis * 100;
                        tributosFederais.percentualPis = parseFloat(tributosFederais.percentualPis).toFixed(2);
                        tributosFederais.pis = (tributosFederais.percentualPis / 100) * $scope.notaFiscal.declaracaoPrestacaoServico.totalServicos;
                    }

                    tributosFederais.percentualCofins = 0;
                    tributosFederais.cofins = 0;
                    if ($scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa.cofins) {
                        tributosFederais.percentualCofins = ($scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa.cofins / 100) * $scope.aliquotaEfetiva;
                        if ($scope.aliquotaServicoExcedente > 0) {
                            tributosFederais.percentualCofins = tributosFederais.percentualCofins + (($scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa.cofins / 100) * $scope.aliquotaServicoExcedente);
                        }
                        tributosFederais.percentualCofins = tributosFederais.percentualCofins * 100;
                        tributosFederais.percentualCofins = parseFloat(tributosFederais.percentualCofins).toFixed(2);
                        tributosFederais.cofins = (tributosFederais.percentualCofins / 100) * $scope.notaFiscal.declaracaoPrestacaoServico.totalServicos;
                    }

                    tributosFederais.percentualIrpj = 0;
                    tributosFederais.irpj = 0;
                    if ($scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa.irpj) {
                        tributosFederais.percentualIrrf = ($scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa.irpj / 100) * $scope.aliquotaEfetiva;
                        if ($scope.aliquotaServicoExcedente > 0) {
                            tributosFederais.percentualIrrf = tributosFederais.percentualIrrf +
                                (($scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006.irpjExcedente / 100) * $scope.aliquotaServicoExcedente);
                        }
                        tributosFederais.percentualIrrf = tributosFederais.percentualIrrf * 100;
                        tributosFederais.percentualIrrf = parseFloat(tributosFederais.percentualIrrf).toFixed(2);
                        tributosFederais.irrf = (tributosFederais.percentualIrrf / 100) * $scope.notaFiscal.declaracaoPrestacaoServico.totalServicos;
                    }

                    tributosFederais.percentualCsll = 0;
                    tributosFederais.csll = 0;
                    if ($scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa.csll) {
                        tributosFederais.percentualCsll = ($scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa.csll / 100) * $scope.aliquotaEfetiva;
                        if ($scope.aliquotaServicoExcedente > 0) {
                            tributosFederais.percentualCsll = tributosFederais.percentualCsll +
                                (($scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006.csllExcedente / 100) * $scope.aliquotaServicoExcedente);
                        }
                        tributosFederais.percentualCsll = tributosFederais.percentualCsll * 100;
                        tributosFederais.percentualCsll = parseFloat(tributosFederais.percentualCsll).toFixed(2);
                        tributosFederais.csll = (tributosFederais.percentualCsll / 100) * $scope.notaFiscal.declaracaoPrestacaoServico.totalServicos;
                    }

                    tributosFederais.percentualCpp = 0;
                    tributosFederais.cpp = 0;
                    if ($scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa.cpp) {
                        tributosFederais.percentualCpp = ($scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa.cpp / 100) * $scope.aliquotaEfetiva;
                        if ($scope.aliquotaServicoExcedente > 0) {
                            tributosFederais.percentualCpp = tributosFederais.percentualCpp +
                                (($scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006.cppExcedente / 100) * $scope.aliquotaServicoExcedente);
                        }
                        tributosFederais.percentualCpp = tributosFederais.percentualCpp * 100;
                        tributosFederais.percentualCpp = parseFloat(tributosFederais.percentualCpp).toFixed(2);
                        tributosFederais.cpp = (tributosFederais.percentualCpp / 100) * $scope.notaFiscal.declaracaoPrestacaoServico.totalServicos;
                    }

                    tributosFederais.percentualInss = 0;
                    tributosFederais.inss = 0;
                    if ($scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa.inss) {
                        tributosFederais.percentualInss = ($scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa.inss / 100) * $scope.aliquotaEfetiva;
                        if ($scope.aliquotaServicoExcedente > 0) {
                            tributosFederais.percentualInss = tributosFederais.percentualInss +
                                (($scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006.inssExcedente / 100) * $scope.aliquotaServicoExcedente);
                        }
                        tributosFederais.percentualInss = tributosFederais.percentualInss * 100;
                        tributosFederais.percentualInss = parseFloat(tributosFederais.percentualInss).toFixed(2);
                        tributosFederais.inss = (tributosFederais.percentualInss / 100) * $scope.notaFiscal.declaracaoPrestacaoServico.totalServicos;
                    }

                    var percentualOutrasRetencoes = 0;

                    if ($scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa.icms &&
                        $scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa.icms > 0) {
                        percentualOutrasRetencoes = percentualOutrasRetencoes + $scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa.icms;
                    }

                    if ($scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa.ipi &&
                        $scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa.ipi > 0) {
                        percentualOutrasRetencoes = percentualOutrasRetencoes + $scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa.ipi;
                    }

                    if (percentualOutrasRetencoes > 0) {
                        tributosFederais.percentualOutrasRetencoes = (percentualOutrasRetencoes / 100) * $scope.aliquotaEfetiva;
                        tributosFederais.outrasRetencoes =
                            (tributosFederais.percentualOutrasRetencoes) * $scope.notaFiscal.declaracaoPrestacaoServico.totalServicos;
                        tributosFederais.percentualOutrasRetencoes = tributosFederais.percentualOutrasRetencoes * 100;
                    }

                }
            };

            function getTotalRetencoesFederais() {
                var total = 0;
                if ($scope.notaFiscal
                    && $scope.notaFiscal.declaracaoPrestacaoServico
                    && $scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais) {

                    if ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.pis) {
                        total = total + ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.pis);
                    }
                    if ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.cofins) {
                        total = total + ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.cofins);
                    }
                    if ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.inss) {
                        total = total + ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.inss);
                    }
                    if ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.irrf) {
                        total = total + ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.irrf);
                    }
                    if ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.cpp) {
                        total = total + ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.cpp);
                    }
                    if ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.csll) {
                        total = total + ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.csll);
                    }
                    if ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.outrasRetencoes) {
                        total = total + ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.outrasRetencoes);
                    }
                }
                return total;
            }

            function getTotalRetencoesFederaisRetidas() {
                var total = 0;
                if ($scope.notaFiscal
                    && $scope.notaFiscal.declaracaoPrestacaoServico
                    && $scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais) {

                    if ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.pis && $scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.retencaoPis) {
                        total = total + ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.pis);
                    }
                    if ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.cofins && $scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.retencaoCofins) {
                        total = total + ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.cofins);
                    }
                    if ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.inss && $scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.retencaoInss) {
                        total = total + ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.inss);
                    }
                    if ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.irrf && $scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.retencaoIrrf) {
                        total = total + ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.irrf);
                    }
                    if ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.cpp && $scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.retencaoCpp) {
                        total = total + ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.cpp);
                    }
                    if ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.csll && $scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.retencaoCsll) {
                        total = total + ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.csll);
                    }
                    if ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.outrasRetencoes && $scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.retencaoOutrasRetencoes) {
                        total = total + ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.outrasRetencoes);
                    }
                }
                return total;
            }

            function getTotalAliquotaRetencoesFederais() {
                var total = 0;
                if ($scope.notaFiscal
                    && $scope.notaFiscal.declaracaoPrestacaoServico
                    && $scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais) {

                    if ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.percentualPis) {
                        total = total + Number($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.percentualPis);
                    }
                    if ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.percentualCofins) {
                        total = total + Number($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.percentualCofins);
                    }
                    if ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.percentualInss) {
                        total = total + Number($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.percentualInss);
                    }
                    if ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.percentualIrrf) {
                        total = total + Number($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.percentualIrrf);
                    }
                    if ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.percentualCpp) {
                        total = total + Number($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.percentualCpp);
                    }
                    if ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.percentualCsll) {
                        total = total + Number($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.percentualCsll);
                    }
                    if ($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.percentualOutrasRetencoes) {
                        total = total + Number($scope.notaFiscal.declaracaoPrestacaoServico.tributosFederais.percentualOutrasRetencoes);
                    }
                }
                return total;
            }

            $scope.removeServico = function (index) {
                $scope.notaFiscal.declaracaoPrestacaoServico.itens.splice(index, 1);
            };

            $scope.editaServico = function (index) {
                $scope.servico = $scope.notaFiscal.declaracaoPrestacaoServico.itens[index];
                $scope.removeServico(index);
                $scope.mostraFormServicos = true;
            };

            $scope.selecionouServico = function () {
                $scope.bloqueiaAliquota = true;
                $scope.notaFiscal.declaracaoPrestacaoServico.construcaoCivil = null;
                $scope.art = null;
                if ($scope.notaFiscal.servico) {
                    $scope.notaFiscal.prestadoNoPais = true;
                    $scope.notaFiscal.municipio = $scope.municipio;
                    $scope.codigoServico = $scope.notaFiscal.servico.codigo;
                    $scope.notaFiscal.nomeServico = $scope.notaFiscal.servico.descricao;
                    $scope.notaFiscal.aliquotaServico = 0;
                    $scope.verificarExigibilidadeIss();
                    $scope.verificarRetencaoIss();
                }
            };

            $scope.loadServico = function () {
                if ($scope.notaFiscal.cnae) {
                    $scope.codigoCnae = $scope.notaFiscal.cnae.codigo;
                    $scope.servicos = Servico.getPorCnaePrestador({
                        cnaeId: $scope.notaFiscal.cnae.id,
                        prestadorId: $scope.prestador.id
                    });
                    angular.element('[id="field_codigoServico"]').focus();
                } else {
                    $scope.servicos = [];
                }
            };


            $scope.searchServico = function () {
                var modalInstance = $modal.open({
                    templateUrl: 'app/entities/prestadorServicos/servicoPrestador-search.html',
                    controller: 'ServicoPrestadorSearchController',
                    size: 'lg'
                });
                modalInstance.result.then(function (result) {
                    $scope.servico.servico = result;
                    $scope.selecionouServico();
                }, function () {
                });
            };

            $scope.validarCamposObrigatorios = function () {
                $scope.mensagemCamposObrigatorios = [];
                if ($scope.notaFiscal.declaracaoPrestacaoServico.issRetido === true && $scope.notaFiscal.declaracaoPrestacaoServico.responsavelRetencao === undefined) {
                    $scope.mensagemCamposObrigatorios.push("O campo Responsável pela Retenção é obrigatório.");
                }

                if ($scope.notaFiscal.declaracaoPrestacaoServico.modalidade == 'IDENTIFICADO') {
                    if ($scope.notaFiscal.tomador.dadosPessoais.cpfCnpj === null) {
                        $scope.mensagemCamposObrigatorios.push("O campo CPF ou CNPJ do Tomador de Serviço é obrigatório.");
                    }
                    if ($scope.notaFiscal.tomador.dadosPessoais.nomeRazaoSocial === null) {
                        $scope.mensagemCamposObrigatorios.push("O campo Nome ou Razão Social é obrigatório.");
                    }
                }
                if ($scope.notaFiscal.declaracaoPrestacaoServico.itens.length === 0) {
                    $scope.mensagemCamposObrigatorios.push("É necessário adicionar ao menos um serviço para a Nota Fiscal.");
                }
                if ($scope.notaFiscal.declaracaoPrestacaoServico.totalServicos <= 0) {
                    $scope.mensagemCamposObrigatorios.push("Os valores totais dos serviços devem ser maiores que ZERO.");
                }
                if ($scope.notaFiscal.declaracaoPrestacaoServico.deducoesLegais != $scope.notaFiscal.declaracaoPrestacaoServico.totalServicos && $scope.notaFiscal.declaracaoPrestacaoServico.baseCalculo <= 0) {
                    $scope.mensagemCamposObrigatorios.push("Os valores totais da base de cálculo deve ser maiore que ZERO.");
                }
                if ($scope.notaFiscal.declaracaoPrestacaoServico.valorLiquido <= 0) {
                    $scope.mensagemCamposObrigatorios.push("O valor liquido deve ser maior que ZERO.");
                }
                if ($scope.notaFiscal.cancelamentoSubstituicao &&
                    !$scope.notaFiscal.cancelamentoSubstituicao.motivoCancelamento) {
                    $scope.mensagemCamposObrigatorios.push("O Motivo de Cancelamento é obrigatório.");
                }
                if ($scope.mensagemCamposObrigatorios.length > 0) {
                    Notificacao.camposObrigatorios($scope.mensagemCamposObrigatorios, "warning");
                    return false;
                } else {
                    return true;
                }
            };


            $scope.loadEnderecoByCEP = function (cep) {
                if (cep) {
                    CEP.getByCep({cep: cep}, function (endereco) {
                        if (endereco.municipio) {
                            $scope.notaFiscal.tomador.dadosPessoais.cep = endereco.cep;
                            $scope.notaFiscal.tomador.dadosPessoais.municipio = endereco.municipio;
                            $scope.notaFiscal.tomador.dadosPessoais.logradouro = endereco.logradouro;
                            $scope.notaFiscal.tomador.dadosPessoais.bairro = endereco.bairro;
                        }
                    });
                }
            };

            $scope.selecionarCnaePorCodigo = function () {
                for (var i = 0; i < $scope.cnaes.length; i++) {
                    if ($scope.cnaes[i].codigo.replace(/^0+/, '') === $scope.codigoCnae.replace(/^0+/, '')) {
                        $scope.notaFiscal.cnae = $scope.cnaes[i];
                        $scope.loadServico();
                        return;
                    }
                }
                $scope.notaFiscal.cnae = {}
            };

            $scope.selecionarServicoPorCodigo = function () {
                for (var i = 0; i < $scope.servicos.length; i++) {
                    if ($scope.servicos[i].codigo.replace(/^0+/, '') === $scope.codigoServico.replace(/^0+/, '')) {
                        $scope.notaFiscal.servico = $scope.servicos[i];
                        $scope.selecionouServico();
                        return;
                    }
                }
                $scope.notaFiscal.servico = {}
            };


            $scope.loadPaisByCodigo = function (codigo, donoDoServico) {
                if (codigo) {
                    Pais.getByCodigo({codigo: codigo}, function (pais) {
                        if (pais.id) {
                            donoDoServico.pais = pais;
                            donoDoServico.municipio = {};
                        } else {
                            Notificacao.warn("Atenção", "Não foi encontrado nenhum País com o código " + codigo);
                            donoDoServico.pais = {};
                        }
                    });
                }
            };

            $scope.searchMunicipio = function (caraQueTemMunicipio) {
                var modalInstance = $modal.open({
                    templateUrl: 'app/entities/municipio/municipio-search.html',
                    controller: 'MunicipioSearchController',
                    size: 'lg'
                });
                modalInstance.result.then(function (municipio) {
                    caraQueTemMunicipio.municipio = municipio;
                    caraQueTemMunicipio.pais = {};
                    $scope.verificarExigibilidadeIss();
                    $scope.verificarRetencaoIss();
                }, function () {
                });
            };

            $scope.searchPais = function (donoDoServico) {
                var modalInstance = $modal.open({
                    templateUrl: 'app/entities/pais/pais-search.html',
                    controller: 'PaisSearchController',
                    size: 'lg'
                });
                modalInstance.result.then(function (pais) {
                    donoDoServico.pais = pais;
                    donoDoServico.municipio = {};
                }, function () {
                });
            };

            $scope.isFisica = function () {
                return $scope.notaFiscal
                    &&
                    (
                        ($scope.notaFiscal.declaracaoPrestacaoServico.modalidade == 'SEM_CPF') ||
                        ($scope.notaFiscal.declaracaoPrestacaoServico
                            && $scope.notaFiscal.tomador
                            && $scope.notaFiscal.tomador.dadosPessoais
                            && $scope.notaFiscal.tomador.dadosPessoais.cpfCnpj
                            && $scope.notaFiscal.tomador.dadosPessoais.cpfCnpj.replace(/[^\w\s]/gi, '').length == 11)
                    )
            };

            $scope.mostrarDadosServico = function () {
                return $scope.notaFiscal &&
                    $scope.notaFiscal.declaracaoPrestacaoServico.modalidade &&
                    (($scope.notaFiscal.declaracaoPrestacaoServico.modalidade === 'IDENTIFICADO' && $scope.temCpfOuCnpj() && !$scope.cpfDigitadoIgualPrestador())
                        || $scope.notaFiscal.declaracaoPrestacaoServico.modalidade !== 'IDENTIFICADO')
            }

            $scope.mostrarDadosGerais = function () {
                return $scope.notaFiscal &&
                    $scope.notaFiscal.declaracaoPrestacaoServico.itens &&
                    $scope.notaFiscal.declaracaoPrestacaoServico.itens.length > 0;
            }

            $scope.temCpfOuCnpj = function () {
                return $scope.notaFiscal
                    && $scope.notaFiscal.declaracaoPrestacaoServico
                    && $scope.notaFiscal.tomador
                    && $scope.notaFiscal.tomador.dadosPessoais
                    && $scope.notaFiscal.tomador.dadosPessoais.cpfCnpj;
            }

            $scope.cpfDigitadoIgualPrestador = function () {
                return $scope.temCpfOuCnpj()
                    && $scope.cpfCnpjDoPrestador
                    && $scope.notaFiscal.tomador.dadosPessoais.cpfCnpj.replace(/[^\w\s]/gi, '')
                    === $scope.cpfCnpjDoPrestador.replace(/[^\w\s]/gi, '');
            }

            $scope.temExigibilidade = function () {
                return $scope.notaFiscal
                    && $scope.notaFiscal.declaracaoPrestacaoServico
                    && $scope.notaFiscal.declaracaoPrestacaoServico.naturezaOperacao
                    && $scope.notaFiscal.declaracaoPrestacaoServico.naturezaOperacao === "TRIBUTACAO_MUNICIPAL";
            }

            $scope.exigibilidadeSuspensa = function () {
                return $scope.notaFiscal
                    && $scope.notaFiscal.declaracaoPrestacaoServico
                    && $scope.notaFiscal.declaracaoPrestacaoServico.naturezaOperacao
                    && ($scope.notaFiscal.declaracaoPrestacaoServico.naturezaOperacao === "EXIGIBILIDADE_SUSPENSA_DECISAO_JUDICIAL"
                        || $scope.notaFiscal.declaracaoPrestacaoServico.naturezaOperacao === "EXIGIBILIDADE_SUSPENSA_PROCESSO_ADMINISTRATIVO");
            };

            $scope.exigibilidadeNaoIncide = function () {
                return $scope.notaFiscal
                    && $scope.notaFiscal.declaracaoPrestacaoServico
                    && $scope.notaFiscal.declaracaoPrestacaoServico.naturezaOperacao
                    && ($scope.notaFiscal.declaracaoPrestacaoServico.naturezaOperacao === "NAO_INCIDENCIA"
                        || $scope.notaFiscal.declaracaoPrestacaoServico.naturezaOperacao === "ISENCAO"
                        || $scope.notaFiscal.declaracaoPrestacaoServico.naturezaOperacao === "IMUNIDADE"
                        || $scope.notaFiscal.declaracaoPrestacaoServico.naturezaOperacao === "EXPORTACAO"
                        || $scope.isMei());
            };

            $scope.copiarNotaPorRps = function () {
                if ($scope.notaFiscal.rps && $scope.notaFiscal.rps.numero) {
                    NotaFiscal.copyPorRps({numeroRps: $scope.notaFiscal.rps.numero}, function (data) {
                        if (data && data.rps && data.rps.numero) {
                            $scope.notaFiscal = data;
                            if ($scope.notaFiscal.rps.dataEmissao) {
                                $scope.notaFiscal.rps.dataEmissao = new Date($scope.notaFiscal.rps.dataEmissao)
                            }
                            $scope.tratarNotaFiscalCopiada();
                        }
                    });
                }
            }

            $scope.alterarAliquotaSimples = function () {
                var modalDescriminacaoServico = $modal.open({
                    templateUrl: 'app/entities/notaFiscal/aliquota-simples-anexo-lei-1232006.html',
                    controller: 'AliquotaSimplesAnesoLei1232006Controller',
                    size: 'lg',
                    resolve: {
                        prestador: function () {
                            return $scope.notaFiscal.prestador;
                        }
                    }
                });
                modalDescriminacaoServico.result.then(function (data) {
                    if (data && data.faixaSelecionada && data.rbt12) {
                        $scope.notaFiscal.prestador.rbt12 = data.rbt12;
                        $scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006 = data;
                        $scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa = data.faixaSelecionada;

                        if ($scope.notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa) {
                            $scope.calcularAliquotaServicoSNA();
                            $scope.calculaValoresDaNota(true);
                            if ($scope.notaFiscal.prestador.id) {
                                PrestadorServicos.salvarFaixaAndRbt12($scope.notaFiscal.prestador);
                            }
                        }
                    }
                });
            };

            $scope.validarDataEmissao = function () {
                if (!$scope.notaFiscal.emissao) {
                    $scope.notaFiscal.emissao = new Date();
                } else {

                    var emissaoSemHora = new Date($scope.notaFiscal.emissao.setHours(0, 0, 0, 0));
                    var ultimaEmissaoSemHora = new Date($scope.notaFiscal.ultimaEmissao.setHours(0, 0, 0, 0));

                    if (!$scope.emissaoRetroativaUltimaEmissao && emissaoSemHora < ultimaEmissaoSemHora) {
                        $scope.notaFiscal.emissao = new Date();
                        Notificacao.error('Erro', 'A Data de Emissão não pode ser inferior a última data de emissão ' + $filter('date')(ultimaEmissaoSemHora, 'dd/MM/yyyy'));
                    }
                }
                $scope.notaFiscal.declaracaoPrestacaoServico.competencia = $scope.notaFiscal.emissao;
            }

            $scope.buscarObra = function () {
                if ($scope.art) {
                    ConstrucaoCivil.buscarConstrucaoCivilByArt({art: $scope.art}, function (data) {
                        $scope.notaFiscal.declaracaoPrestacaoServico.construcaoCivil = null;
                        if (data.id) {
                            $scope.notaFiscal.declaracaoPrestacaoServico.construcaoCivil = data;
                            $scope.selecionouObra();
                        } else {
                            Notificacao.error("Erro", "Número de ART não registrada no sistema.");
                            $scope.art = "";
                            angular.element('[id="field_art"]').focus();
                        }
                    });
                }
            }

        }])
;

'use strict';

angular.module('nfseApp')
    .controller('NotaFiscalDetailController',
        function ($scope, $rootScope, $stateParams, entity, NotaFiscal) {
            $scope.notaFiscal = entity;

            NotaFiscal.getParcelasDaNota({id: $stateParams.id}, function (res) {
                $scope.parcelas = res;
            });


            $scope.load = function (id) {
                NotaFiscal.get({id: id}, function (result) {
                    $scope.notaFiscal = result;
                });
            };
            $rootScope.$on('nfseApp:notaFiscalUpdate', function (event, result) {
                $scope.notaFiscal = result;
            });
        });

'use strict';

angular.module('nfseApp')
    .factory('NotaFiscal', function ($resource, $state, $modal, DateUtils, SweetAlert, BloqueioEmissaoNfse) {

        function transformResponseList(data) {
            data = angular.fromJson(data);
            for (var i = 0; i < data.length; i++) {
                var nota = data[i];
                convertDateFromServer(nota);
            }
            return data;
        }

        function convertDateFromServer(data) {
            if (data.emissao) {
                data.emissao = DateUtils.convertLocaleDateFromServer(data.emissao);
            }
            if (data.ultimaEmissao) {
                data.ultimaEmissao = DateUtils.convertLocaleDateFromServer(data.ultimaEmissao);
            }
            if (data.declaracaoPrestacaoServico && data.declaracaoPrestacaoServico.competencia) {
                data.declaracaoPrestacaoServico.competencia =
                    DateUtils.convertLocaleDateFromServer(data.declaracaoPrestacaoServico.competencia);
            }
            if (data.rps && data.rps.dataEmissao) {
                data.rps.dataEmissao =
                    DateUtils.convertLocaleDateFromServer(data.rps.dataEmissao);
            }
        }

        function convertDateToServer(data) {
            if (data.emissao) {
                data.emissao = DateUtils.convertLocaleDateToServer(data.emissao);
            }
            if (data.ultimaEmissao) {
                data.ultimaEmissao = DateUtils.convertLocaleDateToServer(data.ultimaEmissao);
            }
            if (data.declaracaoPrestacaoServico && data.declaracaoPrestacaoServico.competencia) {
                data.declaracaoPrestacaoServico.competencia =
                    DateUtils.convertLocaleDateToServer(data.declaracaoPrestacaoServico.competencia);
            }
        }

        var resource = $resource('api/notaFiscals/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    convertDateFromServer(data);
                    return data;
                }
            },
            'getPublica': {
                url: '/api/publica/nota-fiscal/:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        convertDateFromServer(data);
                    }
                    return data;
                }
            },
            'getPublicaCartaCorrecao': {
                url: '/api/publica/carta-correcao/:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        convertDateFromServer(data);
                    }
                    return data;
                }
            },
            'buscarNotasEmCancelamento': {
                url: '/api/notaFiscals/em-cancelamento/:cpf/:cnpj',
                method: 'GET',
                isArray: true
            },
            'buscarNotasComoTomador': {
                method: 'GET',
                url: 'api/notaFiscals/notas-tomadas',
                isArray: true
            },
            'buscarNotasComoTomadorAndLote': {
                method: 'GET',
                url: 'api/notaFiscals/notas-tomadas-por-lote',
                isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    for (var i = 0; i < data.length; i++) {
                        var nota = data[i];
                        convertDateFromServer(nota);
                    }
                    return data;
                }
            },
            'buscarNotasFiscais': {
                method: 'POST',
                url: 'api/buscar-notas-fiscais',
                isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    if (data)
                        for (var i = 0; i < data.length; i++) {
                            var nota = data[i];
                            convertDateFromServer(nota);
                        }
                    return data;
                }
            },
            'buscarNotasSemDeclaracaoPorCompetencia': {
                method: 'GET',
                url: 'api/notas-sem-declaracao-por-competencia',
                isArray: true
            },
            'new': {
                method: 'GET',
                url: 'api/notaFiscals/new',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        convertDateFromServer(data);
                    }
                    return data;
                }
            },
            'newSubstituicao': {
                method: 'GET',
                url: 'api/notaFiscals/new-substituicao',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        convertDateFromServer(data);
                    }
                    return data;
                }
            },
            'cancelar': {
                method: 'POST',
                url: 'api/notaFiscals/cancelar',
                transformRequest: function (data) {
                    if (data.notaFiscal)
                        convertDateToServer(data.notaFiscal);
                    if (data.notaFiscalSubstituta)
                        convertDateToServer(data.notaFiscalSubstituta);
                    return angular.toJson(data);
                },
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'cartaCorrecao': {
                method: 'POST',
                url: 'api/notaFiscals/carta-correcao'
            },
            'submeterCancelamento': {
                method: 'POST',
                url: 'api/notaFiscals/submeter-cancelamento'
            },
            'imprimirCartaCorrecao': {
                method: 'GET',
                url: 'api/notaFiscals/carta-correcao-impressao',
                headers: {
                    accept: 'application/pdf'
                }
            },
            'buscarCartaCorrecao': {
                method: 'GET',
                isArray: true,
                url: 'api/notaFiscals/carta-correcao-por-nota/:idNotaFiscal'
            },
            'getCancelamentos': {
                method: 'GET',
                url: 'api/notaFiscals/cancelamentos/:id'
            },
            'autenticar': {
                method: 'POST',
                url: 'api/notaFiscals/autenticar',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'copy': {
                method: 'GET',
                url: 'api/notaFiscals/copy/:id',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.copiada = true;
                        convertDateFromServer(data);
                    }
                    return data;
                }
            },
            'copyPorRps': {
                method: 'GET',
                url: 'api/notaFiscals/copy-rps/:numeroRps',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getItemDeclaracaoServicoEmitidosPorPrestador': {
                method: 'GET',
                isArray: true,
                url: "api/notaFiscals/item_declaracao_emitidos"
            },
            'getTomadorPorCpfCnpj': {
                method: 'GET',
                url: "api/tomador_da_nota_por_cpfCnpj/:cpfCnpj",
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'buscarNotasNaDeclaracao': {
                method: 'GET',
                url: "api/notas-na-declaracao",
                isArray: true,
                transformResponse: transformResponseList

            },
            'getNotasNaoDeclaradas': {
                method: 'GET',
                url: "api/notas_nao_declaradas",
                isArray: true
            },
            'getNotasRetencaoNaoDeclaradas': {
                method: 'GET',
                url: "api/notas_retencao_nao_declaradas",
                isArray: true
            },
            'getEmitidasPorPrestadorMes': {
                url: "/api/nota_emita_por_prestador_mes",
                method: 'GET',
                isArray: true
            },
            'getEmitidasPorMes': {
                url: "/api/nota_emita_por_mes",
                method: 'GET',
                isArray: true
            },
            'imprime': {
                method: 'GET',
                url: "/publico/notaFiscal/imprime/:id",
                headers: {
                    accept: 'application/pdf'
                },
                responseType: 'arraybuffer',
                cache: true,
            },
            'imprimeRelatorio': {
                method: 'POST',
                url: "/api/imprimir-relatorio-notas-fiscais",
                headers: {
                    accept: 'application/pdf'
                },
                responseType: 'arraybuffer',
                cache: true,
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    convertDateToServer(data);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    convertDateToServer(data)
                    return angular.toJson(data);
                }
            },
            'enviarPorEmail': {
                url: "/api/enviar-nota-fiscal",
                method: 'PUT'
            },
            'baixarXml': {
                method: 'POST',
                url: '/api/notaFiscals/baixar-xml'
            },
            'consultarXml': {
                method: 'POST',
                url: '/api/notaFiscals/consultar-xml'
            },
            'baixarXmlNotaFiscal': {
                method: 'GET',
                url: '/api/notaFiscals/baixar-xml-nota-fiscal'
            },
            'baixarXls': {
                method: 'GET',
                url: '/api/notaFiscals/baixar-xls'
            },
            'getParcelasDaNota': {
                method: 'GET',
                url: 'api/notaFiscals/parcelas/:id',
                isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getServicosDeclaradosIssRetido': {
                method: 'GET',
                url: 'api/notaFiscals/servicos-declarados-iss-retido',
                isArray: true,
                transformResponse: transformResponseList
            },
            'porNumero': {
                method: 'GET',
                url: 'api/notaFiscal-por-numero'
            }
        });

        resource.downloadXmlNotaFiscal = function (idNotaFiscal) {
            resource.baixarXmlNotaFiscal({
                idNotaFiscal: idNotaFiscal
            }, function (result) {
                var a = document.createElement('a');
                a.href = 'data:application/xml;base64,' + result.conteudo;
                a.target = '_blank';
                a.download = 'notaFiscal' + idNotaFiscal + '.xml';
                document.body.appendChild(a);
                a.click();
            });
        };

        resource.cancelarNota = function (nota, onSucess) {
            var modalInstance = $modal.open({
                templateUrl: 'app/entities/notaFiscal/cancelamentoNotaFiscal.html',
                controller: 'CancelamentoNotaFiscalController',
                size: 'lg',
                resolve: {
                    entity: function (NotaFiscal) {
                        return NotaFiscal.get({id: nota.id}).$promise;
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('motivoCancelamento');
                        $translatePartialLoader.addPart('situacaoDeferimento');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function (notaFiscal) {
                if (notaFiscal.declaracaoPrestacaoServico.situacao === 'CANCELADA') {
                    SweetAlert.success("Operação realizada", "Nota Fiscal Cancelada!");
                } else {
                    SweetAlert.warning("Solicitação em análise", "Assim que aprovada sua solicitação o documento será cancelado!");
                }
                onSucess();
            }, function () {
            });
        };

        resource.emitirNotaFiscal = function () {
            BloqueioEmissaoNfse.buscarBloqueioPrestador({}, function (result) {
                if (result && result.id) {
                    $modal.open({
                        templateUrl: 'app/entities/bloqueio-emissao-nfse/bloqueio-emissao-nfse.html',
                        controller: 'BloqueioEmissaoNfseController',
                        keyboard: false,
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            bloqueio: function () {
                                return result;
                            }
                        }
                    });
                } else {
                    $state.go('notaFiscal.new');
                }
            });
        }

        return resource;
    })
;

'use strict';

angular.module('nfseApp')
    .factory('NotaFiscalSearch', function ($resource) {
        return $resource('api/_search/notaFiscals/:query', {}, {
            'query': {method: 'GET', isArray: true},
            'searchNotasTomador': {
                url: "/api/_search/notaFiscals/tomador/:query",
                method: 'GET',
                isArray: true
            }
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('notaFiscal', {
                parent: 'entity',
                url: '/nota-fiscal',
                data: {
                    roles: ['ROLE_CONTRIBUINTE'],
                    pageTitle: 'Nota Fiscal'
                },
                ncyBreadcrumb: {
                    label: 'Consulta de Notas Fiscais Emitidas'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/notaFiscal/notaFiscals.html',
                        controller: 'NotaFiscalController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('notaFiscal');
                        $translatePartialLoader.addPart('declaracaoPrestacaoServico');
                        $translatePartialLoader.addPart('modalidadeNota');
                        $translatePartialLoader.addPart('situacaoNota');
                        $translatePartialLoader.addPart('localExecucao');
                        $translatePartialLoader.addPart('regimeTributario');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('naturezaOperacao');
                        $translatePartialLoader.addPart('motivoCancelamento');
                        return $translate.refresh();
                    }]
                }
            })
            .state('cancelamento-nota-fiscal', {
                parent: 'notaFiscal',
                url: '/cancelamento',
                ncyBreadcrumb: {
                    label: 'Cancelamentos Nota Fiscal'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/notaFiscal/cancelamento/cancelamento.html',
                        controller: 'CancelamentoController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('notaFiscal.detail', {
                parent: 'notaFiscal',
                url: '/detalhes/{id}',
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'Nota Fiscal'
                },
                ncyBreadcrumb: {
                    label: 'Detalhes da Nota Fiscal'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/notaFiscal/notaFiscal-detail.html',
                        controller: 'NotaFiscalDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('notaFiscal');
                        $translatePartialLoader.addPart('declaracaoPrestacaoServico');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('situacaoParcela');
                        $translatePartialLoader.addPart('modalidadeNota');
                        $translatePartialLoader.addPart('localExecucao');
                        $translatePartialLoader.addPart('regimeTributario');
                        $translatePartialLoader.addPart('naturezaOperacao');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'NotaFiscal', '$state', function ($stateParams, NotaFiscal, $state) {
                        return NotaFiscal.get({id: $stateParams.id},
                            function (sucess) {
                                return sucess;
                            }, function (error) {
                                $state.go('notaFiscal');
                            });
                    }]
                }
            })
            .state('imprimeNota', {
                url: '/impressao/{id}',
                parent: 'entity',
                data: {
                    roles: [],
                    pageTitle: 'Nota Fiscal'
                },
                ncyBreadcrumb: {
                    label: 'Detalhes da Nota Fiscal'
                },
                onEnter: ['$stateParams', '$state', '$modal', 'NotaFiscal', '$rootScope', function ($stateParams, $state, $modal, NotaFiscal, $rootScope) {
                    $modal.open({
                        templateUrl: 'app/entities/notaFiscal/notaFiscal-impressao.html',
                        controller: 'NotaFiscalImpressaoController',
                        size: 'lg',
                        resolve: {
                            id: function () {
                                return $stateParams.id;
                            }
                        }
                    }).result.then(function (result) {
                        if ($rootScope.previousStateName && $rootScope.previousStateName != 'notaFiscal.edit') {
                            $state.go($rootScope.previousStateName, null, {reload: true});
                        } else {
                            $state.go('notaFiscal', null, {reload: true});
                        }
                    }, function () {
                        if ($rootScope.previousStateName && ($rootScope.previousStateName != 'notaFiscal.edit' && $rootScope.previousStateName != 'notaFiscal.copy')) {
                            $state.go($rootScope.previousStateName);
                        } else {
                            $state.go('notaFiscal');
                        }
                    })
                }]
            })
            .state('notaFiscal.new', {
                parent: 'notaFiscal',
                url: '/novo',
                data: {
                    roles: ['ROLE_EMPRESA_NFSE'],
                    pageTitle: 'Nota Fiscal'
                },
                ncyBreadcrumb: {
                    label: 'Emissão de nova Nota Fiscal'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/notaFiscal/notaFiscal-edit.html',
                        controller: 'NotaFiscalEditController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('notaFiscal');
                        $translatePartialLoader.addPart('declaracaoPrestacaoServico');
                        $translatePartialLoader.addPart('tomador');
                        $translatePartialLoader.addPart('dadosPessoais');
                        $translatePartialLoader.addPart('endereco');
                        $translatePartialLoader.addPart('servico');
                        $translatePartialLoader.addPart('modalidadeNota');
                        $translatePartialLoader.addPart('localExecucao');
                        $translatePartialLoader.addPart('regimeTributario');
                        $translatePartialLoader.addPart('naturezaOperacao');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'NotaFiscal', 'localStorageService', '$state', function ($stateParams, NotaFiscal, localStorageService, $state) {
                        return NotaFiscal.new({}, function (data) {
                            return data;
                        }, function (error) {
                            $state.go('notaFiscal');
                        });
                    }]
                }
            })
            .state('notaFiscal.newSubstituicao', {
                parent: 'notaFiscal',
                url: '/novo/{idNotaSubstituida}',
                data: {
                    roles: ['ROLE_EMPRESA_NFSE'],
                    pageTitle: 'Nota Fiscal'
                },
                ncyBreadcrumb: {
                    label: 'Emissão de nova Nota Fiscal'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/notaFiscal/notaFiscal-edit.html',
                        controller: 'NotaFiscalEditController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('notaFiscal');
                        $translatePartialLoader.addPart('declaracaoPrestacaoServico');
                        $translatePartialLoader.addPart('tomador');
                        $translatePartialLoader.addPart('dadosPessoais');
                        $translatePartialLoader.addPart('endereco');
                        $translatePartialLoader.addPart('servico');
                        $translatePartialLoader.addPart('modalidadeNota');
                        $translatePartialLoader.addPart('localExecucao');
                        $translatePartialLoader.addPart('regimeTributario');
                        $translatePartialLoader.addPart('naturezaOperacao');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'NotaFiscal', 'localStorageService', '$state', function ($stateParams, NotaFiscal, localStorageService, $state) {
                        return NotaFiscal.newSubstituicao({idNotaSubstituida: $stateParams.idNotaSubstituida}, function (data) {
                            return data;
                        }, function () {
                            $state.go('notaFiscal');
                        });
                    }]
                }
            })
            .state('notaFiscal.copy', {
                parent: 'notaFiscal',
                url: '/nova-nota-copiada/{id}',
                data: {
                    roles: ['ROLE_EMPRESA_NFSE'],
                    pageTitle: 'Nota Fiscal'
                },
                ncyBreadcrumb: {
                    label: 'Emissão de nova Nota Fiscal'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/notaFiscal/notaFiscal-edit.html',
                        controller: 'NotaFiscalEditController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('notaFiscal');
                        $translatePartialLoader.addPart('declaracaoPrestacaoServico');
                        $translatePartialLoader.addPart('tomador');
                        $translatePartialLoader.addPart('dadosPessoais');
                        $translatePartialLoader.addPart('endereco');
                        $translatePartialLoader.addPart('servico');
                        $translatePartialLoader.addPart('localExecucao');
                        $translatePartialLoader.addPart('regimeTributario');
                        $translatePartialLoader.addPart('naturezaOperacao');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'NotaFiscal', 'localStorageService', '$state', 'SweetAlert', function ($stateParams, NotaFiscal, localStorageService, $state, SweetAlert) {
                        return NotaFiscal.copy({id: $stateParams.id}, function (data) {
                            return data;
                        }, function (error) {
                            console.log('erro na copia de nfse {}', error);
                            $state.go('notaFiscal');
                        });
                    }]
                }
            })
            .state('notaFiscal.byRps', {
                parent: 'notaFiscal',
                url: '/nova-nota-rps/{numeroRps}',
                data: {
                    roles: ['ROLE_EMPRESA_NFSE'],
                    pageTitle: 'Nota Fiscal'
                },
                ncyBreadcrumb: {
                    label: 'Emissão de nova Nota Fiscal'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/notaFiscal/notaFiscal-edit.html',
                        controller: 'NotaFiscalEditController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('notaFiscal');
                        $translatePartialLoader.addPart('declaracaoPrestacaoServico');
                        $translatePartialLoader.addPart('tomador');
                        $translatePartialLoader.addPart('dadosPessoais');
                        $translatePartialLoader.addPart('endereco');
                        $translatePartialLoader.addPart('servico');
                        $translatePartialLoader.addPart('localExecucao');
                        $translatePartialLoader.addPart('regimeTributario');
                        $translatePartialLoader.addPart('naturezaOperacao');

                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'NotaFiscal', 'localStorageService', '$state', 'SweetAlert', function ($stateParams, NotaFiscal, localStorageService, $state, SweetAlert) {
                        return NotaFiscal.copyPorRps({numeroRps: $stateParams.numeroRps}, function (data) {
                            data.notaPai = $stateParams.id;
                            return data;
                        }, function (error) {
                            $state.go('notaFiscal');
                        });
                    }]
                }
            })
            .state('notaFiscal.edit', {

                parent: 'notaFiscal',
                url: '/edicao/{id}',
                data: {
                    roles: ['ROLE_EMPRESA_NFSE'],
                    pageTitle: 'Nota Fiscal'
                },
                ncyBreadcrumb: {
                    label: 'Edição da Nota Fiscal'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/notaFiscal/notaFiscal-edit.html',
                        controller: 'NotaFiscalEditController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('notaFiscal');
                        $translatePartialLoader.addPart('declaracaoPrestacaoServico');
                        $translatePartialLoader.addPart('dadosPessoais');
                        $translatePartialLoader.addPart('localExecucao');
                        $translatePartialLoader.addPart('regimeTributario');
                        $translatePartialLoader.addPart('naturezaOperacao');

                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'NotaFiscal', '$state', function ($stateParams, NotaFiscal, $state) {
                        return NotaFiscal.get({id: $stateParams.id},
                            function (sucess) {
                                return sucess;
                            }, function (error) {
                                $state.go('notaFiscal');
                            });
                    }]
                }
            })
            .state('notaFiscal.autenticar', {
                parent: 'entity',
                url: '/notas-autenticar',
                data: {
                    roles: [],
                    pageTitle: 'Verifique a Autenticidade da NFS-e '
                },
                ncyBreadcrumb: {
                    label: 'Autenticar Nfse'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/notaFiscal/autenticar-nota.html',
                        controller: 'AutenticarNotaController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('notaFiscal');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    id: function () {
                        return null;
                    }
                }
            })
            .state('exportarXml', {
                parent: 'entity',
                url: '/exportar-xml',
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'Exportar XML de Nota Fiscal'
                },
                ncyBreadcrumb: {
                    label: 'Exportar XML de Nota Fiscal'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/notaFiscal/exportacaoxml/exportacao-xml.html',
                        controller: 'ExportacaoXmlController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('notaFiscal.autenticar-qrcode', {
                parent: 'entity',
                url: '/notas-autenticar-qr-code/{id}',
                data: {
                    roles: [],
                    pageTitle: 'Verifique a Autenticidade da NFS-e '
                },
                ncyBreadcrumb: {
                    label: 'Autenticar Nfse'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/notaFiscal/autenticar-nota.html',
                        controller: 'AutenticarNotaController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('notaFiscal');
                        $translatePartialLoader.addPart('declaracaoPrestacaoServico');
                        $translatePartialLoader.addPart('dadosPessoais');
                        $translatePartialLoader.addPart('localExecucao');
                        $translatePartialLoader.addPart('regimeTributario');
                        $translatePartialLoader.addPart('naturezaOperacao');

                        return $translate.refresh();
                    }],
                    id: ['$stateParams', function ($stateParams) {
                        return $stateParams.id;
                    }]
                }
            })
    });

'use strict';

angular.module('nfseApp')
    .controller('NotaFiscalController',
        function ($scope, $window, NotaFiscal, NotaFiscalSearch, ParseLinks,
                  localStorageService, SweetAlert, $state, ImpressaoPdf, $modal, ExportarXls, moment,
                  $http, EnumCacheService, Notificacao, BloqueioEmissaoNfse) {
            $scope.notaFiscals = [];
            $scope.per_page = 20;
            $scope.orderBy;
            $scope.prestadorPrincipal = localStorageService.get("prestadorPrincipal");
            $scope.situacoes = EnumCacheService.carregarValuesEnum("SituacaoDeclaracaoNfseDTO");


            $scope.buscarOperacoes = function (tipo) {
                var operacoes = [];
                operacoes.push({nome: 'Igual', value: 'IGUAL'});
                if (tipo === 'inteiro' || tipo === 'decimal' || tipo === 'data') {
                    operacoes.push({nome: 'Maior ou igual', value: 'MAIOR_IGUAL'});
                }
                if (tipo === 'inteiro' || tipo === 'decimal' || tipo === 'data') {
                    operacoes.push({nome: 'Menor ou igual', value: 'MENOR_IGUAL'});
                }
                if (tipo === 'inteiro' || tipo === 'decimal' || tipo === 'data') {
                    operacoes.push({nome: 'Menor', value: 'MENOR'});
                }
                if (tipo === 'inteiro' || tipo === 'decimal' || tipo === 'data') {
                    operacoes.push({nome: 'Maior', value: 'MAIOR'});
                }
                if (tipo === 'texto' || tipo === 'cpfcnpj') {
                    operacoes.push({nome: 'Contém', value: 'LIKE'});
                }
                return operacoes;
            };

            $scope.filtrosDisponiveis = [
                {
                    nomeAtributo: 'lower(dptnf.nomerazaosocial)',
                    tipo: 'texto',
                    descricao: 'Tomador - Nome/Razão Social',
                    operacoes: $scope.buscarOperacoes('texto')
                },
                {
                    nomeAtributo: 'dptnf.cpfcnpj',
                    tipo: 'cpfcnpj',
                    descricao: 'Tomador - CPF/CNPJ',
                    operacoes: $scope.buscarOperacoes('cpfcnpj')
                },
                {
                    nomeAtributo: 'nf.numero',
                    tipo: 'inteiro',
                    descricao: 'Número da Nota',
                    operacoes: $scope.buscarOperacoes('inteiro')
                },
                {
                    nomeAtributo: 'coalesce(nf.homologacao, false)',
                    tipo: 'logico',
                    descricao: 'Homologação',
                    operacoes: $scope.buscarOperacoes('logico')
                },
                {
                    nomeAtributo: 'dps.totalservicos',
                    tipo: 'decimal',
                    descricao: 'Valor dos Serviços',
                    operacoes: $scope.buscarOperacoes('decimal')
                },
                {
                    nomeAtributo: 'dps.isscalculado',
                    tipo: 'decimal',
                    descricao: 'Valor do Iss',
                    operacoes: $scope.buscarOperacoes('decimal')
                },
                {
                    nomeAtributo: 'rps.numero',
                    tipo: 'texto',
                    descricao: 'Número do RPS',
                    operacoes: $scope.buscarOperacoes('inteiro')
                },
                {
                    nomeAtributo: "date_trunc('day', nf.emissao)",
                    tipo: 'data',
                    descricao: 'Emissão',
                    operacoes: $scope.buscarOperacoes('data')
                },
                {
                    nomeAtributo: "dps.situacao",
                    tipo: 'enum',
                    descricao: 'Situação',
                    operacoes: $scope.buscarOperacoes('enum'),
                    values: $scope.situacoes
                }
            ];

            $scope.filtrosSelecionados = [];

            $scope.validarFiltros = function () {
                for (var i = 0; i < $scope.filtrosSelecionados.length; i++) {
                    if ($scope.filtrosSelecionados[i].atributo == null) {
                        SweetAlert.warning("Filtro Personalizado inválido!", "Selecione uma opção de filtro.");
                        return false;
                    }
                    if (!$scope.filtrosSelecionados[i].operacao) {
                        SweetAlert.warning("Filtro Personalizado inválido!", "Selecione um operador de filtro.");
                        return false;
                    }
                }
                return true;
            };

            $scope.montarConsultaNotaFiscal = function () {
                var campos = [];

                campos.push({
                    campo: "nf.prestador_id",
                    operador: "IGUAL",
                    valorLong: $scope.prestadorPrincipal.prestador.id
                });

                var contemHomologacao = false;
                angular.forEach($scope.filtrosSelecionados, function (filtro, index) {
                    if (filtro.atributo.nomeAtributo === 'coalesce(nf.homologacao, false)')
                        contemHomologacao = true;
                    if (filtro.atributo.tipo === 'texto' && !filtro.valorString)
                        filtro.valorString = "";
                    campos.push(
                        {
                            operador: filtro.operacao,
                            campo: filtro.atributo.nomeAtributo,
                            valorString: (filtro.operacao !== 'LIKE' ? filtro.valorString : '%' + filtro.valorString.trim().toLowerCase() + '%'),
                            valorDate: filtro.valorData,
                            valorLogico: filtro.valorLogico,
                            valorDecimal: filtro.valorDecimal,
                            valorInteger: filtro.valorInteger
                        }
                    );
                });

                if (!contemHomologacao)
                    campos.push({
                        operador: 'IGUAL',
                        campo: 'coalesce(nf.homologacao, false)',
                        valorLogico: false
                    });

                if (!$scope.orderBy) {
                    $scope.orderBy = "nf.numero";
                    $scope.sortReverse = true;
                }

                return {
                    offset: $scope.page,
                    limit: $scope.per_page,
                    parametrosQuery: [{
                        juncao: " and ",
                        parametroQueryCampos: campos
                    }],
                    orderBy: " order by " + $scope.orderBy + " " + ($scope.sortReverse ? 'desc' : 'asc')
                };
            };

            $scope.getTotalIss = function () {
                var totalIss = 0;
                angular.forEach($scope.notaFiscals, function (value, key) {
                    totalIss += value.iss;
                });
                return totalIss;
            };

            $scope.loadAll = function () {
                if (!$scope.validarFiltros()) {
                    return;
                }
                var consultaNotaFiscal = $scope.montarConsultaNotaFiscal();

                NotaFiscal.buscarNotasFiscais(consultaNotaFiscal,
                    function (result, headers) {
                        if (headers)
                            $scope.links = ParseLinks.parse(headers('link'));
                        $scope.notaFiscals = result;
                        $scope.getTotalIss();
                    });
            };

            $scope.loadAll();

            $scope.loadPage = function (page) {
                $scope.page = page;
                $scope.loadAll();
            };


            $scope.cancelarNota = function (nota) {
                NotaFiscal.cancelarNota(nota, function () {
                    $scope.loadAll();
                });
            };

            $scope.copiarNota = function (nota) {
                SweetAlert.swal({
                        title: "Confirme a cópia da Nota Fiscal",
                        text: "Tem certeza que quer copiar a Nota Fiscal de N° " + nota.numero + " para a competência atual? ",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#F7A54A", confirmButtonText: "Sim, Copiar Nota Fiscal",
                        cancelButtonText: "Não, Cancelar",
                        closeOnConfirm: false,
                        closeOnCancel: false
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            $state.go('notaFiscal.copy', ({id: nota.id}));
                            SweetAlert.info("Nota Fiscal Copiada!", "Prossiga para a emissão da Nota Fiscal.", "success");
                        } else {
                            SweetAlert.info("Cancelado", "A Nota Fiscal não foi copiada.", "error");
                        }
                        SweetAlert.close();
                    }
                )
            };

            $scope.delete = function (id) {
                NotaFiscal.get({id: id}, function (result) {
                    $scope.notaFiscal = result;
                    SweetAlert.swal({
                            title: "Confirme a exclusão",
                            text: "Você tem certeza que quer excluir a Nota Fiscal?",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#DD6B55", confirmButtonText: "Sim, Excluir",
                            cancelButtonText: "Não, Cancelar",
                            closeOnConfirm: false,
                            closeOnCancel: false
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                $scope.confirmDelete(id);
                            } else {
                                SweetAlert.info("Cancelado", "A Nota Fiscal não foi removida :)", "error");
                            }
                        });

                });
            };

            $scope.imprime = function (id) {
                NotaFiscal.imprime({id: id});
            };

            $scope.confirmDelete = function (id) {
                NotaFiscal.delete({id: id},
                    function () {
                        $scope.loadAll();
                        SweetAlert.info("Pronto!", "A Nota Fiscal foi removida com sucesso.", "success");
                    });
            };

            $scope.refresh = function () {
                $scope.loadAll();
                $scope.clear();
            };

            $scope.clear = function () {
                $scope.notaFiscal = {
                    numero: null, codigoVerificacao: null, id: null,
                    declaracaoPrestacaoServico: {prestador: localStorageService.get("prestadorPrincipal")}
                };
            };


            $scope.imprimirNota = function (id) {
                ImpressaoPdf.imprimirPdfViaUrl('/publico/notaFiscal/imprime/' + id);
            };

            $scope.baixarXMlNotaFiscal = function (idNotaFiscal) {
                NotaFiscal.downloadXmlNotaFiscal(idNotaFiscal);
            };

            $scope.baixarXMl = function () {
                NotaFiscal.baixarXml($scope.montarConsultaNotaFiscal(), function (result) {
                    var a = document.createElement('a');
                    a.href = 'data:application/xml;base64,' + result.conteudo;
                    a.target = '_blank';
                    a.download = 'lote-notas-fiscais.xml';
                    document.body.appendChild(a);
                    a.click();
                });
            };

            $scope.baixarPDFResumido = function () {
                $scope.baixarPDF("RESUMIDO");
            };

            $scope.baixarPDFDetalhado = function () {
                $scope.baixarPDF("DETALHADO");
            };

            $scope.baixarPDF = function (tipoRelatorio) {
                $scope.orderBy = "dptnf.nomerazaosocial";
                $scope.sortReverse = false;
                var emissao = {
                    consultaNotaFiscal: $scope.montarConsultaNotaFiscal(),
                    criteriosUtilizados: "",
                    tipoNota: "EMITIDA",
                    tipoRelatorio: tipoRelatorio
                };
                ImpressaoPdf.imprimirPdfViaPost('/api/notaFiscals/relatorio-notas-fiscais', emissao);
            };

            $scope.baixarXls = function () {
                $scope.orderBy = "dptnf.nomerazaosocial";
                $scope.sortReverse = false;
                var emissao = {

                    consultaNotaFiscal: $scope.montarConsultaNotaFiscal(),
                    criteriosUtilizados: "",
                    tipoNota: "EMITIDA",
                    tipoRelatorio: "RESUMIDO"
                };
                $http.post('api/notaFiscals/relatorio-notas-fiscais-xls', emissao, {responseType: 'arraybuffer'}).then(function (response) {
                    if (response.data.byteLength == 0) {
                        Notificacao.warn('Atenção', 'Nenhum registro para ser impresso.');
                    } else {
                        var blob = new Blob([response.data], {
                            type: "application/excel"
                        });
                        saveAs(blob, "NotasFiscais.xls");
                    }
                });
            };

            $scope.enviarNota = function (nota) {
                var modalEnviarNota = $modal.open({
                    templateUrl: 'app/entities/notaFiscal/enviar-nota-email.html',
                    controller: 'EnviarNotaEmailController',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return nota
                        }
                    }
                });
                modalEnviarNota.result.then(function (data) {
                    if (data) {
                    }
                });
            };


            $scope.cartaCorrecaoNota = function (nota) {
                var modalInstance = $modal.open({
                    templateUrl: 'app/entities/notaFiscal/carta-correcao/carta-correcao.html',
                    controller: 'CartaCorrecaoController',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return nota
                        }
                    }
                });
                modalInstance.result.then(function (notaFiscal) {
                    SweetAlert.success("Operação realizada", "Carta de Correção enviada!");
                    $scope.loadAll();
                });
            };


            $scope.adicionarFiltro = function () {
                var filtro = {};
                $scope.filtrosSelecionados.push(filtro);
            };

            $scope.removerFiltro = function (index) {
                $scope.filtrosSelecionados.splice(index, 1);
            };

            $scope.selecionouCampo = function (filtro) {
                filtro.valorString = null;
                filtro.valorDecimal = null;
                filtro.valorInteger = null;
                filtro.valorLogico = false;
                filtro.valorData = null;
            };

            $scope.getTotalServicos = function () {
                var totalIss = 0;
                angular.forEach($scope.notaFiscals, function (value, key) {
                    totalIss += value.totalServicos;
                });
                return totalIss;
            };

            $scope.getTotalBaseCalculo = function () {
                var totalIss = 0;
                angular.forEach($scope.notaFiscals, function (value, key) {
                    totalIss += value.baseCalculo;
                });
                return totalIss;
            }

            $scope.emitirNotaFiscal = function () {
                NotaFiscal.emitirNotaFiscal();
            }
        });

'use strict';

angular.module('nfseApp')
    .controller('ItemDeclaracaoServicoController', function ($scope, NotaFiscal, ParseLinks, SweetAlert, $modalInstance) {
        $scope.itensDeclaracaoServico = [];
        $scope.page = 1;
        $scope.per_page = 5;
        $scope.loadAll = function () {
            NotaFiscal.getItemDeclaracaoServicoEmitidosPorPrestador({
                page: $scope.page,
                per_page: $scope.per_page
            }, function (result, headers) {
                // $scope.links = ParseLinks.parse(headers('link'));
                $scope.itensDeclaracaoServico = result;
            });
        };
        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();


        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };


        $scope.ok = function (item) {
            $modalInstance.close(item);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    });

(function () {
    'use strict';

    angular.module('nfseApp').controller('ExportacaoXmlController',
        function ($scope, PrestadorServicos, Notificacao, localStorageService, DataUtil, NotaFiscal, $interval,
                  Util) {
            $scope.prestador = null;
            $scope.tipoDocumento = 'EMITIDA';

            $scope.tipo = "NORMAL";
            $scope.tipoData = "COMPETENCIA";
            $scope.dataInicial;
            $scope.dataFinal;
            $scope.competenciaAno;
            $scope.competenciaMes;
            $scope.numeroNotaFiscalInicial;
            $scope.numeroNotaFiscalFinal;
            $scope.meses;
            $scope.gerarArquivoXml;
            $scope.xml;


            PrestadorServicos.get({id: localStorageService.get("prestadorPrincipal").prestador.id}, function (data) {
                $scope.prestador = data;
            });

            $scope.meses = Util.getMeses({});

            $scope.montarConsultaNotaFiscal = function (orderBy) {
                var campos = [];

                if ($scope.tipoDocumento === 'EMITIDA') {
                    var parametroQueryCampo = {
                        campo: "nf.prestador_id",
                        operador: "IGUAL",
                        valorLong: $scope.prestador.id
                    };
                    campos.push(parametroQueryCampo);
                } else {
                    if ($scope.prestador) {
                        var parametroQueryCampo = {
                            campo: "dptnf.cpfcnpj",
                            operador: "IGUAL",
                            valorString: Util.apenasNumeros($scope.prestador.pessoa.dadosPessoais.cpfCnpj)
                        };
                        campos.push(parametroQueryCampo);
                    } else {
                        var parametroQueryCampo = {
                            campo: "dptnf.cpfcnpj",
                            operador: "IGUAL",
                            valorString: Util.apenasNumeros($scope.account.login)
                        };
                        campos.push(parametroQueryCampo);
                    }
                }


                var campoData = $scope.tipoData === "COMPETENCIA" ? "dps.competencia" : "nf.emissao";
                if ($scope.tipoData === "EMISSAO") {
                    if ($scope.dataInicial) {
                        var dataInicial = DataUtil.dateWithOutHoursMinutesSeconds($scope.dataInicial);
                        parametroQueryCampo = {
                            campo: "nf.emissao",
                            operador: "MAIOR_IGUAL",
                            valorDate: dataInicial
                        };
                        campos.push(parametroQueryCampo);
                    }
                    if ($scope.dataFinal) {
                        var dataFinal = DataUtil.dateWithOutHoursMinutesSeconds($scope.dataFinal);
                        parametroQueryCampo = {
                            campo: "nf.emissao",
                            operador: "MENOR_IGUAL",
                            valorDate: dataFinal
                        };
                        campos.push(parametroQueryCampo);
                    }
                } else if ($scope.tipoData === "COMPETENCIA") {
                    parametroQueryCampo = {
                        campo: "extract(year from dps.competencia)",
                        operador: "IGUAL",
                        valorInteger: $scope.competenciaAno
                    };
                    campos.push(parametroQueryCampo);
                    parametroQueryCampo = {
                        campo: "extract(month from dps.competencia)",
                        operador: "IGUAL",
                        valorInteger: $scope.competenciaMes.numeroMes
                    };
                    campos.push(parametroQueryCampo);
                }

                if ($scope.numeroNotaFiscalInicial) {
                    parametroQueryCampo = {
                        campo: " nf.numero ",
                        operador: "MAIOR_IGUAL",
                        valorLong: $scope.numeroNotaFiscalInicial
                    };
                    campos.push(parametroQueryCampo);
                }

                if ($scope.numeroNotaFiscalFinal) {
                    parametroQueryCampo = {
                        campo: " nf.numero ",
                        operador: "MENOR_IGUAL",
                        valorLong: $scope.numeroNotaFiscalFinal
                    };
                    campos.push(parametroQueryCampo);
                }

                return {
                    offset: $scope.page,
                    limit: $scope.per_page,
                    parametrosQuery: [{
                        juncao: " and ",
                        parametroQueryCampos: campos
                    }],
                    orderBy: orderBy
                };
            };

            function filtrosValidos() {
                if ($scope.tipoData === "EMISSAO" && !$scope.dataInicial) {
                    Notificacao.warn("Atenção", "A Emissão Inicial deve ser informada.");
                    return false;
                }
                if ($scope.tipoData === "EMISSAO" && !$scope.dataFinal) {
                    Notificacao.warn("Atenção", "A Emissão Final deve ser informada.");
                    return false;
                }
                if ($scope.tipoData === "COMPETENCIA" && !$scope.competenciaMes) {
                    Notificacao.warn("Atenção", "A Competência deve ser informada.");
                    return false;
                }
                if ($scope.tipoData === "COMPETENCIA" && !$scope.competenciaAno) {
                    Notificacao.warn("Atenção", "O Ano deve ser informado.");
                    return false;
                }
                return true;
            }

            $scope.consultarXml = function () {
                NotaFiscal.consultarXml($scope.baixarXml, function (result) {
                    $scope.xml = result;
                    console.log("CONSULTA PERCENTUAL - {}", $scope.xml.percentual);
                    if (!$scope.xml || $scope.xml.percentual >= 100) {
                        if ($scope.interval) {
                            $interval.cancel($scope.interval);
                        }
                        console.log("FINALIZOU CONSULTA");
                        if ($scope.xml.total === 0) {
                            Notificacao.warn("Atenção", "Nenhum nota fiscal encontrado para os filtros selecionados.")
                            $scope.xml = null;
                        }
                    }
                });
            };

            $scope.exportarXml = function () {
                if (!filtrosValidos())
                    return;
                $scope.baixarXml = {
                    tipo: $scope.tipo,
                    consultaGenericaNfseDTO: $scope.montarConsultaNotaFiscal(" order by nf.numero desc "),
                    inscricao: $scope.prestador.inscricaoMunicipal,
                    percentual: 0
                };
                NotaFiscal.baixarXml($scope.baixarXml, function () {
                    verificarSituacaoXml()
                });
            };

            $scope.gerarArquivoXml = function () {
                if ($scope.xml.percentual >= 100) {
                    $scope.baixandoArquivo = true;
                    var a = document.createElement('a');
                    if ($scope.baixarXml.tipo === 'NORMAL') {
                        a.href = 'data:application/xml;base64,' + $scope.xml.conteudo;
                        a.download = 'lote-notas-fiscais.xml';
                    } else {
                        a.href = 'data:application/x-bzip;base64,' + $scope.xml.conteudo;
                        a.download = 'lote-notas-fiscais.zip';
                    }
                    a.target = '_blank';
                    document.body.appendChild(a);
                    a.click();
                    $scope.baixandoArquivo = false;
                    $scope.xml = null;
                }
            }

            function verificarSituacaoXml() {
                $scope.consultarXml();
                $scope.interval = $interval(function () {
                    $scope.consultarXml();
                }, 3000);
            }

            $scope.$on("$destroy", function (event) {
                console.log("TIMOUT ooff");
                $interval.cancel($scope.interval);
            });

            $scope.handleTipoData = function () {
                $scope.dataInicial = null;
                $scope.dataFinal = null;
                $scope.competenciaAno = null;
                $scope.competenciaMes = null;

                if ($scope.tipoData === "EMISSAO") {
                    var hoje = new Date();
                    var month = hoje.getMonth();
                    var fullYear = hoje.getFullYear();
                    $scope.dataInicial = new Date(fullYear, month, 1);
                    $scope.dataFinal = hoje;
                } else {
                    var dataAtual = new Date();
                    $scope.competenciaAno = dataAtual.getFullYear();
                    angular.forEach($scope.meses, function (mes) {
                        if (mes.numeroMes === dataAtual.getMonth() + 1) {
                            $scope.competenciaMes = mes;
                        }
                    });
                }
            };

            $scope.handleTipoData();
        });
})();

'use strict';

angular.module('nfseApp')
    .controller('EnviarNotaEmailController', function ($scope, entity, NotaFiscal, ParseLinks, SweetAlert, $modalInstance) {
        $scope.notaFiscal = entity;

        $scope.ok = function () {
            NotaFiscal.enviarPorEmail($scope.notaFiscal, function(data){
                $modalInstance.close($scope.notaFiscal);
                SweetAlert.info("Enviado", "O email foi enviado aos destinatários", "info");
            }, function (err) {
                SweetAlert.info("Operação não realizada", "não foi possível enviar o email aos destinatários", "error");

            });
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    });

'use strict';

angular.module('nfseApp')
    .controller('CartaCorrecaoController', function ($scope, entity, NotaFiscal, ParseLinks, SweetAlert, $modalInstance, ImpressaoPdf) {

        $scope.per_page = 5;
        $scope.cartas = [];
        $scope.carta = {
            dataEmissao: new Date(),
            numero: entity.numero,
            tomador: entity.nomeTomador,
            notaFiscal: entity
        };

        $scope.formatDate = function (data) {
            return new Date(data).toLocaleDateString();
        };

        $scope.imprimirCarta = function (id) {
            ImpressaoPdf.imprimirPdfViaUrl('/api/notaFiscals/carta-correcao-impressao/' + id);
        };

        $scope.novaCarta = function () {
            $scope.operacaoNovo = true;
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

        $scope.enviarCarta = function () {
            SweetAlert.swal({
                    title: "Confirme o envio da CC-e",
                    text: "Você tem certeza que quer enviar a Carta de Correção?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55", confirmButtonText: "Sim",
                    cancelButtonText: "Não",
                    closeOnConfirm: false,
                    closeOnCancel: false
                },
                function (isConfirm) {
                    if (isConfirm) {
                        NotaFiscal.cartaCorrecao($scope.carta, function (data) {
                            $scope.operacaoNovo = false;
                            $scope.loadPage();
                            SweetAlert.close();
                        });
                    } else {
                        SweetAlert.close();
                    }
                });

        };

        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.buscarCartaCorrecao();
        };

        $scope.buscarCartaCorrecao = function () {
            NotaFiscal.buscarCartaCorrecao({
                page: $scope.page,
                per_page: $scope.per_page,
                idNotaFiscal: entity.id
            }, function (result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.cartas = result;
                $scope.operacaoNovo = $scope.cartas.length === 0;
            });
        };
        $scope.buscarCartaCorrecao();
    });

(function () {
    'use strict';

    angular.module('nfseApp')
        .controller('CancelamentoNotaFiscalController', function ($scope, NotaFiscal,
                                                                  entity, SweetAlert, $modalInstance, Account) {
                $scope.notaFiscal = entity;
                $scope.podeSolicitar = false;
                $scope.cancelando = false;
                $scope.substituida = false;
                $scope.numeroSubstituta;

               if (!$scope.notaFiscal.declaracaoPrestacaoServico.cancelamento ||
                !$scope.notaFiscal.declaracaoPrestacaoServico.cancelamento.situacaoFiscal ||
                $scope.notaFiscal.declaracaoPrestacaoServico.cancelamento.situacaoFiscal == 'NAO_DEFERIDO') {
                    $scope.podeSolicitar = true;
                    $scope.cancelamento = {notaFiscal: entity};
                    Account.get().$promise
                        .then(function (account) {
                            $scope.cancelamento.usuarioTomador = account.data;
                        });
                }

                $scope.cancelarNota = function () {
                    SweetAlert.swal({
                            title: "Confirme o cancelamento",
                            text: "Você tem certeza que quer cancelar a Nota Fiscal?",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#DD6B55", confirmButtonText: "Sim",
                            cancelButtonText: "Não",
                            closeOnConfirm: true,
                            closeOnCancel: true
                        },
                        function (isConfirm) {
                            if (isConfirm && !$scope.cancelando) {
                                $scope.cancelando = true;
                                NotaFiscal.cancelar($scope.cancelamento, function (data) {
                                    $modalInstance.close(data);
                                });
                            }
                        });
                };

                $scope.findNotaSubstituta = function () {
                    $scope.cancelamento.notaFiscalSubstituta = null;
                    NotaFiscal.porNumero({numero: $scope.numeroSubstituta}, function (nota) {
                        if (nota && nota.id == $scope.cancelamento.notaFiscal.id) {
                            Notificacao.warn("Atenção", "Nota Fisca de Substituição deve ser diferente da " +
                                "Nota Fiscal Cancelada.");
                        }
                        $scope.cancelamento.notaFiscalSubstituta = nota;
                    });
                };

                $scope.cancel = function () {
                    $modalInstance.dismiss('cancel');
                };
            });
})();

'use strict';

angular.module('nfseApp')
    .controller('CancelamentoController', function ($scope, NotaFiscal, ParseLinks, Principal, localStorageService, Pessoa, SweetAlert, Account) {

        $scope.notaFiscals = [];
        $scope.per_page = 20;
        $scope.searchQuery = "";

        Account.get().$promise.then(function (account) {
            $scope.tomador = account.data;
            Pessoa.getPessoaDoLogin({login: account.data.login}).$promise.then(function (data) {
                $scope.cpf = data.dadosPessoais.cpfCnpj;
                $scope.cnpj = localStorageService.get("prestadorPrincipal").prestador.pessoa.dadosPessoais.cpfCnpj;
                $scope.loadAll();
            })
        });

        $scope.loadAll = function () {
            NotaFiscal.buscarNotasEmCancelamento({
                page: $scope.page,
                per_page: $scope.per_page,
                filtro: $scope.searchQuery,
                cpf: $scope.cpf,
                cnpj: $scope.cnpj
            }, function (result, headers) {
                if (headers) {
                    $scope.links = ParseLinks.parse(headers('link'));
                }
                $scope.notaFiscals = result;
                console.log($scope.notaFiscals);
            });
        };

        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };

        $scope.deferir = function (idNota) {
            $scope.submeter(true, idNota);
        };

        $scope.indeferir = function (idNota) {
            $scope.submeter(false, idNota);
        };

        $scope.submeter = function (isDeferido, idNota) {
            SweetAlert.swal({
                    title: "Confirme a operação",
                    text: "Você tem certeza que quer " + (isDeferido ? "deferir" : "indeferir") + " está solicitação de cancelamento",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55", confirmButtonText: "Sim",
                    cancelButtonText: "Não",
                    closeOnConfirm: false,
                    closeOnCancel: false
                },
                function (isConfirm) {
                    if (isConfirm) {
                        console.log(idNota);
                        NotaFiscal.submeterCancelamento({
                            idNota: idNota,
                            situacaoTomador: isDeferido ? 'DEFERIDO' : 'NAO_DEFERIDO',
                            tomador: $scope.tomador
                        }, function () {
                            SweetAlert.success("Operação realizada", "Cancelamento " + (isDeferido ? "deferir" : "indeferir") + " com sucesso!");
                            $scope.loadPage();
                            SweetAlert.close();
                        });
                    } else {
                        SweetAlert.close();
                    }
                });
        };
    });

'use strict';

angular.module('nfseApp').controller('AutenticarNotaController',
    ['$rootScope', '$scope', '$modal', '$state', '$filter', '$stateParams', 'NotaFiscal', 'Notificacao', 'ImpressaoPdf', 'id',
        function ($rootScope, $scope, $modal, $state, $filter, $stateParams, NotaFiscal, Notificacao, ImpressaoPdf, id) {

            $scope.nfse = {};
            $scope.tipos = [
                {value: "NOTA_FISCAL", label: "Nota Fiscal"},
                {value: "CARTA_CORRECAO", label: "Carta de Correção"}
            ];

            $scope.limpar = function () {
                $scope.autenticar = {cpfCnpjPrestador: "", numeroNfse: "", codigoAutenticacao: "", tipo: "NOTA_FISCAL"};
                $scope.valido = null;
             };

            function recuperarNotaFiscal() {
                $scope.valido = null;
                if (id) {
                    console.log('bora');
                    NotaFiscal.getPublica({id: $stateParams.id}, function (nota) {
                        if (nota.id) {
                            $scope.autenticar = {
                                tipo: "NOTA_FISCAL",
                                cpfCnpjPrestador: nota.prestador.pessoa.dadosPessoais.cpfCnpj,
                                numero: nota.numero,
                                codigoVerificacao: nota.codigoVerificacao
                            };
                            $scope.valido = true;
                            $scope.nfse = nota;
                        } else {
                            NotaFiscal.getPublicaCartaCorrecao({id: $stateParams.id}, function (carta) {
                                if (carta.id) {
                                    $scope.autenticar = {
                                        tipo: "CARTA_CORRECAO",
                                        cpfCnpjPrestador: carta.notaFiscal.prestador.pessoa.dadosPessoais.cpfCnpj,
                                        numero: carta.sequencialCartaCorrecao,
                                        codigoVerificacao: carta.codigoVerificacao
                                    };
                                    $scope.valido = true;
                                } else {
                                    $scope.valido = false;
                                }
                            });
                        }
                    });
                } else {
                    $scope.limpar();
                }
            }

            recuperarNotaFiscal();

            $scope.autenticarNota = function () {
                console.log("Autenticar", $scope.autenticar);
                NotaFiscal.autenticar($scope.autenticar,
                    function (data) {
                        $scope.nfse = data;
                        Notificacao.info("Válido", "Os valores representam uma " +
                            ($scope.autenticar.tipo == 'NOTA_FISCAL' ? "NFS-e" : "Carta de Correção") + " emitida válida");
                        $scope.valido = true;
                        $scope.nfse = data;
                    }, function (error) {
                        Notificacao.error("Inválido", "Os valores informardos não representam uma " +
                            ($scope.autenticar.tipo == 'NOTA_FISCAL' ? "NFS-e" : "Carta de Correção") + " emitida válida");
                        $scope.valido = false;
                    });
            };

            $scope.imprimirNota = function () {
                ImpressaoPdf.imprimirPdfViaUrl('/publico/notaFiscal/imprime/' +  $scope.nfse.id);
            };


        }])
;

'use strict';

angular.module('nfseApp')
    .controller('AliquotaSimplesAnesoLei1232006Controller',
        function ($scope, PrestadorServicos, ParseLinks, SweetAlert, $modalInstance, prestador) {

            $scope.anexo = {};


            PrestadorServicos.getAnexosLei1232006({}, function (data) {
                $scope.anexos = data;
                for (var i = 0; i < $scope.anexos.length; i++) {
                    var anexo = $scope.anexos[i];

                    if (prestador.enquadramentoFiscal.anexoLei1232006
                        && anexo.id === prestador.enquadramentoFiscal.anexoLei1232006.id) {
                        $scope.anexo = anexo;
                    }

                    if (prestador.rbt12) {
                        $scope.rbt12 = prestador.rbt12;
                    }
                }
            });


            $scope.selecionarFaixa = function (faixa) {
                if (!$scope.rbt12) {
                    SweetAlert.error("Atenção", "Informe o RBT12.");
                    return;
                }
                if($scope.rbt12 > faixa.valorMaximo){
                    SweetAlert.error("Atenção", "RBT12 imcompatível com a faixa selecionada.");
                    return;
                }
                $scope.anexo.faixaSelecionada = faixa;
            };


            $scope.ok = function () {
                $scope.anexo.rbt12 = $scope.rbt12;
                $modalInstance.close($scope.anexo);
            };

            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };
        }
    )
;

'use strict';

angular.module('nfseApp')
    .factory('NotaPremiadaService', function ($resource) {
        return $resource('api/externo/nota-premiada/:id', {}, {
            'notaPremiadaParaExibicao': {
                method: 'GET',
                url: "api/externo/nota-premiada-para-exibicao",
                isArray: true
            },
            'buscarPremios': {
                url: 'api/externo/nota-premiada-premios/:id',
                method: 'GET',
                isArray: true
            },
            'buscarBilhetes': {
                url: 'api/externo/nota-premiada-bilhetes',
                method: 'GET',
                isArray: true
            },
            'buscarBilhetesPremiados': {
                url: 'api/externo/nota-premiada-bilhetes-premiados/:id',
                method: 'GET',
                isArray: true
            },
            'buscarTodosPremios': {
                url: 'api/externo/nota-premiada-premios',
                method: 'GET',
                isArray: true
            },
            'anularParticipacaoCampanha': {
                url: 'api/externo/anular-participacao-campanha',
                method: 'GET',
                isArray: true
            }
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('NaturezaJuridica', function ($resource) {
        return $resource('api/naturezas/', {}, {
            'getFisicas': {url: 'api/naturezas-fisicas', method: 'GET', isArray: true},
            'getJuridicas': {url: 'api/naturezas-juridicas', method: 'GET', isArray: true},
            'update': {method: 'PUT'}
        });
    });

'use strict';

angular.module('nfseApp')
    .controller('MunicipioSearchController', function ($scope, Municipio, MunicipioSearch, ParseLinks, SweetAlert, $modalInstance) {
        $scope.municipios = [];
        $scope.page = 1;
        $scope.per_page = 10;
        $scope.loadAll = function () {
            Municipio.query({page: $scope.page, per_page: $scope.per_page, query: $scope.searchQuery}, function (result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.municipios = result;
            });
        };
        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.municipio = {codigo: null, descricao: null, ativo: null, id: null};
        };

        $scope.ok = function (municipio) {
            $modalInstance.close(municipio);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    });

'use strict';

angular.module('nfseApp').controller('MunicipioDialogController',
    ['$scope', '$stateParams', '$modalInstance', 'entity', 'Municipio',
        function($scope, $stateParams, $modalInstance, entity, Municipio) {

        $scope.municipio = entity;
        $scope.load = function(id) {
            Municipio.get({id : id}, function(result) {
                $scope.municipio = result;
            });
        };

        var onSaveFinished = function (result) {
            $scope.$emit('nfseApp:municipioUpdate', result);
            $modalInstance.close(result);
        };

        $scope.save = function () {
            if ($scope.municipio.id != null) {
                Municipio.update($scope.municipio, onSaveFinished);
            } else {
                Municipio.save($scope.municipio, onSaveFinished);
            }
        };

        $scope.clear = function() {
            $modalInstance.dismiss('cancel');
        };
}]);

'use strict';

angular.module('nfseApp')
    .controller('MunicipioDetailController', function ($scope, $rootScope, $stateParams, entity, Municipio) {
        $scope.municipio = entity;
        $scope.load = function (id) {
            Municipio.get({id: id}, function(result) {
                $scope.municipio = result;
            });
        };
        $rootScope.$on('nfseApp:municipioUpdate', function(event, result) {
            $scope.municipio = result;
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('Municipio', function ($resource, DateUtils) {
        return $resource('api/municipios/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getByCodigo': {
                url: 'api/municipios_por_codigo/:codigo',
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getByNome': {
                url: 'api/municipio_por_descricao/:nome',
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('MunicipioSearch', function ($resource) {
        return $resource('api/_search/municipios/:query', {}, {
            'query': { method: 'GET', isArray: true}
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('municipio', {
                parent: 'entity',
                url: '/municipios',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'nfseApp.municipio.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/municipio/municipios.html',
                        controller: 'MunicipioController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('municipio');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('municipio.detail', {
                parent: 'entity',
                url: '/municipio/{id}',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'nfseApp.municipio.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/municipio/municipio-detail.html',
                        controller: 'MunicipioDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('municipio');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Municipio', function($stateParams, Municipio) {
                        return Municipio.get({id : $stateParams.id});
                    }]
                }
            })
            .state('municipio.new', {
                parent: 'municipio',
                url: '/new',
                data: {
                    roles: ['ROLE_ADMIN'],
                },
                onEnter: ['$stateParams', '$state', '$modal', function($stateParams, $state, $modal) {
                    $modal.open({
                        templateUrl: 'app/entities/municipio/municipio-dialog.html',
                        controller: 'MunicipioDialogController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {codigo: null, nome: null, id: null};
                            }
                        }
                    }).result.then(function(result) {
                        $state.go('municipio', null, { reload: true });
                    }, function() {
                        $state.go('municipio');
                    })
                }]
            })
            .state('municipio.edit', {
                parent: 'municipio',
                url: '/{id}/edit',
                data: {
                    roles: ['ROLE_ADMIN'],
                },
                onEnter: ['$stateParams', '$state', '$modal', function($stateParams, $state, $modal) {
                    $modal.open({
                        templateUrl: 'app/entities/municipio/municipio-dialog.html',
                        controller: 'MunicipioDialogController',
                        size: 'lg',
                        resolve: {
                            entity: ['Municipio', function(Municipio) {
                                return Municipio.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('municipio', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
                }]
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('MunicipioController', function ($scope, Municipio, MunicipioSearch, ParseLinks, SweetAlert) {
        $scope.municipios = [];
        $scope.page = 1;
        $scope.per_page = 10;

        $scope.mostraBotaoLoadInicial = false;
        $scope.loadAll = function () {
            Municipio.query({page: $scope.page, per_page: $scope.per_page}, function (result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.municipios = result;
                if ($scope.page == 1 && $scope.municipios.length == 0) {
                    $scope.mostraBotaoLoadInicial = 1;
                }
            });
        };
        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            Municipio.get({id: id}, function (result) {
                $scope.municipio = result;
                $('#deleteMunicipioConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            Municipio.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deleteMunicipioConfirmation').modal('hide');
                    $scope.clear();
                });
        };

        $scope.search = function () {
            MunicipioSearch.query({query: $scope.searchQuery}, function (result) {
                $scope.municipios = result;
            }, function (response) {
                if (response.status === 404) {
                    $scope.loadAll();
                }
            });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.municipio = {codigo: null, nome: null, id: null};
        };

        $scope.loadInitialData = function () {
            Municipio.loadInitialData();
        }
    });

'use strict';

angular.module('nfseApp')
    .factory('Mongo', function ($resource) {
        return $resource('api/mongo/:id', {}, {
            'dropDb': {
                url: 'api/mongo/drop-db',
                method: 'DELETE'
            },
            'dropCollection': {
                url: 'api/mongo/drop-collection',
                method: 'DELETE'
            }
        });
    });

(function () {
    'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('mongo', {
                parent: 'entity',
                url: '/cache-mongo',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'Cache do MongoDB'
                },
                ncyBreadcrumb: {
                    label: 'Cache do MongoDB'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/mongo/mongo.html',
                        controller: 'MongoController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    });
})();

(function () {
    'use strict';

angular.module('nfseApp')
    .controller('MongoController', function ($scope, Mongo, Notificacao) {
        $scope.collectionName;

        $scope.dropCollection = function () {
            Mongo.dropCollection({collectionName: $scope.collectionName}, function () {
                Notificacao.info("Informação!", "Drop collection efetuado com sucesso!");
            });
        };

        $scope.dropDb = function () {
            Mongo.dropDb({dbName: $scope.dbName}, function () {
                Notificacao.info("Informação!", "Drop db efetuado com sucesso!");
            });
        };
    });
})();

(function () {
    'use strict';

    angular.module('nfseApp')
        .controller('MensagemContribuinteUsuarioNewController', function ($scope, $state, entity,
                                                                          MensagemContribuinteUsuarioService,
                                                                          Principal, $sanitize) {

            $scope.entity = entity;
            $scope.declaro = false;

            $scope.baixouArquivo = function (arquivo) {
                arquivo.baixou = true;
            }

            $scope.trustAsHtml = function (value) {
                return $sanitize(value);
            };

            $scope.uploadFile = function (file, documento) {
                var reader = new FileReader();
                reader.onload = function (evt) {
                    $scope.$apply(function ($scope) {
                        documento.file = evt.target.result;
                        documento.fileName = file.name;
                    });
                };
                reader.readAsDataURL(file);
            };

            $scope.isQuestionamento = function () {
                return $scope.entity.mensagem.tipo == 'QUESTIONAMENTO';
            }

            $scope.isQuestionamentoRespondido = function () {
                return $scope.entity.resposta;
            }

            $scope.isQuestionamentoDocAnexados = function () {
                for (var i = 0; i < $scope.entity.documentos.length; i++) {
                    if ($scope.entity.documentos[i].documento.obrigatorio == true &&
                        !$scope.entity.documentos[i].file) {
                        return false;
                    }
                }
                return true;
            }

            $scope.baixouAnexos = function () {
                if ($scope.entity.mensagem.detentorArquivoComposicao &&
                    $scope.entity.mensagem.detentorArquivoComposicao.arquivos) {
                    for (var i = 0; i < $scope.entity.mensagem.detentorArquivoComposicao.arquivos.length; i++) {
                        if (!$scope.entity.mensagem.detentorArquivoComposicao.arquivos[i].baixou) {
                            return false;
                        }
                    }
                }
                return true;
            }

            $scope.habilitaBotaoConfirmar = function () {
                if ($scope.isQuestionamento() &&
                    (!$scope.isQuestionamentoRespondido() || !$scope.isQuestionamentoDocAnexados())) {
                    return false;
                }
                if (!$scope.baixouAnexos()) {
                    return false;
                }
                if (!$scope.declaro) {
                    return false;
                }
                return true;
            }

            $scope.confirmar = function () {
                Principal.identity().then(function (account) {
                    $scope.entity.lidaPor = account;
                    MensagemContribuinteUsuarioService.marcarComoLida($scope.entity, function () {
                        MensagemContribuinteUsuarioService.proximaMensagemNaoLida({}, function (data) {
                            if (data && data.id) {
                                $state.go("mensagemContribuinteUsuarioNew", {id: data.id});
                            } else {
                                $scope.$emit('nfseApp:navbarUpdate');
                                $state.go('home', {reload: true});
                            }
                        });
                    });
                });
            }
        });
})();

(function () {
    'use strict';

    angular.module('nfseApp')
        .controller('MensagemContribuinteUsuarioDetailController', function ($scope, MensagemContribuinteUsuarioService, entity, $sanitize, Principal) {

            $scope.mensagemContribuinteUsuario = entity;

            $scope.trustAsHtml = function (value) {
                return $sanitize(value);
            };
        });
})();
(function () {
    'use strict';

angular.module('nfseApp')
    .factory('MensagemContribuinteUsuarioService', function ($resource, DateUtils) {
        function transformResponseList(data) {
            data = angular.fromJson(data);
            for (var i = 0; i < data.length; i++) {
                var nota = data[i];
                transformResponse(nota);
            }
            return data;
        }

        function transformResponse(data) {
            if (!data) {
                return;
            }
            data = angular.fromJson(data);
            if (data.dataLeitura) {
                data.dataLeitura = DateUtils.convertLocaleDateFromServer(data.dataLeitura);
            }
            if (data.mensagem) {
                if (data.mensagem.emitidaEm) {
                    data.mensagem.emitidaEm = DateUtils.convertLocaleDateFromServer(data.mensagem.emitidaEm);
                }
            }
            return data;
        }

        var resource = $resource('api/mensagem-contribuinte-usuario/:id', {}, {
            'consultar': {
                url: 'api/mensagem-contribuinte-usuario/consultar',
                method: 'POST',
                isArray: true,
                transformResponse: transformResponseList
            },
            'proximaMensagemNaoLida': {
                url: 'api/mensagem-contribuinte-usuario/proxima-nao-lida',
                method: 'GET',
                transformResponse: transformResponse
            },
            'marcarComoLida': {
                url: 'api/mensagem-contribuinte-usuario/marcar-como-lida',
                method: 'POST'
            }
        });

        return resource;
    });
})();

(function () {
    'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('mensagemContribuinteUsuarioNew', {
                parent: 'entity',
                url: '/mensagem/nova/{id}',
                ncyBreadcrumb: {
                    label: 'Nova Mensagem'
                },
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'Nova Mensagem',
                    specialClass: "white-bg not-navigation",
                    notBreadCrumb: true
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/mensagem-contribuinte-usuario/mensagem-contribuinte-usuario-new.html',
                        controller: 'MensagemContribuinteUsuarioNewController'
                    },
                    'navbar@': {
                        template: '<div></div>',
                    },
                    'menu@': {
                        template: '<div></div>',
                    },
                    'footer@': {
                        template: '<div></div>',
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'MensagemContribuinteUsuarioService', function ($stateParams, MensagemContribuinteUsuarioService) {
                        return MensagemContribuinteUsuarioService.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('mensagemContribuinteUsuario', {
                parent: 'home',
                url: 'mensagens',
                ncyBreadcrumb: {
                    label: 'Mensagens'
                },
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'Mensagens'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/mensagem-contribuinte-usuario/mensagem-contribuinte-usuario.html',
                        controller: 'MensagemContribuinteUsuarioController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('mensagemContribuinteUsuario.detail', {
                parent: 'home',
                url: 'mensagem/{id}',
                ncyBreadcrumb: {
                    label: 'Mensagem'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/mensagem-contribuinte-usuario/mensagem-contribuinte-usuario-detail.html',
                        controller: 'MensagemContribuinteUsuarioDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'MensagemContribuinteUsuarioService', function ($stateParams, MensagemContribuinteUsuarioService) {
                        return MensagemContribuinteUsuarioService.get({id: $stateParams.id}).$promise;
                    }]
                }
            });
    });
})();

(function () {
    'use strict';

    angular.module('nfseApp')
        .controller('MensagemContribuinteUsuarioController', function ($scope, MensagemContribuinteUsuarioService, $modal,
                                                                       SweetAlert, Principal, $sanitize, ParseLinks,
                                                                       localStorageService) {

            $scope.mensagens = [];
            $scope.account = {};
            $scope.page = 0;
            $scope.per_page = 10;
            $scope.prestadorPrincipal = localStorageService.get("prestadorPrincipal");

            $scope.trustAsHtml = function (value) {
                return $sanitize(value);
            };

            $scope.montarConsulta = function () {
                var campos = [];
                var parametroQueryCampo = {
                    campo: "ce.id",
                    operador: "IGUAL",
                    valorLong: $scope.prestadorPrincipal.prestador.id
                };
                campos.push(parametroQueryCampo);
                return {
                    offset: $scope.page,
                    limit: $scope.per_page,
                    parametrosQuery: [{
                        juncao: " and ",
                        parametroQueryCampos: campos
                    }]
                };
            }

            $scope.loadAll = function () {
                MensagemContribuinteUsuarioService.consultar($scope.montarConsulta(),
                    function (result, headers) {
                        $scope.mensagens = result;
                        if (headers)
                            $scope.links = ParseLinks.parse(headers('link'));
                    }
                );
            };

            $scope.loadAll();

            $scope.loadPage = function (page) {
                $scope.page = page;
                $scope.loadAll();
            };
        });
})();

'use strict';

angular.module('nfseApp')
    .factory('ManualService', function ($resource) {
        return $resource('api/externo/manual/:id', {}, {
            'manuaisParaExibicao': {
                method: 'GET',
                url: "api/externo/manuais-para-exibicao",
                isArray: true

            }
        });
    });

'use strict';

angular.module('nfseApp').controller('LoteServicoTomadoDialogController',
    ['$scope', '$stateParams', '$modalInstance', 'entity', 'LoteServicoTomado', 'RPS',
        function($scope, $stateParams, $modalInstance, entity, LoteServicoTomado, RPS) {

        $scope.loteServicoTomado = entity;
        $scope.load = function(id) {
            LoteServicoTomado.get({id : id}, function(result) {
                $scope.loteServicoTomado = result;
            });
        };

        var onSaveFinished = function (result) {
            $scope.$emit('nfseApp:loteServicoTomadoUpdate', result);
            $modalInstance.close(result);
        };

        $scope.save = function () {
            if ($scope.loteServicoTomado.id != null) {
                LoteServicoTomado.update($scope.loteServicoTomado, onSaveFinished);
            } else {
                LoteServicoTomado.save($scope.loteServicoTomado, onSaveFinished);
            }
        };

        $scope.clear = function() {
            $modalInstance.dismiss('cancel');
        };
}]);

'use strict';

angular.module('nfseApp')
    .controller('LoteServicoTomadoDetailController', function ($scope, $rootScope, $stateParams, entity,
                                                               LoteServicoTomado, $timeout, NotaFiscal, ParseLinks) {

        $scope.loteServicoTomado = entity;
        $scope.editable = false;
        $scope.per_page = 10;
        $scope.searchQuery = "";
        $scope.editorOptions = {
            lineWrapping: true,
            lineNumbers: true,
            readOnly: 'nocursor',
            mode: 'htmlmixed',
            lineSeparator: '</br>'
        };

        $scope.load = function (id) {
            LoteServicoTomado.get({id: id}, function (result) {
                $scope.loteServicoTomado = result;
                verificarSituacaoLote();
            });
        };

        $rootScope.$on('nfseApp:loteServicoTomadoUpdate', function (event, result) {
            $scope.loteServicoTomado = result;
        });

        function verificarSituacaoLote() {
            if ($scope.loteServicoTomado.situacao === 'AGUARDANDO') {
                $timeout(function () {
                    $scope.load($scope.loteServicoTomado.id);
                }, 2000)
            }
        }

        verificarSituacaoLote();



        $scope.loadAll = function () {
            NotaFiscal.buscarNotasComoTomadorAndLote({
                page: $scope.page,
                per_page: $scope.per_page,
                filtro: $scope.searchQuery,
                loteId:  $scope.loteServicoTomado.id
            }, function (result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.notas = result;
            });
        };
        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };

        $scope.loadAll();


    });

'use strict';

angular.module('nfseApp')
    .factory('LoteServicoTomado', function ($resource, DateUtils) {
        return $resource('api/lote-declaracao-servico-tomado/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('loteServicoTomado', {
                parent: 'entity',
                url: '/lote-servicos-tomados',
                data: {
                    roles: ['ROLE_CONTRIBUINTE'],
                    pageTitle: 'Log do ARQUIVO'
                },
                ncyBreadcrumb: {
                    label: 'Consulta de Logs de Importação de Documentos Recebidos'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/loteServicoTomado/loteServicoTomados.html',
                        controller: 'LoteServicoTomadoController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('loteServicoTomado');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('loteServicoTomado.detail', {
                parent: 'entity',
                url: '/lote-servicos-tomados/{id}',
                data: {
                    roles: ['ROLE_CONTRIBUINTE'],
                    pageTitle: 'Log do ARQUIVO'
                },
                ncyBreadcrumb: {
                    label: 'Detalhes da Importação do Lote'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/loteServicoTomado/loteServicoTomado-detail.html',
                        controller: 'LoteServicoTomadoDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('loteServicoTomado');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'LoteServicoTomado', function ($stateParams, LoteServicoTomado) {
                        return LoteServicoTomado.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('loteServicoTomado.new', {
                parent: 'loteServicoTomado',
                url: '/new',
                data: {
                    roles: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$modal', function ($stateParams, $state, $modal) {
                    $modal.open({
                        templateUrl: 'app/entities/loteServicoTomado/loteServicoTomado-dialog.html',
                        controller: 'LoteServicoTomadoDialogController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {codigo: null, id: null};
                            }
                        }
                    }).result.then(function (result) {
                        $state.go('loteServicoTomado', null, {reload: true});
                    }, function () {
                        $state.go('loteServicoTomado');
                    })
                }]
            })
            .state('loteServicoTomado.edit', {
                parent: 'loteServicoTomado',
                url: '/{id}/edit',
                data: {
                    roles: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$modal', function ($stateParams, $state, $modal) {
                    $modal.open({
                        templateUrl: 'app/entities/loteServicoTomado/loteServicoTomado-dialog.html',
                        controller: 'LoteServicoTomadoDialogController',
                        size: 'lg',
                        resolve: {
                            entity: ['LoteServicoTomado', function (LoteServicoTomado) {
                                return LoteServicoTomado.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function (result) {
                        $state.go('loteServicoTomado', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    })
                }]
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('LoteServicoTomadoController', function ($scope, LoteServicoTomado, ParseLinks) {
        $scope.lotes = [];
        $scope.page = 1;
        $scope.searchQuery = "";
        $scope.per_page = 10;

        $scope.loadAll = function () {
            LoteServicoTomado.query({
                page: $scope.page,
                per_page: $scope.per_page,
                filtro: $scope.searchQuery
            }, function (result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.lotes = result;
            });
        };
        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.loteServicoTomado = {codigo: null, id: null};
        };
    });

(function () {
    'use strict';

    angular.module('nfseApp')
        .controller('LoteRpsGeralDetailController', function ($scope, LoteRPS, entity, RPS, ParseLinks,
                                                              Notificacao, Util, $timeout) {
            $scope.lote = entity;
            $scope.page = 0;
            $scope.searchQuery = "";
            $scope.per_page = 10;
            $scope.mensagemCopy;

            $scope.editorOptions = {
                lineWrapping: true,
                lineNumbers: true,
                readOnly: 'nocursor',
                mode: 'htmlmixed',
                lineSeparator: '</br>'
            };

            $scope.loadAll = function () {
                RPS.query({
                    page: $scope.page,
                    per_page: $scope.per_page,
                    loteId: $scope.lote.id,
                    prestadorId: $scope.lote.prestador.id,
                    filtro: $scope.searchQuery
                }, function (result, headers) {
                    $scope.links = ParseLinks.parse(headers('link'));
                    $scope.listaRps = result;
                });
            };

            $scope.loadPage = function (page) {
                $scope.page = page;
                $scope.loadAll();
            };

            $scope.verificarSituacaoLote = function () {
                if ($scope.lote.situacao === 'AGUARDANDO') {
                    $scope.timeout = $timeout(function () {
                        $scope.load($scope.lote.id);
                    }, 10000)
                } else {
                    $scope.loadAll();
                }
            };

            $scope.load = function (id) {
                LoteRPS.get({id: id}, function (result) {
                    $scope.lote = result;
                    $scope.verificarSituacaoLote();
                });
            };

            $scope.verificarSituacaoLote();

            $scope.reprocessarLote = function () {
                console.log($scope.lote);
                LoteRPS.reprocessar($scope.lote, function () {
                    Notificacao.info("Informação", "Lote enviado para reprocessamento!");
                    $scope.load($scope.lote.id);
                }, function () {
                    $scope.load($scope.lote.id);
                });
            };

            $scope.copyToClipboard = function (toCopy) {
                $scope.mensagemCopy = "";
                Util.copyToClipboard(toCopy);
                $scope.mensagemCopy = "Copiado!";
            }
        });
})();

(function () {
    'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('loteRpsGeral', {
                parent: 'entity',
                url: '/loteRpsGeral',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'Lotes de RPS'
                },
                ncyBreadcrumb: {
                    label: 'Consulta de Lotes de RPS'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/loterpsgeral/loteRpsGeral.html',
                        controller: 'LoteRpsGeralController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('situacaoLoteRps');
                        return $translate.refresh();
                    }]
                }
            })
            .state('loteRpsGeral.detail', {
                parent: 'entity',
                url: '/loteRpsGeral/{id}',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'Lote de RPS'
                },
                ncyBreadcrumb: {
                    label: 'Detalhes do Lote de RPS'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/loterpsgeral/loteRpsGeral-detail.html',
                        controller: 'LoteRpsGeralDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('situacaoLoteRps');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'LoteRPS', function($stateParams, LoteRPS) {
                        return LoteRPS.get({id : $stateParams.id}).$promise;
                    }]
                }
            });
    });
})();

(function () {
    'use strict';

angular.module('nfseApp')
    .controller('LoteRpsGeralController', function ($scope, LoteRPS, ParseLinks, EnumCacheService, DataUtil, SweetAlert) {
        $scope.lotes = [];
        $scope.links;
        $scope.dataRecebimentoInicial;
        $scope.dataRecebimentoFinal;
        $scope.numeroLoteInicial;
        $scope.numeroLotFinal;
        $scope.inscricaoCadastral;
        $scope.versaoSistema;
        $scope.versaoAbrasf;
        $scope.situacao;
        $scope.reprocessar;
        $scope.page;
        $scope.per_page = 20;
        $scope.situacoes = EnumCacheService.carregarValuesEnum("br.com.webpublico.nfse.dto.enums.SituacaoLoteRps");


        $scope.montarConsulta = function () {
            var campos = [];
            var parametroQueryCampo = {
                campo: "l.id",
                operador: "DIFERENTE",
                valorLong: 0
            };
            campos.push(parametroQueryCampo);

            if ($scope.dataRecebimentoInicial) {
                var dataRecebimentoInicial = DataUtil.dateWithOutHoursMinutesSeconds($scope.dataRecebimentoInicial);
                parametroQueryCampo = {
                    campo: "l.dataRecebimento",
                    operador: "MAIOR_IGUAL",
                    valorDate: dataRecebimentoInicial
                };
                campos.push(parametroQueryCampo);
            }
            if ($scope.dataRecebimentoFinal) {
                var dataRecebimentoFinal = DataUtil.dateWithOutHoursMinutesSeconds($scope.dataRecebimentoFinal);
                parametroQueryCampo = {
                    campo: "l.dataRecebimento",
                    operador: "MENOR_IGUAL",
                    valorDate: dataRecebimentoFinal
                };
                campos.push(parametroQueryCampo);
            }
            if ($scope.inscricaoCadastral) {
                parametroQueryCampo = {
                    campo: "ce.inscricaocadastral",
                    operador: "IGUAL",
                    valorString: $scope.inscricaoCadastral
                };
                campos.push(parametroQueryCampo);
            }
            if ($scope.versaoSistema) {
                parametroQueryCampo = {
                    campo: "l.versaoSistema",
                    operador: "IGUAL",
                    valorString: $scope.versaoSistema
                };
                campos.push(parametroQueryCampo);
            }
            if ($scope.versaoAbrasf) {
                parametroQueryCampo = {
                    campo: "l.versaoAbrasf",
                    operador: "IGUAL",
                    valorString: $scope.versaoAbrasf
                };
                campos.push(parametroQueryCampo);
            }
            if ($scope.numeroLoteInicial) {
                parametroQueryCampo = {
                    campo: "cast(l.numero as bigint)",
                    operador: "MAIOR_IGUAL",
                    valorLong: $scope.numeroLoteInicial
                };
                campos.push(parametroQueryCampo);
            }
            if ($scope.numeroLoteFinal) {
                parametroQueryCampo = {
                    campo: "cast(l.numero as bigint)",
                    operador: "MENOR_IGUAL",
                    valorLong: $scope.numeroLoteFinal
                };
                campos.push(parametroQueryCampo);
            }
            if ($scope.situacao && $scope.situacao.name) {
                parametroQueryCampo = {
                    campo: "l.situacao",
                    operador: "IGUAL",
                    valorString: $scope.situacao.name
                };
                campos.push(parametroQueryCampo);
            }
            if ($scope.reprocessar) {
                parametroQueryCampo = {
                    campo: "l.reprocessar",
                    operador: "IGUAL",
                    valorLogico: $scope.reprocessar
                };
                campos.push(parametroQueryCampo);
            }
            return {
                offset: $scope.page,
                limit: $scope.per_page,
                parametrosQuery: [{
                    juncao: " and ",
                    parametroQueryCampos: campos
                }],
                orderBy: " "
            };
        };

        $scope.loadAll = function () {
            var consultaLoteRps = $scope.montarConsulta();
            LoteRPS.buscarLotesRps(consultaLoteRps,
                function (result, headers) {
                    if (headers)
                        $scope.links = ParseLinks.parse(headers('link'));
                    $scope.lotes = result;
                });
        };

        $scope.limparFiltros = function () {
            $scope.dataRecebimentoInicial = null;
            $scope.dataRecebimentoFinal = null;
            $scope.numeroLoteInicial = null;
            $scope.numeroLotFinal = null;
            $scope.inscricaoCadastral = null;
            $scope.versaoSistema = null;
            $scope.versaoAbrasf = null;
            $scope.situacao = null;
            $scope.reprocessar = null;

        };

        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };

        $scope.loadAll();

        $scope.inverterReprocessar = function (lote) {
            LoteRPS.inverterReprocessar(lote, function () {
                lote.reprocessar = !lote.reprocessar;
            });
        };

        $scope.dispararReprocessamento = function () {
            SweetAlert.swal({
                    title: 'Atenção',
                    text: 'Tem certeza que deseja disparar o reprocessamento de lotes de rps nesse momento?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Não",
                    closeOnConfirm: false,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        LoteRPS.dispararReprocessamento(null, function () {
                            SweetAlert.info("Informação", "Reprocessamento disparado com sucesso!");
                        });
                    }
                });
        }
    });
})();

'use strict';

angular.module('nfseApp').controller('LoteRPSDialogController',
    ['$scope', '$stateParams', '$modalInstance', 'entity', 'LoteRPS', 'RPS',
        function($scope, $stateParams, $modalInstance, entity, LoteRPS, RPS) {

        $scope.loteRPS = entity;
        $scope.load = function(id) {
            LoteRPS.get({id : id}, function(result) {
                $scope.loteRPS = result;
            });
        };

        var onSaveFinished = function (result) {
            $scope.$emit('nfseApp:loteRPSUpdate', result);
            $modalInstance.close(result);
        };

        $scope.save = function () {
            if ($scope.loteRPS.id != null) {
                LoteRPS.update($scope.loteRPS, onSaveFinished);
            } else {
                LoteRPS.save($scope.loteRPS, onSaveFinished);
            }
        };

        $scope.clear = function() {
            $modalInstance.dismiss('cancel');
        };
}]);

'use strict';

angular.module('nfseApp')
    .controller('LoteRPSDetailController', function ($scope, $rootScope, $stateParams,
                                                     entity, LoteRPS, $timeout, RPS,ParseLinks) {

        $scope.loteRPS = entity;
        $scope.editable = false;
        $scope.page = 0;
        $scope.searchQuery = "";
        $scope.per_page = 10;

        $scope.editorOptions = {
            lineWrapping: true,
            lineNumbers: true,
            readOnly: 'nocursor',
            mode: 'htmlmixed',
            lineSeparator: '</br>'
        };

        $scope.load = function (id) {
            LoteRPS.get({id: id}, function (result) {
                $scope.loteRPS = result;
                verificarSituacaoLote();
            });
        };

        $rootScope.$on('nfseApp:loteRPSUpdate', function (event, result) {
            $scope.loteRPS = result;
        });

        function verificarSituacaoLote() {
            if ($scope.loteRPS.situacao === 'AGUARDANDO') {
                $timeout(function () {
                    $scope.load($scope.loteRPS.id);
                }, 2000)
            }
        }

        verificarSituacaoLote();

        $scope.loadAll = function () {
            RPS.query({
                page: $scope.page,
                per_page: $scope.per_page,
                loteId: $scope.loteRPS.id,
                filtro: $scope.searchQuery
            }, function (result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.listaRps = result;
            });
        };
        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

    });

'use strict';

angular.module('nfseApp')
    .factory('LoteRPS', function ($resource, DateUtils) {
        return $resource('api/lote-rps/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' },
            'buscarLotesRps': {
                method: 'POST',
                url: 'api/buscar-lotes-rps',
                isArray: true
            },
            'reprocessar': {
                method: 'POST',
                url: 'api/reprocessar-lote-rps'
            },
            'inverterReprocessar': {
                method: 'POST',
                url: 'api/inverter-reprocessar-lote-rps'
            },
            'dispararReprocessamento': {
                method: 'GET',
                url: 'api/disparar-reprocessamento'
            }
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('LoteRPSSearch', function ($resource) {
        return $resource('api/_search/loteRPSs/:query', {}, {
            'query': { method: 'GET', isArray: true}
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('loteRPS', {
                parent: 'entity',
                url: '/loteRPSs',
                data: {
                    roles: ['ROLE_CONTRIBUINTE'],
                    pageTitle: 'Log do RPS'
                },
                ncyBreadcrumb: {
                    label: 'Consulta de Logs de Importação de RPS'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/loteRPS/loteRPSs.html',
                        controller: 'LoteRPSController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('loteRPS');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('loteRPS.detail', {
                parent: 'entity',
                url: '/loteRPS/{id}',
                data: {
                    roles: ['ROLE_CONTRIBUINTE'],
                    pageTitle: 'Log do RPS'
                },
                ncyBreadcrumb: {
                    label: 'Detalhes da Importação do RPS'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/loteRPS/loteRPS-detail.html',
                        controller: 'LoteRPSDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('loteRPS');
                        $translatePartialLoader.addPart('global');

                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'LoteRPS', function($stateParams, LoteRPS) {
                        return LoteRPS.get({id : $stateParams.id}).$promise;
                    }]
                }
            })
            .state('loteRPS.new', {
                parent: 'loteRPS',
                url: '/new',
                data: {
                    roles: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$modal', function($stateParams, $state, $modal) {
                    $modal.open({
                        templateUrl: 'app/entities/loteRPS/loteRPS-dialog.html',
                        controller: 'LoteRPSDialogController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {codigo: null, id: null};
                            }
                        }
                    }).result.then(function(result) {
                        $state.go('loteRPS', null, { reload: true });
                    }, function() {
                        $state.go('loteRPS');
                    })
                }]
            })
            .state('loteRPS.edit', {
                parent: 'loteRPS',
                url: '/{id}/edit',
                data: {
                    roles: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$modal', function($stateParams, $state, $modal) {
                    $modal.open({
                        templateUrl: 'app/entities/loteRPS/loteRPS-dialog.html',
                        controller: 'LoteRPSDialogController',
                        size: 'lg',
                        resolve: {
                            entity: ['LoteRPS', function(LoteRPS) {
                                return LoteRPS.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('loteRPS', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
                }]
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('LoteRPSController', function ($scope, LoteRPS, LoteRPSSearch, ParseLinks) {
        $scope.lotes = [];
        $scope.page = 1;
        $scope.searchQuery = "";
        $scope.per_page = 10;

        $scope.loadAll = function () {
            LoteRPS.query({
                page: $scope.page,
                per_page: $scope.per_page,
                filtro: $scope.searchQuery
            }, function (result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.lotes = result;
            });
        };
        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.loteRPS = {codigo: null, id: null};
        };
    });

(function () {
    'use strict';

angular.module('nfseApp')
    .factory('LivroFiscal', function ($resource, DateUtils) {
        return $resource('api/livroFiscal/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.competencia = DateUtils.convertDateTimeFromServer(data.competencia);
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'competenciasLivroFiscal': {
                method: 'POST',
                url: 'api/competencias-livro-fiscal',
                isArray: true
            },
            'imprimirLivroFiscal': {
                method: 'POST',
                url: 'api/imprimir-livro-fiscal'
            }
        });
    });
})();
(function () {
    'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('livroFiscal', {
                parent: 'entity',
                url: '/livro-fiscal',
                data: {
                    // roles: ['ROLE_CONTA_CORRENTE_LIVRO_FISCAL'],
                    pageTitle: 'Livro Fiscal'
                },
                ncyBreadcrumb: {
                    label: 'Consulta dos Livros Fiscais'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/livroFiscal/livroFiscal.html',
                        controller: 'LivroFiscalController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tipoMovimentoMensal');
                        $translatePartialLoader.addPart('mes');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('livroFiscal.new', {
                parent: 'livroFiscal',
                url: '/livro-fiscal/gerar',
                data: {
                    roles: ['ROLE_CONTA_CORRENTE_LIVRO_FISCAL'],
                    pageTitle: 'Livro Fiscal'
                },
                ncyBreadcrumb: {
                    label: 'Geração dos Livros Fiscais'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/livroFiscal/livroFiscal-edit.html',
                        controller: 'LivroFiscalEditController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['localStorageService', function (localStorageService) {
                        return {
                            id: null,
                            numero: null,
                            abertura: new Date(),
                            encerramento: new Date(),
                            tipoMovimento: 'NORMAL',
                            prestador: localStorageService.get("prestadorPrincipal").prestador,
                            itens: []
                        };
                    }]
                }
            });
    });
})();

(function () {
    'use strict';

    angular.module('nfseApp')
        .controller('LivroFiscalController',
            function ($scope, $state, LivroFiscal, ParseLinks, Notificacao, ImpressaoPdf,
                      DeclaracaoMensalServico, localStorageService, PrestadorServicos, $modal) {

                $scope.prestador;
                $scope.exercicioInicial;
                $scope.exercicioFinal;
                $scope.mesInicial;
                $scope.mesFinal;
                $scope.competenciasServicosPrestados;
                $scope.competenciasServicosTomados;

                $scope.loadAll = loadAll;

                function loadAll() {
                    LivroFiscal.competenciasLivroFiscal({
                        exercicioInicial: $scope.exercicioInicial,
                        exercicioFinal: $scope.exercicioFinal,
                        mesInicial: $scope.mesInicial.numeroMes,
                        mesFinal: $scope.mesFinal.numeroMes,
                        consideraEncerramento: true,
                        tipoMovimento: $scope.prestador.enquadramentoFiscal &&
                        $scope.prestador.enquadramentoFiscal.instituicaoFinanceira ? 'INSTITUICAO_FINANCEIRA' : 'NORMAL'
                    }, function (data) {
                        $scope.competenciasServicosPrestados = data;
                    });

                    LivroFiscal.competenciasLivroFiscal({
                        exercicioInicial: $scope.exercicioInicial,
                        exercicioFinal: $scope.exercicioFinal,
                        mesInicial: $scope.mesInicial.numeroMes,
                        mesFinal: $scope.mesFinal.numeroMes,
                        tipoMovimento: 'RETENCAO'
                    }, function (data) {
                        $scope.competenciasServicosTomados = data;
                    });

                    $scope.activeTab = $scope.prestador.enquadramentoFiscal
                    && $scope.prestador.enquadramentoFiscal.instituicaoFinanceira ? 1 : 0;
                }

                DeclaracaoMensalServico.getMeses({}, function (data) {
                    $scope.meses = data;

                    var dataAtual = new Date();
                    $scope.exercicioInicial = dataAtual.getFullYear();
                    $scope.exercicioFinal = dataAtual.getFullYear();
                    angular.forEach(data, function (mes) {
                        if (mes.numeroMes == 1) {
                            $scope.mesInicial = mes;
                        }
                        if (mes.numeroMes == dataAtual.getMonth() + 1) {
                            $scope.mesFinal = mes;
                        }
                    });
                    PrestadorServicos.get({id: localStorageService.get("prestadorPrincipal").prestador.id}, function (data) {
                        $scope.prestador = data;
                        $scope.loadAll();
                    });
                });

                $scope.imprimirLivro = function (competencia) {
                    var modalInstance = $modal.open({
                        templateUrl: 'app/entities/relatorios/relatorioResumidoDetalhado.html',
                        controller: 'RelatorioResumidoDetalhadoController',
                        size: 'md'
                    });

                    modalInstance.result.then(function (detalhado) {
                        competencia.detalhado = detalhado;
                        LivroFiscal.imprimirLivroFiscal(competencia, function (webReport) {
                            $modal.open({
                                templateUrl: 'app/entities/wait-report/wait-report.html',
                                controller: 'WaitReportController',
                                size: 'md',
                                animation: true,
                                keyboard: false,
                                backdrop: 'static',
                                resolve: {
                                    uuid: function () {
                                        return webReport.uuid;
                                    }
                                }
                            });
                        });
                    }, function () {
                    });
                };

                $scope.mudarTab = function (value) {
                    $scope.activeTab = value;
                }
            });
})();

'use strict';

angular.module('nfseApp')
    .factory('LegislacaoService', function ($resource) {
        return $resource('api/externo/legislacao/:id', {}, {
            'legislacoesParaExibicao': {
                method: 'GET',
                url: "api/externo/legislacoes-para-exibicao",
                isArray: true

            }
        });
    });

'use strict';

angular.module('nfseApp')
    .service('ImpressaoPdf', function ($modal, $http, Notificacao) {

        this.imprimirPdfViaUrl = function (url) {
            $http.get(url, {responseType: 'arraybuffer'}).then(function (data) {
                abrirModal(data);
            }).catch(function (error) {
                tratarErro(error);
            });
        };

        this.imprimirPdfViaPost = function (url, data) {
            $http.post(url, data, {responseType: 'arraybuffer'}).then(function (data) {
                abrirModal(data);
            }).catch(function (error) {
                tratarErro(error);
            });
        };

        function abrirModal(data) {
            $modal.open({
                templateUrl: 'app/entities/impressaoPdf/dialog.html',
                controller: 'ImpressaoPDFController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowClass: 'modal-giant',
                resolve: {
                    data: [function () {
                        return data;
                    }]
                }
            })
        }

        function tratarErro(error) {
            console.log(error);
            Notificacao.error("Esse serviço está indisponível no momento, por favor tente novamente mais tarde.");
        }
    });

angular.module('nfseApp')
    .controller('ImpressaoPDFController',
        function ($scope, $rootScope, $http, $sce, data, $modalInstance) {

            var vm = this;
            vm.arquivo = data;
            var file = new Blob([vm.arquivo.data], {type: 'application/pdf'});
            var fileURL = window.URL.createObjectURL(file);
            vm.conteudo = $sce.trustAsResourceUrl(fileURL);
            vm.cancel = cancel;
            vm.baixarAnexo = baixarAnexo;

            function cancel() {
                $modalInstance.dismiss('close');
            }

            function baixarAnexo() {
                var a = document.createElement('a');
                a.href = fileURL;
                a.target = '_blank';
                a.download = 'download-iss-onlione.pdf';
                document.body.appendChild(a);
                a.click();
            }

        })
;

'use strict';

'use strict';

angular.module('nfseApp')
    .factory('Imagem', function ($resource) {
        return $resource('api/imagem/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'updateImagem': {
                method: 'PUT',
                url: "api/imagem"
            },

            'getImageFromPessoa': {
                method: 'GET',
                url: "api/imagem-pessoa/:id",
                transformResponse: function (data) {
                    if (data)
                        data = angular.fromJson(data);
                    return data;
                }
            },
            'getImageFromPrestador': {
                method: 'GET',
                url: "api/imagem-prestador/:id",
                transformResponse: function (data) {
                    if (data)
                        data = angular.fromJson(data);
                    return data;
                }
            },
            'updateImagemUsuario': {
                method: 'POST',
                url: "api/imagem-usuario"
            },
            'getImageFromUsuario': {
                method: 'GET',
                url: "api/imagem-usuario",
                transformResponse: function (data) {
                    if (data)
                        data = angular.fromJson(data);
                    return data;
                }
            },

            'update': {method: 'PUT'}
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('ImagemSearch', function ($resource) {
        return $resource('api/_search/imagem/:query', {}, {
            'query': {method: 'GET', isArray: true}
        });
    });

'use strict';

angular.module('nfseApp').controller('GuiaDialogController',
    ['$scope', '$stateParams', '$modalInstance', 'entity', 'Guia', 'DeclaracaoMensalServico',
        function($scope, $stateParams, $modalInstance, entity, Guia, DeclaracaoMensalServico) {

        $scope.guia = entity;
        $scope.declaracaomensalservicos = DeclaracaoMensalServico.query();
        $scope.load = function(id) {
            Guia.get({id : id}, function(result) {
                $scope.guia = result;
            });
        };

        var onSaveFinished = function (result) {
            $scope.$emit('nfseApp:guiaUpdate', result);
            $modalInstance.close(result);
        };

        $scope.save = function () {
            if ($scope.guia.id != null) {
                Guia.update($scope.guia, onSaveFinished);
            } else {
                Guia.save($scope.guia, onSaveFinished);
            }
        };

        $scope.clear = function() {
            $modalInstance.dismiss('cancel');
        };
}]);

'use strict';

angular.module('nfseApp')
    .controller('GuiaDetailController', function ($scope, $rootScope, $stateParams, entity, Guia, DeclaracaoMensalServico) {
        $scope.guia = entity;
        $scope.load = function (id) {
            Guia.get({id: id}, function(result) {
                $scope.guia = result;
            });
        };
        $rootScope.$on('nfseApp:guiaUpdate', function(event, result) {
            $scope.guia = result;
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('Guia', function ($resource, DateUtils) {
        return $resource('api/guias/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.dataVencimento = DateUtils.convertLocaleDateFromServer(data.dataVencimento);
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.dataVencimento = DateUtils.convertLocaleDateToServer(data.dataVencimento);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.dataVencimento = DateUtils.convertLocaleDateToServer(data.dataVencimento);
                    return angular.toJson(data);
                }
            }
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('GuiaSearch', function ($resource) {
        return $resource('api/_search/guias/:query', {}, {
            'query': { method: 'GET', isArray: true}
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('guia', {
                parent: 'entity',
                url: '/guias',
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'nfseApp.guia.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/guia/guias.html',
                        controller: 'GuiaController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('guia');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('guia.detail', {
                parent: 'entity',
                url: '/guia/{id}',
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'nfseApp.guia.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/guia/guia-detail.html',
                        controller: 'GuiaDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('guia');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Guia', function($stateParams, Guia) {
                        return Guia.get({id : $stateParams.id});
                    }]
                }
            })
            .state('guia.new', {
                parent: 'guia',
                url: '/new',
                data: {
                    roles: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$modal', function($stateParams, $state, $modal) {
                    $modal.open({
                        templateUrl: 'app/entities/guia/guia-dialog.html',
                        controller: 'GuiaDialogController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {guia: null, valor: null, dataVencimento: null, id: null};
                            }
                        }
                    }).result.then(function(result) {
                        $state.go('guia', null, { reload: true });
                    }, function() {
                        $state.go('guia');
                    })
                }]
            })
            .state('guia.edit', {
                parent: 'guia',
                url: '/{id}/edit',
                data: {
                    roles: ['ROLE_USER'],
                },
                onEnter: ['$stateParams', '$state', '$modal', function($stateParams, $state, $modal) {
                    $modal.open({
                        templateUrl: 'app/entities/guia/guia-dialog.html',
                        controller: 'GuiaDialogController',
                        size: 'lg',
                        resolve: {
                            entity: ['Guia', function(Guia) {
                                return Guia.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('guia', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
                }]
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('GuiaController', function ($scope, Guia, GuiaSearch) {
        $scope.guias = [];
        $scope.loadAll = function() {
            Guia.query(function(result) {
               $scope.guias = result;
            });
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            Guia.get({id: id}, function(result) {
                $scope.guia = result;
                $('#deleteGuiaConfirmation').modal('show');
            });
        };

        $scope.confirmDelete = function (id) {
            Guia.delete({id: id},
                function () {
                    $scope.loadAll();
                    $('#deleteGuiaConfirmation').modal('hide');
                    $scope.clear();
                });
        };

        $scope.search = function () {
            GuiaSearch.query({query: $scope.searchQuery}, function(result) {
                $scope.guias = result;
            }, function(response) {
                if(response.status === 404) {
                    $scope.loadAll();
                }
            });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.guia = {guia: null, valor: null, dataVencimento: null, id: null};
        };
    });

'use strict';

angular.module('nfseApp')
    .factory('FaleConoscoService', function ($resource) {
        return $resource('api/externo/fale-conosco/:id', {}, {
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('EventoSimplesNacional', function ($resource) {
        return $resource('api/evento-simples-nacional/:id', {}, {
            'buscarEventosPorEmpresa': {
                url: 'api/evento-simples-nacional/por-empresa',
                method: 'GET',
                isArray: true
            }
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('eventosSimplesNacional', {
                parent: 'entity',
                url: '/evento-simples-nacional',
                data: {
                    // roles: ['ROLE_EMPRESA_AIDFE'],
                    pageTitle: 'Consulta de Eventos do Simples Nacional'
                },
                ncyBreadcrumb: {
                    label: 'Consulta de Eventos do Simples Nacional'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/eventosimplesnacional/eventosimplesnacional.html',
                        controller: 'EventoSimplesNacionalController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    });

'use strict';

angular.module('nfseApp')
    .controller('EventoSimplesNacionalController', function ($scope, $state, EventoSimplesNacional, ParseLinks, SweetAlert, localStorageService) {

        $scope.eventos = [];
        $scope.per_page = 10;
        $scope.searchQuery = "";

        $scope.loadAll = function () {
            console.log('loadAll');
            var prestador = localStorageService.get("prestadorPrincipal");
            EventoSimplesNacional.buscarEventosPorEmpresa({
                prestador: prestador.id,
                filtro: $scope.searchQuery
            }, function (result) {
                $scope.eventos = result;
            });
        };

        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };

        $scope.loadAll();

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clean();
        };
    });

'use strict';

angular.module('nfseApp')
    .controller('EscritorioContabilSearchController', function ($scope, EscritorioContabil, ParseLinks, SweetAlert, $modalInstance) {
        $scope.escritorios = [];
        $scope.per_page = 10;
        $scope.searchQuery = "";

        $scope.loadAll = function () {
            EscritorioContabil.query({
                page: $scope.page,
                per_page: $scope.per_page,
                query: $scope.searchQuery
            }, function (result, headers) {
                if (headers)
                    $scope.links = ParseLinks.parse(headers('link'));
                $scope.escritorios = result;
            });
        };
        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };

        $scope.loadAll();


        $scope.ok = function (escritorio) {
            $modalInstance.close(escritorio);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    });


'use strict';

angular.module('nfseApp')
    .factory('EscritorioContabil', function ($resource) {
        return $resource('api/escritorios-contabeis/:id', {}, {
            'query': {method: 'GET', isArray: true, url:'api/escritorios-contabeis'}
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('entity', {
                abstract: true,
                parent: 'site'
            });
    });

'use strict';

angular.module('nfseApp')
    .factory('CEP', function ($resource, DateUtils) {
        return $resource('api/cep/:cep', {}, {
            'getByCep': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });
    });

(function () {
    'use strict';

    angular.module('nfseApp')
        .controller('PesquisaNotasRecebidasController', function ($scope, $modalInstance, entity, NotaFiscal, ParseLinks) {

            $scope.page;
            $scope.per_page = 10;
            $scope.declaracaoMensalServico = entity;
            $scope.notas;
            $scope.notasSelecionadas;
            $scope.links;

            $scope.buscarNotas = function () {
                NotaFiscal.buscarNotasSemDeclaracaoPorCompetencia({
                    page: $scope.page - 1,
                    per_page: $scope.per_page,
                    idPrestador: $scope.declaracaoMensalServico.prestador.id,
                    foraMunicipio: $scope.declaracaoMensalServico.prestador.foraMunicipio,
                    ano: $scope.declaracaoMensalServico.exercicio,
                    mes: $scope.declaracaoMensalServico.mes,
                    tipoMovimento: $scope.declaracaoMensalServico.tipoMovimento
                }, function (result, headers) {
                    if (headers)
                        $scope.links = ParseLinks.parse(headers('link'));
                    $scope.notas = result;
                    console.log($scope.links);
                });
            };

            $scope.buscarNotas();

            $scope.loadPage = function (page) {
                $scope.page = page;
                $scope.buscarNotas();
            };

            $scope.selecionarNota = function (nota) {
                console.log(nota.id);
                if (!$scope.notasSelecionadas) {
                    $scope.notasSelecionadas = [];
                }
                var index = $scope.indexNotaSelecionada(nota);
                if (index >= 0) {
                    $scope.notasSelecionadas.splice(index, 1);
                } else {
                    $scope.notasSelecionadas.push(nota);
                }
            };

            $scope.indexNotaSelecionada = function (nota) {
                if ($scope.notasSelecionadas) {
                    for (var i = 0; i < $scope.notasSelecionadas.length; i++) {
                        if ($scope.notasSelecionadas[i].id == nota.id) {
                            return i;
                        }
                    }
                }
                return -1;
            };

            $scope.ok = function () {
                $modalInstance.close($scope.notasSelecionadas);
            };

            $scope.cancel = function() {
                $modalInstance.dismiss('cancel');
            };
        })
})();

'use strict';

angular.module('nfseApp').controller('DeclaracaoMensalServicoRetencaoEditController',
    function ($scope, $state, $timeout, $stateParams, DeclaracaoMensalServico, NotaFiscal,
              Notificacao, localStorageService, $modal, SweetAlert) {

        $scope.per_page = 10;
        $scope.ano = $stateParams.ano;
        $scope.mes = $stateParams.mes;
        $scope.tipoMovimento = 'RETENCAO';
        $scope.notas = [];
        $scope.meses = DeclaracaoMensalServico.getMeses();
        $scope.declaracaoMensalServico = null;

        function carregar() {
            $scope.prestador = localStorageService.get("prestadorPrincipal").prestador;

            DeclaracaoMensalServico.getMeses({},
                function (data) {
                    $scope.meses = data;
                    angular.forEach(data, function (mes) {
                        if (mes.numeroMes == $scope.mes) {
                            $scope.mes = mes;
                            $scope.acessarCompetencia();
                        }
                    });
                });
        }

        carregar();

        var onSaveFinished = function (result) {
            Notificacao.priority("Registro salvo com sucesso", "");
            $scope.$emit('nfseApp:declaracaoMensalServicoUpdate', result);
            $scope.$emit('nfseApp:navbarUpdate');
            $state.go('declaracaoMensalServicoRetencao');
        };

        $scope.save = function () {
            if ($scope.declaracaoMensalServico.qtdNotas === 0) {
                SweetAlert.swal({
                        title: "Declaração de Ausência de Movimento",
                        text: "Você tem certeza que deseja declarar ausência de movimento para o período " + $scope.declaracaoMensalServico.mes + "/" + $scope.declaracaoMensalServico.exercicio + "?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55", confirmButtonText: "Sim, Declarar",
                        cancelButtonText: "Não, Cancelar",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            DeclaracaoMensalServico.save($scope.declaracaoMensalServico, onSaveFinished);
                        }
                    });
            } else {
                DeclaracaoMensalServico.save($scope.declaracaoMensalServico, onSaveFinished);
            }
        };

        $scope.acessarCompetencia = function () {
            DeclaracaoMensalServico.novaDms({
                    mes: $scope.mes.numeroMes,
                    ano: $scope.ano,
                    tipoMovimento: $scope.tipoMovimento,
                    empresaId: $scope.prestador.id,
                    foraMunicipio: $scope.prestador.foraMunicipio
                },
                function (result) {
                    $scope.declaracaoMensalServico = result;
                }
            );
        };

        $scope.selecionarNotas = function () {
            var modal = $modal.open({
                templateUrl: 'app/entities/declaracaoMensalServicoRetencao/pesquisaNotasRecebidas.html',
                controller: 'PesquisaNotasRecebidasController',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tipoDocumento');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return $scope.declaracaoMensalServico;
                    }
                }
            });
            modal.result.then(function (data) {
                if (data) {
                    $scope.declaracaoMensalServico.notas = data;
                    $scope.declaracaoMensalServico.qtdNotas = 0;
                    $scope.declaracaoMensalServico.totalServicos = 0;
                    $scope.declaracaoMensalServico.totalIss = 0;
                    for (var i = 0; i < $scope.declaracaoMensalServico.notas.length; i++) {
                        $scope.declaracaoMensalServico.qtdNotas = $scope.declaracaoMensalServico.qtdNotas + 1;
                        $scope.declaracaoMensalServico.totalServicos = $scope.declaracaoMensalServico.totalServicos +
                            $scope.declaracaoMensalServico.notas[i].totalServicos;
                        $scope.declaracaoMensalServico.totalIss = $scope.declaracaoMensalServico.totalIss +
                            $scope.declaracaoMensalServico.notas[i].issCalculado;

                    }
                }
            });
        }
    });


'use strict';

angular.module('nfseApp').controller('DeclaracaoMensalServicoRetencaoDetailController',
    function ($scope, entity, NotaFiscal, ParseLinks) {
        $scope.declaracaoMensalServico = entity;
        $scope.page;
        $scope.per_page = 20;
        $scope.links;
        $scope.notas;

        $scope.buscarNotasNaDeclaracao = function () {
            NotaFiscal.buscarNotasNaDeclaracao({
                    page: $scope.page - 1,
                    per_page: $scope.per_page,
                    idDeclaracaoMensalServico: $scope.declaracaoMensalServico.id
                },
                function (data, headers) {
                    if (headers)
                        $scope.links = ParseLinks.parse(headers('link'));
                    $scope.notas = data;
                }
            );
        };

        $scope.buscarNotasNaDeclaracao();

        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.buscarNotasNaDeclaracao();
        };
});


'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('declaracaoMensalServicoRetencao', {
                parent: 'entity',
                url: '/dms-retencao',
                data: {
                    roles: ['ROLE_EMPRESA_DMS'],
                    pageTitle: 'Declaração Mensal de Serviços Tomados com Retenção'
                },
                ncyBreadcrumb: {
                    label: 'Consulta DMS'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/declaracaoMensalServicoRetencao/declaracaoMensalServicosRetencao.html',
                        controller: 'DeclaracaoMensalServicoRetencaoController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('declaracaoMensalServico');
                        $translatePartialLoader.addPart('situacaoDeclaracaoMensal');
                        $translatePartialLoader.addPart('situacaoParcela');
                        $translatePartialLoader.addPart('tipoDeclaracaoMensal');
                        $translatePartialLoader.addPart('tipoMovimentoMensal');
                        $translatePartialLoader.addPart('mes');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('declaracaoMensalServicoRetencao.new', {
                parent: 'declaracaoMensalServicoRetencao',
                url: '/declarar-retencao/{mes}/{ano}',
                data: {
                    roles: ['ROLE_EMPRESA_DMS'],
                    pageTitle: 'Declaração Mensal de Serviços Tomados com Retenção'
                },
                ncyBreadcrumb: {
                    label: 'Nova DMS'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/declaracaoMensalServicoRetencao/declaracaoMensalServicoRetencao-edit.html',
                        controller: 'DeclaracaoMensalServicoRetencaoEditController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('declaracaoMensalServico');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('declaracaoMensalServicoRetencao.detail', {
                parent: 'declaracaoMensalServicoRetencao',
                url: '/detalhes/{id}',
                data: {
                    roles: ['ROLE_EMPRESA_DMS'],
                    pageTitle: 'Detalhes da Declaração Mensal de Serviços'
                },
                ncyBreadcrumb: {
                    label: 'Detalhes da Declaração Mensal de Serviços Tomados com Retenção'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/declaracaoMensalServicoRetencao/declaracaoMensalServicoRetencao-detail.html',
                        controller: 'DeclaracaoMensalServicoRetencaoDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('tipoDocumento');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'DeclaracaoMensalServico', function ($stateParams, DeclaracaoMensalServico) {
                        return DeclaracaoMensalServico.get({id: $stateParams.id}).$promise;
                    }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('DeclaracaoMensalServicoRetencaoController',
        function ($scope, DeclaracaoMensalServico, DeclaracaoMensalServicoSearch, ParseLinks,
                  Notificacao, ImpressaoPdf, NotaFiscal, localStorageService, Util, $modal) {

            $scope.declaracaoMensalServicos = [];
            $scope.page = 1;
            $scope.per_page = 999;
            $scope.exerciciosDeclarados = [];
            $scope.empresa = localStorageService.get("prestadorPrincipal");
            $scope.meses = Util.getMeses();
            $scope.exercicio = Util.getExercicioAtual();
            $scope.mesInicial = Util.getMesAtual();
            $scope.mesFinal = $scope.mesInicial;

            function montarConsultaGenerica(ano, mes) {
                var campos = [];

                campos.push({
                    campo: $scope.empresa.prestador.foraMunicipio ? "dms.prestadorforamunicipio_id" : "dms.prestador_id",
                    operador: "IGUAL",
                    valorLong: $scope.empresa.prestador.id
                });

                campos.push({
                    campo: "e.ano",
                    operador: "IGUAL",
                    valorInteger: ano
                });

                campos.push({
                    campo: "dms.mes",
                    operador: "IGUAL",
                    valorString: Util.getNameMesFromNumero(mes)
                });

                campos.push({
                    campo: "dms.tipomovimento",
                    operador: "IGUAL",
                    valorString: "RETENCAO"
                });

                return {
                    offset: $scope.page,
                    limit: $scope.per_page,
                    parametrosQuery: [{
                        juncao: " and ",
                        parametroQueryCampos: campos
                    }],
                    orderBy: " order by dms.id desc "
                };
            }

            $scope.loadAll = function () {
                $scope.exerciciosDeclarados = [];

                var exercicioDeclarado = {ano: $scope.exercicio, mesesDeclarados: []};

                for (var j = $scope.mesInicial.numeroMes; j <= $scope.mesFinal.numeroMes; j++) {
                    var mesDeclarado = {mes: j, declaracoes: []};
                    exercicioDeclarado.mesesDeclarados.push(mesDeclarado);
                }
                exercicioDeclarado.mesesDeclarados.sort(function (a, b) {
                    return b.mes - a.mes;
                });
                $scope.exerciciosDeclarados.push(exercicioDeclarado);

                $scope.exerciciosDeclarados.sort(function (a, b) {
                    return b.ano - a.ano;
                });

                angular.forEach($scope.exerciciosDeclarados, function (exercicio) {
                    angular.forEach(exercicio.mesesDeclarados, function (mes) {
                        DeclaracaoMensalServico.consultar(montarConsultaGenerica(exercicio.ano, mes.mes), function (result) {
                            mes.declaracoes = result;
                        });
                    })
                });
            };

            $scope.loadAll();

            $scope.getMesPorNumero = function (numero) {
                for (var i = 0; i < $scope.meses.length; i++) {
                    if ($scope.meses[i].numeroMes === numero) {
                        return $scope.meses[i].descricao;
                    }
                }
            };

            $scope.loadPage = function (page) {
                $scope.page = page;
                $scope.loadAll();
            };


            $scope.delete = function (id) {
                DeclaracaoMensalServico.get({id: id}, function (result) {
                    $scope.declaracaoMensalServico = result;

                    Notificacao.confirmDelete(
                        function (success) {
                            console.log('Notificacao.confirmDelete - success: ', success);
                            $scope.confirmDelete(id);
                        },
                        function (error) {
                            console.log('Notificacao.confirmDelete - error: ', error);
                        }
                    );
                });
            };

            $scope.confirmDelete = function (id) {
                DeclaracaoMensalServico.delete({id: id},
                    function () {
                        $scope.loadAll();
                        $scope.clear();
                    });
            };


            $scope.refresh = function () {
                $scope.loadAll();
                $scope.clear();
            };

            $scope.clear = function () {
                $scope.declaracaoMensalServico = {codigo: null, competencia: null, id: null};
            };

            $scope.imprimirDam = function (declaracao) {
                if (new Date(declaracao.vencimento).getTime() > new Date().getTime()) {
                    ImpressaoPdf.imprimirPdfViaPost('/api/imprimir-dam-declaracao', {
                        idDeclaracao: declaracao.id,
                        idPrestador: $scope.empresa.prestador.id,
                        vencimentoDam: null
                    });
                } else {
                    var modal = $modal.open({
                        templateUrl: 'app/entities/declaracaoMensalServico/emissaoGuia.html',
                        controller: 'EmissaoGuiaController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    idDeclaracao: declaracao.id,
                                    idPrestador: $scope.empresa.prestador.id,
                                    vencimentoDam: new Date()
                                };
                            }
                        }
                    });
                    modal.result.then(function (data) {
                    });
                }
            };

            $scope.imprimeRelatorioDMS = function (ano, mes) {
                ImpressaoPdf.imprimirPdfViaUrl('/api/imprimir-relatorio-dms/' + ano + "/" + mes+"/PRESTADO/RETENCAO");
            };

            $scope.cancelar = function (id) {
                Notificacao.confirm('Atenção!', 'Tem certeza que deseja cancelar essa declaração!', 'warning',
                    function () {
                        DeclaracaoMensalServico.cancelar({id: id}, function () {
                            $scope.loadAll();
                            Notificacao.info('Operação Realizada.', 'Declaração Mensal de Serviço Cancelada!');
                        });
                    })
            };

            $scope.emitirProtocoloRecebimentoDms = function (id) {
                ImpressaoPdf.imprimirPdfViaUrl('/api/emitir-protocolo-declaracao/' + id);
            };
        })
;

'use strict';

angular.module('nfseApp').controller('DeclaracaoMensalServicoInstituicaoFinanceiraImportController',
    ['$scope', '$stateParams', 'ArquivoDesif', 'localStorageService', '$state',
        function ($scope, $stateParams, ArquivoDesif, localStorageService, $state) {

            $scope.dto = {file: '', prestador: localStorageService.get("prestadorPrincipal").prestador};

            $scope.uploadXmlFile = function (file) {
                console.log(file);
                var reader = new FileReader();
                reader.onload = function (evt) {
                    console.log(evt);
                    $scope.$apply(function ($scope) {
                        $scope.arquivoSelecionado = file;
                        $scope.dto.file = evt.target.result;
                    });
                };
                reader.readAsDataURL(file);
            };


            $scope.enviarArquivo = function () {
                ArquivoDesif.importarLegado($scope.dto, function () {
                    $state.go("declaracaoMensalServicoInstituicaoFinanceira")
                });
            }

        }]);

'use strict';

angular.module('nfseApp').controller('DeclaracaoMensalServicoInstituicaoFinanceiraEditController',
    function ($scope, $state, $timeout, $stateParams, entity, DeclaracaoMensalServico, NotaFiscal, Notificacao,
              localStorageService, SweetAlert, PrestadorServicos, PlanoGeralContasComentado) {

        $scope.declaracaoMensalServico = entity;
        $scope.meses = [];
        $scope.contasBancarias = [];
        $scope.quantidadeContasBancariasDeclaradas = 0;
        $scope.totalSaldoAnterior = 0;
        $scope.totalCredito = 0;
        $scope.totalDebito = 0;
        $scope.totalDeclarado = 0;
        $scope.totalIss = 0;

        $scope.acessarCompetencia = acessarCompetencia;
        $scope.atualizarContadores = atualizarContadores;
        $scope.save = save;
        $scope.getTextoBotaoSalvar = getTextoBotaoSalvar;
        $scope.meses = [];

        function carregar() {
            PrestadorServicos.get({id: localStorageService.get("prestadorPrincipal").prestador.id}, function (prestador) {
                $scope.prestador = prestador;
                DeclaracaoMensalServico.getMeses({},
                    function (data) {
                        $scope.meses = data;
                        angular.forEach(data, function (mes) {
                            if (mes.numeroMes == $scope.declaracaoMensalServico.mes) {
                                $scope.declaracaoMensalServico.mes = mes;
                                acessarCompetencia();
                            }
                        });
                    });
            });
        }

        carregar();

        function onSaveFinished() {
            Notificacao.priority("Registro salvo com sucesso", "");
            $state.go('declaracaoMensalServicoInstituicaoFinanceira');
        }


        function save() {
            var editDTO = {
                id: $scope.declaracaoMensalServico.id,
                mes: $scope.declaracaoMensalServico.mes.numeroMes,
                exercicio: $scope.declaracaoMensalServico.exercicio,
                tipo: 'PRINCIPAL',
                contasBancarias: [],
                prestador: $scope.prestador,
                qtdNotas: $scope.quantidadeContasBancariasDeclaradas,
                totalServicos: $scope.totalDeclarado,
                totalIss: $scope.totalIss,
                abertura: new Date(),
                tipoMovimento: 'INSTITUICAO_FINANCEIRA',
                encerramento: new Date()
            };

            for (var i = 0; i < $scope.contasBancarias.length; i++) {
                if ($scope.contasBancarias[i].baseCalculo > 0) {
                    editDTO.contasBancarias.push($scope.contasBancarias[i]);
                }
            }

            if (!editDTO.contasBancarias || editDTO.contasBancarias.length === 0) {
                SweetAlert.swal({
                        title: "Declaração de Ausência de Movimento",
                        text: "Você tem certeza que deseja declarar ausência de movimento para o período " +
                            $scope.declaracaoMensalServico.mes.descricao + "/" + $scope.declaracaoMensalServico.exercicio + "?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55", confirmButtonText: "Sim, Declarar",
                        cancelButtonText: "Não, Cancelar",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            $timeout(DeclaracaoMensalServico.save(editDTO, onSaveFinished), 1000);
                        }
                    });
            } else {
                $timeout(DeclaracaoMensalServico.save(editDTO, onSaveFinished), 1000);
            }
        }

        function acessarCompetencia() {
            $scope.contasBancarias = [];
            PlanoGeralContasComentado.buscarPorPrestador({
                prestador: $scope.prestador.id
            }, function (contas) {
                for (var i = 0; i < contas.length; i++) {
                    $scope.declaracaoContaBancaria = {};
                    $scope.declaracaoContaBancaria.conta = contas[i];
                    $scope.declaracaoContaBancaria.saldoInicial = 0;
                    $scope.declaracaoContaBancaria.valorDebito = 0;
                    $scope.declaracaoContaBancaria.valorCredito = 0;
                    $scope.declaracaoContaBancaria.baseCalculo = 0;
                    $scope.declaracaoContaBancaria.aliquotaIssqn = contas[i].aliquotaIssqn;
                    $scope.contasBancarias.push($scope.declaracaoContaBancaria);
                }
            });
            atualizarContadores();
        }

        function atualizarContadores() {
            $scope.quantidadeContasBancariasDeclaradas = 0;
            $scope.totalSaldoAnterior = 0;
            $scope.totalCredito = 0;
            $scope.totalDebito = 0;
            $scope.totalDeclarado = 0;
            $scope.totalIss = 0;
            for (var i = 0; i < $scope.contasBancarias.length; i++) {
                if ($scope.contasBancarias[i].baseCalculo > 0) {
                    $scope.quantidadeContasBancariasDeclaradas = $scope.quantidadeContasBancariasDeclaradas + 1;
                    $scope.totalDeclarado = $scope.totalDeclarado + $scope.contasBancarias[i].baseCalculo;
                    $scope.totalIss = $scope.totalIss + ($scope.contasBancarias[i].baseCalculo * ($scope.contasBancarias[i].aliquotaIssqn / 100));
                }
                $scope.totalSaldoAnterior = $scope.totalSaldoAnterior + $scope.contasBancarias[i].saldoInicial;
                $scope.totalCredito = $scope.totalCredito + $scope.contasBancarias[i].valorCredito;
                $scope.totalDebito = $scope.totalDebito + $scope.contasBancarias[i].valorDebito;
            }
        }

        function getTextoBotaoSalvar() {
            if ($scope.totalIss === 0) {
                return "Declarar Ausência de Movimento";
            }
            return "Encerrar Declaração";
        }
    }
);


'use strict';

angular.module('nfseApp').controller('DeclaracaoMensalServicoInstituicaoFinanceiraDetailController',
    function ($scope, entity, DeclaracaoMensalServico, PrestadorServicos, localStorageService) {
        $scope.declaracaoMensalServicoInstituicaoFinanceira = entity;
        $scope.itens = [];
        $scope.totalSaldoAnterior = 0;
        $scope.totalCredito = 0;
        $scope.totalDebito = 0;
        $scope.totalDeclarado = 0;
        $scope.totalIss = 0;
        $scope.prestador = null;

        $scope.buscarItensDeclaracaoServico = function () {
            DeclaracaoMensalServico.buscarItensDeclaracaoServico({
                    idDeclaracaoMensalServico: $scope.declaracaoMensalServicoInstituicaoFinanceira.id
                },
                function (data) {
                    $scope.itens = data;
                    $scope.itens.forEach(function (item) {
                        $scope.totalSaldoAnterior = $scope.totalSaldoAnterior + item.saldoAnterior;
                        $scope.totalCredito = $scope.totalCredito + item.credito;
                        $scope.totalDebito = $scope.totalDebito + item.debito;
                        $scope.totalDeclarado = $scope.totalDeclarado + item.valorServico;
                        $scope.totalIss = $scope.totalIss + item.iss;
                    });
                }
            );
        };

        $scope.init = function () {
            PrestadorServicos.get({id: localStorageService.get("prestadorPrincipal").prestador.id}, function (data) {
                $scope.prestador = data;
                $scope.buscarItensDeclaracaoServico();
            })
        }

        $scope.init();
    });


'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('declaracaoMensalServicoInstituicaoFinanceira', {
                parent: 'entity',
                url: '/dms-if',
                data: {
                    roles: ['ROLE_EMPRESA_DMS'],
                    pageTitle: 'Declaração Mensal de Serviços de Instituições Financeiras'
                },
                ncyBreadcrumb: {
                    label: 'Consulta DMS-IF'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/declaracaoMensalServicoInstituicaoFinanceira/declaracaoMensalServicosInstituicaoFinanceira.html',
                        controller: 'DeclaracaoMensalServicoInstituicaoFinanceiraController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('declaracaoMensalServico');
                        $translatePartialLoader.addPart('situacaoDeclaracaoMensal');
                        $translatePartialLoader.addPart('situacaoParcela');
                        $translatePartialLoader.addPart('tipoDeclaracaoMensal');
                        $translatePartialLoader.addPart('tipoMovimentoMensal');
                        $translatePartialLoader.addPart('mes');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]

                }
            })
            .state('declaracaoMensalServicoInstituicaoFinanceira.new', {
                parent: 'declaracaoMensalServicoInstituicaoFinanceira',
                url: '/declarar-if/{mes}/{ano}',
                data: {
                    roles: ['ROLE_EMPRESA_DMS'],
                    pageTitle: 'Declaração Mensal de Serviços de Instituições Financeiras'
                },
                ncyBreadcrumb: {
                    label: 'Nova DMS-IF'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/declaracaoMensalServicoInstituicaoFinanceira/declaracaoMensalServicoInstituicaoFinanceira-edit.html',
                        controller: 'DeclaracaoMensalServicoInstituicaoFinanceiraEditController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('declaracaoMensalServico');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'localStorageService', function ($stateParams, localStorageService) {
                        return {
                            id: null,
                            codigo: null,
                            competencia: null,
                            tipo: null,
                            tipoMovimento: 'NORMAL',
                            prestador: localStorageService.get("prestadorPrincipal"),
                            notas: [],
                            mes: $stateParams.mes,
                            exercicio: $stateParams.ano,
                        };
                    }]
                }
            })
            .state('declaracaoMensalServicoInstituicaoFinanceira.import', {
                parent: 'declaracaoMensalServicoInstituicaoFinanceira',
                url: '/importacao-desif',
                data: {
                    roles: ['ROLE_EMPRESA_DMS'],
                    pageTitle: 'Importação Desif'
                },
                ncyBreadcrumb: {
                    label: 'Importação de Cosif via Arquivo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/declaracaoMensalServicoInstituicaoFinanceira/declaracaoMensalServicoInstituicaoFinanceira-import.html',
                        controller: 'DeclaracaoMensalServicoInstituicaoFinanceiraImportController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }

            })
            .state('declaracaoMensalServicoInstituicaoFinanceira.detail', {
                parent: 'declaracaoMensalServicoInstituicaoFinanceira',
                url: '/declararacao-if/detail/:id',
                data: {
                    roles: ['ROLE_EMPRESA_DMS'],
                    pageTitle: 'Detalhes da Declaração Mensal de Serviço de Instituição Financeira'
                },
                ncyBreadcrumb: {
                    label: 'Declaração Mensal de Serviço de Instituição Financeira'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/declaracaoMensalServicoInstituicaoFinanceira/declaracaoMensalServicoInstituicaoFinanceira-detail.html',
                        controller: 'DeclaracaoMensalServicoInstituicaoFinanceiraDetailController'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'DeclaracaoMensalServico',
                        function ($stateParams, DeclaracaoMensalServico) {
                            return DeclaracaoMensalServico.get({id: $stateParams.id}).$promise;
                        }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('DeclaracaoMensalServicoInstituicaoFinanceiraController',
        function ($scope, DeclaracaoMensalServico, DeclaracaoMensalServicoSearch, ParseLinks,
                  Notificacao, ImpressaoPdf, NotaFiscal, localStorageService, $modal,
                  Util) {

            $scope.declaracaoMensalServicos = [];
            $scope.page = 1;
            $scope.per_page = 999;
            $scope.exerciciosDeclarados = [];
            $scope.empresa = localStorageService.get("prestadorPrincipal");
            $scope.meses = Util.getMeses();
            $scope.exercicio = Util.getExercicioAtual();
            $scope.mesInicial = Util.getMesAtual();
            $scope.mesFinal = $scope.mesInicial;

            function montarConsultaGenerica(ano, mes) {
                var campos = [];

                campos.push({
                    campo: $scope.empresa.prestador.foraMunicipio ? "dms.prestadorforamunicipio_id" : "dms.prestador_id",
                    operador: "IGUAL",
                    valorLong: $scope.empresa.prestador.id
                });

                campos.push({
                    campo: "e.ano",
                    operador: "IGUAL",
                    valorInteger: ano
                });

                campos.push({
                    campo: "dms.mes",
                    operador: "IGUAL",
                    valorString: Util.getNameMesFromNumero(mes)
                });

                campos.push({
                    campo: "dms.tipomovimento",
                    operador: "IGUAL",
                    valorString: "INSTITUICAO_FINANCEIRA"
                });

                return {
                    offset: $scope.page,
                    limit: $scope.per_page,
                    parametrosQuery: [{
                        juncao: " and ",
                        parametroQueryCampos: campos
                    }],
                    orderBy: " order by dms.id desc "
                };
            }

            $scope.loadAll = function () {
                $scope.exerciciosDeclarados = [];

                var exercicioDeclarado = {ano: $scope.exercicio, mesesDeclarados: []};

                for (var j = $scope.mesInicial.numeroMes; j <= $scope.mesFinal.numeroMes; j++) {
                    var mesDeclarado = {mes: j, declaracoes: []};
                    exercicioDeclarado.mesesDeclarados.push(mesDeclarado);
                }
                exercicioDeclarado.mesesDeclarados.sort(function (a, b) {
                    return b.mes - a.mes;
                });
                $scope.exerciciosDeclarados.push(exercicioDeclarado);

                $scope.exerciciosDeclarados.sort(function (a, b) {
                    return b.ano - a.ano;
                });

                angular.forEach($scope.exerciciosDeclarados, function (exercicio) {
                    angular.forEach(exercicio.mesesDeclarados, function (mes) {
                        DeclaracaoMensalServico.consultar(montarConsultaGenerica(exercicio.ano, mes.mes), function (result) {
                            mes.declaracoes = result;
                        });
                    })
                });
            };

            $scope.loadAll();

            $scope.getMesPorNumero = function (numero) {
                for (var i = 0; i < $scope.meses.length; i++) {
                    if ($scope.meses[i].numeroMes === numero) {
                        return $scope.meses[i].descricao;
                    }
                }
            };

            $scope.loadPage = function (page) {
                $scope.page = page;
                $scope.loadAll();
            };


            $scope.delete = function (id) {
                DeclaracaoMensalServico.get({id: id}, function (result) {
                    $scope.declaracaoMensalServico = result;

                    Notificacao.confirmDelete(
                        function (success) {
                            console.log('Notificacao.confirmDelete - success: ', success);
                            $scope.confirmDelete(id);
                        },
                        function (error) {
                            console.log('Notificacao.confirmDelete - error: ', error);
                        }
                    );
                });
            };

            $scope.confirmDelete = function (id) {
                DeclaracaoMensalServico.delete({id: id},
                    function () {
                        $scope.loadAll();
                        $scope.clear();
                    });
            };

            $scope.refresh = function () {
                $scope.loadAll();
                $scope.clear();
            };

            $scope.clear = function () {
                $scope.declaracaoMensalServico = {codigo: null, competencia: null, id: null};
            };

            $scope.imprimirDam = function (declaracao) {
                if (new Date(declaracao.vencimento).getTime() > new Date().getTime()) {
                    ImpressaoPdf.imprimirPdfViaPost('/api/imprimir-dam-declaracao', {
                        idDeclaracao: declaracao.id,
                        idPrestador: $scope.empresa.prestador.id,
                        vencimentoDam: null
                    });
                } else {
                    var modal = $modal.open({
                        templateUrl: 'app/entities/declaracaoMensalServico/emissaoGuia.html',
                        controller: 'EmissaoGuiaController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    idDeclaracao: declaracao.id,
                                    idPrestador: $scope.empresa.prestador.id,
                                    vencimentoDam: new Date()
                                };
                            }
                        }
                    });
                    modal.result.then(function (data) {
                    });
                }
            };

            $scope.imprimeRelatorioDMS = function (ano, mes) {
                ImpressaoPdf.imprimirPdfViaUrl('/api/imprimir-relatorio-dms/' + ano + "/" + mes+"/PRESTADO/INSTITUICAO_FINANCEIRA");
            };

            $scope.cancelar = function (id) {
                Notificacao.confirm('Atenção!', 'Tem certeza que deseja cancelar essa declaração!', 'warning',
                    function () {
                        DeclaracaoMensalServico.cancelar({id: id}, function () {
                            $scope.loadAll();
                            Notificacao.info('Operação Realizada.', 'Declaração Mensal de Serviço Cancelada!');
                        });
                    })
            };

            $scope.emitirProtocoloRecebimentoDms = function (id) {
                ImpressaoPdf.imprimirPdfViaUrl('/api/emitir-protocolo-declaracao/' + id);
            };
        })
;

'use strict';

angular.module('nfseApp').controller('DeclaracaoMensalServicoCartorioEditController',
    function ($scope, entity, PrestadorServicos, localStorageService,
              DeclaracaoMensalServico, $timeout, Notificacao, $state) {
        $scope.declaracaoMensalServico = entity;
        $scope.meses = [];
        $scope.itensCartorio = [];
        $scope.quantidadeServicosDeclarados = 0;
        $scope.totalDeclarado = 0;
        $scope.totalIss = 0;

        $scope.acessarCompetencia = acessarCompetencia;
        $scope.atualizarContadores = atualizarContadores;
        $scope.save = save;
        $scope.getTextoBotaoSalvar = getTextoBotaoSalvar;
        $scope.meses = [];

        function carregar() {
            PrestadorServicos.get({id: localStorageService.get("prestadorPrincipal").prestador.id}, function (prestador) {
                $scope.prestador = prestador;
                DeclaracaoMensalServico.getMeses({},
                    function (data) {
                        $scope.meses = data;
                        angular.forEach(data, function (mes) {
                            if (mes.numeroMes == $scope.declaracaoMensalServico.mes) {
                                $scope.declaracaoMensalServico.mes = mes;
                                acessarCompetencia();
                            }
                        });
                    });
            });
        }

        carregar();

        function onSaveFinished() {
            Notificacao.priority("Registro salvo com sucesso", "");
            $state.go('declaracaoMensalServicoCartorio');
        }

        function save() {
            var editDTO = {
                id: $scope.declaracaoMensalServico.id,
                mes: $scope.declaracaoMensalServico.mes.numeroMes,
                exercicio: $scope.declaracaoMensalServico.exercicio,
                tipo: 'PRINCIPAL',
                itensCartorio: [],
                prestador: $scope.prestador,
                qtdNotas: $scope.quantidadeServicosDeclarados,
                totalServicos: $scope.totalDeclarado,
                totalIss: $scope.totalIss,
                abertura: new Date(),
                tipoMovimento: 'CARTORIO',
                encerramento: new Date()
            };

            for (var i = 0; i < $scope.itensCartorio.length; i++) {
                if ($scope.itensCartorio[i].valor > 0) {
                    editDTO.itensCartorio.push($scope.itensCartorio[i]);
                }
            }

            if (!editDTO.itensCartorio || editDTO.itensCartorio.length === 0) {
                SweetAlert.swal({
                        title: "Declaração de Ausência de Movimento",
                        text: "Você tem certeza que deseja declarar ausência de movimento para o período " +
                            $scope.declaracaoMensalServico.mes.descricao + "/" + $scope.declaracaoMensalServico.exercicio + "?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55", confirmButtonText: "Sim, Declarar",
                        cancelButtonText: "Não, Cancelar",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            $timeout(DeclaracaoMensalServico.save(editDTO, onSaveFinished), 1000);
                        }
                    });
            } else {
                $timeout(DeclaracaoMensalServico.save(editDTO, onSaveFinished), 1000);
            }
        }

        function acessarCompetencia() {
            PrestadorServicos.buscarServicosCartorio({}, function (result) {
                $scope.itensCartorio = [];
                for (var i = 0; i < result.length; i++) {
                    $scope.itensCartorio.push({tipoCartorioServico: result[i], valor: 0.0});
                }
            });
            atualizarContadores();
        }

        function atualizarContadores() {
            $scope.quantidadeServicosDeclarados = 0;
            $scope.totalDeclarado = 0;
            $scope.totalIss = 0;
            for (var i = 0; i < $scope.itensCartorio.length; i++) {
                if ($scope.itensCartorio[i].valor > 0) {
                    $scope.quantidadeServicosDeclarados = $scope.quantidadeServicosDeclarados + 1;
                    $scope.totalDeclarado = $scope.totalDeclarado + $scope.itensCartorio[i].valor;
                    $scope.totalIss = $scope.totalIss + ($scope.itensCartorio[i].valor *
                        ($scope.itensCartorio[i].tipoCartorioServico.servico.aliquota / 100));
                }
            }
        }

        function getTextoBotaoSalvar() {
            if ($scope.totalIss === 0) {
                return "Declarar Ausência de Movimento";
            }
            return "Encerrar Declaração";
        }
    });


'use strict';

angular.module('nfseApp').controller('DeclaracaoMensalServicoCartorioDetailController',
    function ($scope, entity, DeclaracaoMensalServico) {
        $scope.declaracaoMensalServico = entity;
        $scope.itens = [];
        $scope.totalDeclarado = 0;
        $scope.totalIss = 0;

        $scope.buscarItensDeclaracaoServico = function () {
            DeclaracaoMensalServico.buscarItensDeclaracaoServico({
                    idDeclaracaoMensalServico: $scope.declaracaoMensalServico.id
                },
                function (data) {
                    $scope.itens = data;
                    $scope.itens.forEach(function (item) {
                        $scope.totalDeclarado = $scope.totalDeclarado + item.valorServico;
                        $scope.totalIss = $scope.totalIss + item.iss;
                    });
                }
            );
        };

        $scope.buscarItensDeclaracaoServico();
    });


'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('declaracaoMensalServicoCartorio', {
                parent: 'entity',
                url: '/dms-cartorio',
                data: {
                    roles: ['ROLE_EMPRESA_DMS'],
                    pageTitle: 'Declaração Mensal de Serviços (Cartório)'
                },
                ncyBreadcrumb: {
                    label: 'Consulta DMS (Cartório)'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/declaracaoMensalServicoCartorio/declaracaoMensalServicoCartorio.html',
                        controller: 'DeclaracaoMensalServicoCartorioController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('declaracaoMensalServico');
                        $translatePartialLoader.addPart('situacaoDeclaracaoMensal');
                        $translatePartialLoader.addPart('situacaoParcela');
                        $translatePartialLoader.addPart('tipoDeclaracaoMensal');
                        $translatePartialLoader.addPart('tipoMovimentoMensal');
                        $translatePartialLoader.addPart('mes');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('declaracaoMensalServicoCartorio.new', {
                parent: 'declaracaoMensalServicoCartorio',
                url: '/dms-cartorio/{mes}/{ano}',
                data: {
                    roles: ['ROLE_EMPRESA_DMS'],
                    pageTitle: 'Declaração Mensal de Serviços (Cartório)'
                },
                ncyBreadcrumb: {
                    label: 'Nova DMS (Cartório)'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/declaracaoMensalServicoCartorio/declaracaoMensalServicoCartorio-edit.html',
                        controller: 'DeclaracaoMensalServicoCartorioEditController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('declaracaoMensalServico');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'localStorageService', function ($stateParams, localStorageService) {
                        return {
                            tipoMovimento: 'CARTORIO',
                            prestador: localStorageService.get("prestadorPrincipal"),
                            mes: $stateParams.mes,
                            exercicio: $stateParams.ano,
                        };
                    }]
                }
            })
            .state('declaracaoMensalServicoCartorio.detail', {
                parent: 'declaracaoMensalServicoCartorio',
                url: '/detalhes/{id}',
                data: {
                    roles: ['ROLE_EMPRESA_DMS'],
                    pageTitle: 'Detalhes da Declaração Mensal de Serviços (Cartório)'
                },
                ncyBreadcrumb: {
                    label: 'Detalhes da Declaração Mensal de Serviços (Cartório)'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/declaracaoMensalServicoCartorio/declaracaoMensalServicoCartorio-detail.html',
                        controller: 'DeclaracaoMensalServicoCartorioDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('declaracaoMensalServico');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['DeclaracaoMensalServico', '$stateParams', function (DeclaracaoMensalServico, $stateParams) {
                        return DeclaracaoMensalServico.get({id: $stateParams.id}).$promise;
                    }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('DeclaracaoMensalServicoCartorioController',
        function ($scope, DeclaracaoMensalServico, Notificacao,
                  ImpressaoPdf, localStorageService,
                  Util, $modal) {
            $scope.declaracaoMensalServicos = [];
            $scope.page = 1;
            $scope.per_page = 999;
            $scope.exerciciosDeclarados = [];
            $scope.empresa = localStorageService.get("prestadorPrincipal");
            $scope.meses = Util.getMeses();
            $scope.exercicio = Util.getExercicioAtual();
            $scope.mesInicial = Util.getMesAtual();
            $scope.mesFinal = $scope.mesInicial;


            function montarConsultaGenerica(ano, mes) {
                var campos = [];

                campos.push({
                    campo: $scope.empresa.prestador.foraMunicipio ? "dms.prestadorforamunicipio_id" : "dms.prestador_id",
                    operador: "IGUAL",
                    valorLong: $scope.empresa.prestador.id
                });

                campos.push({
                    campo: "e.ano",
                    operador: "IGUAL",
                    valorInteger: ano
                });

                campos.push({
                    campo: "dms.mes",
                    operador: "IGUAL",
                    valorString: Util.getNameMesFromNumero(mes)
                });

                campos.push({
                    campo: "dms.tipomovimento",
                    operador: "IGUAL",
                    valorString: "CARTORIO"
                });

                return {
                    offset: $scope.page,
                    limit: $scope.per_page,
                    parametrosQuery: [{
                        juncao: " and ",
                        parametroQueryCampos: campos
                    }],
                    orderBy: " order by dms.id desc "
                };
            }

            $scope.loadAll = function () {
                $scope.exerciciosDeclarados = [];

                var exercicioDeclarado = {ano: $scope.exercicio, mesesDeclarados: []};

                for (var j = $scope.mesInicial.numeroMes; j <= $scope.mesFinal.numeroMes; j++) {
                    var mesDeclarado = {mes: j, declaracoes: []};
                    exercicioDeclarado.mesesDeclarados.push(mesDeclarado);
                }
                exercicioDeclarado.mesesDeclarados.sort(function (a, b) {
                    return b.mes - a.mes;
                });
                $scope.exerciciosDeclarados.push(exercicioDeclarado);

                $scope.exerciciosDeclarados.sort(function (a, b) {
                    return b.ano - a.ano;
                });

                angular.forEach($scope.exerciciosDeclarados, function (exercicio) {
                    angular.forEach(exercicio.mesesDeclarados, function (mes) {
                        DeclaracaoMensalServico.consultar(montarConsultaGenerica(exercicio.ano, mes.mes), function (result) {
                            mes.declaracoes = result;
                        });
                    })
                });
            };

            $scope.loadAll();


            $scope.getMesPorNumero = function (numero) {
                for (var i = 0; i < $scope.meses.length; i++) {
                    if ($scope.meses[i].numeroMes === numero) {
                        return $scope.meses[i].descricao;
                    }
                }
            };

            $scope.loadPage = function (page) {
                $scope.page = page;
                $scope.loadAll();
            };

            $scope.refresh = function () {
                $scope.loadAll();
                $scope.clear();
            };

            $scope.clear = function () {
                $scope.declaracaoMensalServico = {codigo: null, competencia: null, id: null};
            };

            $scope.imprimirDam = function (declaracao) {
                if (new Date(declaracao.vencimento).getTime() > new Date().getTime()) {
                    ImpressaoPdf.imprimirPdfViaPost('/api/imprimir-dam-declaracao', {
                        idDeclaracao: declaracao.id,
                        idPrestador: $scope.empresa.prestador.id,
                        vencimentoDam: null
                    });
                } else {
                    var modal = $modal.open({
                        templateUrl: 'app/entities/declaracaoMensalServico/emissaoGuia.html',
                        controller: 'EmissaoGuiaController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    idDeclaracao: declaracao.id,
                                    idPrestador: $scope.empresa.prestador.id,
                                    vencimentoDam: new Date()
                                };
                            }
                        }
                    });
                    modal.result.then(function (data) {
                    });
                }
            };

            $scope.imprimeRelatorioDMS = function (ano, mes) {
                ImpressaoPdf.imprimirPdfViaUrl('/api/imprimir-relatorio-dms/' + ano + "/" + mes + "/PRESTADO/CARTORIO");
            };

            $scope.hasDeclaracaoNaoCancelada = function (declaracoes) {
                for (var i = 0; i < declaracoes.length; i++) {
                    if (declaracoes[i].situacao != 'CANCELADO')
                        return true;
                }
                return false;
            };

            $scope.cancelar = function (id) {
                Notificacao.confirm('Atenção!', 'Tem certeza que deseja cancelar essa declaração!', 'warning',
                    function () {
                        DeclaracaoMensalServico.cancelar({id: id}, function () {
                            $scope.loadAll();
                            Notificacao.info('Operação Realizada.', 'Declaração Mensal de Serviço Cancelada!');
                        });
                    })
            };
        })
;

(function () {
    'use strict';

    angular.module('nfseApp')
        .controller('PesquisaNotasEmitidasController', function ($scope, $modalInstance, entity, NotaFiscal, ParseLinks) {

            $scope.page;
            $scope.per_page = 10;
            $scope.declaracaoMensalServico = entity;
            $scope.notas;
            $scope.notasSelecionadas;
            $scope.links;

            $scope.buscarNotas = function () {
                NotaFiscal.buscarNotasSemDeclaracaoPorCompetencia({
                    page: $scope.page - 1,
                    per_page: $scope.per_page,
                    idPrestador: $scope.declaracaoMensalServico.prestador.id,
                    foraMunicipio: $scope.declaracaoMensalServico.prestador.foraMunicipio,
                    ano: $scope.declaracaoMensalServico.exercicio,
                    mes: $scope.declaracaoMensalServico.mes,
                    tipoMovimento: $scope.declaracaoMensalServico.tipoMovimento
                }, function (result, headers) {
                    if (headers)
                        $scope.links = ParseLinks.parse(headers('link'));
                    $scope.notas = result;
                    console.log($scope.notas);
                });
            };

            $scope.buscarNotas();

            $scope.loadPage = function (page) {
                $scope.page = page;
                $scope.buscarNotas();
            };

            $scope.selecionarNota = function (nota) {
                console.log(nota.id);
                if (!$scope.notasSelecionadas) {
                    $scope.notasSelecionadas = [];
                }
                var index = $scope.indexNotaSelecionada(nota);
                if (index >= 0) {
                    $scope.notasSelecionadas.splice(index, 1);
                } else {
                    $scope.notasSelecionadas.push(nota);
                }
            };

            $scope.indexNotaSelecionada = function (nota) {
                if ($scope.notasSelecionadas) {
                    for (var i = 0; i < $scope.notasSelecionadas.length; i++) {
                        if ($scope.notasSelecionadas[i].id == nota.id) {
                            return i;
                        }
                    }
                }
                return -1;
            };

            $scope.ok = function () {
                $modalInstance.close($scope.notasSelecionadas);
            };

            $scope.cancel = function() {
                $modalInstance.dismiss('cancel');
            };
        })
})();

(function () {
    'use strict';

    angular.module('nfseApp')
        .controller('EmissaoGuiaController', function ($scope, $modalInstance, entity, Notificacao, DateUtils, ImpressaoPdf) {
            $scope.emissaoDam = entity;

            $scope.imprimirDam = function () {
                if ($scope.emissaoDam.vencimentoDam == null) {
                    Notificacao.warn("Atenção", "O campo Vencimento da Guia deve ser informado.")
                } else if (DateUtils.zerarTempo($scope.emissaoDam.vencimentoDam).getTime() < DateUtils.zerarTempo(new Date()).getTime()) {
                    Notificacao.warn("Atenção", "O Vencimento da Guia não pode ser inferior a hoje.")
                } else {
                    ImpressaoPdf.imprimirPdfViaPost('/api/imprimir-dam-declaracao', $scope.emissaoDam);
                    $scope.cancel();
                }
            };

            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };
        })
})();

'use strict';

angular.module('nfseApp').controller('DeclaracaoMensalServicoEditController',
    function ($scope, $state, $timeout, $stateParams, DeclaracaoMensalServico, NotaFiscal,
              Notificacao, localStorageService, $modal, SweetAlert) {

        $scope.per_page = 10;
        $scope.ano = $stateParams.ano;
        $scope.mes = $stateParams.mes;
        $scope.tipoMovimento = 'NORMAL';
        $scope.notas = [];
        $scope.meses = DeclaracaoMensalServico.getMeses();
        $scope.declaracaoMensalServico = null;

        function carregar() {
            $scope.prestador = localStorageService.get("prestadorPrincipal").prestador;

            DeclaracaoMensalServico.getMeses({},
                function (data) {
                    $scope.meses = data;
                    angular.forEach(data, function (mes) {
                        if (mes.numeroMes == $scope.mes) {
                            $scope.mes = mes;
                            $scope.acessarCompetencia();
                        }
                    });
                });
        }

        carregar();

        var onSaveFinished = function (result) {
            Notificacao.priority("Registro salvo com sucesso", "");
            $scope.$emit('nfseApp:declaracaoMensalServicoUpdate', result);
            $scope.$emit('nfseApp:navbarUpdate');
            $state.go('declaracaoMensalServico');
        };

        $scope.save = function () {
            if ($scope.declaracaoMensalServico.qtdNotas === 0) {
                SweetAlert.swal({
                        title: "Declaração de Ausência de Movimento",
                        text: "Você tem certeza que deseja declarar ausência de movimento para o período " + $scope.declaracaoMensalServico.mes + "/" + $scope.declaracaoMensalServico.exercicio + "?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55", confirmButtonText: "Sim, Declarar",
                        cancelButtonText: "Não, Cancelar",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            SweetAlert.close();
                            DeclaracaoMensalServico.save($scope.declaracaoMensalServico, onSaveFinished);
                        }
                    });
            } else {
                DeclaracaoMensalServico.save($scope.declaracaoMensalServico, onSaveFinished);
            }
        };

        $scope.acessarCompetencia = function () {
            DeclaracaoMensalServico.novaDms({
                    mes: $scope.mes.numeroMes,
                    ano: $scope.ano,
                    tipoMovimento: $scope.tipoMovimento,
                    empresaId: $scope.prestador.id,
                    foraMunicipio: $scope.prestador.foraMunicipio
                },
                function (result) {
                    $scope.declaracaoMensalServico = result;
                }
            );
        };

        $scope.selecionarNotas = function () {
            var modal = $modal.open({
                templateUrl: 'app/entities/declaracaoMensalServico/pesquisaNotasEmitidas.html',
                controller: 'PesquisaNotasEmitidasController',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tipoDocumento');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return $scope.declaracaoMensalServico;
                    }
                }
            });
            modal.result.then(function (data) {
                if (data) {
                    $scope.declaracaoMensalServico.notas = data;
                    $scope.declaracaoMensalServico.qtdNotas = 0;
                    $scope.declaracaoMensalServico.totalServicos = 0;
                    $scope.declaracaoMensalServico.totalIssCalculado = 0;
                    $scope.declaracaoMensalServico.totalIssRetido = 0;
                    $scope.declaracaoMensalServico.totalIss = 0;
                    for (var i = 0; i < $scope.declaracaoMensalServico.notas.length; i++) {
                        $scope.declaracaoMensalServico.qtdNotas = $scope.declaracaoMensalServico.qtdNotas + 1;
                        $scope.declaracaoMensalServico.totalServicos = $scope.declaracaoMensalServico.totalServicos +
                            $scope.declaracaoMensalServico.notas[i].totalServicos;
                        $scope.declaracaoMensalServico.totalIssCalculado = $scope.declaracaoMensalServico.totalIssCalculado +
                            $scope.declaracaoMensalServico.notas[i].issCalculado;
                        $scope.declaracaoMensalServico.totalIssRetido = $scope.declaracaoMensalServico.totalIssRetido +
                            $scope.declaracaoMensalServico.notas[i].issRetido;
                        $scope.declaracaoMensalServico.totalIss = $scope.declaracaoMensalServico.totalIss +
                            $scope.declaracaoMensalServico.notas[i].iss;

                    }
                }
            });
        }
    });


'use strict';

angular.module('nfseApp').controller('DeclaracaoMensalServicoDetailController',
    function ($scope, entity, NotaFiscal, ParseLinks) {
        $scope.declaracaoMensalServico = entity;
        $scope.page;
        $scope.per_page = 20;
        $scope.links;
        $scope.notas;

        $scope.buscarNotasNaDeclaracao = function () {
            NotaFiscal.buscarNotasNaDeclaracao({
                    page: $scope.page - 1,
                    per_page: $scope.per_page,
                    idDeclaracaoMensalServico: $scope.declaracaoMensalServico.id
                },
                function (data, headers) {
                    if (headers)
                        $scope.links = ParseLinks.parse(headers('link'));
                    $scope.notas = data;
                }
            );
        };

        $scope.buscarNotasNaDeclaracao();

        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.buscarNotasNaDeclaracao();
        };
    });


'use strict';

angular.module('nfseApp')
    .factory('DeclaracaoMensalServico', function ($resource, DateUtils) {
        function convertDateFromServer(data) {
            if (data.abertura) {
                data.abertura = DateUtils.convertLocaleDateFromServer(data.abertura);
            }
            if (data.encerramento) {
                data.encerramento = DateUtils.convertLocaleDateFromServer(data.encerramento);
            }
            if (data.vencimento) {
                data.vencimento = DateUtils.convertLocaleDateFromServer(data.vencimento);
            }
        }

        function convertDateToServer(data) {
            if (data.abertura) {
                data.abertura = DateUtils.convertLocaleDateToServer(data.abertura);
            }
            if (data.encerramento) {
                data.encerramento = DateUtils.convertLocaleDateToServer(data.encerramento);
            }
        }

        var resource = $resource('api/declaracaoMensalServicos/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    convertDateToServer(data);
                    return angular.toJson(data);
                }
            },
            'getMeses': {
                url: 'api/declaracaoMensalServicos/meses',
                method: 'GET',
                isArray: true
            },
            'getMesesNaoDeclarados': {
                url: 'api/declaracaoMensalServicos/meses_nao_declarados',
                method: 'GET',
                isArray: true
            },
            'getNotasDeclaradasPorCompetenciaEPrestador': {
                url: '/api/nota_declarada_por_competencia_prestador/:idPrestador/:mes/:ano/:tipoMovimento',
                method: 'GET',
                isArray: true
            },
            'novaDms': {
                url: '/api/nova-dms',
                method: 'GET'
            },
            'getNotasDeclaradasPorDMS': {
                url: '/api/nota_declarada_por_dms/:id',
                method: 'GET',
                isArray: true
            },
            'update': {method: 'PUT'},
            'imprimirDam': {
                method: 'GET',
                url: "/api/imprimir-dam/:id",
                headers: {
                    accept: 'application/pdf'
                },
                responseType: 'arraybuffer',
                cache: true,
            },
            'getEstatisticasDeclaradas': {
                url: '/api/estatistica-mensal-declarada',
                method: 'GET',
                isArray: true
            },
            'cancelar': {
                url: '/api/cancelar-declaracao-mensal-servico/:id',
                method: 'GET'
            },
            'importarDesif': {
                url: '/api/importar-desif',
                method: 'POST'
            },
            'emitirProtocoloRecebimentoDms': {
                method: 'GET',
                url: "/api/emitir-protocolo-declaracao/:id",
                headers: {
                    accept: 'application/pdf'
                },
                responseType: 'arraybuffer',
                cache: true
            },
            'buscarItensDeclaracaoServico': {
                method: 'GET',
                url: '/api/itens-declaracao-servico',
                isArray: true
            },
            'consultar': {
                method: 'POST',
                url: '/api/declaracaoMensalServicos/consultar',
                isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    if (data)
                        for (var i = 0; i < data.length; i++) {
                            var dms = data[i];
                            convertDateFromServer(dms);
                        }
                    return data;
                }
            }
        });

        return resource;
    });

'use strict';

angular.module('nfseApp')
    .factory('DeclaracaoMensalServicoSearch', function ($resource) {
        return $resource('api/_search/declaracaoMensalServicos/:query', {}, {
            'query': { method: 'GET', isArray: true}
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('declaracaoMensalServico', {
                parent: 'entity',
                url: '/dms',
                data: {
                    roles: ['ROLE_EMPRESA_DMS'],
                    pageTitle: 'Declaração Mensal de Serviços'
                },
                ncyBreadcrumb: {
                    label: 'Consulta DMS'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/declaracaoMensalServico/declaracaoMensalServicos.html',
                        controller: 'DeclaracaoMensalServicoController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('declaracaoMensalServico');
                        $translatePartialLoader.addPart('situacaoDeclaracaoMensal');
                        $translatePartialLoader.addPart('situacaoParcela');
                        $translatePartialLoader.addPart('tipoDeclaracaoMensal');
                        $translatePartialLoader.addPart('tipoMovimentoMensal');
                        $translatePartialLoader.addPart('mes');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('declaracaoMensalServico.new', {
                parent: 'declaracaoMensalServico',
                url: '/declarar/{mes}/{ano}',
                data: {
                    roles: ['ROLE_EMPRESA_DMS'],
                    pageTitle: 'Declaração Mensal de Serviços'
                },
                ncyBreadcrumb: {
                    label: 'Nova DMS'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/declaracaoMensalServico/declaracaoMensalServico-edit.html',
                        controller: 'DeclaracaoMensalServicoEditController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('declaracaoMensalServico');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('tipoDocumento');
                        return $translate.refresh();
                    }]
                }
            })
            .state('declaracaoMensalServico.detail', {
                parent: 'declaracaoMensalServico',
                url: '/detalhes/{id}',
                data: {
                    roles: ['ROLE_EMPRESA_DMS'],
                    pageTitle: 'Detalhes da Declaração Mensal de Serviços'
                },
                ncyBreadcrumb: {
                    label: 'Detalhes da Declaração Mensal de Serviços'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/declaracaoMensalServico/declaracaoMensalServico-detail.html',
                        controller: 'DeclaracaoMensalServicoDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('declaracaoMensalServico');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('tipoDocumento');
                        return $translate.refresh();
                    }],
                    entity: ['DeclaracaoMensalServico', '$stateParams', function (DeclaracaoMensalServico, $stateParams) {
                        return DeclaracaoMensalServico.get({id: $stateParams.id}).$promise;
                    }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('DeclaracaoMensalServicoController',
        function ($scope, DeclaracaoMensalServico, DeclaracaoMensalServicoSearch, ParseLinks,
                  Notificacao, ImpressaoPdf, NotaFiscal, localStorageService, Util, $modal) {

            $scope.declaracaoMensalServicos = [];
            $scope.page = 1;
            $scope.per_page = 999;
            $scope.exerciciosDeclarados = [];
            $scope.empresa = localStorageService.get("prestadorPrincipal");
            $scope.meses = Util.getMeses();
            $scope.exercicio = Util.getExercicioAtual();
            $scope.mesInicial = Util.getMesAtual();
            $scope.mesFinal = $scope.mesInicial;

            function montarConsultaGenerica(ano, mes) {
                var campos = [];

                campos.push({
                    campo: $scope.empresa.prestador.foraMunicipio ? "dms.prestadorforamunicipio_id" : "dms.prestador_id",
                    operador: "IGUAL",
                    valorLong: $scope.empresa.prestador.id
                });

                campos.push({
                    campo: "e.ano",
                    operador: "IGUAL",
                    valorInteger: ano
                });

                campos.push({
                    campo: "dms.mes",
                    operador: "IGUAL",
                    valorString: Util.getNameMesFromNumero(mes)
                });

                campos.push({
                    campo: "dms.tipomovimento",
                    operador: "IGUAL",
                    valorString: "NORMAL"
                });

                return {
                    offset: $scope.page,
                    limit: $scope.per_page,
                    parametrosQuery: [{
                        juncao: " and ",
                        parametroQueryCampos: campos
                    }],
                    orderBy: " order by dms.id desc "
                };
            }

            $scope.loadAll = function () {
                $scope.exerciciosDeclarados = [];

                var exercicioDeclarado = {ano: $scope.exercicio, mesesDeclarados: []};

                for (var j = $scope.mesInicial.numeroMes; j <= $scope.mesFinal.numeroMes; j++) {
                    var mesDeclarado = {mes: j, declaracoes: []};
                    exercicioDeclarado.mesesDeclarados.push(mesDeclarado);
                }
                exercicioDeclarado.mesesDeclarados.sort(function (a, b) {
                    return b.mes - a.mes;
                });
                $scope.exerciciosDeclarados.push(exercicioDeclarado);

                $scope.exerciciosDeclarados.sort(function (a, b) {
                    return b.ano - a.ano;
                });

                angular.forEach($scope.exerciciosDeclarados, function (exercicio) {
                    angular.forEach(exercicio.mesesDeclarados, function (mes) {
                        DeclaracaoMensalServico.consultar(montarConsultaGenerica(exercicio.ano, mes.mes), function (result) {
                            mes.declaracoes = result;
                        });
                    })
                });
            };

            $scope.loadAll();


            $scope.getMesPorNumero = function (numero) {
                for (var i = 0; i < $scope.meses.length; i++) {
                    if ($scope.meses[i].numeroMes === numero) {
                        return $scope.meses[i].descricao;
                    }
                }
            };

            $scope.loadPage = function (page) {
                $scope.page = page;
                $scope.loadAll();
            };


            $scope.delete = function (id) {
                DeclaracaoMensalServico.get({id: id}, function (result) {
                    $scope.declaracaoMensalServico = result;

                    Notificacao.confirmDelete(
                        function (success) {
                            console.log('Notificacao.confirmDelete - success: ', success);
                            $scope.confirmDelete(id);
                        },
                        function (error) {
                            console.log('Notificacao.confirmDelete - error: ', error);
                        }
                    );
                });
            };

            $scope.confirmDelete = function (id) {
                DeclaracaoMensalServico.delete({id: id},
                    function () {
                        $scope.loadAll();
                        $scope.clear();
                    });
            };


            $scope.refresh = function () {
                $scope.loadAll();
                $scope.clear();
            };

            $scope.clear = function () {
                $scope.declaracaoMensalServico = {codigo: null, competencia: null, id: null};
            };

            $scope.imprimirDam = function (declaracao) {
                if (new Date(declaracao.vencimento).getTime() > new Date().getTime()) {
                    ImpressaoPdf.imprimirPdfViaPost('/api/imprimir-dam-declaracao', {
                        idDeclaracao: declaracao.id,
                        idPrestador: $scope.empresa.prestador.id,
                        vencimentoDam: null
                    });
                } else {
                    var modal = $modal.open({
                        templateUrl: 'app/entities/declaracaoMensalServico/emissaoGuia.html',
                        controller: 'EmissaoGuiaController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    idDeclaracao: declaracao.id,
                                    idPrestador: $scope.empresa.prestador.id,
                                    vencimentoDam: new Date()
                                };
                            }
                        }
                    });
                    modal.result.then(function (data) {
                    });
                }
            };

            $scope.imprimeRelatorioDMS = function (ano, mes) {
                ImpressaoPdf.imprimirPdfViaUrl('/api/imprimir-relatorio-dms/' + ano + "/" + mes + "/PRESTADO/NORMAL");
            };

            $scope.hasDeclaracaoNaoCancelada = function (declaracoes) {
                for (var i = 0; i < declaracoes.length; i++) {
                    if (declaracoes[i].situacao != 'CANCELADO')
                        return true;
                }
                return false;
            };

            $scope.cancelar = function (id) {
                Notificacao.confirm('Atenção!', 'Tem certeza que deseja cancelar essa declaração!', 'warning',
                    function () {
                        DeclaracaoMensalServico.cancelar({id: id}, function () {
                            $scope.loadAll();
                            Notificacao.info('Operação Realizada.', 'Declaração Mensal de Serviço Cancelada!');
                        });
                    })
            };

            $scope.emitirProtocoloRecebimentoDms = function (id) {
                ImpressaoPdf.imprimirPdfViaUrl('/api/emitir-protocolo-declaracao/' + id);
            };
        })
;

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('debitos', {
                parent: 'entity',
                url: '/consutar-debitos',
                data: {
                    roles: ['ROLE_EMPRESA_CONTA_CORRENTE'],
                    pageTitle: 'Conta Corrente'
                },
                ncyBreadcrumb: {
                    label: 'Consulta de Débitos'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/debitos/debitos.html',
                        controller: 'DebitosController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('situacaoParcela');
                        return $translate.refresh();
                    }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('DebitosController', function ($scope, PrestadorServicos, ImpressaoPdf, $modal) {

        $scope.debitos = [];
        $scope.page = 1;
        $scope.searchQuery = "";
        $scope.per_page = 10;
        $scope.agrupador = {parcelas: []};
        $scope.hoje = new Date();

        $scope.situacoes = [
            {descricao: 'Em Aberto', value: 'EM_ABERTO'},
            {descricao: 'Pago', value: 'PAGO'},
            {descricao: 'Cancelado', value: 'CANCELAMENTO'},
            {descricao: 'Sem Movimento', value: 'SEM_MOVIMENTO'}
        ];

        $scope.filtro = {situacoes: []};
        $scope.filtro.situacoes.push($scope.situacoes[0]);

        $scope.loadAll = function () {
            $scope.valorImposto = 0;
            $scope.valorTaxa = 0;
            $scope.valorJuros = 0;
            $scope.valorMulta = 0;
            $scope.valorCorrecao = 0;
            $scope.valorHonorarios = 0;
            $scope.valorDesconto = 0;
            $scope.valorPago = 0;
            $scope.total = 0;
            PrestadorServicos.getDebitos(
                {
                    vencimentoInicio: $scope.filtro.vencimentoInicial,
                    vencimentoFim: $scope.filtro.vencimentoFinal,
                    situacoes: $scope.filtro.situacoes.map(function (a) {
                        return a.value;
                    })
                }, function (result, headers) {
                    // $scope.links = ParseLinks.parse(headers('link'));
                    $scope.debitos = result;
                    for (var i = 0; i < result.length; i++) {
                        var debito = result[i];
                        $scope.valorImposto += debito.valorImposto;
                        $scope.valorTaxa += debito.valorTaxa;
                        $scope.valorJuros += debito.valorJuros;
                        $scope.valorMulta += debito.valorMulta;
                        $scope.valorCorrecao += debito.valorCorrecao;
                        $scope.valorHonorarios += debito.valorHonorarios;
                        $scope.valorDesconto += debito.valorDesconto;
                        $scope.valorPago += debito.valorPago;
                        $scope.total += debito.total;

                    }
                }
            )
            ;
        };

        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.refresh = function () {
            $scope.loadAll();
        };

        $scope.imprimirDam = function () {
            PrestadorServicos.buscarDamDaParcela($scope.agrupador, function (dam) {
                console.log(dam);
                ImpressaoPdf.imprimirPdfViaPost('/api/imprimir-dam', dam);
            });

        };

        $scope.adicionarParcela = function (servico) {
            $scope.agrupador.parcelas.push(servico);
        };

        $scope.removerParcela = function (index) {
            $scope.agrupador.parcelas.splice(index, 1);
        };

        $scope.enviarDam = function () {
            var modalEnviarNota = $modal.open({
                templateUrl: 'app/entities/debitos/enviar-dam-email.html',
                controller: 'EnviarDamEmailController',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return $scope.agrupador
                    }
                }
            });
            modalEnviarNota.result.then(function (data) {
                if (data) {
                    console.log(data)
                }
            });
        };

    });


angular.module('nfseApp')
    .controller('EnviarDamEmailController', function ($scope, entity, PrestadorServicos, ParseLinks, SweetAlert, $modalInstance) {
        $scope.agrupador = entity;

        $scope.ok = function () {
            PrestadorServicos.enviarDamDaParcela($scope.agrupador, function (data) {
                $modalInstance.close();
                SweetAlert.info("Enviado", "O email foi enviado aos destinatários");
            }, function (err) {
                SweetAlert.error("Operação não realizada", "não foi possível enviar o email aos destinatários");
            });
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    });

'use strict';

angular.module('nfseApp')
    .controller('TermoCredenciamentoImpressaoController',
    function ($scope, $rootScope, $http, $sce, id, NotaFiscal, $modalInstance) {
        $scope.load = function () {
            $http.get('/api/credenciamento/imprime/' + id, {responseType: 'arraybuffer'})
                .then(function (result) {
                    console.log(result);
                    var file = new Blob([result.data], {type: 'application/pdf'});
                    $scope.pdfUrl = window.URL.createObjectURL(file);
                    $scope.pdfName = 'Nota Fiscal';
                });
        };

        $scope.load();

        $scope.scroll = 0;
        $scope.loading = 'Carregando';

        $scope.onError = function(error) {
            console.log(error);
        };

        $scope.onLoad = function() {
            $scope.loading = '';
        };

        $scope.onProgress = function(progress) {
            console.log(progress);
        };

        $scope.print = function () {
            var canvas = document.getElementById('pdf');
            var win=window.open();
            win.document.write("<br><img src='"+canvas.toDataURL()+"'/>");
            win.print();
            win.location.reload();
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    });

'use strict';

angular.module('nfseApp')
    .controller('DocumentosController', function ($scope, $state, entity, localStorageService) {
        $scope.entity = entity;

        $scope.prestadorPrincipal = localStorageService.get("prestadorPrincipal");

        if ($scope.prestadorPrincipal.permitido) {
            $state.go("home");
        }

        $scope.imprimirTermoCredenciamento = function () {
            $state.go("imprimeTermoCredenciamento", {id: $scope.entity.id});
        }
    }
);

'use strict';

angular.module('nfseApp')
    .factory('Credenciamento', function ($resource, DateUtils) {
        return $resource('api/credenciamento/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('credenciamento', {
                parent: 'entity',
                url: '/credenciamento',
                data: {
                    roles: ['ROLE_CONTRIBUINTE'],
                    pageTitle: 'Cadastro Inicial do Prestador de Serviços'
                },
                ncyBreadcrumb: {
                    label: 'Credenciamento'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/credenciamento/credenciamento.html',
                        controller: 'CredenciamentoController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('prestadorServicos');
                        $translatePartialLoader.addPart('dadosPessoais');
                        $translatePartialLoader.addPart('endereco');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('documentacaoCredenciamento', {
                parent: 'entity',
                url: '/documentos-apresentacao/{id}',
                data: {
                    roles: ['ROLE_CONTRIBUINTE'],
                    pageTitle: 'Documentos para o Credencimento'
                },
                ncyBreadcrumb: {
                    label: 'Documentação'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/credenciamento/documentos.html',
                        controller: 'DocumentosController'
                    },
                    'menu@': {
                        templateUrl: 'app/components/menu/navigation.html',
                        controller: 'NavbarController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('prestadorServicos');
                        $translatePartialLoader.addPart('dadosPessoais');
                        $translatePartialLoader.addPart('endereco');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'PrestadorServicos', function ($stateParams, PrestadorServicos) {
                        return PrestadorServicos.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('imprimeTermoCredenciamento', {
                url: '/impressao-termo-credenciamento/{id}',
                parent: 'documentacaoCredenciamento',
                data: {
                    roles: ['ROLE_CONTRIBUINTE'],
                    pageTitle: 'Documentos para o Credencimento'
                },
                ncyBreadcrumb: {
                    label: 'Detalhes do Termo de Credenciamento'
                },
                onEnter: ['$stateParams', '$state', '$modal', function ($stateParams, $state, $modal) {
                    $modal.open({
                        templateUrl: 'app/entities/credenciamento/termo-credenciamento-impressao.html',
                        controller: 'TermoCredenciamentoImpressaoController',
                        size: 'lg',
                        resolve: {
                            id: function () {
                                return $stateParams.id;
                            }
                        }
                    }).result.then(function () {
                        $state.go('^', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    })
                }]
            })
    });

'use strict';

angular.module('nfseApp')
    .controller('CredenciamentoController', function ($scope, $modal, $cacheFactory, $rootScope, localStorageService,
                                                      Notificacao, Principal, $timeout,
                                                      Credenciamento, ParseLinks, $state, PrestadorServicos,
                                                      Pessoa, Municipio, CEP) {

        $scope.error = null;
        $scope.success = 'OK';

        $timeout(function () {
            angular.element('[ng-model="prestadorServicos.pessoa.dadosPessoais.cpfCnpj"]').focus();
        });


        var onSaveFinished = function (result) {
            Principal.identity(true);
            $scope.$emit('nfseApp:navbarUpdate', result);
            $state.go("home", {}, {reload: true});
            Notificacao.info("Operação Realizada", "Sua solicitação foi encaminhada para um fiscal e assim que aprovada você receberá um email com as instruções de como prosseguir");
        };


        $scope.save = function () {
            PrestadorServicos.vincularUsuarioEmpresa($scope.prestadorServicos, onSaveFinished);
        };

        $scope.loadEnderecoByCEP = function (cep) {
            if (cep) {
                CEP.getByCep({cep: cep}, function (endereco) {
                    $scope.prestadorServicos.pessoa.dadosPessoais.cep = endereco.cep;
                    $scope.prestadorServicos.pessoa.dadosPessoais.municipio = endereco.municipio;
                    $scope.prestadorServicos.pessoa.dadosPessoais.logradouro = endereco.logradouro;
                    $scope.prestadorServicos.pessoa.dadosPessoais.bairro = endereco.bairro;
                });
            }
        };

        $scope.loadMunicipioByCodigo = function (codigo) {
            if (codigo) {
                Municipio.getByCodigo({codigo: codigo}, function (municipio) {
                    if (municipio.id) {
                        $scope.prestadorServicos.pessoa.dadosPessoais.municipio = municipio;
                    } else {
                        Notificacao.warn("Atenção", "Não foi encontrado nenhum Municipio com o código " + codigo);
                        $scope.prestadorServicos.pessoa.dadosPessoais.municipio = {};
                    }
                });
            }
        };

        $scope.searchMunicipio = function () {
            var modalInstance = $modal.open({
                templateUrl: 'app/entities/municipio/municipio-search.html',
                controller: 'MunicipioSearchController',
                size: 'lg'
            });
            modalInstance.result.then(function (municipio) {
                $scope.prestadorServicos.pessoa.dadosPessoais.endereco.municipio = municipio;
            }, function () {
                //$log.info('Modal dismissed at: ' + new Date());
            });
        };

        $scope.loadByCpfCnpj = function () {
            PrestadorServicos.getPorCpfCnpj({cpfCnpj: $scope.cnpj},
                function (result) {
                    $scope.editForm.cpfCnpj.$setValidity("exists", true);
                    $scope.prestadorServicos = result;
                    Notificacao.info("Atenção", "A empresa que você está solicitando acesso já existe como cadastro municipal. Ao continuar sua solicitação sará encaminhada para um fiscal e assim que aprovada você receberá um email com a confirmação");
                }, function (error) {
                    if (error.status === 404) {
                        $state.go("registrarEmpresa", {cpfCnpj: $scope.cnpj});
                        Notificacao.warn("Atenção", "A empresa que você está solicitando ainda não existe como cadastro municipal. Realize a solicitação de cadastro para obter acesso");
                    }

                });
        };

    });

(function () {
    'use strict';

    angular.module('nfseApp').controller('CosifSearchController',
        function ($scope, $state, $modalInstance, Cosif, ParseLinks) {

            $scope.contas = [];
            $scope.filtro = {
                conta: '',
                descricao: ''
            };
            $scope.page;
            $scope.per_page = 10;

            $scope.ok = function (conta) {
                $modalInstance.close(conta);
            };

            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };

            $scope.montarConsulta = function () {
                var campos = [];

                if ($scope.filtro.conta) {
                    campos.push({
                        campo: "obj.conta",
                        operador: "LIKE",
                        valorString: '%' + $scope.filtro.conta + '%'
                    });
                }

                if ($scope.filtro.descricao) {
                    campos.push({
                        campo: "obj.descricao",
                        operador: "LIKE",
                        valorString: '%' + $scope.filtro.descricao + '%'
                    });
                }

                return {
                    offset: $scope.page,
                    limit: $scope.per_page,
                    parametrosQuery: [{
                        juncao: " and ",
                        parametroQueryCampos: campos
                    }]
                };
            };

            $scope.loadAll = function () {
                var consulta = $scope.montarConsulta();
                Cosif.consultar(consulta,
                    function (result, headers) {
                        if (headers)
                            $scope.links = ParseLinks.parse(headers('link'));
                        $scope.contas = result;
                    });
            };

            $scope.loadAll();
        });
})();
'use strict';

angular.module('nfseApp')
    .factory('Cosif', function ($resource) {
        return $resource('api/cosifs/:id', {}, {
            'consultar': {
                url: 'api/cosif/consultar',
                method: 'POST',
                isArray: true
            },
            'buscarPorConta': {
                method: 'GET',
                url: 'api/cosif/buscar-por-conta'
            }
        });
    });

'use strict';

angular.module('nfseApp')
    .controller('ConstrucaoCivilEditController', function ($modal, $state, $scope, entity,
                                                           ConstrucaoCivil, localStorageService, CadastroImobiliario,
                                                           Notificacao, CEP, Configuracao, $timeout, Pessoa) {
        $scope.obra = entity;
        $scope.obra.prestador = localStorageService.get("prestadorPrincipal").prestador;
        $scope.inscricaoImovel = null;
        $scope.municipio;
        $scope.profissional;

        $timeout(function () {
            if ($scope.obra.imovel) {
                $scope.inscricaoImovel = $scope.obra.imovel.inscricaoCadastral;
            }
        }, 1000);

        $scope.municipio = Configuracao.get();


        $scope.save = function () {
            ConstrucaoCivil.save($scope.obra, function (data) {
                $state.go('construcaoCivil');
            });
        };

        $scope.buscarImovel = function () {
            if ($scope.inscricaoImovel) {
                CadastroImobiliario.byInscricao({inscricao: $scope.inscricaoImovel}, function (data) {
                    if (data.id) {
                        $scope.obra.imovel = data;
                    } else {
                        $scope.inscricaoImovel = null;
                        Notificacao.warn("Atenção!", "Imóvel não encontrado.");
                    }
                })
            }
        };

        $scope.searchImovel = function () {
            var modalInstance = $modal.open({
                templateUrl: 'app/entities/cadastro-imobiliario/cadastro-imobiliario-search.html',
                controller: 'CadastroImobiliarioSearchController',
                size: 'lg'
            });
            modalInstance.result.then(function (cadastro) {
                CadastroImobiliario.get({id: cadastro.id}, function (data) {
                    console.log(data);
                    if (data && data.id) {
                        $scope.obra.imovel = data;
                        $scope.inscricaoImovel = $scope.obra.imovel.inscricaoCadastral;
                    }
                });
            }, function () {

            });
        };

        $scope.loadEnderecoByCEP = function (cep) {
            if (cep) {
                CEP.getByCep({cep: cep}, function (endereco) {
                    if (endereco.municipio) {
                        $scope.obra.imovel = null;
                        $scope.obra.localizacao.cep = endereco.cep;
                        $scope.obra.localizacao.municipio = endereco.municipio;
                        $scope.obra.localizacao.logradouro = endereco.logradouro;
                        $scope.obra.localizacao.bairro = endereco.bairro;
                    }
                });
            }
        };

        $scope.searchMunicipio = function () {
            var modalInstance = $modal.open({
                templateUrl: 'app/entities/municipio/municipio-search.html',
                controller: 'MunicipioSearchController',
                size: 'lg'
            });
            modalInstance.result.then(function (municipio) {
                $scope.obra.imovel = null;
                $scope.obra.localizacao.municipio = municipio;
                $scope.obra.localizacao.pais = {};
            }, function () {

            });
        };

        $scope.habilitaImovel = function () {
            return $scope.obra &&
                $scope.obra.localizacao &&
                $scope.obra.localizacao.municipio &&
                $scope.obra.localizacao.municipio.id == $scope.municipio.id;
        };

        $scope.novoProfissional = function () {
            $scope.profissional = {};
        };

        $scope.adicionarProfissional = function () {
            if (!$scope.obra.profissionais) {
                $scope.obra.profissionais = [];
            }
            $scope.obra.profissionais.push($scope.profissional);
            $scope.profissional = null;
        };

        $scope.cancelarProfissional = function () {
            $scope.profissional = null;
        };

        $scope.removerProfissional = function (index) {
            Notificacao.confirmDelete(function () {
                $scope.obra.profissionais[index].remover = true;
            });

        };

        $scope.isFisica = function (dadosPessoais) {
            return dadosPessoais &&
                dadosPessoais.cpfCnpj &&
                dadosPessoais.cpfCnpj.replace(/[^\w\s]/gi, '').length == 11;
        }

        $scope.preLoadProfissional = function () {
            if ($scope.profissional.profissional.cpfCnpj) {
                Pessoa.getPorCpfCnpj({cpfCnpj: $scope.profissional.profissional.cpfCnpj}, function (data) {
                    if (data.id) {
                        $scope.profissional.profissional = data.dadosPessoais;
                    }
                })
            }
        };
    });

'use strict';

angular.module('nfseApp')
    .controller('ConstrucaoCivilDetailController', function ($modal, $state, $scope, entity) {
        $scope.obra = entity;
    });

'use strict';

angular.module('nfseApp')
    .factory('ConstrucaoCivil', function ($resource, DateUtils) {
        return $resource('api/construcao-civil/:id', {}, {
            'buscarConstrucaoCivilFromPrestador': {
                method: 'GET',
                url: 'api/construcao-civil/from-prestador',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    if (data.dataAprovacaoProjeto) {
                        data.dataAprovacaoProjeto = new Date(data.dataAprovacaoProjeto);
                    }
                    if (data.dataInicio) {
                        data.dataInicio = new Date(data.dataInicio);
                    }
                    if (data.dataConclusao) {
                        data.dataConclusao = new Date(data.dataConclusao);
                    }
                    return data;
                }
            },
            'buscarConstrucaoCivilByArt': {
                method: 'GET',
                url: 'api/construcao-civil/by-art'
            }
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('construcaoCivil', {
                parent: 'entity',
                url: '/construcao-civil/consultar',
                ncyBreadcrumb: {
                    label: 'Consultar Construção Civil'
                },
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'Construção Civil'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/construcao-civil/construcao-civil.html',
                        controller: 'ConstrucaoCivilController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('construcaoStatus');
                        return $translate.refresh();
                    }]
                }
            })
            .state('construcaoCivil.incluir', {
                parent: 'entity',
                url: '/construcao-civil/incluir',
                ncyBreadcrumb: {
                    label: 'Incluir Construção Civil'
                },
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'Construção Civil'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/construcao-civil/construcao-civil-edit.html',
                        controller: 'ConstrucaoCivilEditController'
                    }
                },
                resolve: {
                    entity: [function () {
                        return {
                            status: "NAO_INICIADA",
                            localizacao: {},
                            profissionais: []
                        };
                    }]
                }
            })
            .state('construcaoCivil.editar', {
                parent: 'entity',
                url: '/construcao-civil/editar/{id}',
                ncyBreadcrumb: {
                    label: 'Incluir Construção Civil'
                },
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'Construção Civil'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/construcao-civil/construcao-civil-edit.html',
                        controller: 'ConstrucaoCivilEditController'
                    }
                },
                resolve: {
                    entity: ['$stateParams', '$state', 'ConstrucaoCivil', function ($stateParams, $state, ConstrucaoCivil) {
                        return ConstrucaoCivil.get({id: $stateParams.id},
                            function (sucess) {
                                return sucess;
                            }, function (error) {
                                $state.go('construcaoCivil');
                            });
                    }]
                }
            })
            .state('construcaoCivil.visualizar', {
                parent: 'entity',
                url: '/construcao-civil/detalhe/{id}',
                ncyBreadcrumb: {
                    label: 'Incluir Construção Civil'
                },
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'Construção Civil'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/construcao-civil/construcao-civil-detail.html',
                        controller: 'ConstrucaoCivilDetailController'
                    }
                },
                resolve: {
                    entity: ['$stateParams', '$state', 'ConstrucaoCivil', function ($stateParams, $state, ConstrucaoCivil) {
                        return ConstrucaoCivil.get({id: $stateParams.id},
                            function (sucess) {
                                return sucess;
                            }, function (error) {
                                $state.go('construcaoCivil');
                            });
                    }]
                }
            })
    });

'use strict';

angular.module('nfseApp')
    .controller('ConstrucaoCivilController', function ($modal, $state, $scope, localStorageService,
                                                       ConstrucaoCivil, ParseLinks, Notificacao) {
        $scope.obras = [];
        $scope.page = 0;
        $scope.per_page = 10;
        $scope.searchQuery = "";

        $scope.loadAll = function () {
            var prestador = localStorageService.get("prestadorPrincipal");
            ConstrucaoCivil.buscarConstrucaoCivilFromPrestador({
                prestador: prestador.id,
                page: $scope.page - 1,
                per_page: $scope.per_page,
                filtro: $scope.searchQuery
            }, function (result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.obras = result;
            });
        };

        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };

        $scope.loadAll();

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clean();
        };


        $scope.remover = function (id) {
            ConstrucaoCivil.delete({id: id}, function () {
                Notificacao.info("Removido!", "O registro foi removido com sucesso.");
                $scope.refresh();
            }, function () {
                Notificacao.info("Falha ao Remover!", "O registro possui dependências.");
            });
        };

        $scope.buscarClasseStatus = function (status) {
            switch (status) {
                case "NAO_INICIADA":
                    return "label label-primary";
                case "EM_ANDAMENTO":
                    return "label label-info";
                case "APROVADA":
                    return "label label-sucess";
                case "CONCLUIDA":
                    return "label label-important";
                case "PARALIZADA":
                    return "label label-danger";
            }
        };
    })
;

'use strict';

angular.module('nfseApp')
    .controller('ConfiguracaoDetailController', function ($modal, $state, $scope, $rootScope, $stateParams, entity, Configuracao, Municipio, Notificacao) {
        $scope.configuracao = entity;
        $scope.documentoObrigatorio = getNovoDocumentoObrigatorio();

        $scope.load = function (id) {
            Configuracao.get({id: id}, function (result) {
                $scope.configuracao = result;
            });
        };
        $rootScope.$on('nfseApp:configuracaoUpdate', function (event, result) {
            $scope.configuracao = result;
        });

        var onSaveFinished = function (result) {
            $state.go("configuracao");
            Notificacao.info("Configuração do Sistema salva com sucesso!")
        };

        $scope.searchMunicipio = function (caraQueTemMunicipio) {
            var modalInstance = $modal.open({
                templateUrl: 'app/entities/municipio/municipio-search.html',
                controller: 'MunicipioSearchController',
                size: 'lg'
            });
            modalInstance.result.then(function (municipio) {
                caraQueTemMunicipio.municipio = municipio;
                caraQueTemMunicipio.pais = {};
            }, function () {
                //$log.info('Modal dismissed at: ' + new Date());
            });
        };

        $scope.loadMunicipioByCodigo = function (codigo, caraQueTemMunicipio) {
            if (codigo) {
                Municipio.getByCodigo({codigo: codigo}, function (municipio) {
                    if (municipio.id) {
                        caraQueTemMunicipio.municipio = municipio;
                        caraQueTemMunicipio.pais = {};
                    } else {
                        Notificacao.warn("Atenção", "Não foi encontrado nenhum Municipio com o código " + codigo);
                        caraQueTemMunicipio.municipio = {};
                    }
                });
            }
        };

        $scope.save = function () {
            if ($scope.configuracao.documentosObrigatorios) {
                for (var i = 0; i < $scope.configuracao.documentosObrigatorios.length; i++) {
                    if (!$scope.configuracao.documentosObrigatorios[i].descricao) {
                        Notificacao.warn('Operação não permitida!', 'É obrigatório informar a descrição de todos documentos adicionados!');
                        return;
                    }
                }
                for (var i = 0; i < $scope.configuracao.documentosObrigatorios.length; i++) {
                    for (var x = 0; i < $scope.configuracao.documentosObrigatorios.length; i++) {
                        if (i != x && $scope.configuracao.documentosObrigatorios[i].descricao == $scope.configuracao.documentosObrigatorios[x].descricao) {
                            Notificacao.warn('Operação não permitida!', 'Não é permitido adicionar mais de um documento com mesmo nome!');
                            return;
                        }
                    }
                }
            }
            if ($scope.configuracao.id != null) {
                Configuracao.update($scope.configuracao, onSaveFinished);
            } else {
                Configuracao.save($scope.configuracao, onSaveFinished);
            }
        };

        function limparIntervaloIntegracao() {
            if ($scope.configuracao.urlConexao == undefined || $scope.configuracao.urlConexao.trim() == '') {
                $scope.configuracao.intervaloIntegracao = null;
            }
        }

        $scope.onBlurUrlConexao = function () {
            limparIntervaloIntegracao();
        };

        $scope.onBlurIntervaloIntegracao = function () {
            limparIntervaloIntegracao();
        };

        $scope.limparDescricao = function () {
            $scope.documentoObrigatorio.descricao = "";
        };

        $scope.adicionarDocumentoObrigatorio = function () {
            if (!$scope.configuracao.documentosObrigatorios) {
                $scope.configuracao.documentosObrigatorios = [];
            }

            if ($scope.configuracao.documentosObrigatorios.length > 0) {
                for (var i = 0; i < $scope.configuracao.documentosObrigatorios.length; i++) {
                    if ($scope.configuracao.documentosObrigatorios[i].descricao == $scope.documentoObrigatorio.descricao) {
                        Notificacao.warn("Operação não permitida!", "O documento já foi adicionado!");
                        return;
                    }
                }
            }
            $scope.configuracao.documentosObrigatorios.push($scope.documentoObrigatorio);

            $scope.documentoObrigatorio = getNovoDocumentoObrigatorio();
        };

        function getNovoDocumentoObrigatorio() {
            return {
                descricao: ""
            };
        }

        $scope.removerDocumentoObrigatorio = function (documento) {
            var indice = $scope.configuracao.documentosObrigatorios.indexOf(documento);
            $scope.configuracao.documentosObrigatorios.splice(indice, 1);
        }
    })
;

'use strict';

angular.module('nfseApp')
    .factory('Configuracao', function ($resource, DateUtils) {
        return $resource('api/configuracao/', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                url: 'publico/configuracao/',
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getPerfil': {
                url: 'publico/perfil-app/',
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('ConfiguracaoSearch', function ($resource) {
        return $resource('api/_search/configuracaos/:query', {}, {
            'query': { method: 'GET', isArray: true}
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('configuracao', {
                parent: 'site',
                url: '/configuracao/',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'Configurações Municipais'
                },
                ncyBreadcrumb: {
                    label: 'Edição'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/configuracao/configuracao-detail.html',
                        controller: 'ConfiguracaoDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('configuracao');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Configuracao', function ($stateParams, Configuracao) {
                        return Configuracao.get();
                    }]
                }
            })
    });

(function () {
    'use strict';

    angular.module('nfseApp').controller('CodigoTributacaoSearchController',
        function ($scope, $state, $modalInstance, CodigoTributacao, ParseLinks) {
            $scope.codigosTributacao = [];
            $scope.filtro = {
                codigo: '',
                descricao: ''
            };
            $scope.page;
            $scope.per_page = 10;

            $scope.ok = function (codigoTributacao) {
                $modalInstance.close(codigoTributacao);
            };

            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };

            $scope.montarConsulta = function () {
                var campos = [];

                if ($scope.filtro.codigo) {
                    campos.push({
                        campo: "obj.codigo",
                        operador: "LIKE",
                        valorString: '%' + $scope.filtro.codigo + '%'
                    });
                }

                if ($scope.filtro.descricao) {
                    campos.push({
                        campo: "obj.descricao",
                        operador: "LIKE",
                        valorString: '%' + $scope.filtro.descricao + '%'
                    });
                }

                return {
                    offset: $scope.page,
                    limit: $scope.per_page,
                    parametrosQuery: [{
                        juncao: " and ",
                        parametroQueryCampos: campos
                    }]
                };
            };

            $scope.loadAll = function () {
                var consulta = $scope.montarConsulta();
                CodigoTributacao.consultar(consulta,
                    function (result, headers) {
                        if (headers)
                            $scope.links = ParseLinks.parse(headers('link'));
                        $scope.codigosTributacao = result;
                    });
            };

            $scope.loadAll();
        });
})();
(function () {
    'use strict';

    angular.module('nfseApp')
        .factory('CodigoTributacao', function ($resource) {
            return $resource('api/codigo-tributacao/:id', {}, {
                'buscarPorCodigo': {
                    method: 'GET',
                    url: 'api/codigo-tributacao/buscar-por-codigo'
                },
                'consultar': {
                    url: 'api/codigo-tributacao/consultar',
                    method: 'POST',
                    isArray: true
                }
            });
        });
})();

'use strict';

angular.module('nfseApp')
    .controller('CnaeSearchController', function ($scope, Cnae, CnaeSearch, ParseLinks, SweetAlert, $modalInstance) {
        $scope.cnaes = [];
        $scope.page = 1;
        $scope.per_page = 5;

        $scope.loadAll = function () {
            Cnae.query({page: $scope.page, per_page: $scope.per_page}, function (result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.cnaes = result;
            });
        };
        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.search = function () {
            CnaeSearch.query({query: $scope.searchQuery}, function (result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.cnaes = result;
            }, function (response) {
                if (response.status === 404) {
                    $scope.loadAll();
                }
            });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.cnae = {codigo: null, descricao: null, ativo: null, id: null};
        };

        $scope.ok = function (cnae) {
            $modalInstance.close(cnae);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    });

'use strict';

angular.module('nfseApp').controller('CnaeDialogController',
    ['$scope','$state', '$stateParams',  'entity', 'Cnae',"Notificacao",
        function($scope,$state, $stateParams, entity, Cnae, Notificacao) {

        $scope.cnae = entity;
        $scope.load = function(id) {
            Cnae.get({id : id}, function(result) {
                $scope.cnae = result;
            });
        };

        var onSaveFinished = function (result) {
            $scope.$emit('nfseApp:cnaeUpdate', result);
            $state.go("cnae");
            Notificacao.info("CNAE Salvo com sucesso.");
        };

        $scope.save = function () {
            if ($scope.cnae.id != null) {
                Cnae.update($scope.cnae, onSaveFinished);
            } else {
                Cnae.save($scope.cnae, onSaveFinished);
            }
        };

        $scope.clear = function() {
            //$modalInstance.dismiss('cancel');
        };
}]);

'use strict';

angular.module('nfseApp')
    .controller('CnaeDetailController', function ($scope, $rootScope, $stateParams, entity, Cnae) {
        $scope.cnae = entity;
        $scope.load = function (id) {
            Cnae.get({id: id}, function(result) {
                $scope.cnae = result;
            });
        };
        $rootScope.$on('nfseApp:cnaeUpdate', function(event, result) {
            $scope.cnae = result;
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('Cnae', function ($resource) {
        return $resource('api/cnaes/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getPorCodigo': {
                method: 'GET',
                url: "api/cnae_por_codigo/:codigo",
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'buscarPorServico': {
                method: 'GET',
                url: "api/cnae-por-servico",
                isArray: true
            },
            'teByPrestador': {
                method: 'GET',
                url: "api/cnaes-por-empresa/:id",
                isArray: true
            },
            'update': {method: 'PUT'}
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('CnaeSearch', function ($resource) {
        return $resource('api/_search/cnaes/:query', {}, {
            'query': { method: 'GET', isArray: true}
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('cnae', {
                parent: 'entity',
                url: '/cnaes',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'nfseApp.cnae.home.title'
                },
                ncyBreadcrumb: {
                    label: 'Consulta de CNAE'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/cnae/cnaes.html',
                        controller: 'CnaeController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('cnae');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('cnae.detail', {
                parent: 'cnae',
                url: '/detalhes/{id}',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'nfseApp.cnae.detail.title'
                },
                ncyBreadcrumb: {
                    label: 'Detalhes do CNAE'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/cnae/cnae-detail.html',
                        controller: 'CnaeDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('cnae');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Cnae', function($stateParams, Cnae) {
                        return Cnae.get({id : $stateParams.id});
                    }]
                }
            })
            .state('cnae.new', {
                parent: 'cnae',
                url: '/novo',
                data: {
                    roles: ['ROLE_ADMIN'],
                },
                ncyBreadcrumb: {
                    label: 'Novo CNAE'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/cnae/cnae-dialog.html',
                        controller: 'CnaeDialogController'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('cnae');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {codigo: null, descricao: null, ativo: true, id: null};
                    }
                }
            })
            .state('cnae.edit', {
                parent: 'cnae',
                url: '/edicao/{id}',
                data: {
                    roles: ['ROLE_ADMIN'],
                },
                ncyBreadcrumb: {
                    label: 'Edição de CNAE'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/cnae/cnae-dialog.html',
                        controller: 'CnaeDialogController'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('cnae');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Cnae', function($stateParams, Cnae) {
                        return Cnae.get({id : $stateParams.id});
                    }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('CnaeController', function ($scope, Cnae, CnaeSearch, ParseLinks, SweetAlert) {
        $scope.cnaes = [];
        $scope.page = 1;
        $scope.loadAll = function () {
            Cnae.query({page: $scope.page, per_page: 20}, function (result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.cnaes = result;
            });
        };
        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.delete = function (id) {
            Cnae.get({id: id}, function (result) {
                $scope.cnae = result;
                SweetAlert.swal({
                        title: "Confirme a exclusão",
                        text: "Você tem certeza que quer excluir o registro selecionado?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55", confirmButtonText: "Sim, Excluir",
                        cancelButtonText: "Não, Cancelar",
                        closeOnConfirm: false,
                        closeOnCancel: false
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            $scope.confirmDelete(id);
                        } else {
                            SweetAlert.info("Cancelado", "O registro não foi removido :)", "error");
                        }
                    });
            });
        };

        $scope.confirmDelete = function (id) {
            Cnae.delete({id: id},
                function () {
                    $scope.loadAll();
                    SweetAlert.info("Removido!", "O registro foi removido com sucesso.", "success");
                    $scope.clear();
                });
        };

        $scope.search = function () {
            CnaeSearch.query({query: $scope.searchQuery}, function (result) {
                $scope.cnaes = result;
            }, function (response) {
                if (response.status === 404) {
                    $scope.loadAll();
                }
            });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.cnae = {codigo: null, descricao: null, ativo: null, id: null};
        };
    });

'use strict';

angular.module('nfseApp')
    .factory('ClassificacaoAtividade', function ($resource) {
        return $resource('api/classificacoes/', {}, {
            'query': {method: 'GET', isArray: true},
            'update': {method: 'PUT'}
        });
    });

'use strict';

angular.module('nfseApp')
    .controller('CadastroImobiliarioSearchController', function ($scope, $timeout,
                                                                 CadastroImobiliario,
                                                                 ParseLinks, SweetAlert, $modalInstance) {
        $scope.cadastros = [];
        $scope.cadastro = null;
        $scope.page = 1;

        $timeout(function () {
            angular.element('[name="searchQuery"]').focus();
        });

        $scope.search = function () {
            CadastroImobiliario.query({
                page: $scope.page,
                per_page: 5,
                search: $scope.searchQuery
            }, function (result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.cadastros = result;
            });
        };

        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.search();
        };

        $scope.refresh = function () {
            $scope.search();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.cadastro = null;
        };

        $scope.ok = function (cadastro) {
            $modalInstance.close(cadastro);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    });

'use strict';

angular.module('nfseApp')
    .factory('CadastroImobiliario', function ($resource) {
        return $resource('api/cadastro-imobiliario/:id', {}, {
            'query': {
                method: 'GET',
                url: 'api/cadastro-imobiliario/search',
                isArray: true
            },
            'byInscricao': {
                method: 'GET',
                url: "api/cadastro-imobiliario/by-inscricao"
            }
        });
    });

'use strict';

angular.module('nfseApp')
    .controller('CadastroEconomicoDialogController', function ($scope, $modalInstance, cadastrosEconomico) {

        $scope.cadastrosEconomico = cadastrosEconomico;

        $scope.ok = function (cadastroEconomico) {
            $modalInstance.close(cadastroEconomico);
        };
    });

'use strict';

angular.module('nfseApp')
    .factory('BloqueioEmissaoNfse', function ($resource) {
        return $resource('api/bloqueio-emissao-nfse/:id', {}, {
            'buscarBloqueioPrestador': {
                url: 'api/bloqueio-emissao-nfse/buscar-bloqueio-prestador',
                method: 'GET'
            }
        });
    });

(function () {
    'use strict';

    angular.module('nfseApp')
        .controller('BloqueioEmissaoNfseController',
            function ($scope, $sanitize, $modalInstance, bloqueio) {
                $scope.bloqueio = bloqueio;

                $scope.fechar = function () {
                    $modalInstance.dismiss('cancel');
                }

                $scope.trustAsHtml = function (value) {
                    return $sanitize(value);
                };
            });
})();

(function () {
    'use strict';

    angular.module('nfseApp')
        .controller('AvisosSistemaController',
            function ($scope, $sanitize, $modalInstance, avisos) {
                $scope.avisos = avisos;
                $scope.aviso = $scope.avisos.splice(0, 1)[0];

                $scope.continuar = function () {
                    if ($scope.avisos.length == 0) {
                        $modalInstance.dismiss('cancel');
                    } else {
                        $scope.aviso = $scope.avisos.splice(0, 1)[0];
                    }
                }

                $scope.trustAsHtml = function (value) {
                    return $sanitize(value);
                };
            });
})();

'use strict';

angular.module('nfseApp')
    .factory('AvisoSistema', function ($resource) {
        return $resource('api/publico/aviso-sistema/:id', {}, {
            'buscarAvisosVigentes': {
                url: 'api/publico/aviso-sistema/buscar-avisos-vigentes',
                method: 'GET',
                isArray: true
            }
        });
    });

(function () {
    'use strict';

    angular.module('nfseApp')
        .controller('ArquivoDesifValidateController',
            function ($scope, $state, localStorageService, PrestadorServicos, ArquivoDesif) {
                $scope.prestador = null;
                $scope.file = null;
                $scope.fileName = null;
                $scope.importacao = null;

                PrestadorServicos.get({id: localStorageService.get("prestadorPrincipal").prestador.id}, function (data) {
                    $scope.prestador = data;
                });


                $scope.uploadFile = function (file) {
                    $scope.importacao = null;
                    var reader = new FileReader();
                    reader.onload = function (evt) {
                        $scope.$apply(function ($scope) {
                            $scope.file = evt.target.result;
                            $scope.fileName = file.name;
                        });
                    };
                    reader.readAsDataURL(file);
                };

                $scope.disableValidarArquivo = function () {
                    return !$scope.file;
                }

                $scope.validarImportacaoDesif = function () {
                    ArquivoDesif.validar({
                        prestador: $scope.prestador,
                        file: $scope.file
                    }, function (data) {
                        $scope.importacao = data;
                        if ($scope.importacao.idArquivo > 0) {
                            $state.go("arquivoDesif.detalhe", {id: $scope.importacao.idArquivo});
                        }
                    });
                }
            });
})();

(function () {
    'use strict';

    angular.module('nfseApp')
        .factory('ArquivoDesifRegistro1000', function ($resource, DateUtils) {
            function transformResponseList(data) {
                data = angular.fromJson(data);
                for (var i = 0; i < data.length; i++) {
                    var nota = data[i];
                    transformResponse(nota);
                }
                return data;
            }

            function transformResponse(data) {
                data = angular.fromJson(data);
                if (data.dataLancamento) {
                    data.dataLancamento = DateUtils.convertLocaleDateFromServer(data.dataLancamento);
                }
                return data;
            }

            var resource = $resource('/api/arquivo-desif-registro-1000/:id', {}, {
                'consultar': {
                    method: 'POST',
                    url: 'api/arquivo-desif-registro-1000/consultar',
                    isArray: true,
                    transformResponse: transformResponseList
                }
            });

            return resource;
        });
})();

(function () {
    'use strict';

    angular.module('nfseApp')
        .factory('ArquivoDesifRegistro0440', function ($resource) {
            return $resource('/api/arquivo-desif-registro-0440/:id', {}, {
                'consultar': {
                    method: 'POST',
                    url: 'api/arquivo-desif-registro-0440/consultar',
                    isArray: true
                }
            });
        });
})();
(function () {
    'use strict';

    angular.module('nfseApp')
        .factory('ArquivoDesifRegistro0430', function ($resource) {
            return $resource('/api/arquivo-desif-registro-0430/:id', {}, {
                'consultar': {
                    method: 'POST',
                    url: 'api/arquivo-desif-registro-0430/consultar',
                    isArray: true
                }
            });
        });
})();
(function () {
    'use strict';

    angular.module('nfseApp')
        .factory('ArquivoDesifRegistro0410', function ($resource, DateUtils) {
            function transformResponseList(data) {
                data = angular.fromJson(data);
                for (var i = 0; i < data.length; i++) {
                    var nota = data[i];
                    transformResponse(nota);
                }
                return data;
            }

            function transformResponse(data) {
                data = angular.fromJson(data);
                if (data.competencia) {
                    data.competencia = DateUtils.convertLocaleDateFromServer(data.competencia);
                }
                return data;
            }

            var resource = $resource('/api/arquivo-desif-registro-0410/:id', {}, {
                'consultar': {
                    method: 'POST',
                    url: 'api/arquivo-desif-registro-0410/consultar',
                    isArray: true,
                    transformResponse: transformResponseList
                }
            });

            return resource;
        });
})();

(function () {
    'use strict';

    angular.module('nfseApp')
        .factory('ArquivoDesifRegistro0400', function ($resource) {
            return $resource('/api/arquivo-desif-registro-0400/:id', {}, {
                'consultar': {
                    method: 'POST',
                    url: 'api/arquivo-desif-registro-0400/consultar',
                    isArray: true
                }
            });
        });
})();
(function () {
    'use strict';

    angular.module('nfseApp')
        .factory('ArquivoDesifRegistro0300', function ($resource) {
            return $resource('/api/arquivo-desif-registro-0300/:id', {}, {
                'consultar': {
                    method: 'POST',
                    url: 'api/arquivo-desif-registro-0300/consultar',
                    isArray: true
                }
            });
        });
})();
(function () {
    'use strict';

    angular.module('nfseApp')
        .factory('ArquivoDesifRegistro0200', function ($resource, DateUtils) {
            function transformResponseList(data) {
                data = angular.fromJson(data);
                for (var i = 0; i < data.length; i++) {
                    var nota = data[i];
                    transformResponse(nota);
                }
                return data;
            }

            function transformResponse(data) {
                data = angular.fromJson(data);
                if (data.inicioVigencia) {
                    data.inicioVigencia = DateUtils.convertLocaleDateFromServer(data.inicioVigencia);
                }
                return data;
            }

            var resource = $resource('/api/arquivo-desif-registro-0200/:id', {}, {
                'consultar': {
                    method: 'POST',
                    url: 'api/arquivo-desif-registro-0200/consultar',
                    isArray: true,
                    transformResponse: transformResponseList
                }
            });

            return resource;
        });
})();

(function () {
    'use strict';

    angular.module('nfseApp')
        .factory('ArquivoDesifRegistro0100', function ($resource) {
            return $resource('/api/arquivo-desif-registro-0100/:id', {}, {
                'consultar': {
                    method: 'POST',
                    url: 'api/arquivo-desif-registro-0100/consultar',
                    isArray: true
                }
            });
        });
})();
(function () {
    'use strict';

    angular.module('nfseApp')
        .controller('ArquivoDesifDetailController',
            function ($scope, $state, $timeout, arquivo, ParseLinks, ArquivoDesif, Notificacao,
                      ArquivoDesifRegistro0100, ArquivoDesifRegistro0200, ArquivoDesifRegistro0300,
                      ArquivoDesifRegistro0400, ArquivoDesifRegistro0410, ArquivoDesifRegistro0430,
                      ArquivoDesifRegistro0440, ArquivoDesifRegistro1000, ImpressaoPdf) {
                $scope.arquivo = arquivo;
                $scope.consultaRegistro0100 = {
                    page: 0,
                    per_page: 10,
                    links: '',
                    list: []
                };
                $scope.consultaRegistro0200 = {
                    page: 0,
                    per_page: 10,
                    links: '',
                    list: []
                };
                $scope.consultaRegistro0300 = {
                    page: 0,
                    per_page: 10,
                    links: '',
                    list: []
                };
                $scope.consultaRegistro0400 = {
                    page: 0,
                    per_page: 10,
                    links: '',
                    list: []
                };
                $scope.consultaRegistro0410 = {
                    page: 0,
                    per_page: 10,
                    links: '',
                    list: []
                };
                $scope.consultaRegistro0430 = {
                    page: 0,
                    per_page: 10,
                    links: '',
                    list: []
                };
                $scope.consultaRegistro0440 = {
                    page: 0,
                    per_page: 10,
                    links: '',
                    list: []
                };
                $scope.consultaRegistro1000 = {
                    page: 0,
                    per_page: 10,
                    links: '',
                    list: []
                };
                $scope.activeTab;
                $scope.timeout;

                $scope.verificarAndamento = function () {
                    ArquivoDesif.get({id: $scope.arquivo.id}, function (arquivo) {
                        $scope.arquivo = arquivo;
                        if ($scope.arquivo.situacao == 'EM_PROCESSAMENTO') {
                            $scope.timeout = $timeout(function () {
                                $scope.verificarAndamento();
                            }, 5000);
                        }
                    });
                }

                $scope.verificarAndamento();

                $scope.buscarRegistros = function (service, consultaRegistro) {
                    var campos = [];
                    var parametroQueryCampo = {
                        campo: "obj.arquivodesif_id",
                        operador: "IGUAL",
                        valorLong: $scope.arquivo.id
                    };
                    campos.push(parametroQueryCampo);

                    var consultaGenerica = {
                        offset: consultaRegistro.page,
                        limit: consultaRegistro.per_page,
                        parametrosQuery: [{
                            juncao: " and ",
                            parametroQueryCampos: campos
                        }]
                    };

                    service.consultar(consultaGenerica,
                        function (result, headers) {
                            if (headers)
                                consultaRegistro.links = ParseLinks.parse(headers('link'));
                            consultaRegistro.list = result;
                        });
                }

                $scope.loadPageRegistros = function (page, service, consultaRegistro) {
                    consulta.page = page;
                    $scope.buscarRegistros(service, consultaRegistro);
                };

                $scope.loadPageRegistros0100 = function (page) {
                    $scope.loadPageRegistros(page, ArquivoDesifRegistro0100, $scope.consultaRegistro0100);
                };

                $scope.loadPageRegistros0200 = function (page) {
                    $scope.loadPageRegistros(page, ArquivoDesifRegistro0200, $scope.consultaRegistro0200);
                };

                $scope.loadPageRegistros0300 = function (page) {
                    $scope.loadPageRegistros(page, ArquivoDesifRegistro0300, $scope.consultaRegistro0300);
                };

                $scope.loadPageRegistros0400 = function (page) {
                    $scope.loadPageRegistros(page, ArquivoDesifRegistro0400, $scope.consultaRegistro0400);
                };

                $scope.loadPageRegistros0410 = function (page) {
                    $scope.loadPageRegistros(page, ArquivoDesifRegistro0410, $scope.consultaRegistro0410);
                };

                $scope.loadPageRegistros0430 = function (page) {
                    $scope.loadPageRegistros(page, ArquivoDesifRegistro0430, $scope.consultaRegistro0430);
                };

                $scope.loadPageRegistros0440 = function (page) {
                    $scope.loadPageRegistros(page, ArquivoDesifRegistro0430, $scope.consultaRegistro0440);
                };

                $scope.loadPageRegistros1000 = function (page) {
                    $scope.loadPageRegistros(page, ArquivoDesifRegistro1000, $scope.consultaRegistro1000);
                };

                $scope.defineActiveTab = function () {
                    switch ($scope.arquivo.modulo) {
                        case 'MODULO_1': {
                            $scope.activeTab = 3;
                            $scope.buscarRegistros(ArquivoDesifRegistro0400, $scope.consultaRegistro0400);
                            $scope.buscarRegistros(ArquivoDesifRegistro0410, $scope.consultaRegistro0410);
                            $scope.buscarRegistros(ArquivoDesifRegistro1000, $scope.consultaRegistro1000);
                            break;
                        }
                        case 'MODULO_2': {
                            $scope.activeTab = 3;
                            $scope.buscarRegistros(ArquivoDesifRegistro0400, $scope.consultaRegistro0400);
                            $scope.buscarRegistros(ArquivoDesifRegistro0430, $scope.consultaRegistro0430);
                            $scope.buscarRegistros(ArquivoDesifRegistro0440, $scope.consultaRegistro0440);
                            break;
                        }
                        case 'MODULO_3': {
                            $scope.activeTab = 0;
                            $scope.buscarRegistros(ArquivoDesifRegistro0100, $scope.consultaRegistro0100);
                            $scope.buscarRegistros(ArquivoDesifRegistro0200, $scope.consultaRegistro0200);
                            $scope.buscarRegistros(ArquivoDesifRegistro0300, $scope.consultaRegistro0300);
                            break;
                        }
                        case 'MODULO_4': {
                            $scope.activeTab = 7;
                            $scope.buscarRegistros(ArquivoDesifRegistro1000, $scope.consultaRegistro1000);
                            break;
                        }
                    }
                }

                $scope.defineActiveTab();

                $scope.mudarActiveTab = function (activeTab) {
                    $scope.activeTab = activeTab;
                }

                $scope.excluir = function () {
                    Notificacao.confirmDelete(
                        function () {
                            ArquivoDesif.remove({id: $scope.arquivo.id}, function (data) {
                                $state.go('arquivoDesif');
                            })
                        }
                    );
                }

                $scope.enviar = function () {
                    Notificacao.confirm('Atenção!', 'Tem certeza que deseja enviar esse arquivo?', 'warning',
                        function () {
                            ArquivoDesif.enviar({id: $scope.arquivo.id}, function () {
                                Notificacao.info('Informação!', 'Arquivo enviado para processamento.');
                                $state.go('arquivoDesif.detalhe', {id: $scope.arquivo.id}, {reload: true});
                            });
                        });
                }

                $scope.imprimirGuia = function () {
                    ImpressaoPdf.imprimirPdfViaPost('/api/imprimir-dam-declaracao', {
                        idDeclaracao: $scope.arquivo.idDeclaracaoMensalServico,
                        idPrestador: $scope.arquivo.prestador.id,
                        vencimentoDam: null
                    });
                };

                $scope.$on('$destroy', function () {
                    if ($scope.timeout) {
                        $timeout.cancel($scope.timeout);
                    }
                });

                $scope.imprimirRecibo = function () {
                    ImpressaoPdf.imprimirPdfViaUrl('/api/arquivo-desif/imprimir-recibo/' + $scope.arquivo.id);
                };
            });
})
();

(function () {
    'use strict';

    angular.module('nfseApp')
        .factory('ArquivoDesif', function ($resource, DateUtils) {
            function transformResponseList(data) {
                data = angular.fromJson(data);
                for (var i = 0; i < data.length; i++) {
                    var nota = data[i];
                    transformResponse(nota);
                }
                return data;
            }

            function transformResponse(data) {
                data = angular.fromJson(data);
                if (data.enviadoEm) {
                    data.enviadoEm = DateUtils.convertLocaleDateFromServer(data.enviadoEm);
                }
                if (data.inicioCompetencia) {
                    data.inicioCompetencia = DateUtils.convertLocaleDateFromServer(data.inicioCompetencia);
                }
                if (data.fimCompetencia) {
                    data.fimCompetencia = DateUtils.convertLocaleDateFromServer(data.fimCompetencia);
                }
                return data;
            }

            var resource = $resource('/api/arquivo-desif/:id', {}, {
                'get': {
                    method: 'GET',
                    url: 'api/arquivo-desif/:id',
                    transformResponse: transformResponse
                },
                'consultar': {
                    method: 'POST',
                    url: 'api/arquivo-desif/consultar',
                    isArray: true,
                    transformResponse: transformResponseList
                },
                'validar': {
                    method: 'POST',
                    url: "api/arquivo-desif/validar"
                },
                'enviar': {
                    method: 'GET',
                    url: "api/arquivo-desif/enviar"
                },
                'consultarSituacao': {
                    method: 'GET',
                    url: "api/arquivo-desif/consultar-situacao"
                },
                'importarLegado': {
                    method: 'POST',
                    url: "api/arquivo-desif/importar-legado"
                }
            });

            return resource;
        });
})();

(function () {
    'use strict';

    angular.module('nfseApp')
        .config(function ($stateProvider) {
            $stateProvider
                .state('arquivoDesif', {
                    parent: 'entity',
                    url: '/arquivo-desif/consultar',
                    data: {
                        roles: ['ROLE_EMPRESA_DMS'],
                        pageTitle: 'Consulta de Importação de Arquivo DES-IF'
                    },
                    ncyBreadcrumb: {
                        label: 'Consulta de Importação de Arquivo DES-IF'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/arquivo-desif/arquivo-desif.html',
                            controller: 'ArquivoDesifController'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('moduloArquivoDesif');
                            $translatePartialLoader.addPart('situacaoArquivoDesif');
                            $translatePartialLoader.addPart('tipoArquivoDesif');
                            return $translate.refresh();
                        }]
                    }
                })
                .state('arquivoDesif.validar', {
                    parent: 'arquivoDesif',
                    url: '/arquivo-desif/validar',
                    data: {
                        roles: ['ROLE_EMPRESA_DMS'],
                        pageTitle: 'Validar Importação de Arquivo DES-IF'
                    },
                    ncyBreadcrumb: {
                        label: 'Validar Importação de Arquivo DES-IF'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/arquivo-desif/arquivo-desif-validate.html',
                            controller: 'ArquivoDesifValidateController'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                    }
                })
                .state('arquivoDesif.detalhe', {
                    parent: 'arquivoDesif',
                    url: '/arquivo-desif/detalhe/:id',
                    data: {
                        roles: ['ROLE_EMPRESA_DMS'],
                        pageTitle: 'Detalhe da Importação de Arquivo DES-IF'
                    },
                    ncyBreadcrumb: {
                        label: 'Detalhe da Importação de Arquivo DES-IF'
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/entities/arquivo-desif/arquivo-desif-detail.html',
                            controller: 'ArquivoDesifDetailController'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('global');
                            $translatePartialLoader.addPart('moduloArquivoDesif');
                            $translatePartialLoader.addPart('situacaoArquivoDesif');
                            $translatePartialLoader.addPart('tipoArquivoDesif');
                            $translatePartialLoader.addPart('tipoConsolidacaoArquivoDesif');
                            $translatePartialLoader.addPart('tipoArredondamentoArquivoDesif');
                            $translatePartialLoader.addPart('tipoPartidaArquivoDesif');
                            $translatePartialLoader.addPart('identificacaoDependenciaDesif');
                            return $translate.refresh();
                        }],
                        arquivo: ['$stateParams', 'ArquivoDesif', function ($stateParams, ArquivoDesif) {
                            return ArquivoDesif.get({id: $stateParams.id},
                                function (sucess) {
                                    return sucess;
                                }, function (error) {
                                    $state.go('arquivoDesif');
                                }).$promise;
                        }]
                    }
                });
        });
})();

(function () {
    'use strict';

    angular.module('nfseApp')
        .controller('ArquivoDesifController',
            function ($scope, $state, localStorageService, ArquivoDesif, ParseLinks, EnumCacheService) {
                $scope.arquivos = [];
                $scope.per_page = 20;
                $scope.prestadorPrincipal = localStorageService.get("prestadorPrincipal");
                $scope.modulos = EnumCacheService.carregarValuesEnum("br.com.webpublico.domain.enums.ModuloDesifNfseDTO");
                $scope.situacoes = EnumCacheService.carregarValuesEnum("br.com.webpublico.domain.enums.SituacaoArquivoDesifNfseDTO");
                $scope.filtro = {
                    modulo: null,
                    situacao: null
                }

                $scope.montarConsulta = function () {
                    var campos = [];
                    campos.push({
                        campo: "obj.cadastroeconomico_id",
                        operador: "IGUAL",
                        valorLong: $scope.prestadorPrincipal.prestador.id
                    });
                    if ($scope.filtro.modulo != null && $scope.filtro.modulo.name != null) {
                        campos.push({
                            campo: "obj.modulo",
                            operador: "IGUAL",
                            valorString: $scope.filtro.modulo.name
                        });
                    }
                    if ($scope.filtro.situacao != null && $scope.filtro.situacao.name != null) {
                        campos.push({
                            campo: "obj.situacao",
                            operador: "IGUAL",
                            valorString: $scope.filtro.situacao.name
                        });
                    }
                    return {
                        offset: $scope.page,
                        limit: $scope.per_page,
                        parametrosQuery: [{
                            juncao: " and ",
                            parametroQueryCampos: campos
                        }]
                    };
                };

                $scope.loadAll = function () {
                    var consulta = $scope.montarConsulta();
                    ArquivoDesif.consultar(consulta,
                        function (result, headers) {
                            if (headers) {
                                $scope.links = ParseLinks.parse(headers('link'));
                                $scope.totalItens = headers('x-total-count')
                            }
                            $scope.arquivos = result;
                        });
                };

                $scope.loadPage = function (page) {
                    $scope.page = page;
                    $scope.loadAll();
                };

                $scope.loadAll();
            });
})();

'use strict';

angular.module('nfseApp')
    .controller('AidfeSearchController', function ($scope, Tomador, AidfeSearch, ParseLinks, SweetAlert, $modalInstance) {
        $scope.aidfes = [];
        $scope.page = 1;
        $scope.loadAll = function () {
            Tomador.query({page: $scope.page, per_page: 5}, function (result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.aidfes = result;
            });
        };
        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.search = function () {
            if (!$scope.searchQuery) {
                $scope.searchQuery = '';
            }
            AidfeSearch.query({nome: $scope.searchQuery},
                function (result) {
                    $scope.aidfes = result;
                }, function (response) {
                    if (response.status === 404) {
                        $scope.loadAll();
                    }
                });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.aidfe = null;
        };

        $scope.ok = function (aidfe) {
            $modalInstance.close(aidfe);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    });

'use strict';

angular.module('nfseApp')
    .controller('AidfeListAnaliseController', function ($scope, Aidfe, AidfeSearch, $filter, ParseLinks, SweetAlert) {
        $scope.aidfes = [];
        $scope.page = 1;
        $scope.per_page = 10;
        $scope.situacoes = Aidfe.getSituacoes();
        $scope.tabSituacaoCorrente = 'AGUARDANDO';
        $scope.loadAll = function (situacao) {
            $scope.tabSituacaoCorrente = situacao;
            Aidfe.queryPorSituacao({
                page: $scope.page,
                per_page: $scope.per_page,
                situacaoAIDFE: situacao
            }, function (result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.aidfes = result;
            });
        };

        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll($scope.tabSituacaoCorrente);
        };

        $scope.loadAll($scope.tabSituacaoCorrente);

        $scope.delete = function (id) {
            Aidfe.get({id: id}, function (result) {
                $scope.aidfe = result;

                SweetAlert.swal({
                        title: "Confirme a exclusão",
                        text: "Você tem certeza que quer excluir essa Solicitação AIDF-e?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55", confirmButtonText: "Sim, Excluir",
                        cancelButtonText: "Não, Cancelar",
                        closeOnConfirm: false,
                        closeOnCancel: false
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            $scope.confirmDelete(id);
                        } else {
                            SweetAlert.info("Cancelado", "A solicitação de AIDF-e não foi removido :)", "error");
                        }
                    });
            });
        };

        $scope.confirmDelete = function (id) {
            Aidfe.delete({id: id},
                function () {
                    $scope.loadAll();
                    SweetAlert.info("Removido!", "A Solicitação de AIDF-e foi removido com sucesso.", "success");
                });
        };

        $scope.search = function (search, situacao) {
            if (!search) {
                search = '';
            }
            AidfeSearch.buscarPorSituacao({query: search, situacaoAIDFE: situacao},
                function (result) {
                    console.log("result ", result);
                    if (result.length == 0) {
                        $scope.loadAll(situacao);
                    } else {
                        $scope.aidfes = result;
                    }
                }, function (response) {
                    console.log("response ", response);
                    if (response.status === 404) {
                        $scope.loadAll(situacao);
                    }
                }
            )
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clean();
        };

        $scope.clear = function () {
            $scope.aidfe = {id: null};
        };

        $scope.classTab = function (situacao) {
            if (situacao == 'AGUARDANDO') {
                return 'text-warning';
            }
            if (situacao == 'DEFERIDA') {
                return 'text-success';
            }
            if (situacao == 'PARCIALMENTE') {
                return 'text-info';
            }
            if (situacao == 'INDEFERIDA') {
                return 'text-danger';
            }
        }
    });

'use strict';

angular.module('nfseApp').controller('AidfeEditController',
    ['$scope', '$state', '$modal', '$stateParams', 'entity', 'Notificacao', 'localStorageService', '$timeout', 'Aidfe', 'Principal',
        function ($scope, $state, $modal, $stateParams, entity, Notificacao, localStorageService, $timeout, Aidfe, Principal) {

            $scope.aidfe = entity;
            $scope.mensagemCamposObrigatorios = [];
            $timeout(function () {
                angular.element('[ng-model="aidfe.quantidade"]').focus();
            });
            $scope.aidfe.prestadorServicos = localStorageService.get("prestadorPrincipal").prestador;
            Principal.identity().then(function (account) {
                $scope.account = account;
                $scope.aidfe.usuarioEmpresa = account;
            });

            var onSaveFinished = function (result) {
                $scope.$emit('nfseApp:aidfeUpdate', result);
                $state.go("aidfe");
                Notificacao.priority("Solicitação de AIDF-e atualizada com sucesso!")
            };

            function onSucessBuscarAidfeAguardando(response) {
                if (response.situacaoAIDFE === 'AGUARDANDO') {
                    Notificacao.warn("Atenção!", "Já existe uma solicitação de AIDF-e com o status aguardando.");
                    $state.go('aidfe');
                }
            }

            function onErrorBuscarAidfeAguardando(error) {
                if (error.status === 404) {
                    $scope.aidfe.situacaoAIDFE = 'AGUARDANDO';
                    $scope.aidfe.solicitadoEm = new Date();
                    Aidfe.save($scope.aidfe, onSaveFinished, function () {
                        $state.go("aidfe");
                    });
                }

            }

            $scope.save = function () {
                if ($scope.validar()) {
                    if ($scope.aidfe.id) {
                        var aidfeDTO = {
                            'id': $scope.aidfe.id,
                            'prestadorServicos': $scope.aidfe.prestadorServicos,
                            'usuarioEmpresa': $scope.aidfe.usuarioEmpresa,
                            'numero': $scope.aidfe.numero,
                            'solicitadoEm': $scope.aidfe.solicitadoEm,
                            'quantidade': $scope.aidfe.quantidade,
                            'numeroInicial': $scope.aidfe.numeroInicial,
                            'numeroFinal': $scope.aidfe.numeroFinal,
                            'observacao': $scope.aidfe.observacao,
                            'situacaoAIDFE': $scope.aidfe.situacaoAIDFE,
                            'deferidoEm': $scope.aidfe.deferidoEm,
                            'quantidadeDeferida': $scope.aidfe.quantidadeDeferida,
                            'observacaoDeferimento': $scope.aidfe.observacaoDeferimento,
                            'usuarioPrefeitura': $scope.aidfe.usuarioPrefeitura,
                            'versao': $scope.aidfe.versao
                        };

                        Aidfe.update(aidfeDTO, onSaveFinished, function () {
                            $state.go("aidfe");
                        });
                    } else {
                        Aidfe.buscarAidfeWithStatusAguardando({prestador_id: $scope.aidfe.prestadorServicos.id}, onSucessBuscarAidfeAguardando, onErrorBuscarAidfeAguardando);

                    }
                }
            };

            $scope.validar = function () {
                $scope.mensagemCamposObrigatorios = [];
                if ($scope.aidfe.quantidade <= 0 || $scope.aidfe.quantidade === undefined) {
                    $scope.mensagemCamposObrigatorios.push("O campo Quantidade Solicitada de NFS-e é obrigatória e deve ser maior que zero.")
                    Notificacao.camposObrigatorios($scope.mensagemCamposObrigatorios, "warning");
                    return false;
                }
                if ($scope.aidfe.quantidade >= 999999) {
                    $scope.mensagemCamposObrigatorios.push("Quantidade Solicitada deve ser inferior a 999999.")
                    Notificacao.camposObrigatorios($scope.mensagemCamposObrigatorios, "warning");
                    return false;
                }
                else {
                    return true;
                }
                return true;
            };

            function onSuccessBuscarNumero(response) {
                $scope.aidfe.numeroInicial = response.numeroInicial;
                $scope.aidfe.numeroFinal = $scope.aidfe.quantidade + $scope.aidfe.numeroInicial;
            }

            function onErrorBuscarNumero(error) {
                if (error.status === 404) {
                    Notificacao.error("Error: ", "Não foi encontrada uma sequência para o numero NFS-e Inicial.");
                }
            }

            $scope.calcularNumeroNFSE = function () {
                Aidfe.buscarAidfeNumeroInicial({},
                    onSuccessBuscarNumero, onErrorBuscarNumero);
            }
        }
    ])
;

'use strict';

angular.module('nfseApp')
    .controller('AidfeDetailController', function ($scope, $rootScope, $stateParams, entity, Tomador) {
        $scope.aidfe = entity;
        $scope.load = function (id) {
            Tomador.get({id: id}, function (result) {
                $scope.aidfe = result;
            });
        };
        $rootScope.$on('nfseApp:aidfeUpdate', function (event, result) {
            $scope.aidfe = result;
        });
    });

(function () {
    'use strict';

    angular.module('nfseApp')
        .controller('AidfeAnaliseController', ['$scope', '$rootScope', '$stateParams', 'entity', 'Aidfe', '$timeout', 'Notificacao', '$state', 'SweetAlert', function ($scope, $rootScope, $stateParams, entity, Aidfe, $timeout, Notificacao, $state, SweetAlert) {
            console.log("result 1111", entity);
            $scope.aidfe = entity;
            $scope.load = function (id) {
                Aidfe.get({id: id}, function (result) {
                    $scope.aidfe = result;
                    console.log("resultadoo ", result);
                });
            };
            $rootScope.$on('nfseApp:aidfeUpdate', function (event, result) {
                $scope.aidfe = result;
            });

            function onSuccess(response) {
                $scope.$emit('nfseApp:aidfeUpdate', response);
                $state.go("aidfe.analises");
                Notificacao.info("Registro Salvo com Sucesso", "");

            }

            function onError(error) {
                console.log("error: ", error);
                var message = '';
                if (error.data.error_description) {
                    message = error.data.error_description;
                } else {
                    message = error.data.message;
                }
                Notificacao.warn("Erro: ", message);
            }

            $scope.deferir = function () {
                SweetAlert.swal({
                        title: "Confirme o deferimento",
                        text: "Tem certeza que quer deferir a quantidade total de notas solicitadas?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#1A7BB9", confirmButtonText: "Sim, Deferir",
                        cancelButtonText: "Não, Cancelar",
                        closeOnConfirm: false,
                        closeOnCancel: false
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            Aidfe.deferir($scope.aidfe, onSuccess, onError);
                            Notificacao.info("Registro Deferido com Sucesso.", "");
                        } else {
                            SweetAlert.info("Cancelado", "O registro não foi deferido.", "error");
                        }
                    });
            };

            $scope.deferirParcialmente = function () {
                SweetAlert.swal({
                        title: "Confirme o deferimento parcial",
                        text: "Tem certeza que quer deferir " + $scope.aidfe.quantidadeDeferida + " notas das " + $scope.aidfe.quantidade + " solicitadas? ",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#F7A54A", confirmButtonText: "Sim, Deferir Parcialmente",
                        cancelButtonText: "Não, Cancelar",
                        closeOnConfirm: false,
                        closeOnCancel: false
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            Aidfe.deferirParcialmente($scope.aidfe, onSuccess, onError);
                            Notificacao.info("Registro Deferido Parcialmente com Sucesso.", "");
                        } else {
                            SweetAlert.info("Cancelado", "O registro não foi deferido parcialmente.", "error");
                        }
                    }
                )
                ;
            };

            $scope.indeferir = function () {
                SweetAlert.swal({
                        title: "Confirme o indeferimento",
                        text: "Tem certeza que quer indeferir essa AIDF-e?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55", confirmButtonText: "Sim, Indeferir",
                        cancelButtonText: "Não, Cancelar",
                        closeOnConfirm: false,
                        closeOnCancel: false
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            Aidfe.indeferir($scope.aidfe, onSuccess, onError);
                            Notificacao.info("Registro Indeferido com Sucesso.", "");
                        } else {
                            SweetAlert.info("Cancelado", "O registro não foi indeferido.", "error");
                        }
                    });
            };

            $scope.calcularNumeroNFSE = function () {
                if ($scope.aidfe.situacaoAIDFE == 'AGUARDANDO') {
                    $scope.aidfe.numeroFinal = Number($scope.aidfe.numeroInicial) + Number($scope.aidfe.quantidadeDeferida) - 1;
                }
            };

            $timeout(function () {
                angular.element('[ng-model="aidfe.quantidadeDeferida"]').focus();
                $scope.aidfe.quantidadeDeferida = entity.quantidade;
                console.log("result ", $scope.aidfe);
            });

        }
        ])
    ;
})
();

'use strict';

angular.module('nfseApp')
    .factory('Aidfe', function ($resource) {
        return $resource('api/aidfes/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'queryPorSituacao': {
                url: 'api/aidfes/por-situacao',
                method: 'GET', isArray: true
            },

            'buscarAidfeNumeroInicial': {
                method: 'GET',
                url: 'api/aidfes/numero-inicial'
            },
            'buscarTodasAidfesDoPrestador': {
                method: 'GET',
                url: 'api/aidfes/por-prestador',
                isArray: true
            },
            'buscarAidfeWithStatusAguardando': {
                method: 'GET',
                url: 'api/aidfes/aidfe-aguardando',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'deferir': {
                url: 'api/aidfes/deferir',
                method: 'POST'
            },
            'deferirParcialmente': {
                url: 'api/aidfes/deferir-parcialmente',
                method: 'POST'
            },
            'indeferir': {
                url: 'api/aidfes/indeferir',
                method: 'POST'
            },
            'getSituacoes': {
                url: 'api/aidfes/situacoes',
                method: 'GET',
                isArray: true
            },
            'getAidfeAsADM': {
                method: 'GET',
                url: 'api/aidfes/admin/:id'
            }
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('AidfeSearch', function ($resource) {
        return $resource('api/_search/aidfes/:query', {}, {
            'query': {method: 'GET', isArray: true},
            'buscarPorSituacao': {
                method: 'POST',
                url: 'api/_search/aidfes/situacao',
                isArray: true
            },
            'buscarAIDFEsPeloPrestador': {
                method: 'GET',
                url: 'api/_search/aidfes/prestador/:query',
                isArray: true
            }
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('aidfe', {
                parent: 'entity',
                url: '/aidfes',
                data: {
                    roles: ['ROLE_EMPRESA_AIDFE'],
                    pageTitle: 'AIDF-e'
                },
                ncyBreadcrumb: {
                    label: 'Consulta de AIDF-e '
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/aidfe/aidfes.html',
                        controller: 'AidfeController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('aidfe');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('dadosPessoais');
                        $translatePartialLoader.addPart('prestadorServicos');
                        return $translate.refresh();
                    }]
                }
            })
            .state('aidfe.detail', {
                parent: 'aidfe',
                url: '/aidfe/{id}',
                data: {
                    roles: ['ROLE_EMPRESA_AIDFE'],
                    pageTitle: 'AIDF-e'
                },
                ncyBreadcrumb: {
                    label: 'Detalhes da AIDF-e'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/aidfe/aidfe-detail.html',
                        controller: 'AidfeDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('aidfe');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('dadosPessoais');
                        $translatePartialLoader.addPart('prestadorServicos');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Aidfe', '$state', function ($stateParams, Aidfe, $state) {
                        return Aidfe.get({id: $stateParams.id},
                            function (sucess) {
                                return sucess;
                            },
                            function (error) {
                                $state.go('aidfe');
                            });
                    }]
                }
            })

            .state('aidfe.new', {
                parent: 'aidfe',
                url: '/novo',
                data: {
                    roles: ['ROLE_EMPRESA_AIDFE'],
                    pageTitle: 'AIDF-e'
                },
                ncyBreadcrumb: {
                    label: 'Solicitar AIDF-e'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/aidfe/aidfe-edit.html',
                        controller: 'AidfeEditController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('aidfe');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('dadosPessoais');
                        $translatePartialLoader.addPart('prestadorServicos');
                        return $translate.refresh();
                    }],
                    entity: ['localStorageService', function (localStorageService) {
                        return {id: null, prestador: localStorageService.get("prestadorPrincipal")};
                    }]
                }
            })
            .state('aidfe.edit', {
                parent: 'aidfe',
                url: '/edicao/{id}',
                data: {
                    roles: ['ROLE_EMPRESA_AIDFE'],
                    pageTitle: 'AIDF-e'
                },
                ncyBreadcrumb: {
                    label: 'Edição da AIDF-e'
                },
                views: {
                    'content@': {
                        templateUrl: '/app/entities/aidfe/aidfe-edit.html',
                        controller: 'AidfeEditController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('prestadorServicos');
                        $translatePartialLoader.addPart('dadosPessoais');
                        $translatePartialLoader.addPart('endereco');
                        $translatePartialLoader.addPart('aidfe');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['Aidfe', '$stateParams', '$state', function (Aidfe, $stateParams, $state) {
                        return Aidfe.get({id: $stateParams.id},
                            function (sucess) {
                                return sucess;
                            },
                            function (error) {
                                $state.go('aidfe');
                            });
                    }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('AidfeController', function ($scope, $state, Aidfe, AidfeSearch, $filter, ParseLinks, SweetAlert, localStorageService) {

        $scope.aidfes = [];
        $scope.per_page = 10;
        $scope.searchQuery = "";

        $scope.loadAll = function () {
            var prestador = localStorageService.get("prestadorPrincipal");
            Aidfe.buscarTodasAidfesDoPrestador({
                prestador: prestador.id,
                page: $scope.page,
                per_page: $scope.per_page,
                filtro: $scope.searchQuery
            }, function (result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.aidfes = result;
            });
        };

        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };

        $scope.loadAll();

        $scope.delete = function (id) {
            Aidfe.get({id: id}, function (result) {
                $scope.aidfe = result;

                SweetAlert.swal({
                        title: "Confirme a exclusão",
                        text: "Você tem certeza que quer excluir essa Solicitação AIDF-e?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55", confirmButtonText: "Sim, Excluir",
                        cancelButtonText: "Não, Cancelar",
                        closeOnConfirm: false,
                        closeOnCancel: false
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            $scope.confirmDelete(id);
                        } else {
                            SweetAlert.info("Cancelado", "A solicitação de AIDF-e não foi removido :)", "error");
                        }
                    });
            });
        };

        $scope.confirmDelete = function (id) {
            Aidfe.delete({id: id},
                function () {
                    SweetAlert.info("Removido!", "A Solicitação de AIDF-e foi removido com sucesso.", "success");
                    $state.reload();
                });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clean();
        };

        $scope.clear = function () {
            $scope.aidfe = {id: null};
        };
    });

'use strict';

angular.module('nfseApp')
    .filter('characters', function () {
        return function (input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        };
    })
    .filter('words', function () {
        return function (input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        };
    });

'use strict';

angular.module('nfseApp')
    .service('ParseLinks', function () {
        this.parse = function (header) {
            if (header.length == 0) {
                throw new Error("input must not be of zero length");
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function (p) {
                var section = p.split(';');
                if (section.length != 2) {
                    throw new Error("section could not be split on ';'");
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp("([^?=&]+)(=([^&]*))?", "g"),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString['page'];
                if( angular.isString(page) ) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });

            return links;
        }
    });

'use strict';

angular.module('nfseApp')
    .service('DateUtils', function ($filter) {
            this.convertLocaleDateToServer = function (date) {
                if (date) {
                    return $filter('date')(date, 'yyyy-MM-dd HH:mm:ss');
                } else {
                    return null;
                }
            };

            this.convertLocaleDateFromServer = function (date) {
                if (date) {
                    var dateHour = date.split(" ");
                    var date = dateHour[0].split("-");
                    var hour = dateHour[1] ? dateHour[1].split(":") : null;
                    var retorno;
                    if (hour) {
                        retorno = new Date(date[0], date[1] - 1, date[2], hour[0], hour[1], hour[2]);
                    } else {
                        retorno = new Date(date[0], date[1] - 1, date[2]);
                    }
                }
                return retorno;
            };

            this.convertDateTimeFromServer = function (date) {
                if (date) {
                    return new Date(date);
                } else {
                    return null;
                }
            };

            this.zerarTempo = function (date) {
                if (date) {
                    date.setHours(0);
                    date.setMinutes(0);
                    date.setSeconds(0);
                    date.setMilliseconds(0);
                }
                return date;
            }
        }
    );

/*jshint bitwise: false*/
'use strict';

angular.module('nfseApp')
    .service('Base64', function () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';
        this.encode = function (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        };

        this.decode = function (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }
        };
    })
    .factory('StorageService', function ($window) {
        return {

            get: function (key) {
                return JSON.parse($window.localStorage.getItem(key));
            },

            save: function (key, data) {
                $window.localStorage.setItem(key, JSON.stringify(data));
            },

            remove: function (key) {
                $window.localStorage.removeItem(key);
            },

            clearAll : function () {
                $window.localStorage.clear();
            }
        };
    });


'use strict';

angular.module('nfseApp')
    .factory('User', function ($resource) {
        return $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {method: 'PUT'},

            'acrescentarTentativaAcesso': {
                url: 'api/users-acrescentar-tentativa-login/:login',
                method: 'GET',
            },
            'zerarTentativaAcesso': {
                url: 'api/users-zerar-tentativa-login/:login',
                method: 'GET',
            }
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('UserSearch', function ($resource) {
        return $resource('api/_search/users/:query', {}, {
            'query': {method: 'GET', isArray: true},
            'getByCpf': {method: 'GET', isArray: true, url: 'api/_search/users-cpf/:query'}
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('Notificacao', function ($resource, notify, SweetAlert) {
        var template = './app/components/notify/notify.html';
        return {
            priority: function (title, message) {
                SweetAlert.swal({title: title, text: message, type: "success", html: true});
            },
            error: function (title, message) {
                SweetAlert.swal({title: title, text: message, type: "error", html: true});
            },
            info: function (title, message) {
                SweetAlert.swal({title: title, text: message, type: "info", html: true});
            },
            warn: function (title, message) {
                SweetAlert.swal({title: title, text: message, type: "warning", html: true});
            },
            confirmDelete: function (callBack) {
                SweetAlert.swal({
                        title: "Confirme a exclusão",
                        text: "Você tem certeza que quer excluir o registro selecionado?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55", confirmButtonText: "Sim, Excluir",
                        cancelButtonText: "Não, Cancelar",
                        closeOnConfirm: false,
                        closeOnCancel: false
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            callBack();
                            SweetAlert.success("Removido!", "O registro foi removido com sucesso.");
                        } else {
                            SweetAlert.error("Cancelado", "O registro não foi removido :)");
                        }
                    });
            },
            confirm: function (title, text, type, callBack) {
                SweetAlert.swal({
                        title: title,
                        text: text,
                        type: type,
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Sim",
                        cancelButtonText: "Não",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            callBack();
                        }
                    });
            },

            camposObrigatorios: function (mensagem, tipoMensagem) {

                var conteudo = "";
                angular.forEach(mensagem, function (msg) {
                    conteudo += '<div class="alert alert-warning" align="left">' + msg + '</div>';
                });
                SweetAlert.swal({
                        title: "Atenção!",
                        type: tipoMensagem,
                        showCancelButton: false,
                        text: conteudo,
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        html: true
                    }
                )
            },
        }
    })
;

'use strict';

angular.module('nfseApp')
    .directive('activeMenu', function($translate, $locale, tmhDynamicLocale) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var language = attrs.activeMenu;

                scope.$watch(function() {
                    return $translate.use();
                }, function(selectedLanguage) {
                    if (language === selectedLanguage) {
                        tmhDynamicLocale.set(language);
                        element.addClass('active');
                    } else {
                        element.removeClass('active');
                    }
                });
            }
        };
    })
    .directive('activeLink', function(location) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var clazz = attrs.activeLink;
                var path = attrs.href;
                path = path.substring(1); //hack because path does bot return including hashbang
                scope.location = location;
                scope.$watch('location.path()', function(newPath) {
                    if (path === newPath) {
                        element.addClass(clazz);
                    } else {
                        element.removeClass(clazz);
                    }
                });
            }
        };
    });

'use strict';

angular.module('nfseApp')
    .controller('NavbarController',
        function ($scope, $rootScope, $location, $state, $window, Auth, Principal, localStorageService,
                  Imagem, NotaFiscal, DeclaracaoMensalServico, TrocaEmpresa, Configuracao, Sistema) {
            $scope.$state = $state;
            $scope.carregarDadosDoPrestador = carregarDadosDoPrestador;
            $scope.abrirTrocarEmpresa = abrirTrocarEmpresa;
            $scope.logout = logout;
            $scope.carregarDadosUsuario = carregarDadosUsuario;
            $scope.isPrestadorPermitido = isPrestadorPermitido;
            $scope.isCartorio = isCartorio;
            $scope.versaoSistema;

            Sistema.getVersaoSistema({}, function (data) {
                $scope.versaoSistema = data.versao;
            });

            $rootScope.$on('nfseApp:navbarUpdate', function (event, account) {
                $scope.carregarDadosUsuario();
            });

            function carregarDadosUsuario() {
                Principal.identity().then(function (account) {
                    if (account) {
                        $scope.account = account;
                        $scope.isAuthenticated = Principal.isAuthenticated;
                        carregarImagemUsuario();
                        $scope.carregarDadosDoPrestador();
                    }
                });

                Principal.config().then(function (configuracao) {
                    $rootScope.configuracao = configuracao;
                    $rootScope.localizacao = configuracao.municipio;
                    $rootScope.logoMunicipio = configuracao.logoMunicipio;
                });

                Configuracao.getPerfil({}, function (data) {
                    $scope.perfilApp = data.perfil;
                })

            };

            carregarDadosUsuario();

            function logout() {
                Auth.logout();
                $scope.account = null;
                $scope.prestadorPrincipal = null;
                $rootScope.logoPrestador = null;
                localStorageService.set("prestadorPrincipal", null);
                $state.go('login');
            };

            function carregarImagemUsuario() {
                if ($scope.account) {
                    Imagem.getImageFromUsuario({}, function (imagem) {
                        if (imagem && imagem.conteudo) {
                            $scope.account.fotoAjustada = imagem.conteudo;
                        }
                    }, function () {
                        if ($scope.account) {
                            $scope.account.fotoAjustada = "/assets/images/user-default.jpg";
                        }
                    })
                }
            }

            function carregarImagemPrestador() {
                if ($scope.prestadorPrincipal) {
                    Imagem.getImageFromPrestador({id: $scope.prestadorPrincipal.prestador.id}, function (result) {
                        $rootScope.logoPrestador = result
                    }, function (error) {
                        $rootScope.logoPrestador = null;
                    });
                } else {
                    $rootScope.logoPrestador = null;
                }
            }

            function carregarDadosDoPrestador() {

                $scope.prestadorPrincipal = localStorageService.get("prestadorPrincipal");
                if ($scope.prestadorPrincipal) {
                    carregarImagemPrestador();
                    $scope.alertas = [];
                }
            }

            function adicionarAlerta(type, text) {
                var items = {
                    type: type,
                    text: text
                };
                if ($scope.alertas.indexOf(items) < 0) {
                    $scope.alertas.push(items)
                }

                $rootScope.alertasDoSistema = $scope.alertas;
            }

            function abrirTrocarEmpresa() {
                TrocaEmpresa.open();
            }

            function isPrestadorPermitido() {
                return ($scope.prestadorPrincipal && $scope.prestadorPrincipal.permitido) || !$scope.account.pessoaFisica;
            }
            function isCartorio() {
                return $scope.prestadorPrincipal.prestador.enquadramentoFiscal &&
                    $scope.prestadorPrincipal.prestador.enquadramentoFiscal.cartorio;
            }

            $scope.emitirNotaFiscal = function () {
                NotaFiscal.emitirNotaFiscal();
            }
        })
;

'use strict';
angular.module('nfseApp')
    .directive('loading', function ($http) {
        return {
            restrict: 'A',
            link: function (scope, elm, attrs) {
                scope.isLoading = function () {
                    return $http.pendingRequests.length > 0;
                };
                scope.$watch(scope.isLoading, function (v) {
                    if (v) {
                        elm.show();
                    } else {
                        elm.hide();
                    }
                });
            }
        }
    });

'use strict';

angular.module('nfseApp')
    .factory('Language', function ($q, $http, $translate, LANGUAGES) {
        return {
            getCurrent: function () {
                var deferred = $q.defer();
                var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

                if (angular.isUndefined(language)) {
                    language = 'pt-br';
                }

                deferred.resolve(language);
                return deferred.promise;
            },
            getAll: function () {
                var deferred = $q.defer();
                deferred.resolve(LANGUAGES);
                return deferred.promise;
            }
        };
    })

/*
 Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
 They are written in English to avoid character encoding issues (not a perfect solution)
 */
    .constant('LANGUAGES', ['pt-br'
        //JHipster will add new languages here
    ]
);





'use strict';

angular.module('nfseApp')
    .controller('LanguageController', function ($scope, $translate, Language, tmhDynamicLocale) {
        $scope.changeLanguage = function (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        };

        Language.getAll().then(function (languages) {
            $scope.languages = languages;
        });
    })
    .filter('findLanguageFromKey', function () {
        return function (lang) {
            return {
                /*  "en": "English",
                "fr": "Français",
                "de": "Deutsch",
                "it": "Italiano",
                "ru": "Русский",
                "tr": "Türkçe",
                "ca": "Català",
                "da": "Dansk",
                "es": "Español",
                "hu": "Magyar",
                "ja": "日本語",
                "kr": "한국어",
                 "pl": "Polski",*/
                "pt-br": "Português (Brasil)",
                /*"ro": "Română",
                "sv": "Svenska",
                "zh-cn": "中文（简体）",
                 "zh-tw": "繁體中文",*/
            }[lang];
        }
    });

(function () {
    'use strict';

    angular.module('nfseApp')
        .directive('sideNavigation', function ($timeout) {
            return {
                restrict: 'A',
                link: function(scope, element) {
                    // Call the metsiMenu plugin and plug it to sidebar navigation
                    $timeout(function(){
                        element.metisMenu();

                    });
                }
            };
        });

})();
(function () {
    'use strict';


    var minimalizaSidebar = {
        restrict: 'A',
        template: '<a class="navbar-minimalize minimalize-styl-2 text-white" href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
        controller: minimalizaSidebarController
    }

    angular
        .module('nfseApp')
        .component('minimalizaSidebar', minimalizaSidebar);

    minimalizaSidebarController.$inject = ['$scope'];


    function minimalizaSidebarController($scope) {

        $scope.minimalize = function () {
            $("body").toggleClass("mini-navbar");
            if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {
                // Hide menu in order to smoothly turn on when maximize menu
                $('#side-menu').hide();
                // For smoothly turn on menu
                setTimeout(
                    function () {
                        $('#side-menu').fadeIn(500);
                    }, 100);
            } else if ($('body').hasClass('fixed-sidebar')) {
                $('#side-menu').hide();
                setTimeout(
                    function () {
                        $('#side-menu').fadeIn(500);
                    }, 300);
            } else {
                // Remove all inline style from jquery fadeIn function to reset menu state
                $('#side-menu').removeAttr('style');
            }
        }

    };
})();



/*
 * metismenu - v2.0.2
 * A jQuery menu plugin
 * https://github.com/onokumus/metisMenu
 *
 * Made by Osman Nuri Okumus
 * Under MIT License
 */

!function(a){"use strict";function b(){var a=document.createElement("mm"),b={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"};for(var c in b)if(void 0!==a.style[c])return{end:b[c]};return!1}function c(b){return this.each(function(){var c=a(this),d=c.data("mm"),f=a.extend({},e.DEFAULTS,c.data(),"object"==typeof b&&b);d||c.data("mm",d=new e(this,f)),"string"==typeof b&&d[b]()})}a.fn.emulateTransitionEnd=function(b){var c=!1,e=this;a(this).one("mmTransitionEnd",function(){c=!0});var f=function(){c||a(e).trigger(d.end)};return setTimeout(f,b),this};var d=b();d&&(a.event.special.mmTransitionEnd={bindType:d.end,delegateType:d.end,handle:function(b){return a(b.target).is(this)?b.handleObj.handler.apply(this,arguments):void 0}});var e=function(b,c){this.$element=a(b),this.options=a.extend({},e.DEFAULTS,c),this.transitioning=null,this.init()};e.TRANSITION_DURATION=350,e.DEFAULTS={toggle:!0,doubleTapToGo:!1,activeClass:"active"},e.prototype.init=function(){var b=this,c=this.options.activeClass;this.$element.find("li."+c).has("ul").children("ul").addClass("collapse in"),this.$element.find("li").not("."+c).has("ul").children("ul").addClass("collapse"),this.options.doubleTapToGo&&this.$element.find("li."+c).has("ul").children("a").addClass("doubleTapToGo"),this.$element.find("li").has("ul").children("a").on("click.metisMenu",function(d){var e=a(this),f=e.parent("li"),g=f.children("ul");return d.preventDefault(),f.hasClass(c)?b.hide(g):b.show(g),b.options.doubleTapToGo&&b.doubleTapToGo(e)&&"#"!==e.attr("href")&&""!==e.attr("href")?(d.stopPropagation(),void(document.location=e.attr("href"))):void 0})},e.prototype.doubleTapToGo=function(a){var b=this.$element;return a.hasClass("doubleTapToGo")?(a.removeClass("doubleTapToGo"),!0):a.parent().children("ul").length?(b.find(".doubleTapToGo").removeClass("doubleTapToGo"),a.addClass("doubleTapToGo"),!1):void 0},e.prototype.show=function(b){var c=this.options.activeClass,f=a(b),g=f.parent("li");if(!this.transitioning&&!f.hasClass("in")){g.addClass(c),this.options.toggle&&this.hide(g.siblings().children("ul.in")),f.removeClass("collapse").addClass("collapsing").height(0),this.transitioning=1;var h=function(){f.removeClass("collapsing").addClass("collapse in").height(""),this.transitioning=0};return d?void f.one("mmTransitionEnd",a.proxy(h,this)).emulateTransitionEnd(e.TRANSITION_DURATION).height(f[0].scrollHeight):h.call(this)}},e.prototype.hide=function(b){var c=this.options.activeClass,f=a(b);if(!this.transitioning&&f.hasClass("in")){f.parent("li").removeClass(c),f.height(f.height())[0].offsetHeight,f.addClass("collapsing").removeClass("collapse").removeClass("in"),this.transitioning=1;var g=function(){this.transitioning=0,f.removeClass("collapsing").addClass("collapse")};return d?void f.height(0).one("mmTransitionEnd",a.proxy(g,this)).emulateTransitionEnd(e.TRANSITION_DURATION):g.call(this)}};var f=a.fn.metisMenu;a.fn.metisMenu=c,a.fn.metisMenu.Constructor=e,a.fn.metisMenu.noConflict=function(){return a.fn.metisMenu=f,this}}(jQuery);

(function () {
    'use strict';
    $(document).ready(function () {


        // Full height of sidebar
        function fix_height() {
            var heightWithoutNavbar = $("body > #wrapper").height() - 61;
            $(".sidebard-panel").css("min-height", heightWithoutNavbar + "px");

            var navbarHeigh = $('nav.navbar-default').height();
            var wrapperHeigh = $('#page-wrapper').height();

            if (navbarHeigh > wrapperHeigh) {
                $('#page-wrapper').css("min-height", navbarHeigh + "px");
            }

            if (navbarHeigh < wrapperHeigh) {
                $('#page-wrapper').css("min-height", $(window).height() + "px");
            }

            if ($('body').hasClass('fixed-nav')) {
                $('#page-wrapper').css("min-height", $(window).height() - 60 + "px");
            }

        }


        $(window).bind("load resize scroll", function () {
            if (!$("body").hasClass('body-small')) {
                fix_height();
            }
        });

        // Move right sidebar top after scroll
        $(window).scroll(function () {
            if ($(window).scrollTop() > 0 && !$('body').hasClass('fixed-nav')) {
                $('#right-sidebar').addClass('sidebar-top');
            } else {
                $('#right-sidebar').removeClass('sidebar-top');
            }
        });


        setTimeout(function () {
            fix_height();
        }, 500)
    });

// Minimalize menu when screen is less than 768px
    $(function () {
        $(window).bind("load resize", function () {
            if ($(this).width() < 769) {
                $('body').addClass('body-small')
            } else {
                $('body').removeClass('body-small')
            }
        })
    })

})();
(function () {
    'use strict';

    angular.module('nfseApp')
        .directive('icheck', function ($timeout) {
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function ($scope, element, $attrs, ngModel) {
                    return $timeout(function () {
                        var value;
                        value = $attrs['value'];

                        $scope.$watch($attrs['ngModel'], function (newValue) {
                            $(element).iCheck('update');
                        })

                        return $(element).iCheck({
                            checkboxClass: 'icheckbox_square-green',
                            radioClass: 'iradio_square-green'

                        }).on('ifChanged', function (event) {
                            if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                                $scope.$apply(function () {
                                    return ngModel.$setViewValue(event.target.checked);
                                });
                            }
                            if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                                return $scope.$apply(function () {
                                    return ngModel.$setViewValue(value);
                                });
                            }
                        });
                    });
                }
            };
        });

})();
'use strict';

angular.module('nfseApp')
    .directive('searchBoxCpf', function ($translate, $locale, tmhDynamicLocale) {
        var tmplt = "\
        <div class='form-group' ng-form='formSearchBoxCpf'> \
        CPF\
        <div class='input-group' >\
                            <input type='text' class='form-control' name='searchByCpf' \
                             ng-model='ngModel'\
                             ui-br-cpf-mask='' \
                             required\
                                 ng-keyup='keyPressPlanItem($event)'\
                                 placeholder='{{&quot;global.form.search&quot; | translate}}'>\
                                    <span class='input-group-btn'>\
                                        <button class='btn btn-info'  ng-click='search()' ng-disabled='formSearchBoxCpf.searchByCpf.$invalid'>\
                                         <span class='glyphicon glyphicon-search'></span>\
                                        </button>\
                                    </span>\
                                    </div>\
       <div class='has-error' ng-show='formSearchBoxCpf.searchByCpf.$invalid'>\
       <p class='help-block small' ng-show='formSearchBoxCpf.searchByCpf.$error.required'>\
            O CPF é obrigatório.\
        </p>\
        <p class='help-block small' ng-show='formSearchBoxCpf.searchByCpf.$invalid' >\
            O CPF é inválido.\
        </p>  \
        </div>\
        </div>";

        return {
            restrict: 'E',
            scope: {
                ngModel: '=',
                searchMethod: '&searchMethod'
            },
            require: '?ngModel',
            template: tmplt,
            replace: true,
            link: function (scope, elm, attrs, ctrl) {
                scope.search = function () {
                    scope.searchMethod();
                };

                scope.keyPressPlanItem = function ($event) {
                    if ($event.keyCode == 13) {
                        if (scope.formSearchBoxCpf.searchByCpf.$valid) {
                            scope.search();
                        }
                    }
                };

                scope.$watch('searchByCpf.$valid', function () {
                });

            }
        };
    });


'use strict';

angular.module('nfseApp')
    .directive('searchBox', function ($translate, $locale, tmhDynamicLocale) {
        var tmplt = "<div class='form-group input-group'>\
                            <input type='text' class='form-control'\
                                 ng-model='ngModel' id='searchQuery'\
                                 ng-keyup='keyPressPlanItem($event)'\
                                 placeholder='Pesquisar ...'>\
                                    <span class='input-group-btn'>\
                                        <button class='btn btn-success' ng-click='search()'><span\
                                             class='glyphicon glyphicon-search'></span>\
                                        </button>\
                                    </span>\
                    </div>";

        return {
            restrict: 'E',
            scope: {
                ngModel: '=',
                searchMethod: '&searchMethod'
            },
            require: '?ngModel',
            template: tmplt,
            replace: true,
            link: function (scope, elm, attrs, ctrl) {
                scope.search = function () {
                    scope.searchMethod();
                }
                scope.keyPressPlanItem = function ($event) {
                    if ($event.keyCode == 13) {
                        scope.search();
                    }
                };

            }
        };
    });


/* globals $ */
'use strict';

angular.module('nfseApp')
    .directive('nfseAppPagination', function() {
        return {
            templateUrl: 'app/components/form/pagination.html'
        };
    });

/* globals $ */
'use strict';

angular.module('nfseApp')
    .directive('nfseAppPager', function() {
        return {
            templateUrl: 'app/components/form/pager.html'
        };
    });

/* globals $ */
'use strict';

angular.module('nfseApp')
    .directive('ngEnter', function () {
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.ngEnter, {'event': event});
                    });

                    event.preventDefault();
                }
            });
        };
    });

'use strict';

angular.module('nfseApp')
    .directive('multipleEmails', function () {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, ctrl) {
                ctrl.$parsers.unshift(function(viewValue) {

                    var emails = viewValue.split(',');
                    // define single email validator here
                    var re = /\S+@\S+\.\S+/;

                    // angular.foreach(emails, function() {
                    var validityArr = emails.map(function(str){
                        return re.test(str.trim());
                    }); // sample return is [true, true, true, false, false, false]
                    var atLeastOneInvalid = false;
                    angular.forEach(validityArr, function(value) {
                        if(value === false)
                            atLeastOneInvalid = true;
                    });
                    if(!atLeastOneInvalid) {
                        // ^ all I need is to call the angular email checker here, I think.
                        ctrl.$setValidity('multipleEmails', true);
                        return viewValue;
                    } else {
                        ctrl.$setValidity('multipleEmails', false);
                        return undefined;
                    }
                    // })
                });
            }
        };
    });

/* globals $ */
'use strict';

angular.module('nfseApp')
    .directive('showValidation', function() {
        return {
            restrict: 'A',
            require: 'form',
            link: function (scope, element) {
                element.find('.form-group').each(function() {
                    var $formGroup = $(this);
                    var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                    if ($inputs.length > 0) {
                        $inputs.each(function() {
                            var $input = $(this);
                            scope.$watch(function() {
                                return $input.hasClass('ng-invalid') && $input.hasClass('ng-dirty');
                            }, function(isInvalid) {
                                $formGroup.toggleClass('has-error', isInvalid);
                            });
                        });
                    }
                });
            }
        };
    });

'use strict';

angular.module('nfseApp')
    .directive('currencyInput', function ($browser, $filter) {
        return {
            require: 'ngModel',
            link: function ($scope, $element, $attrs, ngModel) {
                var listener = function () {
                    var value = $element.val().replace(/,/g, '');
                    $element.val($filter('number')(value, 0));
                };

                // This runs when we update the text field from element
                ngModel.$parsers.push(function (viewValue) {
                    return parseInt(viewValue.replace(/,/g, ''), 10);
                });

                // This runs when the model gets updated on the scope directly and keeps our view in sync
                ngModel.$formatters.push(function (modelValue) {
                    return modelValue == null || modelValue.length === 0 ? '' : $filter('number')(modelValue, 0);
                });

                ngModel.$viewChangeListeners = function () {
                    $element.val($filter('number')(ngModel.$viewValue, 0))
                }

                $element.bind('change', listener);
                $element.bind('keypress', function (event) {
                    var key = event.which;
                    // If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
                    // This lets us support copy and paste too
                    if (key === 0 || key === 8 || (15 < key && key < 19) || (37 <= key && key <= 40)) {
                        return;
                    }
                    $browser.defer(listener); // Have to do this or changes don't get picked up properly
                });
                $element.bind('paste cut', function () {
                    $browser.defer(listener);
                });
            }
        }
    });


'use strict';

angular.module('nfseApp')
    .directive('dateInput', function ($translate, $locale, tmhDynamicLocale) {
        var tmplt = "<p class='input-group {{class}} date-input'> \
            <input type='text' class='form-control '\
              datepicker-popup='dd/MM/yyyy'\
              ng-readonly='readonly'\
              ng-model='ngModel' is-open='dateDialogOpened'\
             /> \
            <span class='input-group-btn'> \
                <button type='button' class='btn btn-info' ng-click='openDateDialog($event)'> \
                    <i class='glyphicon glyphicon-calendar'></i> \
                </button> \
            </span> \
        </p>";

        return {
            restrict: 'E',
            scope: {
                ngModel: '=',
                readonly: '='
            },
            require: '?ngModel',
            template: tmplt,
            replace: true,
            link: function (scope, elm, attrs, ctrl) {
                scope.class = attrs.class;
                scope.dateDialogOpened = false;
                scope.openDateDialog = function ($event) {
                    $event.preventDefault();
                    $event.stopPropagation();
                    scope.dateDialogOpened = true;
                };
            }
        };
    });


/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */
var saveAs=saveAs||function(e){"use strict";if(typeof e==="undefined"||typeof navigator!=="undefined"&&/MSIE [1-9]\./.test(navigator.userAgent)){return}var t=e.document,n=function(){return e.URL||e.webkitURL||e},r=t.createElementNS("http://www.w3.org/1999/xhtml","a"),o="download"in r,a=function(e){var t=new MouseEvent("click");e.dispatchEvent(t)},i=/constructor/i.test(e.HTMLElement)||e.safari,f=/CriOS\/[\d]+/.test(navigator.userAgent),u=function(t){(e.setImmediate||e.setTimeout)(function(){throw t},0)},s="application/octet-stream",d=1e3*40,c=function(e){var t=function(){if(typeof e==="string"){n().revokeObjectURL(e)}else{e.remove()}};setTimeout(t,d)},l=function(e,t,n){t=[].concat(t);var r=t.length;while(r--){var o=e["on"+t[r]];if(typeof o==="function"){try{o.call(e,n||e)}catch(a){u(a)}}}},p=function(e){if(/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type)){return new Blob([String.fromCharCode(65279),e],{type:e.type})}return e},v=function(t,u,d){if(!d){t=p(t)}var v=this,w=t.type,m=w===s,y,h=function(){l(v,"writestart progress write writeend".split(" "))},S=function(){if((f||m&&i)&&e.FileReader){var r=new FileReader;r.onloadend=function(){var t=f?r.result:r.result.replace(/^data:[^;]*;/,"data:attachment/file;");var n=e.open(t,"_blank");if(!n)e.location.href=t;t=undefined;v.readyState=v.DONE;h()};r.readAsDataURL(t);v.readyState=v.INIT;return}if(!y){y=n().createObjectURL(t)}if(m){e.location.href=y}else{var o=e.open(y,"_blank");if(!o){e.location.href=y}}v.readyState=v.DONE;h();c(y)};v.readyState=v.INIT;if(o){y=n().createObjectURL(t);setTimeout(function(){r.href=y;r.download=u;a(r);h();c(y);v.readyState=v.DONE});return}S()},w=v.prototype,m=function(e,t,n){return new v(e,t||e.name||"download",n)};if(typeof navigator!=="undefined"&&navigator.msSaveOrOpenBlob){return function(e,t,n){t=t||e.name||"download";if(!n){e=p(e)}return navigator.msSaveOrOpenBlob(e,t)}}w.abort=function(){};w.readyState=w.INIT=0;w.WRITING=1;w.DONE=2;w.error=w.onwritestart=w.onprogress=w.onwrite=w.onabort=w.onerror=w.onwriteend=null;return m}(typeof self!=="undefined"&&self||typeof window!=="undefined"&&window||this.content);if(typeof module!=="undefined"&&module.exports){module.exports.saveAs=saveAs}else if(typeof define!=="undefined"&&define!==null&&define.amd!==null){define("FileSaver.js",function(){return saveAs})}

'use strict';

angular.module('nfseApp')
    .service('ExportarXls', function ($http, ImpressaoPdf) {

        this.getXls = function (dto) {
            var lista = [];
            angular.forEach(dto.linhas, function (rps) {
                var linha = {};
                for (var i = 0; i < dto.colunas.length; i++) {
                    var coluna = dto.colunas[i];
                    linha[coluna.valor] = rps[coluna.valor];
                }
                lista.push(linha);
            });
            dto.linhas = lista;
            $http.post('/api/exportar/xls', dto).then(function (result) {
                console.log('buscou', result);

                var a = document.createElement('a');
                a.href = 'data:application/csv;base64,' + result.data.conteudo;
                a.target = '_blank';
                a.download = 'filename.csv';
                document.body.appendChild(a);
                a.click();
            });
        };


        this.getPdf = function (dto) {
            var lista = [];
            angular.forEach(dto.linhas, function (rps) {
                var linha = {};
                for (var i = 0; i < dto.colunas.length; i++) {
                    var coluna = dto.colunas[i];
                    console.log(coluna);
                    console.log(rps);
                    console.log(rps[coluna.valor]);
                    linha[coluna.valor] = rps[coluna.valor];
                }
                lista.push(linha);
            });
            dto.linhas = lista;

            ImpressaoPdf.imprimirPdfViaPost('/api/exportar/pdf', dto);
        };


    });


angular.module('nfseApp')
    .factory('EnumeradoJsonService', function ($http) {
        return {
            getEnumValues: function (name) {
                var enuns = [];
                $http.get('i18n/pt-br/' + name + '.json').success(function (data) {
                    angular.forEach(Object.keys(data), function (primeiroField) {
                        angular.forEach(Object.keys(data[primeiroField]), function (sugundoField) {
                            angular.forEach(Object.keys(data[primeiroField][sugundoField]), function (field) {
                                enuns.push({name: field, value: data[primeiroField][sugundoField][field]})
                            });

                        });
                    });


                });
                return enuns;
            }
        }
    });


(function () {
    'use strict';

    angular
        .module('nfseApp')
        .factory('EnumeradoService', EnumeradoService);

    EnumeradoService.$inject = ['$resource'];

    function EnumeradoService($resource) {
        return $resource('api/enumerado/:id', {}, {
            'values': {
                url: 'api/enumerado',
                method: 'POST',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('nfseApp')
        .factory('EnumCacheService', EnumCacheService);

    EnumCacheService.$inject = ['EnumeradoService', '$q'];

    function EnumCacheService(EnumeradoService, $q) {

        var service = {
            carregarValuesEnum: carregarValuesEnum,
            buscarLabelEnum: buscarLabelEnum
        };

        var cache = [];

        function carregarValuesEnum(nameEnum) {
            var values = undefined;
            angular.forEach(cache, function (item) {
                if (item.nameEnum == nameEnum) {
                    values = item.values;
                }
            });
            if (values == undefined) {
                values = EnumeradoService.values(nameEnum);
                cache.push({'nameEnum': nameEnum, 'values': values});
            }
            return values;
        }

        function buscarLabelEnum(name, nameEnum) {
            var label = name;
            var values = carregarValuesEnum(nameEnum);
            angular.forEach(values, function (data) {
                if (data.name == name) {
                    label = data.value;
                }
            });
            return label;
        }

        return service;
    }
})();

'use strict';

angular.module('nfseApp')
    .factory('Register', function ($resource) {
        return $resource('api/register', {}, {
            'autorizarUsuario': {
                method: 'POST',
                url: 'api/prestador-servico/vincular-usuario'
            }
        });
    });



'use strict';

angular.module('nfseApp')
    .factory('Password', function ($resource) {
        return $resource('api/account/change_password/', {}, {});
    });

angular.module('nfseApp')
    .factory('PasswordResetInit', function ($resource) {
        return $resource('api/account/reset_password/init', {}, {})
    });

angular.module('nfseApp')
    .factory('PasswordResetFinish', function ($resource) {
        return $resource('api/account/reset_password/finish', {}, {})
    });

'use strict';

angular.module('nfseApp')
    .factory('Activate', function ($resource) {
        return $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });
    });



'use strict';

angular.module('nfseApp')
    .factory('Account', function Account($resource) {
        return $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('AuthServerProvider', function loginService($http, localStorageService, Base64) {
        return {
            login: function(credentials) {
                var data = "username=" + credentials.username + "&password="
                    + credentials.password + "&grant_type=password&scope=read%20write&" +
                    "client_secret=mySecretOAuthSecret&client_id=nfseapp";
                return $http.post('oauth/token', data, {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Accept": "application/json",
                        "Authorization": "Basic " + Base64.encode("nfseapp" + ':' + "mySecretOAuthSecret")
                    }
                }).success(function (response) {
                    var expiredAt = new Date();
                    expiredAt.setSeconds(expiredAt.getSeconds() + response.expires_in);
                    response.expires_at = expiredAt.getTime();
                    localStorageService.set('token', response);
                    return response;
                });
            },
            logout: function() {
                // logout from the server
                $http.post('api/logout').then(function() {
                    localStorageService.clearAll();
                });
            },
            getToken: function () {
                return localStorageService.get('token');
            },
            hasValidToken: function () {
                var token = this.getToken();
                return token && token.expires_at && token.expires_at > new Date().getTime();
            }
        };
    });

'use strict';

angular.module('nfseApp')
    .factory('Principal', function Principal($q, Account, Configuracao, localStorageService, PrestadorServicos) {
        var _identity, _configuracao,
            _authenticated = false;

        return {
            isIdentityResolved: function () {
                return angular.isDefined(_identity);
            },
            isAuthenticated: function () {
                return _authenticated;
            },
            isInRole: function (role) {
                if (!_authenticated || !_identity || !_identity.roles) {
                    return false;
                }
                if (_identity.roles.indexOf(role) !== -1) {
                    return true;
                }
                var prestadorPrincipal = localStorageService.get('prestadorPrincipal');
                return prestadorPrincipal && prestadorPrincipal.roles && prestadorPrincipal.roles.indexOf(role) !== -1;

            },
            isInAnyRole: function (roles) {
                if (!_authenticated || !_identity.roles) {
                    return false;
                }

                for (var i = 0; i < roles.length; i++) {
                    if (this.isInRole(roles[i])) {
                        return true;
                    }
                }

                return false;
            },
            authenticate: function (identity) {
                _identity = identity;
                _authenticated = identity !== null;
            },

            config: function (force) {
                var deferred = $q.defer();
                if (force === true) {
                    _configuracao = undefined;
                }
                if (angular.isDefined(_configuracao)) {
                    deferred.resolve(_configuracao);
                    return deferred.promise;
                }
                Configuracao.get().$promise
                    .then(function (configuracao) {
                        _configuracao = configuracao;
                        deferred.resolve(_configuracao);
                    })
                    .catch(function (error) {
                        _configuracao = null;
                        deferred.resolve(_configuracao);
                    });

                return deferred.promise;

            },

            identity: function (force) {
                var deferred = $q.defer();

                if (force === true) {
                    _identity = undefined;
                }

                // check and see if we have retrieved the identity data from the server.
                // if we have, reuse it by immediately resolving
                if (angular.isDefined(_identity)) {
                    deferred.resolve(_identity);

                    return deferred.promise;
                }

                // retrieve the identity data from the server, update the identity object, and then resolve.
                Account.get().$promise
                    .then(function (account) {
                        _identity = account.data;
                        _authenticated = true;
                        if (_identity) {
                            localStorageService.set('prestadorPrincipal', _identity.empresa);
                        }
                        deferred.resolve(_identity);
                    })
                    .catch(function () {
                        _identity = null;
                        _authenticated = false;
                        deferred.resolve(_identity);
                    });

                return deferred.promise;
            }
        };
    });

'use strict';

angular.module('nfseApp')
    .directive('hasAnyRole', ['Principal', function (Principal) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var setVisible = function () {
                        element.removeClass('hidden');
                    },
                    setHidden = function () {
                        element.addClass('hidden');
                    },
                    defineVisibility = function (reset) {
                        var result;
                        if (reset) {
                            setVisible();
                        }

                        result = Principal.isInAnyRole(roles);
                        if (result) {
                            setVisible();
                        } else {
                            setHidden();
                        }
                    },
                    roles = attrs.hasAnyRole.replace(/\s+/g, '').split(',');

                if (roles.length > 0) {
                    defineVisibility(true);
                }
            }
        };
    }])
    .directive('hasRole', ['Principal', function (Principal) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var setVisible = function () {
                        element.removeClass('hidden');
                    },
                    setHidden = function () {
                        element.addClass('hidden');
                    },
                    defineVisibility = function (reset) {
                        var result;
                        if (reset) {
                            setVisible();
                        }

                        result = Principal.isInRole(role);
                        if (result) {
                            setVisible();
                        } else {
                            setHidden();
                        }
                    },
                    role = attrs.hasRole.replace(/\s+/g, '');

                if (role.length > 0) {
                    defineVisibility(true);
                }
            }
        };
    }]);

'use strict';

angular.module('nfseApp')
    .factory('Auth', function Auth($rootScope, $state, $q, $translate, Principal, AuthServerProvider, Account, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        return {
            login: function (credentials, callback) {
                var cb = callback || angular.noop;
                var deferred = $q.defer();

                AuthServerProvider.login(credentials).then(function (data) {
                    // retrieve the logged account information
                    Principal.identity(true).then(function (account) {

                        // After the login the language will be changed to
                        // the language selected by the user during his registration
                        //$translate.use(account.langKey); // comentado para usar sempre o pt-br
                        //$translate.refresh();
                        deferred.resolve(data);
                    });
                    return cb();
                }).catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

                return deferred.promise;
            },

            logout: function () {
                AuthServerProvider.logout();
                Principal.authenticate(null);
            },

            authorize: function (force) {
                return Principal.identity(force)
                    .then(function () {
                        var isAuthenticated = Principal.isAuthenticated();

                        if ($rootScope.toState.data.roles && $rootScope.toState.data.roles.length > 0 && !Principal.isInAnyRole($rootScope.toState.data.roles)) {
                            if (isAuthenticated) {
                                // user is signed in but not authorized for desired state
                                $state.go('home');
                            }
                            else {
                                // user is not authenticated. stow the state they wanted before you
                                // send them to the signin state, so you can return them when you're done
                                $rootScope.returnToState = $rootScope.toState;
                                $rootScope.returnToStateParams = $rootScope.toStateParams;

                                // now, send them to the signin state so they can log in
                                $state.go('login');
                            }
                        }
                    });
            },
            createAccount: function (account, callback) {
                var cb = callback || angular.noop;

                return Register.save(account,
                    function () {
                        return cb(account);
                    },
                    function (err) {
                        this.logout();
                        return cb(err);
                    }.bind(this)).$promise;
            },

            updateAccount: function (account, callback) {
                var cb = callback || angular.noop;

                return Account.save(account,
                    function () {
                        return cb(account);
                    },
                    function (err) {
                        return cb(err);
                    }.bind(this)).$promise;
            },

            activateAccount: function (key, callback) {
                var cb = callback || angular.noop;

                return Activate.get(key,
                    function (response) {
                        return cb(response);
                    },
                    function (err) {
                        return cb(err);
                    }.bind(this)).$promise;
            },

            changePassword: function (trocarSenhaDTO, callback) {
                var cb = callback || angular.noop;
                return Password.save(trocarSenhaDTO, function () {
                    return cb();
                }, function (err) {
                    return cb(err);
                }).$promise;
            },

            resetPasswordInit: function (mail, callback) {
                var cb = callback || angular.noop;

                return PasswordResetInit.save(mail, function () {
                    return cb();
                }, function (err) {
                    return cb(err);
                }).$promise;
            },

            resetPasswordFinish: function (key, newPassword, callback) {
                var cb = callback || angular.noop;

                return PasswordResetFinish.save(key, newPassword, function () {
                    return cb();
                }, function (err) {
                    return cb(err);
                }).$promise;
            }
        };
    });

'use strict';

angular.module('nfseApp')
    .factory('MonitoringService', function ($rootScope, $http) {
        return {
            getMetrics: function () {
                return $http.get('metrics/metrics').then(function (response) {
                    return response.data;
                });
            },

            checkHealth: function () {
                return $http.get('health').then(function (response) {
                    return response.data;
                });
            },

            threadDump: function () {
                return $http.get('dump').then(function (response) {
                    return response.data;
                });
            }
        };
    });

'use strict';

angular.module('nfseApp')
    .factory('LogsService', function ($resource) {
        return $resource('api/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });
    });

'use strict';

angular.module('nfseApp')
    .factory('ConfigurationService', function ($rootScope, $filter, $http) {
        return {
            get: function() {
                return $http.get('configprops').then(function (response) {
                    var properties = [];
                    angular.forEach(response.data, function (data) {
                        properties.push(data);
                    });
                    var orderBy = $filter('orderBy');
                    return orderBy(properties, 'prefix');
                });
            }
        };
    });

'use strict';

angular.module('nfseApp')
    .factory('AuditsService', function ($http) {
        return {
            findAll: function () {
                return $http.get('api/audits/all').then(function (response) {
                    return response.data;
                });
            },
            findByDates: function (fromDate, toDate) {

                var formatDate =  function (dateToFormat) {
                    if (dateToFormat !== undefined && !angular.isString(dateToFormat)) {
                        return dateToFormat.getYear() + '-' + dateToFormat.getMonth() + '-' + dateToFormat.getDay();
                    }
                    return dateToFormat;
                };

                return $http.get('api/audits/byDates', {params: {fromDate: formatDate(fromDate), toDate: formatDate(toDate)}}).then(function (response) {
                    return response.data;
                });
            }
        };
    });

'use strict';

angular.module('nfseApp')
    .component('pessoaEdit', {
        restrict: 'E',
        templateUrl: 'app/component/pessoa/pessoa-edit.html',
        bindings: {
            pessoa: '=',
            formReference: '<'
        },
        controllerAs: 'vm',
        controller: function ($scope, Pessoa, CEP, $modal, $timeout) {
            var vm = this;

            $timeout(function () {
                if (!vm.pessoa) {
                    vm.pessoa = {dadosPessoais: {cpfCnpj: ""}}
                }
            }, 1000);

            $scope.preLoadResponsavel = function () {
                if (vm.pessoa.dadosPessoais.cpfCnpj) {
                    Pessoa.getPorCpfCnpj({cpfCnpj: vm.pessoa.dadosPessoais.cpfCnpj}, function (data) {
                        if (data.id) {
                            vm.pessoa = data;
                        }
                    })
                }
            };


            $scope.isFisica = function () {
                return vm.pessoa &&
                    vm.pessoa.dadosPessoais &&
                    vm.pessoa.dadosPessoais.cpfCnpj &&
                    vm.pessoa.dadosPessoais.cpfCnpj.replace(/[^\w\s]/gi, '').length == 11;
            };

            $scope.loadEnderecoByCEP = function (cep) {
                if (cep) {
                    CEP.getByCep({cep: cep}, function (endereco) {
                        if (endereco.municipio) {
                            vm.pessoa.dadosPessoais.cep = endereco.cep;
                            vm.pessoa.dadosPessoais.municipio = endereco.municipio;
                            vm.pessoa.dadosPessoais.logradouro = endereco.logradouro;
                            vm.pessoa.dadosPessoais.bairro = endereco.bairro;
                        }
                    });
                }
            };

            $scope.searchMunicipio = function (caraQueTemMunicipio) {
                var modalInstance = $modal.open({
                    templateUrl: 'app/entities/municipio/municipio-search.html',
                    controller: 'MunicipioSearchController',
                    size: 'lg'
                });
                modalInstance.result.then(function (municipio) {
                    caraQueTemMunicipio.municipio = municipio;
                    caraQueTemMunicipio.pais = {};
                }, function () {
                    //$log.info('Modal dismissed at: ' + new Date());
                });
            };
        }
    });

'use strict';

angular.module('nfseApp')
    .component('dadosPessoaisEdit', {
        restrict: 'E',
        templateUrl: 'app/component/dadospessoais/dados-pessoais-edit.html',
        bindings: {
            dadosPessoais: '=',
            formReference: '<'
        },
        controllerAs: 'vm',
        controller: function ($scope, Pessoa, CEP, $modal, $timeout) {
            var vm = this;

            $timeout(function () {
                if (!vm.dadosPessoais) {
                    vm.dadosPessoais = {cpfCnpj: ""}
                }
            }, 1000);

            $scope.preLoadResponsavel = function () {
                if (vm.dadosPessoais.cpfCnpj) {
                    Pessoa.getPorCpfCnpj({cpfCnpj: vm.dadosPessoais.cpfCnpj}, function (data) {
                        if (data.id) {
                            vm.dadosPessoais = data;
                        }
                    })
                }
            };


            $scope.isFisica = function () {
                return vm.dadosPessoais &&
                    vm.dadosPessoais.cpfCnpj &&
                    vm.dadosPessoais.cpfCnpj.replace(/[^\w\s]/gi, '').length == 11;
            };

            $scope.loadEnderecoByCEP = function (cep) {
                if (cep) {
                    CEP.getByCep({cep: cep}, function (endereco) {
                        if (endereco.municipio) {
                            vm.dadosPessoais.cep = endereco.cep;
                            vm.dadosPessoais.municipio = endereco.municipio;
                            vm.dadosPessoais.logradouro = endereco.logradouro;
                            vm.dadosPessoais.bairro = endereco.bairro;
                        }
                    });
                }
            };

            $scope.searchMunicipio = function (caraQueTemMunicipio) {
                var modalInstance = $modal.open({
                    templateUrl: 'app/entities/municipio/municipio-search.html',
                    controller: 'MunicipioSearchController',
                    size: 'lg'
                });
                modalInstance.result.then(function (municipio) {
                    caraQueTemMunicipio.municipio = municipio;
                    caraQueTemMunicipio.pais = {};
                }, function () {
                    //$log.info('Modal dismissed at: ' + new Date());
                });
            };
        }
    });

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('nfseApp')
        .constant('VERSION', "1.1.6")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

'use strict';

angular.module('nfseApp')
    .controller('UserManagementSearchCpfController', function ($scope, $modalInstance, User, ParseLinks,
                                                               Language, UserSearch, PrestadorServicos, Notificacao,
                                                               localStorageService) {
        $scope.users;
        $scope.authorities = ["ROLE_USER", "ROLE_ADMIN"];
        $scope.solicitacao = {dadosPessoais: {}};
        Language.getAll().then(function (languages) {
            $scope.languages = languages;
        });

        $scope.search = function () {
            console.error('buscar por cpf ' + $scope.searchQuery)
            UserSearch.getByCpf({query: $scope.searchQuery}, function (result) {
                $scope.users = result;
                console.error('result >> ' + result)
            }, function (response) {
                if (response.status === 404) {
                    $scope.loadAll();
                }
            });
        };

        $scope.ok = function (user) {
            $modalInstance.close(user);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

        $scope.novo = function () {
            $scope.users = undefined;
            $scope.searchQuery = '';
        };

        $scope.emailSolicitandoCadastro = function () {
            $scope.solicitacao.prestadorServico = localStorageService.get("prestadorPrincipal").prestador;
            console.log('solicitacao', $scope.solicitacao);
            PrestadorServicos.enviarEmailSolicitandoCadastro($scope.solicitacao, onSuccessEmailSolicitandoCadastro);
        };

        function onSuccessEmailSolicitandoCadastro() {
            Notificacao.info("Informação", "E-mail enviado com sucesso.");
            $scope.cancel();
        }
    });

'use strict';

angular.module('nfseApp')
    .controller('UserManagementSearchController', function ($scope, $modalInstance, User, ParseLinks, Language, UserSearch) {
        $scope.users = [];
        $scope.authorities = ["ROLE_USER", "ROLE_ADMIN"];
        Language.getAll().then(function (languages) {
            $scope.languages = languages;
        });

        $scope.page = 0;
        $scope.loadAll = function () {
            User.query({page: $scope.page, per_page: 20}, function (result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.users = result;
            });
        };

        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();


        $scope.search = function () {
            UserSearch.query({query: $scope.searchQuery}, function (result) {
                $scope.users = result;
            }, function (response) {
                if (response.status === 404) {
                    $scope.loadAll();
                }
            });
        };

        $scope.ok = function (user) {
            $modalInstance.close(user);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    });

'use strict';

angular.module('nfseApp')
    .controller('UserManagementDetailController', function ($scope, $window, $stateParams, $state, User, Notificacao, Pessoa) {
        $scope.user = {};
        $scope.pessoa = {};
        $scope.authorities = ["ROLE_USER", "ROLE_ADMIN", "ROLE_CONTRIBUINTE"];
        $scope.load = function (login) {
            User.get({login: login}, function (result) {
                $scope.user = result;
            });
        };
        $scope.load($stateParams.login);

        var onSaveFinished = function (result) {
            $state.go("user-management");
            Notificacao.info("Usuário salvo com sucesso")
        };

        $scope.save = function () {
            User.update($scope.user, onSaveFinished);
        };

        $scope.clear = function () {
            $state.go("user-management");
        };

        $scope.visualizarPessoaUsuario = function () {
            console.log('visualizarPessoaUsuario');

            Pessoa.getPessoaDoLogin({login: $scope.user.login},
                function (result) {
                    $state.go("pessoa.detail", {id: result.id});
                });
        }
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('user-management', {
                parent: 'site',
                url: '/user-management',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'Lista de Usuários'
                },
                ncyBreadcrumb: {
                    label: 'Usuários'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management.html',
                        controller: 'UserManagementController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }]
                }
            })
            .state('user-management-detail', {
                parent: 'user-management',
                url: '/user-management/:login',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'Detalhes do Usuário'
                },
                ncyBreadcrumb: {
                    label: 'Detalhes do Usuário'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management-detail.html',
                        controller: 'UserManagementDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }]
                }
            }).state('user-management-edit', {
                parent: 'user-management',
                url: '/edit/user-management/:login',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'Edição do Usuário'
                },
                ncyBreadcrumb: {
                    label: 'Edição do Usuário'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management-edit.html',
                        controller: 'UserManagementDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('UserManagementController', function ($scope, User, ParseLinks, Language, UserSearch) {
        $scope.users = [];
        $scope.authorities = ["ROLE_USER", "ROLE_ADMIN"];
        Language.getAll().then(function (languages) {
            $scope.languages = languages;
        });

        $scope.page = 0;
        $scope.loadAll = function () {
            User.query({page: $scope.page, per_page: 20}, function (result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.users = result;
            });
        };

        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();

        $scope.setActive = function (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                $scope.loadAll();
                $scope.clear();
            });
        };

        $scope.save = function () {
            User.update($scope.user,
                function () {
                    $scope.refresh();
                });
        };

        $scope.refresh = function () {
            $scope.loadAll();
            $('#saveUserModal').modal('hide');
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.user = {
                id: null, login: null, nomeRazao: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
            $scope.editForm.$setPristine();
            $scope.editForm.$setUntouched();
        };

        $scope.search = function () {
            UserSearch.query({query: $scope.searchQuery}, function (result) {
                $scope.users = result;
            }, function (response) {
                if (response.status === 404) {
                    $scope.loadAll();
                }
            });
        };

    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('metrics', {
                parent: 'admin',
                url: '/metrics',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'metrics.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/metrics/metrics.html',
                        controller: 'MetricsController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('metrics');
                        return $translate.refresh();
                    }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('MetricsController', function ($scope, MonitoringService) {
        $scope.metrics = {};
        $scope.updatingMetrics = true;

        $scope.refresh = function () {
            $scope.updatingMetrics = true;
            MonitoringService.getMetrics().then(function (promise) {
                $scope.metrics = promise;
                $scope.updatingMetrics = false;
            }, function (promise) {
                $scope.metrics = promise.data;
                $scope.updatingMetrics = false;
            });
        };

        $scope.$watch('metrics', function (newValue) {
            $scope.servicesStats = {};
            $scope.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    $scope.servicesStats[key] = value;
                }

                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    index = newKey.lastIndexOf('.');
                    $scope.cachesStats[newKey] = {
                        'name': newKey.substr(index + 1),
                        'value': value
                    };
                }
            });
        });

        $scope.refresh();

        $scope.refreshThreadDumpData = function () {
            MonitoringService.threadDump().then(function (data) {
                $scope.threadDump = data;

                $scope.threadDumpRunnable = 0;
                $scope.threadDumpWaiting = 0;
                $scope.threadDumpTimedWaiting = 0;
                $scope.threadDumpBlocked = 0;

                angular.forEach(data, function (value) {
                    if (value.threadState === 'RUNNABLE') {
                        $scope.threadDumpRunnable += 1;
                    } else if (value.threadState === 'WAITING') {
                        $scope.threadDumpWaiting += 1;
                    } else if (value.threadState === 'TIMED_WAITING') {
                        $scope.threadDumpTimedWaiting += 1;
                    } else if (value.threadState === 'BLOCKED') {
                        $scope.threadDumpBlocked += 1;
                    }
                });

                $scope.threadDumpAll = $scope.threadDumpRunnable + $scope.threadDumpWaiting +
                    $scope.threadDumpTimedWaiting + $scope.threadDumpBlocked;

            });
        };

        $scope.getLabelClass = function (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        };
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('logs', {
                parent: 'admin',
                url: '/logs',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'logs.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/logs/logs.html',
                        controller: 'LogsController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('logs');
                        return $translate.refresh();
                    }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('LogsController', function ($scope, LogsService) {
        $scope.loggers = LogsService.findAll();

        $scope.changeLevel = function (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                $scope.loggers = LogsService.findAll();
            });
        };
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('health', {
                parent: 'admin',
                url: '/health',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'health.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/health/health.html',
                        controller: 'HealthController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('health');
                        return $translate.refresh();
                    }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('HealthController', function ($scope, MonitoringService) {
        $scope.updatingHealth = true;
        $scope.separator = '.';

        $scope.refresh = function () {
            $scope.updatingHealth = true;
            MonitoringService.checkHealth().then(function (response) {
                $scope.healthData = $scope.transformHealthData(response);
                $scope.updatingHealth = false;
            }, function (response) {
                $scope.healthData =  $scope.transformHealthData(response.data);
                $scope.updatingHealth = false;
            });
        };

        $scope.refresh();

        $scope.getLabelClass = function (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        };

        $scope.transformHealthData = function (data) {
            var response = [];
            $scope.flattenHealthData(response, null, data);
            return response;
        };

        $scope.flattenHealthData = function (result, path, data) {
            angular.forEach(data, function (value, key) {
                if ($scope.isHealthObject(value)) {
                    if ($scope.hasSubSystem(value)) {
                        $scope.addHealthObject(result, false, value, $scope.getModuleName(path, key));
                        $scope.flattenHealthData(result, $scope.getModuleName(path, key), value);
                    } else {
                        $scope.addHealthObject(result, true, value, $scope.getModuleName(path, key));
                    }
                }
            });
            return result;
        };

        $scope.getModuleName = function (path, name) {
            var result;
            if (path && name) {
                result = path + $scope.separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        };


        $scope.showHealth = function (health) {
            $scope.currentHealth = health;
            $('#showHealthModal').modal('show');
        };

        $scope.addHealthObject = function (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!$scope.isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        };

        $scope.hasSubSystem = function (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        };

        $scope.isHealthObject = function (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        };

        $scope.baseName = function (name) {
            if (name) {
              var split = name.split('.');
              return split[0];
            }
        };

        $scope.subSystemName = function (name) {
            if (name) {
              var split = name.split('.');
              split.splice(0, 1);
              var remainder = split.join('.');
              return remainder ? ' - ' + remainder : '';
            }
        };
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('docs', {
                parent: 'admin',
                url: '/docs',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'global.menu.admin.apidocs'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/docs/docs.html'
                    }
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('configuration', {
                parent: 'admin',
                url: '/configuration',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'configuration.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/configuration/configuration.html',
                        controller: 'ConfigurationController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('configuration');
                        return $translate.refresh();
                    }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('ConfigurationController', function ($scope, ConfigurationService) {
        ConfigurationService.get().then(function(configuration) {
            $scope.configuration = configuration;
        });
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('audits', {
                parent: 'admin',
                url: '/audits',
                data: {
                    roles: ['ROLE_ADMIN'],
                    pageTitle: 'audits.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/audits/audits.html',
                        controller: 'AuditsController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('audits');
                        return $translate.refresh();
                    }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('AuditsController', function ($scope, $filter, AuditsService) {
        $scope.onChangeDate = function () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')($scope.fromDate, dateFormat);
            var toDate = $filter('date')($scope.toDate, dateFormat);

            AuditsService.findByDates(fromDate, toDate).then(function (data) {
                $scope.audits = data;
            });
        };

        // Date picker configuration
        $scope.today = function () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            $scope.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        };

        $scope.previousMonth = function () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 0, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            $scope.fromDate = fromDate;
        };

        $scope.today();
        $scope.previousMonth();
        $scope.onChangeDate();
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('admin', {
                abstract: true,
                parent: 'site'
            });
    });

'use strict';

angular.module('nfseApp')
    .factory('TrocaEmpresa', TrocaEmpresa);

function TrocaEmpresa($modal) {

    var service = {
        open: open,
        modalInstance: null,
        isOpen: false
    };
    return service;

    function open() {
        if(service.isOpen){
            return;
        }
        service.modalInstance = $modal.open({
            templateUrl: 'app/account/troca-empresa/troca-empresa.html',
            controller: 'TrocaEmpresaController',
            animation: true,
            keyboard  : false,
            backdrop: 'static',
            size: 'lg'
        });
        service.isOpen =  true;
        service.modalInstance.result.then(function (empresa) {
            console.log("Selecionou a empresa", empresa);
            service.isOpen =  false;
        }, function () {
            service.isOpen =  false;
        });
    }
}





'use strict';

angular.module('nfseApp')
    .controller('TrocaEmpresaController', function ($scope, $state, $window, ParseLinks, SweetAlert, $modalInstance, localStorageService, PrestadorServicos, Principal) {

        $scope.empresas = [];
        $scope.filtro = "";
        $scope.per_page = 20;

        $scope.loadAll = function () {
            PrestadorServicos.getPrestadoresUsuario({
                filtro: $scope.filtro,
                login: $scope.account.login,
                page: $scope.page ? $scope.page : 0,
                per_page: $scope.per_page
            }, function (result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.empresas = result;
            });
            $scope.empresaSelecionada = localStorageService.get("prestadorPrincipal");
        };

        $scope.loadPage = function (page) {
            $scope.page = page;
            $scope.loadAll();
        };

        Principal.identity().then(function (account) {
            if (account) {
                $scope.account = account;
                $scope.loadAll();
            }
        });

        $scope.ok = function (empresa) {
            PrestadorServicos.trocarEmpresa({login: $scope.account.login, prestadorId: empresa.id}, function () {
                Principal.identity(true).then(function (account) {
                    if (account) {
                        $scope.account = account;
                        $window.location.reload();
                    }
                });
            });

        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

        $scope.irParaCredenciamento = function () {
            $scope.cancel();
            $state.go("credenciamento")
        };
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('requestReset', {
                parent: 'account',
                url: '/reset/request',
                data: {
                    roles: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/reset/request/reset.request.html',
                        controller: 'RequestResetController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reset');
                        return $translate.refresh();
                    }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('RequestResetController', function ($rootScope, $scope, $state, $timeout, Auth, SweetAlert) {


        $scope.resetAccount = {};
        $timeout(function () {
            angular.element('[ng-model="resetAccount.login"]').focus();
        });

        $scope.requestReset = function () {
            Auth.resetPasswordInit($scope.resetAccount.login).then(function () {
                $state.go("login");
                SweetAlert.success("Operação Realizada", "Verifique a caixa de entrada de seu email e siga os passos indicados para criar uma nova senha");
            });
        }

    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('finishReset', {
                parent: 'account',
                url: '/reset/finish?key',
                data: {
                    roles: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/reset/finish/reset.finish.html',
                        controller: 'ResetFinishController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reset');
                        return $translate.refresh();
                    }]
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('ResetFinishController', function ($scope, $stateParams, $timeout, Auth) {

        $scope.keyMissing = $stateParams.key === undefined;
        $scope.doNotMatch = null;

        $scope.resetAccount = {};
        $timeout(function (){angular.element('[ng-model="resetAccount.password"]').focus();});

        $scope.finishReset = function() {
            if ($scope.resetAccount.password !== $scope.confirmPassword) {
                $scope.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: $scope.resetAccount.password}).then(function () {
                    $scope.success = 'OK';
                }).catch(function (response) {
                    $scope.success = null;
                    $scope.error = 'ERROR';

                });
            }

        };
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('registrarEmpresa', {
                parent: 'entity',
                url: '/registrar-empresa',
                data: {
                    roles: ['ROLE_CONTRIBUINTE'],
                    pageTitle: 'Informe seus dados para o cadastro'
                },
                ncyBreadcrumb: {
                    label: 'Registro de empresa'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/registrar-empresa/registrar-empresa.html',
                        controller: 'RegistrarEmpresaController'
                    }
                },
                params: {
                    cpfCnpj: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            cpfCnpj: $stateParams.cpfCnpj
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('register');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('servico');
                        $translatePartialLoader.addPart('cnae');
                        $translatePartialLoader.addPart('mes');
                        return $translate.refresh();
                    }],
                    convite: function () {
                        return {};
                    }
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('RegistrarEmpresaController',
        function ($scope, $http, $translate, $timeout, Auth, Notificacao, $state, convite, CEP, Servico,
                  $modal, Municipio, Pessoa, PrestadorServicos, Upload, pagingParams, Principal, ClassificacaoAtividade, NaturezaJuridica) {

            $scope.error = null;
            $scope.success = 'OK';
            $scope.prestadorServicos = {pessoa: {dadosPessoais: {cpfCnpj: pagingParams.cpfCnpj}}};
            $scope.socio = {};
            $scope.servicos = [];

            $timeout(function () {
                angular.element('[ng-model="prestadorServicos.pessoa.dadosPessoais.cpfCnpj"]').focus();
            });

            $scope.buscarEnums = function () {
                $scope.tipoPortes = getEnumValues('tipoPorte');
                $scope.tipoContribuintes = getEnumValues('tipoContribuinte');
                $scope.regimeTributarios = getEnumValues('regimeTributario');
                $scope.tiposIss = getEnumValues('tipoIssqn');
                $scope.tiposIssEstimado = getEnumValues('tipoPeriodoValorEstimado');
                $scope.classificacaoAtividades = ClassificacaoAtividade.query();
                $scope.tipoNotaFiscais = getEnumValues('tipoNotaFiscal');
                $scope.tipoEnquadramentos = getEnumValues('tipoEnquadramento');
                $scope.meses = getEnumValues('mesEnum');
            };

            function getEnumValues(name) {
                var enuns = [];
                $http.get('i18n/pt-br/' + name + '.json').success(function (data) {
                    angular.forEach(Object.keys(data), function (primeiroField) {
                        angular.forEach(Object.keys(data[primeiroField]), function (sugundoField) {
                            angular.forEach(Object.keys(data[primeiroField][sugundoField]), function (field) {
                                enuns.push({name: field, value: data[primeiroField][sugundoField][field]})
                            });

                        });
                    });


                });
                return enuns;
            }

            $scope.loadAll = function () {
                $scope.buscarEnums();
            };
            $scope.loadAll();

            $scope.loadEnderecoByCEP = function (cep) {
                if (cep) {
                    CEP.getByCep({cep: cep}, function (endereco) {
                        $scope.prestadorServicos.pessoa.dadosPessoais.cep = endereco.cep;
                        $scope.prestadorServicos.pessoa.dadosPessoais.municipio = endereco.municipio;
                        $scope.prestadorServicos.pessoa.dadosPessoais.logradouro = endereco.logradouro;
                        $scope.prestadorServicos.pessoa.dadosPessoais.bairro = endereco.bairro;
                    });
                }
            };

            $scope.popularReceitasTributariaBruta = function () {
                $scope.prestadorServicos.receitasTributariaBruta = [];
                var hoje = new Date();

                for (var i = 1; i <= 12; i++) {
                    var receitaTributariaBruta = {};
                    hoje.setMonth(hoje.getMonth() - 1);

                    receitaTributariaBruta.ano = hoje.getFullYear();
                    receitaTributariaBruta.mes = hoje.getMonth() + 1;
                    receitaTributariaBruta.valorBruto = 0.0;

                    $scope.prestadorServicos.receitasTributariaBruta.push(receitaTributariaBruta);
                }
            };

            $scope.popularReceitasTributariaBruta();

            $scope.loadMunicipioByCodigo = function (codigo) {
                if (codigo) {
                    Municipio.getByCodigo({codigo: codigo}, function (municipio) {
                        if (municipio.id) {
                            $scope.prestadorServicos.pessoa.dadosPessoais.municipio = municipio;
                        } else {
                            Notificacao.warn("Atenção", "Não foi encontrado nenhum Municipio com o código " + codigo);
                            $scope.prestadorServicos.pessoa.dadosPessoais.municipio = {};
                        }
                    });
                }
            };

            $scope.searchMunicipio = function () {
                var modalInstance = $modal.open({
                    templateUrl: 'app/entities/municipio/municipio-search.html',
                    controller: 'MunicipioSearchController',
                    size: 'lg'
                });
                modalInstance.result.then(function (municipio) {
                    $scope.prestadorServicos.pessoa.dadosPessoais.endereco.municipio = municipio;
                }, function () {
                    //$log.info('Modal dismissed at: ' + new Date());
                });
            };

            $scope.searchCnae = function () {
                var modalInstance = $modal.open({
                    templateUrl: 'app/entities/cnae/cnaes-search.html',
                    controller: 'CnaeSearchController',
                    size: 'lg'
                });
                modalInstance.result.then(function (cnae) {
                    if (!$scope.prestadorServicos.cnaes) {
                        $scope.prestadorServicos.cnaes = [];
                    }
                    $scope.prestadorServicos.cnaes.push(cnae);

                    $scope.buscarServicosPorCnae(cnae);

                }, function () {
                    // $log.info('Modal dismissed at: ' + new Date());
                });
            };

            $scope.buscarServicosPorCnae = function (cnae) {
                Servico.getPorCnae({id: cnae.id}, function (data) {
                    if (!$scope.prestadorServicos.servicos) {
                        $scope.prestadorServicos.servicos = [];
                    }
                    $scope.servicos = $scope.servicos.concat(data);
                    $scope.prestadorServicos.servicos = $scope.prestadorServicos.servicos.concat(data);
                })
            };

            $scope.removerCnae = function (index) {
                $scope.prestadorServicos.cnaes.splice(index, 1);
                $scope.prestadorServicos.servicos = [];
                angular.forEach($scope.prestadorServicos.cnaes, function (cnae) {
                    $scope.buscarServicosPorCnae(cnae);
                })
            };

            $scope.adicionarServico = function (servico) {
                $scope.prestadorServicos.servicos.push(servico);
            };

            $scope.removerServico = function (index) {
                $scope.prestadorServicos.servicos.splice(index, 1);
            };

            $scope.loadByCpfCnpj = function () {
                PrestadorServicos.getPorCpfCnpj({cpfCnpj: $scope.prestadorServicos.pessoa.dadosPessoais.cpfCnpj},
                    function (result) {
                        $scope.prestadorServicos = {};
                        Notificacao.error("Atenção", "A empresa que você está solicitando acesso já existe como cadastro municipal.");
                    }, function (error) {
                        if (error.status === 404) {
                            console.log(error);
                        }
                    });

                if ($scope.isFisica()) {
                    $scope.naturezasJuridicas = NaturezaJuridica.getFisicas();
                } else {
                    $scope.naturezasJuridicas = NaturezaJuridica.getJuridicas();
                }
            };

            $scope.isFisica = function () {
                return $scope.prestadorServicos
                    && $scope.prestadorServicos.pessoa
                    && $scope.prestadorServicos.pessoa.dadosPessoais
                    && $scope.prestadorServicos.pessoa.dadosPessoais.cpfCnpj
                    && $scope.prestadorServicos.pessoa.dadosPessoais.cpfCnpj.replace(/[^\w\s]/gi, '').length == 11

            };

            $scope.adicionarSocio = function () {
                if (!$scope.prestadorServicos.socios) {
                    $scope.prestadorServicos.socios = [];
                }
                var validou = true;
                console.log($scope.socio);
                if (!$scope.socio.socio.dadosPessoais.cpfCnpj) {
                    Notificacao.error("Atenção!", "O Campo Cpf/Cnpj do sócio é obrigatório.");
                    validou = false;
                }
                if (!$scope.socio.socio.dadosPessoais.nomeRazaoSocial) {
                    Notificacao.error("Atenção!", "O Campo Nome/Razão social do sócio é obrigatório.");
                    validou = false;
                }
                if (!$scope.socio.proporcao) {
                    Notificacao.error("Atenção!", "O Campo percentual do sócio é obrigatório.");
                    validou = false;
                }
                if (validou) {
                    $scope.prestadorServicos.socios.push($scope.socio);
                    $scope.socio = {};
                }
            };

            $scope.removerSocio = function (index) {
                $scope.prestadorServicos.socios.splice(index, 1);
            };

            $scope.register = function () {
                console.log('prestadorServicos ..: ' + JSON.stringify($scope.prestadorServicos));
                PrestadorServicos.salvar($scope.prestadorServicos, function (data) {
                    console.log('retorno..: ' + JSON.stringify(data));
                    if (data.id) {
                        Principal.identity(true);
                        $scope.$emit('nfseApp:navbarUpdate', data);
                        $state.go("home", {}, {reload: true});
                        Notificacao.info("Operação Realizada", "Sua solicitação foi encaminhada para um fiscal e assim que aprovada você receberá um email com as instruções de como prosseguir");
                    } else {
                        Notificacao.error("Algo inesperado aconteceu!", "Entre em contato com o suporte da prefeitura.");
                    }
                });
            };

            $scope.upload = function ($file) {
                console.log('arquivo ' + $file);
                if ($file) {
                    Upload.dataUrl($file, true).then(
                        function (conteudo) {
                            var anexo = {};
                            anexo.descricao = $file.name;
                            anexo.nome = $file.name;
                            anexo.conteudo = conteudo;
                            anexo.mimeType = $file.type;
                            $scope.prestadorServicos.imagem = anexo;
                        }
                    );
                } else {
                    Alerta.warn("Atenção!", "Você deve selecionar um arquivo de até 10Mb");
                }
            }

        });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('register', {
                parent: 'account',
                url: '/register',
                data: {
                    roles: [],
                    pageTitle: 'Informe seus dados para o cadastro'
                },
                ncyBreadcrumb: {
                    label: 'Registro de usuário'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/register/register.html',
                        controller: 'RegisterController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('register');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    convite: function () {
                        return {};
                    }
                }
            })
            .state('registerWithPrestador', {
                parent: 'account',
                url: '/register/{id}',
                data: {
                    roles: [],
                    pageTitle: 'register.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/register/register.html',
                        controller: 'RegisterController'
                    },
                    'navbar@': {
                        templateUrl: 'app/components/navbar/no-navbar.html'
                    },
                    'menu@': {
                        templateUrl: 'app/components/menu/no-navigation.html',
                        controller: 'NavbarController'
                    },
                    /*
                     'footer@': {
                     templateUrl: 'app/components/footer/footer.html',
                     controller: 'NavbarController'
                     }*/
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('register');
                        return $translate.refresh();
                    }],
                    convite: function ($stateParams, ConviteUsuarioService) {
                        return ConviteUsuarioService.get({
                            id: $stateParams.id
                        }).$promise;
                    }
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('RegisterController', function ($scope, $translate, $timeout, Auth,
                                                Notificacao, $state, convite, Register,
                                                CEP, $modal, Municipio, Pessoa, PrestadorServicos, Configuracao) {

        $scope.success = null;
        $scope.error = null;
        $scope.doNotMatch = null;
        $scope.errorUserExists = null;
        $scope.registerAccount = {};
        $scope.convite = convite;
        $scope.registerAccount.dadosPessoais = {};

        Configuracao.get({}, function (data) {
            $scope.configuracao = data;
        });

        $timeout(function () {
            angular.element('[ng-model="registerAccount.login"]').focus();
        });

        $scope.register = function () {
            $scope.registerAccount.login = $scope.registerAccount.dadosPessoais.cpfCnpj;
            if ($scope.registerAccount.password !== $scope.confirmPassword) {
                Notificacao.error('A senha e sua confirmação devem ser iguais! ');
                $scope.doNotMatch = 'ERROR';
                return
            }

            if ($scope.isCnpj()) {
                if (!$scope.registerAccount.dadosPessoais.municipio || $scope.registerAccount.dadosPessoais.municipio.id === $scope.configuracao.municipio.id) {
                    Notificacao.error("Atenção.",
                        " <p>Este cadastro não contempla as Empresas de Dentro do Município.</p>\n" +
                        "                        <p>Para obter acesso ao sistema com Empresas de Dentro do Município é necessário realizar o\n" +
                        "                            credenciamento junto à Prefeitura Municipal.</p>\n" +
                        "                        <p>Entre em contato com a Prefeitura para maiores informações.</p>");

                    return;
                }
                PrestadorServicos.buscarPorCpfCnpj({cpfCnpj: $scope.registerAccount.dadosPessoais.cpfCnpj.replace(/[^\w\s]/gi, '')},
                    function (result) {
                        if (result && result.length > 0) {
                            Notificacao.error("Atenção.",
                                " <p>Este cadastro não contempla as Empresas de Dentro do Município.</p>\n" +
                                "                        <p>Para obter acesso ao sistema com Empresas de Dentro do Município é necessário realizar o\n" +
                                "                            credenciamento junto à Prefeitura Municipal.</p>\n" +
                                "                        <p>Entre em contato com a Prefeitura para maiores informações.</p>");

                            $scope.prestador = result[0];
                        } else {
                            criarConta();
                        }
                    });
            } else {
                criarConta();
            }
        };

        function criarConta() {
            $scope.registerAccount.langKey = $translate.use();
            $scope.doNotMatch = null;
            $scope.error = null;
            $scope.errorUserExists = null;
            $scope.errorEmailExists = null;

            Auth.createAccount($scope.registerAccount).then(function () {
                if ($scope.convite && $scope.conviteValido()) {
                    Register.autorizarUsuario({
                        conviteUsuario: $scope.convite,
                        login: $scope.registerAccount.login
                    });
                }
                $scope.success = 'OK';
                Notificacao.priority('Cadastro salvo com sucesso! Favor verificar seu e-mail para confirmar a conta.');
                $state.go('login');
            }, function (response) {
                if (response.status == 400 && !$scope.registerAccount.dadosPessoais.endereco.municipio.estado) {
                    Notificacao.error("Atenção", "O campo estado é obrigatório!");
                }
                if (response.status == 406) {
                    Notificacao.warn("Atenção!", response.data.message);
                    $state.go('login');
                }
            });
        }


        $scope.conviteValido = function () {

            if ($scope.convite && $scope.convite.ativo) {
                var nowDate = new Date();
                var dataConvite = new Date($scope.convite.dataConvite);
                dataConvite.setHours(dataConvite.getHours() + 48);
                return dataConvite > nowDate;
            }
            return false;
        };

        function carregarDadosConvite() {
            if ($scope.convite) {
                if ($scope.convite && $scope.conviteValido()) {
                    $scope.registerAccount.nomeRazao = $scope.convite.nome;
                    $scope.registerAccount.login = $scope.convite.cpf;
                    $scope.registerAccount.email = $scope.convite.email;
                }
            }
        }

        $scope.loadEnderecoByCEP = function (cep) {
            if (cep) {
                CEP.getByCep({cep: cep}, function (endereco) {
                    $scope.registerAccount.dadosPessoais.cep = endereco.cep;
                    $scope.registerAccount.dadosPessoais.municipio = endereco.municipio;
                    $scope.registerAccount.dadosPessoais.logradouro = endereco.logradouro;
                    $scope.registerAccount.dadosPessoais.bairro = endereco.bairro;
                });
            }
        };

        carregarDadosConvite();

        $scope.loadMunicipioByCodigo = function (nome) {
            if (nome) {
                Municipio.getByNome({nome: $scope.registerAccount.dadosPessoais.municipio.nome}, function (result) {
                        $scope.registerAccount.dadosPessoais.municipio = result;
                    },
                    function (error) {
                        if (error.status === 404) {
                            Notificacao.warn("Atenção!", "Não foi encontrado nenhum município com essa descrição, por favor utilize a pesquisa!")
                        }
                        $scope.registerAccount.dadosPessoais.municipio = {};
                    })
            }
        };

        $scope.searchMunicipio = function () {
            var modalInstance = $modal.open({
                templateUrl: 'app/entities/municipio/municipio-search.html',
                controller: 'MunicipioSearchController',
                size: 'lg'
            });
            modalInstance.result.then(function (municipio) {
                if (!$scope.registerAccount.dadosPessoais) {
                    $scope.registerAccount.dadosPessoais = {};
                }
                $scope.registerAccount.dadosPessoais.municipio = municipio;
            }, function () {
                //$log.info('Modal dismissed at: ' + new Date());
            });
        };

        $scope.loadByCpfCnpj = function () {
            Pessoa.getPorCpfCnpj(
                {cpfCnpj: $scope.registerAccount.dadosPessoais.cpfCnpj}, function (result) {
                    if (result.dadosPessoais) {
                        $scope.registerAccount.dadosPessoais = result.dadosPessoais;
                        Notificacao.warn("Atenção", "Já existe uma Pessoa com o CPF ou CNPJ informado");
                    }
                });
        };

        $scope.isCnpj = function () {
            return $scope.registerAccount && $scope.registerAccount.dadosPessoais.cpfCnpj &&
                $scope.registerAccount.dadosPessoais.cpfCnpj.length > 11
        };

        $scope.isCpf = function () {
            return $scope.registerAccount && $scope.registerAccount.dadosPessoais.cpfCnpj &&
                $scope.registerAccount.dadosPessoais.cpfCnpj.length <= 11
        };

    })
;

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('password', {
                parent: 'entity',
                url: '/password',
                data: {
                    roles: ['ROLE_USER'],
                    pageTitle: 'global.menu.account.password'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/password/password.html',
                        controller: 'PasswordController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('password');
                        return $translate.refresh();
                    }]
                }
            });
    });

/* globals $ */
'use strict';

angular.module('nfseApp')
    .directive('passwordStrengthBar', function () {
        return {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            link: function (scope, iElement, attr) {
                var strength = {
                    colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                    mesureStrength: function (p) {

                        var _force = 0;
                        var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                        var _lowerLetters = /[a-z]+/.test(p);
                        var _upperLetters = /[A-Z]+/.test(p);
                        var _numbers = /[0-9]+/.test(p);
                        var _symbols = _regex.test(p);

                        var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                        var _passedMatches = $.grep(_flags, function (el) {
                            return el === true;
                        }).length;

                        _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                        _force += _passedMatches * 10;

                        // penality (short password)
                        _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                        // penality (poor variety of characters)
                        _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                        _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                        _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                        return _force;

                    },
                    getColor: function (s) {

                        var idx = 0;
                        if (s <= 10) {
                            idx = 0;
                        }
                        else if (s <= 20) {
                            idx = 1;
                        }
                        else if (s <= 30) {
                            idx = 2;
                        }
                        else if (s <= 40) {
                            idx = 3;
                        }
                        else {
                            idx = 4;
                        }

                        return { idx: idx + 1, col: this.colors[idx] };
                    }
                };
                scope.$watch(attr.passwordToCheck, function (password) {
                    if (password) {
                        var c = strength.getColor(strength.mesureStrength(password));
                        iElement.removeClass('ng-hide');
                        iElement.find('ul').children('li')
                            .css({ 'background': '#DDD' })
                            .slice(0, c.idx)
                            .css({ 'background': c.col });
                    }
                });
            }
        };
    });

'use strict';

angular.module('nfseApp')
    .controller('PasswordController', function ($scope, Auth, Principal, $state, Notificacao, localStorageService) {
        Principal.identity().then(function (account) {
            $scope.account = account;
        });


        $scope.success = null;
        $scope.error = null;
        $scope.doNotMatch = null;
        $scope.trocarSenhaDTO = {};
        $scope.changePassword = function () {

            if ($scope.trocarSenhaDTO.newPassword !== $scope.trocarSenhaDTO.confirmPassword) {
                $scope.doNotMatch = 'ERROR';
            } else {
                $scope.doNotMatch = null;

                Auth.changePassword($scope.trocarSenhaDTO).then(function () {
                    console.log('deveria deslogar ');
                    Auth.logout();
                    localStorageService.clearAll();
                    $state.go('login');
                    Notificacao.info('Senha alterada com sucesso!', 'É necessário entrar no sistema novamente para prosseguir.')


                }).catch(function () {
                    $scope.success = null;
                    $scope.error = 'ERROR';
                });
            }
        };
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('logout', {
                parent: 'account',
                url: '/logout',
                data: {
                    roles: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/main/main.html',
                        controller: 'LogoutController'
                    }
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('LogoutController', function (Auth) {
        Auth.logout();
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('login', {
                parent: 'account',
                url: '/login',
                data: {
                    roles: [],
                    pageTitle: 'Bem vindo ao sistema de ISS on-line'
                },
                ncyBreadcrumb: {
                    label: 'Autenticação '
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/login/login.html',
                        controller: 'LoginController'
                    }
                }
            });
    });

'use strict';

angular.module('nfseApp')
    .controller('LoginController', function ($rootScope, $scope, $state, $timeout, Auth, Account,
                                             PrestadorServicos, Principal, Idle, SweetAlert, User,
                                             Notificacao, MensagemContribuinteUsuarioService,
                                             localStorageService, AvisoSistema, $modal) {
        $scope.user = {};
        $scope.errors = {};
        $scope.recaptcha = null;

        $scope.rememberMe = true;
        $timeout(function () {
            angular.element('[ng-model="username"]').focus();
        });

        //manda p o home caso tente acessar o login e já está logado
        Principal.identity().then(function (account) {
            if (account) {
                //manda p o home caso tente acessar o login e já está logado
                $state.go('home', {reload: true});
            } else {
                $scope.verificarAvisos();
            }
        });

        $scope.verificarAvisos = function () {
            AvisoSistema.buscarAvisosVigentes({}, function (result) {
                $modal.open({
                    templateUrl: 'app/entities/aviso-sistema/avisos-sistema.html',
                    controller: 'AvisosSistemaController',
                    keyboard: false,
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        avisos: function () {
                            return result;
                        }
                    }
                });
            });
        }

        $scope.login = function (event) {
            if (!$scope.recaptcha) {
                Notificacao.error('Erro', 'Captcha Inválido.');
                return;
            }
            event.preventDefault();
            Auth.login({
                username: $scope.username,
                password: $scope.password,
                rememberMe: $scope.rememberMe
            }).then(function () {
                $scope.authenticationError = false;
                $rootScope.exibiuMensagem = false;

                $scope.posLogin();

                $scope.$emit('nfseApp:navbarUpdate', event);
                // start watching when the app runs. also starts the Keepalive service by default.
                Idle.watch();
                $rootScope.$on('IdleStart', function () {
                    SweetAlert.swal({
                            title: "Cadê você?",
                            text: "Já faz algum tempo que você não trabalha na aplicação, logo sua sessão irá expirar e será redirecionado para a tela de login",
                            type: "warning",
                            showCancelButton: false,
                            confirmButtonText: "Voltar!",
                            closeOnConfirm: true
                        },
                        function () {
                            Account.get();
                        });
                    // the user appears to have gone idle
                });
                $rootScope.$on('IdleTimeout', function () {
                    SweetAlert.warning("OPS!", "Sua sessão expirou, terá que fazer login novamente");
                    Auth.logout();
                    $state.go('login');
                    // the user has timed out (meaning idleDuration + timeout has passed without any activity)
                    // this is where you'd log them
                });

            }).catch(function (error) {
                console.log(error);
                var msg = [];
                if (!$scope.username) {
                    msg.push("Informe o CPF ou CNPJ");
                }
                if (!$scope.password) {
                    msg.push("Informe a senha");
                }
                if (error.data && error.data.error_description && error.data.error_description === 'UserNotActivated') {
                    msg.push(" Seu cadastro ainda não foi ativado. Por favor, verifique se recebeu um e-mail contendo instruções de ativação do cadastro. Caso contrário utilize a opção 'Esqueceu a senha?' para reenviar o e-mail de ativação do cadastro. Se mesmo assim não receber o e-mail verifique na sua caixa de Spam");
                }
                if (msg.length == 0) {
                    User.acrescentarTentativaAcesso({login: $scope.username});
                    msg.push("Por favor verifique suas credenciais e tente novamente");
                }
                SweetAlert.swal({
                    title: "Problemas na autenticação",
                    text: msg.join(", "),
                    type: "error",
                    showCancelButton: false,
                    confirmButtonText: "Voltar!",
                    closeOnConfirm: true
                });
            });
        };

        $scope.posLogin = function () {
            var prestador = localStorageService.get("prestadorPrincipal");
            if (!Principal.isInRole('ROLE_ADMIN') && prestador && prestador.prestador && prestador.id) {
                MensagemContribuinteUsuarioService.proximaMensagemNaoLida({}, function (data) {
                    if (data && data.id) {
                        $state.go("mensagemContribuinteUsuarioNew", {id: data.id});
                    } else {
                        $scope.redirecionar();
                    }
                });
            } else {
                $scope.redirecionar();
            }
        }

        $scope.redirecionar = function () {
            if ($rootScope.previousStateName === 'register') {
                $state.go('home', {reload: true});
            } else if ($rootScope.previousStateName === 'requestReset') {
                $state.go('home', {reload: true});
            } else {
                User.zerarTentativaAcesso({login: $scope.username});
                $rootScope.back();
            }
        }

        $scope.handleCpf = function () {
            $scope.username = soAlfaNumerico($scope.username);
        }
    });

'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('activate', {
                parent: 'account',
                url: '/activate?key',
                data: {
                    roles: [],
                    pageTitle: 'Ativação do cadastro'
                },
                ncyBreadcrumb: {
                    label: 'Registro de usuário'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/activate/activate.html',
                        controller: 'ActivationController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('activate');
                        return $translate.refresh();
                    }]
                }
            });
    });


'use strict';

angular.module('nfseApp')
    .controller('ActivationController', function ($scope, $stateParams, Auth) {
        Auth.activateAccount({key: $stateParams.key}).then(function () {
            $scope.error = null;
            $scope.success = 'OK';
        }).catch(function () {
            $scope.success = null;
            $scope.error = 'ERROR';
        });
    });


'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('account', {
                abstract: true,
                parent: 'out',
            });
    });
(function(){angular.module('nfseApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-12"><h1 translate="error.title">Error Page!</h1><div class="alert alert-danger" translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/error/error.html','<div ng-cloak><div class="col-md-12"><h1 translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div>');
$templateCache.put('app/main/main.html','<div><div class="row"><div class="col-lg-4"><div class="widget-head-color-box navy-bg p-lg text-center"><i class="fa fa-user fa-3x"></i><div class="m-b-md"><h3 class="font-bold no-margins">Bem vindo,<br><b>{{account.nome}}</b></h3></div><div class="text-right"><a ui-sref="perfilUsuario" class="small text-white"><i class="fa fa-user"></i> Perfil Usu\xE1rio</a></div></div><div class="widget-text-box"><div ng-if="!prestadorPrincipal"><small>Voc\xEA est\xE1 acessando apenas com o perfil de <b>Pessoa {{account.pessoaFisica?\'F\xEDsica\':\'Juridica\'}}</b></small></div><div ng-if="prestadorPrincipal"><small>Voc\xEA est\xE1 acessando a empresa:</small><h4 class="media-heading">{{prestadorPrincipal.prestador.pessoa.dadosPessoais.nomeRazaoSocial}}</h4><h4 class="media-heading text-danger" ng-show="alertasDoSistema && alertasDoSistema.length >0 "><i class="fa fa-exclamation-triangle m-b-sm"></i> {{alertasDoSistema.length}} Inconsist\xEAncias encontradas</h4><div class="text-right" has-role="ROLE_EMPRESA_ADM"><a ui-sref="perfilEmpresa" class="small text-navy"><i class="fa fa-gear"></i> Perfil Empresa</a></div></div></div></div><div class="col-lg-8" ng-if="!prestadorPrincipal"><div class="ibox float-e-margins"><div class="ibox-content text-center"><div class="row"><div class="col-md-12 m-t-lg"><p>Voc\xEA pode solicitar o acesso de sua empresa pressionando o bot\xE3o <b>Solicitar novo acesso \xE0 empresa</b>.</p><button ui-sref="credenciamento" class="btn btn-success m-t-sm"><i class="fa fa-desktop"></i> Solicitar novo acesso \xE0 empresa</button></div></div><div class="row"><div class="col-md-12 m-t-lg"><p>Ou voc\xEA pode selecionar uma de suas empresas pressionando o bot\xE3o <b>Selecionar uma empresa que j\xE1 tenho acesso.</b></p><button ng-click="abrirTrocarEmpresa()" class="btn btn-info m-t-sm"><i class="fa fa-refresh"></i> Selecionar uma empresa que j\xE1 tenho acesso</button></div></div></div></div></div><div class="col-lg-8" ng-if="prestadorPrincipal"><div class="col-md-12"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-primary pull-right">{{\'nfseApp.Mes.\' + competenciaAtual.mes | translate}}</span> <span class="label label-info pull-right">Quantitativo</span><h5>Estatistica Mensal</h5></div><div class="ibox-content"><div class="row"><div class="col-md-4"><h1 class="no-margins">{{competenciaAtual.emitidas}}</h1><small>Emiss\xF5es</small><div class="font-bold {{competenciaAtual.porcentagemEmissao >= 0 ? \'text-success\' : \'text-danger\'}}">{{competenciaAtual.porcentagemEmissao | number:0}}% <i class="fa {{competenciaAtual.porcentagemEmissao >= 0 ? \'fa-level-up\' : \'fa-level-down\'}}"></i></div></div><div class="col-md-4"><h1 class="no-margins">{{competenciaAtual.retidas}}</h1><small>Reten\xE7\xF5es</small><div class="font-bold {{competenciaAtual.porcentagemRetencao >= 0 ? \'text-success\' : \'text-danger\'}}">{{competenciaAtual.porcentagemRetencao | number:0}}% <i class="fa {{competenciaAtual.porcentagemRetencao >= 0 ? \'fa-level-up\' : \'fa-level-down\'}}"></i></div></div><div class="col-md-4"><h1 class="no-margins">{{competenciaAtual.canceladas}}</h1><small>Cancelamentos</small><div class="font-bold {{competenciaAtual.porcentagemCancelamento >= 0 ? \'text-success\' : \'text-danger\'}}">{{competenciaAtual.porcentagemCancelamento | number:0}}% <i class="fa {{competenciaAtual.porcentagemCancelamento >= 0 ? \'fa-level-up\' : \'fa-level-down\'}}"></i></div></div></div></div></div></div><div class="col-md-6"><div class="widget blue-bg p-md text-center"><i class="fa fa-dollar fa-3x"></i><h1 class="m-xs">{{competenciaAtual.totalServicos | finance:true:2}}</h1><h3 class="font-bold no-margins">Faturamento em {{\'nfseApp.Mes.\' + competenciaAtual.mes | translate}}</h3><small class="font-bold {{competenciaAtual.porcentagemValor >= 0 ? \'text-navy\' : \'text-warning\'}}">{{competenciaAtual.porcentagemValor | number:0}}% <i class="fa {{competenciaAtual.porcentagemValor >= 0 ? \'fa-level-up\' : \'fa-level-down\'}}"></i></small></div></div><div class="col-md-6"><div class="widget lazur-bg p-md text-center"><i class="fa fa-legal fa-3x"></i><h1 class="m-xs">{{competenciaAtual.iss | finance:true:2}}</h1><h3 class="font-bold no-margins">Iss em {{\'nfseApp.Mes.\' + competenciaAtual.mes | translate}}</h3><small class="font-bold {{competenciaAtual.porcentagemIss >= 0 ? \'text-success\' : \'text-warn\'}}">{{competenciaAtual.porcentagemIss | number:0}}% <i class="fa {{competenciaAtual.porcentagemIss >= 0 ? \'fa-level-up\' : \'fa-level-down\'}}"></i></small></div></div></div></div><div class="row m-t-md" ng-if="prestadorPrincipal && !prestadorPrincipal.prestador.enquadramentoFiscal.simplesNacional"><div class="col-md-12"><div class="ibox float-e-margins"><div class="ibox-title"><h5>Estat\xEDstica Anual</h5></div><div class="ibox-content"><div class="row"><div class="col-md-9"><canvas linechart options="lineOptions" data="lineData" height="50" responsive="true"></canvas></div><div class="col-md-3"><ul class="stat-list"><li><small>Valor M\xE9dio recebido por m\xEAs</small><h2 class="no-margins">{{valorMedioMensal | finance:true:2}}</h2></li><li><small>Quantidade m\xE9dia emitida por m\xEAs</small><h2 class="no-margins">{{quantidadeMediaMensal | number:2}}</h2></li></ul></div></div></div></div></div></div><div class="row m-t-md" ng-if="prestadorPrincipal && prestadorPrincipal.prestador.enquadramentoFiscal.simplesNacional"><div class="col-md-12"><div class="ibox float-e-margins"><div class="ibox-title"><h5>\xDAltimas Receitas Brutas Trubut\xE1rias</h5></div><div class="ibox-content"><div class="row"><div class="col-md-9"><canvas linechart options="lineOptions" data="lineData" height="50" responsive="true"></canvas></div><div class="col-md-3"><ul class="stat-list"><li><label>RBT12</label><h2 class="no-margins">{{prestadorPrincipal.prestador.rbt12 | currency:\'R$ \'}}</h2></li></ul></div></div></div></div></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div class="text-center loginscreen animated fadeInDown"><div><div class="alert alert-success" ng-show="success"><strong>Usu\xE1rio ativado com sucesso.</strong><br>Clique <a href="#/login">aqui</a> para efetuar o login e obter acesso ao sistema</div><div class="alert alert-danger" ng-show="error"><strong>O usu\xE1rio n\xE3o pode ser ativado.</strong><br>Utilize o formul\xE1rio de cadastro para criar uma nova conta.</div></div></div>');
$templateCache.put('app/account/login/login.html','<div class="col-md-12"><div class="col-md-8 text-raleway fadeInLeft animated"><div class="row"><div class="col-md-6"><h3 class="font-bold">O que \xE9 NFS-e?</h3><p class="text-justify">NFS-e significa Nota Fiscal de Servi\xE7os Eletr\xF4nica e \xE9 um documento de exist\xEAncia exclusivamente digital, gerado e armazenado em sistema pr\xF3prio da Prefeitura Municipal, com o objetivo de registrar as opera\xE7\xF5es relativas \xE0 presta\xE7\xE3o de servi\xE7os. Este documento vem a substituir as Notas Fiscais Convencionais (impressas em papel), autorizadas pelo Munic\xEDpio e confeccionadas em gr\xE1fica. <a ui-sref="perguntas-respostas">Saiba mais.</a></p></div><div class="col-md-6"><h3 class="font-bold">O que \xE9 o ISS Online?</h3><p class="text-justify">O ISS Online \xE9 um sistema implantado pela Prefeitura para viabilizar o controle do ISS dos contribuintes de forma eletr\xF4nica e em tempo real. A implanta\xE7\xE3o do ISS Online simplifica a vida dos prestadores de servi\xE7os, dos cidad\xE3os e das empresas da cidade. <a ui-sref="perguntas-respostas">Saiba mais.</a></p></div></div><div class="hr-line-dashed"></div><div class="row"><div class="col-md-12"><h3 class="font-bold">Quem pode acessar o ISS Online?</h3><h4 class="font-bold m-t-md">Prestador de Servi\xE7os</h4><p class="text-justify">Realize seu cadastro no site e credenciamento junto \xE0 Prefeitura e comece a emitir a NFS-e e gerar guias de pagamento de ISS, dentre outros servi\xE7os on-line. <a ui-sref="perguntas-respostas">Saiba mais.</a></p><h4 class="font-bold">Tomador de Servi\xE7os e Empresas de Fora do Munic\xEDpio</h4><p class="text-justify">Fa\xE7a seu cadastro no site e consulte as notas fiscais recebidas, verifique a autenticidade de NFS-e e consulte a substitui\xE7\xE3o de RPS em NFS-e. As Empresas de Fora do Munic\xEDpio tamb\xE9m podem se cadastrar e, al\xE9m de consultar as notas fiscais recebidas, verificar a autenticidade de NFS-e e consultar a substitui\xE7\xE3o de RPS em NFS-e, tamb\xE9m podem gerar a guia de pagamento de ISS devido no munic\xEDpio atrav\xE9s do sistema. <a ui-sref="perguntas-respostas">Saiba mais.</a></p><h4 class="font-bold">Contador</h4><p class="text-justify">Realize seu cadastro no site e credenciamento junto \xE0 Prefeitura e solicite ao seu cliente a autoriza\xE7\xE3o para inclu\xED-lo como contador. Somente desta forma voc\xEA poder\xE1 realizar as atividades cont\xE1beis referentes a presta\xE7\xE3o de servi\xE7os para esta empresa. <a ui-sref="perguntas-respostas">Saiba mais.</a></p></div></div></div><div class="col-md-4 fadeInRight animated"><div class="ibox float-e-margins"><div class="ibox-title text-center"><h5>Acesso ao Sistema</h5></div><div class="ibox-content"><div><form class="form" role="form" ng-submit="login($event)"><div class="form-group"><label>CPF</label><input type="text" class="form-control" id="username" ng-keyup="handleCpf()" placeholder="CPF ou CNPJ" ng-model="username"></div><div class="form-group"><label>Senha</label><input type="password" class="form-control" id="password" placeholder="Senha" ng-model="password"></div><div class="form-group m-b-sm"><!--<div vc-recaptcha--><!--ng-model="recaptcha"--><!--size="normal"--><!--key="\'6LeHfJwUAAAAAC2rtJxDS-ydwIioUql7MP16xwi6\'"--><!--lang="pt-BR">--><!--</div>--><div vc-recaptcha ng-model="recaptcha" size="normal" key="\'6LeDfJwUAAAAAK9fxbM4eNjCLljIns6edxAr6ixY\'"></div></div><button type="submit" class="btn btn-info block full-width m-t-md">Entrar</button></form><div class="form-group text-center m-t-md"><span class="text-small text-muted">Ainda n\xE3o tem acesso?</span> <a class="btn btn-success btn-block" href="#/register">Registrar uma nova conta</a></div><div class="form-group text-center m-t-md"><a href="#/reset/request"><small>Esqueceu a senha?</small></a></div></div></div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><div class="ibox float-e-margins"><div class="ibox-content"><h2 translate="password.title" translate-values="{username: \'{{account.nomeRazao}}\'}">Password for user<b>{{account.nomeRazao}}</b></h2><div class="alert alert-success" ng-show="success" translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="error" translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="doNotMatch" translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="changePassword()" show-validation><div class="form-group"><label translate="global.form.currentpassword">Current password</label><input type="password" class="form-control" name="currentpassword" placeholder="{{\'global.form.currentpassword.placeholder\' | translate}}" ng-model="trocarSenhaDTO.oldPassword" required><label translate="global.form.newpassword">New password</label><input type="password" class="form-control" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="trocarSenhaDTO.newPassword" ng-minlength="5" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 5 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="password"></password-strength-bar></div><div class="form-group"><label translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="trocarSenhaDTO.confirmPassword" ng-minlength="5" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 5 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="password.form.button">Save</button></form></div></div></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-12"><form ng-show="!success" name="form" role="form" ng-submit="register()"><div class="alert alert-warning text-center" ng-show="convite.id != undefined &&  !conviteValido()">Seu convite expirou ou j\xE1 foi utilizado. Voc\xEA pode se cadastrar e solicitar um novo acesso a empresa.</div><div class="row m-t-md"><div class="col-md-12 text-center text-muted">Este cadastro \xE9 destinado \xE0s pessoas f\xEDsicas e empresas de fora do munic\xEDpio que desejam obter acesso \xE0s funcionalidades do sistema.</div></div><div class="row m-t-md"><div class="col-md-12"><div class="form-group col-md-3"><label for="field_cpfCnpj">CPF ou CNPJ <span class="text-danger">*</span></label><input type="text" class="form-control" name="cpfCnpj" id="field_cpfCnpj" ui-br-cpfcnpj-mask="" placeholder="CPF ou CNPJ" ng-blur="loadByCpfCnpj()" ng-model="registerAccount.dadosPessoais.cpfCnpj"><div ng-show="form.cpfCnpj.$invalid" class="has-error"><p class="help-block" ng-show="form.cpfCnpj.$error.cpf || form.cpfCnpj.$error.cnpj">CPF inv\xE1lido</p></div></div><div ng-show="isCpf() || isCnpj()" class="col-md-3 form-group"><label for="inscricaoEstadual">Inscri\xE7\xE3o Estadual</label><input type="text" class="form-control" name="inscricaoEstadual" id="inscricaoEstadual" placeholder="Inscri\xE7\xE3o Estadual" ng-model="registerAccount.dadosPessoais.inscricaoEstadual"></div><div ng-show="isCpf()" class="col-md-3 form-group"><label for="rg">RG<span class="text-danger">*</span></label><input type="text" class="form-control" name="rg" id="rg" placeholder="RG" ng-model="registerAccount.dadosPessoais.rg"></div></div><div class="col-md-12"><div class="col-md-3 form-group"><label>E-mail <span class="text-danger">*</span></label><input type="email" class="form-control" name="email" placeholder="E-mail" ng-model="registerAccount.email" minlength="5" maxlength="100"><div ng-show="form.email.$invalid" class="has-error"><p class="help-block" ng-show="form.email.$error.email">E-mail \xE9 inv\xE1lido</p></div></div><div class="col-md-6 form-group"><label>{{isCnpj() ? \'Raz\xE3o Social\' : \'Nome Completo\'}}<span class="text-danger">*</span></label><input type="text" class="form-control" name="nomeRazao" placeholder="{{isCnpj() ?\'Raz\xE3o Social\': \'Nome Completo\'}}" minlength="3" maxlength="50" ng-model="registerAccount.dadosPessoais.nomeRazaoSocial"></div><div class="col-md-3 form-group" ng-show="isCnpj()"><label>Nome Fantasia<span class="text-danger">*</span></label><input type="text" class="form-control" name="nomeFantasia" placeholder="Nome Fantasia" minlength="3" maxlength="50" ng-model="registerAccount.dadosPessoais.nomeFantasia"></div></div><div class="col-md-12"><div class="col-md-2 form-group"><label for="field_telefone">Telefone <span class="text-info">*</span></label><input type="text" class="form-control" name="telefone" id="field_telefone" ui-br-phone-number ng-model="registerAccount.dadosPessoais.telefone"><div ng-show="form.telefone.$invalid" class="has-error"><p class="help-block" ng-show="form.telefone.$error">Telefone \xE9 inv\xE1lido</p></div></div><div class="col-md-2 form-group"><label for="field_celular">Celular <span class="text-info">*</span></label><input type="text" class="form-control" name="celular" id="field_celular" ui-br-phone-number ng-model="registerAccount.dadosPessoais.celular"><div ng-show="form.celular.$invalid" class="has-error"><p class="help-block" ng-show="form.celular.$error">Celular \xE9 inv\xE1lido</p></div></div></div><div class="col-md-12"><div class="col-md-2 form-group"><label for="field_cep">CEP <span class="text-danger">*</span></label><input type="text" class="form-control" name="cep" id="field_cep" ui-br-cep-mask ng-blur="loadEnderecoByCEP(registerAccount.dadosPessoais.cep)" ng-model="registerAccount.dadosPessoais.cep"></div><div class="col-md-5 form-group"><label for="field_logradouro">Logradouro <span class="text-danger">*</span></label><input type="text" class="form-control" name="logradouro" id="field_logradouro" ng-model="registerAccount.dadosPessoais.logradouro" maxlength="255"></div><div class="col-md-2 form-group"><label for="field_numero">N\xFAmero <span class="text-danger">*</span></label><input type="text" class="form-control" name="numero" id="field_numero" onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.keyCode == 9 || event.keyCode == 8" ng-model="registerAccount.dadosPessoais.numero" maxlength="255"></div><div class="col-md-3 form-group"><label for="field_complemento">Complemento</label><input type="text" class="form-control" name="complemento" id="field_complemento" ng-model="registerAccount.dadosPessoais.complemento" maxlength="255"></div></div><div class="col-md-12"><div class="col-md-4"><label for="field_bairro">Bairro <span class="text-danger">*</span></label><input type="text" class="form-control" name="bairro" id="field_bairro" ng-model="registerAccount.dadosPessoais.bairro" maxlength="255"></div><div class="col-md-6 form-group"><label for="field_municipio">Munic\xEDpio <span class="text-danger">*</span></label><div class="input-group"><input type="text" class="form-control" name="municioio" id="field_municipio" disabled="disabled" ng-model="registerAccount.dadosPessoais.municipio.nome"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="searchMunicipio()"><span class="glyphicon glyphicon-search"></span></button></span></div></div><div class="col-md-2 form-group"><label for="field_estado">UF <span class="text-danger">*</span></label><input type="text" class="form-control" name="municipio" id="field_estado" disabled="disabled" ng-model="registerAccount.dadosPessoais.municipio.estado" maxlength="2"></div></div><div class="col-md-12"><div class="col-md-6 form-group"><label>Senha <span class="text-danger">*</span></label><input type="password" class="form-control" name="password" placeholder="Senha" ng-model="registerAccount.password" ng-minlength="5" ng-maxlength="50"><password-strength-bar password-to-check="registerAccount.password"></password-strength-bar></div><div class="col-md-6 form-group"><label>Confirma\xE7\xE3o de Senha <span class="text-danger">*</span></label><input type="password" class="form-control" name="confirmPassword" placeholder="Informe a senha novamente" ng-model="confirmPassword" ng-minlength="5" ng-maxlength="50"></div></div><div class="col-md-12"><div class="col-md-10 form-group"><button type="submit" ui-sref="login" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div><div class="col-md-2"><button type="submit" class="btn btn-primary btn-block"><span class="glyphicon glyphicon-arrow-right"></span>&nbsp; Registrar</button></div></div><div class="col-md-12 text-right"><small><i class="fa fa-info-circle"></i> Os campos que possuem <span class="text-danger">*</span> s\xE3o campos obrigat\xF3rios.<br><i class="fa fa-info-circle"></i> Os campos que possuem <span class="text-info">*</span> deve-se informar pelo menos um dos campos.</small></div><div class="col-md-12 text-right"><small><i class="fa fa-info-circle"></i> Para solicitar o cadastro e cred\xEAnciamento de uma empresa \xE9 necess\xE1rio primeiro cadastrar seu usu\xE1rio.</small></div></div></form></div></div></div>');
$templateCache.put('app/account/registrar-empresa/registrar-empresa.html','<div><div class="row"><div class="col-md-12"><form class="form-horizontal" name="form" role="form" ng-submit="register()"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row m-t-md"><div class="col-md-12"><div class="form-group"><div class="col-md-6"><label for="field_cpfCnpj">CPF ou CNPJ <span class="text-danger">*</span></label><input type="text" class="form-control" name="cpfCnpj" id="field_cpfCnpj" ui-br-cpfcnpj-mask placeholder="CPF ou CNPJ" ng-blur="loadByCpfCnpj()" ng-model="prestadorServicos.pessoa.dadosPessoais.cpfCnpj"><div ng-show="form.cpfCnpj.$invalid" class="has-error"><p class="help-block" ng-show="form.cpfCnpj.$error.cpf || form.cpfCnpj.$error.cnpj">CPF ou CNPJ inv\xE1lido</p></div></div><div class="col-md-6"><label for="field_rg_ie">RG ou Inscri\xE7\xE3o Estadual<span class="text-danger">*</span></label><input type="text" class="form-control" name="rgIE" id="field_rg_ie" placeholder="RG ou Inscri\xE7\xE3o Estadual" ng-model="prestadorServicos.pessoa.dadosPessoais.inscricaoEstadualRg"></div></div><div class="form-group"><div class="col-md-6"><label>Nome/Raz\xE3o Social <span class="text-danger">*</span></label><input type="text" class="form-control" name="nomeRazao" placeholder="Nome" minlength="3" maxlength="50" ng-model="prestadorServicos.pessoa.dadosPessoais.nomeRazaoSocial"></div><div class="col-md-6"><label for="field_rg_ie">Inscri\xE7\xE3o Municipal<span class="text-danger">*</span></label><input type="text" class="form-control" placeholder="Inscri\xE7\xE3o Municipal" ng-model="prestadorServicos.inscricaoMunicipal"></div></div><div class="form-group"><div class="col-md-6"><label>Nome Fantasia <span class="text-danger">*</span></label><input type="text" class="form-control" name="nomeRazao" placeholder="Nome" minlength="3" maxlength="50" ng-model="prestadorServicos.pessoa.dadosPessoais.nomeFantasia"></div><div class="col-md-6"><label>E-mail <span class="text-danger">*</span></label><input type="email" class="form-control" name="email" placeholder="E-mail" ng-model="prestadorServicos.pessoa.dadosPessoais.email" minlength="5" maxlength="100"><div ng-show="form.email.$invalid" class="has-error"><p class="help-block" ng-show="form.email.$error.email">E-mail \xE9 inv\xE1lido</p></div></div></div><div class="form-group"><div class="col-md-3"><label for="field_telefone">Telefone <span class="text-info">*</span></label><input type="text" class="form-control" name="telefone" id="field_telefone" ui-br-phone-number ng-model="prestadorServicos.pessoa.dadosPessoais.telefone"><div ng-show="form.telefone.$invalid" class="has-error"><p class="help-block" ng-show="form.telefone.$error">Telefone \xE9 inv\xE1lido</p></div></div><div class="col-md-3"><label for="field_celular">Celular <span class="text-info">*</span></label><input type="text" class="form-control" name="celular" id="field_celular" ui-br-phone-number ng-model="prestadorServicos.pessoa.dadosPessoais.celular"><div ng-show="form.celular.$invalid" class="has-error"><p class="help-block" ng-show="form.celular.$error">Celular \xE9 inv\xE1lido</p></div></div></div></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h4>Endere\xE7o</h4></div><div class="ibox-content"><div class="form-group animated fadeInUp"><div class="col-md-2"><label for="field_cep">CEP <span class="text-danger">*</span></label><input type="text" class="form-control" name="cep" id="field_cep" ui-br-cep-mask ng-blur="loadEnderecoByCEP(prestadorServicos.pessoa.dadosPessoais.cep)" ng-model="prestadorServicos.pessoa.dadosPessoais.cep"></div><div class="col-md-7"><label for="field_logradouro">Logradouro <span class="text-danger">*</span></label><input type="text" class="form-control" name="logradouro" id="field_logradouro" ng-model="prestadorServicos.pessoa.dadosPessoais.logradouro" maxlength="255"></div><div class="col-md-3"><label for="field_numero">N\xFAmero <span class="text-danger">*</span></label><input type="text" class="form-control" name="numero" id="field_numero" onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.keyCode == 9 || event.keyCode == 8" ng-model="prestadorServicos.pessoa.dadosPessoais.numero" maxlength="255"></div><div class="col-md-6"><label for="field_complemento">Complemento</label><input type="text" class="form-control" name="complemento" id="field_complemento" ng-model="prestadorServicos.pessoa.dadosPessoais.complemento" maxlength="255"></div><div class="col-md-6"><label for="field_bairro">Bairro <span class="text-danger">*</span></label><input type="text" class="form-control" name="bairro" id="field_bairro" ng-model="prestadorServicos.pessoa.dadosPessoais.bairro" maxlength="255"></div><div class="col-md-10"><label for="field_municipio">Munic\xEDpio <span class="text-danger">*</span></label><div class="input-group"><input type="text" class="form-control" name="municioio" id="field_municipio" disabled="disabled" ng-model="prestadorServicos.pessoa.dadosPessoais.municipio.nome"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="searchMunicipio()"><span class="glyphicon glyphicon-search"></span></button></span></div></div><div class="col-md-2"><label for="field_estado">UF <span class="text-danger">*</span></label><input type="text" class="form-control" name="municipio" id="field_estado" disabled="disabled" ng-model="prestadorServicos.pessoa.dadosPessoais.municipio.estado" maxlength="2"></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h4>S\xF3cios</h4></div><div class="ibox-content"><div class="form-group animated fadeInUp"><div class="col-md-3"><label for="field_cpfCnpj">CPF ou CNPJ <span class="text-danger">*</span></label><input type="text" class="form-control" name="cpfCnpjSocio" id="field_cpfCnpj_socio" ui-br-cpfcnpj-mask placeholder="CPF ou CNPJ" ng-model="socio.socio.dadosPessoais.cpfCnpj"><div ng-show="form.cpfCnpjSocio.$invalid" class="has-error"><p class="help-block" ng-show="form.cpfCnpjSocio.$error.cpf || form.cpfCnpjSocio.$error.cnpj">CPF ou CNPJ inv\xE1lido</p></div></div><div class="col-md-6"><label>Nome/Raz\xE3o Social <span class="text-danger">*</span></label><input type="text" class="form-control" name="nomeRazaoSocio" placeholder="Nome" minlength="3" maxlength="50" ng-model="socio.socio.dadosPessoais.nomeRazaoSocial"></div><div class="col-md-3"><label for="field_percentual">Percentual</label><input type="number" class="form-control" id="field_percentual" placeholder="Percentual" ng-model="socio.proporcao"></div></div><button type="button" class="btn btn-info" ng-click="adicionarSocio()"><i class="fa fa-plus"></i> Adicionar</button><div class="form-group m-t-lg"><div class="col-md-2"></div><div class="col-md-2"><label>CPF/CNPJ</label></div><div class="col-md-6"><label>Nome/Raz\xE3o Social</label></div><div class="col-md-2"><label>Percentual</label></div></div><div class="form-group" data-ng-repeat="socio in prestadorServicos.socios" class="animated fadeInDown"><div class="col-md-2"><button ng-click="removerSocio($index)" class="btn btn-default"><i class="fa fa-trash"></i></button></div><div class="col-md-2"><h4>{{socio.socio.dadosPessoais.cpfCnpj}}</h4></div><div class="col-md-6"><h4>{{socio.socio.dadosPessoais.nomeRazaoSocial}}</h4></div><div class="col-md-2"><h4>{{socio.proporcao}}</h4></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h4>Enquadramento Fiscal</h4></div><div class="ibox-content"><div class="form-group animated fadeInUp"><div class="col-md-4"><label for="field_porte">Porte <span class="text-danger">*</span></label><select class="form-control" name="porte" required ng-options="tipoPorte.name as (tipoPorte.value) for tipoPorte in tipoPortes" ng-model="prestadorServicos.enquadramentoFiscal.porte" id="field_porte"></select></div><div class="col-md-4"><label for="field_porte">Tipo de Contribuinte <span class="text-danger">*</span></label><select class="form-control" name="tipoContribuinte" required ng-options="tipo.name as (tipo.value) for tipo in tipoContribuintes" ng-model="prestadorServicos.enquadramentoFiscal.tipoContribuinte" id="field_tipoContribuinte"></select></div><div class="col-md-4"><label for="field_porte">Regime Tributario <span class="text-danger">*</span></label><select class="form-control" name="regimeTributario" required ng-options="regime.name as (regime.value) for regime in regimeTributarios" ng-model="prestadorServicos.enquadramentoFiscal.regimeTributario" id="field_regimeTributario"></select></div><div class="col-md-4"><label for="field_porte">Classifica\xE7\xE3o da Atividade <span class="text-danger">*</span></label><select class="form-control" name="classificacaoAtividade" required ng-options="classificacao as (classificacao.descricao) for classificacao in classificacaoAtividades" ng-model="prestadorServicos.enquadramentoFiscal.classificacaoAtividade" id="field_classificacaoAtividade"></select></div><div class="col-md-4"><label for="field_porte">Tipo de Nota Fiscal <span class="text-danger">*</span></label><select class="form-control" name="tipoNotaFiscal" required ng-options="tipoNotaFiscal.name as (tipoNotaFiscal.value) for tipoNotaFiscal in tipoNotaFiscais" ng-model="prestadorServicos.enquadramentoFiscal.tipoNotaFiscal" id="field_tipoNotaFiscal"></select></div><div class="col-md-4"><label for="field_porte">Natureza Jur\xEDdica<span class="text-danger">*</span></label><select class="form-control" name="naturezaJuridica" required ng-options="naturezaJuridica as (naturezaJuridica.descricao) for naturezaJuridica in naturezasJuridicas" ng-model="prestadorServicos.naturezaJuridica" id="field_naturezaJuridica"></select></div><div class="col-md-4"><label for="field_substitutoTributario">Substituto Tribut\xE1rio <span class="text-danger">*</span></label><input type="checkbox" name="substitutoTributario" id="field_substitutoTributario" ng-model="prestadorServicos.enquadramentoFiscal.substitutoTributario"><label for="field_substitutoTributario" ng-if="!prestadorServicos.enquadramentoFiscal.substitutoTributario"><span class="text-danger">N\xE3o</span></label><label for="field_substitutoTributario" ng-if="prestadorServicos.enquadramentoFiscal.substitutoTributario"><span class="text-success">Sim</span></label></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h4>Cnaes</h4></div><div class="ibox-content"><div class="row"><div class="col-md-12 text-center"><button type="button" class="btn btn-info" ng-click="searchCnae()"><span class="fa fa-search"></span> Escolher</button></div><div class="col-md-12 text-center"><div class="form-group m-t-lg" ng-if="prestadorServicos.cnaes && prestadorServicos.cnaes.length > 0"><div class="col-md-2"><label>C\xF3digo</label></div><div class="col-md-8"><label>Descricao</label></div><div class="col-md-2"><label>Remover</label></div></div><div class="form-group animated fadeInDown" data-ng-repeat="cnae in prestadorServicos.cnaes"><div class="col-md-2"><h4>{{cnae.codigo}}</h4></div><div class="col-md-8"><h4>{{cnae.descricao}}</h4></div><div class="col-md-2"><a ng-click="removerCnae($index)" class="text-danger"><i class="fa fa-trash"></i></a></div></div></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h4>Servi\xE7os <small>* Os servi\xE7os s\xE3o adicionados automaticamente de acordo com os CNAEs selecionados</small></h4></div><div class="ibox-content" ng-if="prestadorServicos.cnaes && prestadorServicos.cnaes.length > 0"><div class="row"><div class="col-md-12 text-center"><div class="form-group m-t-lg"><div class="col-md-2"><label>C\xF3digo</label></div><div class="col-md-2"><label>Aliquota</label></div><div class="col-md-6"><label>Descri\xE7\xE3o</label></div><div class="col-md-2"><label>Remover</label></div></div><div class="form-group animated fadeInDown" data-ng-repeat="servico in servicos"><div class="col-md-2"><h4>{{servico.codigo}}</h4></div><div class="col-md-2"><h4>{{servico.aliquota}}</h4></div><div class="col-md-6"><h4>{{servico.descricao}}</h4></div><div class="col-md-2"><a ng-click="removerServico(prestadorServicos.servicos.indexOf(servico))" ng-show="prestadorServicos.servicos.indexOf(servico) >= 0" class="text-danger"><i class="fa fa-trash"></i> </a><a ng-click="adicionarServico(servico)" ng-show="prestadorServicos.servicos.indexOf(servico) < 0" class="text-info"><i class="fa fa-plus-circle"></i></a></div></div></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h4>Receita Tribut\xE1ria Bruta</h4></div><div class="ibox-content"><div class="row"><div class="form-group col-md-4" ng-repeat="receitaTributariaBruta in prestadorServicos.receitasTributariaBruta"><div class="form-group col-md-6 text-right"><label class="m-xxs">{{receitaTributariaBruta.ano}} / {{\'nfseApp.Mes.\' + receitaTributariaBruta.mes | translate}}</label></div><div class="form-group col-md-6 text-left"><input type="text" class="form-control m-xxs" name="valorBruto" ui-money-mask="R$" id="field_valor_bruto" ng-model="receitaTributariaBruta.valorBruto"></div></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h4>Logo da empresa</h4></div><div class="ibox-content"><div class="form-group col-md-12"><button ngf-select="upload($file)" ngf-max-size="10MB" class="btn btn-block btn-default btn-outline" accept="image/*"><i class="fa fa-upload"></i> Selecione um arquivo para anexar</button></div><br><br><br></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h4>Finalizar</h4></div><div class="ibox-content"><div class="form-group"><div class="col-md-10"><button type="submit" ui-sref="login" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div><div class="col-md-2"><button type="submit" class="btn btn-primary btn-block"><span class="glyphicon glyphicon-arrow-right"></span>&nbsp; Registrar</button></div></div>Os campos que possuem <span class="text-danger">*</span> s\xE3o campos obrigat\xF3rios.<br>Os campos que possuem <span class="text-info">*</span> deve-se informar pelo menos um dos campos.</div></div></form></div></div></div>');
$templateCache.put('app/component/dadospessoais/dados-pessoais-edit.html','<div class="form-group"><div class="col-md-4"><label class="control-label" for="responsavelCpfCnpj">CPF ou CNPJ</label><div class="input-group"><input type="text" class="form-control" id="responsavelCpfCnpj" name="responsavelCpfCnpj" ui-br-cpfcnpj-mask ng-change="preLoadResponsavel()" ng-model="vm.dadosPessoais.cpfCnpj" required> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="searchPessoa()"><span class="glyphicon glyphicon-search"></span></button></span></div><div ng-show="vm.formReference.responsavelCpfCnpj.$invalid"><p class="help-block" ng-show="vm.formReference.responsavelCpfCnpj.$error.required">Informe o CPF ou CNPJ</p><p class="help-block" ng-show="vm.formReference.responsavelCpfCnpj.$error.cpf || vm.formReference.responsavelCpfCnpj.$error.cnpj">CPF ou CNPJ inv\xE1lido</p></div></div></div><div ng-show="vm.formReference.responsavelCpfCnpj.$valid"><div class="form-group" ng-if="!isFisica()"><div class="col-md-4"><label for="field_inscricaoMunicipal">Inscri\xE7\xE3o Municipal</label><input type="text" class="form-control" name="inscricaoMunicipal" id="field_inscricaoMunicipal" ng-disabled="vm.pessoa.id" ng-model="vm.dadosPessoais.inscricaoMunicipal"></div><div class="col-md-8"><label class="control-label" for="field_nomeFantasia">Nome Fantasia</label><input type="text" class="form-control" name="nomeFantasia" id="field_nomeFantasia" ng-disabled="vm.pessoa.id" ng-model="vm.dadosPessoais.nomeFantasia"></div></div><div class="form-group"><div class="col-md-4" ng-if="!isFisica()" ng-class="{\'has-error\' : vm.formReference.inscricaoEstadual.$invalid && (vm.formReference.$submitted || vm.formReference.inscricaoEstadual.$touched)}"><label class="control-label" for="field_inscricaoEstadual">Inscri\xE7\xE3o Estadual</label><input type="text" class="form-control" name="inscricaoEstadual" id="field_inscricaoEstadual" ng-disabled="vm.pessoa.id" ng-model="vm.dadosPessoais.inscricaoEstadualRg"></div><div class="col-md-4" ng-if="isFisica()" ng-class="{\'has-error\' : vm.formReference.rg.$invalid  && (vm.formReference.$submitted || vm.formReference.rg.$touched)}"><label class="control-label" for="field_rg">RG</label><input type="text" class="form-control" name="rg" id="field_rg" ng-disabled="vm.pessoa.id" ng-model="vm.dadosPessoais.inscricaoEstadualRg"></div><div class="col-md-8" ng-class="{\'has-error\' : vm.formReference.nomeRazaoSocial.$invalid && (vm.formReference.$submitted || vm.formReference.nomeRazaoSocial.$touched)}"><label class="control-label" for="field_nomeRazaoSocial">{{isFisica() ? \'Nome \':\'Raz\xE3o Social\'}}</label><input type="text" class="form-control" name="nomeRazaoSocial" id="field_nomeRazaoSocial" ng-disabled="vm.pessoa.id" ng-model="vm.dadosPessoais.nomeRazaoSocial" required><div ng-show="vm.formReference.nomeRazaoSocial.$invalid"><p class="help-block" ng-show="vm.formReference.nomeRazaoSocial.$error.required">Informe o Nome ou a Raz\xE3o Social</p></div></div></div><div class="form-group"><div class="col-md-4"><label for="field_apelido">Apelido</label><input type="text" class="form-control" name="email" id="field_apelido" ng-disabled="vm.pessoa.id" ng-model="vm.dadosPessoais.apelido"></div><div class="col-md-5"><label for="field_email">e-Mail</label><input type="text" class="form-control" name="email" id="field_email" ng-disabled="vm.pessoa.id" ng-model="vm.dadosPessoais.email"></div><div class="col-md-3"><label for="field_telefone">Telefone</label><input type="text" class="form-control" name="telefone" id="field_telefone" ui-br-phone-number ng-disabled="vm.pessoa.id" ng-model="vm.dadosPessoais.telefone"></div></div><div class="form-group"><div class="col-md-2"><label for="field_cep">Cep</label><input type="text" class="form-control" name="id" id="field_cep" ui-br-cep-mask ng-blur="loadEnderecoByCEP(vm.dadosPessoais.cep)" ng-disabled="vm.pessoa.id" ng-model="vm.dadosPessoais.cep"></div><div class="col-md-8"><label for="field_nome_municipio">Munic\xEDpio</label><div class="input-group"><input type="text" class="form-control" name="nome_municipio" id="field_nome_municipio" disabled="disabled" ng-model="vm.dadosPessoais.municipio.nome"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-disabled="vm.pessoa.id" ng-click="searchMunicipio(vm.dadosPessoais)"><span class="glyphicon glyphicon-search"></span></button></span></div></div><div class="col-md-2"><label for="field_estado_municipio">Estado</label><input type="text" class="form-control" name="estado_municipio" id="field_estado_municipio" disabled="disabled" ng-model="vm.dadosPessoais.municipio.estado"></div></div><div class="form-group"><div class="col-md-12"><label for="field_logradouro">Logradouro</label><input type="text" class="form-control" name="logradouro" id="field_logradouro" ng-disabled="vm.pessoa.id" ng-model="vm.dadosPessoais.logradouro"></div></div><div class="form-group"><div class="col-md-6"><label for="field_bairro">Bairro</label><input type="text" class="form-control" name="bairro" id="field_bairro" ng-disabled="vm.pessoa.id" ng-model="vm.dadosPessoais.bairro"></div><div class="col-md-2"><label for="field_numero">N\xFAmero</label><input type="text" class="form-control" name="numero" id="field_numero" ng-disabled="vm.pessoa.id" ng-model="vm.dadosPessoais.numero"></div><div class="col-md-4"><label for="field_complemento">Complemento</label><input type="text" class="form-control" name="complemento" id="field_complemento" ng-disabled="vm.pessoa.id" ng-model="vm.dadosPessoais.complemento"></div></div></div>');
$templateCache.put('app/account/troca-empresa/troca-empresa.html','<div class="modal-header"><h4 class="modal-title" id="myServicoLabel"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button> Selecione uma empresa</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><search-box ng-model="filtro" search-method="loadAll()"></search-box></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Inscri\xE7\xE3o Municipal</th><th>Cpf/Cnpj</th><th>Empresa</th><th></th></tr></thead><tbody><tr ng-repeat="empresa in empresas" class="{{empresa.id == empresaSelecionada.prestador.id ? \'info\': \'\'}}"><td>{{empresa.inscricaoMunicipal}}</td><td>{{empresa.pessoa.dadosPessoais.cpfCnpj}}</td><td>{{empresa.pessoa.dadosPessoais.nomeRazaoSocial}}</td><td class="text-center"><button type="submit" ng-disabled="empresa.id == empresaSelecionada.prestador.id" ng-click="ok(empresa)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-check"></span></button></td></tr><tr><td colspan="3" class="text-center"><a ng-click="irParaCredenciamento()"><i class="fa fa-plus-circle"></i> <span class="nav-label">Solicitar novo acesso</span></a></td></tr></tbody></table><span nfse-app-pagination></div></div>');
$templateCache.put('app/component/pessoa/pessoa-edit.html','<div class="form-group"><div class="col-md-4"><label class="control-label" for="responsavelCpfCnpj">CPF ou CNPJ</label><div class="input-group"><input type="text" class="form-control" id="responsavelCpfCnpj" name="responsavelCpfCnpj" ui-br-cpfcnpj-mask ng-change="preLoadResponsavel()" ng-model="vm.pessoa.dadosPessoais.cpfCnpj" required> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="searchPessoa()"><span class="glyphicon glyphicon-search"></span></button></span></div><div ng-show="vm.formReference.responsavelCpfCnpj.$invalid"><p class="help-block" ng-show="vm.formReference.responsavelCpfCnpj.$error.required">Informe o CPF ou CNPJ</p><p class="help-block" ng-show="vm.formReference.responsavelCpfCnpj.$error.cpf || vm.formReference.responsavelCpfCnpj.$error.cnpj">CPF ou CNPJ inv\xE1lido</p></div></div></div><div ng-show="vm.formReference.responsavelCpfCnpj.$valid"><div class="form-group" ng-if="!isFisica()"><div class="col-md-4"><label for="field_inscricaoMunicipal">Inscri\xE7\xE3o Municipal</label><input type="text" class="form-control" name="inscricaoMunicipal" id="field_inscricaoMunicipal" ng-disabled="vm.pessoa.id" ng-model="vm.pessoa.dadosPessoais.inscricaoMunicipal"></div><div class="col-md-8"><label class="control-label" for="field_nomeFantasia">Nome Fantasia</label><input type="text" class="form-control" name="nomeFantasia" id="field_nomeFantasia" ng-disabled="vm.pessoa.id" ng-model="vm.pessoa.dadosPessoais.nomeFantasia"></div></div><div class="form-group"><div class="col-md-4" ng-if="!isFisica()" ng-class="{\'has-error\' : vm.formReference.inscricaoEstadual.$invalid && (vm.formReference.$submitted || vm.formReference.inscricaoEstadual.$touched)}"><label class="control-label" for="field_inscricaoEstadual">Inscri\xE7\xE3o Estadual</label><input type="text" class="form-control" name="inscricaoEstadual" id="field_inscricaoEstadual" ng-disabled="vm.pessoa.id" ng-model="vm.pessoa.dadosPessoais.inscricaoEstadualRg"></div><div class="col-md-4" ng-if="isFisica()" ng-class="{\'has-error\' : vm.formReference.rg.$invalid  && (vm.formReference.$submitted || vm.formReference.rg.$touched)}"><label class="control-label" for="field_rg">RG</label><input type="text" class="form-control" name="rg" id="field_rg" ng-disabled="vm.pessoa.id" ng-model="vm.pessoa.dadosPessoais.inscricaoEstadualRg"></div><div class="col-md-8" ng-class="{\'has-error\' : vm.formReference.nomeRazaoSocial.$invalid && (vm.formReference.$submitted || vm.formReference.nomeRazaoSocial.$touched)}"><label class="control-label" for="field_nomeRazaoSocial">{{isFisica() ? \'Nome \':\'Raz\xE3o Social\'}}</label><input type="text" class="form-control" name="nomeRazaoSocial" id="field_nomeRazaoSocial" ng-disabled="vm.pessoa.id" ng-model="vm.pessoa.dadosPessoais.nomeRazaoSocial" required><div ng-show="vm.formReference.nomeRazaoSocial.$invalid"><p class="help-block" ng-show="vm.formReference.nomeRazaoSocial.$error.required">Informe o Nome ou a Raz\xE3o Social</p></div></div></div><div class="form-group"><div class="col-md-4"><label for="field_apelido">Apelido</label><input type="text" class="form-control" name="email" id="field_apelido" ng-disabled="vm.pessoa.id" ng-model="vm.pessoa.dadosPessoais.apelido"></div><div class="col-md-5"><label for="field_email">e-Mail</label><input type="text" class="form-control" name="email" id="field_email" ng-disabled="vm.pessoa.id" ng-model="vm.pessoa.dadosPessoais.email"></div><div class="col-md-3"><label for="field_telefone">Telefone</label><input type="text" class="form-control" name="telefone" id="field_telefone" ui-br-phone-number ng-disabled="vm.pessoa.id" ng-model="vm.pessoa.dadosPessoais.telefone"></div></div><div class="form-group"><div class="col-md-2"><label for="field_cep">Cep</label><input type="text" class="form-control" name="id" id="field_cep" ui-br-cep-mask ng-blur="loadEnderecoByCEP(vm.pessoa.dadosPessoais.cep)" ng-disabled="vm.pessoa.id" ng-model="vm.pessoa.dadosPessoais.cep"></div><div class="col-md-8"><label for="field_nome_municipio">Munic\xEDpio</label><div class="input-group"><input type="text" class="form-control" name="nome_municipio" id="field_nome_municipio" disabled="disabled" ng-model="vm.pessoa.dadosPessoais.municipio.nome"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-disabled="vm.pessoa.id" ng-click="searchMunicipio(vm.pessoa.dadosPessoais)"><span class="glyphicon glyphicon-search"></span></button></span></div></div><div class="col-md-2"><label for="field_estado_municipio">Estado</label><input type="text" class="form-control" name="estado_municipio" id="field_estado_municipio" disabled="disabled" ng-model="vm.pessoa.dadosPessoais.municipio.estado"></div></div><div class="form-group"><div class="col-md-12"><label for="field_logradouro">Logradouro</label><input type="text" class="form-control" name="logradouro" id="field_logradouro" ng-disabled="vm.pessoa.id" ng-model="vm.pessoa.dadosPessoais.logradouro"></div></div><div class="form-group"><div class="col-md-6"><label for="field_bairro">Bairro</label><input type="text" class="form-control" name="bairro" id="field_bairro" ng-disabled="vm.pessoa.id" ng-model="vm.pessoa.dadosPessoais.bairro"></div><div class="col-md-2"><label for="field_numero">N\xFAmero</label><input type="text" class="form-control" name="numero" id="field_numero" ng-disabled="vm.pessoa.id" ng-model="vm.pessoa.dadosPessoais.numero"></div><div class="col-md-4"><label for="field_complemento">Complemento</label><input type="text" class="form-control" name="complemento" id="field_complemento" ng-disabled="vm.pessoa.id" ng-model="vm.pessoa.dadosPessoais.complemento"></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="fromDate" ng-change="onChangeDate()" required> <span class="input-group-addon" translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="toDate" ng-change="onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 translate="configuration.title">configuration</h2><span translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse"><span translate="configuration.table.prefix">Prefix</span></th><th translate="configuration.table.properties">Properties</th></tr></thead><tr ng-repeat="entry in configuration | filter:filter | orderBy:predicate:reverse"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-6">{{key}}</div><div class="col-md-6"><span class="pull-right label label-info" style="white-space: normal;word-break:break-all">{{value}}</span></div></div></td></tr></table></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top"></iframe>');
$templateCache.put('app/admin/health/health.html','<div><h2 translate="health.title">Health Check</h2><div class="modal fade" id="showHealthModal" tabindex="-1" role="dialog" aria-labelledby="showHealthLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><form name="form" role="form" novalidate class="ng-scope ng-invalid ng-invalid-required ng-dirty ng-valid-minlength" ng-submit="create()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + baseName(currentHealth.name) | translate}} {{subSystemName(currentHealth.name)}}</h4></div><div class="modal-body"><div ng-show="currentHealth.details"><h4 translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" translate="health.details.name">Name</th><th class="col-md-6 text-left" translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="currentHealth.error"><h4 translate="health.details.error">Error</h4><pre>{{currentHealth.error}}</pre></div></div></form></div></div></div><p><button type="button" class="btn btn-primary" ng-click="refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" translate="health.table.service">Service Name</th><th class="col-md-2 text-center" translate="health.table.status">Status</th><th class="col-md-2 text-center" translate="health.details.details">Details</th><th class="col-md-1 text-center"></th></tr></thead><tbody><tr ng-repeat="health in healthData"><td>{{\'health.indicator.\' + baseName(health.name) | translate}} {{subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td><td></td></tr></tbody></table></div>');
$templateCache.put('app/admin/logs/logs.html','<div><h2 translate="logs.title">Logs</h2><p translate="logs.nbloggers" translate-values="{total: \'{{ loggers.length }}\'}">There are {{ loggers.length }} loggers.</p><span translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="metrics.refresh.button">Refresh</span></button></p><h3 translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="updatingMetrics"><div class="col-md-4"><b translate="metrics.jvm.memory.title">Memory</b><p><span translate="metrics.jvm.memory.total">Total Memory</span> ({{metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><div class="progress progress-striped"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="{{metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}" aria-valuemin="0" aria-valuemax="{{metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}" ng-style="{width: (metrics.gauges[\'jvm.memory.total.used\'].value * 100 / metrics.gauges[\'jvm.memory.total.max\'].value | number:0) + \'%\'}">{{metrics.gauges[\'jvm.memory.total.used\'].value * 100 / metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</div></div><p><span translate="metrics.jvm.memory.heap">Heap Memory</span> ({{metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><div class="progress progress-striped"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="{{metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}" aria-valuemin="0" aria-valuemax="{{metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}" ng-style="{width: (metrics.gauges[\'jvm.memory.heap.usage\'].value * 100 | number:0) + \'%\'}">{{(metrics.gauges[\'jvm.memory.heap.usage\'].value * 100 | number:0)}}%</div></div><p><span translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><div class="progress progress-striped"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="{{metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}" aria-valuemin="0" aria-valuemax="{{metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}" ng-style="{width: (metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0) + \'%\'}">{{(metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0)}}%</div></div></div><div class="col-md-4"><b translate="metrics.jvm.threads.title">Threads</b> (Total: {{metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span translate="metrics.jvm.threads.runnable">Runnable</span> {{metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><div class="progress progress-striped"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="{{metrics.gauges[\'jvm.threads.runnable.count\'].value}}" aria-valuemin="0" aria-valuemax="{{metrics.gauges[\'jvm.threads.count\'].value}}" ng-style="{width: (metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / metrics.gauges[\'jvm.threads.count\'].value | number:0) + \'%\'}">{{metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</div></div><p><span translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><div class="progress progress-striped"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="{{metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}}" aria-valuemin="0" aria-valuemax="{{metrics.gauges[\'jvm.threads.count\'].value}}" ng-style="{width: (metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / metrics.gauges[\'jvm.threads.count\'].value | number:0) + \'%\'}">{{metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</div></div><p><span translate="metrics.jvm.threads.waiting">Waiting</span> ({{metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><div class="progress progress-striped"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="{{metrics.gauges[\'jvm.threads.waiting.count\'].value}}" aria-valuemin="0" aria-valuemax="{{metrics.gauges[\'jvm.threads.count\'].value}}" ng-style="{width: (metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / metrics.gauges[\'jvm.threads.count\'].value | number:0) + \'%\'}">{{metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</div></div><p><span translate="metrics.jvm.threads.blocked">Blocked</span> ({{metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><div class="progress progress-striped"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="{{metrics.gauges[\'jvm.threads.blocked.count\'].value}}" aria-valuemin="0" aria-valuemax="{{metrics.gauges[\'jvm.threads.count\'].value}}" ng-style="{width: (metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / metrics.gauges[\'jvm.threads.count\'].value | number:0) + \'%\'}">{{metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</div></div></div><div class="col-md-4"><b translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="updatingMetrics" translate="metrics.updating">Updating...</div><h3 translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span translate="metrics.jvm.http.active">Active requests</span> <b>{{metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span translate="metrics.jvm.http.total">Total requests</span> <b>{{metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.jvm.http.table.code">Code</th><th translate="metrics.jvm.http.table.count">Count</th><th class="text-right" translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td translate="metrics.jvm.http.code.ok">OK</td><td><div class="progress progress-striped"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count * 100 / metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count}}" aria-valuemin="0" aria-valuemax="{{metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count}}" ng-style="{width: ((metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count * 100 / metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count) | number:0) + \'%\'}">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</div></div></td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td translate="metrics.jvm.http.code.notfound">Not Found</td><td><div class="progress progress-striped"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count * 100 / metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count}}" aria-valuemin="0" aria-valuemax="{{metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count}}" ng-style="{width: ((metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count * 100 / metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count) | number:0) + \'%\'}">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</div></div></td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td translate="metrics.jvm.http.code.servererror">Server error</td><td><div class="progress progress-striped"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count * 100 / metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count}}" aria-valuemin="0" aria-valuemax="{{metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count}}" ng-style="{width: ((metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count * 100 / metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count) | number:0) + \'%\'}">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</div></div></td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" translate="metrics.servicesstats.table.count">Count</th><th class="text-right" translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" translate="metrics.servicesstats.table.min">Min</th><th class="text-right" translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 translate="metrics.datasource.title" ng-show="metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span translate="metrics.datasource.usage">Usage</span> ({{metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value}} / {{metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value}})</th><th class="text-right" translate="metrics.datasource.count">Count</th><th class="text-right" translate="metrics.datasource.mean">Mean</th><th class="text-right" translate="metrics.datasource.min">Min</th><th class="text-right" translate="metrics.datasource.p50">p50</th><th class="text-right" translate="metrics.datasource.p75">p75</th><th class="text-right" translate="metrics.datasource.p95">p95</th><th class="text-right" translate="metrics.datasource.p99">p99</th><th class="text-right" translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="{{metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value | number:0}}" aria-valuemin="0" aria-valuemax="{{metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value | number:0}}" ng-style="{width: (metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value * 100 / metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value | number:0) + \'%\'}">{{metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value * 100 / metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value | number:0}}%</div></div></td><td class="text-right">{{metrics.histograms[\'HikariPool-0.pool.Usage\'].count}}</td><td class="text-right">{{metrics.histograms[\'HikariPool-0.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{metrics.histograms[\'HikariPool-0.pool.Usage\'].min | number:2}}</td><td class="text-right">{{metrics.histograms[\'HikariPool-0.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{metrics.histograms[\'HikariPool-0.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{metrics.histograms[\'HikariPool-0.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{metrics.histograms[\'HikariPool-0.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{metrics.histograms[\'HikariPool-0.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div><!-- Modal used to display the threads dump --><div id="threadDump" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog modal-lg"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title" id="myModalLabel" translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body well"><span class="label label-primary" ng-click="threadDumpFilter = {}"><span translate="metrics.jvm.threads.all">All</span>&nbsp;<span class="badge">{{threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}"><span translate="metrics.jvm.threads.runnable">Runnable</span>&nbsp;<span class="badge">{{threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}"><span translate="metrics.jvm.threads.waiting">Waiting</span>&nbsp;<span class="badge">{{threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}"><span translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span>&nbsp;<span class="badge">{{threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}"><span translate="metrics.jvm.threads.blocked">Blocked</span>&nbsp;<span class="badge">{{threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div><div class="row" ng-repeat="(k, v) in threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="getLabelClass(v.threadState)">&nbsp;</span>&nbsp;{{v.threadName}} (<span translate="metrics.jvm.threads.dump.id">Id</span> {{v.threadId}})</h5><table class="table table-condensed"><thead><tr><th class="text-right" translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th translate="metrics.jvm.threads.dump.lockname">Lock Name</th><th translate="metrics.jvm.threads.dump.stacktrace">StackTrace</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td><td><a ng-click="show = !show" data-placement="left"><span ng-show="!show" translate="metrics.jvm.threads.dump.show">show</span> <span ng-show="show" translate="metrics.jvm.threads.dump.hide">hide</span></a><div class="popover left" ng-show="show"><div class="popover-title"><h4><span translate="metrics.jvm.threads.dump.stacktrace">Stacktrace</span><button type="button" class="close" ng-click="show = !show">&times;</button></h4></div><div class="popover-content"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div></div></td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Close</button></div></div></div></div>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span translate="user-management.detail.title">User</span> "{{user.nomeRazao}}"</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span translate="user-management.login">Login</span></td><td><input type="text" class="input-sm form-control" value="{{user.login}}" readonly="readonly"></td></tr><tr><td><span translate="user-management.nomeRazao">nomeRazao</span></td><td><input type="text" class="input-sm form-control" value="{{user.nomeRazao}}" readonly="readonly"></td></tr><tr><td><span translate="user-management.email">Email</span></td><td><input type="text" class="input-sm form-control" value="{{user.email}}" readonly="readonly"></td></tr><tr><td><span translate="user-management.activated">Activated</span></td><td><input type="text" class="input-sm form-control" value="{{user.activated ? \'Sim\' : \'N\xE3o\'}}" readonly="readonly"></td></tr><tr><td><span translate="user-management.langKey">LangKey</span></td><td><input type="text" class="input-sm form-control" value="{{user.langKey}}" readonly="readonly"></td></tr><tr><td><span translate="user-management.createdBy">CreatedBy</span></td><td><input type="text" class="input-sm form-control" value="{{user.createdBy}}" readonly="readonly"></td></tr><tr><td><span translate="user-management.createdDate">CreatedDate</span></td><td><input type="text" class="input-sm form-control" value="{{user.createdDate | date:\'dd/MM/yy HH:mm\' }}" readonly="readonly"></td></tr><tr><td><span translate="user-management.lastModifiedBy">LastModifiedBy</span></td><td><input type="text" class="input-sm form-control" value="{{user.lastModifiedBy}}" readonly="readonly"></td></tr><tr><td><span translate="user-management.lastModifiedDate">LastCreatedDate</span></td><td><input type="text" class="input-sm form-control" value="{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}" readonly="readonly"></td></tr><tr><td><span>Pessoa</span></td><td><button type="submit" ng-click="visualizarPessoaUsuario()" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button></td></tr><tr><td><span translate="user-management.profiles">Profiles</span></td><td><ul class="list-unstyled"><li ng-repeat="authority in user.roles"><span>{{authority}}</span></li></ul></td></tr></tbody></table></div><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-edit.html','<div class="row"><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="save()"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h4>Dados do Usu\xE1rio</h4></div><div class="ibox-content"><div class="form-group"><div class="col-md-6"><label>C\xF3digo</label><input type="text" class="form-control" name="id" ng-model="user.id" readonly="readonly"></div><div class="col-md-6"><label for="field_ativo">Ativo</label><div class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="ativo" ng-model="user.activated" class="onoffswitch-checkbox" id="field_ativo"><label class="onoffswitch-label" for="field_ativo"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div></div><div class="form-group"><div class="col-md-6"><label>Login</label><input type="text" class="form-control" name="login" ng-model="user.login" ng-required="user.id == null" ng-maxlength="50"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="col-md-6"><label>e-Mail</label><input type="text" class="form-control" name="email" ng-model="user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="form-group"><div class="col-md-12"><label translate="user-management.nomeRazao">Nome/Raz\xE3o Social</label><input type="text" class="form-control" name="nomeRazao" ng-model="user.nomeRazao" ng-maxlength="50"><div ng-show="editForm.nomeRazao.$invalid"><p class="help-block" ng-show="editForm.nomeRazao.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><div class="col-md-12"><label style="margin-right: 10px">Pessoa</label><button type="button" ng-click="visualizarPessoaUsuario()" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button></div></div><div class="form-group"><div class="col-md-12"><label>Perfil</label><select class="form-control" multiple="multiple" name="authority" ng-model="user.roles" ng-options="authority for authority in authorities"></select></div></div></div></div><div class="form-actions"><button type="button" class="btn btn-default" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></div></form></div>');
$templateCache.put('app/admin/user-management/user-management-search-by-cpf.html','<div class="modal-header" ng-form="form-user"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4>Procure usu\xE1rios por nome, e-mail ou cpf</h4></div><div class="modal-body"><div class="row"><form name="form"><div ng-show="users == undefined"><div class="col-md-12"><search-box ng-model="searchQuery" id="search" search-method="search()"></search-box></div></div><div ng-show="users.length > 0"><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Login/Cpf</th><th>e-Mail</th><th></th></tr></thead><tbody><tr ng-repeat="user in users"><td>{{user.login}}</td><td>{{user.email}}</td><td class="text-right"><button type="submit" ng-click="ok(user)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-check"></span></button></td></tr></tbody></table><nav><ul class="pager"><li ng-show="links[\'first\']" ng-click="loadPage(links[\'first\'])"><a href="#">&lt;&lt;</a></li><li ng-show="links[\'prev\']" ng-click="loadPage(links[\'prev\'])"><a href="#">&lt;</a></li><li ng-show="links[\'next\']" ng-click="loadPage(links[\'next\'])"><a href="#">&gt;</a></li><li ng-show="links[\'last\']" ng-click="loadPage(links[\'last\'])"><a href="#">&gt;&gt;</a></li></ul></nav></div><div class="col-md-12 text-center" style="padding: 10px"><button type="button" ng-click="novo()" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-check"></span> Digitar novo Filtro</button></div></div><div ng-show="users.length == 0"><div><div class="alert alert-warning">N\xE3o foi encontrado nenhum usu\xE1rio para o Filtro {{searchQuery}}. Por favor digite o email para solicitar o cadastro do usu\xE1rio.</div><div class="ibox-content"><div class="form-group"><div class="col-md-12"><label>Email</label><input type="email" class="form-control" name="email" ng-model="solicitacao.dadosPessoais.email" required><div ng-show="form.email.$invalid" class="has-error"><p class="help-block small">E-mail inv\xE1lido.</p></div></div></div><div class="form-group"><div class="col-md-12"><label>Nome</label><input type="text" class="form-control" name="nome" ng-model="solicitacao.dadosPessoais.nomeRazaoSocial" required><div ng-show="form.nome.$invalid" class="has-error"><p class="help-block small">Nome inv\xE1lido.</p></div></div></div></div></div><div class="col-md-12 text-center" style="padding: 10px"><button ng-disabled="form.email.$invalid" ng-click="emailSolicitandoCadastro()" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-check"></span> Enviar Email</button> <button type="button" ng-click="novo()" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-check"></span> Digitar novo CPF</button></div></div></form></div></div>');
$templateCache.put('app/admin/user-management/user-management-search.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title" id="myUserLabel">Usu\xE1rios</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><search-box ng-model="searchQuery" search-method="search()"></search-box></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th>C\xF3digo</th><th>Login</th><th>e-Mail</th><th></th></tr></thead><tbody><tr ng-repeat="user in users"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td class="text-right"><button type="submit" ng-click="ok(user)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-check"></span></button></td></tr></tbody></table><nav><ul class="pager"><li ng-show="links[\'first\']" ng-click="loadPage(links[\'first\'])"><a href="#">&lt;&lt;</a></li><li ng-show="links[\'prev\']" ng-click="loadPage(links[\'prev\'])"><a href="#">&lt;</a></li><li ng-show="links[\'next\']" ng-click="loadPage(links[\'next\'])"><a href="#">&gt;</a></li><li ng-show="links[\'last\']" ng-click="loadPage(links[\'last\'])"><a href="#">&gt;&gt;</a></li></ul></nav></div></div>');
$templateCache.put('app/admin/user-management/user-management.html','<div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title">Usu\xE1rios</div><div class="ibox-content"><div class="row"><div class="col-md-12"><search-box ng-model="searchQuery" search-method="search()"></search-box></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th>C\xF3digo</th><th>Login</th><th>e-Mail</th><th></th><th>Perfil</th><th>Data de Cria\xE7\xE3o</th><th>Ultima Modifica\xE7\xE3o</th><th></th></tr></thead><tbody><tr ng-repeat="user in users"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class="label label-danger" ng-click="setActive(user, true)" ng-show="!user.activated" style="cursor: pointer">Inativo</span> <span class="label label-success" ng-click="setActive(user, false)" ng-show="user.activated" style="cursor: pointer">Ativo</span></td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{user.lastModifiedBy}} - {{user.lastModifiedDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td class="text-right"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="user-management-edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button></td></tr></tbody></table><nav><ul class="pager"><li ng-show="links[\'first\']" ng-click="loadPage(links[\'first\'])"><a href="#">&lt;&lt;</a></li><li ng-show="links[\'prev\']" ng-click="loadPage(links[\'prev\'])"><a href="#">&lt;</a></li><li ng-show="links[\'next\']" ng-click="loadPage(links[\'next\'])"><a href="#">&gt;</a></li><li ng-show="links[\'last\']" ng-click="loadPage(links[\'last\'])"><a href="#">&gt;&gt;</a></li></ul></nav></div></div></div></div></div>');
$templateCache.put('app/components/footer/footer.html','<div class="footer"><div class="pull-right"><img alt="image" width="22" ng-src="/assets/images/logo-wp-62.png"> <strong>&nbsp;&nbsp;Webpublico</strong> - Sistema Integrado de Gest\xE3o P\xFAblica &copy; 2011-2017</div><div><strong><span>ISS Online </span></strong>v {{VERSION}}</div></div>');
$templateCache.put('app/components/footer/no-footer.html','<div class="footer-externo text-black"><!--<img alt="image"--><!--width="22"--><!--ng-src="/assets/images/logo-wp-62.png"/>--><!--<strong>&nbsp;&nbsp;Webpublico</strong> - Sistema Integrado de Gest\xE3o P\xFAblica &copy; 2011-2017--></div>');
$templateCache.put('app/components/form/pager.html','<nav><ul class="nfseApp-pager"><li ng-show="links[\'first\']" ng-click="loadPage(links[\'first\'])"><a href="#">&lt;&lt;</a></li><li ng-show="links[\'prev\']" ng-click="loadPage(links[\'prev\'])"><a href="#">&lt;</a></li><li ng-show="links[\'next\']" ng-click="loadPage(links[\'next\'])"><a href="#">&gt;</a></li><li ng-show="links[\'last\']" ng-click="loadPage(links[\'last\'])"><a href="#">&gt;&gt;</a></li></ul></nav>');
$templateCache.put('app/components/form/pagination.html','<div class="row"><div class="col-md-offset-4 col-md-4"><pagination boundary-links="true" total-items="per_page * links.last" ng-model="page" max-size="5" items-per-page="per_page" ng-change="loadPage(page)" class="pagination-sm" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></pagination></div><div class="col-md-4 text-right"><ul class="pagination-sm pagination"><li ng-class="{\'active\':per_page == 10}"><a ng-click="per_page = 10; loadPage(page)">10</a></li><li ng-class="{\'active\':per_page == 20}"><a ng-click="per_page = 20; loadPage(page)">20</a></li><li ng-class="{\'active\':per_page == 50}"><a ng-click="per_page = 50; loadPage(page)">50</a></li><li ng-class="{\'active\':per_page == 100}"><a ng-click="per_page = 100; loadPage(page)">100</a></li><li ng-class="{\'active\':per_page == 500}"><a ng-click="per_page = 500; loadPage(page)">500</a></li></ul></div></div><div class="row"><div class="col-md-offset-8 col-md-4 text-right"><span>P\xE1gina <strong>{{page ? page : 1}}</strong> de <strong>{{links.last}}</strong>.</span><br><span ng-if="totalItens">Total de registros <strong>{{totalItens}}.</strong></span></div></div>');
$templateCache.put('app/components/menu/navigation.html','<nav class="navbar-default navbar-static-side" role="navigation" ng-switch="isAuthenticated()"><div class="sidebar-collapse"><ul side-navigation class="nav metismenu" id="side-menu"><li class="nav-header" ng-switch-when="false"><div class="profile-element"><div style="text-align: center"><span><img alt="image" class="img-thumbnail m-b-sm" ng-src="/assets/images/logo-wp-62.png" width="50"> </span><a ui-sref="login"><span class="clear"><span class="block"><strong class="font-bold"><i class="fa fa-sign-in"></i> Entrar</strong></span></span></a></div></div></li><li class="nav-header" ng-switch-when="true"><div class="profile-element"><div style="text-align: center"><span><img ng-show="account.fotoAjustada" alt="image" class="img-circle m-b-sm" ng-src="{{account.fotoAjustada}}" width="50"> <img ng-show="!account.fotoAjustada" alt="image" class="img-circle m-b-sm" ng-src="/assets/images/user-default.jpg" width="50"></span><div class="dropdown small"><a class="dropdown-toggle" data-toggle="dropdown"><span class="clear"><span class="block"><strong>{{account.nome}} <b class="caret"></b> </strong></span><span class="text-muted">{{account.login | brCpfCnpj}}</span></span></a><ul class="dropdown-menu"><li><a ui-sref="perfilUsuario"><i class="fa fa-gear"></i> &#xA0;<span>Perfil</span></a></li><li><a ui-sref="password"><i class="fa fa-lock"></i> &#xA0;<span>Senha</span></a></li><li><a href="" ng-click="logout()"><span class="fa fa-sign-out"></span> &#xA0;<span>Sair</span></a></li></ul></div><div class="dropdown m-t-sm small"><a class="dropdown-toggle" data-toggle="dropdown" ng-if="prestadorPrincipal && account.pessoaFisica"><span class="clear"><span class="text-small">Empresa: </span><span class="block"><strong class="font-bold">{{prestadorPrincipal.prestador.pessoa.dadosPessoais.nomeRazaoSocial}} <b class="caret"></b> </strong></span><span class="text-muted">{{prestadorPrincipal.prestador.pessoa.dadosPessoais.cpfCnpj | brCpfCnpj}} </span></span></a><a ng-if="prestadorPrincipal && prestadorPrincipal.prestador.foraMunicipio"><span class="clear"><span class="block"><strong class="font-bold">(fora do municipio)</strong></span></span></a><ul class="dropdown-menu"><li><a ui-sref="perfilEmpresa"><i class="fa fa-gear"></i> &#xA0;<span>Configura\xE7\xF5es</span></a></li><li><a ng-click="abrirTrocarEmpresa()" class="text-small"><i class="fa fa-refresh"></i> &#xA0;<span>Trocar de Empresa</span></a></li></ul></div><a ng-click="abrirTrocarEmpresa()" ng-if="account.pessoaFisica" class="text-small m-t-sm"><i class="fa fa-refresh"></i> {{prestadorPrincipal ? \'Trocar de Empresa\' : \'Selecionar Empresa\'}}</a></div></div></li><li><a href="#" ui-sref="home"><i class="fa fa-home"></i> <span>Home</span></a></li><li has-role="ROLE_EMPRESA_AIDFE" ng-if="prestadorPrincipal && prestadorPrincipal.permitido && prestadorPrincipal.prestador.emiteNfs && configuracao.verificaAidfe"><a href=""><i class="fa fa-check-square-o"></i> <span>AIDF-e</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level"><li><a ui-sref="aidfe.new">Solicitar</a></li><li><a ui-sref="aidfe">Consultar</a></li></ul></li><li has-role="ROLE_EMPRESA_PLANO_GERAL_CONTAS_COMENTADO" ng-if="prestadorPrincipal.prestador.enquadramentoFiscal.instituicaoFinanceira"><a href=""><i class="fa fa-list-ol"></i> <span>Plano Geral de Contas Comentado</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level"><li><a ui-sref="planoGeralContasComentado">Consultar</a></li></ul></li><li has-role="ROLE_USER" ng-if="isPrestadorPermitido()"><a href=""><i class="fa fa-newspaper-o"></i> <span>Documentos Fiscais</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level"><li has-role="ROLE_EMPRESA_NFSE" ng-if="isPrestadorPermitido() && prestadorPrincipal.prestador.emiteNfs"><a ng-click="emitirNotaFiscal()">Emitir Nfs-e</a></li><li has-role="ROLE_EMPRESA_NFSE" ng-if="isPrestadorPermitido()"><a ui-sref="notaFiscal">Consultar Nfs-e</a></li><li has-role="ROLE_EMPRESA_DOC_RECEBIDO" ng-if="isPrestadorPermitido()"><a ui-sref="servicoDeclarado.new">Declarar Servi\xE7o</a></li><li has-role="ROLE_EMPRESA_DOC_RECEBIDO" ng-if="isPrestadorPermitido()"><a ui-sref="servicoDeclarado">Consultar Servi\xE7o</a></li><li class="hidden"><a ui-sref="notaFiscalAvulsa.new">Emitir Nfs Avulsa</a></li><li class="hidden"><a ui-sref="notaFiscalAvulsa">Consultar Nfs Avulsa</a></li></ul></li><li has-role="ROLE_EMPRESA_RPS" ng-if="isPrestadorPermitido() && prestadorPrincipal.prestador.emiteNfs"><a href=""><i class="fa fa-clipboard"></i> <span>RPS</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level"><li><a ui-sref="solicitacaorps" ng-if="configuracao.obrigaSolicitarRps">Solicitar</a></li><li><a ui-sref="rPS">Consultar</a></li><li><a ui-sref="rPS.import">Importar</a></li><li><a ui-sref="loteRPS">Log dos Lotes</a></li></ul></li><li ng-switch-when="true" has-role="ROLE_EMPRESA_DMS" ng-if="isPrestadorPermitido()"><a href=""><i class="fa fa-calendar"></i> <span>Movimento Mensal</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level"><li><a ui-sref="declaracaoMensalServico">Servi\xE7os Prestados</a></li><li><a ui-sref="declaracaoMensalServicoRetencao">Servi\xE7os Tomados</a></li><li ng-if="prestadorPrincipal.prestador.enquadramentoFiscal.instituicaoFinanceira &&\n                prestadorPrincipal.prestador.enquadramentoFiscal.versaoDesif == \'VERSAO_ABRASF_3_1\'"><a ui-sref="arquivoDesif">Arquivo DES-IF</a></li><li ng-if="prestadorPrincipal.prestador.enquadramentoFiscal.instituicaoFinanceira"><a ui-sref="declaracaoMensalServicoInstituicaoFinanceira">Institui\xE7\xE3o Financeira</a></li><li ng-if="isCartorio()"><a ui-sref="declaracaoMensalServicoCartorio">Cart\xF3rio</a></li><li><a ui-sref="livroFiscal">Livro Fiscal</a></li></ul></li><li ng-switch-when="true" has-role="ROLE_EMPRESA_CONTA_CORRENTE" ng-if="isPrestadorPermitido()"><a href=""><i class="fa fa-money"></i> <span>Conta Corrente</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level"><li><a ui-sref="debitos">Consultar</a></li></ul></li><li ng-switch-when="true" has-role="ROLE_EMPRESA_TOMADOR" ng-if="isPrestadorPermitido() && prestadorPrincipal.prestador.emiteNfs"><a href=""><i class="fa fa-user"></i> <span>Tomadores</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level"><li><a ui-sref="tomador.new">Novo</a></li><li><a ui-sref="tomador">Consultar</a></li></ul></li><li has-role="ROLE_USER" ng-if="isPrestadorPermitido() && prestadorPrincipal.prestador.emiteNfs"><a href=""><i class="fa fa-newspaper-o"></i> <span>Simples Nacional</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level"><li><a ui-sref="eventosSimplesNacional">Consultar Eventos</a></li></ul></li><li has-role="ROLE_USER" ng-if="isPrestadorPermitido() && prestadorPrincipal.prestador.emiteNfs"><a href=""><i class="fa fa-building-o"></i> <span>Constru\xE7\xE3o Civil</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level"><li><a ui-sref="construcaoCivil">Consultar</a></li><li><a ui-sref="construcaoCivil.incluir">Incluir</a></li></ul></li><li has-role="ROLE_ADMIN"><a href=""><span class="glyphicon glyphicon-tower"></span> <span class="hidden-tablet" translate="global.menu.admin.main">Administration</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level"><li ui-sref-active="active"><a ui-sref="mongo"><span class="glyphicon glyphicon-ban-circle"></span> <span>Cache MongoDB</span></a></li><li ui-sref-active="active"><a ui-sref="loteRpsGeral"><span class="glyphicon glyphicon-dashboard"></span> <span>Lote Rps Geral</span></a></li><li ui-sref-active="active"><a ui-sref="metrics"><span class="glyphicon glyphicon-dashboard"></span> &#xA0;<span translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="health"><span class="glyphicon glyphicon-heart"></span> &#xA0;<span translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="configuration"><span class="glyphicon glyphicon-list-alt"></span> &#xA0;<span translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits"><span class="glyphicon glyphicon-bell"></span> &#xA0;<span translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs"><span class="glyphicon glyphicon-tasks"></span> &#xA0;<span translate="global.menu.admin.logs">Logs</span></a></li><li ui-sref-active="active"><a ui-sref="docs"><span class="glyphicon glyphicon-book"></span> &#xA0; <span translate="global.menu.admin.apidocs">API</span></a></li><li ui-sref-active="active"><a ui-sref="sync-data-base"><span class="fa fa-refresh"></span> &#xA0; <span>Sincroniza\xE7\xE3o</span></a></li></ul></li><li ng-switch-when="true" has-role="ROLE_CONTRIBUINTE" ng-if="!prestadorPrincipal && account.pessoaFisica"><a ui-sref="credenciamento"><i class="fa fa-plus-circle"></i> <span class="nav-label">Credenciamento</span></a></li><li><a ui-sref="perguntas-respostas"><i class="fa fa-comments"></i> <span class="nav-label">Perguntas e Respostas</span></a></li><li><a ui-sref="legislacao"><i class="fa fa-newspaper-o"></i> <span class="nav-label">Legisla\xE7\xE3o</span></a></li><li><a ui-sref="nota-premiada" class="hidden"><i class="fa fa-newspaper-o"></i> <span class="nav-label">Nota Premiada</span></a></li><li><a ui-sref="manual"><i class="fa fa-television"></i> <span class="nav-label">Manuais</span></a></li><li><a ui-sref="notaFiscal.autenticar"><i class="fa fa-check-circle-o"></i> <span class="nav-label">Aut\xEAnticidade da Nota</span></a></li><li><a ui-sref="rPS.autenticar"><i class="fa fa-refresh"></i> <span class="nav-label">Consulta de RPS</span></a></li><li><a ui-sref="reciboRetencaoIss"><i class="fa fa-print"></i> <span class="nav-label">Recibo de Reten\xE7\xE3o de Iss</span></a></li><li><a ui-sref="faleconosco"><i class="fa fa-envelope"></i> <span class="nav-label">Fale Conosco</span></a></li><li><a ui-sref="pesquisa-cnae"><i class="fa fa-search"></i> <span class="nav-label">Pesquisar CNAE/Servi\xE7o</span></a></li><li ng-switch-when="false"><a ui-sref="register"><i class="fa fa-user"></i> <span class="nav-label">Cadastre-se</span></a></li><li><a href="#"><span class="fa fa-sync"></span> <span>Vers\xE3o: {{versaoSistema}}</span></a></li></ul></div></nav>');
$templateCache.put('app/components/menu/no-navigation.html','<div></div>');
$templateCache.put('app/components/navbar/navbar.html','<div class="row border-bottom"><nav class="navbar navbar-fixed-top" role="navigation" style="margin-bottom: 0" ng-switch="isAuthenticated()"><div class="navbar-header"><span minimaliza-sidebar></span></div><ul class="nav navbar-top-links navbar-left hidden-sm hidden-xs"><li><a ui-sref="home"><span>&nbsp; <i class="fa fa-globe"></i> <strong><span>ISS On-line - Webpublico</span></strong></span></a></li><li ng-show="!configuracao.producao"><span class="text-danger gray-bg"><i class="fa fa-exclamation-triangle"></i> Aten\xE7\xE3o! Voc\xEA est\xE1 em um ambiente de homologa\xE7\xE3o</span></li></ul><ul class="nav navbar-top-links navbar-right" ng-switch-when="true"><li has-role="ROLE_CONTRIBUINTE" ng-if="alertas && alertas.length > 0" class="dropdown"><a class="count-info dropdown-toggle" data-toggle="dropdown" href=""><i class="fa fa-bell faa-shake animated"></i> <span class="label label-danger">{{alertas.length}}</span></a><ul class="dropdown-alerts dropdown-menu"><li ng-repeat="alerta in alertas"><a><div><i class="fa fa-exclamation-triangle fa-fw"></i> {{alerta.text}}</div></a></li></ul></li><li has-role="ROLE_CONTRIBUINTE" ng-show="prestadorPrincipal && prestadorPrincipal.prestador"><a class="link-mensagem" ui-sref="mensagemContribuinteUsuario" title="Mensagens"><i class="link-mensagem-icon fa fa-bell"></i> <span class="link-mensagem-label">Mensagens Recebidas</span></a></li><li><a ng-click="logout()" ui-sref="login" ng-if="isAuthenticated()"><i class="fa fa-sign-out"></i>Sair</a></li></ul></nav></div>');
$templateCache.put('app/components/navbar/no-navbar.html','<header class="microbranding text-center text-raleway m-b-md fadeIn animated"><h1 class="microbranding-logo-topo"><i class="fa fa-code"></i> WEBPUBLICO</h1><h2 class="microbranding-logo" href="/"><i class="fa fa-cubes"></i> Iss Online</h2></header>');
$templateCache.put('app/components/notify/notify.html','<div class="cg-notify-message inspinia-notify" ng-class="$classes"><div class="p-lg"><div ng-show="!$messageTemplate">{{$message}}</div><div ng-show="$messageTemplate" class="cg-notify-message-template"></div><button type="button" class="cg-notify-close" ng-click="$close()"><span aria-hidden="true">&times;</span> <span class="cg-notify-sr-only">Close</span></button></div></div>');
$templateCache.put('app/components/template/modelo-nota.html','<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><title>Nota</title></head><body><style>* {\n        margin: 0;\n        padding: 0;\n        font-family: sans-serif;\n        font-size: 12px;\n    }\n\n    .corpo {\n        width: 748px;\n        margin: 10px;\n        border: #000000 solid 1px;\n    }\n\n    .pdLeft10 {\n        padding-left: 10px;\n    }\n\n    .pd10 {\n        padding: 10px;\n    }\n\n    .pdRight10 {\n        padding-right: 10px;\n    }\n\n    .tpBlack {\n        border-top: #000000 solid 1px;\n    }\n\n    .btBlack {\n        border-bottom: #000000 solid 1px;\n    }\n\n    .lfBlack {\n        border-left: #000000 solid 1px;\n    }\n\n    .rgBlack {\n        border-right: #000000 solid 1px;\n    }\n\n    .larguraTotal {\n        width: 100%;\n    }\n\n    .textCenter {\n        text-align: center;\n    }\n\n    .textLeft {\n        text-align: left;\n    }\n\n    .textRight {\n        text-align: right;\n    }</style><div class="corpo"><table class="larguraTotal" cellpadding="0" cellspacing="0"><tr><td style="width: 80%" class="rgBlack pdLeft10"><p>PREFEITURA MUNICIPAL DE PARANAVA\xCD</p><p>Secretaria Municipal de Fazenda P\xFAblica</p><p>NOTA LEGAL - Nota Fiscal Eletr\xF4nica de Servi\xE7os</p></td><td><table class="larguraTotal" cellspacing="0"><tr><td class="btBlack rgBlack">N\xFAmero do RPS<br>123132</td><td class="btBlack">N\xFAmero da nota<br>123132132132312</td></tr><tr><td colspan="2" class="btBlack">Data de emiss\xE3o da nota<br>03/10/2015</td></tr><tr><td colspan="2" class="btBlack">Data do fato gerador<br>03/10/2015</td></tr><tr><td colspan="2">C\xF3digo de verifica\xE7\xE3o<br>IU3Y1I23U1-213H1NKI23-13I2U1</td></tr></table></td></tr></table><table class="larguraTotal tpBlack btBlack"><tr><td class="textCenter">PRESTADOR DE SERVI\xC7OS</td></tr></table><div><table><tr><td><table class="pdLeft10"><tr><td>Nome fantasia: JD SISTEMAS</td></tr><tr><td>Nome/Raz\xE3o social: J. W. DIAS & CIA LTDA</td></tr><tr><td>CPF/CNPJ:12.398.474/0001-12</td></tr><tr><td>Endere\xE7o: R RAFAEL BRUNO N\xFAmero: 66 Bairro: CENTRO CEP: 87701-040</td></tr><tr><td>Complemento: JD SISTEMAS</td></tr><tr><td>Munic\xEDpio: Paranava\xED</td></tr><tr><td>E-mail: jaimewdias@gmail.com</td></tr></table></td></tr></table></div><table class="larguraTotal tpBlack btBlack"><tr><td class="textCenter">TOMADOR DE SERVI\xC7OS</td></tr></table><div><table><tr><td><table class="pdLeft10"><tr><td>Nome fantasia: JD SISTEMAS</td></tr><tr><td>Nome/Raz\xE3o social: J. W. DIAS & CIA LTDA</td></tr><tr><td>CPF/CNPJ:12.398.474/0001-12</td></tr><tr><td>Endere\xE7o: R RAFAEL BRUNO N\xFAmero: 66 Bairro: CENTRO CEP: 87701-040</td></tr><tr><td>Complemento: JD SISTEMAS</td></tr><tr><td>Munic\xEDpio: Paranava\xED</td></tr><tr><td>E-mail: jaimewdias@gmail.com</td></tr></table></td></tr></table></div><table class="larguraTotal tpBlack btBlack"><tr><td class="textCenter">DISCRIMINA\xC7\xC3O DOS SERVI\xC7OS</td></tr></table><div><table class="pdLeft10 pdRight10 larguraTotal"><tr><th class="textLeft">Servi\xE7o</th><th class="textRight">Valor Unit\xE1rio</th><th class="textRight">Qtd</th><th class="textRight">Valor do Servi\xE7o</th><th class="textRight">Base de C\xE1lculo</th><th class="textRight">ISS</th></tr><tr><td class="textLeft">Suporte e manuten\xE7\xE3o de sistema.</td><td class="textRight">788,000</td><td class="textRight">1,000</td><td class="textRight">788,000</td><td class="textRight">788,00x2,00</td><td class="textRight">15,76</td></tr></table></div><table class="larguraTotal tpBlack btBlack"><tr><td class="textCenter">FORMA DE PAGAMENTO</td></tr></table><div><table class="pdLeft10 pdRight10 larguraTotal"><tr><th class="textLeft">Parcela</th><th class="textLeft">Vencimento</th><th class="textLeft">Tipo</th><th class="textRight">Valor</th></tr><tr><td class="textLeft">1</td><td class="textLeft"></td><td class="textLeft">\xC0 vista</td><td class="textRight">788,000</td></tr></table></div><table class="larguraTotal tpBlack btBlack"><tr><td class="textCenter">RETEN\xC7\xD5ES FEDERAIS</td></tr></table><div><table class="pdLeft10 pdRight10 larguraTotal"><tr><th class="textCenter">PIS/PASEP</th><th class="textCenter">COFINS</th><th class="textCenter">INSS</th><th class="textCenter">IR</th><th class="textCenter">CSLL</th><th class="textCenter">Outras reten\xE7\xF5es</th></tr><tr><td class="textCenter">R$ 0,00</td><td class="textCenter">R$ 0,00</td><td class="textCenter">R$ 0,00</td><td class="textCenter">R$ 0,00</td><td class="textCenter">R$ 0,00</td><td class="textCenter">R$ 0,00</td></tr></table><table class="pdLeft10 pdRight10 tpBlack btBlack larguraTotal" cellspacing="0"><tr><td class="textCenter">Valor bruto = R$ 788,00</td><td class="textCenter lfBlack">Valor l\xEDquido = R$ 788,00</td><td class="textCenter lfBlack">Valor tribut\xE1rio = R$ 788,00</td></tr></table><div class="pdLeft10 pdRight10 pd10"><h3>C\xF3digos dos servi\xE7os:</h3><p>01.07 - Suporte t\xE9cnico em inform\xE1tica, inclusive instala\xE7\xE3o, configura\xE7\xE3o e manuten\xE7\xE3o de programas de computa\xE7\xE3o e bancos de dados.</p></div><table class="pdLeft10 pdRight10 tpBlack larguraTotal" cellspacing="0"><tr><th class="textCenter rgBlack">Desc. condicionado(R$)</th><th class="textCenter rgBlack">Desc. incondicionado(R$)</th><th class="textCenter rgBlack">Dedu\xE7\xF5es(R$)</th><th class="textCenter rgBlack">Base de c\xE1lculo(R$)</th><th class="textCenter">Valor ISS(R$)</th></tr><tr><td class="textCenter rgBlack">0,00</td><td class="textCenter rgBlack">0,00</td><td class="textCenter rgBlack">0,00</td><td class="textCenter rgBlack">0,00</td><td class="textCenter">0,00</td></tr></table><table class="larguraTotal tpBlack btBlack"><tr><td class="textCenter">OUTRAS INFORMA\xC7\xD5ES</td></tr></table><div class="pd10">Natureza da opera\xE7\xE3o: Tributa\xE7\xE3o no munic\xEDpio<br>Situa\xE7\xE3o tribut\xE1ria do ISSQN: Reten\xE7\xE3o<br>Local da presta\xE7\xE3o do servi\xE7o: Maring\xE1<br></div></div></div></body></html>');
$templateCache.put('app/entities/aidfe/aidfe-analise.html','<div class="row"><form name="editForm" class="form-horizontal" role="form" novalidate><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h4 class="modal-title" translate="nfseApp.aidfe.home.deferimentoAidfe">Deferimento de AIDF-e</h4></div><div class="ibox-content"><div class="form-group"><div class="col-md-3"><label for="quantidade">Quantidade Solicitada de NFS-e</label><input id="quantidade" type="number" class="form-control" ng-disabled="true" name="quantidade" min="1" ng-blur="calcularNumeroNFSE()" ng-model="aidfe.quantidade"></div><div class="col-md-2"><label for="numeroInicial">NFS-e Inicial</label><input id="numeroInicial" type="text" ng-disabled="true" ng-model="aidfe.numeroInicial" class="form-control" name="numeroInicial"></div><div class="col-md-2"><label for="numeroFinal">NFS-e Final</label><input id="numeroFinal" type="text" ng-disabled="true" ng-model="aidfe.numeroFinal" class="form-control" name="numeroFinal"></div><div class="col-md-5"><label for="observacoes">Observa\xE7\xF5es</label><textarea id="observacoes" ng-disabled="true" type="text" ng-model="aidfe.observacao" class="form-control" name="observacoes">\n                        </div>\n                    </div>\n\n                    <div class="form-group">\n                        <div class="col-md-3">\n                            <label for="quantidade">Quantidade Deferida</label>\n                            <input id="quantidadeDeferida" type="text" class="form-control" name="quantidadeDeferida" min="1" ng-blur="calcularNumeroNFSE()" ng-model="aidfe.quantidadeDeferida">\n                        </div>\n                        <div class="col-md-9">\n                            <label for="observacoesDeferimento">Observa\xE7\xF5es do Deferimento</label>\n                                <textarea id="observacoesDeferimento" type="text" ng-model="aidfe.observacaoDeferimento" class="form-control" name="observacoesDeferimento">\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <button type="submit" ng-click="deferir()" class="btn btn-success">\n                <span class="glyphicon glyphicon-check"></span>&nbsp;\n                <span>Defefir</span>\n            </button>\n            <button type="submit" ng-click="deferirParcialmente()" class="btn btn-warning">\n                <span class="glyphicon glyphicon-check"></span>&nbsp;\n                <span>Deferir Parcialmente</span>\n            </button>\n            <button type="submit" ng-click="indeferir()" class="btn btn-danger">\n                <span class="glyphicon glyphicon-alert"></span>&nbsp;\n                <span>Indeferir</span></button></div></form></div>');
$templateCache.put('app/entities/aidfe/aidfe-detail.html','<div class="row"><div class="col-lg-12"><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="save()"><div class="form-group"><div class="col-md-3"><label for="quantidade">Quantidade Solicitada de NFS-e</label><input id="quantidade" type="number" ng-disabled="true" class="form-control" name="quantidade" min="1" ng-model="aidfe.quantidade"></div><div class="col-md-3"><label for="quantidade">Quantidade Deferida de NFS-e</label><input id="quantidadeDeferida" type="number" ng-disabled="true" class="form-control" name="quantidadeDeferida" min="1" ng-model="aidfe.quantidadeDeferida"></div><div class="col-md-2"><label for="numeroInicial">NFS-e Inicial</label><input id="numeroInicial" type="text" ng-disabled="true" ng-model="aidfe.numeroInicial" class="form-control" name="numeroInicial"></div><div class="col-md-2"><label for="numeroFinal">NFS-e Final</label><input id="numeroFinal" type="text" ng-disabled="true" ng-model="aidfe.numeroFinal" class="form-control" name="numeroFinal"></div></div><div class="form-group"><div class="col-md-12"><label for="observacoes">Observa\xE7\xF5es</label><textarea type="text" ng-model="aidfe.observacao" class="form-control" name="observacoes" id="observacoes" ng-disabled="true">\n                </div>\n            </div>\n            <div class="form-group">\n\n                <div class="col-md-12">\n                    <label for="observacoes">Observa\xE7\xF5es do Deferimento</label>\n                    <textarea type="text" ng-model="aidfe.observacaoDeferimento" class="form-control" name="observacaoDeferimento" id="observacaoDeferimento" ng-disabled="true">\n                </div>\n\n                <div class="col-md-12 m-t-md">\n                    <button type="button" class="btn btn-default" data-dismiss="modal" ui-sref="aidfe">\n                        <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button></div></div></form></div></div>');
$templateCache.put('app/entities/aidfe/aidfe-edit.html','<div class="row"><div class="col-lg-12"><form name="editForm" class="form-horizontal" role="form" novalidate><div class="form-group"><div class="col-md-3"><label for="quantidade">Quantidade Solicitada de NFS-e</label><input id="quantidade" type="number" class="form-control" name="quantidade" min="1" ng-blur="calcularNumeroNFSE()" ng-model="aidfe.quantidade"></div><div class="col-md-2"><label for="numeroInicial">NFS-e Inicial</label><input id="numeroInicial" type="text" ng-disabled="true" ng-model="aidfe.numeroInicial" class="form-control" name="numeroInicial"></div><div class="col-md-2"><label for="numeroFinal">NFS-e Final</label><input id="numeroFinal" type="text" ng-disabled="true" ng-model="aidfe.numeroFinal" class="form-control" name="numeroFinal"></div></div><div class="form-group"><div class="col-md-12"><label for="observacoes">NFS-e Observa\xE7\xF5es</label><textarea type="text" ng-model="aidfe.observacao" class="form-control" id="observacoes" name="observacoes" maxlength="3000">\n                    <span>{{3000 - aidfe.observacao.length}}</span>\n                </div>\n            </div>\n\n            <div class="form-group">\n                <div class="col-md-12">\n                    <button type="button" class="btn btn-default" data-dismiss="modal" ui-sref="aidfe">\n                        <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span>\n                    </button>\n\n                    <button type="submit" ng-click="save()" class="btn btn-success">\n                        <span class="glyphicon glyphicon-check"></span>&nbsp;\n                        <span>Solicitar</span></button></div></div></form></div></div>');
$templateCache.put('app/entities/aidfe/aidfe-search.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title" id="myServicoLabel" translate="nfseApp.adife.home.title">Create or edit a AIDF-e</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><div class="form-group input-group"><input type="text" class="form-control" ng-model="searchQuery" id="searchQuery" placeholder="{{\'global.form.search\' | translate}}"> <span class="input-group-btn"><button class="btn btn-info" ng-click="search()"><span class="glyphicon glyphicon-search"></span></button></span></div></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th>N\xFAmero</th><th>Solicitado em</th><th>QTD Solicitada</th><th>QTD Deferida</th><th>Deferido em</th><th>Numero Inicial</th><th>Numero Final</th><th>Situa\xE7\xE3o</th><th></th></tr></thead><tbody><tr ng-repeat="aidfe in aidfes"><td>{{aidfe.numero}}</td><td>{{aidfe.solicitadoEm |date:\'dd/MM/yyyy HH:mm\' }}</td><td>{{aidfe.quantidade}}</td><td>{{aidfe.quantidadeDeferida}}</td><td>{{aidfe.deferidoEm |date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{aidfe.numeroInicial}}</td><td>{{aidfe.numeroFinal}}</td><td>{{aidfe.situacaoAIDFE}}</td><td class="pull-right"><button type="submit" ng-click="ok(adife)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-check"></span></button></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/aidfe/aidfes-list-analise.html','<div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><span translate="nfseApp.aidfe.home.title">Form</span></div><div class="ibox-content"><tabset><tab ng-repeat="situacao in situacoes" ng-click="loadAll(situacao)"><tab-heading ng-class="classTab(situacao)"><span>{{situacao}}</span></tab-heading><div class="row"><div class="col-md-8"><search-box ng-model="searchQuery" search-method="search(searchQuery,situacao)"></search-box></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th>N\xFAmero</th><th>Solicitado Em</th><th>Qtde Solicitada</th><th>Qtde Deferida</th><th>Deferido Em</th><th>NFS-e Inicial</th><th>NFS-e Final</th><th>Empresa</th><th>CPF/CNPJ</th><th ng-if="situacao == \'AGUARDANDO\'">Op\xE7\xF5es</th></tr></thead><tbody><tr ng-repeat="aidfe in aidfes"><td>{{aidfe.numero}}</td><td>{{aidfe.solicitadoEm | date: \'dd/MM/yyyy\'}}</td><td>{{aidfe.quantidade}}</td><td>{{aidfe.quantidadeDeferida}}</td><td>{{aidfe.deferidoEm | date: \'dd/MM/yyyy\'}}</td><td>{{aidfe.numeroInicial}}</td><td>{{aidfe.numeroFinal}}</td><td>{{aidfe.prestadorServicos.pessoa.dadosPessoais.nomeRazaoSocial}}</td><td>{{aidfe.prestadorServicos.pessoa.dadosPessoais.cpfCnpj}}</td><td ng-if="!aidfe.deferidoEm"><div class="pull-right"><button type="submit" ui-sref="aidfe.analise({id:aidfe.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon glyphicon-check"></span></button></div></td></tr></tbody></table><span nfse-app-pagination></div></tab></tabset></div></div></div></div>');
$templateCache.put('app/entities/aidfe/aidfes.html','<div class="row"><div class="col-lg-12"><div class="row"><div class="col-md-8"><search-box ng-model="searchQuery" search-method="loadAll()"></search-box></div><div class="col-md-4"><button class="btn btn-primary pull-right" ui-sref="aidfe.new"><span class="fa fa-plus"></span> <span translate="nfseApp.aidfe.home.createLabel">Create a new Tomador</span></button></div></div><div class="table-responsive"><table class="table table-striped small"><thead><tr><th>N\xFAmero</th><th>Solicitado em</th><th>QTD Solicitada</th><th>QTD Deferida</th><th>Deferido em</th><th>Situa\xE7\xE3o</th><th></th></tr></thead><tbody><tr ng-repeat="aidfe in aidfes"><td>{{aidfe.numero}}</td><td>{{aidfe.solicitadoEm |date:\'dd/MM/yyyy HH:mm\' }}</td><td>{{aidfe.quantidade}}</td><td>{{aidfe.quantidadeDeferida}}</td><td>{{aidfe.deferidoEm |date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{aidfe.situacaoAIDFE}}</td><td><div class="pull-right"><button type="submit" ui-sref="aidfe.detail({id:aidfe.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ng-show="!aidfe.deferidoEm" ui-sref="aidfe.edit({id:aidfe.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ng-show="!aidfe.deferidoEm" ng-click="delete(aidfe.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table><span nfse-app-pagination></div></div></div>');
$templateCache.put('app/entities/arquivo-desif/arquivo-desif-detail.html','<div class="ibox float-e-margins animated fadeInDown"><div class="ibox-content"><div class="alert alert-success text-center" ng-show="arquivo.situacao == \'PROCESSADO\'"><strong>Informa\xE7\xE3o</strong><br>O Arquivo foi processado com sucesso.</div><div class="alert alert-info text-center" ng-show="arquivo.situacao == \'EM_PROCESSAMENTO\'"><strong>Informa\xE7\xE3o</strong><br>O Arquivo est\xE1 sendo processado e a tela ser\xE1 atualizada automaticamente.</div><div class="alert alert-danger text-center" ng-show="arquivo.situacao == \'INCONSISTENTE\'"><strong>Erro</strong><br>Ocorreu um erro no processamento do arquivo. Por favor entre em contato com o suporte.</div><div class="row"><div class="col-md-2"><label>Enviado em</label><input class="form-control" value="{{arquivo.enviadoEm | date: \'dd/MM/yyyy\'}}" disabled="disabled"></div><div class="col-md-4"><label>M\xF3dulo</label><input class="form-control" value="{{\'nfseApp.ModuloArquivoDesif.\' + arquivo.modulo | translate}}" disabled="disabled"></div><div class="col-md-2"><label>Tipo</label><input class="form-control" value="{{\'nfseApp.TipoArquivoDesif.\' + arquivo.tipo | translate}}" disabled="disabled"></div><div class="col-md-2"><label>Situa\xE7\xE3o</label><input class="form-control" value="{{\'nfseApp.SituacaoArquivoDesif.\' + arquivo.situacao | translate}}" disabled="disabled"></div><div class="col-md-2"><label>Protocolo</label><input class="form-control" value="{{arquivo.protocolo}}" disabled="disabled"></div></div><div class="row m-t-md"><div class="col-md-2"><label>Compet\xEAncia</label><input class="form-control" value="{{arquivo.inicioCompetencia | date: \'MM/yyyy\' : \'+0000\'}} - {{arquivo.fimCompetencia | date: \'MM/yyyy\': \'+0000\'}}" disabled="disabled"></div><div class="col-md-4"><label>Tipo de Institui\xE7\xE3o</label><input class="form-control" value="{{arquivo.tipoInstituicaoFinanceira.codigo}} - {{arquivo.tipoInstituicaoFinanceira.descricao}}" disabled="disabled"></div><div class="col-md-2"><label>Tipo de Consolida\xE7\xE3o</label><input class="form-control" value="{{\'nfseApp.TipoConsolidacaoArquivoDesif.\' + arquivo.tipoConsolidacao | translate}}" disabled="disabled"></div><div class="col-md-2"><label>Tipo de Arredondamento</label><input class="form-control" value="{{\'nfseApp.TipoArredondamentoArquivoDesif.\' + arquivo.tipoArredondamento | translate}}" disabled="disabled"></div></div><ul class="nav nav-tabs m-t-md"><li ng-if="arquivo.modulo == \'MODULO_3\'"><a class="nav-link {{activeTab == 0 ? \'active\' : \'\'}}" ng-click="mudarActiveTab(0)">Plano Geral de Contas Comentado \u2013 PGCC</a></li><li ng-if="arquivo.modulo == \'MODULO_3\'"><a class="nav-link {{activeTab == 1 ? \'active\' : \'\'}}" ng-click="mudarActiveTab(1)">Tarifas Banc\xE1rias</a></li><li ng-if="arquivo.modulo == \'MODULO_3\'"><a class="nav-link {{activeTab == 2 ? \'active\' : \'\'}}" ng-click="mudarActiveTab(2)">Identifica\xE7\xE3o de Outros Produtos e Servi\xE7os</a></li><li ng-if="arquivo.modulo == \'MODULO_1\' || arquivo.modulo == \'MODULO_2\'"><a class="nav-link {{activeTab == 3 ? \'active\' : \'\'}}" ng-click="mudarActiveTab(3)">Identifica\xE7\xE3o da Depend\xEAncia</a></li><li ng-if="arquivo.modulo == \'MODULO_1\'"><a class="nav-link {{activeTab == 4 ? \'active\' : \'\'}}" ng-click="mudarActiveTab(4)">Balancete Anal\xEDtico Mensal</a></li><li ng-if="arquivo.modulo == \'MODULO_2\'"><a class="nav-link {{activeTab == 5 ? \'active\' : \'\'}}" ng-click="mudarActiveTab(5)">Demonstrativo da apura\xE7\xE3o da receita tribut\xE1vel e do ISSQN mensal por Subt\xEDtulo</a></li><li ng-if="arquivo.modulo == \'MODULO_2\'"><a class="nav-link {{activeTab == 6 ? \'active\' : \'\'}}" ng-click="mudarActiveTab(6)">Demonstrativo do ISSQN mensal a recolher</a></li><li ng-if="arquivo.modulo == \'MODULO_1\' || arquivo.modulo == \'MODULO_4\'"><a class="nav-link {{activeTab == 7 ? \'active\' : \'\'}}" ng-click="mudarActiveTab(7)">Demonstrativo das Partidas dos Lan\xE7amentos Cont\xE1beis</a></li></ul><div class="tabs-container"><div class="tab-content"><div role="tabpanel" id="tab-0" class="tab-pane {{activeTab == 0 ? \'active\' : \'\'}}" ng-if="arquivo.modulo == \'MODULO_3\'"><div class="col-lg-12"><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th>Conta</th><th>Desdobramento</th><th>Nome</th></tr></thead><tbody><tr ng-repeat="registro0100 in consultaRegistro0100.list"><td>{{registro0100.conta}}</td><td>{{registro0100.desdobramento}}</td><td>{{registro0100.nome}}</td></tr></tbody></table><div class="text-center"><pagination boundary-links="true" total-items="consultaRegistro0100.per_page * consultaRegistro0100.links.last" ng-model="consultaRegistro0100.page" max-size="consultaRegistro0100.per_page" items-per-page="consultaRegistro0100.per_page" ng-change="loadPageRegistros0100(consultaRegistro0100.page)" class="pagination-sm" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></pagination></div></div></div></div><div role="tabpanel" id="tab-1" class="tab-pane {{activeTab == 1 ? \'active\' : \'\'}}" ng-if="arquivo.modulo == \'MODULO_3\'"><div class="col-lg-12"><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th>Conta</th><th>Desdobramento</th><th>Tarifa Banc\xE1ria</th><th>In\xEDcio de Vig\xEAncia</th></tr></thead><tbody><tr ng-repeat="registro0200 in consultaRegistro0200.list"><td>{{registro0200.conta}}</td><td>{{registro0200.desdobramento}}</td><td>{{registro0200.tarifaBancaria.codigo}} - {{registro0200.tarifaBancaria.descricao}}</td><td>{{registro0200.inicioVigencia | date: \'dd/MM/yyyy\': \'+0000\'}}</td></tr></tbody></table><div class="text-center"><pagination boundary-links="true" total-items="consultaRegistro0200.per_page * consultaRegistro0200.links.last" ng-model="consultaRegistro0200.page" max-size="consultaRegistro0200.per_page" items-per-page="consultaRegistro0200.per_page" ng-change="loadPageRegistros0200(consultaRegistro0200.page)" class="pagination-sm" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></pagination></div></div></div></div><div role="tabpanel" id="tab-2" class="tab-pane {{activeTab == 2 ? \'active\' : \'\'}}" ng-if="arquivo.modulo == \'MODULO_3\'"><div class="col-lg-12"><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th>Conta</th><th>Desdobramento</th><th>Produto/Servi\xE7o</th></tr></thead><tbody><tr ng-repeat="registro0300 in consultaRegistro0300.list"><td>{{registro0300.conta}}</td><td>{{registro0300.desdobramento}}</td><td>{{registro0300.produtoServicoBancario.codigo}} - {{registro0300.produtoServicoBancario.descricao}}</td></tr></tbody></table><div class="text-center"><pagination boundary-links="true" total-items="consultaRegistro0300.per_page * consultaRegistro0300.links.last" ng-model="consultaRegistro0300.page" max-size="consultaRegistro0300.per_page" items-per-page="consultaRegistro0300.per_page" ng-change="loadPageRegistros0300(consultaRegistro0300.page)" class="pagination-sm" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></pagination></div></div></div></div><div role="tabpanel" id="tab-3" class="tab-pane {{activeTab == 3 ? \'active\' : \'\'}}" ng-if="arquivo.modulo == \'MODULO_1\' || arquivo.modulo == \'MODULO_2\'"><div class="col-lg-12"><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th>C\xF3digo Depend\xEAncia</th><th>Identifica\xE7\xE3o</th><th>CNPJ Pr\xF3prio</th><th>Tipo Depend\xEAncia</th><th>CNPJ Respons\xE1vel</th></tr></thead><tbody><tr ng-repeat="registro0400 in consultaRegistro0400.list"><td>{{registro0400.codigoDependencia}}</td><td>{{\'nfseApp.IdentificacaoDependenciaDesif.\' + registro0400.identificacaoDependencia | translate}}</td><td>{{registro0400.cnpjProprio}}</td><td>{{registro0400.tipoDependencia.codigo}} - {{registro0400.tipoDependencia.descricao}}</td><td>{{registro0400.cnpjResponsavel}}</td></tr></tbody></table><div class="text-center"><pagination boundary-links="true" total-items="consultaRegistro0400.per_page * consultaRegistro0400.links.last" ng-model="consultaRegistro0400.page" max-size="consultaRegistro0400.per_page" items-per-page="consultaRegistro0400.per_page" ng-change="loadPageRegistros0400(consultaRegistro0400.page)" class="pagination-sm" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></pagination></div></div></div></div><div role="tabpanel" id="tab-4" class="tab-pane {{activeTab == 4 ? \'active\' : \'\'}}" ng-if="arquivo.modulo == \'MODULO_1\'"><div class="col-lg-12"><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th>C\xF3digo da Depend\xEAncia</th><th>Compet\xEAncia</th><th>Conta</th><th>Desdobramento</th><th>Saldo Inicial</th><th>Valor D\xE9bito</th><th>Valor Cr\xE9dito</th><th>Saldo Final</th></tr></thead><tbody><tr ng-repeat="registro0410 in consultaRegistro0410.list"><td>{{registro0410.codigoDependencia}}</td><td>{{registro0410.competencia | date: \'MM/yyyy\'}}</td><td>{{registro0410.conta.conta}}</td><td>{{registro0410.conta.desdobramento}}</td><td>{{registro0410.saldoInicial | currency: \'R$ \'}}</td><td>{{registro0410.valorDebito | currency: \'R$ \'}}</td><td>{{registro0410.valorCredito | currency: \'R$ \'}}</td><td>{{registro0410.saldoFinal | currency: \'R$ \'}}</td></tr></tbody></table><div class="text-center"><pagination boundary-links="true" total-items="consultaRegistro0410.per_page * consultaRegistro0410.links.last" ng-model="consultaRegistro0410.page" max-size="consultaRegistro0410.per_page" items-per-page="consultaRegistro0410.per_page" ng-change="loadPageRegistros0410(consultaRegistro0410.page)" class="pagination-sm" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></pagination></div></div></div></div><div role="tabpanel" id="tab-5" class="tab-pane {{activeTab == 5 ? \'active\' : \'\'}}" ng-if="arquivo.modulo == \'MODULO_2\'"><div class="col-lg-12"><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th>C\xF3digo da Depend\xEAncia</th><th>Conta</th><th>Desdobramento</th><th>Valor Cr\xE9dito</th><th>Valor D\xE9bito</th><th>Valor Receita Tribut\xE1vel</th><th>Base de C\xE1lculo</th><th>Al\xEDquota</th><th>Valor ISSQN Retido</th></tr></thead><tbody><tr ng-repeat="registro0430 in consultaRegistro0430.list"><td>{{registro0430.codigoDependencia}}</td><td>{{registro0430.conta.conta}}</td><td>{{registro0430.conta.desdobramento}}</td><td>{{registro0430.valorCredito | currency: \'R$ \'}}</td><td>{{registro0430.valorDebito | currency: \'R$ \'}}</td><td>{{registro0430.valorReceitaTributavel | currency: \'R$ \'}}</td><td>{{registro0430.baseCalculo | currency: \'R$ \'}}</td><td>{{registro0430.aliquota | currency: \'% \'}}</td><td>{{registro0430.valorIssqnRetido | currency: \'R$ \'}}</td></tr></tbody></table><div class="text-center"><pagination boundary-links="true" total-items="consultaRegistro0430.per_page * consultaRegistro0430.links.last" ng-model="consultaRegistro0430.page" max-size="consultaRegistro0430.per_page" items-per-page="consultaRegistro0430.per_page" ng-change="loadPageRegistros0430(consultaRegistro0430.page)" class="pagination-sm" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></pagination></div></div></div></div><div role="tabpanel" id="tab-6" class="tab-pane {{activeTab == 6 ? \'active\' : \'\'}}" ng-if="arquivo.modulo == \'MODULO_2\'"><div class="col-lg-12"><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th>CNPJ Depend\xEAncia</th><th>C\xF3digo de Tributa\xE7\xE3o</th><th>Valor Receita Tribut\xE1vel</th><th>Base de C\xE1lculo</th><th>Al\xEDquota</th><th>Valor ISSQN Devido</th><th>Valor ISSQN Retido</th><th>Valor Compensa\xE7\xE3o</th><th>Valor ISSQN Recolhido</th><th>Valor ISSQN a Recolher</th></tr></thead><tbody><tr ng-repeat="registro0440 in consultaRegistro0440.list"><td>{{registro0440.cnpjDependencia}}</td><td>{{registro0440.codigoTributacao.codigo}} - {{registro0440.codigoTributacao.descricao}}</td><td>{{registro0440.valorReceitaTributavel | currency: \'R$ \'}}</td><td>{{registro0440.baseCalculo | currency: \'R$ \'}}</td><td>{{registro0440.aliquota | currency: \'% \'}}</td><td>{{registro0440.valorIssqn | currency: \'R$ \'}}</td><td>{{registro0440.valorIssqnRetido | currency: \'R$ \'}}</td><td>{{registro0440.valorCompensacao | currency: \'R$ \'}}</td><td>{{registro0440.valorIssqnRecolhido | currency: \'R$ \'}}</td><td>{{registro0440.valorIssqnRecolher | currency: \'R$ \'}}</td></tr></tbody></table><div class="text-center"><pagination boundary-links="true" total-items="consultaRegistro0430.per_page * consultaRegistro0430.links.last" ng-model="consultaRegistro0430.page" max-size="consultaRegistro0430.per_page" items-per-page="consultaRegistro0430.per_page" ng-change="loadPageRegistros0430(consultaRegistro0430.page)" class="pagination-sm" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></pagination></div></div></div></div><div role="tabpanel" id="tab-7" class="tab-pane {{activeTab == 7 ? \'active\' : \'\'}}" ng-if="arquivo.modulo == \'MODULO_1\' || arquivo.modulo == \'MODULO_4\'"><div class="col-lg-12"><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th>CNPJ Contabiliza\xE7\xE3o</th><th>N\xFAmero</th><th>Data</th><th>Valor da Partida</th><th>Conta</th><th>Tipo Partida</th></tr></thead><tbody><tr ng-repeat="registro1000 in consultaRegistro1000.list"><td>{{registro1000.cnpj}}</td><td>{{registro1000.numeroLancamento}}</td><td>{{registro1000.dataLancamento | date: \'dd/MM/yyyy\' : \'+0000\'}}</td><td>{{registro1000.valorPartidaLancamento | currency: \'R$ \'}}</td><td>{{registro1000.conta}}</td><td>{{\'nfseApp.TipoPartidaArquivoDesif.\' + registro1000.tipoPartida | translate}}</td></tr></tbody></table><div class="text-center"><pagination boundary-links="true" total-items="consultaRegistro1000.per_page * consultaRegistro1000.links.last" ng-model="consultaRegistro1000.page" max-size="consultaRegistro1000.per_page" items-per-page="consultaRegistro1000.per_page" ng-change="loadPageRegistros1000(consultaRegistro1000.page)" class="pagination-sm" previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;" last-text="&raquo;"></pagination></div></div></div></div></div></div><div class="row m-t-lg"><div class="col-md-12"><button type="button" class="btn btn-success" ng-click="enviar()" ng-show="arquivo.situacao == \'AGUARDANDO\'"><span class="glyphicon glyphicon-send"></span>&nbsp; <span>Enviar</span></button> <button type="button" ui-sref="arquivoDesif" class="btn btn-default"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span>Voltar</span></button> <button type="button" class="btn btn-danger" ng-click="excluir()" ng-show="arquivo.situacao == \'AGUARDANDO\' || arquivo.situacao == \'INCONSISTENTE\'"><span class="glyphicon glyphicon-trash"></span>&nbsp; <span>Excluir</span></button> <button class="btn btn-info" ng-if="arquivo.idDeclaracaoMensalServico" title="Imprimir Guia" ng-click="imprimirGuia()"><span class="fa fa-print"></span> Imprimir Guia</button> <button class="btn btn-info" ng-if="arquivo.situacao == \'PROCESSADO\'" title="Imprimir Recibo" ng-click="imprimirRecibo()"><span class="fa fa-print"></span> Imprimir Recibo</button></div></div></div></div>');
$templateCache.put('app/entities/arquivo-desif/arquivo-desif-validate.html','<div class="row"><div class="col-lg-12"><form name="editForm" class="form-horizontal" role="form" novalidate><div class="ibox float-e-margins animated fadeInDown"><div class="ibox-content"><div class="row m-t-md"><div class="col-md-12 text-center"><label>Arquivo para Importa\xE7\xE3o<span class="text-danger">*</span></label><label for="file-upload" class="custom-file-upload"><span class="fa fa-cloud-upload"></span>Selecionar Arquivo</label><input type="file" id="file-upload" ngf-select="uploadFile($file)" ngf-max-size="15MB"><label>{{fileName}}</label></div></div><div class="row m-t-md" ng-if="importacao.validacoes && importacao.validacoes.length > 0"><div class="col-md-12"><table class="table table-striped table-hover table-condensed"><thead><tr><th colspan="5" class="text-center">Erros/Alertas da valida\xE7\xE3o do arquivo da DES-IF</th></tr><tr><th>Erro/Alerta</th><th>Mensagem</th></tr></thead><tbody><tr ng-repeat="validacao in importacao.validacoes"><td>{{validacao.tipoValidacao}}</td><td>{{validacao.mensagem}}</td></tr></tbody></table></div></div><div class="row m-t-md"><div class="col-md-12"><button type="button" class="btn btn-primary" ng-disabled="disableValidarArquivo()" ng-click="validarImportacaoDesif()"><span class="glyphicon glyphicon-check"></span>&nbsp; <span>Validar</span></button> <button type="button" class="btn btn-danger" ui-sref="arquivoDesif"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span>Cancelar</span></button></div></div></div></div></form></div></div>');
$templateCache.put('app/entities/arquivo-desif/arquivo-desif.html','<div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><div class="row"><div class="col-md-12"><div class="panel panel-default"><div class="panel-heading">Op\xE7\xF5es de Filtros</div><div class="panel-body"><div class="row"><div class="form-group col-md-3"><label>M\xF3dulo</label><select class="form-control" ng-model="filtro.modulo" ng-options="modulo as \'nfseApp.ModuloArquivoDesif.\' + modulo.name | translate for modulo in modulos track by modulo.value"></select></div><div class="form-group col-md-3"><label>Situa\xE7\xE3o</label><select class="form-control" ng-model="filtro.situacao" ng-options="situacao as \'nfseApp.SituacaoArquivoDesif.\' + situacao.name | translate for situacao in situacoes track by situacao.value"></select></div></div><div class="row m-t-md"><div class="col-md-4"><button class="btn btn-primary" ng-click="loadAll()"><span class="fa fa-search"></span> <span>Pesquisar</span></button> <button class="btn btn-default" ng-click="filtro = {}"><span class="fa fa-close"></span> <span>Limpar Filtros</span></button></div><div class="col-md-offset-5 col-md-3"><button class="btn btn-primary btn-block" ui-sref="arquivoDesif.validar"><span class="fa fa-plus"></span> <span>Importar DES-IF</span></button></div></div></div></div></div></div></div><div class="ibox-content"><div class="row"><div class="col-md-12"><span nfse-app-pagination></span><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th>Op\xE7\xF5es</th><th>Enviado em</th><th>M\xF3dulo</th><th>Situa\xE7\xE3o</th><th>Compet\xEAncia</th><th>Tipo</th><th>Protocolo</th></tr></thead><tbody><tr ng-repeat="arquivo in arquivos"><td><button class="btn btn-sm btn-info" ui-sref="arquivoDesif.detalhe({id: arquivo.id})"><i class="fa fa-eye"></i></button></td><td>{{arquivo.enviadoEm | date:\'dd/MM/yyyy\'}}</td><td>{{\'nfseApp.ModuloArquivoDesif.\' + arquivo.modulo | translate}}</td><td>{{\'nfseApp.SituacaoArquivoDesif.\' + arquivo.situacao | translate}}</td><td>{{arquivo.inicioCompetencia | date:\'MM/yyyy\'}} - {{arquivo.fimCompetencia | date:\'MM/yyyy\'}}</td><td>{{\'nfseApp.TipoArquivoDesif.\' + arquivo.tipo | translate}}</td><td>{{arquivo.protocolo}}</td></tr></tbody></table></div><span nfse-app-pagination></span></div></div></div></div></div></div>');
$templateCache.put('app/entities/aviso-sistema/avisos-sistema.html','<div class="modal-header"><h4 class="modal-title">Aviso(s) Importante(s)!</h4></div><div class="modal-body"><div class="row" style="max-height: 300px; overflow-x: auto"><div class="col-md-12 m-t-md"><div ng-bind-html="trustAsHtml(aviso.mensagem)"></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="continuar()"><span class="glyphicon {{avisos.length == 0 ? \'glyphicon-check\': \'glyphicon-arrow-right\'}}"></span>&nbsp; <span>{{avisos.length == 0 ? \'Fechar\': \'Pr\xF3ximo\'}}</span></button></div>');
$templateCache.put('app/entities/bloqueio-emissao-nfse/bloqueio-emissao-nfse.html','<div class="modal-header"><h4 class="modal-title">Bloqueio de Emiss\xE3o de NFS-e</h4></div><div class="modal-body"><div class="row" style="max-height: 300px; overflow-x: auto"><div class="col-md-12 m-t-md"><div ng-bind-html="trustAsHtml(bloqueio.mensagem)"></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-info" data-dismiss="modal" ng-click="fechar()"><span class="glyphicon glyphicon-check"></span>&nbsp; <span>Fechar</span></button></div>');
$templateCache.put('app/entities/cadastro-economico-dlg/cadastro-economico-dlg.html','<div class="modal-header"><h4 class="modal-title">Existe mais de um Cadastro Econ\xF4mico ativo para esse CPF ou CNPJ</h4></div><div class="modal-body"><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Inscri\xE7\xE3o Municipal</th><th>CNPJ</th><th>Nome</th><th>Substituto Tribut\xE1rio</th><th></th></tr></thead><tbody><tr ng-repeat="cadastroEconomico in cadastrosEconomico"><td>{{cadastroEconomico.inscricaoMunicipal}}</td><td>{{cadastroEconomico.pessoa.dadosPessoais.cpfCnpj}}</td><td>{{cadastroEconomico.pessoa.dadosPessoais.nomeRazaoSocial}}</td><td>{{cadastroEconomico.enquadramentoFiscal.substitutoTributario ? \'Sim\': \'N\xE3o\'}}</td><td class="pull-right"><button type="submit" ng-click="ok(cadastroEconomico)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-check"></span></button></td></tr></tbody></table></div><span nfse-app-pagination></div>');
$templateCache.put('app/entities/cadastro-imobiliario/cadastro-imobiliario-search.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title" id="myServicoLabel">Pesquisa de Cadastro Imobili\xE1rio</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><div class="form-group input-group"><input type="text" class="form-control" name="searchQuery" ng-enter="search()" ng-model="searchQuery" id="searchQuery" placeholder="Pesquisar ..."> <span class="input-group-btn"><button class="btn btn-info" type="button" ng-click="search()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Inscri\xE7\xE3o Cadastral</th><th>Propriet\xE1rio(s)</th><th>Bairro</th><th>Logradouro</th><th>N\xFAmero</th><th></th></tr></thead><tbody><tr ng-repeat="cadastro in cadastros"><td>{{cadastro.inscricaoCadastral}}</td><td>{{cadastro.proprietarios}}</td><td>{{cadastro.bairro}}</td><td>{{cadastro.logradouro}}</td><td>{{cadastro.numero}}</td><td class="pull-right"><button type="submit" ng-click="ok(cadastro)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-check"></span></button></td></tr></tbody></table></div><span nfse-app-pagination></div>');
$templateCache.put('app/entities/cnae/cnae-detail.html','<div><h2><span translate="nfseApp.cnae.detail.title">Cnae</span> {{cnae.id}}</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span translate="nfseApp.cnae.codigo">Codigo</span></td><td><input type="text" class="input-sm form-control" value="{{cnae.codigo}}" readonly="readonly"></td></tr><tr><td><span translate="nfseApp.cnae.descricao">Descricao</span></td><td><input type="text" class="input-sm form-control" value="{{cnae.descricao}}" readonly="readonly"></td></tr><tr><td><span translate="nfseApp.cnae.ativo">Ativo</span></td><td><input type="text" class="input-sm form-control" value="{{cnae.ativo}}" readonly="readonly"></td></tr></tbody></table></div><button type="submit" ui-sref="cnae" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/entities/cnae/cnae-dialog.html','<div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h4 class="modal-title" id="cnaeLabel" translate="nfseApp.cnae.home.createOrEditLabel">Criar ou Editar o CNAE</h4></div><div class="ibox-content"><form name="editForm" role="form" novalidate ng-submit="save()" show-validation><!--<div class="form-group">--><div class="col-md-6"><div class="form-group"><label class="center-block" translate="nfseApp.cnae.codigo" for="field_codigo">Codigo</label><input type="text" class="form-control" name="codigo" id="field_codigo" ng-model="cnae.codigo" required><div ng-show="editForm.codigo.$invalid"><p class="help-block" ng-show="editForm.codigo.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-md-6"><div class="form-group"><label translate="nfseApp.cnae.ativo" for="field_ativo">Ativo</label><!--<input type="checkbox" class="form-control" name="ativo" id="field_ativo"\n                                   ng-model="cnae.ativo">--><div class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="ativo" ng-model="cnae.ativo" class="onoffswitch-checkbox" id="field_ativo"><label class="onoffswitch-label" for="field_ativo"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div></div><div class="col-md-12"><div class="form-group"><label translate="nfseApp.cnae.descricao" for="field_descricao">Descricao</label><textarea type="text" class="form-control" name="descricao" id="field_descricao" ng-model="cnae.descricao" required>\n                            </textarea><div ng-show="editForm.descricao.$invalid"><p class="help-block" ng-show="editForm.descricao.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><!--</div>--><div class="form-actions"><button type="button" class="btn btn-default" ui-sref="cnae"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form></div></div></div></div>');
$templateCache.put('app/entities/cnae/cnaes-search.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title" id="myCnaeLabel" translate="nfseApp.cnae.home.title">Create or edit a ConstrucaoCivil</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><search-box ng-model="searchQuery" search-method="search()"></search-box></div></div><div class="row"><div class="col-md-12"><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="nfseApp.cnae.codigo">Coddfsdfsdfigo</th><th translate="nfseApp.cnae.descricao">Descricao</th><th translate="nfseApp.cnae.ativo">Ativo</th><th></th></tr></thead><tbody><tr ng-repeat="cnae in cnaes"><td>{{cnae.codigo}}</td><td>{{cnae.descricao}}</td><td>{{cnae.ativo ? \'Sim\' : \'N\xE3o\'}}</td><td class="pull-right"><button type="submit" ng-click="ok(cnae)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-check"></span></button></td></tr></tbody></table></div><span nfse-app-pagination></div></div></div>');
$templateCache.put('app/entities/cnae/cnaes.html','<div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><span translate="nfseApp.cnae.home.title">Form</span></div><div class="ibox-content"><div class="row"><div class="col-md-8"><search-box ng-model="searchQuery" search-method="search()"></search-box></div><div class="col-md-4"><button class="btn btn-primary pull-right" ui-sref="cnae.new"><span class="fa fa-plus"></span> <span translate="nfseApp.cnae.home.createLabel">Create a new Cnae</span></button></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th>C\xF3digo</th><th>Descri\xE7\xE3o</th><th>Ativo</th><th></th></tr></thead><tbody><tr ng-repeat="cnae in cnaes"><td><a ui-sref="cnae.detail({id:cnae.id})">{{cnae.codigo}}</a></td><td>{{cnae.descricao}}</td><td>{{cnae.ativo ? \'Sim\' : \'N\xE3o\'}}</td><td style="min-width: 15%"><div class="pull-right"><button type="submit" ui-sref="cnae.detail({id:cnae.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="cnae.edit({id:cnae.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ng-click="delete(cnae.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table><nav><ul class="pager"><li ng-show="links[\'first\']" ng-click="loadPage(links[\'first\'])"><a href="#">&lt;&lt;</a></li><li ng-show="links[\'prev\']" ng-click="loadPage(links[\'prev\'])"><a href="#">&lt;</a></li><li ng-show="links[\'next\']" ng-click="loadPage(links[\'next\'])"><a href="#">&gt;</a></li><li ng-show="links[\'last\']" ng-click="loadPage(links[\'last\'])"><a href="#">&gt;&gt;</a></li></ul></nav></div></div></div></div></div>');
$templateCache.put('app/entities/codigo-tributacao/codigo-tributacao-search.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title">Pesquisa C\xF3digo de Tributa\xE7\xE3o</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><div class="panel panel-default"><div class="panel-heading">Op\xE7\xF5es de Filtros</div><div class="panel-body"><div class="row"><div class="col-md-12"><div class="form-group col-md-2"><label>C\xF3digo</label><input class="form-control" ng-model="filtro.codigo"></div><div class="form-group col-md-10"><label>Descri\xE7\xE3o</label><input class="form-control" ng-model="filtro.descricao"></div></div></div><div class="row"><div class="col-md-12"><div class="col-md-6"><button class="btn btn-primary" ng-click="loadAll()"><span class="fa fa-search"></span> <span>Pesquisar</span></button> <button class="btn btn-default" ng-click="filtro = {}"><span class="fa fa-close"></span> <span>Limpar Filtros</span></button></div></div></div></div></div></div></div><div class="row m-t-md"><div class="col-md-12"><span nfse-app-pagination></span><div class="table-responsive"><table class="table table-striped small"><thead><tr><th class="col-md-2">C\xF3digo</th><th>Descri\xE7\xE3o</th><th></th></tr></thead><tbody><tr ng-repeat="codigoTributacao in codigosTributacao"><td class="col-md-2">{{codigoTributacao.codigo}}</td><td>{{codigoTributacao.descricao}}</td><td class="pull-right"><button type="submit" ng-click="ok(codigoTributacao)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-check"></span></button></td></tr></tbody></table></div><span nfse-app-pagination></span></div></div></div>');
$templateCache.put('app/entities/configuracao/configuracao-detail.html','<div class="row"><form name="editForm" role="form" class="form-horizontal" novalidate ng-submit="save()"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h4 class="modal-title">Edi\xE7\xE3o das Configura\xE7\xF5es do Sistema</h4></div><div class="ibox-content"><div class="form-group"><div class="col-md-12"><label translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="configuracao.id" readonly="readonly"></div></div><div class="form-group"><div class="col-md-2"><label for="field_configuracao_codigo_municipio">Munic\xEDpio</label><div class="input-group"><input type="text" class="form-control" name="configuracaoMunicipio" id="field_configuracao_codigo_municipio" ng-blur="loadMunicipioByCodigo(configuracao.municipio.codigo,configuracao)" ng-model="configuracao.municipio.codigo"> <span class="input-group-btn"><button type="button" class="btn" ng-click="searchMunicipio(configuracao)"><span class="glyphicon glyphicon-search"></span></button></span></div></div><div class="col-md-7"><label for="field_configuracao_nome_municipio">Nome</label><input type="text" class="form-control" name="nome_configuracao_municipio" id="field_configuracao_nome_municipio" disabled="disabled" ng-model="configuracao.municipio.nome"></div><div class="col-md-3"><label for="field_configuracao_estado_municipio">Estado</label><input type="text" class="form-control" name="estado_configuracao_municipio" id="field_configuracao_estado_municipio" disabled="disabled" ng-model="configuracao.municipio.estado"></div></div><div class="form-group"><div class="col-md-3"><label>Verificar Aidf-e na gera\xE7\xE3o de NF-e</label><div class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="ativo" ng-model="configuracao.verificarAidfe" class="onoffswitch-checkbox" id="field_ativo"><label class="onoffswitch-label" for="field_ativo"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h4 class="modal-title">Integra\xE7\xE3o com o Sistema de Tributa\xE7\xE3o</h4></div><div class="ibox-content"><div class="form-group"><div class="col-md-12"><label for="field_configuracao_urlconexao">Url de Conex\xE3o</label><input type="text" class="form-control" name="urlConexao" id="field_configuracao_urlconexao" ng-model="configuracao.urlConexao" ng-blur="onBlurUrlConexao()" maxlength="255"></div></div><div class="form-group"><div class="col-md-4"><label for="field_configuracao_intervalointegracao">Intervalo para Integra\xE7\xE3o (em minutos)</label><input type="number" class="form-control" name="intervaloIntegracao" id="field_configuracao_intervalointegracao" ng-model="configuracao.intervaloIntegracao" ng-disabled="configuracao.urlConexao == undefined || configuracao.urlConexao == \'\'" ng-blur="onBlurIntervaloIntegracao()" ng-required="configuracao.urlConexao != undefined && configuracao.urlConexao != \'\'"><div ng-show="editForm.intervaloIntegracao.$invalid" class="has-error"><p class="help-block small has-error" ng-show="editForm.intervaloIntegracao.$error">Intervalo informado \xE9 invalido.</p></div></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h4 class="modal-title">Documentos Obrigat\xF3rios para Credenciamento</h4></div><div class="ibox-content"><div class="form-group"><div class="col-md-12"><label for="field_configuracao_descricao_documento_novo">Nome do Documento</label></div></div><div class="form-group" data-ng-repeat="documento in configuracao.documentosObrigatorios | orderBy: \'descricao\'"><div class="col-md-6"><input type="text" class="form-control" id="field_configuracao_descricao_documento" name="descricaoDocumento" ng-model="documento.descricao" min="2" maxlength="255" required></div><div class="col-md-2"><button class="btn btn-danger" type="button" ng-click="removerDocumentoObrigatorio(documento)"><span class="glyphicon glyphicon-trash"></span></button></div></div><div class="form-group"><div class="col-md-6"><input type="text" class="form-control" id="field_configuracao_descricao_documento_novo" name="descricaoDocumentoNovo" ng-model="documentoObrigatorio.descricao" ng-minlength="2" ng-maxlength="255" required></div><div class="col-md-2"><button class="btn btn-danger" type="button" ng-click="limparDescricao()"><span class="glyphicon glyphicon-trash"></span></button> <button class="btn btn-primary" type="button" ng-show="editForm.descricaoDocumentoNovo.$valid" ng-click="adicionarDocumentoObrigatorio()"><span class="glyphicon glyphicon-save"></span></button></div></div></div></div><div class="form-actions"><button type="submit" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></div></form></div>');
$templateCache.put('app/entities/construcao-civil/construcao-civil-detail.html','<div class="row"><div class="col-lg-12"><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="save()"><div class="form-group"><div class="col-md-3"><label>C\xF3digo da Obra</label><input id="codigo_bra" name="field_codigo_obra" ng-value="obra.codigoObra" ng-disabled="true" class="form-control"></div></div><button type="submit" class="btn btn-success" ui-sref="construcaoCivil"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span>Voltar</span></button></form></div></div>');
$templateCache.put('app/entities/construcao-civil/construcao-civil-edit.html','<div class="row"><div class="col-lg-12"><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="save()"><div class="ibox float-e-margins animated fadeInDown"><div class="ibox-content"><div class="form-group"><div class="col-md-2"><h3>Dados da Obra</h3></div></div><div class="form-group"><div class="col-md-2"><label>C\xF3digo da Obra</label><input type="text" id="codigo_bra" name="field_codigo_obra" ng-value="obra.codigoObra" ng-disabled="true" class="form-control"></div><div class="col-md-4"><label>ART</label><input type="text" id="art" name="art" ng-model="obra.art" class="form-control" required><div ng-show="editForm.art.$invalid"><p class="help-block" ng-show="editForm.art.$error.required">Informe a ART</p></div></div><div class="col-md-2"><label>Data de Aprova\xE7\xE3o</label><input type="text" name="dataAprovacao" ng-model="obra.dataAprovacaoProjeto" class="form-control" ui-date-mask="dd/MM/yyyy" required><div ng-show="editForm.dataAprovacao.$invalid"><p class="help-block" ng-show="editForm.dataAprovacao.$error.required">Informe a Data de Aprova\xE7\xE3o</p></div></div><div class="col-md-2"><label>Data de In\xEDcio</label><input type="text" ng-model="obra.dataInicio" class="form-control" ui-date-mask="dd/MM/yyyy"></div><div class="col-md-2"><label>Data de Conclus\xE3o</label><input type="text" ng-model="obra.dataConclusao" class="form-control" ui-date-mask="dd/MM/yyyy"></div></div><div class="form-group"><div class="col-md-2"><label>N\xB0 Alvar\xE1</label><input type="text" id="numero_alvara" required name="numeroAlvara" ng-model="obra.numeroAlvara" class="form-control"><div ng-show="editForm.numeroAlvara.$invalid"><p class="help-block" ng-show="editForm.numeroAlvara.$error.required">Informe o N\xB0 Alvar\xE1</p></div></div><div class="col-md-2"><label>Incorpora\xE7\xE3o</label><div class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" id="incorporacao" name="field_incorporacao" ng-model="obra.incorporacao" class="onoffswitch-checkbox"><label class="onoffswitch-label" for="incorporacao"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-md-3"><label>Matr\xEDcula Im\xF3vel</label><input type="text" id="matricula_imovel" name="field_matricula_imovel" ng-model="obra.matriculaImovel" class="form-control"></div><div class="col-md-2"><label>N\xB0 Habite-se</label><input type="text" id="numero_habitese" name="field_numero_habitese" ng-model="obra.numeroHabitese" class="form-control"></div></div><div class="form-group"><div class="col-md-4"><label>Status da Obra</label><select class="form-control" id="status_obra" name="statusObra" required ng-model="obra.status"><option value="NAO_INICIADA">N\xE3o Iniciada</option><option value="EM_ANDAMENTO">Em Andamento</option><option value="CONCLUIDA">Conclu\xEDda</option><option value="APROVADA">Aprovada</option><option value="PARALIZADA">Paralizada</option></select><div ng-show="editForm.statusObra.$invalid"><p class="help-block" ng-show="editForm.statusObra.$error.required">Informe o Status da Obra</p></div></div></div></div></div><div class="ibox float-e-margins animated fadeInDown"><div class="ibox-content"><div class="form-group"><div class="col-md-12"><h3>Respons\xE1vel da Obra</h3></div></div><dados-pessoais-edit form-reference="editForm" dados-pessoais="obra.responsavel"></dados-pessoais-edit></div></div><div class="ibox float-e-margins animated fadeInDown"><div class="ibox-content"><div class="form-group"><div class="col-md-12"><h3>Localiza\xE7\xE3o da Obra</h3></div></div><div class="form-group"><div class="col-md-2"><label>CEP</label><input type="text" class="form-control" name="localizacaoCep" ui-br-cep-mask required ng-blur="loadEnderecoByCEP(obra.localizacao.cep)" ng-model="obra.localizacao.cep"><div ng-show="editForm.localizacaoCep.$invalid"><p class="help-block" ng-show="editForm.localizacaoCep.$error.required">Informe o CEP</p></div></div><div class="col-md-8"><label>Munic\xEDpio</label><div class="input-group"><input type="text" class="form-control" name="localizacaoMunicipio" disabled="disabled" required ng-model="obra.localizacao.municipio.nome"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="searchMunicipio(obra.localizacao)"><span class="glyphicon glyphicon-search"></span></button></span></div><div ng-show="editForm.localizacaoMunicipio.$invalid"><p class="help-block" ng-show="editForm.localizacaoMunicipio.$error.required">Informe o Munic\xEDpio</p></div></div><div class="col-md-2"><label>Estado</label><input type="text" class="form-control" name="localizacaoEstado" disabled="disabled" ng-model="obra.localizacao.municipio.estado"><div ng-show="editForm.localizacaoEstado.$invalid"><p class="help-block" ng-show="editForm.localizacaoEstado.$error.required">Informe o Estado</p></div></div></div><div class="form-group"><div class="col-md-12"><label for="field_logradouro">Logradouro</label><input type="text" class="form-control" name="localizacaoLogradouro" id="field_logradouro" required ng-model="obra.localizacao.logradouro"><div ng-show="editForm.localizacaoLogradouro.$invalid"><p class="help-block" ng-show="editForm.localizacaoLogradouro.$error.required">Informe o Logradouro</p></div></div></div><div class="form-group"><div class="col-md-6"><label for="field_bairro">Bairro</label><input type="text" class="form-control" name="localizacaoBairro" id="field_bairro" required ng-model="obra.localizacao.bairro"><div ng-show="editForm.localizacaoBairro.$invalid"><p class="help-block" ng-show="editForm.localizacaoBairro.$error.required">Informe o Bairro</p></div></div><div class="col-md-2"><label for="field_numero">N\xFAmero</label><input type="text" class="form-control" name="localizacaoNumero" id="field_numero" required ng-model="obra.localizacao.numero"><div ng-show="editForm.localizacaoNumero.$invalid"><p class="help-block" ng-show="editForm.localizacaoNumero.$error.required">Informe o N\xFAmero</p></div></div><div class="col-md-4"><label for="field_complemento">Complemento</label><input type="text" class="form-control" name="complemento" id="field_complemento" ng-model="obra.localizacao.complemento"></div></div><div class="form-group"><div class="col-md-3"><label>Im\xF3vel (Munic\xEDpio)</label><div class="input-group"><input type="text" id="imovel" name="field_imovel" class="form-control" ng-disabled="!habilitaImovel()" ng-blur="buscarImovel()" ng-model="inscricaoImovel"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-disabled="!habilitaImovel()" ng-click="searchImovel()"><span class="glyphicon glyphicon-search"></span></button></span></div></div></div></div></div><div class="ibox float-e-margins animated fadeInDown" ng-form="editFormProfissional"><div class="ibox-content"><div class="form-group"><div class="col-md-12"><h3>Profissionais Ligados a Obra</h3></div></div><div class="form-group" ng-show="!profissional"><div class="col-md-12"><button type="button" class="btn btn-primary" ng-click="novoProfissional()"><span class="glyphicon glyphicon-check"></span>&nbsp; <span>Inserir</span></button></div></div><div ng-if="profissional"><div class="form-group"><div class="col-md-4"><label class="control-label" for="profissionalCpfCnpj">CPF ou CNPJ</label><div class="input-group"><input type="text" class="form-control" id="profissionalCpfCnpj" name="profissionalCpfCnpj" ui-br-cpfcnpj-mask ng-change="preLoadProfissional()" ng-model="profissional.profissional.cpfCnpj" required> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="searchPessoa()"><span class="glyphicon glyphicon-search"></span></button></span></div><div ng-show="editFormProfissional.profissionalCpfCnpj.$invalid"><p class="help-block" ng-show="editFormProfissional.profissionalCpfCnpj.$error.required">Informe o CPF ou CNPJ</p><p class="help-block" ng-show="editFormProfissional.profissionalCpfCnpj.$error.cpf || editFormProfissional.profissionalCpfCnpj.$error.cnpj">CPF ou CNPJ inv\xE1lido</p></div></div></div><div ng-show="editFormProfissional.profissionalCpfCnpj.$valid"><div class="form-group" ng-if="!isFisica(profissional.profissional)"><div class="col-md-4"><label for="field_inscricaoMunicipal">Inscri\xE7\xE3o Municipal</label><input type="text" class="form-control" name="profissionalInscricaoMunicipal" id="field_inscricaoMunicipal" ng-disabled="profissional.profissional.id" ng-model="profissional.profissional.inscricaoMunicipal"></div><div class="col-md-8"><label class="control-label" for="field_nomeFantasia">Nome Fantasia</label><input type="text" class="form-control" name="profissionalNomeFantasia" id="field_nomeFantasia" ng-disabled="profissional.profissional.id" ng-model="profissional.profissional.nomeFantasia"></div></div><div class="form-group"><div class="col-md-4" ng-if="!isFisica(profissional.profissional)" ng-class="{\'has-error\' : editFormProfissional.profissionalInscricaoEstadual.$invalid && (editFormProfissional.$submitted || editFormProfissional.profissionalInscricaoEstadual.$touched)}"><label class="control-label" for="field_inscricaoEstadual">Inscri\xE7\xE3o Estadual</label><input type="text" class="form-control" name="profissionalInscricaoEstadual" id="field_inscricaoEstadual" ng-disabled="profissional.profissional.id" ng-model="profissional.profissional.inscricaoEstadualRg"></div><div class="col-md-4" ng-if="isFisica(profissional.profissional)" ng-class="{\'has-error\' : editFormProfissional.profissionalRg.$invalid  && (editFormProfissional.$submitted || editFormProfissional.profissionalRg.$touched)}"><label class="control-label" for="field_rg">RG</label><input type="text" class="form-control" name="profissionalRg" id="field_rg" ng-disabled="profissional.profissional.id" ng-model="profissional.profissional.inscricaoEstadualRg"></div><div class="col-md-8" ng-class="{\'has-error\' : editFormProfissional.profissionalNomeRazaoSocial.$invalid && (editFormProfissional.$submitted || editFormProfissional.profissionalNomeRazaoSocial.$touched)}"><label class="control-label" for="field_nomeRazaoSocial">{{isFisica(profissional.profissional) ? \'Nome\':\'Raz\xE3o Social\'}}</label><input type="text" class="form-control" name="profissionalNomeRazaoSocial" id="field_nomeRazaoSocial" ng-disabled="profissional.profissional.id" ng-model="profissional.profissional.nomeRazaoSocial" required><div ng-show="editFormProfissional.profissionalNomeRazaoSocial.$invalid"><p class="help-block" ng-show="editFormProfissional.profissionalNomeRazaoSocial.$error.required">Informe o Nome ou a Raz\xE3o Social</p></div></div></div><div class="form-group"><div class="col-md-4"><label>Tipo de Profissional</label><select class="form-control" id="tipoProfissional" name="tipoProfissional" required ng-model="profissional.tipoProfissional"><option value=""></option><option value="ENGENHEIRO">Engenheiro</option><option value="ARQUITETO">Arquiteto</option><option value="OUTRO">Outro</option></select><div ng-if="!profissional.tipoProfissional || profissional.tipoProfissional == \'\'"><p class="help-block">Informe o Tipo de Profissional</p></div></div></div></div><button type="button" class="btn btn-primary" ng-disabled="editFormProfissional.$invalid" ng-click="adicionarProfissional()"><span class="glyphicon glyphicon-check"></span>&nbsp; <span>Adicionar</span></button> <button type="button" class="btn btn-danger" ng-click="cancelarProfissional()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span>Cancelar</span></button></div><div class="form-group"><div class="col-md-12"><div class="table-responsive"><table class="table table-striped small"><thead><tr><th class="col-md-2 text-center">Op\xE7\xF5es</th><th>Profissional</th><th class="col-md-2 text-center">Tipo</th></tr></thead><tbody><tr ng-repeat="profissional in obra.profissionais" ng-show="!profissional.remover"><td class="col-md-2 text-center"><button type="button" class="btn btn-sm btn-danger" title="Clique para remover o registro." ng-click="removerProfissional($index)"><span class="fa fa-trash"></span></button></td><td>{{profissional.profissional.cpfCnpj}} - {{profissional.profissional.nomeRazaoSocial}}</td><td class="col-md-2 text-center"><span>{{profissional.tipoProfissional}}</span></td></tr></tbody></table></div></div></div></div></div><button type="submit" class="btn btn-primary" ng-disabled="editForm.$invalid"><span class="glyphicon glyphicon-check"></span>&nbsp; <span>Salvar</span></button> <button type="button" class="btn btn-danger" ui-sref="construcaoCivil"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span>Cancelar</span></button></form></div></div>');
$templateCache.put('app/entities/construcao-civil/construcao-civil.html','<div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-md-10"><search-box ng-model="searchQuery" search-method="loadAll()"></search-box></div><div class="col-md-2"><button class="btn btn-primary pull-right btn-block" ui-sref="construcaoCivil.incluir"><span class="fa fa-plus"></span> <span>Incluir</span></button></div></div><div class="table-responsive"><table class="table table-striped small"><thead><tr><th class="col-md-2 text-center">Op\xE7\xF5es</th><th class="col-md-2">C\xF3digo da Obra</th><th class="col-md-6">Respons\xE1vel da Obra</th><th class="col-md-2 text-center">Status</th></tr></thead><tbody><tr ng-repeat="obra in obras"><td class="col-md-2 text-center"><button class="btn btn-sm btn-primary" title="Clique para editar o registro." ui-sref="construcaoCivil.editar({id:obra.id})"><span class="fa fa-edit"></span></button> <button class="btn btn-sm btn-success" title="Clique para visualizar o registro." ng-show="false" ui-sref="construcaoCivil.visualizar({id:obra.id})"><span class="fa fa-eye"></span></button> <button class="btn btn-sm btn-danger" title="Clique para remover o registro." ng-click="remover(obra.id)"><span class="fa fa-trash"></span></button></td><td class="col-md-2">{{obra.codigoObra}}</td><td class="col-md-6">{{obra.responsavel.cpfCnpj}} - {{obra.responsavel.nomeRazaoSocial}}</td><td class="col-md-2 text-center"><span ng-class="buscarClasseStatus(obra.status)">{{\'nfseApp.ConstrucaoCivilStatus.\' + obra.status | translate}}</span></td></tr></tbody></table><span nfse-app-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/cosif/cosif-search.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title">Pesquisa Conta Cosif</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><div class="panel panel-default"><div class="panel-heading">Op\xE7\xF5es de Filtros</div><div class="panel-body"><div class="row"><div class="col-md-12"><div class="form-group col-md-2"><label>Conta</label><input class="form-control" ng-model="filtro.conta"></div><div class="form-group col-md-10"><label>Nome</label><input class="form-control" ng-model="filtro.descricao"></div></div></div><div class="row"><div class="col-md-12"><div class="col-md-6"><button class="btn btn-primary" ng-click="loadAll()"><span class="fa fa-search"></span> <span>Pesquisar</span></button> <button class="btn btn-default" ng-click="filtro = {}"><span class="fa fa-close"></span> <span>Limpar Filtros</span></button></div></div></div></div></div></div></div><div class="row m-t-md"><div class="col-md-12"><span nfse-app-pagination></span><div class="table-responsive"><table class="table table-striped small"><thead><tr><th class="col-md-2">Conta</th><th>Descri\xE7\xE3o</th><th></th></tr></thead><tbody><tr ng-repeat="conta in contas"><td class="col-md-2">{{conta.conta}}</td><td>{{conta.descricao}}</td><td class="pull-right"><button type="submit" ng-click="ok(conta)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-check"></span></button></td></tr></tbody></table></div><span nfse-app-pagination></span></div></div></div>');
$templateCache.put('app/entities/credenciamento/credenciamento.html','<div class="row" ng-show="!prestadorServicos"><form class="form-horizontal" name="formPesquisa" role="form"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h4>Informe o CNPJ da empresa que deseja o acesso</h4></div><div class="ibox-content"><div class="form-group"><div class="col-md-12"><label for="pesquisaCnpj">C.N.P.J.</label><input type="text" class="form-control" name="pesquisaCnpj" id="pesquisaCnpj" ui-br-cnpj-mask="" ng-model="cnpj" required><div ng-show="formPesquisa.pesquisaCnpj.$invalid" class="has-error"><p class="help-block" ng-show="formPesquisa.pesquisaCnpj.$error.required">Informe o CNPJ</p><p class="help-block" ng-show="formPesquisa.pesquisaCnpj.$error.cpf || formPesquisa.pesquisaCnpj.$error.cnpj">CNPJ inv\xE1lido</p></div></div></div><div class="form-group"><div class="col-md-12"><button class="btn btn-info" ng-click="loadByCpfCnpj()">Continuar</button></div></div></div></div></div></form></div><div class="row" ng-show="prestadorServicos"><form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="save()"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h4>Dados Legais</h4></div><div class="ibox-content"><div class="form-group"><div class="col-md-6"><label for="field_cpfCnpj">C.N.P.J.</label><input type="text" class="form-control" name="cpfCnpj" id="field_cpfCnpj" ui-br-cnpj-mask="" disabled="disabled" ng-model="prestadorServicos.pessoa.dadosPessoais.cpfCnpj" required><div ng-show="editForm.cpfCnpj.$invalid" class="has-error"><p class="help-block" ng-show="editForm.cpfCnpj.$error.required">Informe o CNPJ</p><p class="help-block" ng-show="editForm.cpfCnpj.$error.cpf || editForm.cpfCnpj.$error.cnpj">CNPJ inv\xE1lido</p></div></div><div><div class="col-md-3"><label for="field_inscricaoMunicipal">Inscri\xE7\xE3o Municipal</label><input type="text" class="form-control" name="inscricaoMunicipal" id="field_inscricaoMunicipal" ng-disabled="prestadorServicos.id" ng-model="prestadorServicos.inscricaoMunicipal"></div><div class="col-md-3"><label for="field_inscricaoEstadualRg">Inscri\xE7\xE3o Estadual</label><input type="text" class="form-control" name="inscricaoEstadualRg" id="field_inscricaoEstadualRg" ng-disabled="prestadorServicos.id" ng-model="prestadorServicos.pessoa.dadosPessoais.inscricaoEstadualRg" required><div ng-show="editForm.inscricaoEstadualRg.$invalid"><p class="help-block" ng-show="editForm.inscricaoEstadualRg.$error.required">Informe a Inscri\xE7\xE3o Estadual</p></div></div></div></div><div class="form-group"><div class="col-md-6"><label for="field_nomeRazaoSocial">Raz\xE3o Social</label><input type="text" class="form-control" name="nomeRazaoSocial" id="field_nomeRazaoSocial" ng-disabled="prestadorServicos.id" ng-model="prestadorServicos.pessoa.dadosPessoais.nomeRazaoSocial" required><div ng-show="editForm.nomeRazaoSocial.$invalid"><p class="help-block" ng-show="editForm.nomeRazaoSocial.$error.required">Informe a Raz\xE3o Social</p></div></div><div class="col-md-6"><label for="field_nomeFantasia">Nome Fantasia</label><input type="text" class="form-control" name="nomeFantasia" ng-disabled="prestadorServicos.id" id="field_nomeFantasia" ng-model="prestadorServicos.pessoa.dadosPessoais.nomeFantasia"></div></div><div class="form-group"><div class="col-md-6"><label for="field_email">e-Mail</label><input type="email" class="form-control" name="email" id="field_email" ng-disabled="prestadorServicos.id" ng-model="prestadorServicos.pessoa.dadosPessoais.email"><div ng-show="editForm.email.$invalid" class="has-error"><p class="help-block">e-Mail inv\xE1lido.</p></div></div><div class="col-md-3"><label for="field_telefone">Telefone</label><input type="text" class="form-control" name="telefone" id="field_telefone" ui-br-phone-number ng-disabled="prestadorServicos.id" ng-model="prestadorServicos.pessoa.dadosPessoais.telefone"><div ng-show="editForm.telefone.$invalid" class="has-error"><p class="help-block">Telefone inv\xE1lido.</p></div></div><div class="col-md-3"><label for="field_celular">Celular</label><input type="text" class="form-control" name="celular" id="field_celular" ui-br-phone-number ng-disabled="prestadorServicos.id" ng-model="prestadorServicos.pessoa.dadosPessoais.celular"><div ng-show="editForm.celular.$invalid" class="has-error"><p class="help-block">Celular inv\xE1lido.</p></div></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h4>Endere\xE7o</h4></div><div class="ibox-content"><div class="form-group"><div class="col-md-2"><label for="field_cep">C.E.P.</label><input type="text" class="form-control" name="id" id="field_cep" ui-br-cep-mask="" ng-disabled="prestadorServicos.id" ng-blur="loadEnderecoByCEP(prestadorServicos.pessoa.dadosPessoais.cep)" ng-model="prestadorServicos.pessoa.dadosPessoais.cep" required><div ng-show="editForm.id.$invalid"><p class="help-block" ng-show="editForm.id.$error.required">Informe o CEP</p></div></div><div class="col-md-8"><label for="field_nome_municipio">Municipio</label><div class="input-group"><input type="text" class="form-control" name="nome_municipio" id="field_nome_municipio" disabled="disabled" ng-model="prestadorServicos.pessoa.dadosPessoais.municipio.nome"> <span class="input-group-btn"><button ng-disabled="prestadorServicos.id" type="button" class="btn" ng-click="searchMunicipio()"><span class="glyphicon glyphicon-search"></span></button></span></div></div><div class="col-md-2"><label for="field_estado_municipio">Estado</label><input type="text" class="form-control" name="estado_municipio" id="field_estado_municipio" disabled="disabled" ng-model="prestadorServicos.pessoa.dadosPessoais.municipio.estado"></div></div><div class="form-group"><div class="col-md-12"><label for="field_logradouro">Logradouro</label><input type="text" class="form-control" name="logradouro" id="field_logradouro" ng-disabled="prestadorServicos.id" ng-model="prestadorServicos.pessoa.dadosPessoais.logradouro" required><div ng-show="editForm.logradouro.$invalid"><p class="help-block" ng-show="editForm.logradouro.$error.required">Informe o Logradouro</p></div></div></div><div class="form-group"><div class="col-md-6"><label for="field_bairro">Bairro</label><input type="text" class="form-control" ng-disabled="prestadorServicos.id" name="bairro" id="field_bairro" ng-model="prestadorServicos.pessoa.dadosPessoais.bairro"></div><div class="col-md-2"><label for="field_numero">N\xFAmero</label><input type="text" class="form-control" ng-disabled="prestadorServicos.id" name="numero" id="field_numero" ng-model="prestadorServicos.pessoa.dadosPessoais.numero" required><div ng-show="editForm.numero.$invalid"><p class="help-block" ng-show="editForm.numero.$error.required">Informe o N\xFAmero</p></div></div><div class="col-md-4"><label for="field_complemento">Complemento</label><input type="text" class="form-control" ng-disabled="prestadorServicos.id" name="complemento" id="field_complemento" ng-model="prestadorServicos.pessoa.dadosPessoais.complemento"></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h4>Socios</h4></div><div class="ibox-content"><div class="form-group"><div class="col-md-3"><label class="center-block">CPF/CNPJ</label></div><div class="col-md-7"><label class="center-block">Nome</label></div><div class="col-md-2"><label class="center-block">Percentual</label></div></div><div class="form-group" data-ng-repeat="socio in prestadorServicos.socios" ng-form="socioForm" class="animated fadeInDown"><div class="col-md-3"><input type="text" class="form-control" name="socio_cpfCnpj" id="field_socio_cpfCnpj" ui-br-cpfcnpj-mask="" required disabled="disabled" ng-model="socio.socio.dadosPessoais.cpfCnpj"></div><div class="col-md-7"><input type="text" class="form-control" name="socio_nome" id="field_socio_nome" disabled="disabled" ng-model="socio.socio.dadosPessoais.nomeRazaoSocial"></div><div class="col-md-2"><div class="input-group"><input type="text" class="form-control" name="socio_proporcao" ui-percentage-mask ui-percentage-value disabled="disabled" id="field_socio_proporcao" ng-model="socio.proporcao"></div></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h4>Enquadramento Fiscal</h4></div><div class="ibox-content"><div class="form-group animated fadeInUp"><div class="col-md-4"><label for="field_porte">Porte</label><input type="text" class="form-control" name="porte" id="field_porte" disabled="disabled" ng-model="prestadorServicos.enquadramentoFiscal.porte"></div><div class="col-md-4"><label for="field_porte">Tipo de Contribuinte</label><input type="text" class="form-control" name="tipoContribuinte" id="field_tipoContribuinte" disabled="disabled" ng-model="prestadorServicos.enquadramentoFiscal.tipoContribuinte"></div><div class="col-md-4"><label for="field_porte">Regime Tributario</label><input type="text" class="form-control" name="regimeTributario" id="field_regimeTributario" disabled="disabled" ng-model="prestadorServicos.enquadramentoFiscal.regimeTributario"></div><div class="col-md-4"><label for="field_porte">Tipo de Iss</label><input type="text" class="form-control" name="tipoIss" id="field_tipoIss" disabled="disabled" ng-model="prestadorServicos.enquadramentoFiscal.tipoIss"></div><div class="col-md-4"><label for="field_porte">Tipo de Iss Estimado</label><input type="text" class="form-control" name="tipoIssEstimado" id="field_tipoIssEstimado" disabled="disabled" ng-model="prestadorServicos.enquadramentoFiscal.tipoIssEstimado"></div><div class="col-md-4"><label for="field_porte">Valor de Iss Estimado</label><input type="text" class="form-control" name="valorIssEstimado" id="field_valorIssEstimado" disabled="disabled" ng-model="prestadorServicos.enquadramentoFiscal.valorIssEstimado"></div><div class="col-md-4"><label for="field_porte">Classifica\xE7\xE3o da Atividade</label><input type="text" class="form-control" name="classificacaoAtividade" id="field_classificacaoAtividade" disabled="disabled" ng-model="prestadorServicos.enquadramentoFiscal.classificacaoAtividade"></div><div class="col-md-4"><label for="field_porte">Tipo de Nota Fiscal</label><input type="text" class="form-control" name="tipoNotaFiscal" id="field_tipoNotaFiscal" disabled="disabled" ng-model="prestadorServicos.enquadramentoFiscal.tipoNotaFiscal"></div><div class="col-md-4"><label for="field_porte">Substituto Tributario</label><input type="text" class="form-control" name="substitutoTributario" id="field_substitutoTributario" disabled="disabled" value="{{prestadorServicos.enquadramentoFiscal.substitutoTributario? \'Sim\': \'N\xE3o\'}}"></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h4>Servi\xE7os</h4></div><div class="ibox-content"><div class="form-group"><div class="col-md-2"><label class="center-block">C\xF3digo</label></div><div class="col-md-2"><label class="center-block">Aliquota</label></div><div class="col-md-8"><label class="center-block">Descri\xE7\xE3o</label></div></div><div class="form-group" data-ng-repeat="servico in prestadorServicos.servicos" class="animated fadeInDown"><div class="col-md-2"><input type="text" class="form-control" name="servico_codigo" id="field_servico_codigo" disabled="disabled" ng-model="servico.codigo"></div><div class="col-md-2"><input type="text" class="form-control" name="servico_aliquota" id="field_servico_aliquota" ng-model="servico.aliquota" disabled="disabled"></div><div class="col-md-8"><input type="text" class="form-control" name="servico_descricao" id="field_servico_descricao" disabled="disabled" ng-model="servico.descricao"></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h4>Cnaes</h4></div><div class="ibox-content"><div class="form-group"><div class="col-md-2"><label class="center-block">C\xF3digo</label></div><div class="col-md-2"><label class="center-block">Descricao</label></div></div><div class="form-group" data-ng-repeat="cnae in prestadorServicos.cnaes" class="animated fadeInDown"><div class="col-md-2"><input type="text" class="form-control" name="cane_codigo" id="field_cnae_codigo" disabled="disabled" ng-model="cnae.codigo"></div><div class="col-md-10"><input type="text" class="form-control" name="cnae_descricao" id="field_cnae_descricao" disabled="disabled" ng-model="cnae.descricao"></div></div></div></div><button type="submit" ng-disabled="!prestadorServicos.id && editForm.$invalid" class="btn btn-primary btn-group-lg" style="width: 100%"><span class="fa fa-angle-double-right"></span>&nbsp; Continuar</button></div></form></div>');
$templateCache.put('app/entities/credenciamento/documentos.html','<div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><span translate="nfseApp.prestadorServicos.credenciamento.title">Form</span></div><div class="ibox-content text-center"><div class="alert alert-success"><h2>Cadastro Efetuado!</h2><p>Seus dados foram inseridos na base com sucesso! Assim que for liberada a emiss\xE3o das Notas Ficais voc\xEA ser\xE1 notificado por e-mail.</p></div><div class="alert alert-danger" ng-show="error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div></div>');
$templateCache.put('app/entities/credenciamento/impressao-template.html','<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><title></title><link rel="stylesheet" href="bower_components/bootstrap/dist/css/bootstrap.css"><!-- Font awesome --><link href="assets/font-awesome/css/font-awesome.css" rel="stylesheet"><!-- Main Inspinia CSS files --><link href="assets/css/animate.css" rel="stylesheet"><link id="loadBefore" href="assets/css/style.css" rel="stylesheet"><link href="assets/styles/documentation.css" rel="stylesheet"></head><body><div class="text-center ibox-title" style="border-bottom: 1px solid #E7EAEC"><button class="btn btn-default" type="button" ng-click="goPrevious()"><i class="fa fa-arrow-circle-left"></i></button> <button class="btn btn-white" type="button" ng-click="zoomIn()"><i class="fa fa-plus-circle"></i></button> <button class="btn btn-success" type="button" ng-click="print()"><i class="fa fa-print"></i></button> <button class="btn btn-white" type="button" ng-click="zoomOut()"><i class="fa fa-minus-circle"></i></button> <button class="btn btn-default" type="button" ng-click="goNext()"><i class="fa fa-arrow-circle-right"></i></button></div><div style="overflow: auto; max-height: 400px; max-width: 100%"><canvas id="pdf" class="rotate0"></canvas></div></body></html>');
$templateCache.put('app/entities/credenciamento/termo-credenciamento-impressao.html','<div class="modal-header"><button type="button" class="close" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title">Impress\xE3o do Termo de Credenciamento</h4></div><div class="modal-body" style="background-color: #F3F3F4"><div class="modal-content"><ng-pdf template-url="/scripts/app/entities/credenciamento/impressao-template.html" canvasid="pdf" scale="1.3"></ng-pdf></div></div>');
$templateCache.put('app/entities/debitos/debitos.html','<div class="row"><div class="col-lg-12"><div class="row"><div class="col-md-4"><table class="table small"><tr><th class="text-center" colspan="2">Situa\xE7\xF5es</th></tr><tr ng-repeat="situacao in situacoes"><td><a ng-click="filtro.situacoes.splice(filtro.situacoes.indexOf(situacao), 1)" ng-show="filtro.situacoes.indexOf(situacao) >= 0" class="text-info"><i class="fa fa-check-circle-o"></i> </a><a ng-click="filtro.situacoes.push(situacao)" ng-show="filtro.situacoes.indexOf(situacao) < 0"><i class="fa fa-circle-o"></i></a></td><td>{{situacao.descricao}}</td></tr></table></div><div class="col-md-4"><div class="form-group col-md-12"><label for="field_vencimentoInicial">Vencimento Inicial</label><input type="date" ng-model="filtro.vencimentoInicial" id="field_vencimentoInicial" class="form-control" name="vencimentoInicial"></div><div class="form-group col-md-12"><label for="field_vencimentoFinal">Vencimento Final</label><input type="date" ng-model="filtro.vencimentoFinal" id="field_vencimentoFinal" class="form-control" name="vencimentoFinal"></div><div class="col-md-12"><button class="btn btn-success pull-right" title="Pesqusiar" ng-click="loadAll()"><span class="fa fa-search"></span> Filtrar D\xE9bitos</button></div></div></div><div class="table-responsive m-t-md"><table class="table table-striped" style="overflow: auto"><thead><tr><th></th><th>Tipo</th><th>Imposto</th><th>Taxa</th><th>Juros</th><th>Multa</th><th>Corre\xE7\xE3o</th><th>Honor\xE1rios</th><th>Desconto</th><th>Pago</th><th>Total</th><th>Vencimento</th><th>Situa\xE7\xE3o</th></tr></thead><tbody><tr ng-repeat="debito in debitos" class="{{debito.vencimento < hoje ? \'text-danger\': \'\'}} {{agrupador.parcelas.indexOf(debito) >= 0 ? \'success\' : \'\'}}"><td><a ng-click="removerParcela(agrupador.parcelas.indexOf(debito))" ng-show="agrupador.parcelas.indexOf(debito) >= 0" ng-if="debito.situacao === \'EM_ABERTO\'" class="text-info"><i class="fa fa-check-circle-o"></i> </a><a ng-click="adicionarParcela(debito)" ng-show="agrupador.parcelas.indexOf(debito) < 0" ng-if="debito.situacao === \'EM_ABERTO\'"><i class="fa fa-circle-o"></i></a></td><td>{{debito.divida}}</td><td>{{debito.valorImposto | currency: \'R$\'}}</td><td>{{debito.valorTaxa | currency: \'R$\'}}</td><td>{{debito.valorJuros | currency: \'R$\'}}</td><td>{{debito.valorMulta | currency: \'R$\'}}</td><td>{{debito.valorCorrecao | currency: \'R$\'}}</td><td>{{debito.valorHonorarios | currency: \'R$\'}}</td><td>{{debito.valorDesconto | currency: \'R$\'}}</td><td>{{debito.valorPago | currency: \'R$\'}}</td><td>{{debito.total | currency: \'R$\'}}</td><td>{{debito.vencimentoToString}}</td><td>{{\'nfseApp.SituacaoParcela.\' + debito.situacao | translate}}</td></tr><tr><td colspan="2" class="text-right">Total</td><td>{{valorImposto | currency: \'R$\'}}</td><td>{{valorTaxa | currency: \'R$\'}}</td><td>{{valorJuros | currency: \'R$\'}}</td><td>{{valorMulta | currency: \'R$\'}}</td><td>{{valorCorrecao | currency: \'R$\'}}</td><td>{{valorHonorarios | currency: \'R$\'}}</td><td>{{valorDesconto | currency: \'R$\'}}</td><td>{{valorPago | currency: \'R$\'}}</td><td>{{total | currency: \'R$\'}}</td><td colspan="2" class="text-right"></td></tr></tbody></table><div class="col-md-12"><button class="btn btn-info" ng-disabled="agrupador.parcelas.length <= 0" title="Imprimir Guia" ng-click="imprimirDam()"><span class="fa fa-print"></span> Imprimir Guia</button> <button class="btn btn-success" ng-disabled="agrupador.parcelas.length <= 0" title="Imprimir Guia" ng-click="enviarDam()"><span class="fa fa-envelope"></span> Enviar Guia</button></div><span nfse-app-pagination></div></div></div>');
$templateCache.put('app/entities/debitos/enviar-dam-email.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title" id="myServicoLabel">Deseja notificar mais algu\xE9m por e-mail?</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><form name="editForm"><div class="form-group"><div class="form-group col-md-12"><input type="text" class="form-control" multiple-emails name="recipientEmail" ng-model="agrupador.emails"><div ng-show="editForm.recipientEmail.$invalid"><p class="help-block">E-mail informado inv\xE1lido</p></div></div><div class="col-md-12"><span class="help-block m-b-none">Informe todos os e-mails a serem notificados separados por virgula. Ex. jose@gmail.com, maria@gmail.com</span></div></div><div class="form-group col-md-12"><button ng-click="ok()" class="btn btn-success pull-right"><i class="fa fa-send"></i> Enviar</button></div></form></div></div></div>');
$templateCache.put('app/entities/declaracaoMensalServico/declaracaoMensalServico-detail.html','<div class="row"><div class="col-lg-12"><form name="editForm" class="form-horizontal" role="form" novalidate><div class="form-group"><div class="col-md-3"><label for="field_mes" class="control-label">M\xEAs da Compet\xEAncia</label><input type="text" id="field_mes" class="form-control" readonly="readonly" ng-model="declaracaoMensalServico.mes"></div><div class="col-md-3"><label for="field_ano" class="control-label">Ano da Compet\xEAncia</label><input type="text" class="form-control" id="field_ano" readonly="readonly" ng-model="declaracaoMensalServico.exercicio"></div></div><div class="row"><div class="col-md-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-info pull-right">{{declaracaoMensalServico.mes}}/{{declaracaoMensalServico.exercicio}}</span><h5>Quantidade de notas</h5></div><div class="ibox-content"><h1 class="no-margins">{{declaracaoMensalServico.qtdNotas}}</h1><div class="stat-percent font-bold text-info"><i class="fa fa-check-square-o"></i></div></div></div></div><div class="col-md-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-primary pull-right">{{declaracaoMensalServico.mes}}/{{declaracaoMensalServico.exercicio}}</span><h5>Valor Servi\xE7os</h5></div><div class="ibox-content"><h1 class="no-margins">{{declaracaoMensalServico.totalServicos | currency: \'R$\'}}</h1><div class="stat-percent font-bold text-primary"><i class="fa fa-money"></i></div></div></div></div><div class="col-md-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-danger pull-right">{{declaracaoMensalServico.mes}}/{{declaracaoMensalServico.exercicio}}</span><h5>ISS Devido</h5></div><div class="ibox-content"><h1 class="no-margins">{{declaracaoMensalServico.totalIss | currency: \'R$\'}}</h1><div class="stat-percent font-bold text-primary"><i class="fa fa-money"></i></div></div></div></div></div><div class="col-md-12"><div class="table-responsive"><table class="table table-striped table-hover table-condensed"><thead><tr><th colspan="12" class="text-center">Notas Fiscais</th></tr><tr><th>#</th><th>Tipo</th><th>N\xFAmero</th><th>Emiss\xE3o</th><th>Tomador</th><th>CPF/CNPJ</th><th>Situa\xE7\xE3o</th><th style="text-align: right">Valor Servi\xE7os</th><th style="text-align: right">Valor ISS</th><th style="text-align: right">Valor ISS Retido</th><th style="text-align: right">Valor ISS Devido</th></tr></thead><tbody><tr ng-repeat="nota in notas | orderBy: \'-numero\'"><td>{{$index + 1}}</td><td>{{\'nfseApp.TipoDocumento.\' + nota.tipoDocumentoNfse | translate}}</td><td>{{nota.numero}}</td><td>{{nota.emissao | date: \'dd/MM/yyyy\'}}</td><td>{{nota.nomeTomador}}</td><td>{{nota.cpfCnpjTomador}}</td><td>{{nota.situacao}}</td><td style="text-align: right">{{nota.totalServicos | currency: \'R$\'}}</td><td style="text-align: right">{{nota.issCalculado | currency: \'R$\'}}</td><td style="text-align: right">{{nota.issRetido ? nota.issCalculado : 0.0 | currency: \'R$\'}}</td><td style="text-align: right">{{nota.iss | currency: \'R$\'}}</td></tr></tbody></table></div><span nfse-app-pagination></div><button type="button" ui-sref="declaracaoMensalServico" class="btn btn-default"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span>Voltar</span></button></form></div></div>');
$templateCache.put('app/entities/declaracaoMensalServico/declaracaoMensalServico-edit.html','<div class="row"><div class="col-lg-12"><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="save()"><div class="form-group"><div class="col-md-3"><label for="field_mes" class="control-label">M\xEAs da Compet\xEAncia</label><select class="form-control" id="field_mes" name="mes" ng-model="mes" ng-options="mes as mes.descricao for mes in meses track by mes.numeroMes" ng-change="acessarCompetencia();"></div><div class="col-md-3"><label for="field_ano" class="control-label">Ano da Compet\xEAncia</label><input type="text" id="field_ano" name="ano" class="form-control" ng-model="ano" ng-change="acessarCompetencia();" required><div ng-if="!ano"><p class="help-block">Informe o ano</p></div></div></div><div class="row" ng-if="declaracaoMensalServico"><div class="col-md-6"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-success pull-right">{{declaracaoMensalServico.mes}}/{{declaracaoMensalServico.exercicio}}</span><h5>Quantidade de Notas</h5></div><div class="ibox-content"><h1 class="no-margins">{{declaracaoMensalServico.qtdNotas}}</h1><div class="stat-percent font-bold text-success"><i class="fa fa-edit"></i></div></div></div></div><div class="col-md-6"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-primary pull-right">{{declaracaoMensalServico.mes}}/{{declaracaoMensalServico.exercicio}}</span><h5>Total dos Servi\xE7os</h5></div><div class="ibox-content"><h1 class="no-margins">{{declaracaoMensalServico.totalServicos | currency: \'R$\'}}</h1><div class="stat-percent font-bold text-primary"><i class="fa fa-money"></i></div></div></div></div></div><div class="row" ng-if="declaracaoMensalServico"><div class="col-md-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-danger pull-right">{{declaracaoMensalServico.mes}}/{{declaracaoMensalServico.exercicio}}</span><h5>ISS Calculado</h5></div><div class="ibox-content"><h1 class="no-margins">{{declaracaoMensalServico.totalIssCalculado | currency: \'R$\'}}</h1><div class="stat-percent font-bold text-danger"><i class="fa fa-barcode"></i></div></div></div></div><div class="col-md-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-danger pull-right">{{declaracaoMensalServico.mes.numeroMes}}/{{declaracaoMensalServico.exercicio}}</span><h5>ISS Retido</h5></div><div class="ibox-content"><h1 class="no-margins">{{declaracaoMensalServico.totalIssRetido | currency: \'R$\'}}</h1><div class="stat-percent font-bold text-danger"><i class="fa fa-barcode"></i></div></div></div></div><div class="col-md-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-danger pull-right">{{declaracaoMensalServico.mes.numeroMes}}/{{declaracaoMensalServico.exercicio}}</span><h5>ISS Devido</h5></div><div class="ibox-content"><h1 class="no-margins">{{declaracaoMensalServico.totalIss | currency: \'R$\'}}</h1><div class="stat-percent font-bold text-danger"><i class="fa fa-barcode"></i></div></div></div></div></div><div class="row"><div class="col-md-offset-5 col-md-2"><button type="button" class="btn btn-info" ng-click="selecionarNotas()"><span class="glyphicon glyphicon-check"></span>&nbsp; <span>Selecionar Notas</span></button></div></div><div class="col-md-12"><div class="table-responsive" ng-show="declaracaoMensalServico.notas && declaracaoMensalServico.notas.length > 0"><table class="table table-striped table-hover table-condensed"><thead><tr><th colspan="10" class="text-center">Notas Fiscais Selecionadas</th></tr><tr><th>Tipo</th><th>N\xFAmero</th><th>Emiss\xE3o</th><th>Tomador</th><th>CPF/CNPJ</th><th>Situa\xE7\xE3o</th><th style="text-align: right">Valor Servi\xE7os</th><th style="text-align: right">Valor ISS</th><th style="text-align: right">Valor ISS Retido</th><th style="text-align: right">Valor ISS Devido</th></tr></thead><tbody><tr ng-repeat="nota in declaracaoMensalServico.notas"><td>{{\'nfseApp.TipoDocumento.\'+nota.tipoDocumentoNfse | translate}}</td><td>{{nota.numero}}</td><td>{{nota.emissao | date: \'dd/MM/yyyy\'}}</td><td>{{nota.nomeTomador}}</td><td>{{nota.cpfCnpjTomador}}</td><td>{{nota.situacao}}</td><td style="text-align: right">{{nota.totalServicos | currency: \'R$\'}}</td><td style="text-align: right">{{nota.issCalculado | currency: \'R$\'}}</td><td style="text-align: right">{{nota.issRetido ? nota.issCalculado : 0.0 | currency: \'R$\'}}</td><td style="text-align: right">{{nota.iss | currency: \'R$\'}}</td></tr></tbody></table></div></div><button type="button" ui-sref="declaracaoMensalServico" class="btn btn-default"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-if="declaracaoMensalServico" ng-disabled="editForm.$invalid"><span class="glyphicon glyphicon-check"></span>&nbsp; <span>{{declaracaoMensalServico.qtdNotas > 0 ? \'Encerrar Declara\xE7\xE3o\' : \'Declarar Aus\xEAncia de Movimento\'}}</span></button></form></div></div>');
$templateCache.put('app/entities/declaracaoMensalServico/declaracaoMensalServicos.html','<div class="row"><div class="col-lg-12"><div class="row"><div class="form-group col-md-3"><label for="field_final">Exerc\xEDcio</label><input type="text" id="field_final" name="ano" class="form-control" ng-model="exercicio"></div><div class="form-group col-md-3"><label for="field_mes_inicial" class="control-label">M\xEAs Inicial</label><select class="form-control" id="field_mes_inicial" name="mesInicial" ng-model="mesInicial" ng-options="mes as mes.descricao for mes in meses track by mes.numeroMes"></select></div><div class="form-group col-md-3"><label for="field_mes_final" class="control-label">M\xEAs Final</label><select class="form-control" id="field_mes_final" name="mesFinal" ng-model="mesFinal" ng-options="mes as mes.descricao for mes in meses track by mes.numeroMes"></select></div><div class="form-group col-md-3"><label>&ensp;</label><button class="btn btn-info btn-block" ng-click="loadAll()"><span class="fa fa-search"></span> <span>Filtrar</span></button></div></div><div ng-repeat="exericicoDeclarado in exerciciosDeclarados"><div><div class="table-responsive" ng-repeat="mesDeclarado in exericicoDeclarado.mesesDeclarados"><table class="table table-striped"><thead><tr><th colspan="9">{{\'nfseApp.Mes.\' + mesDeclarado.mes | translate}}/{{exericicoDeclarado.ano}}</th></tr><tr><th>C\xF3digo</th><th>Tipo</th><th>Movimento</th><th>Situacao</th><th>Abertura</th><th>Encerramento</th><th>D\xE9bitos</th><th>Vencimento</th><th>Qtde Doc</th><th>Servi\xE7os</th><th>ISS</th><th>Valor Total</th><th class="text-center">Op\xE7\xF5es</th></tr></thead><tbody><tr ng-show="mesDeclarado.declaracoes.length == 0"><td colspan="12" class="text-center text-danger">A compet\xEAncia {{\'nfseApp.Mes.\' + mesDeclarado.mes | translate}}/{{exericicoDeclarado.ano}} n\xE3o possui declara\xE7\xE3o realizada.</td></tr><tr ng-repeat="declaracaoMensalServico in mesDeclarado.declaracoes | orderBy: \'-codigo\'"><td><a ui-sref="declaracaoMensalServico.detail({id:declaracaoMensalServico.id})">{{declaracaoMensalServico.codigo}}</a></td><td>{{\'nfseApp.TipoDeclaracaoMensal.\' + declaracaoMensalServico.tipo | translate}}</td><td>{{\'nfseApp.TipoMovimentoMensal.\' + declaracaoMensalServico.tipoMovimento | translate}}</td><td>{{\'nfseApp.SituacaoDeclaracaoMensal.\' + declaracaoMensalServico.situacao | translate}}</td><td>{{declaracaoMensalServico.abertura | date:\'dd/MM/yyyy\'}}</td><td>{{declaracaoMensalServico.encerramento | date:\'dd/MM/yyyy\'}}</td><td>{{\'nfseApp.SituacaoParcela.\' + declaracaoMensalServico.situacaoDebito | translate}}</td><td>{{declaracaoMensalServico.vencimento | date:\'dd/MM/yyyy\'}}</td><td>{{declaracaoMensalServico.qtdNotas}}</td><td>{{declaracaoMensalServico.totalServicos | number:2}}</td><td>{{declaracaoMensalServico.totalIss | number:2}}</td><td>{{declaracaoMensalServico.totalIss + declaracaoMensalServico.totalJuros + declaracaoMensalServico.totalMulta + declaracaoMensalServico.totalCorrecao | number:2}}</td><td class="text-center"><a title="Imprimir Guia" ng-if="declaracaoMensalServico.situacaoDebito === \'EM_ABERTO\'" ng-click="imprimirDam(declaracaoMensalServico)"><span class="glyphicon glyphicon-print"></span> </a><a title="Emitir Protocolo" ng-if="declaracaoMensalServico.situacao === \'ENCERRADO\'" ng-click="emitirProtocoloRecebimentoDms(declaracaoMensalServico.id)"><span style="color: blue" class="glyphicon glyphicon-align-left"></span> </a><a title="Cancelar Declara\xE7\xE3o" ng-if="declaracaoMensalServico.situacao != \'CANCELADO\'" ng-click="cancelar(declaracaoMensalServico.id)"><span style="color: red" class="glyphicon glyphicon-remove"></span></a></td></tr><tr><td colspan="13" class="text-center warning"><a ui-sref="declaracaoMensalServico.new({mes:mesDeclarado.mes, ano:exericicoDeclarado.ano})"><span class="fa fa-plus"></span> Declarar {{hasDeclaracaoNaoCancelada(mesDeclarado.declaracoes) ? \'Complementar\' : \'\'}}</a></td></tr></tbody></table><button type="submit" ng-show="mesDeclarado.declaracoes.length > 0 && !empresa.prestador.foraMunicipio" ng-click="imprimeRelatorioDMS(exericicoDeclarado.ano, mesDeclarado.mes)" class="btn btn-info btn-sm pull-right"><span class="glyphicon glyphicon-print"></span> Declara\xE7\xF5es ({{\'nfseApp.Mes.\' + mesDeclarado.mes | translate}}/{{exericicoDeclarado.ano}})</button></div></div></div></div></div>');
$templateCache.put('app/entities/declaracaoMensalServico/emissaoGuia.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title" id="myServicoLabel">Emiss\xE3o de guia para pagamento</h4></div><div class="modal-body"><div class="row"><div class="form-group col-md-12"><span class="text-info"><strong>Informa\xE7\xE3o!</strong> Selecione a data de vencimento para emiss\xE3o da guia de pagamento.</span></div><div class="form-group col-md-4"><label>Vencimento da Guia</label><input type="date" ng-model="emissaoDam.vencimentoDam" class="form-control"></div></div></div><div class="modal-footer"><button type="button" ng-click="imprimirDam()" class="btn btn-success"><span class="glyphicon glyphicon-print"></span>&nbsp; <span>Imprimir</span></button></div>');
$templateCache.put('app/entities/declaracaoMensalServico/pesquisaNotasEmitidas.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title" id="myServicoLabel">Notas Emitidas</h4></div><div class="modal-body"><div class="col-md-12"><div class="table-responsive" ng-show="notas && notas.length > 0"><table class="table table-striped table-hover table-condensed"><thead><tr><th></th><th>Tipo</th><th><span>N\xFAmero</span><br><small>Emiss\xE3o</small></th><th>Tomador</th><th style="text-align: right">Valor Servi\xE7os</th><th style="text-align: right">Valor ISS</th><th style="text-align: right">Valor ISS Retido</th><th style="text-align: right">Valor ISS Devido</th></tr></thead><tbody><tr ng-repeat="nota in notas"><td><button class="btn btn-success" ng-if="indexNotaSelecionada(nota) >= 0" ng-click="selecionarNota(nota)"><span class="glyphicon glyphicon-check"></span></button> <button class="btn btn-default" ng-if="indexNotaSelecionada(nota) < 0" ng-click="selecionarNota(nota)"><span class="glyphicon glyphicon-unchecked"></span></button></td><td>{{\'nfseApp.TipoDocumento.\'+nota.tipoDocumentoNfse | translate}}</td><td><span>{{nota.numero}}</span> <small>{{nota.emissao | date: \'dd/MM/yyyy\'}}</small></td><td>{{nota.nomeTomador}} ({{nota.cpfCnpjTomador}})</td><td style="text-align: right">{{nota.totalServicos | currency: \'R$\'}}</td><td style="text-align: right">{{nota.issCalculado | currency: \'R$\'}}</td><td style="text-align: right">{{nota.issRetido ? nota.issCalculado : 0.0 | currency: \'R$\'}}</td><td style="text-align: right">{{nota.iss | currency: \'R$\'}}</td></tr></tbody></table></div><span nfse-app-pagination></div></div><div class="modal-footer"><button type="button" ng-click="ok()" class="btn btn-success"><span class="glyphicon glyphicon-check"></span>&nbsp; <span>Ok</span></button></div>');
$templateCache.put('app/entities/declaracaoMensalServicoCartorio/declaracaoMensalServicoCartorio-detail.html','<div class="row"><div class="col-lg-12"><form name="editForm" class="form-horizontal" role="form" novalidate><div class="form-group"><div class="col-md-3"><label for="field_mes" class="control-label">M\xEAs da Compet\xEAncia</label><input type="text" id="field_mes" class="form-control" readonly="readonly" ng-model="declaracaoMensalServico.mes"></div><div class="col-md-3"><label for="field_ano" class="control-label">Ano da Compet\xEAncia</label><input type="text" class="form-control" id="field_ano" readonly="readonly" ng-model="declaracaoMensalServico.exercicio"></div></div><div class="row"><div class="col-md-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-primary pull-right">{{declaracaoMensalServico.mes}}/{{declaracaoMensalServico.exercicio}}</span><h5>Valor Servi\xE7os</h5></div><div class="ibox-content"><h1 class="no-margins">{{declaracaoMensalServico.totalServicos | currency: \'R$\'}}</h1><div class="stat-percent font-bold text-primary"><i class="fa fa-money"></i></div><small>Declaradas na compet\xEAncia</small></div></div></div><div class="col-md-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-danger pull-right">{{declaracaoMensalServico.mes}}/{{declaracaoMensalServico.exercicio}}</span><h5>Valor ISS</h5></div><div class="ibox-content"><h1 class="no-margins">{{declaracaoMensalServico.totalIss | currency: \'R$\'}}</h1><div class="stat-percent font-bold text-danger"><i class="fa fa-barcode"></i></div><small>ISS calculado</small></div></div></div></div><div class="col-md-12"><div class="table-responsive"><table class="table table-striped table-hover table-condensed"><thead><tr><th colspan="8" class="text-center">Servi\xE7os Declarados</th></tr><tr><th>#</th><th>Servi\xE7o</th><th style="text-align: right">Valor Declarado</th><th style="text-align: right">ISS</th></tr></thead><tbody><tr ng-repeat="itemServico in itens"><td>{{$index + 1}}</td><td>{{itemServico.nomeServico}}</td><td style="text-align: right">{{itemServico.valorServico | currency: \'R$\'}}</td><td style="text-align: right">{{itemServico.iss | currency: \'R$\'}}</td></tr></tbody></table></div></div><button type="button" ui-sref="declaracaoMensalServicoCartorio" class="btn btn-default"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp<span>Voltar</span></button></form></div></div>');
$templateCache.put('app/entities/declaracaoMensalServicoCartorio/declaracaoMensalServicoCartorio-edit.html','<div class="row"><div class="col-lg-12"><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="save()"><div class="form-group"><div class="col-md-3"><label for="field_mes" class="control-label">M\xEAs da Compet\xEAncia</label><select class="form-control" id="field_mes" name="mes" ng-model="declaracaoMensalServico.mes" ng-options="mes as mes.descricao for mes in meses track by mes.numeroMes" ng-change="acessarCompetencia();"></div><div class="col-md-3"><label for="field_ano" class="control-label">Ano da Compet\xEAncia</label><input type="text" id="field_ano" name="ano" class="form-control" ng-model="declaracaoMensalServico.exercicio" ng-change="acessarCompetencia();" required><div ng-if="!declaracaoMensalServico.exercicio"><p class="help-block">Informe o ano</p></div></div></div><div class="row" ng-if="itensCartorio"><div class="col-md-12"><table class="table table-striped"><thead><tr><th class="col-md-3">Tipo de Cart\xF3rio</th><th>Servi\xE7o</th><th class="col-md-1">Valor Movimento</th><th class="col-md-1">%</th><th class="col-md-1">ISS</th></tr></thead><tbody><tr ng-repeat="item in itensCartorio" ng-class="{\'success\': (item.valor > 0)}"><td>{{item.tipoCartorioServico.codigo}} - {{item.tipoCartorioServico.descricao}}</td><td>{{item.tipoCartorioServico.codigoServico}} - {{item.tipoCartorioServico.descricaoServico}}</td><td><input type="text" name="itemValor" ng-keyup="atualizarContadores()" class="form-control" ng-model="item.valor" ui-money-mask=""></td><td><input type="text" ng-disabled="true" class="form-control" value="{{item.tipoCartorioServico.servico.aliquota/100 | percentage}}"></td><td><input type="text" ng-disabled="true" class="form-control" value="{{item.valor * (item.tipoCartorioServico.servico.aliquota / 100) | currency: \'R$ \'}}"></td></tr></tbody><tfoot><tr><td colspan="2" class="font-bold" style="text-align: right">Total:</td><td class="col-md-2"><input type="text" ng-disabled="true" class="form-control font-bold" value="{{totalDeclarado | currency: \'R$ \'}}"></td><td class="col-md-1"></td><td class="col-md-2"><input type="text" ng-disabled="true" class="form-control font-bold" value="{{totalIss | currency: \'R$ \'}}"></td></tr></tfoot></table></div></div><button type="button" ui-sref="declaracaoMensalServicoCartorio" class="btn btn-default"><span class="glyphicon glyphicon-ban-circle"></span><span> Cancelar</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editForm.$invalid"><span class="glyphicon glyphicon-check"></span>&nbsp; <span>{{getTextoBotaoSalvar()}}</span></button></form></div></div>');
$templateCache.put('app/entities/declaracaoMensalServicoCartorio/declaracaoMensalServicoCartorio.html','<div class="row"><div class="col-lg-12"><div class="row"><div class="form-group col-md-3"><label for="field_final">Exerc\xEDcio</label><input type="text" id="field_final" name="ano" class="form-control" ng-model="exercicio"></div><div class="form-group col-md-3"><label for="field_mes_inicial" class="control-label">M\xEAs Inicial</label><select class="form-control" id="field_mes_inicial" name="mesInicial" ng-model="mesInicial" ng-options="mes as mes.descricao for mes in meses track by mes.numeroMes"></select></div><div class="form-group col-md-3"><label for="field_mes_final" class="control-label">M\xEAs Final</label><select class="form-control" id="field_mes_final" name="mesFinal" ng-model="mesFinal" ng-options="mes as mes.descricao for mes in meses track by mes.numeroMes"></select></div><div class="form-group col-md-3"><label>&ensp;</label><button class="btn btn-info btn-block" ng-click="loadAll()"><span class="fa fa-search"></span> <span>Filtrar</span></button></div></div><div ng-repeat="exericicoDeclarado in exerciciosDeclarados"><div><div class="table-responsive" ng-repeat="mesDeclarado in exericicoDeclarado.mesesDeclarados"><table class="table table-striped"><thead><tr><th colspan="9">{{\'nfseApp.Mes.\' + mesDeclarado.mes | translate}}/{{exericicoDeclarado.ano}}</th></tr><tr><th>C\xF3digo</th><th>Tipo</th><th>Movimento</th><th>Situacao</th><th>Abertura</th><th>Encerramento</th><th>D\xE9bitos</th><th>Vencimento</th><th>Qtde Doc</th><th>Servi\xE7os</th><th>ISS</th><th>Valor Total</th><th class="text-center">Op\xE7\xF5es</th></tr></thead><tbody><tr ng-show="mesDeclarado.declaracoes.length == 0"><td colspan="12" class="text-center text-danger">A compet\xEAncia {{\'nfseApp.Mes.\' + mesDeclarado.mes | translate}}/{{exericicoDeclarado.ano}} n\xE3o possui declara\xE7\xE3o realizada.</td></tr><tr ng-repeat="declaracaoMensalServico in mesDeclarado.declaracoes | orderBy: \'-codigo\'"><td><a ui-sref="declaracaoMensalServicoCartorio.detail({id:declaracaoMensalServico.id})">{{declaracaoMensalServico.codigo}}</a></td><td>{{\'nfseApp.TipoDeclaracaoMensal.\' + declaracaoMensalServico.tipo | translate}}</td><td>{{\'nfseApp.TipoMovimentoMensal.\' + declaracaoMensalServico.tipoMovimento | translate}}</td><td>{{\'nfseApp.SituacaoDeclaracaoMensal.\' + declaracaoMensalServico.situacao | translate}}</td><td>{{declaracaoMensalServico.abertura | date:\'dd/MM/yyyy\'}}</td><td>{{declaracaoMensalServico.encerramento | date:\'dd/MM/yyyy\'}}</td><td>{{\'nfseApp.SituacaoParcela.\' + declaracaoMensalServico.situacaoDebito | translate}}</td><td>{{declaracaoMensalServico.vencimento | date:\'dd/MM/yyyy\'}}</td><td>{{declaracaoMensalServico.qtdNotas}}</td><td>{{declaracaoMensalServico.totalServicos | number:2}}</td><td>{{declaracaoMensalServico.totalIss | number:2}}</td><td>{{declaracaoMensalServico.totalIss + declaracaoMensalServico.totalJuros + declaracaoMensalServico.totalMulta + declaracaoMensalServico.totalCorrecao | number:2}}</td><td class="text-center"><a title="Imprimir Guia" ng-if="declaracaoMensalServico.situacaoDebito === \'EM_ABERTO\'" ng-click="imprimirDam(declaracaoMensalServico)"><span class="glyphicon glyphicon-print"></span> </a><a title="Cancelar Declara\xE7\xE3o" ng-if="declaracaoMensalServico.situacao != \'CANCELADO\'" ng-click="cancelar(declaracaoMensalServico.id)"><span style="color: red" class="glyphicon glyphicon-remove"></span></a></td></tr><tr><td colspan="13" class="text-center warning"><a ui-sref="declaracaoMensalServicoCartorio.new({mes:mesDeclarado.mes, ano:exericicoDeclarado.ano})"><span class="fa fa-plus"></span> Declarar {{hasDeclaracaoNaoCancelada(mesDeclarado.declaracoes) ? \'Complementar\' : \'\'}}</a></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/declaracaoMensalServicoInstituicaoFinanceira/declaracaoMensalServicoInstituicaoFinanceira-detail.html','<div class="row"><div class="col-lg-12"><form name="editForm" class="form-horizontal" role="form" novalidate><div class="form-group"><div class="col-md-3"><label for="field_mes" class="control-label">M\xEAs da Compet\xEAncia</label><input type="text" id="field_mes" class="form-control" readonly="readonly" ng-model="declaracaoMensalServicoInstituicaoFinanceira.mes"></div><div class="col-md-3"><label for="field_ano" class="control-label">Ano da Compet\xEAncia</label><input type="text" class="form-control" id="field_ano" readonly="readonly" ng-model="declaracaoMensalServicoInstituicaoFinanceira.exercicio"></div></div><div class="row"><div class="col-md-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-primary pull-right">{{declaracaoMensalServicoInstituicaoFinanceira.mes}}/{{declaracaoMensalServicoInstituicaoFinanceira.exercicio}}</span><h5>Saldo Anterior</h5></div><div class="ibox-content"><h1 class="no-margins">{{totalSaldoAnterior | currency: \'R$\'}}</h1><div class="stat-percent font-bold text-primary"><i class="fa fa-money"></i></div></div></div></div><div class="col-md-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-primary pull-right">{{declaracaoMensalServicoInstituicaoFinanceira.mes}}/{{declaracaoMensalServicoInstituicaoFinanceira.exercicio}}</span><h5>Cr\xE9dito</h5></div><div class="ibox-content"><h1 class="no-margins">{{totalCredito | currency: \'R$\'}}</h1><div class="stat-percent font-bold text-primary"><i class="fa fa-money"></i></div></div></div></div><div class="col-md-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-primary pull-right">{{declaracaoMensalServicoInstituicaoFinanceira.mes}}/{{declaracaoMensalServicoInstituicaoFinanceira.exercicio}}</span><h5>D\xE9bito</h5></div><div class="ibox-content"><h1 class="no-margins">{{totalDebito | currency: \'R$\'}}</h1><div class="stat-percent font-bold text-primary"><i class="fa fa-money"></i></div></div></div></div><div class="col-md-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-primary pull-right">{{declaracaoMensalServicoInstituicaoFinanceira.mes}}/{{declaracaoMensalServicoInstituicaoFinanceira.exercicio}}</span><h5>Total de Servi\xE7os</h5></div><div class="ibox-content"><h1 class="no-margins">{{declaracaoMensalServicoInstituicaoFinanceira.totalServicos | currency: \'R$\'}}</h1><div class="stat-percent font-bold text-primary"><i class="fa fa-money"></i></div></div></div></div><div class="col-md-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-danger pull-right">{{declaracaoMensalServicoInstituicaoFinanceira.mes}}/{{declaracaoMensalServicoInstituicaoFinanceira.exercicio}}</span><h5>Total ISS</h5></div><div class="ibox-content"><h1 class="no-margins">{{declaracaoMensalServicoInstituicaoFinanceira.totalIss | currency: \'R$\'}}</h1><div class="stat-percent font-bold text-danger"><i class="fa fa-barcode"></i></div></div></div></div></div><div class="col-md-12"><div class="table-responsive"><table class="table table-striped table-hover table-condensed"><thead><tr><th colspan="8" class="text-center">Contas Declaradas</th></tr><tr><th>Conta</th><th>Nome</th><th style="text-align: right">Saldo Anterior</th><th style="text-align: right">Cr\xE9dito</th><th style="text-align: right">D\xE9bito</th><th style="text-align: right">Valor do Movimento</th><th style="text-align: right">%</th><th style="text-align: right">ISS</th></tr></thead><tbody><tr ng-repeat="itemServico in itens"><td><div ng-if="prestador.enquadramentoFiscal.versaoDesif == \'VERSAO_1_0\'">{{itemServico.conta.conta}}</div><div ng-if="prestador.enquadramentoFiscal.versaoDesif == \'VERSAO_ABRASF_3_1\'">{{itemServico.conta.conta}} - {{itemServico.conta.desdobramento}}</div></td><td>{{itemServico.conta.nome}}</td><td style="text-align: right">{{itemServico.saldoAnterior | currency: \'R$ \'}}</td><td style="text-align: right">{{itemServico.credito | currency: \'R$ \'}}</td><td style="text-align: right">{{itemServico.debito | currency: \'R$ \'}}</td><td style="text-align: right">{{itemServico.valorServico | currency: \'R$ \'}}</td><td style="text-align: right">{{itemServico.servico.aliquota / 100 | percentage}}</td><td style="text-align: right">{{itemServico.iss | currency: \'R$ \'}}</td></tr></tbody></table></div></div><button type="button" ui-sref="declaracaoMensalServicoInstituicaoFinanceira" class="btn btn-default"><span class="glyphicon glyphicon-ban-circle"></span><span>Voltar</span></button></form></div></div>');
$templateCache.put('app/entities/declaracaoMensalServicoInstituicaoFinanceira/declaracaoMensalServicoInstituicaoFinanceira-edit.html','<div class="row"><div class="col-lg-12"><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="save()"><div class="form-group"><div class="col-md-3"><label for="field_mes" class="control-label">M\xEAs da Compet\xEAncia</label><select class="form-control" id="field_mes" name="mes" ng-model="declaracaoMensalServico.mes" ng-options="mes as mes.descricao for mes in meses track by mes.numeroMes" ng-change="acessarCompetencia();"></div><div class="col-md-3"><label for="field_ano" class="control-label">Ano da Compet\xEAncia</label><input type="text" id="field_ano" name="ano" class="form-control" ng-model="declaracaoMensalServico.exercicio" ng-change="acessarCompetencia();" required><div ng-if="!declaracaoMensalServico.exercicio"><p class="help-block">Informe o ano</p></div></div></div><div class="row" ng-if="contasBancarias"><div class="col-md-12"><table class="table table-striped"><thead><tr><th>Conta</th><th>Nome</th><th>Saldo Anterior</th><th>Cr\xE9dito</th><th>D\xE9bito</th><th>Valor Movimento</th><th>%</th><th>ISS</th></tr></thead><tbody><tr ng-repeat="contaBancaria in contasBancarias" ng-class="{\'success\': (contaBancaria.baseCalculo > 0)}"><td><div ng-if="prestador.enquadramentoFiscal.versaoDesif == \'VERSAO_1_0\'">{{contaBancaria.conta.conta}}</div><div ng-if="prestador.enquadramentoFiscal.versaoDesif == \'VERSAO_ABRASF_3_1\'">{{contaBancaria.conta.conta}} - {{contaBancaria.conta.desdobramento}}</div></td><td>{{contaBancaria.conta.nome}}</td><td><input type="text" ng-keyup="atualizarContadores()" class="form-control" ng-model="contaBancaria.saldoInicial" ui-money-mask=""></td><td><input type="text" ng-keyup="atualizarContadores()" class="form-control" ng-model="contaBancaria.valorCredito" ui-money-mask=""></td><td><input type="text" ng-keyup="atualizarContadores()" class="form-control" ng-model="contaBancaria.valorDebito" ui-money-mask=""></td><td><input type="text" ng-keyup="atualizarContadores()" class="form-control" ng-model="contaBancaria.baseCalculo" ui-money-mask=""></td><td><input type="text" ng-disabled="true" ng-keyup="atualizarContadores()" class="form-control" value="{{contaBancaria.aliquotaIssqn / 100 | percentage}}"></td><td><input type="text" ng-disabled="true" ng-keyup="atualizarContadores()" class="form-control" value="{{contaBancaria.baseCalculo * (contaBancaria.aliquotaIssqn / 100) | currency: \'R$ \'}}"></td></tr></tbody><tfoot><tr><td colspan="2" style="text-align: right">Total:</td><td><input type="text" ng-disabled="true" class="form-control" ng-model="totalSaldoAnterior" ui-money-mask=""></td><td><input type="text" ng-disabled="true" class="form-control" ng-model="totalCredito" ui-money-mask=""></td><td><input type="text" ng-disabled="true" class="form-control" ng-model="totalDebito" ui-money-mask=""></td><td><input type="text" ng-disabled="true" class="form-control" ng-model="totalDeclarado" ui-money-mask=""></td><td></td><td><input type="text" ng-disabled="true" class="form-control" ng-model="totalIss" ui-money-mask=""></td></tr></tfoot></table></div></div><button type="button" ui-sref="declaracaoMensalServicoInstituicaoFinanceira" class="btn btn-default"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editForm.$invalid"><span class="glyphicon glyphicon-check"></span>&nbsp; <span>{{getTextoBotaoSalvar()}}</span></button></form></div></div>');
$templateCache.put('app/entities/declaracaoMensalServicoInstituicaoFinanceira/declaracaoMensalServicoInstituicaoFinanceira-import.html','<div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><form name="editForm" role="form" novalidate><div class="form-group" ng-show="!arquivoSelecionado"><div class="col-md-8 col-md-offset-2 text-center"><label for="file-upload" class="custom-file-upload"><span class="fa fa-cloud-upload"></span> Selecionar Arquivo</label><input type="file" id="file-upload" name="file" ngf-select="uploadXmlFile($file)" ng-model="arquivo" ngf-max-size="15MB"></div></div><div ng-show="arquivoSelecionado"><div class="form-group col-md-12 border-bottom"><h3>Dados do Arquivo</h3></div><div class="form-group col-md-4"><label>Nome</label><input type="text" readonly="readonly" class="form-control" value="{{arquivoSelecionado.name}}"></div><div class="form-group col-md-4"><label>Tamanho</label><input type="text" readonly="readonly" class="form-control" value="{{arquivoSelecionado.size}}"></div><div class="form-group col-md-4"></div><div class="form-group col-md-12"><button type="submit" class="btn btn-warning" ng-click="arquivoSelecionado = null"><span class="fa fa-times"></span>&nbsp;Cancelar</button> <button type="submit" class="btn btn-primary" ng-click="enviarArquivo()"><span class="glyphicon glyphicon-save"></span>&nbsp;Confirmar</button></div></div></form></div></div></div>');
$templateCache.put('app/entities/declaracaoMensalServicoInstituicaoFinanceira/declaracaoMensalServicosInstituicaoFinanceira.html','<div class="row"><div class="col-lg-12"><div class="row"><div class="form-group col-md-2"><label for="field_final">Exerc\xEDcio</label><input type="text" id="field_final" name="ano" class="form-control" ng-model="exercicio"></div><div class="form-group col-md-2"><label for="field_mes_inicial" class="control-label">M\xEAs Inicial</label><select class="form-control" id="field_mes_inicial" name="mesInicial" ng-model="mesInicial" ng-options="mes as mes.descricao for mes in meses track by mes.numeroMes"></select></div><div class="form-group col-md-2"><label for="field_mes_final" class="control-label">M\xEAs Final</label><select class="form-control" id="field_mes_final" name="mesFinal" ng-model="mesFinal" ng-options="mes as mes.descricao for mes in meses track by mes.numeroMes"></select></div><div class="form-group col-md-2"><label>&ensp;</label><button class="btn btn-info btn-block" ng-click="loadAll()"><span class="fa fa-search"></span> <span>Filtrar</span></button></div><div class="form-group col-md-2"><label>&ensp;</label><button class="btn btn-success btn-block" ui-sref="declaracaoMensalServicoInstituicaoFinanceira.new"><span class="fa fa-plus-circle"></span> <span>Declarar</span></button></div><div class="form-group col-md-2" ng-if="empresa.prestador.enquadramentoFiscal.versaoDesif == \'VERSAO_1_0\'"><label>&ensp;</label><button class="btn btn-success btn-block" ui-sref="declaracaoMensalServicoInstituicaoFinanceira.import"><span class="fa fa-upload"></span> <span>Importar</span></button></div></div><div ng-repeat="exericicoDeclarado in exerciciosDeclarados"><div><div class="table-responsive" ng-repeat="mesDeclarado in exericicoDeclarado.mesesDeclarados"><table class="table table-striped"><thead><tr><th colspan="9">{{\'nfseApp.Mes.\' + mesDeclarado.mes | translate}}/{{exericicoDeclarado.ano}}</th></tr><tr><th>C\xF3digo</th><th>Tipo</th><th>Movimento</th><th>Situacao</th><th>Abertura</th><th>Encerramento</th><th>D\xE9bitos</th><th>Vencimento</th><th>Qtde Doc</th><th>Servi\xE7os</th><th>ISS</th><th>Valor Total</th><th class="text-center">Guia</th></tr></thead><tbody><tr ng-show="mesDeclarado.declaracoes.length == 0"><td colspan="12" class="text-center text-danger">A compet\xEAncia {{\'nfseApp.Mes.\' + mesDeclarado.mes | translate}}/{{exericicoDeclarado.ano}} n\xE3o possui declara\xE7\xE3o realizada.<br></td></tr><tr ng-repeat="declaracaoMensalServico in mesDeclarado.declaracoes | orderBy: \'-codigo\'"><td><a ui-sref="declaracaoMensalServicoInstituicaoFinanceira.detail({id:declaracaoMensalServico.id})">{{declaracaoMensalServico.codigo}}</a></td><td>{{\'nfseApp.TipoDeclaracaoMensal.\' + declaracaoMensalServico.tipo | translate}}</td><td>{{\'nfseApp.TipoMovimentoMensal.\' + declaracaoMensalServico.tipoMovimento | translate}}</td><td>{{\'nfseApp.SituacaoDeclaracaoMensal.\' + declaracaoMensalServico.situacao | translate}}</td><td>{{declaracaoMensalServico.abertura | date:\'dd/MM/yyyy\'}}</td><td>{{declaracaoMensalServico.encerramento | date:\'dd/MM/yyyy\'}}</td><td>{{\'nfseApp.SituacaoParcela.\' + declaracaoMensalServico.situacaoDebito | translate}}</td><td>{{declaracaoMensalServico.vencimento | date:\'dd/MM/yyyy\'}}</td><td>{{declaracaoMensalServico.qtdNotas}}</td><td>{{declaracaoMensalServico.totalServicos | number:2}}</td><td>{{declaracaoMensalServico.totalIss | number:2}}</td><td>{{declaracaoMensalServico.totalIss + declaracaoMensalServico.totalJuros + declaracaoMensalServico.totalMulta + declaracaoMensalServico.totalCorrecao | number:2}}</td><td class="text-center"><a title="Imprimir Guia" ng-if="declaracaoMensalServico.situacaoDebito === \'EM_ABERTO\'" ng-click="imprimirDam(declaracaoMensalServico)"><span class="glyphicon glyphicon-print"></span> </a><a title="Emitir Protocolo" ng-if="declaracaoMensalServico.situacao === \'ENCERRADO\'" ng-click="emitirProtocoloRecebimentoDms(declaracaoMensalServico.id)"><span style="color: blue" class="glyphicon glyphicon-align-left"></span> </a><a title="Cancelar Declara\xE7\xE3o" ng-if="declaracaoMensalServico.situacao != \'CANCELADO\'" ng-click="cancelar(declaracaoMensalServico.id)"><span style="color: red" class="glyphicon glyphicon-remove"></span></a></td></tr><tr><td colspan="13" class="text-center warning"><a ui-sref="declaracaoMensalServicoInstituicaoFinanceira.new({mes:mesDeclarado.mes, ano:exericicoDeclarado.ano})"><span class="fa fa-plus"></span> Declarar {{mesDeclarado.declaracoes.length > 0 ? \'Complementar\' : \'\'}}</a></td></tr></tbody></table><button type="submit" ng-show="mesDeclarado.declaracoes.length > 0" ng-click="imprimeRelatorioDMS(exericicoDeclarado.ano, mesDeclarado.mes)" class="btn btn-info btn-sm pull-right"><span class="glyphicon glyphicon-print"></span> Declara\xE7\xF5es ({{\'nfseApp.Mes.\' + mesDeclarado.mes | translate}}/{{exericicoDeclarado.ano}})</button></div></div></div></div></div>');
$templateCache.put('app/entities/declaracaoMensalServicoRetencao/declaracaoMensalServicoRetencao-detail.html','<div class="row"><div class="col-lg-12"><form name="editForm" class="form-horizontal" role="form" novalidate><div class="form-group"><div class="col-md-3"><label for="field_mes" class="control-label">M\xEAs da Compet\xEAncia</label><input type="text" id="field_mes" class="form-control" readonly="readonly" ng-model="declaracaoMensalServico.mes"></div><div class="col-md-3"><label for="field_ano" class="control-label">Ano da Compet\xEAncia</label><input type="text" class="form-control" id="field_ano" readonly="readonly" ng-model="declaracaoMensalServico.exercicio"></div></div><div class="row"><div class="col-md-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-info pull-right">{{declaracaoMensalServico.mes}}/{{declaracaoMensalServico.exercicio}}</span><h5>Quantidade de notas</h5></div><div class="ibox-content"><h1 class="no-margins">{{declaracaoMensalServico.qtdNotas}}</h1><div class="stat-percent font-bold text-info"><i class="fa fa-check-square-o"></i></div></div></div></div><div class="col-md-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-primary pull-right">{{declaracaoMensalServico.mes}}/{{declaracaoMensalServico.exercicio}}</span><h5>Valor Servi\xE7os</h5></div><div class="ibox-content"><h1 class="no-margins">{{declaracaoMensalServico.totalServicos | currency: \'R$\'}}</h1><div class="stat-percent font-bold text-primary"><i class="fa fa-money"></i></div></div></div></div><div class="col-md-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-danger pull-right">{{declaracaoMensalServico.mes}}/{{declaracaoMensalServico.exercicio}}</span><h5>ISS Retido</h5></div><div class="ibox-content"><h1 class="no-margins">{{declaracaoMensalServico.totalIss | currency: \'R$\'}}</h1><div class="stat-percent font-bold text-primary"><i class="fa fa-money"></i></div></div></div></div></div><div class="col-md-12"><div class="table-responsive"><table class="table table-striped table-hover table-condensed"><thead><tr><th colspan="12" class="text-center">Notas Fiscais</th></tr><tr><th>#</th><th>Tipo</th><th>N\xFAmero</th><th>Emiss\xE3o</th><th>Tomador</th><th>CPF/CNPJ</th><th>Situa\xE7\xE3o</th><th style="text-align: right">Valor Servi\xE7os</th><th style="text-align: right">Valor ISS Retido</th></tr></thead><tbody><tr ng-repeat="nota in notas | orderBy: \'-numero\'"><td>{{$index + 1}}</td><td>{{\'nfseApp.TipoDocumento.\'+ nota.tipoDocumentoNfse | translate}}</td><td>{{nota.numero}}</td><td>{{nota.emissao | date: \'dd/MM/yyyy\'}}</td><td>{{nota.nomePrestador}}</td><td>{{nota.cpfCnpjPrestador}}</td><td>{{nota.situacao}}</td><td style="text-align: right">{{nota.totalServicos | currency: \'R$\'}}</td><td style="text-align: right">{{nota.issRetido ? nota.issCalculado : 0.0 | currency: \'R$\'}}</td></tr></tbody></table></div><span nfse-app-pagination></div><button type="button" ui-sref="declaracaoMensalServicoRetencao" class="btn btn-default"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span>Voltar</span></button></form></div></div>');
$templateCache.put('app/entities/declaracaoMensalServicoRetencao/declaracaoMensalServicoRetencao-edit.html','<div class="row"><div class="col-lg-12"><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="save()"><div class="form-group"><div class="col-md-3"><label for="field_mes" class="control-label">M\xEAs da Compet\xEAncia</label><select class="form-control" id="field_mes" name="mes" ng-model="mes" ng-options="mes as mes.descricao for mes in meses track by mes.numeroMes" ng-change="acessarCompetencia();"></div><div class="col-md-3"><label for="field_ano" class="control-label">Ano da Compet\xEAncia</label><input type="text" id="field_ano" name="ano" class="form-control" ng-model="ano" ng-change="acessarCompetencia();" required><div ng-if="!ano"><p class="help-block">Informe o ano</p></div></div></div><div class="row" ng-if="declaracaoMensalServico"><div class="col-md-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-success pull-right">{{declaracaoMensalServico.mes}}/{{declaracaoMensalServico.exercicio}}</span><h5>Quantidade de Notas</h5></div><div class="ibox-content"><h1 class="no-margins">{{declaracaoMensalServico.qtdNotas}}</h1><div class="stat-percent font-bold text-success"><i class="fa fa-edit"></i></div></div></div></div><div class="col-md-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-primary pull-right">{{declaracaoMensalServico.mes}}/{{declaracaoMensalServico.exercicio}}</span><h5>Total dos Servi\xE7os</h5></div><div class="ibox-content"><h1 class="no-margins">{{declaracaoMensalServico.totalServicos | currency: \'R$\'}}</h1><div class="stat-percent font-bold text-primary"><i class="fa fa-money"></i></div></div></div></div><div class="col-md-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-danger pull-right">{{declaracaoMensalServico.mes}}/{{declaracaoMensalServico.exercicio}}</span><h5>ISS Retido</h5></div><div class="ibox-content"><h1 class="no-margins">{{declaracaoMensalServico.totalIss | currency: \'R$\'}}</h1><div class="stat-percent font-bold text-danger"><i class="fa fa-barcode"></i></div></div></div></div></div><div class="row"><div class="col-md-offset-5 col-md-2"><button type="button" class="btn btn-info" ng-click="selecionarNotas()"><span class="glyphicon glyphicon-check"></span>&nbsp; <span>Selecionar Notas</span></button></div></div><div class="col-md-12"><div class="table-responsive" ng-show="declaracaoMensalServico.notas && declaracaoMensalServico.notas.length > 0"><table class="table table-striped table-hover table-condensed"><thead><tr><th colspan="10" class="text-center">Notas Fiscais Selecionadas</th></tr><tr><th>Tipo</th><th>N\xFAmero</th><th>Emiss\xE3o</th><th>Prestador</th><th>CPF/CNPJ</th><th>Situa\xE7\xE3o</th><th style="text-align: right">Valor Servi\xE7os</th><th style="text-align: right">Valor ISS Retido</th></tr></thead><tbody><tr ng-repeat="nota in declaracaoMensalServico.notas"><td>{{\'nfseApp.TipoDocumento.\'+nota.tipoDocumentoNfse | translate}}</td><td>{{nota.numero}}</td><td>{{nota.emissao | date: \'dd/MM/yyyy\'}}</td><td>{{nota.nomePrestador}}</td><td>{{nota.cpfCnpjPrestador}}</td><td>{{nota.situacao}}</td><td style="text-align: right">{{nota.totalServicos | currency: \'R$\'}}</td><td style="text-align: right">{{nota.issRetido ? nota.issCalculado : 0.0 | currency: \'R$\'}}</td></tr></tbody></table></div></div><button type="button" ui-sref="declaracaoMensalServicoRetencao" class="btn btn-default"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-if="declaracaoMensalServico" ng-disabled="editForm.$invalid"><span class="glyphicon glyphicon-check"></span>&nbsp; <span>{{declaracaoMensalServico.qtdNotas > 0 ? \'Encerrar Declara\xE7\xE3o\' : \'Declarar Aus\xEAncia de Movimento\'}}</span></button></form></div></div>');
$templateCache.put('app/entities/declaracaoMensalServicoRetencao/declaracaoMensalServicosRetencao.html','<div class="row"><div class="col-lg-12"><div class="row"><div class="form-group col-md-3"><label for="field_final">Exerc\xEDcio</label><input type="text" id="field_final" name="ano" class="form-control" ng-model="exercicio"></div><div class="form-group col-md-3"><label for="field_mes_inicial" class="control-label">M\xEAs Inicial</label><select class="form-control" id="field_mes_inicial" name="mesInicial" ng-model="mesInicial" ng-options="mes as mes.descricao for mes in meses track by mes.numeroMes"></select></div><div class="form-group col-md-3"><label for="field_mes_final" class="control-label">M\xEAs Final</label><select class="form-control" id="field_mes_final" name="mesFinal" ng-model="mesFinal" ng-options="mes as mes.descricao for mes in meses track by mes.numeroMes"></select></div><div class="form-group col-md-3"><label>&ensp;</label><button class="btn btn-info btn-block" ng-click="loadAll()"><span class="fa fa-search"></span> <span>Filtrar</span></button></div></div><div ng-repeat="exericicoDeclarado in exerciciosDeclarados"><div><div class="table-responsive" ng-repeat="mesDeclarado in exericicoDeclarado.mesesDeclarados"><table class="table table-striped"><thead><tr><th colspan="9">{{\'nfseApp.Mes.\' + mesDeclarado.mes | translate}}/{{exericicoDeclarado.ano}}</th></tr><tr><th>C\xF3digo</th><th>Tipo</th><th>Movimento</th><th>Situacao</th><th>Abertura</th><th>Encerramento</th><th>D\xE9bitos</th><th>Vencimento</th><th>Qtde Doc</th><th>Servi\xE7os</th><th>ISS</th><th>Valor Total</th><th class="text-center">Op\xE7\xF5es</th></tr></thead><tbody><tr ng-show="mesDeclarado.declaracoes.length == 0"><td colspan="12" class="text-center text-danger">A compet\xEAncia {{\'nfseApp.Mes.\' + mesDeclarado.mes | translate}}/{{exericicoDeclarado.ano}} n\xE3o possui declara\xE7\xE3o realizada.<br></td></tr><tr ng-repeat="declaracaoMensalServico in mesDeclarado.declaracoes | orderBy: \'-codigo\'"><td><a ui-sref="declaracaoMensalServicoRetencao.detail({id:declaracaoMensalServico.id})">{{declaracaoMensalServico.codigo}}</a></td><td>{{\'nfseApp.TipoDeclaracaoMensal.\' + declaracaoMensalServico.tipo | translate}}</td><td>{{\'nfseApp.TipoMovimentoMensal.\' + declaracaoMensalServico.tipoMovimento | translate}}</td><td>{{\'nfseApp.SituacaoDeclaracaoMensal.\' + declaracaoMensalServico.situacao | translate}}</td><td>{{declaracaoMensalServico.abertura | date:\'dd/MM/yyyy\'}}</td><td>{{declaracaoMensalServico.encerramento | date:\'dd/MM/yyyy\'}}</td><td>{{\'nfseApp.SituacaoParcela.\' + declaracaoMensalServico.situacaoDebito | translate}}</td><td>{{declaracaoMensalServico.vencimento | date:\'dd/MM/yyyy\'}}</td><td>{{declaracaoMensalServico.qtdNotas}}</td><td>{{declaracaoMensalServico.totalServicos | number:2}}</td><td>{{declaracaoMensalServico.totalIss | number:2}}</td><td>{{declaracaoMensalServico.totalIss + declaracaoMensalServico.totalJuros + declaracaoMensalServico.totalMulta + declaracaoMensalServico.totalCorrecao | number:2}}</td><td class="text-center"><a title="Imprimir Guia" ng-if="declaracaoMensalServico.situacaoDebito === \'EM_ABERTO\'" ng-click="imprimirDam(declaracaoMensalServico)"><span class="glyphicon glyphicon-print"></span> </a><a title="Emitir Protocolo" ng-if="declaracaoMensalServico.situacao === \'ENCERRADO\'" ng-click="emitirProtocoloRecebimentoDms(declaracaoMensalServico.id)"><span style="color: blue" class="glyphicon glyphicon-align-left"></span> </a><a title="Cancelar Declara\xE7\xE3o" ng-if="declaracaoMensalServico.situacao != \'CANCELADO\'" ng-click="cancelar(declaracaoMensalServico.id)"><span style="color: red" class="glyphicon glyphicon-remove"></span></a></td></tr><tr><td colspan="13" class="text-center warning"><a ui-sref="declaracaoMensalServicoRetencao.new({mes:mesDeclarado.mes, ano:exericicoDeclarado.ano})"><span class="fa fa-plus"></span> Declarar {{mesDeclarado.declaracoes.length > 0 ? \'Complementar\' : \'\'}}</a></td></tr></tbody></table><button type="submit" ng-show="mesDeclarado.declaracoes.length > 0 && !empresa.prestador.foraMunicipio" ng-click="imprimeRelatorioDMS(exericicoDeclarado.ano, mesDeclarado.mes)" class="btn btn-info btn-sm pull-right"><span class="glyphicon glyphicon-print"></span> Declara\xE7\xF5es ({{\'nfseApp.Mes.\' + mesDeclarado.mes | translate}}/{{exericicoDeclarado.ano}})</button></div></div></div></div></div>');
$templateCache.put('app/entities/declaracaoMensalServicoRetencao/pesquisaNotasRecebidas.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title" id="myServicoLabel">Notas Recebidas</h4></div><div class="modal-body"><div class="col-md-12"><div class="table-responsive" ng-show="notas && notas.length > 0"><table class="table table-striped table-hover table-condensed"><thead><tr><th></th><th>Tipo</th><th><span>N\xFAmero</span><br><small>Emiss\xE3o</small></th><th>Prestador</th><th style="text-align: right">Valor Servi\xE7os</th><th style="text-align: right">ISS Retido</th></tr></thead><tbody><tr ng-repeat="nota in notas"><td><button class="btn btn-success" ng-if="indexNotaSelecionada(nota) >= 0" ng-click="selecionarNota(nota)"><span class="glyphicon glyphicon-check"></span></button> <button class="btn btn-default" ng-if="indexNotaSelecionada(nota) < 0" ng-click="selecionarNota(nota)"><span class="glyphicon glyphicon-unchecked"></span></button></td><td>{{\'nfseApp.TipoDocumento.\'+nota.tipoDocumentoNfse | translate}}</td><td><span>{{nota.numero}}</span><br><small>{{nota.emissao | date: \'dd/MM/yyyy\'}}</small></td><td>{{nota.nomePrestador}} ({{nota.cpfCnpjPrestador}})</td><td style="text-align: right">{{nota.totalServicos | currency: \'R$\'}}</td><td style="text-align: right">{{nota.issCalculado | currency: \'R$\'}}</td></tr></tbody></table></div><span nfse-app-pagination></div></div><div class="modal-footer"><button type="button" ng-click="ok()" class="btn btn-success"><span class="glyphicon glyphicon-check"></span>&nbsp; <span>Ok</span></button></div>');
$templateCache.put('app/entities/escritorioContabil/escritorioContabil-search.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title" id="myServicoLabel">Selecione um Escrit\xF3rio</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><div class="form-group input-group"><input type="text" class="form-control" ng-model="searchQuery" id="searchQuery" placeholder="{{\'global.form.search\' | translate}}"> <span class="input-group-btn"><button class="btn btn-info" ng-click="loadAll()"><span class="glyphicon glyphicon-search"></span></button></span></div></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th>C\xF3digo</th><th>Nome Escrit\xF3rio</th><th>Cnpj</th><th>Crc</th><th>Nome Contabor</th><th>Cpf</th><th>Crc</th><th></th></tr></thead><tbody><tr ng-repeat="escritorio in escritorios"><td>{{escritorio.codigo}}</td><td>{{escritorio.dadosPessoais.nomeRazaoSocial}}</td><td>{{escritorio.dadosPessoais.cpfCnpj}}</td><td>{{escritorio.crcEscritorio}}</td><td>{{escritorio.responsavel.nomeRazaoSocial}}</td><td>{{escritorio.responsavel.cpfCnpj}}</td><td>{{escritorio.crcContador}}</td><td class="pull-right"><button type="submit" ng-click="ok(escritorio)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-check"></span></button></td></tr></tbody></table></div><span nfse-app-pagination></div>');
$templateCache.put('app/entities/eventosimplesnacional/eventosimplesnacional.html','<div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-md-8"><search-box ng-model="searchQuery" search-method="loadAll()"></search-box></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th class="col-lg-2">Data do Efeito</th><th class="col-lg-10">Evento</th></tr></thead><tbody><tr ng-repeat="evento in eventos"><td class="col-lg-2">{{evento.dataEfeito | date:"dd/MM/yyyy"}}</td><td class="col-lg-10">{{evento.tipoEventoSimplesNacionalNfseDTO.nome}}</td></tr></tbody></table><nav><ul class="pager"><li ng-show="links[\'first\']" ng-click="loadPage(links[\'first\'])"><a href="#">&lt;&lt;</a></li><li ng-show="links[\'prev\']" ng-click="loadPage(links[\'prev\'])"><a href="#">&lt;</a></li><li ng-show="links[\'next\']" ng-click="loadPage(links[\'next\'])"><a href="#">&gt;</a></li><li ng-show="links[\'last\']" ng-click="loadPage(links[\'last\'])"><a href="#">&gt;&gt;</a></li></ul></nav></div></div></div></div></div>');
$templateCache.put('app/entities/guia/guia-detail.html','<div><h2><span translate="nfseApp.guia.detail.title">Guia</span> {{guia.id}}</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span translate="nfseApp.guia.guia">Guia</span></td><td><input type="text" class="input-sm form-control" value="{{guia.guia}}" readonly="readonly"></td></tr><tr><td><span translate="nfseApp.guia.valor">Valor</span></td><td><input type="text" class="input-sm form-control" value="{{guia.valor}}" readonly="readonly"></td></tr><tr><td><span translate="nfseApp.guia.dataVencimento">DataVencimento</span></td><td><input type="text" class="input-sm form-control" value="{{guia.dataVencimento}}" readonly="readonly"></td></tr><tr><td><span translate="nfseApp.guia.declaracaoMensalServico">declaracaoMensalServico</span></td><td><input type="text" class="input-sm form-control" value="{{guia.declaracaoMensalServico.id}}" readonly="readonly"></td></tr></tbody></table></div><button type="submit" ui-sref="guia" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/entities/guia/guia-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myGuiaLabel" translate="nfseApp.guia.home.createOrEditLabel">Create or edit a Guia</h4></div><div class="modal-body"><div class="form-group"><label translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="guia.id" readonly="readonly"></div><div class="form-group"><label translate="nfseApp.guia.guia" for="field_guia">Guia</label><input type="text" class="form-control" name="guia" id="field_guia" ng-model="guia.guia"></div><div class="form-group"><label translate="nfseApp.guia.valor" for="field_valor">Valor</label><input type="number" class="form-control" name="valor" id="field_valor" ng-model="guia.valor"></div><div class="form-group"><label translate="nfseApp.guia.dataVencimento" for="field_dataVencimento">DataVencimento</label><input type="date" class="form-control" name="dataVencimento" id="field_dataVencimento" ng-model="guia.dataVencimento"></div><div class="form-group"><label translate="nfseApp.guia.declaracaoMensalServico" for="field_declaracaoMensalServico">declaracaoMensalServico</label><select class="form-control" id="field_declaracaoMensalServico" name="declaracaoMensalServico" ng-model="guia.declaracaoMensalServico.id" ng-options="declaracaoMensalServico.id as declaracaoMensalServico.id for declaracaoMensalServico in declaracaomensalservicos"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/guia/guias.html','<div><h2 translate="nfseApp.guia.home.title">Guias</h2><div class="container"><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="guia.new"><span class="glyphicon glyphicon-flash"></span> <span translate="nfseApp.guia.home.createLabel">Create a new Guia</span></button></div><div class="col-md-8"><form name="searchForm" class="form-inline"><div class="form-group"><input type="text" class="form-control" ng-model="searchQuery" id="searchQuery" placeholder="query"></div><button class="btn btn-info" ng-click="search()"><span class="glyphicon glyphicon-search"></span> <span>Search a Guia</span></button></form></div></div></div><div class="modal fade" id="deleteGuiaConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(guia.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="nfseApp.guia.delete.question" translate-values="{id: \'{{guia.id}}\'}">Are you sure you want to delete this Guia?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="global.field.id">ID</th><th translate="nfseApp.guia.guia">Guia</th><th translate="nfseApp.guia.valor">Valor</th><th translate="nfseApp.guia.dataVencimento">DataVencimento</th><th translate="nfseApp.guia.declaracaoMensalServico">declaracaoMensalServico</th><th></th></tr></thead><tbody><tr ng-repeat="guia in guias"><td><a ui-sref="guia.detail({id:guia.id})">{{guia.id}}</a></td><td>{{guia.guia}}</td><td>{{guia.valor}}</td><td>{{guia.dataVencimento}}</td><td>{{guia.declaracaoMensalServico.id}}</td><td><button type="submit" ui-sref="guia.detail({id:guia.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span>&nbsp;<span translate="entity.action.view"> View</span></button> <button type="submit" ui-sref="guia.edit({id:guia.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button type="submit" ng-click="delete(guia.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete"> Delete</span></button></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/impressaoPdf/dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">Visualizar Arquivo</h4></div><div class="modal-body"><div class="row"><div class="col-md-12 text-muted text-center"><small>N\xE3o consegue visualizar o arquivo? <a ng-click="vm.baixarAnexo()">Clique aqui</a> para fazer download</small></div></div><div class="row m-t-md"><div class="col-md-12 text-center"><embed ng-show="vm.conteudo" ng-src="{{vm.conteudo}}" style="min-width: 100%; min-height: 500px"></div></div></div>');
$templateCache.put('app/entities/impressaoPdf/template.html','<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><title></title><link rel="stylesheet" href="bower_components/bootstrap/dist/css/bootstrap.css"><!-- Font awesome --><link href="assets/font-awesome/css/font-awesome.css" rel="stylesheet"><!-- Main Inspinia CSS files --><link href="assets/css/animate.css" rel="stylesheet"><link id="loadBefore" href="assets/css/style.css" rel="stylesheet"><link href="assets/styles/documentation.css" rel="stylesheet"></head><body><div class="text-center" style="border-bottom: 1px solid #E7EAEC"><button class="btn btn-default" type="button" ng-click="goPrevious()"><i class="fa fa-arrow-circle-left"></i></button> <button class="btn btn-white" type="button" ng-click="zoomIn()"><i class="fa fa-plus-circle"></i></button> <button class="btn btn-success" type="button" ng-click="print()"><i class="fa fa-print"></i></button> <button class="btn btn-white" type="button" ng-click="zoomOut()"><i class="fa fa-minus-circle"></i></button> <button class="btn btn-default" type="button" ng-click="goNext()"><i class="fa fa-arrow-circle-right"></i></button></div><div style="overflow: auto; max-height: 400px; max-width: 100%"><canvas id="pdf" class="rotate0"></canvas></div></body></html>');
$templateCache.put('app/entities/livroFiscal/livroFiscal.html','<div class="ibox animated fadeInDown"><div class="ibox-content"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-md-5"><label>Per\xEDodo Inicial</label></div><div class="col-md-5"><label>Per\xEDodo Final</label></div></div><div class="row"><div class="form-group col-md-2"><input type="text" id="field_inicial" ng-required class="form-control" ng-model="exercicioInicial"></div><div class="form-group col-md-3"><select class="form-control" id="field_mes_inicial" ng-required ng-model="mesInicial" ng-options="mes as mes.descricao for mes in meses track by mes.numeroMes"></select></div><div class="form-group col-md-2"><input type="text" id="field_final" ng-required class="form-control" ng-model="exercicioFinal"></div><div class="form-group col-md-3"><select class="form-control" id="field_mes_final" ng-model="mesFinal" ng-options="mes as mes.descricao for mes in meses track by mes.numeroMes"></select></div><div class="form-group col-md-2"><button class="btn btn-info btn-block" ng-disabled="!exercicioInicial || !exercicioFinal" ng-click="loadAll()"><span class="fa fa-search"></span> <span>Filtrar</span></button></div></div></div></div></div></div><div class="ibox animated fadeInDown" ng-if="(competenciasServicosPrestados && competenciasServicosPrestados.length > 0) &&\n     (competenciasServicosTomados && competenciasServicosTomados.length > 0)"><div class="ibox-content"><div class="row"><div class="col-md-12"><ul class="nav nav-tabs" role="tablist"><li ng-if="!prestador.enquadramentoFiscal.instituicaoFinanceira"><a class="nav-link {{activeTab == 0 ? \'active\' : \'\'}}" data-toggle="tab" ng-click="mudarTab(0)">Servi\xE7os Prestados</a></li><li ng-if="prestador.enquadramentoFiscal.instituicaoFinanceira"><a class="nav-link {{activeTab == 1 ? \'active\' : \'\'}}" data-toggle="tab" ng-click="mudarTab(1)">Servi\xE7os Prestados</a></li><li><a class="nav-link {{activeTab == 2 ? \'active\' : \'\'}}" data-toggle="tab" ng-click="mudarTab(2)">Servi\xE7os Tomados</a></li></ul><div class="tabs-container"><div class="tab-content"><div role="tabpanel" id="tab-0" class="tab-pane {{activeTab == 0 ? \'active\' : \'\'}}"><div class="table-responsive"><table class="table table-striped table-hover table-condensed"><thead><tr><th colspan="2"></th><th colspan="4" style="text-align: center!important"><small>Notas fiscais escrituradas</small></th><th colspan="4" style="text-align: center!important"><small>Notas fiscais n\xE3o escrituradas</small></th></tr><tr><th></th><th><small>Refer\xEAncia</small></th><th style="text-align: right"><small>Quantidade</small></th><th style="text-align: right"><small>Servi\xE7os</small></th><th style="text-align: right"><small>ISSQN Pr\xF3prio</small></th><th style="text-align: right"><small>ISSQN Retido</small></th><th style="text-align: right"><small>Quantidade</small></th><th style="text-align: right"><small>Servi\xE7os</small></th><th style="text-align: right"><small>ISSQN Pr\xF3prio</small></th><th style="text-align: right"><small>ISSQN Retido</small></th></tr></thead><tbody><tr ng-repeat="competencia in competenciasServicosPrestados"><td><button class="btn btn-xs" ng-click="imprimirLivro(competencia)"><i class="fa fa-print"></i></button></td><td><small>{{\'nfseApp.Mes.\' + competencia.mes | translate}}/{{competencia.exercicio}}</small></td><td style="text-align: right"><small>{{competencia.quantidade}}</small></td><td style="text-align: right"><small>{{competencia.valorServico | currency: \'R$ \'}}</small></td><td style="text-align: right"><small>{{competencia.issqnProprio | currency: \'R$ \'}}</small></td><td style="text-align: right"><small>{{competencia.issqnRetido | currency: \'R$ \'}}</small></td><td style="text-align: right"><small>{{competencia.quantidadeNaoDeclarado}}</small></td><td style="text-align: right"><small>{{competencia.valorServicoNaoDeclarado | currency: \'R$ \'}}</small></td><td style="text-align: right"><small>{{competencia.issqnProprioNaoDeclarado | currency: \'R$ \'}}</small></td><td style="text-align: right"><small>{{competencia.issqnRetidoNaoDeclarado | currency: \'R$ \'}}</small></td></tr></tbody></table></div></div><div role="tabpanel" id="tab-1" class="tab-pane {{activeTab == 1 ? \'active\' : \'\'}}"><div class="table-responsive"><table class="table table-striped table-hover table-condensed"><thead><tr><th></th><th><small>Refer\xEAncia</small></th><th style="text-align: right"><small>Quantidade Contas</small></th><th style="text-align: right"><small>Servi\xE7os</small></th><th style="text-align: right"><small>ISSQN Pr\xF3prio</small></th></tr></thead><tbody><tr ng-repeat="competencia in competenciasServicosPrestados"><td><button class="btn btn-xs" ng-click="imprimirLivro(competencia)"><i class="fa fa-print"></i></button></td><td><small>{{\'nfseApp.Mes.\' + competencia.mes | translate}}/{{competencia.exercicio}}</small></td><td style="text-align: right"><small>{{competencia.quantidade}}</small></td><td style="text-align: right"><small>{{competencia.valorServico | currency: \'R$ \'}}</small></td><td style="text-align: right"><small>{{competencia.issqnProprio | currency: \'R$ \'}}</small></td></tr></tbody></table></div></div><div role="tabpanel" id="tab-2" class="tab-pane {{activeTab == 2 ? \'active\' : \'\'}}"><div class="table-responsive"><table class="table table-striped table-hover table-condensed"><thead><tr><th colspan="2"></th><th colspan="4" style="text-align: center!important"><small>Notas fiscais escrituradas</small></th><th colspan="4" style="text-align: center!important"><small>Notas fiscais n\xE3o escrituradas</small></th></tr><tr><th></th><th><small>Refer\xEAncia</small></th><th style="text-align: right"><small>Quantidade</small></th><th style="text-align: right"><small>Servi\xE7os</small></th><th style="text-align: right"><small>ISSQN Pr\xF3prio</small></th><th style="text-align: right"><small>ISSQN Retido</small></th><th style="text-align: right"><small>Quantidade</small></th><th style="text-align: right"><small>Servi\xE7os</small></th><th style="text-align: right"><small>ISSQN Pr\xF3prio</small></th><th style="text-align: right"><small>ISSQN Retido</small></th></tr></thead><tbody><tr ng-repeat="competencia in competenciasServicosTomados"><td><button class="btn btn-xs" ng-click="imprimirLivro(competencia)"><i class="fa fa-print"></i></button></td><td><small>{{\'nfseApp.Mes.\' + competencia.mes | translate}}/{{competencia.exercicio}}</small></td><td style="text-align: right"><small>{{competencia.quantidade}}</small></td><td style="text-align: right"><small>{{competencia.valorServico | currency: \'R$ \'}}</small></td><td style="text-align: right"><small>{{competencia.issqnProprio | currency: \'R$ \'}}</small></td><td style="text-align: right"><small>{{competencia.issqnRetido | currency: \'R$ \'}}</small></td><td style="text-align: right"><small>{{competencia.quantidadeNaoDeclarado}}</small></td><td style="text-align: right"><small>{{competencia.valorServicoNaoDeclarado | currency: \'R$ \'}}</small></td><td style="text-align: right"><small>{{competencia.issqnProprioNaoDeclarado | currency: \'R$ \'}}</small></td><td style="text-align: right"><small>{{competencia.issqnRetidoNaoDeclarado | currency: \'R$ \'}}</small></td></tr></tbody></table></div></div></div></div></div></div></div></div><div class="row"><div class="alert alert-info" ng-if="(competenciasServicosPrestados && competenciasServicosPrestados.length == 0) &&\n         (competenciasServicosTomados && competenciasServicosTomados.length == 0)">Nenhum movimento encontrato para os filtros selecionados.</div></div>');
$templateCache.put('app/entities/loteRPS/loteRPS-detail.html','<div class="alert alert-info text-center" ng-show="loteRPS.situacao === \'AGUARDANDO\'"><strong>Aguarde</strong><br>O Log do lote \xE9 recarregado automaticamente enquando estiver processando</div><div><div class="table-responsive"><table class="table table-striped"><tbody><tr><th>N\xFAmero</th><th>Situa\xE7\xE3o</th></tr><tr><td>{{loteRPS.numero}}</td><td>{{loteRPS.situacao}}</td></tr></tbody></table></div><div class="col-md-12"><h3>RPS do Lote</h3><search-box ng-model="searchQuery" search-method="loadAll()"></search-box></div><div class="col-md-12"><div class="table-responsive"><table class="table table-striped small"><thead><tr><th>N\xFAmero</th><th>S\xE9rie</th><th>Data de Emiss\xE3o</th><th>Valor Servi\xE7os</th><th>Valor ISS</th><th>N\xFAmero Nfs-e</th></tr></thead><tbody><tr ng-repeat="rps in listaRps"><td>{{rps.numero}}</td><td>{{rps.serie}}</td><td>{{rps.dataEmissao |date:\'dd/MM/yyyy\' }}</td><td>{{rps.totalServicos | currency: \'R$\'}}</td><td>{{rps.issPagar | currency: \'R$\'}}</td><td>{{rps.numeroNotaFiscal ? rps.numeroNotaFiscal : \'N\xE3o Gerado\'}}</td></tr></tbody></table><span nfse-app-pagination></div></div><div class="col-md-12"><h3>Log do Lote</h3><div ui-codemirror ng-model="loteRPS.log" ui-codemirror-opts="editorOptions"></div></div><button type="submit" ui-sref="loteRPS" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;Voltar</button></div>');
$templateCache.put('app/entities/loteRPS/loteRPS-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myLoteRPSLabel" translate="nfseApp.loteRPS.home.createOrEditLabel">Create or edit a LoteRPS</h4></div><div class="modal-body"><div class="form-group"><label translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="loteRPS.id" readonly="readonly"></div><div class="form-group"><label translate="nfseApp.loteRPS.codigo" for="field_codigo">Codigo</label><input type="text" class="form-control" name="codigo" id="field_codigo" ng-model="loteRPS.codigo"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/loteRPS/loteRPSs.html','<div class="row"><div class="col-lg-12"><div class="row"><div class="col-md-8"><search-box ng-model="searchQuery" search-method="loadAll()"></search-box></div><div class="col-md-4"><button class="btn btn-primary pull-right" ui-sref="rPS.import"><span class="fa fa-cloud-upload"></span> Importar Arquivo</button></div></div><div class="table-responsive"><table class="table table-striped small"><thead><tr><th>N\xFAmero</th><th>Situa\xE7\xE3o</th><th></th></tr></thead><tbody><tr ng-repeat="lote in lotes"><td>{{lote .numero}}</td><td>{{lote .situacao}}</td><td><div class="pull-right"><button type="submit" ui-sref="loteRPS.detail({id:lote.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button></div></td></tr></tbody></table><span nfse-app-pagination></div></div></div>');
$templateCache.put('app/entities/loteServicoTomado/loteServicoTomado-detail.html','<div class="alert alert-info text-center" ng-show="loteServicoTomado.situacao === \'AGUARDANDO\'"><strong>Aguarde</strong><br>O Log do lote \xE9 recarregado automaticamente enquando estiver processando</div><div><div class="table-responsive"><table class="table table-striped"><tbody><tr><th>N\xFAmero</th><th>Situa\xE7\xE3o</th></tr><tr><td>{{loteServicoTomado.numero}}</td><td>{{loteServicoTomado.situacao}}</td></tr><tr><th colspan="2">Log</th></tr><tr><td colspan="2"><div ui-codemirror ng-model="loteServicoTomado.log" ui-codemirror-opts="editorOptions"></div></td></tr></tbody></table></div><div class="row"><div class="col-lg-12"><h3>Documentos do Lote</h3><div class="table-responsive"><table class="table table-striped small"><thead><tr><th>N\xFAmero</th><th>Emiss\xE3o</th><th>Compet\xEAncia</th><th>Prestador</th><th class="text-center">ISS Retido?</th><th class="text-right">Valor Servi\xE7os</th><th class="text-right">Base de Calculo</th><th class="text-right">Valor ISS</th></tr></thead><tbody><tr ng-repeat="notaFiscal in notas"><td>{{notaFiscal.numero}}</td><td>{{notaFiscal.emissao | date : \'dd/MM/yyyy\'}}</td><td>{{notaFiscal.competencia | date : \'MM/yyyy\'}}</td><td><span ng-if="notaFiscal.modalidade == \'NAO_IDENTIFICADO\'">{{\'nfseApp.ModalidadeNota.\' + notaFiscal.modalidade | translate}} </span><span ng-if="notaFiscal.cpfCnpjPrestador">({{notaFiscal.cpfCnpjPrestador | brCpfCnpj}})&ensp;</span> {{notaFiscal.nomePrestador}}</td><td class="text-center">{{notaFiscal.issRetido ? \'Sim\': \'N\xE3o\'}}</td><td class="text-right">{{notaFiscal.totalServicos | currency : \'R$ \'}}</td><td class="text-right">{{notaFiscal.baseCalculo | currency : \'R$ \'}}</td><td class="text-right">{{notaFiscal.issCalculado | currency : \'R$ \'}}</td><td class="text-center"></td></tr></tbody></table><span nfse-app-pagination></div></div></div><button type="submit" ui-sref="loteServicoTomado" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;Voltar</button></div>');
$templateCache.put('app/entities/loteServicoTomado/loteServicoTomado-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myLoteServicoTomadoLabel" translate="nfseApp.loteServicoTomado.home.createOrEditLabel">Create or edit a LoteServicoTomado</h4></div><div class="modal-body"><div class="form-group"><label translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="loteServicoTomado.id" readonly="readonly"></div><div class="form-group"><label translate="nfseApp.loteServicoTomado.codigo" for="field_codigo">Codigo</label><input type="text" class="form-control" name="codigo" id="field_codigo" ng-model="loteServicoTomado.codigo"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/loteServicoTomado/loteServicoTomados.html','<div class="row"><div class="col-lg-12"><div class="row"><div class="col-md-8"><search-box ng-model="searchQuery" search-method="loadAll()"></search-box></div><div class="col-md-4"><button class="btn btn-primary pull-right" ui-sref="notaFiscal.importNotaRecebida"><span class="fa fa-cloud-upload"></span> Importar Arquivo</button></div></div><div class="table-responsive"><table class="table table-striped small"><thead><tr><th>N\xFAmero</th><th>Situa\xE7\xE3o</th><th></th></tr></thead><tbody><tr ng-repeat="lote in lotes"><td>{{lote .numero}}</td><td>{{lote .situacao}}</td><td><div class="pull-right"><button type="submit" ui-sref="loteServicoTomado.detail({id:lote.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button></div></td></tr></tbody></table><span nfse-app-pagination></div></div></div>');
$templateCache.put('app/entities/loterpsgeral/loteRpsGeral-detail.html','<div class="ibox animated fadeInDown"><div class="ibox-content"><div class="alert alert-info text-center" ng-show="lote.situacao === \'AGUARDANDO\'"><strong>Aguarde</strong><br>O Log do lote \xE9 recarregado automaticamente enquando estiver processando</div><div><div class="table-responsive"><table class="table table-striped"><tbody><tr><th>Vers\xE3o do Sistema</th><th>Vers\xE3o da Abrasf</th><th>Data de Recebimento</th><th>N\xFAmero</th><th>Situa\xE7\xE3o</th></tr><tr><td>{{lote.versaoSistema}}</td><td>{{lote.versaoAbrasf}}</td><td>{{lote.dataRecebimento | date: \'dd/MM/yyyy\'}}</td><td>{{lote.numero}}</td><td>{{\'nfseApp.SituacaoLoteRps.\' + lote.situacao | translate}}</td></tr></tbody></table></div><div class="col-md-12"><h3>RPS do Lote</h3><search-box ng-model="searchQuery" search-method="loadAll()"></search-box></div><div class="col-md-12"><div class="table-responsive"><table class="table table-striped small"><thead><tr><th>N\xFAmero</th><th>S\xE9rie</th><th>Data de Emiss\xE3o</th><th>Valor Servi\xE7os</th><th>Valor ISS</th><th>N\xFAmero Nfs-e</th></tr></thead><tbody><tr ng-repeat="rps in listaRps"><td>{{rps.numero}}</td><td>{{rps.serie}}</td><td>{{rps.dataEmissao |date:\'dd/MM/yyyy\' }}</td><td>{{rps.totalServicos | currency: \'R$\'}}</td><td>{{rps.issPagar | currency: \'R$\'}}</td><td>{{rps.numeroNotaFiscal ? rps.numeroNotaFiscal : \'N\xE3o Gerado\'}}</td></tr></tbody></table><span nfse-app-pagination></span></div></div><div class="col-md-12"><div class="col-md-6"><h3>Log do Lote</h3><div ui-codemirror ng-model="lote.log" ui-codemirror-opts="editorOptions"></div></div><div class="col-md-6"><h3 style="display: inline-block">XML do Lote</h3><button style="display: inline-block" type="button" class="btn btn-sm btn-info" ng-click="copyToClipboard(lote.xml)"><span class="glyphicon glyphicon-copy"></span></button> <span class="text-info">{{mensagemCopy}}</span><div ui-codemirror ng-model="lote.xml" ui-codemirror-opts="editorOptions"></div></div></div></div><div class="com-md-12"><button type="submit" ui-sref="loteRpsGeral" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;Voltar</button> <button type="button" ng-disabled="lote.situacao == \'PROCESSADO\'" ng-click="reprocessarLote()" class="btn btn-success"><span class="glyphicon glyphicon-adjust"></span>&nbsp;Reprocessar</button></div></div></div>');
$templateCache.put('app/entities/loterpsgeral/loteRpsGeral.html','<div class="ibox animated fadeInDown"><div class="ibox-content"><form name="formFiltros" class="validate-input"><div class="row"><div class="col-md-12 form-group"><div class="form-group col-md-3"><label>Data Recebimento Inicial</label><input enter-as-tab type="date" id="dataRecebimentoInicial" name="dataRecebimentoInicial" ng-model="dataRecebimentoInicial" class="form-control"><div ng-show="formFiltros.dataRecebimentoInicial.$invalid"><p class="help-block">Data inv\xE1lida.</p></div></div><div class="form-group col-md-3"><label>Data Recebimento Final</label><input enter-as-tab type="date" name="dataRecebimentoFinal" ng-model="dataRecebimentoFinal" class="form-control"><div ng-show="formFiltros.dataRecebimentoFinal.$invalid"><p class="help-block">Data inv\xE1lida.</p></div></div><div class="col-md-3 form-group"><label>N\xB0 Lote Inicial</label><input enter-as-tab type="text" ng-model="numeroLoteInicial" class="form-control"></div><div class="col-md-3 form-group"><label>N\xB0 Lote Final</label><input enter-as-tab type="text" ng-model="numeroLoteFinal" class="form-control"></div></div><div class="col-md-12"><div class="col-md-3 form-group"><label>Inscri\xE7\xE3o Cadastral</label><input enter-as-tab type="text" ng-model="inscricaoCadastral" class="form-control"></div><div class="col-md-2 form-group"><label>Situa\xE7\xE3o</label><select class="form-control" ng-model="situacao" ng-options="situacao as \'nfseApp.SituacaoLoteRps.\' + situacao.name | translate for situacao in situacoes track by situacao.value"></select></div><div class="col-md-2 form-group"><label>Vers\xE3o do Sistema</label><input enter-as-tab type="text" ng-model="versaoSistema" class="form-control"></div><div class="col-md-2 form-group"><label>Vers\xE3o Abrasf</label><input enter-as-tab type="text" ng-model="versaoAbrasf" class="form-control"></div><div class="col-md-1 form-group"><label>Reprocessar?</label><div class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="reprocessar" ng-model="reprocessar" class="onoffswitch-checkbox" id="reprocessar"><label class="onoffswitch-label" for="reprocessar"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="col-md-6 form-group"><button type="button" ng-disabled="formFiltros.$invalid" ng-click="loadAll()" class="btn btn-primary"><span class="fa fa-search"></span> <span>Pesquisar</span></button> <button type="button" ng-click="loadAll()" class="btn btn-default"><span class="fa fa-close"></span> <span>Limpar Filtros</span></button> <button type="button" ng-click="dispararReprocessamento()" class="btn btn-danger"><span class="fa fa-check"></span> <span>Disparar Reprocessamento</span></button></div></div></div></form><div class="row"><div class="col-md-12"><div class="col-md-12 table-responsive"><table class="table table-striped small"><thead><tr><th>Vers\xE3o do Sistema</th><th>Vers\xE3o da Abrasf</th><th>Data de Recebimento</th><th>N\xFAmero</th><th>Prestador</th><th>Situa\xE7\xE3o</th><th class="text-center">Reprocessar?</th><th></th></tr></thead><tbody><tr ng-repeat="lote in lotes"><td>{{lote.versaoSistema}}</td><td>{{lote.versaoAbrasf}}</td><td>{{lote.dataRecebimento | date: \'dd/MM/yyyy\'}}</td><td>{{lote .numero}}</td><td>{{lote.prestador.inscricaoMunicipal}} ( {{lote.prestador.pessoa.dadosPessoais.nomeRazaoSocial}} -{{lote.prestador.pessoa.dadosPessoais.cpfCnpj}} )</td><td>{{\'nfseApp.SituacaoLoteRps.\' + lote .situacao | translate}}</td><td class="text-center"><a ng-if="lote.situacao != \'PROCESSADO\'" ng-click="inverterReprocessar(lote)"><span ng-if="lote.reprocessar" class="label label-success">Sim</span> <span ng-if="!lote.reprocessar" class="label label-default">N\xE3o</span></a></td><td><div class="pull-right"><button type="submit" ui-sref="loteRpsGeral.detail({id:lote.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button></div></td></tr></tbody></table><span nfse-app-pagination></span></div></div></div></div></div>');
$templateCache.put('app/entities/mensagem-contribuinte-usuario/mensagem-contribuinte-usuario-detail.html','<div class="ibox float-e-margins"><div class="ibox-title"><h3>{{mensagemContribuinteUsuario.mensagem.titulo}}</h3></div><div class="ibox-content"><div class="row"><div class="col-md-12 m-t-md"><div ng-bind-html="trustAsHtml(mensagemContribuinteUsuario.mensagem.conteudo)"></div></div><div class="col-md-12 m-t-md" ng-if="mensagemContribuinteUsuario.mensagem.tipo == \'QUESTIONAMENTO\'"><div class="form-group"><label>Resposta</label><p>{{mensagemContribuinteUsuario.resposta}}</p></div></div><div class="col-md-12 m-t-md" ng-if="mensagemContribuinteUsuario.mensagem.tipo == \'QUESTIONAMENTO\'"><h5>Documento(s)</h5><div class="table-responsive" style="max-height: 400px; overflow-y: auto"><table class="table table-striped"><thead><tr><th class="col-md-10">Descri\xE7\xE3o do Documento</th><th class="col-md-1"></th></tr></thead><tbody><tr ng-repeat="documento in mensagemContribuinteUsuario.documentos"><td>{{documento.documento.descricaoDocumento}}</td><td><a class="btn btn-xs btn-success" style="color: white" href="/api/arquivo/{{documento.arquivo.id}}" target="_blank"><i class="fa fa-download"></i> Baixar</a></td></tr></tbody></table></div></div><div class="col-md-12 m-t-md" ng-if="mensagemContribuinteUsuario.mensagem.detentorArquivoComposicao && mensagemContribuinteUsuario.mensagem.detentorArquivoComposicao.arquivos.length > 0"><h5>Anexo(s)</h5><div ng-repeat="arquivo in mensagemContribuinteUsuario.mensagem.detentorArquivoComposicao.arquivos"><a class="btn btn-xs btn-success" style="color: white" href="/api/arquivo/{{arquivo.arquivoNfseDTO.id}}" target="_blank"><i class="fa fa-download"></i> {{arquivo.arquivoNfseDTO.nome}}</a></div></div></div></div><div class="ibox-footer"><div class="row"><div class="col-md-12 m-t-md"><button type="button" ui-sref="mensagemContribuinteUsuario" class="btn btn-default"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span>Voltar</span></button></div></div></div></div>');
$templateCache.put('app/entities/mensagem-contribuinte-usuario/mensagem-contribuinte-usuario-new.html','<div class="ibox animated fadeInDown"><div class="ibox-title"><h4>{{entity.mensagem.titulo}}</h4></div><div class="ibox-content"><div class="row"><div class="col-md-12 m-t-md"><div ng-bind-html="trustAsHtml(entity.mensagem.conteudo)"></div></div><div ng-if="entity.mensagem.tipo == \'QUESTIONAMENTO\'"><div class="col-md-12 m-t-md"><div class="form-group"><label class="center-block">Resposta</label><textarea type="text" class="form-control" required="" rows="7" maxlength="3000" minlength="3" ng-model="entity.resposta"></textarea></div></div><div class="col-md-12"><h3>Documento(s)</h3></div><div class="col-md-12"><div class="table-responsive" style="max-height: 400px; overflow-y: auto"><table class="table table-striped"><thead><tr><th class="col-md-10">Descri\xE7\xE3o do Documento</th><th class="col-md-1">Obrigat\xF3rio?</th><th class="col-md-1"></th></tr></thead><tbody><tr ng-repeat="documento in entity.documentos"><td>{{documento.documento.descricaoDocumento}}</td><td>{{documento.documento.obrigatorio ? \'Sim\' : \'N\xE3o\'}}</td><td><label for="file-upload{{documento.documento.id}}" class="custom-file-upload"><span class="fa fa-cloud-upload"></span>Selecionar Arquivo</label><input type="file" id="file-upload{{documento.documento.id}}" ngf-select="uploadFile($file, documento)" ngf-max-size="15MB"><br><label ng-if="documento.file">{{documento.fileName}}</label></td></tr></tbody></table></div></div></div><div class="col-md-12 m-t-md"><div ng-if="entity.mensagem.detentorArquivoComposicao && entity.mensagem.detentorArquivoComposicao.arquivos.length > 0"><h5>Anexo(s)</h5><div ng-repeat="arquivo in entity.mensagem.detentorArquivoComposicao.arquivos"><a class="btn btn-xs btn-success" style="color: white" ng-click="baixouArquivo(arquivo)" href="/api/arquivo/{{arquivo.arquivoNfseDTO.id}}" target="_blank"><i class="fa fa-download"></i> {{arquivo.arquivoNfseDTO.nome}}</a></div></div></div></div></div><div class="ibox-footer"><div class="row"><div ng-if="!habilitaBotaoConfirmar()" class="alert alert-warning" style="text-align: left"><strong>Para confirmar voc\xEA precisa:</strong><br><div ng-if="isQuestionamento() && !isQuestionamentoRespondido()"><span>- Responder a pergunta.</span><br></div><div ng-if="isQuestionamento() && !isQuestionamentoDocAnexados()"><span>- Anexar os documentos obrigat\xF3rios.</span></div><div ng-if="!baixouAnexos()"><span>- Baixar os anexos</span><br></div><div ng-if="!declaro"><span>- Declarar ter lido a mensagem</span><br></div></div><div class="col-md-12"><input type="checkbox" ng-model="declaro"> <span>Declaro ter lido a mensagem</span></div><div class="col-md-12 m-t-md"><button type="button" class="btn btn-success" ng-disabled="!habilitaBotaoConfirmar()" ng-click="confirmar()"><span class="fa fa-check"></span>&nbsp; <span>Confirmar</span></button></div></div></div></div>');
$templateCache.put('app/entities/mensagem-contribuinte-usuario/mensagem-contribuinte-usuario.html','<div class="ibox float-e-margins"><div class="ibox-title"><h3>Mensagens</h3></div><div class="ibox-content"><table class="table"><thead><tr><th>T\xEDtulo da Mensagem</th><th class="col-md-2">Data do Envio</th><th class="col-md-2">Data de Leitura</th></tr></thead><tbody><tr ng-repeat="mensagemContribuinteUsuario in mensagens" style="cursor: pointer" ui-sref="mensagemContribuinteUsuario.detail({id: mensagemContribuinteUsuario.id})"><td>{{mensagemContribuinteUsuario.mensagem.titulo}}</td><td class="col-md-2 text-navy textRight">{{mensagemContribuinteUsuario.mensagem.emitidaEm | date: \'dd/MM/yyyy\'}}</td><td class="col-md-2 text-navy textRight">{{mensagemContribuinteUsuario.dataLeitura | date: \'dd/MM/yyyy\'}}</td></tr></tbody></table><span nfse-app-pagination></span></div></div>');
$templateCache.put('app/entities/mongo/mongo.html','<div class="ibox animated fadeInDown"><div class="ibox-content"><form name="formFiltros" class="validate-input"><div class="row"><div class="col-md-12 form-group"><div class="form-group col-md-5"><label>DB Name</label><div class="input-group"><input enter-as-tab type="text" id="dbName" name="dbName" ng-model="dbName" class="form-control"><div class="input-group-btn"><button type="button" ng-click="dropDb()" class="btn btn-danger"><span class="fa fa-trash"></span> <span>Drop Database</span></button></div></div></div></div></div><div class="row"><div class="col-md-12 form-group"><div class="form-group col-md-5"><label>Collection Name</label><div class="input-group"><input enter-as-tab type="text" id="collectionName" name="collectionName" ng-model="collectionName" class="form-control"><div class="input-group-btn"><button type="button" ng-click="dropCollection()" class="btn btn-danger"><span class="fa fa-trash"></span> <span>Drop Collection</span></button></div></div></div></div></div></form></div></div>');
$templateCache.put('app/entities/municipio/municipio-detail.html','<div><h2><span translate="nfseApp.municipio.detail.title">Municipio</span> {{municipio.id}}</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span translate="nfseApp.municipio.codigo">Codigo</span></td><td><input type="text" class="input-sm form-control" value="{{municipio.codigo}}" readonly="readonly"></td></tr><tr><td><span translate="nfseApp.municipio.nome">Nome</span></td><td><input type="text" class="input-sm form-control" value="{{municipio.nome}}" readonly="readonly"></td></tr></tbody></table></div><button type="submit" ui-sref="municipio" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/entities/municipio/municipio-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myMunicipioLabel" translate="nfseApp.municipio.home.createOrEditLabel">Create or edit a Municipio</h4></div><div class="modal-body"><div class="form-group"><label translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="municipio.id" readonly="readonly"></div><div class="form-group"><label translate="nfseApp.municipio.codigo" for="field_codigo">Codigo</label><input type="text" class="form-control" name="codigo" id="field_codigo" ng-model="municipio.codigo"></div><div class="form-group"><label translate="nfseApp.municipio.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="municipio.nome"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/municipio/municipio-search.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title" id="myMunicipioLabel">Munic\xEDpio</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><search-box ng-model="searchQuery" search-method="loadAll()"></search-box></div></div><div class="row"><div class="col-md-12"><div class="table-responsive"><table class="table table-striped"><thead><tr><th>C\xF3digo</th><th>Nome</th><th>UF</th><th></th></tr></thead><tbody><tr ng-repeat="municipio in municipios"><td>{{municipio.codigo}}</td><td>{{municipio.nome}}</td><td>{{municipio.estado}}</td><td class="pull-right"><button type="submit" ng-click="ok(municipio)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-check"></span></button></td></tr></tbody></table><span nfse-app-pagination></div></div></div></div>');
$templateCache.put('app/entities/municipio/municipios.html','<div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><span translate="nfseApp.municipio.home.title">Form</span></div><div class="ibox-content"><div class="row"><div class="col-md-8"><search-box ng-model="searchQuery" search-method="search()"></search-box></div><div class="col-md-4"><button class="btn btn-primary pull-right" ui-sref="municipio.new"><span class="fa fa-plus"></span> <span translate="nfseApp.municipio.home.createLabel">Create a new Municipio</span></button></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th>ID</th><th>C\xF3digo</th><th>Nome</th><th>UF</th><th></th></tr></thead><tbody><tr ng-repeat="municipio in municipios"><td><a ui-sref="municipio.detail({id:municipio.id})">{{municipio.id}}</a></td><td>{{municipio.codigo}}</td><td>{{municipio.nome}}</td><td>{{municipio.estado}}</td><td><div class="pull-right"><button type="submit" ui-sref="municipio.detail({id:municipio.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="municipio.edit({id:municipio.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ng-click="delete(municipio.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table><span nfse-app-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/notaFiscalAvulsa/notaFiscalAvulsa-detail.html','<div class="row"><div class="col-lg-12"><form name="editForm" role="form" novalidate><div class="ibox float-e-margins animated fadeInDown"><div class="ibox-content"><div class="row"><div class="col-md-12"><h3>Dados do Prestador do Servi\xE7o</h3></div></div><div class="row m-t-sm"><div class="fodrm-group"><div class="col-md-2"><label for="field_cpf_cnpj_prestador">CPF/CNPJ</label><input type="text" class="form-control" name="cpfCnpjPrestador" ui-br-cpfcnpj-mask id="field_cpf_cnpj_prestador" readonly="readonly" ng-model="notaFiscalAvulsa.prestador.dadosPessoais.cpfCnpj"></div><div class="col-md-10"><label for="field_nome_razao_social_prestador">Nome/Raz\xE3o Social</label><input type="text" class="form-control" name="nomeRazaoSocialPrestador" id="field_nome_razao_social_prestador" readonly="readonly" ng-maxlength="7" ng-model="notaFiscalAvulsa.prestador.dadosPessoais.nomeRazaoSocial"></div></div></div></div></div><div class="ibox float-e-margins animated fadeInDown"><div class="ibox-content"><div class="row"><div class="col-md-12"><h3>Dados da Nota Fiscal Avulsa</h3></div></div><div class="row m-t-sm"><div class="fodrm-group"><div class="col-md-3"><label for="field_numero_nota">N\xFAmero</label><input type="number" class="form-control" name="numeroNota" id="field_numero_nota" readonly="readonly" ng-maxlength="7" ng-model="notaFiscalAvulsa.numero"></div><div class="col-md-3"><label for="field_data_nota">Data da Nota</label><input class="form-control" value="{{notaFiscalAvulsa.dataNota | date:\'dd/MM/yyyy\'}}" id="field_data_nota" readonly="readonly" name="dataNota"></div></div></div></div></div><div class="ibox float-e-margins animated fadeInDown"><div class="ibox-content"><div class="row"><div class="col-md-12"><h3>Para quem foi prestado o servi\xE7o?</h3></div></div><div class="row m-t-sm"><div class="col-md-12"><div class="row animated fadeInDown"><div class="form-group col-md-4"><label class="control-label" for="field_cpfCnpj">CPF ou CNPJ</label><div class="input-group"><input type="text" class="form-control" name="cpfCnpj" id="field_cpfCnpj" ui-br-cpfcnpj-mask readonly="readonly" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.cpfCnpj" required></div></div></div><div class="fadeInDown animated"><div class="row" ng-show="!isFisica()"><div class="form-group col-md-4"><label for="field_inscricaoMunicipal">Inscri\xE7\xE3o Municipal</label><input type="text" class="form-control" name="inscricaoMunicipal" readonly="readonly" id="field_inscricaoMunicipal" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.inscricaoMunicipal"></div><div class="form-group col-md-8"><label class="control-label" for="field_nomeFantasia">Nome Fantasia</label><input type="text" class="form-control" name="nomeFantasia" id="field_nomeFantasia" readonly="readonly" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.nomeFantasia"></div></div><div class="row"><div class="form-group col-md-4" ng-if="!isFisica()"><label class="control-label" for="field_inscricaoEstadual">Inscri\xE7\xE3o Estadual</label><input type="text" class="form-control" name="inscricaoEstadual" id="field_inscricaoEstadual" readonly="readonly" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.inscricaoEstadualRg"></div><div class="form-group col-md-4" ng-if="isFisica()"><label class="control-label" for="field_rg">RG</label><input type="text" class="form-control" name="rg" id="field_rg" readonly="readonly" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.inscricaoEstadualRg"></div><div class="form-group col-md-8"><label class="control-label" for="field_nomeRazaoSocial">{{isFisica() ? \'Nome \':\'Raz\xE3o Social\'}}</label><input type="text" class="form-control" name="nomeRazaoSocial" id="field_nomeRazaoSocial" readonly="readonly" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.nomeRazaoSocial" required></div></div><div class="row"><div class="form-group col-md-9"><label for="field_email">e-Mail</label><input type="text" class="form-control" name="email" id="field_email" readonly="readonly" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.email"></div><div class="form-group col-md-3"><label for="field_telefone">Telefone</label><input type="text" class="form-control" name="telefone" id="field_telefone" ui-br-phone-number readonly="readonly" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.telefone"></div></div><div class="row fadeInDown animated"><div class="form-group col-md-2"><label for="field_cep">Cep</label><input type="text" class="form-control" name="id" id="field_cep" ui-br-cep-mask readonly="readonly" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.cep"></div><div class="form-group col-md-8"><label for="field_nome_municipio">Munic\xEDpio</label><div class="input-group"><input type="text" class="form-control" name="nome_municipio" id="field_nome_municipio" disabled="disabled" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.municipio.nome"></div></div><div class="form-group col-md-2"><label for="field_estado_municipio">Estado</label><input type="text" class="form-control" name="estado_municipio" id="field_estado_municipio" disabled="disabled" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.municipio.estado"></div><div class="form-group col-md-12"><label for="field_logradouro">Logradouro</label><input type="text" class="form-control" name="logradouro" id="field_logradouro" readonly="readonly" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.logradouro"></div><div class="form-group col-md-6"><label for="field_bairro">Bairro</label><input type="text" class="form-control" name="bairro" id="field_bairro" readonly="readonly" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.bairro"></div><div class="form-group col-md-2"><label for="field_numero">N\xFAmero</label><input type="text" class="form-control" name="numero" id="field_numero" readonly="readonly" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.numero"></div><div class="form-group col-md-4"><label for="field_complemento">Complemento</label><input type="text" class="form-control" name="complemento" disabled="disabled" id="field_complemento" readonly="readonly" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.complemento"></div></div></div></div></div></div></div><div class="ibox float-e-margins animated fadeInDown"><div class="ibox-content"><div class="row"><div class="form-group col-md-12" ng-show="notaFiscalAvulsa.itens.length > 0"><table class="table table-striped"><thead><tr><th colspan="6">Servi\xE7o prestado</th></tr><tr><th>C\xF3digo</th><th>Descri\xE7\xE3o</th><th>Al\xEDquota</th><th>Quant.</th><th>Valor Unit.</th><th>Valor Total</th><th>Valor ISS</th></tr></thead><tbody><tr ng-repeat="item in notaFiscalAvulsa.itens"><td class="col-md-1">{{item.servico.codigo}}</td><td class="col-md-5">{{item.servico.descricao}}</td><td class="col-md-1">{{item.servico.aliquota}}</td><td class="col-md-1">{{item.quantidade}}</td><td class="col-md-1">{{item.valorUnitario | currency : \'R$ \'}}</td><td class="col-md-2">{{item.valorTotal | currency : \'R$ \'}}</td><td class="col-md-1">{{item.valorIss | currency : \'R$ \'}}</td></tr></tbody></table></div></div></div></div><div class="row m-t-md"><div class="col-md-12"><button type="button" class="btn btn-default" ui-sref="notaFiscalAvulsa"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Voltar</span></button></div></div></form></div></div>');
$templateCache.put('app/entities/notaFiscalAvulsa/notaFiscalAvulsa-edit.html','<div class="row"><div class="col-lg-12"><form name="editForm" role="form" novalidate><div class="ibox float-e-margins animated fadeInDown"><div class="ibox-content"><div class="row"><div class="col-md-12"><h3>Dados do Prestador do Servi\xE7o</h3></div></div><div class="row m-t-sm"><div class="fodrm-group"><div class="col-md-2"><label for="field_cpf_cnpj_prestador">CPF/CNPJ</label><input type="text" class="form-control" name="cpfCnpjPrestador" ui-br-cpfcnpj-mask id="field_cpf_cnpj_prestador" readonly="readonly" ng-model="notaFiscalAvulsa.prestador.dadosPessoais.cpfCnpj"></div><div class="col-md-10"><label for="field_nome_razao_social_prestador">Nome/Raz\xE3o Social</label><input type="text" class="form-control" name="nomeRazaoSocialPrestador" id="field_nome_razao_social_prestador" readonly="readonly" ng-maxlength="7" ng-model="notaFiscalAvulsa.prestador.dadosPessoais.nomeRazaoSocial"></div></div></div></div></div><div class="ibox float-e-margins animated fadeInDown"><div class="ibox-content"><div class="row"><div class="col-md-12"><h3>Dados da Nota Fiscal Avulsa</h3></div></div><div class="row m-t-sm"><div class="fodrm-group"><div class="col-md-3"><label for="field_numero_nota">N\xFAmero</label><input type="number" class="form-control" name="numeroNota" id="field_numero_nota" readonly="readonly" ng-maxlength="7" ng-model="notaFiscalAvulsa.numero"><div ng-show="!notaFiscalAvulsa.numero"><p class="help-block">Gerado automaticamente.</p></div></div><div class="col-md-3"><label for="field_data_nota">Data da Nota</label><input class="form-control" value="{{notaFiscalAvulsa.dataNota | date:\'dd/MM/yyyy\'}}" id="field_data_nota" readonly="readonly" name="dataNota"></div></div></div></div></div><div class="ibox float-e-margins animated fadeInDown"><div class="ibox-content"><div class="row"><div class="col-md-12"><h3>Para quem foi prestado o servi\xE7o?</h3></div></div><div class="row m-t-sm"><div class="col-md-12"><div class="row animated fadeInDown"><div class="form-group col-md-4" ng-class="{\'has-error\' : editForm.cpfCnpj.$invalid && (editForm.$submitted || editForm.cpfCnpj.$touched)}"><label class="control-label" for="field_cpfCnpj">CPF ou CNPJ</label><div class="input-group"><input type="text" class="form-control" name="cpfCnpj" id="field_cpfCnpj" ui-br-cpfcnpj-mask ng-model="notaFiscalAvulsa.tomador.dadosPessoais.cpfCnpj" required></div><div ng-show="editForm.cpfCnpj.$invalid"><p class="help-block" ng-show="editForm.cpfCnpj.$error.required">Informe o CPF ou CNPJ</p><p class="help-block" ng-show="editForm.cpfCnpj.$error.cpf || editForm.cpfCnpj.$error.cnpj">CPF ou CNPJ inv\xE1lido</p></div></div></div><div ng-show="editForm.cpfCnpj.$valid" class="fadeInDown animated"><div class="row" ng-show="!isFisica()"><div class="form-group col-md-4"><label for="field_inscricaoMunicipal">Inscri\xE7\xE3o Municipal</label><input type="text" class="form-control" name="inscricaoMunicipal" id="field_inscricaoMunicipal" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.inscricaoMunicipal"></div><div class="form-group col-md-8"><label class="control-label" for="field_nomeFantasia">Nome Fantasia</label><input type="text" class="form-control" name="nomeFantasia" id="field_nomeFantasia" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.nomeFantasia"></div></div><div class="row"><div class="form-group col-md-4" ng-if="!isFisica()" ng-class="{\'has-error\' : editForm.inscricaoEstadual.$invalid && (editForm.$submitted || editForm.inscricaoEstadual.$touched)}"><label class="control-label" for="field_inscricaoEstadual">Inscri\xE7\xE3o Estadual</label><input type="text" class="form-control" name="inscricaoEstadual" id="field_inscricaoEstadual" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.inscricaoEstadualRg"></div><div class="form-group col-md-4" ng-if="isFisica()" ng-class="{\'has-error\' : editForm.rg.$invalid  && (editForm.$submitted || editForm.rg.$touched)}"><label class="control-label" for="field_rg">RG</label><input type="text" class="form-control" name="rg" id="field_rg" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.inscricaoEstadualRg"></div><div class="form-group col-md-8" ng-class="{\'has-error\' : editForm.nomeRazaoSocial.$invalid && (editForm.$submitted || editForm.nomeRazaoSocial.$touched)}"><label class="control-label" for="field_nomeRazaoSocial">{{isFisica() ? \'Nome \':\'Raz\xE3o Social\'}}</label><input type="text" class="form-control" name="nomeRazaoSocial" id="field_nomeRazaoSocial" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.nomeRazaoSocial" required><div ng-show="editForm.nomeRazaoSocial.$invalid"><p class="help-block" ng-show="editForm.nomeRazaoSocial.$error.required">Informe o Nome ou a Raz\xE3o Social</p></div></div></div><div class="row"><div class="form-group col-md-9"><label for="field_email">e-Mail</label><input type="text" class="form-control" name="email" id="field_email" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.email"></div><div class="form-group col-md-3"><label for="field_telefone">Telefone</label><input type="text" class="form-control" name="telefone" id="field_telefone" ui-br-phone-number ng-model="notaFiscalAvulsa.tomador.dadosPessoais.telefone"></div></div><div class="row fadeInDown animated"><div class="form-group col-md-2"><label for="field_cep">Cep</label><input type="text" class="form-control" name="id" id="field_cep" ui-br-cep-mask ng-blur="loadEnderecoByCEP(notaFiscalAvulsa.tomador.dadosPessoais.cep)" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.cep"></div><div class="form-group col-md-8"><label for="field_nome_municipio">Munic\xEDpio</label><div class="input-group"><input type="text" class="form-control" name="nome_municipio" id="field_nome_municipio" disabled="disabled" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.municipio.nome"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="searchMunicipio(notaFiscalAvulsa.tomador.dadosPessoais)"><span class="glyphicon glyphicon-search"></span></button></span></div></div><div class="form-group col-md-2"><label for="field_estado_municipio">Estado</label><input type="text" class="form-control" name="estado_municipio" id="field_estado_municipio" disabled="disabled" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.municipio.estado"></div><div class="form-group col-md-12"><label for="field_logradouro">Logradouro</label><input type="text" class="form-control" name="logradouro" id="field_logradouro" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.logradouro"></div><div class="form-group col-md-6"><label for="field_bairro">Bairro</label><input type="text" class="form-control" name="bairro" id="field_bairro" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.bairro"></div><div class="form-group col-md-2"><label for="field_numero">N\xFAmero</label><input type="text" class="form-control" name="numero" id="field_numero" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.numero"></div><div class="form-group col-md-4"><label for="field_complemento">Complemento</label><input type="text" class="form-control" name="complemento" id="field_complemento" ng-model="notaFiscalAvulsa.tomador.dadosPessoais.complemento"></div></div></div></div></div></div></div><div ng-if="editForm.cpfCnpj.$valid" class="ibox float-e-margins animated fadeInDown"><div class="ibox-content"><div class="row"><div class="col-md-12"><h3>Qual o servi\xE7o prestado?</h3></div></div><div ng-if="notaFiscalAvulsa.itens.length == 0" class="fadeIn"><div class="row"><div class="form-group col-md-8"><label class="center-block">Servi\xE7o</label><div class="input-group"><input class="form-control" readonly="readonly" id="field_servico_descricao" name="servico_descricao" value="{{item.servico.descricao}}"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="searchServico()"><span class="glyphicon glyphicon-search"></span></button></span></div></div><div class="form-group col-md-4"><label class="center-block">Aliquota</label><input class="form-control" readonly="readonly" id="field_servico_aliquota" name="servico_aliquota" value="{{item.aliquota}}"></div></div><div class="row"><div class="form-group col-md-12"><label class="center-block">Discrimina\xE7\xE3o do servi\xE7o</label><textarea type="text" class="form-control" name="descriminacao_servico" id="field_descriminacao_servico" ng-model="item.descricao">\n                                        </textarea></div></div><div class="row"><div class="form-group col-md-1"><label class="center-block">Quantidade</label><input type="number" class="form-control" ng-class="{\'has-error\' : item.quantidade <= 0 && (editForm.$submitted || editForm.servico_quantidade.$touched)}" ng-disabled="!item.servico" ng-blur="calcularValoresServico()" name="servico_quantidade" id="field_servico_quantidade" ng-model="item.quantidade"><div class="margin"><p class="help-block" ng-show="item.quantidade <= 0">O valor deve ser maior que ZERO (0)</p></div></div><div class="form-group col-md-3" ng-class="{\'has-error\' : item.valorUnitario <= 0 && (editForm.$submitted || editForm.servico_valor_unitario.$touched)}"><label class="control-label">Valor Unit\xE1rio</label><input type="text" class="form-control" ui-money-mask="R$" ng-disabled="!item.servico" ng-change="calcularValoresServico()" name="servico_valor_unitario" id="field_servico_valor_unitario" ng-model="item.valorUnitario"><div class="margin"><p class="help-block" ng-show="item.valorUnitario <= 0">O valor deve ser maior que ZERO (R$ 0,00)</p></div></div><div class="form-group col-md-3"><label class="control-label">Valor Total</label><input type="text" class="form-control" ui-money-mask="R$" readonly="readonly" name="servico_valor_total" id="field_servico_valor_total" ng-model="item.valorTotal"></div><div class="form-group col-md-3"><label class="control-label">Valor ISS</label><input type="text" class="form-control" ui-money-mask="R$" readonly="readonly" name="servico_valor_iss" id="field_servico_valor_iss" ng-model="item.valorIss"></div></div><div class="row"><div class="form-group col-md-12"><button class="btn btn-success" ng-click="addServico()" type="button"><i class="fa fa-chevron-right"></i> Adicionar Servi\xE7o</button></div></div></div><div class="row"><div class="form-group col-md-12" ng-show="notaFiscalAvulsa.itens.length > 0"><table class="table table-striped"><thead><tr><th colspan="6">Servi\xE7o adicionado</th></tr><tr><th>C\xF3digo</th><th>Descri\xE7\xE3o</th><th>Al\xEDquota</th><th>Quant.</th><th>Valor Unit.</th><th>Valor Total</th><th>Valor ISS</th><th></th></tr></thead><tbody><tr ng-repeat="item in notaFiscalAvulsa.itens"><td class="col-md-1">{{item.servico.codigo}}</td><td class="col-md-3">{{item.servico.descricao}}</td><td class="col-md-1">{{item.servico.aliquota}}</td><td class="col-md-1">{{item.quantidade}}</td><td class="col-md-1">{{item.valorUnitario | currency : \'R$ \'}}</td><td class="col-md-2">{{item.valorTotal | currency : \'R$ \'}}</td><td class="col-md-1">{{item.valorIss | currency : \'R$ \'}}</td><td class="col-md-2 text-center"><div class="pull-right"><button type="submit" ng-click="delServico($index)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button> <button type="submit" ng-click="editServico($index)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-pencil"></span></button></div></td></tr></tbody></table></div></div></div></div><div class="row m-t-md"><div class="col-md-12"><button type="button" class="btn btn-default" ui-sref="notaFiscalAvulsa"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="!editForm.cpfCnpj.$valid" ng-click="salvar()" class="btn btn-success"><span class="glyphicon glyphicon-check"></span>&nbsp; <span>Salvar</span></button></div></div></form></div></div>');
$templateCache.put('app/entities/notaFiscalAvulsa/notaFiscalAvulsa.html','<div class="row"><div class="col-lg-12"><div class="row"><div class="col-md-8"><search-box ng-model="searchQuery" search-method="loadAll()"></search-box></div><div class="col-md-4"><button class="btn btn-primary pull-right" ui-sref="notaFiscalAvulsa.new"><span class="fa fa-plus"></span> <span>Emitir Nota Fiscal Avulsa</span></button></div></div><div id="div-tabela-notas" class="table-responsive"><table class="table table-striped table-hover small"><thead><tr><th>Op\xE7\xF5es</th><th>N\xFAmero</th><th>Data da Nota</th><th>Tomador</th><th>Total Servi\xE7os</th><th>Total ISS</th></tr></thead><tbody><tr ng-repeat="notaFiscalAvulsa in notasFiscaisAvulsa | orderBy:\'-numero\'"><td class="dropdown"><button class="btn btn-white btn-sm dropdown-toggle" data-toggle="dropdown" type="button"><i class="fa fa-caret-down">Op\xE7\xF5es</button><ul class="dropdown-menu"><li><a type="submit" title="clique para visualizar os dados deste documento" ui-sref="notaFiscalAvulsa.detail({id:notaFiscalAvulsa.id})" class="text-info"><span class="fa fa-eye"></span> Visualizar</a></li><li><a type="submit" title="Clique para imprimir a guia" ng-click="imprimeNFSAvulsa(notaFiscalAvulsa.id)" class="text-primary"><span class="fa fa-print"></span> Imprimir Nota</a></li></ul></td><td>{{notaFiscalAvulsa.numero}}</td><td>{{notaFiscalAvulsa.dataNota | date : \'dd/MM/yyyy\'}}</td><td>{{notaFiscalAvulsa.tomador}}</td><td>{{notaFiscalAvulsa.valorServicos | currency:"R$ "}}</td><td>{{notaFiscalAvulsa.valorTotalIss | currency:"R$ "}}</td></tr></tbody></table><span nfse-app-pagination></div></div></div>');
$templateCache.put('app/entities/notaFiscal/aliquota-simples-anexo-lei-1232006.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title" id="myServicoLabel">Tabela de Al\xEDquotas do Simples Nacional</h4></div><div class="modal-body"><div class="row"><div class="form-group col-md-8"><label class="center-block">Anexo</label><select class="form-control" id="field_anexo" name="cnae_descricao" ng-model="anexo" ng-options="anexo as anexo.descricao for anexo in anexos"><option value=""></option></select></div><div class="form-group col-md-4"><label class="center-block">RBT12</label><input type="text" class="form-control" name="rbt12" id="field_rbt12" ui-money-mask="" ng-disabled="!anexo" ng-model="rbt12"></div></div><div class="table-responsive" style="max-height: 400px; overflow-y: auto"><table class="table table-striped"><thead><tr><th>Descri\xE7\xE3o</th><th>Al\xEDquota</th><th>IRRF</th><th>CSLL</th><th>COFINS</th><th>PIS</th><th>CPP</th><th>ISS</th><th></th></tr></thead><tbody><tr ng-repeat="faixa in anexo.faixas" class="{{anexo.faixaSelecionada.id == faixa.id ? \'info\': \'\'}}"><td>Faixa de faturamento at\xE9: {{faixa.valorMaximo | number:2}}</td><td>{{faixa.aliquota | number:2}}</td><td>{{faixa.irpj | number:2}}</td><td>{{faixa.csll | number:2}}</td><td>{{faixa.cofins | number:2}}</td><td>{{faixa.pisPasep | number:2}}</td><td>{{faixa.cpp | number:2}}</td><td>{{faixa.iss | number:2}}</td><td class="pull-right"><button type="submit" ng-click="selecionarFaixa(faixa)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-check"></span></button></td></tr></tbody></table></div></div><div class="modal-footer"><button class="btn btn-success" ng-click="ok()" ng-disabled="!anexo || !anexo.faixaSelecionada || !rbt12"><i class="fa fa-save"></i> Confirmar</button></div>');
$templateCache.put('app/entities/notaFiscal/autenticar-nota.html','<div class="row"><div class="col-lg-12"><h3 class="font-bold">Informe os dados abaixo e clique em Verificar</h3><p class="text-justify">Esta p\xE1gina possibilita verificar a autenticidade da NFS-e emitida.<br>No caso da confirma\xE7\xE3o da autenticidade, a NFS-e ser\xE1 exibida na tela, podendo ser impressa.</p></div><div class="col-lg-8"><form name="editForm" role="form" novalidate><div class="row m-t-sm"><div class="form-group" ng-class="{\'has-error\' : editForm.cpfCnpj.$invalid && (editForm.$submitted || editForm.cpfCnpj.$touched)}"><div class="col-md-12 text-center m-md"><button class="btn {{autenticar.tipo == \'NOTA_FISCAL\' ? \'btn-primary\' : \'btn-default\'}}" ng-click="autenticar.tipo = \'NOTA_FISCAL\';  valido = null;">Nota Fiscal</button> <button class="btn {{autenticar.tipo == \'CARTA_CORRECAO\' ? \'btn-primary\' : \'btn-default\'}}" ng-click="autenticar.tipo = \'CARTA_CORRECAO\';  valido = null;">Carta de Corre\xE7\xE3o</button></div><div class="col-md-12" ng-if="autenticar.tipo"><label class="control-label" for="field_cpfCnpj">CPF ou CNPJ do Prestador (Emitente da NFS-e)</label><input type="text" class="form-control" name="cpfCnpj" id="field_cpfCnpj" ui-br-cpfcnpj-mask ng-model="autenticar.cpfCnpjPrestador" required><div ng-show="editForm.cpfCnpj.$invalid"><p class="help-block" ng-show="editForm.cpfCnpj.$error.required">Informe o CPF ou CNPJ do prestador de servi\xE7os</p><p class="help-block" ng-show="editForm.cpfCnpj.$error.cpf || editForm.cpfCnpj.$error.cnpj">CPF ou CNPJ inv\xE1lido</p></div></div></div></div><div class="row m-t-sm" ng-if="autenticar.tipo"><div class="form-group"><div class="col-md-12"><label for="field_numero">N\xFAmero da {{autenticar.tipo == \'NOTA_FISCAL\' ? \'NFS-e\' : autenticar.tipo == \'CARTA_CORRECAO\' ? \'Carta de Corre\xE7\xE3o\' : \'Documento\'}}</label><input type="number" class="form-control" name="numero" id="field_numero" required ng-maxlength="7" ng-model="autenticar.numero"><div ng-show="editForm.numero.$invalid"><p class="help-block" ng-show="editForm.numero.$error">Informe o n\xFAmero da {{autenticar.tipo == \'NOTA_FISCAL\' ? \'NFS-e\' : \'Carta de Corre\xE7\xE3o\'}} com o m\xE1ximo de 7 caracteres</p></div></div></div></div><div class="row m-t-sm" ng-if="autenticar.tipo"><div class="form-group"><div class="col-md-12"><label for="field_codigo_verificacao">C\xF3digo de Verifica\xE7\xE3o da {{autenticar.tipo == \'NOTA_FISCAL\' ? \'NFS-e\' : \'Carta de Corre\xE7\xE3o\'}}</label><input type="text" class="form-control" name="codigoVerificacao" id="field_codigo_verificacao" required ng-maxlength="40" ng-model="autenticar.codigoVerificacao"><div ng-show="editForm.codigoVerificacao.$invalid"><p class="help-block" ng-show="editForm.codigoVerificacao.$error">Informe o C\xF3digo de Verifica\xE7\xE3o da {{autenticar.tipo == \'NOTA_FISCAL\' ? \'NFS-e\' : \'Carta de Corre\xE7\xE3o\'}} com o m\xE1ximo de 40 caracteres</p></div></div></div></div><div class="row m-t-sm"><div class="form-group"><div class="col-md-12"><button type="submit" ng-disabled="editForm.$invalid" ng-click="autenticarNota()" class="btn btn-success"><span class="glyphicon glyphicon-check"></span>&nbsp; <span>Autenticar</span></button> <button type="button" ng-click="limpar()" class="btn btn-default"><span class="fa fa-times"></span>&nbsp; <span>Limpar</span></button></div></div></div></form></div><div class="col-lg-4"><div class="widget navy-bg p-lg text-center" ng-if="valido === true"><div class="m-b-md"><i class="fa fa-thumbs-up fa-4x"></i><h1 class="m-xs">{{autenticar.tipo == \'NOTA_FISCAL\' ? \'NFS-e\' : \'Carta de Corre\xE7\xE3o\'}} V\xE1lida</h1><h3 ng-click="imprimirNota()" class="font-bold no-margins"><i class="fa fa-print"></i> Imprimir</h3></div></div><div class="widget red-bg p-lg text-center" ng-if="valido === false"><div class="m-b-md"><i class="fa fa-exclamation-triangle fa-4x"></i><h3 class="font-bold no-margins">{{autenticar.tipo == \'NOTA_FISCAL\' ? \'NFS-e Inv\xE1lida\' : autenticar.tipo == \'CARTA_CORRECAO\' ? \'Carta de Corre\xE7\xE3o Inv\xE1lida\' : \'Documento Inv\xE1lido\'}}</h3><small>N\xE3o foi encontrada nenhuma {{autenticar.tipo == \'NOTA_FISCAL\' ? \'NFS-e\' : autenticar.tipo == \'CARTA_CORRECAO\' ? \'Carta de Corre\xE7\xE3o\' : \'NFS-e/Carta de Corre\xE7\xE3o\'}} com os campos informados</small></div></div></div></div>');
$templateCache.put('app/entities/notaFiscal/cancelamentoNotaFiscal.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title" id="myServicoLabel">Cancelamento de Nota Fiscal</h4></div><div class="modal-body"><div class="row" ng-show="notaFiscal.declaracaoPrestacaoServico.cancelamento"><div class="col-md-12 text-center"><h3>J\xE1 existe uma solicita\xE7\xE3o de cancelamento para esse documento.</h3></div><div class="col-md-12"><table class="table"><tr><th>Data do Cancelamento</th><th>Solicitante</th><th>Motivo</th><th>Observa\xE7\xF5es</th><th>Situa\xE7\xE3o</th></tr><tr><td>{{notaFiscal.declaracaoPrestacaoServico.cancelamento.dataCancelamento | date: \'dd/MM/yyyy\'}}</td><td>{{notaFiscal.declaracaoPrestacaoServico.cancelamento.solicitante}}</td><td>{{\'nfseApp.MotivoCancelamento.\'+notaFiscal.declaracaoPrestacaoServico.cancelamento.motivoCancelamento | translate}}</td><td>{{notaFiscal.declaracaoPrestacaoServico.cancelamento.observacoesCancelamento}}</td><td>{{\'nfseApp.SituacaoDeferimento.\'+notaFiscal.declaracaoPrestacaoServico.cancelamento.situacaoFiscal | translate}}</td></tr></table></div></div><div class="row" ng-show="podeSolicitar"><form name="editForm" role="form" novalidate><div class="form-group col-md-12"><div class="col-md-2"><small>N\xB0 da Nota Fiscal</small><br><strong>{{cancelamento.notaFiscal.numero}}</strong></div><div class="col-md-8"><small>Tomador do Servi\xE7o</small><br><strong ng-show="cancelamento.notaFiscal.tomador && cancelamento.notaFiscal.tomador.dadosPessoais">{{cancelamento.notaFiscal.tomador.dadosPessoais.cpfCnpj}} - {{cancelamento.notaFiscal.tomador.dadosPessoais.nomeRazaoSocial}} </strong><strong ng-show="!cancelamento.notaFiscal.tomador || !cancelamento.notaFiscal.tomador.dadosPessoais">N\xE3o Identificado</strong></div><div class="col-md-2"><small>Total do Servi\xE7o</small><br><strong>{{cancelamento.notaFiscal.totalServicos | currency:\'R$ \'}}</strong></div></div><div class="form-group col-md-12"><div class="col-md-12"><label for="field_motivo">Motivo do cancelamento</label><select class="form-control" name="motivo" required ng-model="cancelamento.motivoCancelamento" id="field_motivo"><option value="ERRO_EMISSAO">Erro de emiss\xE3o</option><option value="SERVICO_NAO_PRESTADO">Servi\xE7o n\xE3o prestado</option><option value="DUPLICIDADE">Duplicidade de nota</option><option value="ERRO_ASSINATURA">Erro de assinatura</option><option value="ERRO_DADOS">Erro de dados na Emiss\xE3o</option></select><div ng-show="editForm.motivo.$invalid"><p class="help-block" ng-show="editForm.motivo.$error.required">Informe o Motivo</p></div></div></div><div class="form-group col-md-12"><div class="col-md-12"><label for="field_observacap">Observa\xE7\xF5es do cancelamento</label><textarea type="text" class="form-control" ng-maxlength="3000" name="observacao" id="field_observacap" ng-model="cancelamento.observacoesCancelamento">\n                    </textarea></div></div><div class="form-group col-md-12"><div class="col-md-12"><label for="field_substituida">Foi substituida por outra nota?</label><div class="switch"><div class="onoffswitch"><input enter-as-tab type="checkbox" checked="checked" name="subistituida" ng-model="substituida" class="onoffswitch-checkbox" id="field_substituida"><label class="onoffswitch-label" for="field_substituida"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span> <span class="onoffswitch-switch"></span></label></div></div></div></div><div ng-show="substituida" class="form-group col-md-12"><div class="col-md-2"><label for="field_numeroSubstituta">N\xB0 Nota Fiscal Substituta</label><div class="input-group"><input enter-as-tab type="text" class="form-control" name="numeroSubstituta" id="field_numeroSubstituta" ng-model="numeroSubstituta" ng-blur="findNotaSubstituta()"></div></div><div class="col-md-8" ng-show="cancelamento.notaFiscalSubstituta"><small>Tomador do Servi\xE7o</small><br><strong ng-show="cancelamento.notaFiscalSubstituta.tomador">{{cancelamento.notaFiscalSubstituta.tomador.dadosPessoais.cpfCnpj - cancelamento.notaFiscalSubstituta.tomador.dadosPessoais.nomeRazaoSocial}} </strong><strong ng-show="!cancelamento.notaFiscalSubstituta.tomador">N\xE3o Identificado</strong></div><div class="col-md-2" ng-show="cancelamento.notaFiscalSubstituta"><small>Total do Servi\xE7o</small><br><strong>{{cancelamento.notaFiscalSubstituta.totalServicos | currency:\'R$ \'}}</strong></div></div></form></div></div><div class="modal-footer" ng-show="podeSolicitar"><button type="submit" ng-click="cancelarNota()" ng-disabled="editForm.$invalid || (cancelamento.substituida && !cancelamento.notaFiscalSubstituta)" class="btn btn-danger"><span class="glyphicon glyphicon-check"></span>&nbsp; <span>Cancelar Nota Fiscal</span></button></div>');
$templateCache.put('app/entities/notaFiscal/enviar-nota-email.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title" id="myServicoLabel">Deseja notificar mais algu\xE9m por e-mail?</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><form name="editForm"><div class="form-group"><div class="form-group col-md-12"><input type="text" class="form-control" multiple-emails name="recipientEmail" ng-model="notaFiscal.emails"><div ng-show="editForm.recipientEmail.$invalid"><p class="help-block">E-mail informado inv\xE1lido</p></div></div><div class="col-md-12"><span class="help-block m-b-none">Informe todos os e-mails a serem notificados separados por virgula. Ex. jose@gmail.com, maria@gmail.com</span></div></div><div class="form-group col-md-12"><button ng-click="ok()" class="btn btn-success pull-right"><i class="fa fa-send"></i> Enviar</button></div></form></div></div></div>');
$templateCache.put('app/entities/notaFiscal/item-declaracao-servico-search.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title" id="myServicoLabel">Descrimina\xE7\xE3o dos Servi\xE7os</h4></div><div class="modal-body"><div class="row"></div><div class="table-responsive" style="max-height: 400px; overflow-y: auto"><table class="table table-striped"><thead><tr><th>Descri\xE7\xE3o</th><th></th></tr></thead><tbody><tr ng-repeat="itemDeclaracao in itensDeclaracaoServico"><td>{{itemDeclaracao}}</td><td class="pull-right"><button type="submit" ng-click="ok(itemDeclaracao)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-check"></span></button></td></tr></tbody></table></div><span nfse-app-pagination></div>');
$templateCache.put('app/entities/notaFiscal/notaFiscal-detail.html','<form class="form-horizontal" name="editForm" role="form" novalidate><div class="ibox float-e-margins"><div class="ibox-content"><div ng-include="\'scripts/app/entities/notaFiscal/notaFiscal-ver.html\'"></div></div></div><button type="submit" ui-sref="notaFiscal" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></form>');
$templateCache.put('app/entities/notaFiscal/notaFiscal-edit.html','<div class="row"><div class="col-lg-12"><form name="editForm" role="form" novalidate><div class="ibox animated fadeInDown"><div class="ibox-content"><div class="row"><div class="col-md-12 small"><div class="form-group col-md-6"><label for="field_prestador_servicos">Prestador</label><input type="text" class="form-control" name="field_prestador_servicos" id="field_prestador_servicos" disabled="disabled" value="{{prestador.pessoa.dadosPessoais.nomeRazaoSocial}} ({{prestador.pessoa.dadosPessoais.cpfCnpj | brCpfCnpj}})"></div><div class="form-group col-md-4"><label for="field_prestador_servicos">Enquadramento Fiscal</label><input type="text" class="form-control" name="field_regimeTributario" id="field_regimeTributario" disabled="disabled" value="{{\'nfseApp.RegimeTributario.\' + prestador.enquadramentoFiscal.regimeTributario | translate}}"></div><div class="form-group col-md-2" ng-show="emissaoRetroativa"><label>Data de Emiss\xE3o</label><input type="date" ng-model="notaFiscal.emissao" ng-blur="validarDataEmissao()" class="form-control"></div></div></div></div></div><div class="ibox animated fadeInDown" ng-if="notaFiscal.cancelamentoSubstituicao"><div class="ibox-content"><div class="row"><div class="col-md-12"><h3>Dados da Substitui\xE7\xE3o</h3></div><div class="col-md-12"><div class="form-group col-md-2"><label for="field_prestador_servicos">Nfs-e Substitu\xEDda</label><input type="text" class="form-control" disabled="disabled" ng-value="notaFiscal.cancelamentoSubstituicao.notaFiscal.numero"></div><div class="form-group col-md-4"><label>Motivo Cancelamento</label><select class="form-control" name="motivo" required ng-model="notaFiscal.cancelamentoSubstituicao.motivoCancelamento"><option value="ERRO_EMISSAO">Erro de emiss\xE3o</option><option value="SERVICO_NAO_PRESTADO">Servi\xE7o n\xE3o prestado</option><option value="DUPLICIDADE">Duplicidade de nota</option><option value="ERRO_ASSINATURA">Erro de assinatura</option><option value="ERRO_DADOS">Erro de dados na Emiss\xE3o</option></select><div ng-show="editForm.motivo.$invalid"><p class="help-block" ng-show="editForm.motivo.$error.required">Informe o Motivo do Cancelamento</p></div></div><div class="form-group col-md-6"><label>Observa\xE7\xF5es do cancelamento</label><textarea type="text" class="form-control" ng-maxlength="3000" ng-model="notaFiscal.cancelamentoSubstituicao.observacoesCancelamento">\n                                        </textarea></div></div><div class="col-md-12"></div></div></div></div><div class="ibox float-e-margins animated fadeInDown" ng-show="passoAtual === passos.tipoTomador && configuracao.vincularRpsNaEmissao"><div class="ibox-content"><div class="row"><div class="col-md-12"><h3>Existe um RPS para esta nota?</h3><button class="btn btn-success" ng-class="{\'btn-outline\': possuiRps}" ng-click="possuiRps = false" type="button"><i class="fa {{!possuiRps? \'fa-check-circle-o\':\'fa-circle-o\'}}"></i> N\xE3o</button> <button class="btn btn-success" ng-class="{\'btn-outline\': !possuiRps}" ng-click="possuiRps = true" type="button"><i class="fa {{possuiRps? \'fa-check-circle-o\':\'fa-circle-o\'}}"></i> Sim</button></div></div><div class="row animated fadeInDown" ng-show="possuiRps"><div class="form-group col-md-4"><label for="field_numeroRps">N\xFAmero do RPS</label><input type="text" class="form-control" name="numeroRps" id="field_numeroRps" ng-blur="copiarNotaPorRps()" ng-model="notaFiscal.rps.numero"></div><div class="form-group col-md-4"><label for="field_serieRps">S\xE9rie</label><input type="text" class="form-control" name="serieRps" id="field_serieRps" ng-model="notaFiscal.rps.serie"></div><div class="form-group col-md-4"><label for="field_serieRps">Data de Emiss\xE3o</label><input type="text" ng-model="notaFiscal.rps.dataEmissao" id="field_emissaoRps" class="form-control" ui-date-mask="dd/MM/yyyy" name="emissaoRps"></div></div></div></div><div class="ibox float-e-margins animated fadeInDown" ng-show="passoAtual === passos.tipoTomador"><div class="ibox-content"><div class="row"><div class="col-md-12"><h3>Para quem foi prestado o servi\xE7o?</h3></div></div><div class="row"><div class="col-md-3"><button class="btn btn-success btn-block" ng-class="{\'btn-outline\': notaFiscal.declaracaoPrestacaoServico.modalidade != \'IDENTIFICADO\'}" ng-click="notaFiscal.declaracaoPrestacaoServico.modalidade = \'IDENTIFICADO\'; notaFiscal.tomador ={}" type="button"><i class="fa {{notaFiscal.declaracaoPrestacaoServico.modalidade == \'IDENTIFICADO\'? \'fa-check-circle-o\':\'fa-circle-o\'}}"></i> Tomador Identificado</button></div><div class="col-md-6"><button class="btn btn-success btn-outline btn-block" ng-click="notaFiscal.declaracaoPrestacaoServico.modalidade = \'SEM_CPF\'; notaFiscal.tomador={}" ng-class="{\'btn-outline\': notaFiscal.declaracaoPrestacaoServico.modalidade != \'SEM_CPF\'}" type="button"><i class="fa {{notaFiscal.declaracaoPrestacaoServico.modalidade == \'SEM_CPF\'? \'fa-check-circle-o\':\'fa-circle-o\'}}"></i> Estabelecido Fora do Pa\xEDs</button></div><div class="col-md-3"><button class="btn btn-success btn-outline btn-block" ng-class="{\'btn-outline\': notaFiscal.declaracaoPrestacaoServico.modalidade != \'NAO_IDENTIFICADO\'}" ng-click="notaFiscal.declaracaoPrestacaoServico.modalidade = \'NAO_IDENTIFICADO\'; notaFiscal.tomador={}; proximoPasso(); verificarExigibilidadeIss()" type="button"><i class="fa {{notaFiscal.declaracaoPrestacaoServico.modalidade == \'NAO_IDENTIFICADO\'? \'fa-check-circle-o\':\'fa-circle-o\'}}"></i> N\xE3o Identificado (Consumidor)</button></div></div><div class="row m-t-sm"><div class="col-md-12"><div class="row animated fadeInDown" ng-show="notaFiscal.declaracaoPrestacaoServico.modalidade == \'IDENTIFICADO\'"><div class="form-group col-md-4" ng-class="{\'has-error\' : editForm.cpfCnpj.$invalid && (editForm.$submitted || editForm.cpfCnpj.$touched)}"><label class="control-label" for="field_cpfCnpj">CPF ou CNPJ</label><div class="input-group"><input type="text" class="form-control" name="cpfCnpj" id="field_cpfCnpj" ui-br-cpfcnpj-mask ng-change="preLoadTomador()" ng-model="notaFiscal.tomador.dadosPessoais.cpfCnpj" required> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="searchTomadorServico()"><span class="glyphicon glyphicon-search"></span></button></span></div><div ng-show="editForm.cpfCnpj.$invalid"><p class="help-block" ng-show="editForm.cpfCnpj.$error.required">Informe o CPF ou CNPJ</p><p class="help-block" ng-show="editForm.cpfCnpj.$error.cpf || editForm.cpfCnpj.$error.cnpj">CPF ou CNPJ inv\xE1lido</p></div><div ng-show="notaFiscal.tomador && notaFiscal.tomador.cadastroEconomico && notaFiscal.tomador.cadastroEconomico.enquadramentoFiscal.substitutoTributario"><p class="help-block">Substituto Tribut\xE1rio</p></div></div></div><div ng-show="editForm.cpfCnpj.$valid || notaFiscal.declaracaoPrestacaoServico.modalidade == \'SEM_CPF\'" class="fadeInDown animated"><div class="row" ng-show="!isFisica()"><div class="form-group col-md-4"><label for="field_inscricaoMunicipal">Inscri\xE7\xE3o Municipal</label><input type="text" class="form-control" name="inscricaoMunicipal" id="field_inscricaoMunicipal" ng-model="notaFiscal.tomador.dadosPessoais.inscricaoMunicipal"></div><div class="form-group col-md-8"><label class="control-label" for="field_nomeFantasia">Nome Fantasia</label><input type="text" class="form-control" name="nomeFantasia" id="field_nomeFantasia" ng-model="notaFiscal.tomador.dadosPessoais.nomeFantasia"></div></div><div class="row"><div class="form-group col-md-6" ng-class="{\'has-error\' : editForm.nomeRazaoSocial.$invalid && (editForm.$submitted || editForm.nomeRazaoSocial.$touched)}"><label class="control-label" for="field_nomeRazaoSocial">{{isFisica() ? \'Nome \' : \'Raz\xE3o Social \'}}</label><input type="text" class="form-control" name="nomeRazaoSocial" id="field_nomeRazaoSocial" ng-model="notaFiscal.tomador.dadosPessoais.nomeRazaoSocial" required><div ng-show="editForm.nomeRazaoSocial.$invalid"><p class="help-block" ng-show="editForm.nomeRazaoSocial.$error.required">Informe o Nome ou a Raz\xE3o Social</p></div></div><div class="form-group col-md-3" ng-if="notaFiscal.declaracaoPrestacaoServico.modalidade != \'SEM_CPF\'" ng-class="{\'has-error\' : editForm.inscricaoEstadual.$invalid && (editForm.$submitted || editForm.inscricaoEstadual.$touched)}"><label class="control-label" for="field_inscricaoEstadual">Inscri\xE7\xE3o Estadual</label><input type="text" class="form-control" name="inscricaoEstadual" id="field_inscricaoEstadual" ng-model="notaFiscal.tomador.dadosPessoais.inscricaoEstadual"></div><div class="form-group col-md-3" ng-if="isFisica() && notaFiscal.declaracaoPrestacaoServico.modalidade != \'SEM_CPF\'" ng-class="{\'has-error\' : editForm.rg.$invalid  && (editForm.$submitted || editForm.rg.$touched)}"><label class="control-label" for="field_rg">RG</label><input type="text" class="form-control" name="rg" id="field_rg" ng-model="notaFiscal.tomador.dadosPessoais.rg"></div><div ng-show="notaFiscal.declaracaoPrestacaoServico.modalidade === \'SEM_CPF\'" class="form-group col-md-4" ng-class="{\'has-error\' : editForm.nomeRazaoSocial.$invalid && (editForm.$submitted || editForm.nomeRazaoSocial.$touched)}"><label class="control-label" for="field_identificacaoFora">N\xBA. Identifica\xE7\xE3o</label><input type="text" class="form-control" name="field_identificacaoFora" id="field_identificacaoFora" ng-model="notaFiscal.tomador.dadosPessoais.numeroIdentificacao"></div></div><div class="row"><div class="form-group col-md-4"><label for="field_apelido">Apelido</label><input type="text" class="form-control" name="email" id="field_apelido" ng-model="notaFiscal.tomador.dadosPessoais.apelido"></div><div class="form-group col-md-5"><label for="field_email">e-Mail</label><input type="text" class="form-control" name="email" id="field_email" ng-model="notaFiscal.tomador.dadosPessoais.email"></div><div class="form-group col-md-3"><label for="field_telefone">Telefone</label><input type="text" class="form-control" name="telefone" id="field_telefone" ui-br-phone-number ng-model="notaFiscal.tomador.dadosPessoais.telefone"></div></div><div class="row fadeInDown animated" ng-show="notaFiscal.declaracaoPrestacaoServico.modalidade == \'SEM_CPF\'"><div class="form-group col-md-6"><label for="field_apelido">Munic\xEDpio</label><input type="text" class="form-control" name="email" id="field_municipio_fora" ng-model="notaFiscal.tomador.dadosPessoais.municipio.nome"></div><div class="form-group col-md-6"><label for="field_servico_nome_pais">Pais</label><div class="input-group"><input type="text" class="form-control" name="field_pais_fora" id="field_pais_fora" disabled="disabled" value="{{notaFiscal.tomador.dadosPessoais.pais.nome}}"> <span class="input-group-btn"><button type="button" class="btn" ng-click="searchPais(notaFiscal.tomador.dadosPessoais)"><span class="glyphicon glyphicon-search"></span></button></span></div></div></div><div class="row fadeInDown animated" ng-form="enderecoForm" ng-show="notaFiscal.declaracaoPrestacaoServico.modalidade == \'IDENTIFICADO\'"><div class="form-group col-md-2"><label for="field_cep">Cep</label><input type="text" class="form-control" name="cep" id="field_cep" ui-br-cep-mask required ng-blur="loadEnderecoByCEP(notaFiscal.tomador.dadosPessoais.cep)" ng-model="notaFiscal.tomador.dadosPessoais.cep"><div ng-show="enderecoForm.cep.$invalid"><p class="help-block" ng-show="enderecoForm.cep.$error.required">Informe o CEP</p></div></div><div class="form-group col-md-8"><label for="field_nome_municipio">Munic\xEDpio</label><div class="input-group"><input type="text" class="form-control" name="nome_municipio" id="field_nome_municipio" disabled="disabled" required="" ng-model="notaFiscal.tomador.dadosPessoais.municipio.nome"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="searchMunicipio(notaFiscal.tomador.dadosPessoais)"><span class="glyphicon glyphicon-search"></span></button></span></div><div ng-show="enderecoForm.nome_municipio.$invalid"><p class="help-block" ng-show="enderecoForm.nome_municipio.$error.required">Informe o Munic\xEDpio</p></div></div><div class="form-group col-md-2"><label for="field_estado_municipio">Estado</label><input type="text" class="form-control" name="estado_municipio" id="field_estado_municipio" disabled="disabled" ng-model="notaFiscal.tomador.dadosPessoais.municipio.estado"></div><div class="form-group col-md-12"><label for="field_logradouro">Logradouro</label><input type="text" class="form-control" name="logradouro" id="field_logradouro" required ng-model="notaFiscal.tomador.dadosPessoais.logradouro"><div ng-show="enderecoForm.logradouro.$invalid"><p class="help-block" ng-show="enderecoForm.logradouro.$error.required">Informe o Logradouro</p></div></div><div class="form-group col-md-6"><label for="field_bairro">Bairro</label><input type="text" class="form-control" name="bairro" id="field_bairro" required ng-model="notaFiscal.tomador.dadosPessoais.bairro"><div ng-show="enderecoForm.bairro.$invalid"><p class="help-block" ng-show="enderecoForm.bairro.$error.required">Informe o Bairro</p></div></div><div class="form-group col-md-2"><label for="field_numero">N\xFAmero</label><input type="text" class="form-control" name="numero" id="field_numero" required ng-model="notaFiscal.tomador.dadosPessoais.numero"><div ng-show="enderecoForm.numero.$invalid"><p class="help-block" ng-show="enderecoForm.numero.$error.required">Informe o N\xFAmero</p></div></div><div class="form-group col-md-4"><label for="field_complemento">Complemento</label><input type="text" class="form-control" name="complemento" id="field_complemento" ng-model="notaFiscal.tomador.dadosPessoais.complemento"></div></div></div></div></div><div class="row" ng-show="notaFiscal.declaracaoPrestacaoServico.modalidade"><div class="col-md-12"><button class="btn btn-success" ng-disabled="(notaFiscal.declaracaoPrestacaoServico.modalidade == \'IDENTIFICADO\' && (enderecoForm.$invalid || editForm.cpfCnpj.$invalid || editForm.nomeRazaoSocial.$invalid)) || (notaFiscal.declaracaoPrestacaoServico.modalidade == \'SEM_CPF\' &&  editForm.nomeRazaoSocial.$invalid)" ng-click="proximoPasso(); verificarExigibilidadeIss()" type="button"><i class="fa fa-chevron-right"></i> Continuar</button></div></div></div></div><div class="ibox float-e-margins animated fadeInDown" ng-show="passoAtual === passos.servico"><div class="ibox-content"><div class="row"><div class="col-md-12"><h3>Qual o servi\xE7o prestado?</h3></div></div><div class="row m-t-md"><div class="form-group col-md-2"><label class="center-block">CNAE</label><input type="text" class="form-control" name="complemento" id="field_codigoCnae" ng-change="selecionarCnaePorCodigo()" ng-model="codigoCnae"></div><div class="form-group col-md-10"><label class="center-block">&ensp;</label><select class="form-control" ng-change="loadServico()" id="field_servico_cnae" name="cnae_descricao" ng-model="notaFiscal.cnae" ng-options="cnae as cnae.codigo + \' - \' + cnae.descricao for cnae in cnaes track by cnae.id"><option value=""></option></select></div><div class="form-group col-md-2"><label class="center-block">Servi\xE7o</label><input type="text" class="form-control" name="complemento" id="field_codigoServico" ng-change="selecionarServicoPorCodigo()" ng-model="codigoServico"></div><div class="form-group col-md-10"><label class="center-block">&ensp;</label><select class="form-control" ng-change="selecionouServico()" id="field_servico_descricao" name="servico_descricao" ng-model="notaFiscal.servico" ng-options="servico as servico.codigo + \' - \' + servico.descricaoCurta for servico in servicos track by servico.id"><option value=""></option></select></div><div class="form-group col-md-offset-2 col-md-10 text-left text-small text-muted">{{notaFiscal.servico.descricao}}</div></div><div class="row form-group text-center text-small text-muted" ng-show="notaFiscal.servico"><div class="col-md-12"><div class="col-md-4">Prestado <span translate="nfseApp.LocalExecucao.{{notaFiscal.servico.localExecucaoTrabalho}}"></span></div><div class="col-md-4"><i class="{{notaFiscal.servico && notaFiscal.servico.permiteDeducao ? \'fa fa-check-circle-o text-success\' : \'fa fa-times-circle text-danger\'}}"></i> {{notaFiscal.servico && notaFiscal.servico.permiteDeducao ? \'\' : \'N\xE3o\' }} Permite Dedu\xE7\xE3o</div><div class="col-md-4" ng-if="notaFiscal.tomador.cadastroEconomico && notaFiscal.tomador.cadastroEconomico.enquadramentoFiscal.substitutoTributario"><i class="{{notaFiscal.tomador.cadastroEconomico && notaFiscal.tomador.cadastroEconomico.enquadramentoFiscal.substitutoTributario ? \'fa fa-check-circle-o text-success\' : \'fa fa-times-circle text-danger\'}}"></i> {{notaFiscal.tomador.cadastroEconomico && notaFiscal.tomador.cadastroEconomico.enquadramentoFiscal.substitutoTributario ? \'\' : \'N\xE3o\' }} Substituto Tribut\xE1rio</div></div></div><div class="row fadeInDown animated" ng-show="notaFiscal.servico.construcaoCivil"><div class="form-group col-md-4"><label class="center-block">ART</label><input type="text" id="field_art" name="art" class="form-control" ng-model="art" ng-blur="buscarObra()"></div><div class="form-group col-md-3"><label class="center-block">C\xF3digo da Obra</label><input type="text" id="field_codigo_obra" name="codigoObra" class="form-control" ng-model="notaFiscal.declaracaoPrestacaoServico.construcaoCivil.codigoObra" ng-disabled="true"></div><div class="form-group col-md-3"><label class="center-block">N\xB0 Alvar\xE1</label><input type="text" id="field_numero_alvara" name="numeroAlvara" class="form-control" ng-model="notaFiscal.declaracaoPrestacaoServico.construcaoCivil.numeroAlvara" ng-disabled="true"></div><div class="form-group col-md-2"><label for="field_incorporacao">Incorpora\xE7\xE3o?</label><div class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="field_incorporacao" ng-model="notaFiscal.declaracaoPrestacaoServico.construcaoCivil.incorporacao" ng-disabled="true" class="onoffswitch-checkbox" id="field_incorporacao"><label class="onoffswitch-label" for="field_prestadoNoPais"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span> <span class="onoffswitch-switch"></span></label></div></div></div></div><div class="row m-t-md"><div class="form-group col-md-2"><label for="field_prestadoNoPais">Foi prestado no pais?</label><div class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="prestadoNoPais" ng-model="notaFiscal.prestadoNoPais" ng-disabled="!permiteMudarPais" ng-change="verificarRetencaoIss(); verificarExigibilidadeIss()" class="onoffswitch-checkbox" id="field_prestadoNoPais"><label class="onoffswitch-label {{permiteMudarPais ? \'\': \'disabled\'}}" for="field_prestadoNoPais"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch {{permiteMudarPais ? \'\': \'disabled\'}}"></span> <span class="onoffswitch-switch {{permiteMudarPais ? \'\': \'disabled\'}}"></span></label></div></div></div><div ng-if="notaFiscal.prestadoNoPais" class="form-group col-md-4"><label for="field_servico_nome_municipio">Qual Municipio?</label><div class="input-group"><input type="text" class="form-control" name="nome_servico_municipio" id="field_servico_nome_municipio" disabled="disabled" value="{{notaFiscal.municipio.nome}}/{{notaFiscal.municipio.estado}}"> <span class="input-group-btn"><button type="button" class="btn {{permiteMudarCidade ? \'btn-info\': \'\'}}" ng-disabled="!permiteMudarCidade" ng-click="searchMunicipio(notaFiscal)"><span class="fa fa-search"></span></button></span></div></div><div ng-if="!notaFiscal.prestadoNoPais" class="form-group col-md-4"><label for="field_servico_nome_pais">Qual Pais?</label><div class="input-group"><input type="text" class="form-control" name="nome_servico_pais" id="field_servico_nome_pais" disabled="disabled" value="{{notaFiscal.pais.nome}}"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="searchPais(notaFiscal)"><span class="glyphicon glyphicon-search"></span></button></span></div></div><div class="form-group col-md-6"><label translate="nfseApp.declaracaoPrestacaoServico.naturezaOperacao" for="field_naturezaOperacao">NaturezaOperacao</label><select class="form-control" name="naturezaOperacao" ng-model="notaFiscal.declaracaoPrestacaoServico.naturezaOperacao" ng-disabled="!permiteExigibilidade" id="field_naturezaOperacao" required ng-options="naturezaOperacao as \'nfseApp.NaturezaOperacao.\' + naturezaOperacao | translate for naturezaOperacao in naturezasOperacao"></select></div></div><div class="row" ng-if="exigibilidadeSuspensa()"><div class="form-group col-md-8"><label class="control-label">N\xFAmero do Processo de Suspens\xE3o da Exigibilidade do ISSQN</label><input type="text" class="form-control" required name="processoSuspensa" id="field_processoSuspensa" ng-model="notaFiscal.processoSuspensao"><div class="margin"><p class="help-block" ng-show="exigibilidadeSuspensa() && editForm.processoSuspensa.$error.required">Informe o n\xFAmero do processo de suspens\xE3o da exigibilidade do ISSQN</p></div></div></div><div class="row"><div class="form-group col-md-12"><label class="center-block">Discrimina\xE7\xE3o do servi\xE7o <a ng-click="searchItemDeclaracaoServico()" class="small">Consulta descrimina\xE7\xF5es anteriores</a></label><textarea type="text" class="form-control" maxlength="3000" minlength="3" required="" name="servico_descriminacao_nota" id="field_descriminacao_servico_nota" ng-model="notaFiscal.descriminacaoServico">\n                                        </textarea><p class="help-block">{{notaFiscal.descriminacaoServico.length}}</p><p class="help-block" ng-show="editForm.servico_descriminacao_nota.$error.minlength || editForm.servico_descriminacao_nota.$error.maxlength">A Discrimina\xE7\xE3o do servi\xE7o deve ter entre 3 e 3000 caracteres</p></div></div><div class="row"><div class="col-md-12"><h3><a ng-click="mostrarIntermediario = !mostrarIntermediario "><i class="fa {{mostrarIntermediario ? \'fa-chevron-down\': \'fa-chevron-right\'}}"></i> Intermedi\xE1rio do Servi\xE7o <i>(Opcional)</i></a></h3></div></div><div class="row fadeInDown animated" ng-show="mostrarIntermediario"><div class="col-md-12"><div class="form-group col-md-6" ng-class="{\'has-error\' : editForm.cpfCnpjIntermediario.$invalid\n                                     && (editForm.$submitted || editForm.cpfCnpjIntermediario.$touched)}"><label class="control-label" for="field_cpfCnpjIntermediario">CPF ou CNPJ</label><div class="input-group"><input type="text" class="form-control" name="cpfCnpjIntermediario" id="field_cpfCnpjIntermediario" ui-br-cpfcnpj-mask ng-model="notaFiscal.declaracaoPrestacaoServico.intermediario.cpfCnpj" required> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="searchIntermediarioServico()"><span class="glyphicon glyphicon-search"></span></button></span></div><div ng-show="editForm.cpfCnpjIntermediario.$invalid"><p class="help-block" ng-show="editForm.cpfCnpjIntermediario.$error.required">Informe o CPF ou CNPJ</p><p class="help-block" ng-show="editForm.cpfCnpjIntermediario.$error.cpf || editForm.cpfCnpjIntermediario.$error.cnpj">CPF ou CNPJ inv\xE1lido</p></div></div><div class="form-group col-md-6" ng-class="{\'has-error\' : editForm.nomeRazaoSocialIntermediario.$invalid\n                                     && (editForm.$submitted || editForm.nomeRazaoSocialIntermediario.$touched)}"><label class="control-label" for="field_nomeRazaoSocialIntermediario">Nome ou Raz\xE3o Social</label><input type="text" class="form-control" name="nomeRazaoSocialIntermediario" id="field_nomeRazaoSocialIntermediario" ng-model="notaFiscal.declaracaoPrestacaoServico.intermediario.nomeRazaoSocial" required><div ng-show="editForm.nomeRazaoSocialIntermediario.$invalid"><p class="help-block" ng-show="editForm.nomeRazaoSocialIntermediario.$error.required">Informe o Nome ou a Raz\xE3o Social</p></div></div></div></div><div class="row m-t-md"><div class="col-md-12"><button class="btn btn-default" ng-click="passoAnterior();" type="button"><i class="fa fa-chevron-left"></i> Voltar</button> <button class="btn btn-success" ng-click="proximoPasso(); clearServico()" ng-disabled="!notaFiscal.cnae || !notaFiscal.servico || !notaFiscal.descriminacaoServico" type="button"><i class="fa fa-chevron-right"></i> Continuar</button></div></div></div></div><div class="ibox float-e-margins" ng-show="passoAtual === passos.itensNota"><div class="ibox-content"><div class="row"><div class="col-md-12"><h3>Itens da Nota</h3></div></div><div class="row m-t-md"><div class="form-group col-md-12" ng-show="notaFiscal.declaracaoPrestacaoServico.itens.length > 0"><table class="table table-striped"><thead><tr><th colspan="6">Servi\xE7os j\xE1 adicionados</th></tr><tr><th>Dedu\xE7\xE3o</th><th>C\xF3digo</th><th>Descri\xE7\xE3o</th><th>Valor unit\xE1rio</th><th>Quantidade</th><th>Desconto</th><th>Total</th><th></th></tr></thead><tbody><tr ng-repeat="serv in notaFiscal.declaracaoPrestacaoServico.itens"><td class="col-md-1">{{serv.deducao ? \'Sim\' : \'N\xE3o\'}}</td><td class="col-md-1">{{serv.servico.codigo}}</td><td class="col-md-5">{{serv.descricao}}</td><td class="col-md-1">{{serv.valorServico | currency: \'R$ \' : 5}}</td><td class="col-md-1">{{serv.quantidade }}</td><td class="col-md-1">{{serv.descontosIncondicionados | currency: \'R$ \'}}</td><td class="col-md-2">{{serv.total | currency: \'R$ \'}}</td><td class="col-md-2"><div class="pull-right"><button type="submit" ng-click="removeServico($index)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button> <button type="submit" ng-click="editaServico($index)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-pencil"></span></button></div></td></tr></tbody></table></div></div><div collapse="!mostraFormServicos" class="fadeIn"><div class="row"><div class="form-group col-md-12"><label class="center-block">Descri\xE7\xE3o do item</label><input type="text" class="form-control" name="servico_aliquota" id="field_descriminacao_servico" maxlength="100" minlength="3" ng-model="servico.descricao"><p class="help-block" ng-show="editForm.field_descriminacao_servico.$error.minlength || editForm.field_descriminacao_servico.$error.maxlength">A descri\xE7\xE3o do item deve ter entre 3 e 100 caracteres</p></div></div><div class="margin"><p class="help-block text-danger" ng-show="getSomaDescontosServico() > servico.valorServico * servico.quantidade">O valor dos descontos n\xE3o pode ser maior que o valor dos servi\xE7os</p></div><div class="row"><div class="form-group col-md-3" ng-class="{\'has-error\' : servico.valorServico <= 0 && (editForm.$submitted || editForm.servico_aliquota.$touched)}"><label class="control-label">Valor do Servi\xE7o</label><input type="number" class="form-control" ng-change="calculaValoresServico(servico)" ng-pattern="/^[0-9]+(\\.[0-9]{1,5})?$/" step="0.01" name="servico_aliquota" id="field_servico_valor_servico" ng-model="servico.valorServico"><div class="margin"><div ng-show="editForm.servico_aliquota.$invalid"><p class="help-block text-danger">O valor inv\xE1lido deve ser maior que ZERO (R$ 0,00) e ter at\xE9 5 casas decimais</p></div><p class="help-block" ng-show="servico.valorServico <= 0">O valor deve ser maior que ZERO (R$ 0,00)</p></div></div><div class="form-group col-md-2"><label class="center-block">Quantidade</label><input type="number" class="form-control" ng-class="{\'has-error\' : servico.quantidade <= 0 && (editForm.$submitted || editForm.servico_quantidade.$touched)}" ng-blur="calculaValoresServico(servico)" name="servico_quantidade" id="field_servico_quantidade" ng-model="servico.quantidade"><div class="margin"><p class="help-block" ng-show="servico.quantidade <= 0">O valor deve ser maior que ZERO (0)</p></div></div><div class="form-group col-md-2" ng-class="{\'has-error\' : getSomaDescontosServico() > servico.total  && (editForm.$submitted || editForm.field_servico_desconto_incondicionado.$touched)}"><label class="center-block">Desconto</label><input type="text" class="form-control" ui-money-mask="" name="servico_desconto_incondicionado" id="field_servico_desconto_incondicionado" ng-change="calculaValoresServico(servico)" ng-model="servico.descontosIncondicionados"></div><div class="form-group col-md-3"><label class="center-block">Total do Servi\xE7o</label><input type="text" class="form-control" ui-money-mask="" disabled="disabled" name="servico_total_servico" id="field_servico_total_servico" ng-model="servico.total"></div><div class="form-group col-md-3 hidden"><label class="center-block">Base de Calculo</label><input type="text" class="form-control" ui-money-mask="" disabled="disabled" name="servico_base_calculo" id="field_servico_base_calculo" ng-model="servico.baseCalculo"></div><div class="form-group col-md-2"><label for="field_isDeducao">\xC9 Dedu\xE7\xE3o?</label><div class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="isDeducao" ng-model="servico.deducao" ng-disabled="!notaFiscal.servico.permiteDeducao" class="onoffswitch-checkbox" id="field_isDeducao"><label class="onoffswitch-label {{notaFiscal.servico.permiteDeducao ? \'\': \'disabled\'}}" for="field_isDeducao"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch {{notaFiscal.servico.permiteDeducao ? \'\': \'disabled\'}}"></span> <span class="onoffswitch-switch {{notaFiscal.servico.permiteDeducao ? \'\': \'disabled\'}}"></span></label></div></div></div></div><div class="row fadeInDown animated" ng-show="servico.deducao"><div class="form-group col-md-3"><label class="center-block" for="tipoDeducao">Tipo de Dedu\xE7\xE3o</label><select class="form-control" id="tipoDeducao" name="tipoDeducao" ng-model="servico.tipoDeducao"><option value="MATERIAL">Material</option><option value="SUB_EMPREITADA">Sub Empreitada</option><option value="ALUGUEL_DE_EQUIPAMENTOS">Aluguel de Equipamentos</option></select></div><div class="form-group col-md-3"><label class="center-block" for="tipoOperacao">Tipo de Operacao</label><select class="form-control" id="tipoOperacao" name="tipoOperacao" ng-model="servico.tipoOperacao"><option value="VENDAS">Vendas</option><option value="PRESTACAO_DE_SERVICOS">Presta\xE7\xE3o de Servi\xE7os</option></select></div><div class="form-group col-md-2"><label class="center-block" for="numeroDocFiscalDeducao">N\xBA Doc. Fiscal</label><input type="text" class="form-control" name="numeroDocFiscalDeducao" id="numeroDocFiscalDeducao" maxlength="100" minlength="3" ng-model="servico.numeroDocumentoFiscal"></div><div class="form-group col-md-2"><label class="center-block" for="valorDocFiscalDeducao">Valor Doc. Fiscal</label><input type="text" class="form-control" ui-money-mask="" name="valorDocFiscalDeducao" id="valorDocFiscalDeducao" ng-model="servico.valorDocumentoFiscal"></div><div class="form-group col-md-2"><label class="center-block" for="cpfCnpjDeducao">CPF/CNPJ</label><input type="text" class="form-control" name="cpfCnpjDeducao" id="cpfCnpjDeducao" ui-br-cpfcnpj-mask="" ng-model="servico.cpfCnpjDeducao"><p class="help-block" ng-show="editForm.cpfCnpjDeducao.$error.cpf || editForm.cpfCnpjDeducao.$error.cnpj">CPF ou CNPJ inv\xE1lido</p></div></div></div><div class="row"><div class="col-md-12"><a class="pull-right m-sm" ng-show="notaFiscal.declaracaoPrestacaoServico.itens.length > 0 && mostraFormServicos" ng-click="clearServico(); mostraFormServicos = !mostraFormServicos" id="btn-remover-servico"><i class="fa fa-stop-circle"></i> Cancelar Novo Servi\xE7o </a><a class="pull-right m-sm" ng-click="novoServico()" id="btn-add-servico"><i class="fa fa-plus-circle"></i> Informar Novo Servi\xE7o</a></div></div><div class="row m-t-md"><div class="col-md-12"><button class="btn btn-default" ng-click="passoAnterior();" type="button"><i class="fa fa-chevron-left"></i> Voltar</button> <button class="btn btn-success" ng-show="mostraFormServicos" ng-click="addServico(true)" type="button"><i class="fa fa-chevron-right"></i> Adicionar Servi\xE7o e Continuar</button> <button class="btn btn-success" ng-show="!mostraFormServicos" ng-click="proximoPasso()" type="button"><i class="fa fa-chevron-right"></i> Continuar</button></div></div></div></div><div class="ibox float-e-margins fadeInDown animated" ng-show="passoAtual === passos.outrasInfos" ng-init="mostrarTributosFederais = true"><div class="ibox-content"><div class="row m-t-md"><div class="col-md-12"><h3>Tributos Incidentes</h3></div></div><div class="row m-b-md" ng-show="isPrestadorSimplesNacional()"><div class="col-md-12 small text-right"><p>RBT12: {{notaFiscal.prestador.rbt12 ? notaFiscal.prestador.rbt12 : 0 | number:2}} <b ng-show="notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006">&nbsp; {{notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006.descricao}} </b><i ng-show="notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa">&nbsp; Faixa de faturamento at\xE9: {{notaFiscal.prestador.enquadramentoFiscal.anexoLei1232006Faixa.valorMaximo | number:2}}</i></p><a ng-click="alterarAliquotaSimples()"><i class="fa fa-refresh"></i> Alterar Aliquota SNA</a></div></div><div class="row"><div class="form-group col-md-2"><label class="center-block">Al\xEDquota ISS</label><input type="text" class="form-control" name="percentual_iss" ui-number-mask="" ng-disabled="bloqueiaAliquota" id="field_percentual_iss" ng-blur="calculaValoresDaNota(false)" ng-model="notaFiscal.aliquotaServico"></div><div class="form-group col-md-2"><label class="center-block">Valor ISS</label><input type="text" class="form-control" ui-money-mask="" name="iss" ng-disabled="bloqueiaAliquota" id="field_iss" ng-blur="calculaValoresDaNota(false)" ng-model="notaFiscal.declaracaoPrestacaoServico.issCalculado"></div><div class="form-group col-md-2"><label for="field_retencao">ISS Retido?</label><div class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="retencao" ng-disabled="!permiteRetencao" ng-change="verificarExigibilidadeIss()" ng-model="notaFiscal.declaracaoPrestacaoServico.issRetido" class="onoffswitch-checkbox" id="field_retencao"><label class="onoffswitch-label {{permiteRetencao ? \'\': \'disabled\'}}" for="field_retencao"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch {{permiteRetencao ? \'\': \'disabled\'}}"></span> <span class="onoffswitch-switch {{permiteRetencao ? \'\': \'disabled\'}}"></span></label></div></div></div><div class="form-group col-md-2"><label class="center-block">Al\xEDquota PIS</label><input type="text" class="form-control" name="percentual_pis" ui-number-mask="2" id="field_percentual_pis" ng-blur="calcularValoresPorAliquota(\'percentualPis\', \'pis\')" ng-model="notaFiscal.declaracaoPrestacaoServico.tributosFederais.percentualPis"></div><div class="form-group col-md-2"><label class="center-block">Valor PIS</label><input type="text" class="form-control" ui-money-mask="" name="pis" id="field_pis" ng-model="notaFiscal.declaracaoPrestacaoServico.tributosFederais.pis"></div><div class="form-group col-md-2"><label for="field_retencao">PIS Retido?</label><div class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="retencaoPIS" ng-model="notaFiscal.declaracaoPrestacaoServico.tributosFederais.retencaoPis" class="onoffswitch-checkbox" id="field_retencaoPIS"><label class="onoffswitch-label" for="field_retencaoPIS"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span> <span class="onoffswitch-switch"></span></label></div></div></div></div><div class="row"><div class="form-group col-md-2"><label class="center-block">Al\xEDquota COFINS</label><input type="text" class="form-control" name="percentual_cofins" ui-number-mask="2" id="field_percentual_cofins" ng-blur="calcularValoresPorAliquota(\'percentualCofins\', \'cofins\')" ng-model="notaFiscal.declaracaoPrestacaoServico.tributosFederais.percentualCofins"></div><div class="form-group col-md-2"><label class="center-block">Valor COFINS</label><input type="text" class="form-control" ui-money-mask="" name="cofins" id="field_cofins" ng-model="notaFiscal.declaracaoPrestacaoServico.tributosFederais.cofins"></div><div class="form-group col-md-2"><label for="field_retencao">COFINS Retido?</label><div class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="retencaoCOFINS" ng-model="notaFiscal.declaracaoPrestacaoServico.tributosFederais.retencaoCofins" class="onoffswitch-checkbox" id="field_retencaoCOFINS"><label class="onoffswitch-label" for="field_retencaoCOFINS"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="form-group col-md-2"><label class="center-block">Al\xEDquota INSS</label><input type="text" class="form-control" name="percentual_inss" ui-number-mask="2" id="field_percentual_inss" ng-blur="calcularValoresPorAliquota(\'percentualInss\', \'inss\')" ng-model="notaFiscal.declaracaoPrestacaoServico.tributosFederais.percentualInss"></div><div class="form-group col-md-2"><label class="center-block">Valor INSS</label><input type="text" class="form-control" ui-money-mask="" name="inss" id="field_inss" ng-model="notaFiscal.declaracaoPrestacaoServico.tributosFederais.inss"></div><div class="form-group col-md-2"><label for="field_retencao">INSS Retido?</label><div class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="retencaoINSS" ng-model="notaFiscal.declaracaoPrestacaoServico.tributosFederais.retencaoInss" class="onoffswitch-checkbox" id="field_retencaoINSS"><label class="onoffswitch-label" for="field_retencaoINSS"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span> <span class="onoffswitch-switch"></span></label></div></div></div></div><div class="row"><div class="form-group col-md-2"><label class="center-block">Al\xEDquota IR</label><input type="text" class="form-control" name="percentual_irrf" ui-number-mask="2" id="field_percentual_irrf" ng-blur="calcularValoresPorAliquota(\'percentualIrrf\', \'irrf\')" ng-model="notaFiscal.declaracaoPrestacaoServico.tributosFederais.percentualIrrf"></div><div class="form-group col-md-2"><label class="center-block">Valor IR</label><input type="text" class="form-control" ui-money-mask="" name="irrf" id="field_irrf" ng-model="notaFiscal.declaracaoPrestacaoServico.tributosFederais.irrf"></div><div class="form-group col-md-2"><label for="field_retencao">IR Retido?</label><div class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="retencaoIR" ng-model="notaFiscal.declaracaoPrestacaoServico.tributosFederais.retencaoIrrf" class="onoffswitch-checkbox" id="field_retencaoIR"><label class="onoffswitch-label" for="field_retencaoIR"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="form-group col-md-2"><label class="center-block">Al\xEDquota CSLL</label><input type="text" class="form-control" ui-number-mask="2" name="percentual_csll" id="field_percentual_csll" ng-blur="calcularValoresPorAliquota(\'percentualCsll\', \'csll\')" ng-model="notaFiscal.declaracaoPrestacaoServico.tributosFederais.percentualCsll"></div><div class="form-group col-md-2"><label class="center-block">Valor CSLL</label><input type="text" class="form-control" ui-money-mask="" name="csll" id="field_csll" ng-model="notaFiscal.declaracaoPrestacaoServico.tributosFederais.csll"></div><div class="form-group col-md-2"><label for="field_retencao">CSLL Retido?</label><div class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="retencaoCSLL" ng-model="notaFiscal.declaracaoPrestacaoServico.tributosFederais.retencaoCsll" class="onoffswitch-checkbox" id="field_retencaoCSLL"><label class="onoffswitch-label" for="field_retencaoCSLL"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span> <span class="onoffswitch-switch"></span></label></div></div></div></div><div class="row"><div class="form-group col-md-2"><label class="center-block">Al\xEDquota CPP</label><input type="text" class="form-control" ui-number-mask="2" name="percentual_cpp" id="field_percentual_cpp" ng-blur="calcularValoresPorAliquota(\'percentualCpp\', \'cpp\')" ng-model="notaFiscal.declaracaoPrestacaoServico.tributosFederais.percentualCpp"></div><div class="form-group col-md-2"><label class="center-block">Valor CPP</label><input type="text" class="form-control" ui-money-mask="" name="csll" id="field_cpp" ng-model="notaFiscal.declaracaoPrestacaoServico.tributosFederais.cpp"></div><div class="form-group col-md-2"><label for="field_retencao">CPP Retido?</label><div class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="retencaoCPP" ng-model="notaFiscal.declaracaoPrestacaoServico.tributosFederais.retencaoCpp" class="onoffswitch-checkbox" id="field_retencaoCPP"><label class="onoffswitch-label" for="field_retencaoCPP"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="form-group col-md-2"><label class="center-block">Al\xEDquota Outras Ret.</label><input type="text" class="form-control" ui-number-mask="2" name="percentual_outrasRetencoes" id="field_percentual_outrasRetencoes" ng-blur=" calcularValoresPorAliquota(\'percentualOutrasRetencoes\', \'outrasRetencoes\')" ng-model="notaFiscal.declaracaoPrestacaoServico.tributosFederais.percentualOutrasRetencoes"></div><div class="form-group col-md-2"><label class="center-block">Valor Outras Ret.</label><input type="text" class="form-control" ui-money-mask="" name="outrasRetencoes" id="field_outrasRetencoes" ng-model="notaFiscal.declaracaoPrestacaoServico.tributosFederais.outrasRetencoes"></div><div class="form-group col-md-2"><label for="field_retencao">Retido?</label><div class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="retencaoOutrasRetencoes" ng-model="notaFiscal.declaracaoPrestacaoServico.tributosFederais.retencaoOutrasRetencoes" class="onoffswitch-checkbox" id="field_retencaoOutrasRetencoes"><label class="onoffswitch-label" for="field_retencaoOutrasRetencoes"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span> <span class="onoffswitch-switch"></span></label></div></div></div></div><div class="margin"><p class="help-block text-danger" ng-show="notaFiscal.retencoesFederais > notaFiscal.declaracaoPrestacaoServico.totalServicos">O valor da reten\xE7\xF5es federais n\xE3o pode ser maior que o valor dos servi\xE7os</p></div><div class="row m-t-md"><div class="col-md-12"><button class="btn btn-default" ng-click="passoAnterior();" type="button"><i class="fa fa-chevron-left"></i> Voltar</button> <button class="btn btn-success" ng-click="continuarParaResumo()" type="button"><i class="fa fa-chevron-right"></i> Continuar</button></div></div></div></div><div class="ibox float-e-margins" ng-show="passoAtual === passos.resumo"><div class="ibox-content"><div class="row"><div class="col-md-12"><div ng-include="\'app/entities/notaFiscal/notaFiscal-ver.html\'"></div></div></div></div></div><div class="ibox float-e-margins" ng-show="passoAtual === passos.resumo"><div class="ibox-content"><div class="row"><div class="col-md-12"><h3>Valores da Nota</h3></div></div><div class="row"><div class="col-md-12"><div class="col-md-3 form-group"><label>Valor Total dos Descontos</label><input type="text" readonly="readonly" class="form-control" value="{{notaFiscal.declaracaoPrestacaoServico.descontosIncondicionais | finance:\'R$ \'}}"></div><div class="col-md-3 form-group"><label>Valor Total de Dedu\xE7\xF5es</label><input type="text" readonly="readonly" class="form-control" value="{{notaFiscal.declaracaoPrestacaoServico.deducoesLegais | finance:\'R$ \'}}"></div><div class="col-md-3 form-group"><label>Percentual de Dedu\xE7\xF5es</label><input type="text" readonly="readonly" class="form-control" value="{{notaFiscal.declaracaoPrestacaoServico.deducoesLegais/notaFiscal.declaracaoPrestacaoServico.totalServicos*100 | number:0}}%"></div><div class="col-md-3 form-group"><label>Base de C\xE1lculo do ISS</label><input type="text" readonly="readonly" class="form-control" value="{{notaFiscal.declaracaoPrestacaoServico.baseCalculo | finance:\'R$ \'}}"></div></div></div><div class="row"><div class="col-md-12"><div class="col-md-3 form-group"><label>Valor Total dos Tributos</label><input type="text" readonly="readonly" class="form-control" value="{{notaFiscal.retencoesFederais + notaFiscal.declaracaoPrestacaoServico.issCalculado | finance:\'R$ \'}}"></div><div class="col-md-3 form-group"><label>Aliquota Total dos Tributos</label><input type="text" readonly="readonly" class="form-control" value="{{notaFiscal.aliquotaRetencoesFederais + notaFiscal.aliquotaServico | number:0}} %"></div><div class="col-md-3 form-group"><label>Valor Total do Documento Fiscal</label><input type="text" readonly="readonly" class="form-control" value="{{notaFiscal.declaracaoPrestacaoServico.totalServicos | finance:\'R$ \'}}"></div><div class="col-md-3 form-group"><label>Valor Liquido do Documento Fiscal</label><input type="text" readonly="readonly" class="form-control" value="{{notaFiscal.declaracaoPrestacaoServico.valorLiquido | finance:\'R$ \'}}"></div></div></div></div></div><div class="ibox float-e-margins" ng-show="passoAtual === passos.resumo"><div class="ibox-content"><div class="row"><div class="col-md-12"><h3>Deseja notificar algu\xE9m por e-mail?</h3></div></div><div class="row"><div class="form-group col-md-12"><input type="text" class="form-control" multiple-emails name="recipientEmail" autocomplete="off" ng-model="notaFiscal.emails"><div ng-show="editForm.recipientEmail.$invalid"><p class="help-block">E-mail informado inv\xE1lido</p></div></div><div class="col-md-12"><small class="help-block m-b-none">Sugest\xE3o: <a ng-click="adicionarEmail(notaFiscal.tomador.dadosPessoais.email)" ng-show="notaFiscal.tomador\n                               && notaFiscal.tomador.dadosPessoais.email">&ensp; {{notaFiscal.tomador.dadosPessoais.email}} </a><a ng-click="adicionarEmail(notaFiscal.prestador.pessoa.dadosPessoais.email)" ng-show="notaFiscal.prestador\n                                && notaFiscal.prestador.pessoa.dadosPessoais.email">&ensp;{{notaFiscal.prestador.pessoa.dadosPessoais.email}} </a><a ng-click="adicionarEmail(account.email)" ng-show="account.email">&ensp;{{account.email}} </a><small>(clique no email para adicionar)</small></small></div><div class="col-md-12"><span class="help-block m-b-none">Informe todos os e-mails a serem notificados separados por virgula. Ex. jose@gmail.com, maria@gmail.com</span></div></div><div class="row" ng-show="passoAtual == passos.resumo"><div class="col-md-12 m-t-md"><button class="btn btn-default" ng-click="passoAnterior();" type="button"><i class="fa fa-chevron-left"></i> Voltar</button> <button type="button" class="btn btn-default" data-dismiss="modal" ui-sref="notaFiscal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; Cancelar Emiss\xE3o</button> <button type="submit" ng-click="emitir()" class="btn btn-success"><span class="glyphicon glyphicon-check"></span>&nbsp; Confirmar e Emitir</button></div></div></div></div></form></div></div>');
$templateCache.put('app/entities/notaFiscal/notaFiscal-ver.html','<div class="row"><div class="col-md-12 m-t-md"><h3>Resumo da NFS-e {{notaFiscal.numero}}</h3></div></div><div ng-show="notaFiscal.rps"><div class="row"><div class="col-md-12 m-t-md"><h3>Dados do RPS</h3></div></div><div class="col-md-12 form-group"><div class="col-md-2"><small>N\xFAmero</small><br><strong>{{notaFiscal.rps.numero}}</strong></div><div class="col-md-2"><small>S\xE9rie</small><br><strong>{{notaFiscal.rps.serie}}</strong></div><div class="col-md-2"><small>Data de Emiss\xE3o</small><br><strong>{{notaFiscal.rps.dataEmissao | date:\'dd/MM/yyyy\'}}</strong></div></div></div><div class="row"><div class="col-md-12 m-t-md"><h3>Dados da Nota</h3></div></div><div class="col-md-12 form-group"><div class="col-md-3" ng-show="notaFiscal.id"><small>C\xF3digo de Verifica\xE7\xE3o</small><br><strong>{{notaFiscal.codigoVerificacao}}</strong></div><div class="col-md-1" ng-if="notaFiscal.id"><small>Compet\xEAncia</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.competencia | date:\'MM/yyyy\'}}</strong></div><div class="col-md-1" ng-if="notaFiscal.id"><small>Emiss\xE3o</small><br><strong ng-if="temHora(notaFiscal.emissao)">{{notaFiscal.emissao | date:\'dd/MM/yyyy HH:mm\': \'+0000\'}}</strong> <strong ng-if="!temHora(notaFiscal.emissao)">{{notaFiscal.emissao | date:\'dd/MM/yyyy\': \'+0000\'}}</strong></div><div class="col-md-1" ng-if="notaFiscal.id && !tributadoEmOutroMunicipio()"><small>ISS Retido</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.issRetido ? \'Sim\' : \'N\xE3o\'}}</strong></div><div class="col-md-2" ng-if="notaFiscal.declaracaoPrestacaoServico.itens[0].municipio"><small>Local de Presta\xE7\xE3o</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.itens[0].municipio.nome}}/{{notaFiscal.declaracaoPrestacaoServico.itens[0].municipio.estado}}</strong></div><div class="col-md-2" ng-if="!notaFiscal.declaracaoPrestacaoServico.itens[0].municipio"><small>Local de Presta\xE7\xE3o</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.itens[0].pais.nome}}</strong></div><div class="col-md-3"><small>Regime Tribut\xE1rio</small><br><strong>{{\'nfseApp.RegimeTributario.\' + notaFiscal.prestador.enquadramentoFiscal.regimeTributario | translate}}</strong></div></div><div class="row"><div class="col-md-12 m-t-md"><h3>Tomador do Servi\xE7o</h3></div></div><div class="col-md-12 form-group" ng-if="notaFiscal.modalidade == \'NAO_IDENTIFICADO\'"><div class="col-md-3"><strong>N\xE3o Identificado</strong></div></div><div ng-if="notaFiscal.modalidade != \'NAO_IDENTIFICADO\'"><div class="col-md-12 form-group"><div class="col-md-3"><small>CPF ou CNPJ</small><br><strong>{{notaFiscal.tomador.dadosPessoais.cpfCnpj | brCpfCnpj}}</strong></div><div class="col-md-3"><small>Inscri\xE7\xE3o Municipal</small><br><strong>{{notaFiscal.tomador.dadosPessoais.inscricaoMunicipal}}</strong></div><div class="col-md-3"><small>Inscri\xE7\xE3o Estadual ou RG</small><br><strong>{{notaFiscal.tomador.dadosPessoais.inscricaoEstadualRg}}</strong></div></div><div class="col-md-12 form-group"><div class="col-md-8"><small>Nome ou Raz\xE3o Social</small><br><strong>{{notaFiscal.tomador.dadosPessoais.nomeRazaoSocial}}</strong></div><div class="col-md-4"><small>Nome Fantasia</small><br><strong>{{notaFiscal.tomador.dadosPessoais.nomeFantasia}}</strong></div></div><div class="col-md-12 form-group"><div class="col-md-6"><small>E-mail</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.dadosPessoaisPrestador.email}}</strong></div></div><div class="col-md-12 form-group"><div class="col-md-2"><small>Telefone</small><br><strong>{{notaFiscal.tomador.dadosPessoais.telefone}}</strong></div><div class="col-md-2"><small>Celular</small><br><strong>{{notaFiscal.tomador.dadosPessoais.celular}}</strong></div><div class="col-md-2"><small>Cep</small><br><strong>{{notaFiscal.tomador.dadosPessoais.cep}}</strong></div><div class="col-md-6"><small>Munic\xEDpio</small><br><strong>{{notaFiscal.tomador.dadosPessoais.municipio.nome}} {{notaFiscal.tomador.dadosPessoais.municipio.estado}}</strong></div></div><div class="col-md-12 form-group"><div class="col-md-5"><small>Logradouro</small><br><strong>{{notaFiscal.tomador.dadosPessoais.logradouro}}</strong></div><div class="col-md-3"><small>Bairro</small><br><strong>{{notaFiscal.tomador.dadosPessoais.bairro}}</strong></div><div class="col-md-1"><small>N\xFAmero</small><br><strong>{{notaFiscal.tomador.dadosPessoais.numero}}</strong></div><div class="col-md-3"><small>Complemento</small><br><strong>{{notaFiscal.tomador.dadosPessoais.complemento}}</strong></div></div></div><div class="row"><div class="col-md-12 m-t-md"><h3>CNAE</h3></div></div><div class="col-md-12 form-group"><div class="col-md-3"><small>C\xF3digo</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.itens[0].cnae.codigo}}</strong></div><div class="col-md-9"><small>Descri\xE7\xE3o</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.itens[0].cnae.descricao}}</strong></div></div><div class="row"><div class="col-md-12 m-t-md"><h3>Servi\xE7os</h3></div></div><div ng-repeat="serv in notaFiscal.declaracaoPrestacaoServico.itens"><div class="col-md-12 form-group"><div class="col-md-2"><small>C\xF3digo</small><br><strong>{{serv.servico.codigo}}</strong></div><div class="col-md-10"><small>Descri\xE7\xE3o</small><br><strong>{{serv.nomeServico}}</strong></div><div class="col-md-4"><small>Al\xEDquota</small><br><strong>{{serv.aliquotaServico}}</strong></div><div class="col-md-4"><small>Base de C\xE1lculo</small><br><strong>{{serv.baseCalculo | currency: \'R$ \'}}</strong></div><div class="col-md-4"><small>Valor ISS</small><br><strong>{{serv.iss | currency: \'R$ \'}}</strong></div></div></div><div class="row"><div class="col-md-12 m-t-md"><h3>Tributos Federais</h3></div></div><div class="col-md-12 form-group"><div class="col-md-2"><small>Al\xEDquota PIS</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.tributosFederais.percentualPis | number:2}}</strong></div><div class="col-md-2"><small>Valor PIS</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.tributosFederais.pis | currency:\'R$ \'}}</strong></div><div class="col-md-2"><small>PIS Retido?</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.tributosFederais.retencaoPis ? \'Sim\':\'N\xE3o\'}}</strong></div><div class="col-md-2"><small>Al\xEDquota COFINS</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.tributosFederais.percentualCofins | number:2}}</strong></div><div class="col-md-2"><small>Valor COFINS</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.tributosFederais.cofins | currency:\'R$ \'}}</strong></div><div class="col-md-2"><small>COFINS Retido?</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.tributosFederais.retencaoCofins ? \'Sim\':\'N\xE3o\'}}</strong></div><div class="col-md-2"><small>Al\xEDquota INSS</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.tributosFederais.percentualInss | number:2}}</strong></div><div class="col-md-2"><small>Valor INSS</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.tributosFederais.inss | currency:\'R$ \'}}</strong></div><div class="col-md-2"><small>INSS Retido?</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.tributosFederais.issRetido ? \'Sim\':\'N\xE3o\'}}</strong></div><div class="col-md-2"><small>Al\xEDquota IRRF</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.tributosFederais.percentualIrrf | number:2}}</strong></div><div class="col-md-2"><small>Valor IRRF</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.tributosFederais.irrf | currency:\'R$ \'}}</strong></div><div class="col-md-2"><small>IRRF Retido?</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.tributosFederais.retencaoIrrf ? \'Sim\':\'N\xE3o\'}}</strong></div><div class="col-md-2"><small>Al\xEDquota CSLL</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.tributosFederais.percentualCsll | number:2}}</strong></div><div class="col-md-2"><small>Valor CSLL</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.tributosFederais.csll | currency:\'R$ \'}}</strong></div><div class="col-md-2"><small>CSLL Retido?</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.tributosFederais.retencaoCsll ? \'Sim\':\'N\xE3o\'}}</strong></div><div class="col-md-2"><small>Al\xEDquota Outras Ret.</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.tributosFederais.percentualOutrasRetencoes | number:2}}</strong></div><div class="col-md-2"><small>Valor Outras Ret.</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.tributosFederais.outrasRetencoes | currency:\'R$ \'}}</strong></div><div class="col-md-2"><small>Retido?</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.tributosFederais.retencaoOutrasRetencoes ? \'Sim\':\'N\xE3o\'}}</strong></div></div><div class="row"><div class="col-md-6 m-t-md"><h3>Constru\xE7\xE3o Civil</h3></div><div class="col-md-6 m-t-md"><h3>Intermedi\xE1rio</h3></div></div><div class="col-md-6"><div class="form-group"><div class="col-md-6"><small>C\xF3digo da Obra</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.construcaoCivil.codigoObra}}</strong></div><div class="col-md-6"><small>ART</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.construcaoCivil.art}}</strong></div></div></div><div class="col-md-6"><div class="form-group"><div class="col-md-4"><small>CPF ou CNPJ</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.intermediario.cpfCnpj}}</strong></div><div class="col-md-8"><small>Nome ou Raz\xE3o Social</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.intermediario.nomeRazaoSocial}}</strong></div></div></div><div class="row" ng-include="notaFiscal.id"><div class="col-md-12 m-t-md"><h3>Valores da Nota</h3></div></div><div class="col-md-12" ng-include="notaFiscal.id"><div class="form-group"><div class="col-md-3"><small>Total dos Servi\xE7os</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.totalServicos | finance:\'R$ \'}}</strong></div><div class="col-md-3"><small>Dedu\xE7\xF5es Legais</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.deducoesLegais | finance:\'R$ \'}}</strong></div><div class="col-md-3"><small>Descontos Incondicionados</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.descontosIncondicionais | finance:\'R$ \'}}</strong></div><div class="col-md-3"><small>Descontos Condicionados</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.descontosCondicionais | finance:\'R$ \'}}</strong></div></div><div class="form-group"><div class="col-md-2"><small>Reten\xE7\xF5es Federais</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.retencoesFederais | finance:\'R$ \'}}</strong></div><div class="col-md-3"><small>Base de C\xE1lculo</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.baseCalculo | finance:\'R$ \'}}</strong></div><div class="col-md-2"><small>Valor de ISS Calculado</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.issCalculado | finance:\'R$ \'}}</strong></div><div class="col-md-2"><small>Valor de ISS Devido</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.issPagar | finance:\'R$ \'}}</strong></div><div class="col-md-3"><small>Valor Liquido</small><br><strong>{{notaFiscal.declaracaoPrestacaoServico.valorLiquido | finance:\'R$ \'}}</strong></div></div></div><div class="row"><div class="col-md-12"><div class="row" ng-if="parcelas && parcelas.length > 0"><div class="col-md-12 m-t-md border-bottom"><h3>Parcelas</h3></div></div><div class="form-group" ng-if="parcelas && parcelas.length > 0"><div class="col-md-12"><table class="table"><thead><tr><th>DAM</th><th>D\xEDvida</th><th>Exerc\xEDcio</th><th>Parcela</th><th>Vencimento</th><th>Imposto</th><th>Taxa</th><th>Juros</th><th>Multa</th><th>Corre\xE7\xE3o</th><th>Honor\xE1rios</th><th>Total</th><th>Situa\xE7\xE3o</th></tr></thead><tbody><tr ng-repeat="parc in parcelas"><td>{{parc.numeroDam}}</td><td>{{parc.divida}}</td><td>{{parc.exercicio}}</td><td>{{parc.parcela}}</td><td>{{parc.vencimento | date:\'dd/MM/yyyy\'}}</td><td>{{parc.valorImposto | currency: \' \'}}</td><td>{{parc.valorTaxa | currency: \' \'}}</td><td>{{parc.valorJuros | currency: \' \'}}</td><td>{{parc.valorMulta | currency: \' \'}}</td><td>{{parc.valorCorrecao | currency: \' \'}}</td><td>{{parc.valorHonorarios | currency: \' \'}}</td><td>{{parc.total | currency: \' \'}}</td><td>{{\'nfseApp.SituacaoParcela.\' + parc.situacao | translate}}</td></tr></tbody></table><div style="text-align: center" ng-show="notaFiscal.declaracaoPrestacaoServico.itens.length == 0"><div class="help-block"><strong>Aten\xE7\xE3o!</strong> Adicione ao menos um servi\xE7o para salvar a Nota Fiscal</div></div></div></div></div></div>');
$templateCache.put('app/entities/notaFiscal/notaFiscals.html','<div class="row"><div class="col-lg-12"><div class="row m-b-md"><div class="col-md-10"><span ng-if="filtrosSelecionados.length > 0"><h3>Filtros Dispon\xEDveis</h3></span></div><div class="col-md-2"><button type="button" class="btn btn-primary pull-right btn-block" ng-click="emitirNotaFiscal()"><span class="fa fa-plus"></span> <span>Emitir Nota</span></button></div></div><div ng-repeat="filtro in filtrosSelecionados track by $index" class="row float-e-margins"><div class="col-md-4"><div><select class="form-control" id="filtro_campos" name="filtros" ng-model="filtro.atributo" ng-change="selecionouCampo(filtro)" ng-options="filtroDisponivel as filtroDisponivel.descricao  for filtroDisponivel in filtrosDisponiveis  track by filtroDisponivel.nomeAtributo"></select></div></div><div class="col-md-2"><div><select class="form-control" id="filtro_peracao" name="oprecoes" ng-model="filtro.operacao" ng-options="operacao.value as operacao.nome for operacao in filtro.atributo.operacoes"></select></div></div><div class="col-md-6"><div class="form-group input-group"><input ng-show="filtro.atributo.tipo === \'cpfcnpj\'" type="text" class="form-control" name="valorCpfCnpj" ui-br-cpfcnpj-mask ng-model="filtro.valorString"> <input ng-show="filtro.atributo.tipo === \'decimal\'" type="number" class="form-control" ng-pattern="/^[0-9]+(\\.[0-9]{1,5})?$/" step="0.01" name="valorDecimal" ng-model="filtro.valorDecimal"> <input ng-show="filtro.atributo.tipo === \'inteiro\'" type="number" class="form-control" ng-model="filtro.valorInteger" name="valorInteger"> <input ng-show="filtro.atributo.tipo === \'texto\'" type="text" class="form-control" ng-model="filtro.valorString" name="valorString"><div ng-show="filtro.atributo.tipo === \'logico\'" class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="boolean" ng-model="filtro.valorLogico" class="onoffswitch-checkbox" id="field_boolean"><label class="onoffswitch-label" for="field_boolean"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span> <span class="onoffswitch-switch"></span></label></div></div><input ng-show="filtro.atributo.tipo === \'data\'" type="date" ng-model="filtro.valorData" class="form-control"><select ng-show="filtro.atributo.tipo === \'enum\'" class="form-control" ng-model="filtro.valorString" ng-options="item.name as item.value for item in filtro.atributo.values"></select><span class="input-group-btn"><button ng-click="removerFiltro($index)" class="btn btn-danger"><span class="fa fa-trash"></span></button></span></div></div></div><div class="row m-b-md"><div class="col-md-10 text-center"><a ng-click="adicionarFiltro()"><span class="fa fa-plus"></span> Adicionar filtros</a></div><div class="col-md-2"><button ng-click="loadAll()" ng-if="filtrosSelecionados.length > 0" class="btn btn-success btn-block"><span class="fa fa-search"></span> <span>Filtrar</span></button></div></div><div id="div-tabela-notas" class="table-responsive"><table class="table table-striped table-hover small"><thead><tr><th>Op\xE7\xF5es</th><th>N\xFAmero</th><th>Emiss\xE3o</th><th>Tomador</th><th class="text-center">ISS Retido?</th><th class="text-right">Valor Servi\xE7os</th><th class="text-right">Base de Calculo</th><th class="text-right">Valor ISS</th><th class="text-center">Situa\xE7\xE3o</th><th>RPS</th></tr></thead><tbody><tr ng-repeat="notaFiscal in notaFiscals"><td class="dropdown"><button class="btn btn-white btn-sm dropdown-toggle" data-toggle="dropdown" type="button"><i class="fa fa-caret-down"></i>&ensp; Op\xE7\xF5es</button><ul class="dropdown-menu"><li><a type="submit" title="clique para visualizar os dados deste documento" ng-click="baixarXMlNotaFiscal(notaFiscal.id)" class="text-info"><i class="fa fa-eye"></i>&ensp; Baixar XML</a></li><li><a type="submit" ng-click="copiarNota(notaFiscal)" title="Clique para emitir um novo documento fiscal com os mesmos dados deste documento" class="text-warning"><i class="fa fa-copy"></i>&ensp; Copiar</a></li><li><a type="submit" title="Clique para editar o documento" ng-if="notaFiscal.situacao == \'ABERTA\'" ui-sref="notaFiscal.edit({id:notaFiscal.id})" class="text-primary"><i class="fa fa-pencil"></i>&ensp; Editar</a></li><li><a type="submit" title="Clique para imprimir o documento" ng-click="imprimirNota(notaFiscal.id)" class="text-primary"><i class="fa fa-print"></i>&ensp; Imprimir</a></li><li><a type="submit" title="Clique para enviar o documento via e-mail" ng-if="notaFiscal.situacao == \'EMITIDA\'" ng-click="enviarNota(notaFiscal)" class="text-primary"><i class="fa fa-envelope"></i>&ensp; Enviar</a></li><li><a type="submit" title="Clique para substituir essa Nfs-e" ng-if="notaFiscal.situacao == \'EMITIDA\'" ui-sref="notaFiscal.newSubstituicao({idNotaSubstituida: notaFiscal.id})" class="text-primary"><i class="fa fa-exchange"></i>&ensp; Substituir</a></li><li><a type="submit" ng-click="delete(notaFiscal.id)" ng-if="notaFiscal.situacao == \'ABERTA\'" class="text-danger"><i class="fa fa-trash"></i>&ensp; Remover</a></li><li><a type="submit" title="Clique para solicitar o cancelamento do documento" ng-click="cancelarNota(notaFiscal)" class="text-danger"><i class="fa fa-ban"></i>&ensp; {{notaFiscal.situacao == \'EMITIDA\' ? \'Cancelar\' : \'Ver Cancelamento\'}}</a></li><li><a type="submit" title="Clique para enviar a carta de corre\xE7\xE3o do documento" ng-click="cartaCorrecaoNota(notaFiscal)" ng-if="notaFiscal.situacao == \'EMITIDA\'" class="text-danger"><i class="fa fa-edit"></i>&ensp; Carta de Corre\xE7\xE3o</a></li></ul></td><td><a ui-sref="notaFiscal.detail({id:notaFiscal.id})">{{notaFiscal.numero}}</a></td><td>{{notaFiscal.emissao | date : \'dd/MM/yyyy\'}}</td><td><span ng-if="notaFiscal.modalidade == \'NAO_IDENTIFICADO\'">{{\'nfseApp.ModalidadeNota.\' + notaFiscal.modalidade | translate}}</span> <span ng-if="notaFiscal.cpfCnpjTomador">({{notaFiscal.cpfCnpjTomador | brCpfCnpj}})&ensp;</span> {{notaFiscal.nomeTomador}}</td><td class="text-center">{{notaFiscal.issRetido ? \'Sim\': \'N\xE3o\'}}</td><td class="text-right">{{notaFiscal.totalServicos | currency : \'R$ \'}}</td><td class="text-right">{{notaFiscal.baseCalculo | currency : \'R$ \'}}</td><td class="text-right">{{notaFiscal.iss | currency : \'R$ \'}}</td><td class="text-center"><span class="label {{notaFiscal.situacao === \'CANCELADA\' ? \'label-danger\': \'label-primary\'}}">{{\'nfseApp.SituacaoNota.\' + notaFiscal.situacao | translate}}</span></td><td class="text-center"><a ui-sref="rPS.detail({id:notaFiscal.idRps})">{{notaFiscal.codigoRps}}</a></td></tr><tr><td colspan="4" class="text-right font-bold">Totais:</td><td class="font-bold">{{getTotalServicos() | currency : \'R$ \'}}</td><td class="font-bold">{{getTotalBaseCalculo() | currency : \'R$ \'}}</td><td class="font-bold">{{getTotalIss() | currency : \'R$ \'}}</td><td colspan="2"></td></tr></tbody></table><div class="col-md-12 text-right"><button class="btn btn-primary btn-outline" title="Clique para baixar as notas da tabela acima em formato de XML" ui-sref="exportarXml"><i class="fa fa-download"></i> XML</button> <button class="btn btn-danger btn-outline" title="Clique para baixar as notas resumidas em PDF" ng-click="baixarPDFResumido()"><i class="fa fa-download"></i> PDF (Resumido)</button> <button class="btn btn-danger btn-outline" title="Clique para baixar as notas detalhadas em PDF" ng-click="baixarPDFDetalhado()"><i class="fa fa-download"></i> PDF (Detalhado)</button> <button class="btn btn-primary btn-outline" title="Clique para baixar as notas da tabela acima em formato de XLS" ng-click="baixarXls()"><i class="fa fa-download"></i> XLS</button></div><span nfse-app-pagination></div></div></div>');
$templateCache.put('app/entities/pais/pais-detail.html','<div><h2><span translate="nfseApp.cnae.detail.title">Pais</span> {{pais.id}}</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span translate="nfseApp.pais.nome">Nome</span></td><td><input type="text" class="input-sm form-control" value="{{pais.nome}}" readonly="readonly"></td></tr><tr><td><span translate="nfseApp.pais.codigo">Sigla</span></td><td><input type="text" class="input-sm form-control" value="{{pais.codigo}}" readonly="readonly"></td></tr></tbody></table></div><button type="submit" ui-sref="pais" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/entities/pais/pais-dialog.html','<div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h4 class="modal-title" id="paisLabel" translate="nfseApp.pais.home.createOrEditLabel">Criar ou Editar o Pa\xEDs</h4></div><div class="ibox-content"><form name="editForm" role="form" novalidate ng-submit="save()" show-validation><!--<div class="form-group">--><div class="col-md-3"><div class="form-group"><label class="center-block" translate="nfseApp.pais.codigo" for="nome">Codigo</label><input type="text" class="form-control" name="codigo" id="codigo" ng-model="pais.codigo" required><div ng-show="editForm.codigo.$invalid"><p class="help-block" ng-show="editForm.codigo.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-md-6"><div class="form-group"><label class="center-block" translate="nfseApp.pais.nome" for="nome">Nome</label><input type="text" class="form-control" name="codigo" id="nome" ng-model="pais.nome" required><div ng-show="editForm.codigo.$invalid"><p class="help-block" ng-show="editForm.codigo.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-md-3"><div class="form-group"><label class="center-block" translate="nfseApp.pais.sigla" for="codigo">Sigla</label><input type="text" maxlength="3" class="form-control" name="codigo" id="sigla" ng-model="pais.sigla" required><div ng-show="editForm.codigo.$invalid"><p class="help-block" ng-show="editForm.codigo.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-actions"><button type="button" class="btn btn-default" ui-sref="pais"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form></div></div></div></div>');
$templateCache.put('app/entities/pais/pais-search.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title" id="myPaisesLabel">Buscar Pa\xEDses</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><search-box ng-model="searchQuery" search-method="search()"></search-box></div></div></div><div class="table-responsive"><div class="row"><div class="col-md-12"><table class="table table-striped"><thead><tr><th>Codigo</th><th>Nome</th><th>Sigla</th><th></th></tr></thead><tbody><tr ng-repeat="pais in paises"><td>{{pais.codigo}}</td><td>{{pais.nome}}</td><td>{{pais.sigla}}</td><td class="pull-right"><button type="submit" ng-click="ok(pais)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-check"></span></button></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/entities/pais/paises.html','<div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><span translate="nfseApp.pais.home.title">Form</span></div><div class="ibox-content"><div class="row"><div class="col-md-8"><search-box ng-model="searchQuery" search-method="search()"></search-box></div><div class="col-md-4"><button class="btn btn-primary pull-right" ui-sref="pais.new"><span class="fa fa-plus"></span> <span translate="nfseApp.pais.home.createLabel">Create a new Pais</span></button></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="nfseApp.pais.codigo">Codigo</th><th translate="nfseApp.pais.nome">Nome</th><th translate="nfseApp.pais.sigla">Sigla</th><th></th></tr></thead><tbody><tr ng-repeat="pais in paises"><td><a ui-sref="pais.detail({id:pais.id})">{{pais.codigo}}</a></td><td>{{pais.nome}}</td><td>{{pais.sigla}}</td><td><div class="pull-right"><button type="submit" ui-sref="pais.detail({id:pais.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="pais.edit({id:pais.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ng-click="delete(pais.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table><span nfse-app-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/perfilEmpresa/perfilEmpresa-edit.html','<div ng-show="prestadorServicos"><div class="col-md-5"><div class="ibox float-e-margins"><div><div class="ibox-content no-padding border-left-right"><img ng-if="imagemPrestador" ng-src="{{imagemPrestador}}" alt="image" class="img-responsive center"> <img ng-show="!imagemPrestador" ng-src="/assets/images/user-default.jpg" alt="image" class="img-responsive center"></div><div class="ibox-content profile-content"><p class="small text-center"><a ng-click="trocarImagemEmpresa()"><i class="fa fa-refresh"></i> Trocar Imagem</a></p><h3 class="m-t-md"><strong>{{prestadorServicos.pessoa.dadosPessoais.nomeRazaoSocial}}</strong></h3><h4><strong>{{prestadorServicos.pessoa.dadosPessoais.cpfCnpj | brCpfCnpj}}</strong></h4><p>Ins. Mun. {{prestadorServicos.inscricaoMunicipal}}</p><p>Ins. Est. {{prestadorServicos.inscricaoEstadualRg}}</p><p><i class="fa fa-map-marker"></i> {{getEnderecoCompleto()}}</p><dl class="dl-horizontal text-left"><dt>Porte:</dt><dd>{{ajustaNomeEnum(prestadorServicos.enquadramentoFiscal.porte)}}</dd><dt>Tipo de Contribuinte:</dt><dd>{{ajustaNomeEnum(prestadorServicos.enquadramentoFiscal.tipoContribuinte)}}</dd><dt>Tipo de Enquadramento:</dt><dd>{{ajustaNomeEnum(prestadorServicos.enquadramentoFiscal.tipoEnquadramentoFiscal)}}</dd><dt>Regime Tributario:</dt><dd>{{ajustaNomeEnum(prestadorServicos.enquadramentoFiscal.regimeTributario)}}</dd><dt>Vers\xE3o DES-IF:</dt><dd>{{ajustaNomeEnum(prestadorServicos.enquadramentoFiscal.versaoDesif)}}</dd><dt>Tipo de Iss:</dt><dd>{{ajustaNomeEnum(prestadorServicos.enquadramentoFiscal.tipoIss)}}</dd><span ng-if="prestadorServicos.enquadramentoFiscal.tipoIss == \'ESTIMADO\'"><dt>Tipo de Iss Estimado:</dt><dd>{{ajustaNomeEnum(prestadorServicos.enquadramentoFiscal.tipoIssEstimado)}}</dd><dt>Valor de Iss Estimado:</dt><dd>{{ajustaNomeEnum(prestadorServicos.enquadramentoFiscal.valorIssEstimado)}}</dd></span><dt>Classifica\xE7\xE3o da Atividade:</dt><dd>{{ajustaNomeEnum(prestadorServicos.enquadramentoFiscal.classificacaoAtividade)}}</dd><dt>Tipo de Nota Fiscal:</dt><dd>{{ajustaNomeEnum(prestadorServicos.enquadramentoFiscal.tipoNotaFiscal)}}</dd><dt>Substituto Tributario:</dt><dd>{{prestadorServicos.enquadramentoFiscal.substitutoTributario? \'Sim\': \'N\xE3o\'}}</dd><dt ng-if="prestadorServicos.enquadramentoFiscal.simplesNacional">Rbt12:</dt><dd ng-if="prestadorServicos.enquadramentoFiscal.simplesNacional">{{prestadorServicos.rbt12 | currency:\'R$ \'}}</dd><dt ng-if="prestadorServicos.enquadramentoFiscal.simplesNacional">Anexo Lei 123/2006:</dt><dd ng-if="prestadorServicos.enquadramentoFiscal.simplesNacional">{{prestadorServicos.enquadramentoFiscal.anexoLei1232006.descricao}}</dd><dt ng-if="prestadorServicos.enquadramentoFiscal.simplesNacional">Faixa Anexo Lei 123/2006:</dt><dd ng-if="prestadorServicos.enquadramentoFiscal.simplesNacional">{{prestadorServicos.enquadramentoFiscal.anexoLei1232006Faixa.faixa}}</dd></dl><table class="table table-hover no-margins" ng-show="prestadorServicos.socios && prestadorServicos.socios.length > 0"><thead><tr class="text-center"><th colspan="2">Quadro societ\xE1rio</th></tr></thead><tbody><tr ng-repeat="socio in prestadorServicos.socios"><td>{{socio.socio.dadosPessoais.nomeRazaoSocial}}</td><td class="text-navy">{{socio.proporcao}}%</td></tr></tbody></table><table class="table table-hover no-margins" ng-show="prestadorServicos.servicos && prestadorServicos.servicos.length > 0"><thead><tr class="text-center"><th colspan="3">Servi\xE7os</th></tr></thead><tbody><tr ng-repeat="servico in prestadorServicos.servicos"><td>{{servico.codigo}}</td><td>{{servico.descricao}}</td><td class="text-navy">{{servico.aliquota}}%</td></tr></tbody></table><table class="table table-hover no-margins" ng-show="prestadorServicos.cnaes && prestadorServicos.cnaes.length > 0"><thead><tr class="text-center"><th colspan="2">Cnaes</th></tr></thead><tbody><tr ng-repeat="cnae in prestadorServicos.cnaes"><td>{{cnae.codigo}}</td><td>{{cnae.descricao}}</td></tr></tbody></table></div></div></div></div><div class="col-md-7"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><form name="editForm" role="form" novalidate><div class="form-group col-md-12"><label for="field_nomeFantasia">Nome Fantasia</label><input type="text" class="form-control" name="nomeFantasia" id="field_nomeFantasia" ng-model="prestadorServicos.pessoa.dadosPessoais.nomeFantasia"></div><div class="form-group col-md-6"><label for="field_email">e-Mail</label><input type="email" class="form-control" name="email" id="field_email" ng-model="prestadorServicos.pessoa.dadosPessoais.email"><div ng-show="editForm.email.$invalid" class="has-error"><p class="help-block">e-Mail inv\xE1lido.</p></div></div><div class="form-group col-md-6"><label for="field_site">Site (home page)</label><input type="text" class="form-control" name="site" id="field_site" ng-model="prestadorServicos.pessoa.dadosPessoais.site"><div ng-show="editForm.email.$invalid" class="has-error"><p class="help-block">Site inv\xE1lido.</p></div></div><div class="form-group col-md-6"><label for="field_telefone">Telefone</label><input type="text" class="form-control" name="telefone" id="field_telefone" ui-br-phone-number ng-model="prestadorServicos.pessoa.dadosPessoais.telefone"><div ng-show="editForm.telefone.$invalid" class="has-error"><p class="help-block">Telefone inv\xE1lido.</p></div></div><div class="form-group col-md-6"><label for="field_celular">Celular</label><input type="text" class="form-control" name="celular" id="field_celular" ui-br-phone-number ng-model="prestadorServicos.pessoa.dadosPessoais.celular"><div ng-show="editForm.celular.$invalid" class="has-error"><p class="help-block">Celular inv\xE1lido.</p></div></div><div class="form-group col-md-6"><label for="field_contato">Nome para Contato</label><input type="text" class="form-control" name="contato" id="field_contato" ng-model="prestadorServicos.nomeParaContato"><div ng-show="editForm.contato.$invalid" class="has-error"><p class="help-block">Nome para contato inv\xE1lido.</p></div></div><div class="form-group col-md-6"><label for="field_telefoneParaContato">Telefone para Contato</label><input type="text" class="form-control" name="telefoneParaContato" id="field_telefoneParaContato" ui-br-phone-number ng-model="prestadorServicos.telefoneParaContato"><div ng-show="editForm.telefoneParaContato.$invalid" class="has-error"><p class="help-block">Telefone para contato inv\xE1lido.</p></div></div><div class="form-group col-md-12"><label class="control-label" for="field_escritorio">Escrit\xF3rio Cont\xE1bil</label><div class="input-group"><input type="text" class="form-control" disabled="disabled" name="escritorio" id="field_escritorio" value="{{getNomeEscritorio()}}" required> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="searchEscritorioContabil()"><span class="glyphicon glyphicon-search"></span></button></span></div></div><div class="form-group col-md-12"><label for="field_resumoSobreEmpresa">Resumo sobre a empresa</label><textarea type="text" class="form-control" name="resumoSobreEmpresa" id="field_resumoSobreEmpresa" maxlength="300" ng-model="prestadorServicos.resumoSobreEmpresa">\n                                        </textarea><div ng-show="editForm.resumoSobreEmpresa.$invalid" class="has-error"><p class="help-block">Resumo sobre a empresa inv\xE1lido.</p></div></div><div class="form-group col-md-12"><label for="chave-acesso">Chave Acesso WS</label><div class="input-group"><input type="text" class="form-control" name="chave-acesso" id="chave-acesso" ng-disabled="true" value="{{prestadorServicos.chaveAcesso}}"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="trocarChaveAcesso()"><span class="fa fa-refresh"></span> {{prestadorServicos.chaveAcesso ? \'Trocar Chave\': \'Gerar Chave\'}}</button></span></div></div><div class="form-group col-md-6"><label for="field_enviaEmailNfseTomador">Enviar e-mail automaticamente ao Tomador de Servi\xE7os na emiss\xE3o de NFS-e (Via RPS)?</label><div class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="enviaEmailNfseTomador" ng-model="prestadorServicos.enviaEmailNfseTomador" class="onoffswitch-checkbox" id="field_enviaEmailNfseTomador"><label class="onoffswitch-label" for="field_enviaEmailNfseTomador"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="form-group col-md-6"><label for="field_enviaEmailNfseTomador">Enviar e-mail automaticamente ao Tomador de Servi\xE7os no cancelamento de NFS-e?</label><div class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="enviaEmailCancelaNfseTomador" ng-model="prestadorServicos.enviaEmailCancelaNfseTomador" class="onoffswitch-checkbox" id="field_enviaEmailCancelaNfseTomador"><label class="onoffswitch-label" for="field_enviaEmailCancelaNfseTomador"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="form-group col-md-6"><label for="field_enviaEmailNfseContador">Enviar e-mail automaticamente ao meu Contador na emiss\xE3o de NFS-e (Via RPS)?</label><div class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="enviaEmailNfseContador" ng-model="prestadorServicos.enviaEmailNfseContador" class="onoffswitch-checkbox" id="field_enviaEmailNfseContador"><label class="onoffswitch-label" for="field_enviaEmailNfseContador"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="form-group col-md-6"><label for="field_enviaEmailCancelaNfseContador">Enviar e-mail automaticamente ao meu Contador no cancelamento de NFS-e?</label><div class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="enviaEmailCancelaNfseContador" ng-model="prestadorServicos.enviaEmailCancelaNfseContador" class="onoffswitch-checkbox" id="field_enviaEmailCancelaNfseContador"><label class="onoffswitch-label" for="field_enviaEmailCancelaNfseContador"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="form-group col-md-6"><label for="field_enviaEmailNfseContador">Enviar e-mail automaticamente ao S\xF3cios na emiss\xE3o de NFS-e (Via RPS)?</label><div class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="enviaEmailNfseSocios" ng-model="prestadorServicos.enviaEmailNfseSocios" class="onoffswitch-checkbox" id="field_enviaEmailNfseSocios"><label class="onoffswitch-label" for="field_enviaEmailNfseSocios"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="form-group col-md-6"><label for="field_enviaEmailCancelaNfseSocios">Enviar e-mail automaticamente ao S\xF3cios no cancelamento de NFS-e?</label><div class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="enviaEmailCancelaNfseSocios" ng-model="prestadorServicos.enviaEmailCancelaNfseSocios" class="onoffswitch-checkbox" id="field_enviaEmailCancelaNfseSocios"><label class="onoffswitch-label" for="field_enviaEmailCancelaNfseSocios"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="form-group col-md-12"><button type="button" ng-click="save()" class="btn btn-primary pull-right"><i class="fa fa-save"></i>&nbsp; Salvar</button></div></form></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h2>Configura\xE7\xF5es dos Tributos Federais</h2></div><div class="ibox-content"><div class="row"><div class="form-group col-md-3"><label class="center-block">Al\xEDquota PIS</label><input type="text" class="form-control" ui-number-mask="2" name="percentual_pis" id="field_pis" ng-model="prestadorServicos.tributosFederais.pis"></div><div class="form-group col-md-3"><label class="center-block">Al\xEDquota COFINS</label><input type="text" class="form-control" ui-number-mask="2" name="percentual_cofins" id="field_cofins" ng-model="prestadorServicos.tributosFederais.cofins"></div><div class="form-group col-md-3"><label class="center-block">Al\xEDquota INSS</label><input type="text" class="form-control" ui-number-mask="2" name="percentual_inss" id="field_inss" ng-model="prestadorServicos.tributosFederais.inss"></div><div class="form-group col-md-3"><label class="center-block">Al\xEDquota IR</label><input type="text" class="form-control" ui-number-mask="2" name="percentual_irrf" id="field_irrf" ng-model="prestadorServicos.tributosFederais.irrf"></div><div class="form-group col-md-3"><label class="center-block">Al\xEDquota CSLL</label><input type="text" class="form-control" ui-number-mask="2" name="percentual_csll" id="field_csll" ng-model="prestadorServicos.tributosFederais.csll"></div><div class="form-group col-md-3"><label class="center-block">Al\xEDquota CPP</label><input type="text" class="form-control" ui-number-mask="2" name="percentual_cpp" id="field_percentual_cpp" ng-model="prestadorServicos.tributosFederais.cpp"></div><div class="form-group col-md-6"><label class="center-block">Al\xEDquota Outras Reten\xE7\xF5es</label><input type="text" class="form-control" ui-number-mask="2" name="percentual_outrasRetencoes" id="field_percentual_outrasRetencoes" ng-model="prestadorServicos.tributosFederais.outrasRetencoes"></div><div class="form-group col-md-12"><button type="button" ng-click="salvarTributosFederais()" class="btn btn-primary pull-right"><i class="fa fa-save"></i>&nbsp; Salvar</button></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h2>Usu\xE1rios da empresa</h2></div><div class="ibox-content"><div class="row"><table class="table"><tr><th>Nome</th><th>E-mail</th><th>Login/Cpf</th><th class="center">Contador?</th><th class="center">Ativo?</th></tr><tr ng-repeat-start="usuario in prestadorServicos.usuarios" ng-class="{\'todo-completed\': !usuario.permitido}"><td>{{usuario.nome}}</td><td>{{usuario.email}}</td><td>{{usuario.login}}</td><td class="center">{{usuario.contador ? \'Sim\' : \'N\xE3o\'}} <a ng-show="usuario.contador" ng-class="{\'disabled\': !usuario.permitido}" ng-disabled="!usuario.permitido" ng-click="permitirAcessoAoUsuario(usuario)" class="text-danger"><i class="fa fa-times"></i> </a><a ng-show="!usuario.contador" ng-class="{\'disabled\': !usuario.permitido}" ng-disabled="!usuario.permitido" ng-click="permitirAcessoAoUsuario(usuario)" class="text-success"><i class="fa fa-check"></i></a></td><td class="center">{{usuario.permitido ? \'Sim\' : \'N\xE3o\'}} <a ng-show="usuario.permitido" ng-click="ativarOuDesativarUsuario(usuario)" class="text-danger"><i class="fa fa-times"></i> </a><a ng-show="!usuario.permitido" ng-click="ativarOuDesativarUsuario(usuario)" class="text-success"><i class="fa fa-check"></i></a></td></tr><tr ng-show="usuario.permitido"><td colspan="4" valign="middle"><label>Fun\xE7\xE3o</label><textarea type="text" class="form-control" maxlength="255" ng-model="usuario.descricao">\n                                </textarea></td><td class="center" style="vertical-align: middle !important"><a ng-click="permitirAcessoAoUsuario(usuario)" class="text-info"><i class="fa fa-save"></i></a></td></tr><tr ng-repeat-end ng-show="usuario.permitido"><td colspan="5"><table class="table small m-sm"><tr><th>Acesso</th><th>Permite?</th></tr><tr ng-repeat="role in rolesEmpresa"><td>{{role.value}}</td><td>{{usuario.roles.indexOf(role.name) >= 0 ? \'Sim\': \'N\xE3o\'}} <a ng-show="usuario.roles.indexOf(role.name) >= 0" ng-click="usuario.roles.splice(usuario.roles.indexOf(role.name),1); permitirAcessoAoUsuario(usuario);" class="text-danger"><i class="fa fa-times"></i> </a><a ng-show="usuario.roles.indexOf(role.name) < 0" ng-click="usuario.roles.push(role.name); permitirAcessoAoUsuario(usuario);" class="text-success"><i class="fa fa-check"></i></a></td></tr></table></td></tr><tr><td colspan="4" class="text-center"><a ng-click="searchUser()" class="text-navy"><i class="fa fa-plus-circle"></i>&nbsp; Adicionar Usu\xE1rio</a></td></tr></table></div></div></div></div></div>');
$templateCache.put('app/entities/perfilEmpresa/uploadImagemEmpresa.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title" id="myServicoLabel">Logo da Empresa</h4></div><div class="modal-body"><div class="row"><div class="form-group" ng-show="imagemPrestador"><div class="col-md-4 col-md-offset-4"><img ng-src="{{imagemPrestador}}" class="img-circle img-responsive"></div></div><div class="form-group"><div class="form-group"><div class="col-md-8 col-md-offset-2"><label for="file-upload" class="custom-file-upload"><span class="fa fa-cloud-upload"></span> Selecionar Imagem</label><input type="file" id="file-upload" name="file" ngf-select="upload($file)" ng-model="arquivo" ngf-max-size="15MB" accept="image/*"></div></div></div><div class="form-group" ng-show="!imagemPrestador && myImage"><div class="col-md-7"><label>Imagem Original</label><div class="cropArea"><img-crop area-type="square" image="myImage" result-image="myCroppedImage"></img-crop></div></div><div class="col-md-5"><div class="col-md-12"><label>Imagem Ajustada</label></div><div class="col-md-12"><img ng-src="{{myCroppedImage}}"></div></div></div></div><div class="modal-footer"><button type="button" ng-click="updateImagem()" class="btn btn-primary"><i class="fa fa-save"></i>&nbsp; Salvar</button></div></div>');
$templateCache.put('app/entities/perfilUsuario/perfilUsuario.html','<div><div class="row"><div class="col-lg-12"><form name="editForm" role="form" class="form-horizontal" ng-submit="save()" novalidate><div class="ibox float-e-margins"><div class="ibox-title"><h4>Dados do Usu\xE1rio</h4></div><div class="ibox-content"><div class="form-group"><div class="col-md-6"><label for="field_cpf">CPF</label><input type="text" class="form-control" id="field_cpf" name="cpf" ui-br-cpfcnpj-mask ng-model="pessoa.dadosPessoais.cpfCnpj" ng-disabled="true"><div ng-show="editForm.cpf.$invalid"><p class="help-block" ng-show="editForm.cp.$error.required">O Campo \xE9 obrigat\xF3rio.</p><p class="help-block" ng-show="editForm.cpf.$error.cpf">CPF inv\xE1lido</p></div></div><div class="col-md-6"><label for="field_rg">RG</label><input type="text" class="form-control" id="field_rg" name="rg" ng-model="pessoa.dadosPessoais.rg"></div></div><div class="form-group"><div class="col-md-12"><label for="field_nome">Nome</label><input type="text" class="form-control" id="field_nome" name="nome" ng-model="pessoa.dadosPessoais.nomeRazaoSocial" required><div ng-show="editForm.nome.$invalid"><p class="help-block" ng-show="editForm.nome.$error.required">O Campo \xE9 obrigat\xF3rio.</p></div></div></div><div class="form-group"><div class="col-md-6"><label for="field_email">e-Mail</label><input type="text" class="form-control" id="field_email" name="email" ng-model="pessoa.dadosPessoais.email" ng-disabled="true"></div><div class="col-md-3"><label for="field_telefone">Telefone</label><input type="text" class="form-control" id="field_telefone" name="telefone" ng-model="pessoa.dadosPessoais.telefone" ui-br-phone-number><div ng-show="editForm.telefone.$invalid" class="has-error"><p class="help-block">Telefone inv\xE1lido.</p></div></div><div class="col-md-3"><label for="field_celular">Celular</label><input type="text" class="form-control" id="field_celular" name="celular" ng-model="pessoa.dadosPessoais.celular" ui-br-phone-number><div ng-show="editForm.celular.$invalid" class="has-error"><p class="help-block">Celular inv\xE1lido.</p></div></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h4>Endere\xE7o</h4></div><div class="ibox-content"><div class="form-group"><div class="col-md-2"><label for="field_cep">Cep</label><input type="text" id="field_cep" name="id" class="form-control" ui-br-cep-mask="" ng-blur="loadEnderecoByCEP(pessoa.dadosPessoais.cep)" ng-model="pessoa.dadosPessoais.cep"></div><div class="col-md-2"><label for="field_codigo_municipio">Munic\xEDpio</label><div class="input-group"><input type="text" id="field_codigo_municipio" name="municioio" class="form-control" ng-blur="loadMunicipioByCodigo(pessoa.dadosPessoais.municipio.codigo)" ng-model="pessoa.dadosPessoais.municipio.codigo"> <span class="input-group-btn"><button type="button" class="btn" ng-click="searchMunicipio()"><span class="glyphicon glyphicon-search"></span></button></span></div></div><div class="col-md-6"><label for="field_municipio_nome">Nome</label><input type="text" class="form-control" id="field_municipio_nome" name="municipio_nome" ng-model="pessoa.dadosPessoais.municipio.nome" ng-disabled="true"></div><div class="col-md-2"><label for="field_municipio_estado">Estado</label><input type="text" class="form-control" id="field_municipio_estado" name="municipio_estado" ng-model="pessoa.dadosPessoais.municipio.estado" ng-disabled="true"></div></div><div class="form-group"><div class="col-md-12"><label for="field_logradouro">Logradouro</label><input type="text" class="form-control" id="field_logradouro" name="logradouro" ng-model="pessoa.dadosPessoais.logradouro"></div></div><div class="form-group"><div class="col-md-6"><label for="field_bairro">Bairro</label><input type="text" class="form-control" id="field_bairro" name="bairro" ng-model="pessoa.dadosPessoais.bairro"></div><div class="col-md-2"><label for="field_numero">N\xFAmero</label><input type="text" class="form-control" id="field_numero" name="numero" ng-model="pessoa.dadosPessoais.numero"></div><div class="col-md-4"><label for="field_complemento">Complemento</label><input type="text" class="form-control" id="field_complemento" name="complemento" ng-model="pessoa.dadosPessoais.complemento"></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h4>Imagem</h4></div><div class="ibox-content"><div class="form-group" ng-show="imagemUsuario"><div class="col-md-4 col-md-offset-4"><img ng-src="{{imagemUsuario}}" class="img-circle img-responsive"></div></div><div class="form-group" ng-show="imagemUsuario"><div class="col-md-8 col-md-offset-2"><button class="btn btn-info btn-block" type="button" ng-click="imagemUsuario = null"><i class="fa fa-refresh"></i> Trocar Imagem</button></div></div><div class="form-group" ng-show="!imagemUsuario"><div class="form-group"><div class="col-md-8 col-md-offset-2"><label for="file-upload" class="custom-file-upload"><span class="fa fa-cloud-upload"></span> Selecionar Imagem</label><input type="file" id="file-upload" name="file" ngf-select="upload($file)" ng-model="arquivo" ngf-max-size="15MB" accept="image/*"></div></div></div><div class="form-group" ng-show="!imagemUsuario && myImage"><div class="col-md-7"><label>Imagem Original</label><div class="cropArea"><img-crop image="myImage" result-image="myCroppedImage"></img-crop></div></div><div class="col-md-5"><div class="col-md-12"><label>Imagem Ajustada</label></div><div class="col-md-12"><img ng-src="{{myCroppedImage}}"></div></div></div><div class="hr-line-dashed"></div><button type="submit" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp; Salvar</button></div></div></form></div></div></div>');
$templateCache.put('app/entities/pessoa/pessoa-detail.html','<div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h4 class="modal-title" id="myPessoaLabel"><span translate="nfseApp.pessoa.detail.title">Pessoa</span> {{pessoa.id}}</h4></div><div class="ibox-content"><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="save()"><div class="form-group"><div class="col-md-6"><label translate="nfseApp.dadosPessoais.cpfCnpj" for="field_cpfCnpj">CpfCnpj</label><input type="text" class="form-control" name="cpfCnpj" id="field_cpfCnpj" ui-br-cpfcnpj-mask readonly="readonly" ng-blur="loadInPessoaRepoByCpfCnpj()" ng-model="pessoa.dadosPessoais.cpfCnpj" required></div><div class="col-md-3"><label translate="nfseApp.dadosPessoais.inscricaoMunicipal" for="field_inscricaoMunicipal">InscricaoMunicipal</label><input type="text" class="form-control" name="inscricaoMunicipal" id="field_inscricaoMunicipal" readonly="readonly" ng-model="pessoa.dadosPessoais.inscricaoMunicipal"></div><div class="col-md-3"><label translate="nfseApp.dadosPessoais.inscricaoEstadualRg" for="field_inscricaoEstadualRg">InscricaoEstadualRg</label><input type="text" class="form-control" name="inscricaoEstadualRg" id="field_inscricaoEstadualRg" readonly="readonly" ng-model="pessoa.dadosPessoais.inscricaoEstadualRg" required></div></div><div class="form-group"><div class="col-md-6"><label translate="nfseApp.dadosPessoais.nomeRazaoSocial" for="field_nomeRazaoSocial">NomeRazaoSocial</label><input type="text" class="form-control" name="nomeRazaoSocial" id="field_nomeRazaoSocial" ng-model="pessoa.dadosPessoais.nomeRazaoSocial" readonly="readonly" required></div><div class="col-md-6"><label translate="nfseApp.dadosPessoais.nomeFantasia" for="field_nomeFantasia">NomeFantasia</label><input type="text" class="form-control" name="nomeFantasia" id="field_nomeFantasia" readonly="readonly" ng-model="pessoa.dadosPessoais.nomeFantasia"></div></div><div class="form-group"><div class="col-md-6"><label translate="nfseApp.dadosPessoais.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="pessoa.dadosPessoais.email" readonly="readonly"></div><div class="col-md-3"><label translate="nfseApp.dadosPessoais.telefone" for="field_telefone">Telefone</label><input type="text" class="form-control" name="telefone" id="field_telefone" ui-br-phone-number ng-model="pessoa.dadosPessoais.telefone" readonly="readonly"></div><div class="col-md-3"><label for="field_celular">Celular</label><input type="text" class="form-control" name="celular" id="field_celular" ui-br-phone-number ng-model="pessoa.dadosPessoais.celular" readonly="readonly"></div></div><div class="hr-line-dashed"></div><div class="form-group"><div class="col-md-3"><label translate="nfseApp.endereco.cep" for="field_cep">Cep</label><input type="text" class="form-control" name="id" id="field_cep" ui-br-cep-mask="" readonly="readonly" ng-model="pessoa.dadosPessoais.cep" required></div><div class="col-md-9"><label translate="nfseApp.endereco.logradouro" for="field_logradouro">Logradouro</label><input type="text" class="form-control" name="logradouro" id="field_logradouro" ng-model="pessoa.dadosPessoais.logradouro" readonly="readonly" required></div></div><div class="form-group"><div class="col-md-6"><label translate="nfseApp.endereco.bairro" for="field_bairro">Bairro</label><input type="text" class="form-control" name="bairro" id="field_bairro" readonly="readonly" ng-model="pessoa.dadosPessoais.bairro"></div><div class="col-md-2"><label translate="nfseApp.endereco.numero" for="field_numero">Numero</label><input type="text" class="form-control" name="numero" id="field_numero" readonly="readonly" ng-model="pessoa.dadosPessoais.numero" required></div><div class="col-md-4"><label translate="nfseApp.endereco.complemento" for="field_complemento">Complemento</label><input type="text" class="form-control" name="complemento" id="field_complemento" readonly="readonly" ng-model="pessoa.dadosPessoais.complemento"></div></div><div class="hr-line-dashed"></div><div class="form-actions"><button type="submit" ui-sref="pessoa" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div></form></div></div></div></div>');
$templateCache.put('app/entities/pessoa/pessoa-edit.html','<div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h4 class="modal-title" id="myPessoaLabel" translate="nfseApp.pessoa.home.createOrEditLabel">Create or edit a Pessoa</h4></div><div class="ibox-content"><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="save()"><div class="form-group"><div class="col-md-6"><label translate="nfseApp.dadosPessoais.cpfCnpj" for="field_cpfCnpj">CpfCnpj</label><input type="text" class="form-control" name="cpfCnpj" id="field_cpfCnpj" ui-br-cpfcnpj-mask ng-disabled="pessoa.id" ng-blur="loadByCpfCnpj()" ng-model="pessoa.dadosPessoais.cpfCnpj" required><div ng-show="editForm.cpfCnpj.$invalid"><p class="help-block" ng-show="editForm.cpfCnpj.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.cpfCnpj.$error.exists" translate="nfseApp.dadosPessoais.validation.cpfCnpj.exists">J\xE1 existe</p><p class="help-block" ng-show="editForm.cpfCnpj.$error.cpf || editForm.cpfCnpj.$error.cnpj">CPF ou CNPJ inv\xE1lido</p></div></div><div class="col-md-3"><label translate="nfseApp.dadosPessoais.inscricaoMunicipal" for="field_inscricaoMunicipal">InscricaoMunicipal</label><input type="text" class="form-control" name="inscricaoMunicipal" id="field_inscricaoMunicipal" ng-model="pessoa.dadosPessoais.inscricaoMunicipal"></div><div class="col-md-3"><label translate="nfseApp.dadosPessoais.inscricaoEstadualRg" for="field_inscricaoEstadualRg">InscricaoEstadualRg</label><input type="text" class="form-control" name="inscricaoEstadualRg" id="field_inscricaoEstadualRg" ng-model="pessoa.dadosPessoais.inscricaoEstadualRg" required><div ng-show="editForm.inscricaoEstadualRg.$invalid"><p class="help-block" ng-show="editForm.inscricaoEstadualRg.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group"><div class="col-md-6"><label translate="nfseApp.dadosPessoais.nomeRazaoSocial" for="field_nomeRazaoSocial">NomeRazaoSocial</label><input type="text" class="form-control" name="nomeRazaoSocial" id="field_nomeRazaoSocial" ng-model="pessoa.dadosPessoais.nomeRazaoSocial" required><div ng-show="editForm.nomeRazaoSocial.$invalid"><p class="help-block" ng-show="editForm.nomeRazaoSocial.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-6"><label translate="nfseApp.dadosPessoais.nomeFantasia" for="field_nomeFantasia">NomeFantasia</label><input type="text" class="form-control" name="nomeFantasia" id="field_nomeFantasia" ng-model="pessoa.dadosPessoais.nomeFantasia"></div></div><div class="form-group"><div class="col-md-6"><label translate="nfseApp.dadosPessoais.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="pessoa.dadosPessoais.email"></div><div class="col-md-3"><label translate="nfseApp.dadosPessoais.telefone" for="field_telefone">Telefone</label><input type="text" class="form-control" name="telefone" id="field_telefone" ui-br-phone-number ng-model="pessoa.dadosPessoais.telefone"></div><div class="col-md-3"><label for="field_celular">Celular</label><input type="text" class="form-control" name="celular" id="field_celular" ui-br-phone-number ng-model="pessoa.dadosPessoais.celular"></div></div><div class="hr-line-dashed"></div><div class="form-group"><div class="col-md-2"><label translate="nfseApp.endereco.cep" for="field_cep">Cep</label><input type="text" class="form-control" name="id" id="field_cep" ui-br-cep-mask ng-blur="loadEnderecoByCEP(pessoa.dadosPessoais.endereco.cep)" ng-model="pessoa.dadosPessoais.endereco.cep" required><div ng-show="editForm.cep.$invalid"><p class="help-block" ng-show="editForm.cep.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-2"><label for="field_codigo_municipio">Munic\xEDpio</label><div class="input-group"><input type="text" class="form-control" name="municioio" id="field_codigo_municipio" ng-blur="loadMunicipioByCodigo(pessoa.dadosPessoais.endereco.municipio.codigo)" ng-model="pessoa.dadosPessoais.endereco.municipio.codigo" required> <span class="input-group-btn"><button type="button" class="btn" ng-click="searchMunicipio()"><span class="glyphicon glyphicon-search"></span></button></span></div><div ng-show="editForm.municipio.$invalid"><p class="help-block" ng-show="editForm.municipio.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-6"><label for="field_nome_municipio">Nome</label><input type="text" class="form-control" name="nome_municipio" id="field_nome_municipio" disabled="disabled" ng-model="pessoa.dadosPessoais.endereco.municipio.nome"></div><div class="col-md-2"><label for="field_estado_municipio">Estado</label><input type="text" class="form-control" name="estado_municipio" id="field_estado_municipio" disabled="disabled" ng-model="pessoa.dadosPessoais.endereco.municipio.estado"></div></div><div class="form-group"><div class="col-md-12"><label translate="nfseApp.endereco.logradouro" for="field_logradouro">Logradouro</label><input type="text" class="form-control" name="logradouro" id="field_logradouro" ng-model="pessoa.dadosPessoais.endereco.logradouro" required><div ng-show="editForm.logradouro.$invalid"><p class="help-block" ng-show="editForm.logradouro.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group"><div class="col-md-6"><label translate="nfseApp.endereco.bairro" for="field_bairro">Bairro</label><input type="text" class="form-control" name="bairro" id="field_bairro" ng-model="pessoa.dadosPessoais.endereco.bairro"></div><div class="col-md-2"><label translate="nfseApp.endereco.numero" for="field_numero">Numero</label><input type="text" class="form-control" name="numero" id="field_numero" ng-model="pessoa.dadosPessoais.endereco.numero" required><div ng-show="editForm.numero.$invalid"><p class="help-block" ng-show="editForm.numero.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-4"><label translate="nfseApp.endereco.complemento" for="field_complemento">Complemento</label><input type="text" class="form-control" name="complemento" id="field_complemento" ng-model="pessoa.dadosPessoais.endereco.complemento"></div></div><div class="hr-line-dashed"></div><div class="form-actions"><button type="button" class="btn btn-default" ui-sref="pessoa"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form></div></div></div></div>');
$templateCache.put('app/entities/pessoa/pessoas.html','<div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><span translate="nfseApp.pessoa.home.title">Form</span></div><div class="ibox-content"><div class="row"><div class="col-md-8"><search-box ng-model="searchQuery" search-method="search()"></search-box></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="global.field.id">ID</th><th translate="nfseApp.dadosPessoais.nomeRazaoSocial">nomeRazaoSocial</th><th translate="nfseApp.dadosPessoais.nomeFantasia">nomeFantasia</th><th translate="nfseApp.dadosPessoais.cpfCnpj">cpfCnpj</th><th translate="nfseApp.dadosPessoais.email">email</th><th></th></tr></thead><tbody><tr ng-repeat="pessoa in pessoas"><td><a ui-sref="pessoa.detail({id:pessoa.id})">{{pessoa.id}}</a></td><td>{{pessoa.dadosPessoais.nomeRazaoSocial}}</td><td>{{pessoa.dadosPessoais.nomeFantasia}}</td><td>{{pessoa.dadosPessoais.cpfCnpj}}</td><td>{{pessoa.dadosPessoais.email}}</td><td><div class="pull-right"><button type="submit" ui-sref="pessoa.detail({id:pessoa.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button></div></td></tr></tbody></table><nav><ul class="pager"><li ng-show="links[\'first\']" ng-click="loadPage(links[\'first\'])"><a href="#">&lt;&lt;</a></li><li ng-show="links[\'prev\']" ng-click="loadPage(links[\'prev\'])"><a href="#">&lt;</a></li><li ng-show="links[\'next\']" ng-click="loadPage(links[\'next\'])"><a href="#">&gt;</a></li><li ng-show="links[\'last\']" ng-click="loadPage(links[\'last\'])"><a href="#">&gt;&gt;</a></li></ul></nav></div></div></div></div></div>');
$templateCache.put('app/entities/plano-geral-contas-comentado/plano-geral-contas-comentado-detail.html','<div class="row" ng-if="prestador"><div class="col-lg-12"><div class="ibox float-e-margins animated fadeInDown"><div class="ibox-content"><div class="row"><div class="form-group"><div class="col-md-12"><h3>Detalhe da Conta do PGCC</h3></div></div><div class="form-group"><div class="col-md-2"><label>In\xEDcio de Vig\xEAncia</label><input type="text" disabled="true" value="{{entity.inicioVigencia | date: \'dd/MM/yyyy\'}}" class="form-control"></div><div class="col-md-2"><label>Fim de Vig\xEAncia</label><input type="text" disabled="true" value="{{entity.fimVigencia | date: \'dd/MM/yyyy\'}}" class="form-control"></div><div class="col-md-2"><label>Conta</label><input type="text" disabled="true" value="{{entity.conta}}" class="form-control"></div><div class="col-md-1" ng-if="prestador.enquadramentoFiscal.versaoDesif == \'VERSAO_ABRASF_3_1\'"><label>Desdobramento</label><input type="text" disabled="true" value="{{entity.desdobramento}}" class="form-control"></div><div class="col-md-5"><label>Nome</label><input type="text" disabled="true" value="{{entity.nome}}" class="form-control"></div></div><div class="form-group"><div class="col-md-12 m-t-sm"><label>Descri\xE7\xE3o Detalhada</label><textarea type="text" class="form-control" required disabled="disabled" rows="7" maxlength="3000" minlength="3" name="descricaoDetalhada" ng-model="entity.descricaoDetalhada">\n                                </textarea></div></div><div class="form-group"><div class="col-md-12 m-t-md"><h4>COSIF</h4></div></div><div class="form-group"><div class="col-md-2"><label class="center-block">Conta</label><input type="text" disabled="true" value="{{entity.cosif.conta}}" class="form-control"></div><div class="col-md-10"><label class="center-block">Descri\xE7\xE3o</label><input type="text" disabled="true" value="{{entity.cosif.descricao}}" class="form-control"></div></div><div class="form-group" ng-if="prestador.enquadramentoFiscal.versaoDesif == \'VERSAO_1_0\'"><div class="col-md-12 m-t-md"><h4>Servi\xE7o</h4></div></div><div class="form-group" ng-if="prestador.enquadramentoFiscal.versaoDesif == \'VERSAO_1_0\'"><div class="col-md-2"><label class="center-block">C\xF3digo</label><input type="text" disabled="true" value="{{entity.servico.codigo}}" class="form-control"></div><div class="col-md-10"><label class="center-block">Descri\xE7\xE3o</label><input type="text" disabled="true" value="{{entity.servico.descricao}}" class="form-control"></div></div><div class="form-group" ng-if="prestador.enquadramentoFiscal.versaoDesif == \'VERSAO_ABRASF_3_1\'"><div class="col-md-12 m-t-md"><h4>C\xF3digo de Tributa\xE7\xE3o</h4></div></div><div class="form-group" ng-if="prestador.enquadramentoFiscal.versaoDesif == \'VERSAO_ABRASF_3_1\'"><div class="col-md-2"><label class="center-block">C\xF3digo</label><input type="text" disabled="true" value="{{entity.codigoTributacao.codigo}}" class="form-control"></div><div class="col-md-10"><label class="center-block">Descri\xE7\xE3o</label><input type="text" disabled="true" value="{{entity.codigoTributacao.descricao}}" class="form-control"></div></div><div class="form-group" ng-if="prestador.enquadramentoFiscal.versaoDesif == \'VERSAO_ABRASF_3_1\' &&\n                         entity.tarifaBancaria && entity.tarifaBancaria.id"><div class="col-md-12 m-t-md"><h4>Tarifa Banc\xE1ria</h4></div><div class="col-md-2"><label class="center-block">C\xF3digo</label><input type="text" disabled="true" value="{{entity.tarifaBancaria.tarifaBancaria.codigo}}" class="form-control"></div><div class="col-md-4"><label class="center-block">Descri\xE7\xE3o</label><input type="text" disabled="true" value="{{entity.tarifaBancaria.tarifaBancaria.descricao}}" class="form-control"></div><div class="col-md-2"><label class="center-block">In\xEDcio de Vig\xEAncia</label><input type="text" disabled="true" value="{{entity.tarifaBancaria.inicioVigencia | date: \'dd/MM/yyyy\'}}" class="form-control"></div><div class="col-md-2"><label class="center-block">Valor Unit\xE1rio</label><input type="text" disabled="true" value="{{entity.tarifaBancaria.valorUnitario | currency: \'R$ \'}}" class="form-control"></div><div class="col-md-2"><label class="center-block">Valor Percentual</label><input type="text" disabled="true" value="{{entity.tarifaBancaria.valorPercentual | currency: \'% \'}}" class="form-control"></div></div><div class="form-group" ng-if="prestador.enquadramentoFiscal.versaoDesif == \'VERSAO_ABRASF_3_1\' &&\n                         entity.produtoServico && entity.produtoServico.id"><div class="col-md-12 m-t-md"><h4>Produto/Servico</h4></div><div class="col-md-2"><label class="center-block">C\xF3digo</label><input type="text" disabled="true" value="{{entity.produtoServico.produtoServico.codigo}}" class="form-control"></div><div class="col-md-5"><label class="center-block">Descri\xE7\xE3o</label><input type="text" disabled="true" value="{{entity.produtoServico.produtoServico.descricao}}" class="form-control"></div><div class="col-md-5"><label class="center-block">Descri\xE7\xE3o Complementar</label><input type="text" disabled="true" value="{{entity.produtoServico.descricaoComplementar}}" class="form-control"></div></div><div class="col-md-12 m-t-lg"><button class="btn btn-success" title="Clique para editar os dados do registro." ui-sref="planoGeralContasComentado.edit({id:entity.id})"><span class="fa fa-edit"></span> Editar</button> <button class="btn btn-danger" title="Clique para excluir esse registro." ng-click="remove()"><span class="fa fa-trash"></span> Excluir</button> <button type="button" ui-sref="planoGeralContasComentado" class="btn btn-default"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp; Voltar</button></div></div></div></div></div></div>');
$templateCache.put('app/entities/plano-geral-contas-comentado/plano-geral-contas-comentado-edit.html','<div class="row"><div class="col-lg-12"><div class="ibox float-e-margins animated fadeInDown"><div class="ibox-content"><div class="row"><div class="form-group"><div class="col-md-12"><h3>Cadastro de Conta do PGCC</h3></div></div></div><form name="editForm" ng-submit="save(editForm)"><div class="row m-t-md"><div class="form-group"><div class="col-md-2"><label>In\xEDcio de Vig\xEAncia</label><input type="date" name="inicioVigencia" ng-required="true" ng-model="entity.inicioVigencia" class="form-control"><p class="help-block" ng-show="editForm.$submitted && editForm.inicioVigencia.$error.required">Informe o In\xEDcio de Vig\xEAncia</p></div><div class="col-md-2"><label>Fim de Vig\xEAncia</label><input type="date" ng-model="entity.fimVigencia" class="form-control"></div></div></div><div class="row m-t-md"><div class="form-group"><div class="col-md-2"><label>Conta</label><input type="text" name="conta" ng-required="true" onkeypress="somenteNumeros(event, this, false, true, true)" ng-model="entity.conta" class="form-control"><p class="help-block" ng-show="editForm.$submitted && editForm.conta.$error.required">Informe a Conta</p></div><div class="col-md-2" ng-if="entity.prestador.enquadramentoFiscal.versaoDesif == \'VERSAO_ABRASF_3_1\'"><label>Desdobramento</label><input type="text" required name="desdobramento" onkeypress="somenteNumeros(event, this, false, true, true)" ng-model="entity.desdobramento" maxlength="2" class="form-control"><p class="help-block" ng-show="editForm.$submitted && editForm.desdobramento.$error.required">Informe o Desdobramento, caso n\xE3o tenha, informe \'00\'.</p></div><div class="col-md-8"><label>Nome</label><input type="text" required name="nome" ng-model="entity.nome" class="form-control"><p class="help-block" ng-show="editForm.$submitted && editForm.nome.$error.required">Informe o Nome.</p></div></div></div><div class="row m-t-md"><div class="form-group"><div class="col-md-12"><label>Descri\xE7\xE3o Detalhada</label><textarea type="text" class="form-control" required rows="7" maxlength="3000" minlength="3" name="descricaoDetalhada" ng-model="entity.descricaoDetalhada">\n                                </textarea><p class="help-block" ng-show="editForm.$submitted && editForm.descricaoDetalhada.$error.required">Informe a Descri\xE7\xE3o Detalhada.</p></div></div></div><div class="row m-t-md"><div class="form-group"><div class="col-md-12"><h4>COSIF</h4></div></div></div><div class="row"><div class="form-group"><div class="col-md-2"><label class="center-block">Conta</label><div class="input-group"><input type="text" ng-model="cosif" ng-blur="buscarCosif()" class="form-control"> <span class="input-group-btn"><button type="button" class="btn btn btn-success" ng-click="pesquisarCosif()"><i class="fa fa-search"></i></button></span></div></div><div class="col-md-10"><label class="center-block">Descri\xE7\xE3o</label><input type="text" disabled="true" ng-model="entity.cosif.descricao" class="form-control"></div></div></div><div class="row m-t-md" ng-if="entity.prestador.enquadramentoFiscal.versaoDesif == \'VERSAO_1_0\'"><div class="form-group"><div class="col-md-12"><h4>Servi\xE7o</h4></div></div></div><div class="row" ng-if="entity.prestador.enquadramentoFiscal.versaoDesif == \'VERSAO_1_0\'"><div class="form-group"><div class="col-md-2"><label class="center-block">C\xF3digo</label><div class="input-group"><input type="text" ng-model="codigoServico" ng-blur="buscarServico()" class="form-control"> <span class="input-group-btn"><button type="button" class="btn btn btn-success" ng-click="pesquisarServico()"><i class="fa fa-search"></i></button></span></div></div><div class="col-md-10"><label class="center-block">Descri\xE7\xE3o</label><input type="text" disabled="true" ng-model="entity.servico.descricao" class="form-control"></div></div></div><div class="row m-t-md" ng-if="entity.prestador.enquadramentoFiscal.versaoDesif == \'VERSAO_ABRASF_3_1\'"><div class="form-group"><div class="col-md-12"><h4>C\xF3digo de Tributa\xE7\xE3o</h4></div></div></div><div class="row" ng-if="entity.prestador.enquadramentoFiscal.versaoDesif == \'VERSAO_ABRASF_3_1\'"><div class="form-group"><div class="col-md-2"><label class="center-block">C\xF3digo</label><div class="input-group"><input type="text" ng-model="codigoTributacao" ng-blur="buscarCodigoTributacao()" class="form-control"> <span class="input-group-btn"><button type="button" class="btn btn btn-success" ng-click="pesquisarCodigoTributacao()"><i class="fa fa-search"></i></button></span></div></div><div class="col-md-10"><label class="center-block">Descri\xE7\xE3o</label><input type="text" disabled="true" ng-model="entity.codigoTributacao.descricao" class="form-control"></div></div></div><div class="row m-t-md" ng-if="entity.prestador.enquadramentoFiscal.versaoDesif == \'VERSAO_ABRASF_3_1\'"><div class="col-md-offset-3 col-md-6 text-center"><button type="button" ng-click="changeTipoVinculo(\'TARIFA_BANCARIA\')" class="btn {{tipoVinculo == \'TARIFA_BANCARIA\' ? \'btn-success\' : \'btn-default\'}}"><span class="glyphicon glyphicon-save"></span>&nbsp; Tarifa Banc\xE1ria</button> <button type="button" ng-click="changeTipoVinculo(\'PRODUTO_SERVICO\')" class="btn {{tipoVinculo == \'PRODUTO_SERVICO\' ? \'btn-success\' : \'btn-default\'}}"><span class="glyphicon glyphicon-save"></span>&nbsp; Produto/Servi\xE7o</button></div></div><div ng-if="entity.prestador.enquadramentoFiscal.versaoDesif == \'VERSAO_ABRASF_3_1\' && tipoVinculo == \'TARIFA_BANCARIA\'"><div class="row m-t-md"><div class="form-group"><div class="col-md-12"><h4>Tarifa Banc\xE1ria</h4></div></div></div><div class="row"><div class="form-group"><div class="col-md-2"><label class="center-block">C\xF3digo</label><div class="input-group"><input type="text" ng-model="tarifaBancaria" ng-blur="buscarTarifaBancaria()" class="form-control"> <span class="input-group-btn"><button type="button" class="btn btn btn-success" ng-click="pesquisarTarifaBancaria()"><i class="fa fa-search"></i></button></span></div></div><div class="col-md-4"><label class="center-block">Descri\xE7\xE3o</label><input type="text" disabled="disabled" value="{{entity.tarifaBancaria.tarifaBancaria.descricao}}" class="form-control"></div><div class="col-md-2"><label class="center-block">In\xEDcio de Vig\xEAncia</label><input type="date" ng-disabled="!entity.tarifaBancaria" ng-model="entity.tarifaBancaria.inicioVigencia" class="form-control"></div><div class="col-md-2"><label class="center-block">Valor Unit\xE1rio</label><input enter-as-tab type="text" class="form-control" ui-money-mask="" ng-disabled="!entity.tarifaBancaria" ng-model="entity.tarifaBancaria.valorUnitario"></div><div class="col-md-2"><label class="center-block">Valor Percentual</label><input enter-as-tab type="text" class="form-control" ui-number-mask="" ng-disabled="!entity.tarifaBancaria" ng-model="entity.tarifaBancaria.valorPercentual"></div></div></div></div><div ng-if="entity.prestador.enquadramentoFiscal.versaoDesif == \'VERSAO_ABRASF_3_1\' && tipoVinculo == \'PRODUTO_SERVICO\'"><div class="row m-t-md"><div class="form-group"><div class="col-md-12"><h4>Produto/Servi\xE7o</h4></div></div></div><div class="row"><div class="form-group"><div class="col-md-2"><label class="center-block">C\xF3digo</label><div class="input-group"><input type="text" ng-model="produtoServico" ng-blur="buscarProdutoServico()" class="form-control"> <span class="input-group-btn"><button type="button" class="btn btn btn-success" ng-click="pesquisarProdutoServico()"><i class="fa fa-search"></i></button></span></div></div><div class="col-md-10"><label class="center-block">Descri\xE7\xE3o</label><input type="text" disabled="disabled" value="{{entity.produtoServico.produtoServico.descricao}}" class="form-control"></div></div></div><div class="row"><div class="form-group"><div class="col-md-12"><label class="center-block">Descri\xE7\xE3o Complementar</label><textarea type="text" class="form-control" ng-disabled="!entity.produtoServico" rows="7" maxlength="3000" minlength="3" ng-model="entity.produtoServico.descricaoComplementar">\n                                </textarea></div></div></div></div><div class="row m-t-md"><div class="col-md-12 m-t-lg"><button type="submit" ng-disabled="editForm.$invalid" class="btn btn-success"><span class="glyphicon glyphicon-save"></span>&nbsp; Salvar</button> <button type="button" ui-sref="planoGeralContasComentado" class="btn btn-default"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp; Cancelar</button></div></div></form></div></div></div></div>');
$templateCache.put('app/entities/plano-geral-contas-comentado/plano-geral-contas-comentado-search.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title">Pesquisa Conta no Plano Geral de Contas Comentado</h4></div><div class="modal-body"><div class="row"><div class="row"><div class="col-md-12"><div class="form-group col-md-2"><label>Conta</label><input class="form-control" ng-model="filtro.conta"></div><div class="form-group col-md-1"><label>Desd.</label><input class="form-control" ng-model="filtro.desdobramento"></div><div class="form-group col-md-9"><label>Nome</label><input class="form-control" ng-model="filtro.nome"></div></div></div><div class="row"><div class="col-md-12"><div class="col-md-4"><button class="btn btn-primary" ng-click="loadAll()"><span class="fa fa-search"></span> <span>Pesquisar</span></button> <button class="btn btn-default" ng-click="filtro = {}"><span class="fa fa-close"></span> <span>Limpar Filtros</span></button></div></div></div></div><div class="row m-t-md"><div class="col-md-12"><div class="table-responsive"><table class="table table-striped small"><thead><tr><th class="col-md-2">Conta</th><th class="col-md-1">Desdobramento</th><th>Nome</th></tr></thead><tbody><tr ng-repeat="conta in contas"><td class="col-md-2">{{conta.conta}}</td><td class="col-md-1">{{conta.desdobramento}}</td><td>{{conta.nome}}</td><td class="pull-right"><button type="submit" ng-click="ok(conta)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-check"></span></button></td></tr></tbody></table><span nfse-app-pagination></span></div></div></div></div>');
$templateCache.put('app/entities/plano-geral-contas-comentado/plano-geral-contas-comentado.html','<div class="row" ng-if="prestador"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><div class="row"><div class="col-md-12"><div class="panel panel-default"><div class="panel-heading">Op\xE7\xF5es de Filtros</div><div class="panel-body"><div class="row"><div class="form-group"><div class="col-md-2"><label>Conta</label><input class="form-control" ng-model="filtro.conta"></div><div class="col-md-2" ng-if="prestador.enquadramentoFiscal.versaoDesif == \'VERSAO_ABRASF_3_1\'"><label>Desdobramento</label><input class="form-control" ng-model="filtro.desdobramento"></div><div class="col-md-8"><label>Nome</label><input class="form-control" ng-model="filtro.nome"></div></div></div><div class="row m-t-md"><div class="col-md-4"><button class="btn btn-primary" ng-click="loadAll()"><span class="fa fa-search"></span> <span>Pesquisar</span></button> <button class="btn btn-default" ng-click="filtro = {}"><span class="fa fa-close"></span> <span>Limpar Filtros</span></button></div><div class="col-md-offset-5 col-md-3"><button class="btn btn-primary btn-block" ui-sref="planoGeralContasComentado.insert"><span class="fa fa-plus"></span> <span>Nova Conta</span></button></div></div></div></div></div></div></div><div class="ibox-content"><span nfse-app-pagination></span><div class="table-responsive"><table class="table table-striped small"><thead><tr><th class="col-md-1 text-center">Op\xE7\xF5es</th><th class="col-md-2">In\xEDcio de Vig\xEAncia</th><th class="col-md-2">Fim de Vig\xEAncia</th><th class="col-md-2">Conta</th><th class="col-md-1" ng-if="prestador.enquadramentoFiscal.versaoDesif == \'VERSAO_ABRASF_3_1\'">Desdobramento</th><th>Nome</th></tr></thead><tbody><tr ng-repeat="conta in contas"><td class="col-md-2 text-center"><button class="btn btn-sm btn-info" title="Clique para visualizar os dados do registro." ui-sref="planoGeralContasComentado.detail({id:conta.id})"><span class="fa fa-eye"></span></button> <button class="btn btn-sm btn-success" title="Clique para editar os dados do registro." ui-sref="planoGeralContasComentado.edit({id:conta.id})"><span class="fa fa-edit"></span></button> <button class="btn btn-sm btn-danger" title="Clique para excluir esse registro." ng-click="remove(conta)"><span class="fa fa-trash"></span></button></td><td class="col-md-2">{{conta.inicioVigencia | date: \'dd/MM/yyyy\'}}</td><td class="col-md-2">{{conta.fimVigencia | date: \'dd/MM/yyyy\'}}</td><td class="col-md-2">{{conta.conta}}</td><td class="col-md-1" ng-if="prestador.enquadramentoFiscal.versaoDesif == \'VERSAO_ABRASF_3_1\'">{{conta.desdobramento}}</td><td>{{conta.nome}}</td></tr></tbody></table><span nfse-app-pagination></span></div></div></div></div></div>');
$templateCache.put('app/entities/prestadorServicos/prestadorServicos-detail.html','<div class="row"><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="save()"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h4>Dados da Pessoa</h4></div><div class="ibox-content"><div class="form-group"><div class="col-md-6"><label class="control-label" for="field_cpfCnpj">CNPJ</label><input type="text" class="form-control" name="cpfCnpj" id="field_cpfCnpj" ui-br-cnpj-mask disabled="disabled" ng-model="prestadorServicos.pessoa.dadosPessoais.cpfCnpj"></div><div class="col-md-3"><label translate="nfseApp.dadosPessoais.inscricaoMunicipal" for="field_inscricaoMunicipal">InscricaoMunicipal</label><input type="text" class="form-control" name="inscricaoMunicipal" id="field_inscricaoMunicipal" disabled="disabled" ng-model="prestadorServicos.inscricaoMunicipal"></div><div class="col-md-3"><label class="control-label" for="field_inscricaoEstadualRg">Inscri\xE7\xE3o Estadual</label><input type="text" class="form-control" name="inscricaoEstadualRg" id="field_inscricaoEstadualRg" disabled="disabled" ng-model="prestadorServicos.pessoa.dadosPessoais.inscricaoEstadualRg" required></div></div><div class="form-group"><div class="col-md-6"><label class="control-label" for="field_nomeRazaoSocial">Raz\xE3o Social</label><input type="text" class="form-control" name="nomeRazaoSocial" id="field_nomeRazaoSocial" ng-model="prestadorServicos.pessoa.dadosPessoais.nomeRazaoSocial" disabled="disabled"></div><div class="col-md-6"><label translate="nfseApp.dadosPessoais.nomeFantasia" for="field_nomeFantasia">NomeFantasia</label><input type="text" class="form-control" name="nomeFantasia" id="field_nomeFantasia" disabled="disabled" ng-model="prestadorServicos.pessoa.dadosPessoais.nomeFantasia"></div></div><div class="form-group"><div class="col-md-6"><label translate="nfseApp.dadosPessoais.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" disabled="disabled" ng-model="prestadorServicos.pessoa.dadosPessoais.email"></div><div class="col-md-3"><label translate="nfseApp.dadosPessoais.telefone" for="field_telefone">Telefone</label><input type="text" class="form-control" name="telefone" id="field_telefone" ui-br-phone-number disabled="disabled" ng-model="prestadorServicos.pessoa.dadosPessoais.telefone"></div><div class="col-md-3"><label for="field_telefone">Celular</label><input type="text" class="form-control" name="celular" id="field_celular" ui-br-phone-number disabled="disabled" ng-model="prestadorServicos.pessoa.dadosPessoais.celular"></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h4>Endere\xE7o</h4></div><div class="ibox-content"><div class="form-group"><div class="col-md-2"><label translate="nfseApp.endereco.cep" for="field_cep">Cep</label><input type="text" class="form-control" name="id" id="field_cep" ui-br-cep-mask ng-model="prestadorServicos.pessoa.dadosPessoais.cep" disabled="disabled"></div><div class="col-md-2"><label for="field_codigo_municipio">Munic\xEDpio</label><input type="text" class="form-control" name="municioio" id="field_codigo_municipio" ng-model="prestadorServicos.pessoa.dadosPessoais.municipio.codigo" disabled="disabled"></div><div class="col-md-6"><label for="field_nome_municipio">Nome</label><input type="text" class="form-control" name="nome_municipio" id="field_nome_municipio" disabled="disabled" ng-model="prestadorServicos.pessoa.dadosPessoais.municipio.nome"></div><div class="col-md-2"><label for="field_estado_municipio">Estado</label><input type="text" class="form-control" name="estado_municipio" id="field_estado_municipio" disabled="disabled" ng-model="prestadorServicos.pessoa.dadosPessoais.municipio.estado"></div></div><div class="form-group"><div class="col-md-12"><label translate="nfseApp.endereco.logradouro" for="field_logradouro">Logradouro</label><input type="text" class="form-control" name="logradouro" id="field_logradouro" ng-model="prestadorServicos.pessoa.dadosPessoais.logradouro" disabled="disabled"></div></div><div class="form-group"><div class="col-md-6"><label translate="nfseApp.endereco.bairro" for="field_bairro">Bairro</label><input type="text" class="form-control" name="bairro" id="field_bairro" disabled="disabled" ng-model="prestadorServicos.pessoa.dadosPessoais.bairro"></div><div class="col-md-2"><label translate="nfseApp.endereco.numero" for="field_numero">Numero</label><input type="text" class="form-control" name="numero" id="field_numero" ng-model="prestadorServicos.pessoa.dadosPessoais.numero" disabled="disabled"></div><div class="col-md-4"><label translate="nfseApp.endereco.complemento" for="field_complemento">Complemento</label><input type="text" class="form-control" name="complemento" id="field_complemento" disabled="disabled" ng-model="prestadorServicos.pessoa.dadosPessoais.complemento"></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h4>Socios</h4></div><div class="ibox-content"><div class="form-group"><div class="col-md-3"><label class="center-block">CPF/CNPJ</label></div><div class="col-md-7"><label class="center-block">Nome</label></div><div class="col-md-2"><label class="center-block">Percentual</label></div></div><div class="form-group" data-ng-repeat="socio in prestadorServicos.socios" ng-form="socioForm" class="animated fadeInDown"><div class="col-md-3"><input type="text" class="form-control" name="socio_cpfCnpj" id="field_socio_cpfCnpj" ui-br-cpfcnpj-mask="" required disabled="disabled" ng-model="socio.socio.dadosPessoais.cpfCnpj"></div><div class="col-md-7"><input type="text" class="form-control" name="socio_nome" id="field_socio_nome" disabled="disabled" ng-model="socio.socio.dadosPessoais.nomeRazaoSocial"></div><div class="col-md-2"><div class="input-group"><input type="text" class="form-control" name="socio_proporcao" ui-percentage-mask ui-percentage-value disabled="disabled" id="field_socio_proporcao" ng-model="socio.proporcao"></div></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h4>Enquadramento Fiscal</h4></div><div class="ibox-content"><div class="form-group animated fadeInUp"><div class="col-md-4"><label for="field_porte">Porte</label><input type="text" class="form-control" name="porte" id="field_porte" disabled="disabled" ng-model="prestadorServicos.enquadramentoFiscal.porte"></div><div class="col-md-4"><label for="field_porte">Tipo de Contribuinte</label><input type="text" class="form-control" name="tipoContribuinte" id="field_tipoContribuinte" disabled="disabled" ng-model="prestadorServicos.enquadramentoFiscal.tipoContribuinte"></div><div class="col-md-4"><label for="field_porte">Regime Tributario</label><input type="text" class="form-control" name="regimeTributario" id="field_regimeTributario" disabled="disabled" ng-model="prestadorServicos.enquadramentoFiscal.regimeTributario"></div><div class="col-md-4"><label for="field_porte">Tipo de Iss</label><input type="text" class="form-control" name="tipoIss" id="field_tipoIss" disabled="disabled" ng-model="prestadorServicos.enquadramentoFiscal.tipoIss"></div><div class="col-md-4"><label for="field_porte">Tipo de Iss Estimado</label><input type="text" class="form-control" name="tipoIssEstimado" id="field_tipoIssEstimado" disabled="disabled" ng-model="prestadorServicos.enquadramentoFiscal.tipoIssEstimado"></div><div class="col-md-4"><label for="field_porte">Valor de Iss Estimado</label><input type="text" class="form-control" name="valorIssEstimado" id="field_valorIssEstimado" disabled="disabled" ng-model="prestadorServicos.enquadramentoFiscal.valorIssEstimado"></div><div class="col-md-4"><label for="field_porte">Classifica\xE7\xE3o da Atividade</label><input type="text" class="form-control" name="classificacaoAtividade" id="field_classificacaoAtividade" disabled="disabled" ng-model="prestadorServicos.enquadramentoFiscal.classificacaoAtividade"></div><div class="col-md-4"><label for="field_porte">Tipo de Nota Fiscal</label><input type="text" class="form-control" name="tipoNotaFiscal" id="field_tipoNotaFiscal" disabled="disabled" ng-model="prestadorServicos.enquadramentoFiscal.tipoNotaFiscal"></div><div class="col-md-4"><label for="field_porte">Substituto Tributario</label><input type="text" class="form-control" name="substitutoTributario" id="field_substitutoTributario" disabled="disabled" value="{{prestadorServicos.enquadramentoFiscal.substitutoTributario? \'Sim\': \'N\xE3o\'}}"></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h4>Servi\xE7os</h4></div><div class="ibox-content"><div class="form-group"><div class="col-md-2"><label class="center-block">C\xF3digo</label></div><div class="col-md-2"><label class="center-block">Aliquota</label></div><div class="col-md-8"><label class="center-block">Descri\xE7\xE3o</label></div></div><div class="form-group" data-ng-repeat="servico in prestadorServicos.servicos" class="animated fadeInDown"><div class="col-md-2"><input type="text" class="form-control" name="servico_codigo" id="field_servico_codigo" disabled="disabled" ng-model="servico.codigo"></div><div class="col-md-2"><input type="text" class="form-control" name="servico_aliquota" id="field_servico_aliquota" ng-model="servico.aliquota" disabled="disabled"></div><div class="col-md-8"><input type="text" class="form-control" name="servico_descricao" id="field_servico_descricao" disabled="disabled" ng-model="servico.descricao"></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h4>Cnaes</h4></div><div class="ibox-content"><div class="form-group"><div class="col-md-2"><label class="center-block">C\xF3digo</label></div><div class="col-md-2"><label class="center-block">Descricao</label></div></div><div class="form-group" data-ng-repeat="cnae in prestadorServicos.cnaes" class="animated fadeInDown"><div class="col-md-2"><input type="text" class="form-control" name="cane_codigo" id="field_cnae_codigo" disabled="disabled" ng-model="cnae.codigo"></div><div class="col-md-10"><input type="text" class="form-control" name="cnae_descricao" id="field_cnae_descricao" disabled="disabled" ng-model="cnae.descricao"></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h4>Usu\xE1rios</h4></div><div class="ibox-content"><table class="table table-striped"><thead><tr><th>Login</th></tr></thead><tbody><tr ng-repeat="usuario in prestadorServicos.usuarios"><td>{{usuario.usuario.nomeRazao ? usuario.usuario.nomeRazao : usuario.usuario.login}}</td></tr></tbody></table></div></div><div class="form-actions"><button type="button" class="btn btn-default" ui-sref="prestadorServicos"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid\n                        || !$scope.prestadorServicos.situacoesTributaria && $scope.prestadorServicos.situacoesTributaria == 0" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span> &nbsp; <span translate="entity.action.save">Save</span></button></div></div></form></div>');
$templateCache.put('app/entities/prestadorServicos/prestadorServicos-edit.html','<div class="row"><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="save()"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h4>Dados da Pessoa</h4></div><div class="ibox-content"><div class="form-group"><div class="col-md-6" ng-class="{\'has-error\' : editForm.cpfCnpj.$invalid && (editForm.$submitted || editForm.cpfCnpj.$touched)}"><label class="control-label" for="field_cpfCnpj">CNPJ</label><input type="text" class="form-control" name="cpfCnpj" id="field_cpfCnpj" ui-br-cnpj-mask ng-disabled="prestadorServicos.id" ng-blur="loadByCpfCnpj()" ng-model="prestadorServicos.pessoa.dadosPessoais.cpfCnpj" required><div ng-show="editForm.cpfCnpj.$invalid"><p class="help-block" ng-show="editForm.cpfCnpj.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.cpfCnpj.$error.exists" translate="nfseApp.dadosPessoais.validation.cpfCnpj.exists">J\xE1 existe</p><p class="help-block" ng-show="editForm.cpfCnpj.$error.cpf || editForm.cpfCnpj.$error.cnpj">CNPJ inv\xE1lido</p></div></div><div class="col-md-3"><label translate="nfseApp.dadosPessoais.inscricaoMunicipal" for="field_inscricaoMunicipal">InscricaoMunicipal</label><input type="text" class="form-control" name="inscricaoMunicipal" id="field_inscricaoMunicipal" ng-model="prestadorServicos.inscricaoCadastral"></div><div class="col-md-3" ng-class="{\'has-error\' : editForm.inscricaoEstadualRg.$invalid && (editForm.$submitted || editForm.inscricaoEstadualRg.$touched)}"><label class="control-label" for="field_inscricaoEstadualRg">Inscri\xE7\xE3o Estadual</label><input type="text" class="form-control" name="inscricaoEstadualRg" id="field_inscricaoEstadualRg" ng-model="prestadorServicos.pessoa.dadosPessoais.inscricaoEstadualRg" required><div ng-show="editForm.inscricaoEstadualRg.$invalid"><p class="help-block" ng-show="editForm.inscricaoEstadualRg.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group"><div class="col-md-6" ng-class="{\'has-error\' : editForm.nomeRazaoSocial.$invalid && (editForm.$submitted || editForm.nomeRazaoSocial.$touched)}"><label class="control-label" for="field_nomeRazaoSocial">Raz\xE3o Social</label><input type="text" class="form-control" name="nomeRazaoSocial" id="field_nomeRazaoSocial" ng-model="prestadorServicos.pessoa.dadosPessoais.nomeRazaoSocial" required><div ng-show="editForm.nomeRazaoSocial.$invalid"><p class="help-block" ng-show="editForm.nomeRazaoSocial.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-6"><label translate="nfseApp.dadosPessoais.nomeFantasia" for="field_nomeFantasia">NomeFantasia</label><input type="text" class="form-control" name="nomeFantasia" id="field_nomeFantasia" ng-model="prestadorServicos.pessoa.dadosPessoais.nomeFantasia"></div></div><div class="form-group"><div class="col-md-6"><label translate="nfseApp.dadosPessoais.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="prestadorServicos.pessoa.dadosPessoais.email"></div><div class="col-md-3"><label translate="nfseApp.dadosPessoais.telefone" for="field_telefone">Telefone</label><input type="text" class="form-control" name="telefone" id="field_telefone" ui-br-phone-number ng-model="prestadorServicos.pessoa.dadosPessoais.telefone"></div><div class="col-md-3"><label for="field_celular">Celular</label><input type="text" class="form-control" name="celular" id="field_celular" ui-br-phone-number ng-model="prestadorServicos.pessoa.dadosPessoais.celular"></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h4>Endere\xE7o</h4></div><div class="ibox-content"><div class="form-group"><div class="col-md-2"><label translate="nfseApp.endereco.cep" for="field_cep">Cep</label><input type="text" class="form-control" name="id" id="field_cep" ui-br-cep-mask ng-blur="loadEnderecoByCEP(prestadorServicos.pessoa.dadosPessoais.cep)" ng-model="prestadorServicos.pessoa.dadosPessoais.endereco.cep" required><div ng-show="editForm.cep.$invalid"><p class="help-block" ng-show="editForm.cep.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-2"><label for="field_codigo_municipio">Munic\xEDpio</label><div class="input-group"><input type="text" class="form-control" name="municioio" id="field_codigo_municipio" ng-blur="loadMunicipioByCodigo(prestadorServicos.pessoa.dadosPessoais.municipio.codigo)" ng-model="prestadorServicos.pessoa.dadosPessoais.endereco.municipio.codigo" required> <span class="input-group-btn"><button type="button" class="btn" ng-click="searchMunicipio()"><span class="glyphicon glyphicon-search"></span></button></span></div><div ng-show="editForm.municipio.$invalid"><p class="help-block" ng-show="editForm.municipio.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-6"><label for="field_nome_municipio">Nome</label><input type="text" class="form-control" name="nome_municipio" id="field_nome_municipio" disabled="disabled" ng-model="prestadorServicos.pessoa.dadosPessoais.municipio.nome"></div><div class="col-md-2"><label for="field_estado_municipio">Estado</label><input type="text" class="form-control" name="estado_municipio" id="field_estado_municipio" disabled="disabled" ng-model="prestadorServicos.pessoa.dadosPessoais.municipio.estado"></div></div><div class="form-group"><div class="col-md-12"><label translate="nfseApp.logradouro" for="field_logradouro">Logradouro</label><input type="text" class="form-control" name="logradouro" id="field_logradouro" ng-model="prestadorServicos.pessoa.dadosPessoais.logradouro" required><div ng-show="editForm.logradouro.$invalid"><p class="help-block" ng-show="editForm.logradouro.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group"><div class="col-md-6"><label translate="nfseApp.bairro" for="field_bairro">Bairro</label><input type="text" class="form-control" name="bairro" id="field_bairro" ng-model="prestadorServicos.pessoa.dadosPessoais.bairro"></div><div class="col-md-2"><label translate="nfseApp.numero" for="field_numero">Numero</label><input type="text" class="form-control" name="numero" id="field_numero" ng-model="prestadorServicos.pessoa.dadosPessoais.numero" required><div ng-show="editForm.numero.$invalid"><p class="help-block" ng-show="editForm.numero.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-4"><label translate="nfseApp.complemento" for="field_complemento">Complemento</label><input type="text" class="form-control" name="complemento" id="field_complemento" ng-model="prestadorServicos.pessoa.dadosPessoais.complemento"></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h4>Socios</h4></div><div class="ibox-content"><div class="form-group"><div class="col-md-2"><label class="center-block">CPF/CNPJ</label></div><div class="col-md-7"><label class="center-block">Nome</label></div><div class="col-md-3"><label class="center-block">Percentual</label></div></div><div class="form-group" data-ng-repeat="socio in prestadorServicos.socios" ng-form="socioForm" class="animated fadeInDown"><div class="col-md-2" ng-class="{\'has-error\' : socioForm.socio_cpfCnpj.$invalid\n                              && (socioForm.$submitted || socioForm.socio_cpfCnpj.$touched)}"><input type="text" class="form-control" name="socio_cpfCnpj" id="field_socio_cpfCnpj" ui-br-cpfcnpj-mask="" required ng-disabled="socio.pessoa.id" ng-blur="loadByCpfCnpjSocio(socio.pessoa.dadosPessoais.cpfCnpj, socio)" ng-model="socio.pessoa.dadosPessoais.cpfCnpj"><div ng-show="socioForm.socio_cpfCnpj.$invalid"><p class="help-block" ng-show="socioForm.socio_cpfCnpj.$error.required">Informe o CPF ou CNPJ do s\xF3cio</p><p class="help-block" ng-show="socioForm.socio_cpfCnpj.$error.cpf || socioForm.socio_cpfCnpj.$error.cnpj">CPF ou CNPJ inv\xE1lido</p></div></div><div class="col-md-7" ng-class="{\'has-error\' : socioForm.socio_nome.$invalid\n                              && (socioForm.$submitted || socioForm.socio_nome.$touched)}"><input type="text" class="form-control" name="socio_nome" id="field_socio_nome" required ng-disabled="socio.pessoa.id" ng-model="socio.pessoa.dadosPessoais.nomeRazaoSocial"><div ng-show="socioForm.socio_nome.$invalid"><p class="help-block" ng-show="socioForm.socio_nome.$error.required">Informe o nome do s\xF3cio</p></div></div><div class="col-md-3" ng-class="{\'has-error\' : socioForm.socio_proporcao.$invalid\n                              && (socioForm.$submitted || socioForm.socio_proporcao.$touched)}"><div class="input-group"><input type="text" class="form-control" name="socio_proporcao" ui-percentage-mask ui-percentage-value required id="field_socio_proporcao" ng-model="socio.proporcao"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-show="$index + 1 == prestadorServicos.socios.length" ng-click="addSocio()" id="btn_add_socio"><i class="fa fa-arrow-down"></i></button> <button type="button" class="btn btn-danger" ng-click="removeSocio($index)" id="btn_remove_socio"><i class="fa fa-trash"></i></button></span></div><div ng-show="socioForm.socio_proporcao.$invalid"><p class="help-block" ng-show="socioForm.socio_proporcao.$error.required">Informe o percentual do s\xF3cio</p></div></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-title"><h4>Situa\xE7\xE3o Tribut\xE1ria</h4></div><div class="ibox-content"><div class="form-group"><div class="col-md-3"><label for="dataCredenciamento" class="control-label">Data de Credenciamento</label><date-input id="dataCredenciamento" ng-model="prestadorServicos.credenciadoEm"></div></div><div ng-show="mostraSituacao" class="animated fadeInDown"><div class="form-group"><div class="col-md-3" ng-class="{\'has-error\' : !situacao.tipoISS && (editForm.$submitted || editForm.tipoISS.$touched)}"><label class="control-label" for="field_tipoISS">Tipo de ISS</label><select class="form-control" name="tipoISS" ng-model="situacao.tipoISS" id="field_tipoISS"><option value="HOMOLOGADO">Mensal (Homologado)</option><option value="FIXO">Fixo (Anual)</option><option value="ESTIMADO">Estimado</option></select><div ng-show="!situacao.tipoISS"><p class="help-block" translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-2"><label for="field_simplesNacional">Simples Nacional</label><div class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="ativo" ng-model="situacao.optanteSimplesNacional" class="onoffswitch-checkbox" id="field_simplesNacional"><label class="onoffswitch-label" for="field_simplesNacional"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-md-1"><label for="field_imune">Imune</label><div class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="ativo" ng-model="situacao.imune" class="onoffswitch-checkbox" id="field_imune"><label class="onoffswitch-label" for="field_imune"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="col-md-6"><label for="field_Regime">Regime Especial de Tributa\xE7\xE3o</label><select class="form-control" name="regimeEspecial" ng-model="situacao.regimeEspecialTributacao" id="field_Regime"><option value="{{null}}"></option><option value="MICROEMPRESA_MUNICIPAL">Microempresa Municipal</option><option value="ESTIMATIVA">Estimativa</option><option value="SOCIEDADE_PROFISSIONAIS">Sociedade de Profissionais</option><option value="MICROEMPRESARIO_INDIVIDUAL">Microempres\xE1rio Individual (MEI)</option><option value="MICROEMPRES\xC1RIO_EMPRESA_PEQUENO_PORTE">Microempres\xE1rio e Empresa de Pequeno Porte (ME EPP)</option></select></div></div><div class="form-group"><div class="col-md-3" ng-class="{\'has-error\' : !situacao.inicioVigencia && (editForm.$submitted || editForm.inicioVigenciaSituacao.$touched)}"><label class="control-label" for="inicioVigenciaSituacao">In\xEDcio</label><date-input type="text" ng-model="situacao.inicioVigencia" id="inicioVigenciaSituacao" name="inicioVigenciaSituacao"></date-input><div ng-show="!situacao.inicioVigencia"><p class="help-block" translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-3"><label for="field_finalVigencia">Fim</label><date-input type="text" ng-model="situacao.finalVigencia" id="field_finalVigencia" name="field_finalVigencia"></date-input></div><div class="col-md-6"><label for="embasamentoLegal">Embasamento Legal</label><textarea type="text" class="form-control" name="embasamentoLegal" id="embasamentoLegal" ng-model="situacao.embasamentoLegal">\n                            </div>\n                        </div>\n                        <div class="form-group">\n                            <div class="col-md-3">\n                                <label for="btn_addSituacao">&nbsp;</label>\n                                <button class="btn btn-info btn-block" type="button" ng-disabled="!situacao.tipoISS || !situacao.inicioVigencia" ng-click="addSituacao()" id="btn_addSituacao">\n                                    <i class="fa fa-save"></i>\n                                    Adicionar Situa\xE7\xE3o\n                                </button>\n                            </div>\n                            <div class="col-md-3">\n                                <label for="btn_LimpaCamposSituacao">&nbsp;</label>\n                                <button class="btn btn-danger btn-block" type="button" ng-click="limparSituacao()" id="btn_LimpaCamposSituacao">\n                                    <i class="fa fa-trash-o"></i>\n                                    Cancelar Lan\xE7amento\n                                </button>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-show="!mostraSituacao">\n                        <button class="btn btn-info btn-block btn-outline" type="button" ng-click="mostraSituacao = true" id="btn_novaSituacao">\n                            <i class="fa fa-plus-circle"></i>\n                            Informar uma nova Situa\xE7\xE3o\n                        </button>\n                    </div>\n                    <div class="form-group text-center" ng-show="prestadorServicos.situacoesTributaria.length == 0 ">\n                        <div class="text-danger">\n                            <strong>Aten\xE7\xE3o!</strong> Adicione ao menos uma Situa\xE7\xE3o Tribut\xE1ria para salvar o prestador\n                        </div>\n                    </div>\n                    <div class="form-group animated fadeInUp" ng-show="prestadorServicos.situacoesTributaria.length > 0 ">\n                        <table class="table table-striped">\n                            <thead>\n                            <tr>\n                                <th>Tipo de ISS</th>\n                                <th>Simples</th>\n                                <th>Regime Especial</th>\n                                <th>Inicio</th>\n                                <th>Fim</th>\n                                <th></th>\n                            </tr>\n                            </thead>\n                            <tbody>\n                            <tr ng-repeat="situacao in prestadorServicos.situacoesTributaria">\n                                <td>{{TIPO_ISS[situacao.tipoISS].descricao}}</td>\n                                <td>{{situacao.optanteSimplesNacional == true ? \'Sim\' : \'N\xE3o\'}}</td>\n                                <td>{{REGIME_TRIBUTACAO[situacao.regimeEspecialTributacao].descricao}}</td>\n                                <td>{{situacao.inicioVigencia | date : \'dd/MM/yyyy\'}}</td>\n                                <td>{{situacao.finalVigencia | date : \'dd/MM/yyyy\'}}</td>\n                                <td>\n                                        <span ng-show="situacao.vigente == true">\n                                             <i class="fa fa-circle text-navy"></i>\n                                        </span>\n\n                                    <div class="pull-right">\n\n                                        <button type="button" ng-click="removeSituacao(index)" class="btn btn-danger btn-sm">\n                                            <span class="glyphicon glyphicon-trash"></span>\n                                        </button>\n                                        <button type="button" ng-click="editarSituacao($index)" class="btn btn-info btn-sm">\n                                            <span class="glyphicon glyphicon-pencil"></span>\n                                        </button>\n                                    </div>\n\n                                </td>\n                            </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n            </div>\n\n            <div class="ibox float-e-margins">\n                <div class="ibox-title">\n                    <h4>Servi\xE7os</h4>\n                </div>\n                <div class="ibox-content">\n                    <div class="form-group">\n                        <div class="col-md-2">\n                            <label class="center-block">C\xF3digo</label>\n                        </div>\n                        <div class="col-md-2">\n                            <label class="center-block">Aliquota</label>\n                        </div>\n                        <div class="col-md-8">\n                            <label class="center-block">Descri\xE7\xE3o</label>\n                        </div>\n                    </div>\n                    <div class="form-group" data-ng-repeat="servico in prestadorServicos.servicos" class="animated fadeInDown">\n                        <div class="col-md-2">\n                            <div class="input-group">\n                                <input type="text" class="form-control" name="servico_codigo" id="field_servico_codigo" ng-blur="loadServicoByCodigo(servico.servico.codigo, $index)" ng-model="servico.servico.codigo">\n                                        <span class="input-group-btn">\n                                            <button type="button" class="btn" ng-click="searchServico($index)">\n                                                <span class="glyphicon glyphicon-search"></span>\n                                            </button>\n                                        </span>\n                            </div>\n                        </div>\n                        <div class="col-md-2">\n                            <input type="text" class="form-control" name="servico_aliquota" id="field_servico_aliquota" ng-model="servico.servico.aliquota" disabled="disabled">\n                        </div>\n                        <div class="col-md-8">\n                            <div class="input-group">\n                                <input type="text" class="form-control" name="servico_descricao" id="field_servico_descricao" disabled="disabled" ng-model="servico.servico.descricao">\n                                                        <span class="input-group-btn">\n                                                             <button type="button" class="btn btn-info" ng-show="$index + 1 == prestadorServicos.servicos.length" ng-click="addServico()" id="btn_add_servico">\n                                                                 <i class="fa fa-arrow-down"></i>\n                                                             </button>\n\n                                                             <button type="button" class="btn btn-danger" ng-click="removeServico($index)" id="btn_remove_servico">\n                                                                 <i class="fa fa-trash"></i>\n                                                             </button>\n                                                        </span>\n                            </div>\n                        </div>\n                    </div>\n\n                </div>\n            </div>\n            <div class="ibox float-e-margins">\n                <div class="ibox-title">\n                    <h4>Isen\xE7\xF5es</h4>\n                </div>\n                <div class="ibox-content">\n                    <div ng-show="mostraIsencao" class="animated fadeInDown">\n                        <div class="form-group">\n                            <div class="col-md-12" ng-class="{\'has-error\' : !isencao.servico && (editForm.$submitted || editForm.isencaoServico.$touched)}">\n                                <label for="isencaoServico">Servico a ser isento</label>\n                                <select class="form-control" ng-options="serv.servico as serv.servico.descricao for serv in\n                                     prestadorServicos.servicos track by serv.servico.id" id="isencaoServico" name="isencaoServico" ng-model="isencao.servico">\n                                </select>\n\n                                <div ng-show="!isencao.servico">\n                                    <p class="help-block" translate="entity.validation.required">\n                                        This field is required.\n                                    </p>\n                                </div>\n                            </div>\n                        </div>\n                        <div class="form-group">\n                            <div class="col-md-3" ng-class="{\'has-error\' : !isencao.inicioVigencia && (editForm.$submitted || editForm.inicioVigenciaIsencao.$touched)}">\n                                <label class="control-label" for="inicioVigenciaSituacao">Inicio</label>\n                                <date-input type="text" ng-model="isencao.inicioVigencia" id="inicioVigenciaIsencao" name="inicioVigenciaIsencao">\n                                </date-input>\n\n                                <div ng-show="!isencao.inicioVigencia">\n                                    <p class="help-block" translate="entity.validation.required">\n                                        This field is required.\n                                    </p>\n                                </div>\n                            </div>\n\n                            <div class="col-md-3">\n                                <label for="finalVigenciaIsencao">Fim</label>\n                                <date-input type="text" ng-model="isencao.finalVigencia" id="finalVigenciaIsencao" name="finalVigenciaIsencao">\n                                </date-input>\n                            </div>\n                            <div class="col-md-6">\n                                <label for="embasamentoLegalIsencao">Embasamento Legal</label>\n                                 <textarea type="text" class="form-control" name="embasamentoLegalIsencao" id="embasamentoLegalIsencao" ng-model="isencao.embasamentoLegal">\n                            </div>\n                        </div>\n                        <div class="form-group">\n                            <div class="col-md-3">\n                                <label for="btn_addIsencao">&nbsp;</label>\n                                <button class="btn btn-info btn-block" type="button" ng-disabled="!isencao.inicioVigencia" ng-click="addIsencao()" id="btn_addIsencao">\n                                    <i class="fa fa-save"></i>\n                                    Adicionar Isen\xE7\xE3o\n                                </button>\n                            </div>\n                            <div class="col-md-3">\n                                <label for="btn_LimpaCamposIsencao">&nbsp;</label>\n                                <button class="btn btn-danger btn-block" type="button" ng-click="limparIsencao()" id="btn_LimpaCamposIsencao">\n                                    <i class="fa fa-trash-o"></i>\n                                    Cancelar Lan\xE7amento\n                                </button>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-show="!mostraIsencao">\n                        <button class="btn btn-info btn-block btn-outline" type="button" ng-click="mostraIsencao = true" id="btn_novaIsencao">\n                            <i class="fa fa-plus-circle"></i>\n                            Informar uma nova Isen\xE7\xE3o\n                        </button>\n                    </div>\n                    <div class="form-group" ng-show="prestadorServicos.isencoes.length > 0 ">\n                        <table class="table table-striped">\n                            <thead>\n                            <tr>\n                                <th>Servi\xE7o</th>\n                                <th>Inicio</th>\n                                <th>Fim</th>\n                                <th></th>\n                            </tr>\n                            </thead>\n                            <tbody>\n                            <tr ng-repeat="isencao in prestadorServicos.isencoes">\n                                <td>{{isencao.servico.descricao}}</td>\n                                <td>{{isencao.inicioVigencia | date : \'dd/MM/yyyy\'}}</td>\n                                <td>{{isencao.finalVigencia | date : \'dd/MM/yyyy\'}}</td>\n                                <td>\n                                    <span ng-show="isencao.vigente == true">\n                                             <i class="fa fa-circle text-navy"></i>\n                                        </span>\n\n                                    <div class="pull-right">\n\n                                        <button type="button" ng-click="removeIsencao(index)" class="btn btn-danger btn-sm">\n                                            <span class="glyphicon glyphicon-trash"></span>\n                                        </button>\n                                        <button type="button" ng-click="editarIsencao($index)" class="btn btn-info btn-sm">\n                                            <span class="glyphicon glyphicon-pencil"></span>\n                                        </button>\n                                    </div>\n\n                                </td>\n                            </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n            </div>\n            <div class="ibox float-e-margins">\n                <div class="ibox-title">\n                    <h4>Suspens\xF5es</h4>\n                </div>\n                <div class="ibox-content">\n                    <div ng-show="mostraSuspensao" class="animated fadeInDown">\n                        <div class="form-group">\n                            <div class="col-md-12" ng-class="{\'has-error\' : !suspensao.servico && (editForm.$submitted || editForm.suspensaoServico.$touched)}">\n                                <label for="suspensaoServico">Servi\xE7o a ser suspenso</label>\n                                <select class="form-control" ng-options="serv.servico as serv.servico.descricao for serv in\n                                     prestadorServicos.servicos track by serv.servico.id" id="suspensaoServico" name="suspensaoServico" ng-model="suspensao.servico">\n                                </select>\n\n                                <div ng-show="!suspensao.servico">\n                                    <p class="help-block" translate="entity.validation.required">\n                                        This field is required.\n                                    </p>\n                                </div>\n                            </div>\n                        </div>\n                        <div class="form-group">\n                            <div class="col-md-3" ng-class="{\'has-error\' : !suspensao.inicioVigencia && (editForm.$submitted || editForm.inicioVigenciaSuspensao.$touched)}">\n                                <label class="control-label" for="inicioVigenciaSuspensao">In\xEDcio</label>\n                                <date-input type="text" ng-model="suspensao.inicioVigencia" id="inicioVigenciaSuspensao" name="inicioVigenciaSuspensao">\n                                </date-input>\n\n                                <div ng-show="!suspensao.inicioVigencia">\n                                    <p class="help-block" translate="entity.validation.required">\n                                        This field is required.\n                                    </p>\n                                </div>\n                            </div>\n\n                            <div class="col-md-3">\n                                <label for="finalVigenciaSuspensao">Fim</label>\n                                <date-input type="text" ng-model="isencao.finalSuspensao" id="finalVigenciaSuspensao" name="finalVigenciaSuspensao">\n                                </date-input>\n                            </div>\n                            <div class="col-md-3">\n                                <label class="control-label" for="field_tipoSuspensao">Tipo de Suspensao</label>\n                                <select class="form-control" name="tipoSuspensao" ng-model="suspensao.tipo" id="field_tipoSuspensao">\n                                    <option value="PROCESSO_ADMINISTRATIVO">Processo Administrativo</option>\n                                    <option value="DECISAO_JUDICIAL">Decis\xE3o Judicial</option>\n                                </select>\n                            </div>\n                            <div class="col-md-3">\n                                <label class="control-label" for="field_numeroProcessoSuspensao">N\xFAmero do Processo</label>\n\n                                <input type="text" class="form-control" name="numeroProcessoSuspensao" id="field_numeroProcessoSuspensao" ng-model="suspensao.numeroProcesso">\n                            </div>\n                        </div>\n                        <div class="form-group">\n                            <div class="col-md-12">\n                                <label for="embasamentoLegalSuspensao">Embasamento Legal</label>\n                                 <textarea type="text" class="form-control" name="embasamentoLegalSuspensao" id="embasamentoLegalSuspensao" ng-model="suspensao.embasamentoLegal">\n                            </div>\n                        </div>\n                        <div class="form-group">\n                            <div class="col-md-3">\n                                <label for="btn_addSuspensao">&nbsp;</label>\n                                <button class="btn btn-info btn-block" type="button" ng-disabled="!suspensao.inicioVigencia" ng-click="addSuspensao()" id="btn_addSuspensao">\n                                    <i class="fa fa-save"></i>\n                                    Adicionar Suspensao\n                                </button>\n                            </div>\n                            <div class="col-md-3">\n                                <label for="btn_LimpaCamposSuspensao">&nbsp;</label>\n                                <button class="btn btn-danger btn-block" type="button" ng-click="limparSuspensao()" id="btn_LimpaCamposSuspensao">\n                                    <i class="fa fa-trash-o"></i>\n                                    Cancelar Lan\xE7amento\n                                </button>\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-show="!mostraSuspensao">\n                        <button class="btn btn-info btn-block btn-outline" type="button" ng-click="mostraSuspensao = true" id="btn_novaSuspensao">\n                            <i class="fa fa-plus-circle"></i>\n                            Informar uma nova Suspens\xE3o\n                        </button>\n                    </div>\n                    <div class="form-group" ng-show="prestadorServicos.suspensoes.length > 0 ">\n                        <table class="table table-striped">\n                            <thead>\n                            <tr>\n                                <th>Servi\xE7o</th>\n                                <th>Tipo</th>\n                                <th>Numero do Processo</th>\n                                <th>Inicio</th>\n                                <th>Fim</th>\n                                <th></th>\n                            </tr>\n                            </thead>\n                            <tbody>\n                            <tr ng-repeat="suspensao in prestadorServicos.suspensoes">\n                                <td>{{suspensao.servico.descricao}}</td>\n                                <td>{{TIPO_PROCESSO[suspensao.tipo].descricao}}</td>\n                                <td>{{suspensao.numeroProcesso}}</td>\n                                <td>{{suspensao.inicioVigencia | date : \'dd/MM/yyyy\'}}</td>\n                                <td>{{suspensao.finalVigencia | date : \'dd/MM/yyyy\'}}</td>\n                                <td>\n                                    <span ng-show="suspensao.vigente == true">\n                                             <i class="fa fa-circle text-navy"></i>\n                                        </span>\n\n                                    <div class="pull-right">\n\n                                        <button type="button" ng-click="removeSuspensao(index)" class="btn btn-danger btn-sm">\n                                            <span class="glyphicon glyphicon-trash"></span>\n                                        </button>\n                                        <button type="button" ng-click="editarSuspensao($index)" class="btn btn-info btn-sm">\n                                            <span class="glyphicon glyphicon-pencil"></span>\n                                        </button>\n                                    </div>\n\n                                </td>\n                            </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n            </div>\n\n            <div class="ibox float-e-margins">\n                <div class="ibox-title">\n                    <h4>Usu\xE1rios</h4>\n                </div>\n                <div class="ibox-content">\n                    <div>\n                        <button class="btn btn-info btn-block btn-outline" type="button" ng-click="searchUser()" id="btn_novoUser">\n                            <i class="fa fa-plus-circle"></i>\n                            Informar um novo Usu\xE1rio\n                        </button>\n                    </div>\n\n                    <table class="table table-striped">\n                        <thead>\n                        <tr>\n                            <th>Login</th>\n                        </tr>\n                        </thead>\n                        <tbody>\n                        <tr ng-repeat="usuario in prestadorServicos.usuarios">\n                            <td>{{usuario.usuario.nomeRazao ? usuario.usuario.nomeRazao : usuario.usuario.login}}</td>\n                            <td>\n                                <button type="button" ng-click="removeUsuario(index)" class="btn btn-danger btn-sm pull-right">\n                                    <span class="glyphicon glyphicon-trash"></span>\n                                </button>\n                            </td>\n                        </tr>\n                        </tbody>\n                    </table>\n                </div>\n            </div>\n            <div class="form-actions">\n                <button type="button" class="btn btn-default" ui-sref="prestadorServicos">\n                    <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span>\n                </button>\n                <button type="submit" ng-disabled="editForm.$invalid\n                        || !$scope.prestadorServicos.situacoesTributaria && $scope.prestadorServicos.situacoesTributaria == 0" class="btn btn-primary">\n                    <span class="glyphicon glyphicon-save"></span>\n                    &nbsp;\n                    <span translate="entity.action.save">Save</span></button></div></div></form></div>');
$templateCache.put('app/entities/prestadorServicos/prestadorServicoss.html','<div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><span translate="nfseApp.prestadorServicos.home.title">Form</span></div><div class="ibox-content"><div class="row"><div class="col-md-8"><search-box ng-model="searchQuery" search-method="search()"></search-box></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th>ID</th><th>Nome ou Raz\xE3o Social</th><th>Cpf ou Cnpj</th><th></th></tr></thead><tbody><tr ng-repeat="prestadorServicos in prestadorServicoss"><td><a ui-sref="prestadorServicos.detail({id:prestadorServicos.id})">{{prestadorServicos.id}}</a></td><td>{{prestadorServicos.pessoa.dadosPessoais.nomeRazaoSocial}}</td><td>{{prestadorServicos.pessoa.dadosPessoais.cpfCnpj}}</td><td><div class="pull-right"><button type="submit" ui-sref="prestadorServicos.detail({id:prestadorServicos.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button></div></td></tr></tbody></table><nav><ul class="pager"><li ng-show="links[\'first\']" ng-click="loadPage(links[\'first\'])"><a href="#">&lt;&lt;</a></li><li ng-show="links[\'prev\']" ng-click="loadPage(links[\'prev\'])"><a href="#">&lt;</a></li><li ng-show="links[\'next\']" ng-click="loadPage(links[\'next\'])"><a href="#">&gt;</a></li><li ng-show="links[\'last\']" ng-click="loadPage(links[\'last\'])"><a href="#">&gt;&gt;</a></li></ul></nav></div></div></div></div></div>');
$templateCache.put('app/entities/prestadorServicos/servicoPrestador-search.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title" id="myServicoLabel" translate="nfseApp.servico.home.title">Create or edit a Servico</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><search-box ng-model="searchQuery" search-method="search()"></search-box></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Codigo</th><th>Descricao</th><th>Aliquota</th><th></th></tr></thead><tbody><tr ng-repeat="servico in servicos"><td>{{servico.codigo}}</td><td>{{servico.descricao}}</td><td>{{servico.aliquota}}</td><td class="pull-right"><button type="submit" ng-click="ok(servico)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-check"></span></button></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/produto-servico/produto-servico-search.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title">Pesquisa Produto/Servi\xE7o</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><div class="panel panel-default"><div class="panel-heading">Op\xE7\xF5es de Filtros</div><div class="panel-body"><div class="row"><div class="col-md-12"><div class="form-group col-md-2"><label>C\xF3digo</label><input class="form-control" ng-model="filtro.codigo"></div><div class="form-group col-md-10"><label>Descri\xE7\xE3o</label><input class="form-control" ng-model="filtro.descricao"></div></div></div><div class="row"><div class="col-md-12"><div class="col-md-6"><button class="btn btn-primary" ng-click="loadAll()"><span class="fa fa-search"></span> <span>Pesquisar</span></button> <button class="btn btn-default" ng-click="filtro = {}"><span class="fa fa-close"></span> <span>Limpar Filtros</span></button></div></div></div></div></div></div></div><div class="row m-t-md"><div class="col-md-12"><span nfse-app-pagination></span><div class="table-responsive"><table class="table table-striped small"><thead><tr><th class="col-md-2">C\xF3digo</th><th>Descri\xE7\xE3o</th><th></th></tr></thead><tbody><tr ng-repeat="registro in registros"><td class="col-md-2">{{registro.codigo}}</td><td>{{registro.descricao}}</td><td class="pull-right"><button type="submit" ng-click="ok(registro)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-check"></span></button></td></tr></tbody></table></div><span nfse-app-pagination></span></div></div></div>');
$templateCache.put('app/entities/relatorios/relatorioResumidoDetalhado.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title" id="myPaisesLabel">Tipo de Impress\xE3o do Relat\xF3rio</h4></div><div class="modal-body"><div class="row"><div class="col-md-6"><button type="button" class="btn btn-info btn-block" ng-click="resumido()"><i class="fa fa-print"></i> <span>Resumido</span></button></div><div class="col-md-6"><button type="button" class="btn btn-info btn-block" ng-click="detalhado()"><i class="fa fa-print"></i> <span>Detalhado</span></button></div></div></div>');
$templateCache.put('app/entities/rPS/autenticar-rps.html','<div class="row"><div class="col-lg-12"><h3 class="font-bold">Informe os dados abaixo e clique em Verificar</h3><p class="text-justify">O Recibo Provis\xF3rio de Servi\xE7os \u2013 RPS \xE9 o documento que dever\xE1 ser usado por emitentes da NFS-e na eventual impossibilidade de conex\xE3o imediata com o sistema para emiss\xE3o "on-line" da NFS-e. Neste caso, o prestador dever\xE1 substituir o RPS em NFS-e diretamente no sistema.<br>No caso da confirma\xE7\xE3o da substitui\xE7\xE3o, a NFS-e ser\xE1 exibida na tela, podendo ser impressa.</p></div><div class="col-lg-8"><form name="editForm" role="form" novalidate><div class="row m-t-sm"><div class="form-group" ng-class="{\'has-error\' : editForm.cpfCnpj.$invalid && (editForm.$submitted || editForm.cpfCnpj.$touched)}"><div class="col-md-12"><label class="control-label" for="field_cpfCnpj">CPF/CNPJ do Prestador (Emitente da RPS)</label><input type="text" class="form-control" name="cpfCnpj" id="field_cpfCnpj" ui-br-cpfcnpj-mask ng-model="autenticar.cpfCnpj" required><div ng-show="editForm.cpfCnpj.$invalid"><p class="help-block" ng-show="editForm.cpfCnpj.$error.required">Informe o CPF ou CNPJ do prestador de servi\xE7os</p><p class="help-block" ng-show="editForm.cpfCnpj.$error.cpf || editForm.cpfCnpj.$error.cnpj">CPF ou CNPJ inv\xE1lido</p></div></div></div></div><div class="row m-t-sm"><div class="form-group"><div class="col-md-12"><label for="field_numero_nota">N\xFAmero do RPS</label><input type="number" class="form-control" name="numeroNota" id="field_numero_nota" required ng-maxlength="7" ng-model="autenticar.numero"><div ng-show="editForm.numeroNota.$invalid"><p class="help-block" ng-show="editForm.numeroNota.$error">Informe o n\xFAmero do documento com o m\xE1ximo de 7 caracteres</p></div></div></div></div><div class="row m-t-sm"><div class="form-group"><div class="col-md-12"><label for="field_serie">S\xE9rie, se houver</label><input type="text" class="form-control" name="serie" id="field_serie" ng-maxlength="70" ng-model="autenticar.serie"><div ng-show="editForm.serie.$invalid"><p class="serie" ng-show="editForm.codigoAutenticacao.$error">Informe a s\xE9rie do documento com o m\xE1ximo de 70 caracteres</p></div></div></div></div><div class="row m-t-sm"><div class="form-group"><div class="col-md-12"><button type="submit" ng-disabled="editForm.$invalid" ng-click="autenticarRps()" class="btn btn-success"><span class="glyphicon glyphicon-check"></span>&nbsp; <span>Autenticar</span></button> <button type="button" ng-click="limpar()" class="btn btn-default"><span class="fa fa-times"></span>&nbsp; <span>Limpar</span></button></div></div></div></form></div><div class="col-lg-4"><div class="widget {{rps.idNotaFiscal ? \'navy-bg\': \'yellow-bg\'}} p-lg text-center" ng-if="valido === true"><div class="m-b-md"><i class="fa fa-thumbs-up fa-4x"></i><h1 class="m-xs">RPS V\xE1lido</h1><h3 ng-if="!rps.idNotaFiscal">Por\xE9m ainda n\xE3o foi substitu\xEDdo por uma Nota Fiscal</h3><h3 ng-if="rps.idNotaFiscal" ng-click="imprimirNota(rps.idNotaFiscal)" class="font-bold no-margins"><i class="fa fa-print"></i> Imprimir</h3></div></div><div class="widget red-bg p-lg text-center" ng-if="valido === false"><div class="m-b-md"><i class="fa fa-exclamation-triangle fa-4x"></i><h3 class="font-bold no-margins">RPS Inv\xE1lido</h3><small>N\xE3o foi encontrado nenhum RPS com os campos informados</small></div></div></div></div>');
$templateCache.put('app/entities/rPS/rPS-detail.html','<form class="form-horizontal" name="editForm" role="form" novalidate><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-md-12"><div class="row"><div class="col-md-12 m-t-md border-bottom"><h3>Dados do RPS</h3></div></div><div class="form-group"><div class="col-md-1"><small>N\xFAmero</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.numero}}"></div><div class="col-md-2"><small>Compet\xEAncia</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.competencia|date:\'MM/yyyy\'}}"></div><div class="col-md-2"><small>Emiss\xE3o</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.dataEmissao|date:\'dd/MM/yyyy HH:mm\'}}"></div><div class="col-md-1"><small>ISS Retido</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.issRetido ? \'Sim\': \'Nao\'}}"></div></div><div ng-show="rPS.modalidade != \'NAO_IDENTIFICADO\'"><div class="row"><div class="col-md-12 m-t-md border-bottom"><h3>Tomador do Servi\xE7o</h3></div></div><div class="form-group"><div class="col-md-3"><small>CPF ou CNPJ</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.dadosPessoaisTomador.cpfCnpj |\n                    brCpfCnpj}}"></div><div class="col-md-3"><small>Inscri\xE7\xE3o Municipal</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.dadosPessoaisTomador.inscricaoMunicipal}}"></div><div class="col-md-3"><small>Inscri\xE7\xE3o Estadual ou RG</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.dadosPessoaisTomador.inscricaoEstadualRg}}"></div><div class="col-md-3"><small>e-Mail</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.dadosPessoaisTomador.email}}"></div></div><div class="form-group"><div class="col-md-8"><small>Nome ou Raz\xE3o Social</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.dadosPessoaisTomador.nomeRazaoSocial}}"></div><div class="col-md-4"><small>Nome Fantasia</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.dadosPessoaisTomador.nomeFantasia}}"></div></div><div class="form-group"><div class="col-md-2"><small>Telefone</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.dadosPessoaisTomador.telefone}}"></div><div class="col-md-2"><small>Celular</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.dadosPessoaisTomador.celular\n                    }}"></div><div class="col-md-2"><small>Cep</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.dadosPessoaisTomador.cep |\n                    brCep}}"></div><div class="col-md-6"><small>Munic\xEDpio</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.dadosPessoaisTomador.municipio.nome}}\n                    {{rPS.dadosPessoaisTomador.municipio.estado}}"></div></div><div class="form-group"><div class="col-md-5"><small>Logradouro</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.dadosPessoaisTomador.logradouro}}"></div><div class="col-md-3"><small>Bairro</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.dadosPessoaisTomador.bairro}}"></div><div class="col-md-1"><small>N\xFAmero</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.dadosPessoaisTomador.numero}}"></div><div class="col-md-3"><small>Complemento</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.dadosPessoaisTomador.complemento}}"></div></div></div><div class="row"><div class="col-md-12 m-t-md border-bottom"><h3>Servi\xE7os</h3></div></div><div class="form-group"><div class="col-md-12"><table class="table"><thead><tr><th>C\xF3digo</th><th>Descri\xE7\xE3o</th><th>Al\xEDquota</th><th>Base de C\xE1lculo</th><th>Valor ISS</th></tr></thead><tbody><tr ng-repeat="serv in rPS.itens"><td>{{serv.servico.codigo}}</td><td>{{serv.nomeServico}}</td><td>{{serv.servico.aliquota}}</td><td>{{serv.baseCalculo | currency : \'R$ \'}}</td><td>{{serv.iss | currency : \'R$ \'}}</td></tr></tbody></table><div style="text-align: center" ng-show="rPS.itens.length == 0"><div class="help-block"><strong>Aten\xE7\xE3o!</strong> Adicione ao menos um servi\xE7o para salvar a Nota Fiscal</div></div></div></div><div class="row"><div class="col-md-12 m-t-md border-bottom"><h3>Tributos Federais</h3></div></div><div class="form-group"><div class="col-md-4"><small>PIS</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.tributosFederais.pis | currency:\'R$ \'}}"></div><div class="col-md-4"><small>COFINS</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.tributosFederais.cofins | currency:\'R$ \'}}"></div><div class="col-md-4"><small>INSS</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.tributosFederais.inss | currency:\'R$ \'}}"></div></div><div class="form-group"><div class="col-md-4"><small>IRRF</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.tributosFederais.irrf | currency:\'R$ \'}}"></div><div class="col-md-4"><small>CSLL</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.tributosFederais.csll | currency:\'R$ \'}}"></div><div class="col-md-4"><small>Outras Retencoes</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.tributosFederais.outrasRetencoes | currency:\'R$ \'}}"></div></div><div class="row"><div class="col-md-12 m-t-md border-bottom"><h3>Valores do RPS</h3></div></div><div class="form-group"><div class="col-md-3"><small>Total dos Servi\xE7os</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.totalServicos | finance:\'R$ \'}}"></div><div class="col-md-3"><small>Dedu\xE7\xF5es Legais</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.deducoesLegais | finance:\'R$ \'}}"></div><div class="col-md-3"><small>Descontos Incondicionados</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.descontosIncondicionais | finance:\'R$ \'}}"></div><div class="col-md-3"><small>Descontos Condicionados</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.descontosCondicionais | finance:\'R$ \'}}"></div></div><div class="form-group"><div class="col-md-3"><small>Reten\xE7\xF5es Federais</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.retencoesFederais | finance:\'R$ \'}}"></div><div class="col-md-3"><small>Base de C\xE1lculo</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.baseCalculo | finance:\'R$ \'}}"></div><div class="col-md-3"><small>Valor de ISS</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.issCalculado | finance:\'R$ \'}}"></div><div class="col-md-3"><small>Valor Liquido</small><br><input type="text" readonly="readonly" class="form-control" value="{{rPS.valorLiquido | finance:\'R$ \'}}"></div></div></div></div></div></div><button type="submit" ui-sref="rPS" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp; Voltar</button></form>');
$templateCache.put('app/entities/rPS/rPS-edit.html','<form name="editForm" role="form" novalidate ng-submit="save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="myRPSLabel" translate="nfseApp.rPS.home.createOrEditLabel">Create or edit a RPS</h4></div><div class="modal-body"><div class="form-group"><label translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="rPS.id" readonly="readonly"></div><div class="form-group"><label translate="nfseApp.rPS.numero" for="field_numero">Numero</label><input type="text" class="form-control" name="numero" id="field_numero" ng-model="rPS.numero"></div><div class="form-group"><label translate="nfseApp.rPS.serie" for="field_serie">Serie</label><input type="text" class="form-control" name="serie" id="field_serie" ng-model="rPS.serie"></div><div class="form-group"><label translate="nfseApp.rPS.dataEmissao" for="field_dataEmissao">DataEmissao</label><input type="date" class="form-control" name="dataEmissao" id="field_dataEmissao" ng-model="rPS.dataEmissao"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ui-sref="rPS"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/rPS/rPS-import.html','<div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><form name="editForm" role="form" novalidate><div class="form-group" ng-show="!arquivoSelecionado"><div class="col-md-8 col-md-offset-2 text-center"><label for="file-upload" class="custom-file-upload"><span class="fa fa-cloud-upload"></span> Selecionar Arquivo XML</label><input type="file" id="file-upload" name="file" ngf-select="uploadXmlFile($file)" ng-model="arquivo" ngf-max-size="15MB"></div></div><div ng-show="arquivoSelecionado"><div class="form-group col-md-12 border-bottom"><h3>Dados do Arquivo</h3></div><div class="form-group col-md-4"><label>Nome</label><input type="text" readonly="readonly" class="form-control" value="{{arquivoSelecionado.name}}"></div><div class="form-group col-md-4"><label>Tamanho</label><input type="text" readonly="readonly" class="form-control" value="{{arquivoSelecionado.size}}"></div><div class="form-group col-md-4"><label>Quantidade de RPS</label><input type="text" readonly="readonly" class="form-control" value="{{}}"></div><div class="form-group col-md-12"><button type="submit" class="btn btn-warning" ng-click="arquivoSelecionado = null"><span class="fa fa-times"></span>&nbsp;Cancelar</button> <button type="submit" class="btn btn-primary" ng-click="enviarArquivo()"><span class="glyphicon glyphicon-save"></span>&nbsp;Confirmar</button></div></div></form></div></div></div>');
$templateCache.put('app/entities/rPS/rPSs.html','<div class="row"><div class="col-lg-12"><div class="row m-b-md"><div class="col-md-10"><span ng-show="!filtrosSelecionados || filtrosSelecionados.length <= 0"><search-box ng-model="searchQuery" search-method="loadAll()"></search-box></span><span ng-show="filtrosSelecionados && filtrosSelecionados.length > 0"><h3>Filtros Personalizados</h3></span></div><div class="col-md-2"><button class="btn btn-primary pull-right" ui-sref="rPS.import"><span class="fa fa-cloud-upload"></span> Importar Arquivo</button></div></div><div ng-repeat="filtro in filtrosSelecionados track by $index" class="row float-e-margins"><div class="col-md-4"><div><select class="form-control" id="filtro_campos" name="filtros" ng-model="filtro.atributo" ng-options="filtroDisponivel as filtroDisponivel.descricao for filtroDisponivel in filtrosDisponiveis"></select></div></div><div class="col-md-2"><div><select class="form-control" id="filtro_peracao" name="oprecoes" ng-model="filtro.operacao" ng-options="operacao.value as operacao.nome for operacao in filtro.atributo.operacoes"></select></div></div><div class="col-md-6"><div class="form-group input-group"><input ng-show="filtro.atributo.tipo === \'decimal\'" type="number" class="form-control" ng-pattern="/^[0-9]+(\\.[0-9]{1,5})?$/" step="0.01" name="valorDecimal" ng-model="filtro.valorDecimal"> <input ng-show="filtro.atributo.tipo === \'inteiro\'" type="number" class="form-control" ng-model="filtro.valorInteiro" name="valorInteiro"> <input ng-show="filtro.atributo.tipo === \'texto\'" type="text" class="form-control" ng-model="filtro.valorTexto" name="valorTexto"><div ng-show="filtro.atributo.tipo === \'logico\'" class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="boolean" ng-model="filtro.valorLogico" class="onoffswitch-checkbox" id="field_boolean"><label class="onoffswitch-label" for="field_boolean"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span> <span class="onoffswitch-switch"></span></label></div></div><input ng-show="filtro.atributo.tipo === \'data\'" type="date" ng-model="filtro.valorData" class="form-control"> <span class="input-group-btn"><button ng-click="removerFiltro($index)" class="btn btn-danger"><span class="fa fa-trash"></span></button></span></div></div></div></div><div class="row m-b-md"><div class="col-md-10 text-center"><a ng-click="adicionarFiltro()"><span class="fa fa-plus"></span> Adicionar filtros</a></div><div class="col-md-2" ng-show="filtrosSelecionados.length> 0"><button ng-click="loadAll()" class="btn btn-success btn-block"><span class="fa fa-search"></span> <span>Filtrar</span></button></div></div><div class="table-responsive"><table class="table table-striped small"><thead><tr><th>Op\xE7\xF5es</th><th>N\xFAmero do RPS</th><th>S\xE9rie</th><th>Data de Emiss\xE3o</th><th>Valor Servi\xE7os</th><th>Valor ISS</th><th class="text-center">N\xFAmero Nfs-e</th><th class="text-center">N\xFAmero Lote</th></tr></thead><tbody><tr ng-repeat="rps in listaRps"><td class="dropdown"><button class="btn btn-white btn-sm dropdown-toggle" data-toggle="dropdown" type="button"><i class="fa fa-caret-down">Op\xE7\xF5es</button><ul class="dropdown-menu"><li><a type="submit" ui-sref="rPS.detail({id:rps.id})"><i class="fa fa-eye"></i> &ensp; Visualizar</a></li><li><a ng-click="delete(rps.id)"><i class="fa fa-trash"></i> &ensp; Remover</a></li><li><a ng-show="!rps.numeroNotaFiscal" ng-click="gerarNota(rps)" title="Clique aqui para emitir uma nova nota fiscal com os mesmos dados deste RPS"><i class="fa fa-file"></i> &ensp; Gerar Nota Fiscal</a></li></ul></td><td>{{rps.numero}}</td><td>{{rps.serie}}</td><td>{{rps.dataEmissao |date:\'dd/MM/yyyy\' }}</td><td>{{rps.totalServicos | currency: \'R$\'}}</td><td>{{rps.issPagar | currency: \'R$\'}}</td><td class="text-center"><a ui-sref="notaFiscal.detail({id:rps.idNotaFiscal})" ng-show="rps.numeroNotaFiscal" class="label label-info">{{rps.numeroNotaFiscal}} </a><a ng-click="gerarNota(rps)" ng-show="!rps.numeroNotaFiscal" class="label label-danger">N\xE3o Gerado</a></td><td class="text-center"><a ui-sref="loteRPS.detail({id: rps.idLote})">{{rps.numeroLote}}</a></td></tr></tbody></table><div class="col-md-12 text-right"><button class="btn btn-danger btn-outline" title="Clique para baixar as notas da tabela acima em formato de PDF" ng-click="baixarPDF()"><i class="fa fa-download"></i> PDF</button> <button class="btn btn-primary btn-outline" title="Clique para baixar as notas da tabela acima em formato de XLS" ng-click="baixarXls()"><i class="fa fa-download"></i> XLS</button></div><span nfse-app-pagination></div></div>');
$templateCache.put('app/entities/servico/servico-detail.html','<div><h2><span translate="nfseApp.servico.detail.title">Servico</span> {{servico.id}}</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span translate="nfseApp.servico.codigo">Codigo</span></td><td><input type="text" class="input-sm form-control" value="{{servico.codigo}}" readonly="readonly"></td></tr><tr><td><span translate="nfseApp.servico.descricao">Descricao</span></td><td><input type="text" class="input-sm form-control" value="{{servico.descricao}}" readonly="readonly"></td></tr><tr><td><span translate="nfseApp.servico.aliquota">Aliquota</span></td><td><input type="text" class="input-sm form-control" value="{{servico.aliquota}}" readonly="readonly"></td></tr><tr><td><span translate="nfseApp.servico.aliquotaIBPT">Aliquota IBPT</span></td><td><input type="text" class="input-sm form-control" ui-percentage-mask value="{{servico.aliquotaIBPT}}" readonly="readonly"></td></tr></tbody></table></div><button type="submit" ui-sref="servico" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/entities/servico/servico-dialog.html','<div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h4 class="modal-title" id="myServicoLabel" translate="nfseApp.servico.home.createOrEditLabel">Create or edit a Servico</h4></div><div class="ibox-content"><form name="editForm" role="form" novalidate ng-submit="save()"><div class="col-md-3"><div class="form-group"><label translate="nfseApp.servico.codigo" for="field_codigo">Codigo</label><input type="text" class="form-control" name="codigo" id="field_codigo" ng-model="servico.codigo"></div></div><div class="col-md-9"><div class="form-group"><label translate="nfseApp.servico.descricao" for="field_descricao">Descricao</label><input type="text" class="form-control" name="descricao" id="field_descricao" ng-model="servico.descricao"></div></div><!--<div class="form-group">--><div class="col-md-6"><div class="form-group"><label translate="nfseApp.servico.aliquota" for="field_aliquota">Aliquota</label><input type="text" class="form-control" name="aliquota" id="field_aliquota" ui-percentage-mask ui-percentage-value ng-model="servico.aliquota"></div></div><!--</div>--><!--<div class="form-group">--><div class="col-md-6"><div class="form-group"><label translate="nfseApp.servico.aliquotaIBPT" for="field_aliquotaIBPT">Aliquota IBPT</label><input type="text" class="form-control" name="aliquotaIBPT" id="field_aliquotaIBPT" ui-percentage-mask ui-percentage-value ng-model="servico.aliquotaIBPT"></div></div><!--</div>--><div class="col-md-12"><div class="form-group"><label translate="nfseApp.servico.cnae" for="field_cnae">cnae</label><select class="form-control" id="field_cnae" name="cnae" ng-model="servico.cnae" ng-options="cnae.codigo for cnae in cnaes track by cnae.id"></select></div></div><div class="form-actions"><button type="button" class="btn btn-default" ui-sref="servico"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form></div></div></div></div>');
$templateCache.put('app/entities/servico/servico-search.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title" id="myServicoLabel">Buscar um Servi\xE7o</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><search-box ng-model="searchQuery" search-method="search()"></search-box></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th>C\xF3digo</th><th>Descri\xE7\xE3o</th><th>Aliquota</th><th></th></tr></thead><tbody><tr ng-repeat="servico in servicos"><td>{{servico.codigo}}</td><td>{{servico.descricao}}</td><td>{{servico.aliquota}}</td><td class="pull-right"><button type="submit" ng-click="ok(servico)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-check"></span></button></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/servico/servicos.html','<div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><span>Servi\xE7os</span></div><div class="ibox-content"><div class="row"><div class="col-md-8"><search-box ng-model="searchQuery" search-method="search()"></search-box></div><div class="col-md-4"><button class="btn btn-primary pull-right" ui-sref="servico.new"><span class="fa fa-plus"></span> <span>Criar um novo Servi\xE7o</span></button></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th>ID</th><th>C\xF3digo</th><th>Descri\xE7\xE3o</th><th>Al\xEDquota</th><th>Al\xEDquota IBPT</th><th></th></tr></thead><tbody><tr ng-repeat="servico in servicos"><td><a ui-sref="servico.detail({id:servico.id})">{{servico.id}}</a></td><td>{{servico.codigo}}</td><td>{{servico.descricao}}</td><td>{{servico.aliquota}}</td><td>{{servico.aliquotaIBPT}}</td><td style="min-width: 15%"><div class="pull-right"><button type="submit" ui-sref="servico.detail({id:servico.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="servico.edit({id:servico.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ng-click="delete(servico.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table><nav><ul class="pager"><li ng-show="links[\'first\']" ng-click="loadPage(links[\'first\'])"><a href="#">&lt;&lt;</a></li><li ng-show="links[\'prev\']" ng-click="loadPage(links[\'prev\'])"><a href="#">&lt;</a></li><li ng-show="links[\'next\']" ng-click="loadPage(links[\'next\'])"><a href="#">&gt;</a></li><li ng-show="links[\'last\']" ng-click="loadPage(links[\'last\'])"><a href="#">&gt;&gt;</a></li></ul></nav></div></div></div></div></div>');
$templateCache.put('app/entities/servico-declarado/cancelamento-servico-declarado.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title" id="myServicoLabel">Cancelamento de Servi\xE7o Declarado</h4></div><div class="modal-body"><div class="row" ng-show="servicoDeclarado.declaracaoPrestacaoServico.cancelamento"><div class="col-md-12 text-center"><h3>J\xE1 existe uma solicita\xE7\xE3o de cancelamento para esse documento.</h3></div><div class="col-md-12"><table class="table"><tr><th>Data do Cancelamento</th><th>Solicitante</th><th>Motivo</th><th>Observa\xE7\xF5es</th><th>Situa\xE7\xE3o</th></tr><tr><td>{{servicoDeclarado.declaracaoPrestacaoServico.cancelamento.dataCancelamento | date: \'dd/MM/yyyy\'}}</td><td>{{servicoDeclarado.declaracaoPrestacaoServico.cancelamento.solicitante}}</td><td>{{\'nfseApp.MotivoCancelamento.\'+servicoDeclarado.declaracaoPrestacaoServico.cancelamento.motivoCancelamento | translate}}</td><td>{{servicoDeclarado.declaracaoPrestacaoServico.cancelamento.observacoesCancelamento}}</td><td>{{\'nfseApp.SituacaoDeferimento.\'+servicoDeclarado.declaracaoPrestacaoServico.cancelamento.situacaoFiscal | translate}}</td></tr></table></div></div><div class="row" ng-show="podeSolicitar"><form name="editForm" role="form" novalidate><div class="form-group col-md-12"><div class="col-md-2"><small>N\xB0 do Documento</small><br><strong>{{cancelamento.servicoDeclarado.numero}}</strong></div><div class="col-md-8"><small>Prestador do Servi\xE7o</small><br><strong ng-show="cancelamento.servicoDeclarado.dadosPessoaisPrestador">{{cancelamento.servicoDeclarado.dadosPessoaisPrestador.cpfCnpj}} - {{cancelamento.servicoDeclarado.dadosPessoaisPrestador.nomeRazaoSocial}}</strong></div><div class="col-md-2"><small>Total do Servi\xE7o</small><br><strong>{{cancelamento.servicoDeclarado.totalServicos | currency:\'R$ \'}}</strong></div></div><div class="form-group col-md-12"><div class="col-md-12"><label for="field_motivo">Motivo do cancelamento</label><select class="form-control" name="motivo" required ng-model="cancelamento.motivoCancelamento" id="field_motivo"><option value="ERRO_EMISSAO">Erro de emiss\xE3o</option><option value="SERVICO_NAO_PRESTADO">Servi\xE7o n\xE3o prestado</option><option value="DUPLICIDADE">Duplicidade de nota</option><option value="ERRO_ASSINATURA">Erro de assinatura</option><option value="ERRO_DADOS">Erro de dados na Emiss\xE3o</option></select><div ng-show="editForm.motivo.$invalid"><p class="help-block" ng-show="editForm.motivo.$error.required">Informe o Motivo</p></div></div></div><div class="form-group col-md-12"><div class="col-md-12"><label for="field_observacap">Observa\xE7\xF5es do cancelamento</label><textarea type="text" class="form-control" ng-maxlength="3000" name="observacao" id="field_observacap" ng-model="cancelamento.observacoesCancelamento">\n                    </textarea></div></div></form></div></div><div class="modal-footer" ng-show="podeSolicitar"><button type="submit" ng-click="cancelarServicoDeclarado()" ng-disabled="editForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-check"></span>&nbsp; <span>Cancelar Servi\xE7o Declarado</span></button></div>');
$templateCache.put('app/entities/servico-declarado/servico-declarado-detail.html','<div class="row"><div class="col-lg-12"><form name="editForm" role="form" novalidate><div class="ibox float-e-margins animated fadeInDown"><div class="ibox-content"><div class="row"><div class="col-md-12"><h3>Dados do Servi\xE7o {{servicoDeclarado.tipoServicoDeclarado == \'SERVICO_PRESTADO\' ? \'Prestado\' : \'Tomado\'}}</h3></div></div><div class="row m-t-sm"><div class="form-group"><div class="col-md-2"><label for="field_numero_nota">N\xFAmero</label><input type="number" class="form-control" name="numeroNota" id="field_numero_nota" readonly="readonly" ng-maxlength="7" ng-model="servicoDeclarado.numero"></div><div class="col-md-4"><label for="field_tipodoc">Tipo de Documento</label><input type="text" value="{{servicoDeclarado.tipoDocumentoServicoDeclarado.descricao}}" id="field_tipodoc" required readonly="readonly" class="form-control" name="tipodoc"><div ng-show="editForm.competencia.$invalid"><p class="help-block" ng-show="editForm.competencia.$error">Informe uma data de compet\xEAncia v\xE1lida</p></div></div><div class="col-md-3"><label for="field_competencia">Compet\xEAncia</label><input type="text" value="{{servicoDeclarado.competencia | date:\'MM/yyyy\'}}" id="field_competencia" required readonly="readonly" class="form-control" name="competencia"><div ng-show="editForm.competencia.$invalid"><p class="help-block" ng-show="editForm.competencia.$error">Informe uma data de compet\xEAncia v\xE1lida</p></div></div><div class="col-md-3"><label for="field_emissao">Emiss\xE3o</label><input type="text" value="{{servicoDeclarado.emissao | date:\'dd/MM/yyyy\'}}" id="field_emissao" required readonly="readonly" class="form-control" name="competencia"></div></div></div></div></div><div class="ibox float-e-margins animated fadeInDown"><div class="ibox-content" ng-show="servicoDeclarado.modalidade != \'NAO_IDENTIFICADO\'"><div class="row"><div class="col-md-12"><h3>{{servicoDeclarado.tipoServicoDeclarado == \'SERVICO_TOMADO\' ? \'Quem prestou o servi\xE7o?\' : \'Quem tomou o servi\xE7o\'}}</h3></div></div><div class="row"><div class="col-md-12"><div class="row animated fadeInDown" ng-show="servicoDeclarado.modalidade == \'IDENTIFICADO\'"><div class="form-group col-md-4"><label class="control-label" for="field_cpfCnpj">CPF ou CNPJ</label><input type="text" class="form-control" name="cpfCnpj" id="field_cpfCnpj" ui-br-cpfcnpj-mask readonly="readonly" ng-model="servicoDeclarado.dadosPessoais.cpfCnpj" required></div></div><div class="fadeInDown animated"><div class="row" ng-show="!isFisica()"><div class="form-group col-md-4"><label for="field_inscricaoMunicipal">Inscri\xE7\xE3o Municipal</label><input type="text" class="form-control" name="inscricaoMunicipal" id="field_inscricaoMunicipal" readonly="readonly" ng-model="servicoDeclarado.dadosPessoais.inscricaoMunicipal"></div><div class="form-group col-md-8"><label class="control-label" for="field_nomeFantasia">Nome Fantasia</label><input type="text" class="form-control" name="nomeFantasia" id="field_nomeFantasia" readonly="readonly" ng-model="servicoDeclarado.dadosPessoais.nomeFantasia"></div></div><div class="row"><div class="form-group col-md-4" ng-if="!isFisica()" ng-class="{\'has-error\' : editForm.inscricaoEstadual.$invalid && (editForm.$submitted || editForm.inscricaoEstadual.$touched)}"><label class="control-label" for="field_inscricaoEstadual">Inscri\xE7\xE3o Estadual</label><input type="text" class="form-control" name="inscricaoEstadual" id="field_inscricaoEstadual" readonly="readonly" ng-model="servicoDeclarado.dadosPessoais.inscricaoEstadualRg"></div><div class="form-group col-md-4" ng-if="isFisica() && notaFiscal.modalidade != \'SEM_CPF\'" ng-class="{\'has-error\' : editForm.rg.$invalid  && (editForm.$submitted || editForm.rg.$touched)}"><label class="control-label" for="field_rg">RG</label><input type="text" class="form-control" name="rg" id="field_rg" readonly="readonly" ng-model="servicoDeclarado.dadosPessoais.inscricaoEstadualRg"></div><div class="form-group {{isFisica() && notaFiscal.modalidade != \'SEM_CPF\' ? \'col-md-8\': \'col-md-8\'}}" ng-class="{\'has-error\' : editForm.nomeRazaoSocial.$invalid && (editForm.$submitted || editForm.nomeRazaoSocial.$touched)}"><label class="control-label" for="field_nomeRazaoSocial">{{isFisica() ? \'Nome \':\'Raz\xE3o Social\'}}</label><input type="text" class="form-control" name="nomeRazaoSocial" id="field_nomeRazaoSocial" readonly="readonly" ng-model="servicoDeclarado.dadosPessoais.nomeRazaoSocial" required></div></div><div class="row"><div class="form-group col-md-9"><label for="field_email">e-Mail</label><input type="text" class="form-control" name="email" id="field_email" readonly="readonly" ng-model="servicoDeclarado.dadosPessoais.email"></div><div class="form-group col-md-3"><label for="field_telefone">Telefone</label><input type="text" class="form-control" name="telefone" id="field_telefone" ui-br-phone-number readonly="readonly" ng-model="servicoDeclarado.dadosPessoais.telefone"></div></div><div class="row fadeInDown animated"><div class="form-group col-md-2"><label for="field_cep">Cep</label><input type="text" class="form-control" name="id" id="field_cep" ui-br-cep-mask readonly="readonly" ng-model="servicoDeclarado.dadosPessoais.cep"></div><div class="form-group col-md-8"><label for="field_nome_municipio">Munic\xEDpio</label><input type="text" class="form-control" name="nome_municipio" id="field_nome_municipio" disabled="disabled" readonly="readonly" ng-model="servicoDeclarado.dadosPessoais.municipio.nome"></div><div class="form-group col-md-2"><label for="field_estado_municipio">Estado</label><input type="text" class="form-control" name="estado_municipio" id="field_estado_municipio" disabled="disabled" readonly="readonly" ng-model="servicoDeclarado.dadosPessoais.municipio.estado"></div><div class="form-group col-md-12"><label for="field_logradouro">Logradouro</label><input type="text" class="form-control" name="logradouro" id="field_logradouro" readonly="readonly" ng-model="servicoDeclarado.dadosPessoais.logradouro"></div><div class="form-group col-md-6"><label for="field_bairro">Bairro</label><input type="text" class="form-control" readonly="readonly" name="bairro" id="field_bairro" ng-model="servicoDeclarado.dadosPessoais.bairro"></div><div class="form-group col-md-2"><label for="field_numero">N\xFAmero</label><input type="text" class="form-control" name="numero" id="field_numero" readonly="readonly" ng-model="servicoDeclarado.dadosPessoais.numero"></div><div class="form-group col-md-4"><label for="field_complemento">Complemento</label><input type="text" class="form-control" name="complemento" id="field_complemento" readonly="readonly" ng-model="servicoDeclarado.dadosPessoais.complemento"></div></div></div></div></div></div></div><div class="ibox float-e-margins animated fadeInDown"><div class="ibox-content"><div class="row"><div class="col-md-12"><h3>Qual o servi\xE7o prestado?</h3></div></div><div class="row m-t-md"><div class="form-group col-md-2"><label for="field_retencao">Reten\xE7\xE3o do ISSQN?</label><div class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="retencao" ng-change="verificarExigibilidadeIss()" ng-model="servicoDeclarado.issRetido" class="onoffswitch-checkbox" readonly="readonly" disabled="disabled" id="field_retencao"><label class="onoffswitch-label" for="field_retencao"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="form-group col-md-4"><label translate="nfseApp.declaracaoPrestacaoServico.naturezaOperacao" for="field_naturezaOperacao">NaturezaOperacao</label><select class="form-control" name="naturezaOperacao" ng-model="servicoDeclarado.naturezaOperacao" readonly="readonly" disabled="disabled" ng-change="selecionouServico()" id="field_naturezaOperacao"><option value="TRIBUTACAO_MUNICIPAL">Tributa\xE7\xE3o Municipal</option><option value="ISENCAO">Is\xEAn\xE7\xE3o</option><option value="IMUNIDADE">Imunidade</option><option value="EXIGIBILIDADE_SUSPENSA_DECISAO_JUDICIAL">Exigibilidade Suspensa por Decis\xE3o Judicial</option><option value="EXIGIBILIDADE_SUSPENSA_PROCESSO_ADMINISTRATIVO">Exigibilidade Suspensa por Processo Administrativo</option><option value="NAO_INCIDENCIA">N\xE3o Incid\xEAncia</option><option value="EXPORTACAO">Exporta\xE7\xE3o</option></select></div></div><div class="row"><div class="form-group col-md-12" ng-show="servicoDeclarado.itens.length > 0"><table class="table table-striped"><thead><tr><th>C\xF3digo</th><th>Descri\xE7\xE3o</th><th>Al\xEDquota</th><th>Base de C\xE1lculo</th><th>Valor ISS</th></tr></thead><tbody><tr ng-repeat="serv in servicoDeclarado.itens"><td class="col-md-1">{{serv.servico.codigo}}</td><td class="col-md-5">{{serv.nomeServico}}</td><td class="col-md-1">{{serv.servico.aliquota}}</td><td class="col-md-2">{{serv.baseCalculo | currency : \'R$ \'}}</td><td class="col-md-1">{{serv.iss | currency : \'R$ \'}}</td></tr></tbody></table></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="form-group"><div class="col-md-3"><small>Total dos Servi\xE7os</small><br><input type="text" readonly="readonly" class="form-control" value="{{servicoDeclarado.totalServicos | finance:\'R$ \'}}"></div><div class="col-md-3"><small>Dedu\xE7\xF5es</small><br><input type="text" readonly="readonly" class="form-control" value="{{servicoDeclarado.deducoes | finance:\'R$ \'}}"></div><div class="col-md-3"><small>Base de C\xE1lculo</small><br><input type="text" readonly="readonly" class="form-control" value="{{servicoDeclarado.baseCalculo | finance:\'R$ \'}}"></div><div class="col-md-3"><small>ISS</small><br><input type="text" readonly="readonly" class="form-control" value="{{servicoDeclarado.issCalculado | finance:\'R$ \'}}"></div></div></div><div class="row m-t-md"><div class="col-md-12"><button type="submit" ui-sref="servicoDeclarado" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div></div></div></div></form></div></div>');
$templateCache.put('app/entities/servico-declarado/servico-declarado-edit.html','<div class="row"><div class="col-lg-12"><form name="editForm" role="form" novalidate><div class="row m-md text-center"><div class="col-md-6"><button class="btn btn-success btn-block" ng-class="{\'btn-outline\': servicoDeclarado.tipoServicoDeclarado != \'SERVICO_TOMADO\'}" ng-click="seleciouTipoServicoDeclarado(\'SERVICO_TOMADO\')" type="button"><i class="fa {{servicoDeclarado.tipoServicoDeclarado == \'SERVICO_TOMADO\'? \'fa-check-circle-o\':\'fa-circle-o\'}}"></i> Servi\xE7o Tomado</button></div><div class="col-md-6"><button class="btn btn-success btn-block" ng-class="{\'btn-outline\': servicoDeclarado.tipoServicoDeclarado != \'SERVICO_PRESTADO\'}" ng-click="seleciouTipoServicoDeclarado(\'SERVICO_PRESTADO\')" type="button"><i class="fa {{servicoDeclarado.tipoServicoDeclarado == \'SERVICO_PRESTADO\'? \'fa-check-circle-o\':\'fa-circle-o\'}}"></i> Servi\xE7o Prestado</button></div></div><div class="ibox float-e-margins animated fadeInDown" ng-if="servicoDeclarado.tipoServicoDeclarado"><div class="ibox-content"><div class="row"><div class="col-md-12"><h3>Dados do Documento</h3></div></div><div class="row m-t-sm"><div class="fodrm-group"><div class="col-md-3"><label for="field_numero_nota">N\xFAmero</label><input type="number" class="form-control" name="numeroNota" id="field_numero_nota" required ng-maxlength="7" ng-model="servicoDeclarado.numero"><div ng-show="editForm.numeroNota.$invalid"><p class="help-block" ng-show="editForm.numeroNota.$error">Informe o n\xFAmero do documento com o m\xE1ximo de 7 caracteres</p></div></div><div class="form-group col-md-3"><label for="field_tipo_documento">Tipo de Documento</label><select class="form-control" name="tipoDocumento" required="" ng-model="servicoDeclarado.tipoDocumentoServicoDeclarado" ng-options="tipoDocumento as tipoDocumento.descricao for tipoDocumento in tiposServicosDeclarados" id="field_tipo_documento"></select><div ng-show="editForm.tipoDocumento.$invalid"><p class="help-block" ng-show="editForm.tipoDocumento.$error">Informe o Tipo de Documento</p></div></div><div class="col-md-3" ng-if="permiteAlterarCompetenciaServicoDeclarado"><label for="field_competencia">Compet\xEAncia</label><input type="date" id="field_competencia" ng-model="servicoDeclarado.competencia" class="form-control"></div><div class="col-md-3"><label for="field_emissao">Data de Emiss\xE3o Documento Fiscal</label><input type="date" id="field_emissao" ng-model="servicoDeclarado.emissao" ng-blur="atribuirCompetencia()" class="form-control"><div ng-show="editForm.emissao.$invalid"><p class="help-block" ng-show="editForm.emissao.$error">Informe uma data de emiss\xE3o v\xE1lida</p></div></div></div></div></div></div><div class="ibox float-e-margins animated fadeInDown" ng-show="servicoDeclarado.numero && servicoDeclarado.emissao && servicoDeclarado.competencia"><div class="ibox-content"><div class="row"><div class="col-md-12"><h3>{{servicoDeclarado.tipoServicoDeclarado == \'SERVICO_TOMADO\' ? \'Quem prestou o servi\xE7o?\' : \'Quem tomou o servi\xE7o\'}}</h3></div></div><div class="row m-t-sm"><div class="col-md-3"><button class="btn btn-success btn-block" ng-class="{\'btn-outline\': servicoDeclarado.modalidade != \'IDENTIFICADO\'}" ng-click="mudouIdentificacao(\'IDENTIFICADO\')" type="button"><i class="fa {{servicoDeclarado.modalidade == \'IDENTIFICADO\'? \'fa-check-circle-o\':\'fa-circle-o\'}}"></i> {{servicoDeclarado.tipoServicoDeclarado == \'SERVICO_TOMADO\' ? \'Prestador Identificado\' : \'Tomador Identificado\'}}</button></div><div class="col-md-6"><button class="btn btn-success btn-outline btn-block" ng-click="mudouIdentificacao(\'SEM_CPF\')" ng-class="{\'btn-outline\': servicoDeclarado.modalidade != \'SEM_CPF\'}" type="button"><i class="fa {{servicoDeclarado.modalidade == \'SEM_CPF\'? \'fa-check-circle-o\':\'fa-circle-o\'}}"></i> Estabelecido Fora do Pa\xEDs</button></div><div class="col-md-3"><button class="btn btn-success btn-outline btn-block" ng-class="{\'btn-outline\': servicoDeclarado.modalidade != \'NAO_IDENTIFICADO\'}" ng-click="mudouIdentificacao(\'NAO_IDENTIFICADO\')" type="button"><i class="fa {{servicoDeclarado.modalidade == \'NAO_IDENTIFICADO\'? \'fa-check-circle-o\':\'fa-circle-o\'}}"></i> N\xE3o Identificado (Consumidor)</button></div></div><div class="row m-t-sm" ng-show="servicoDeclarado.modalidade"><div class="col-md-12"><div class="row animated fadeInDown"><div class="form-group col-md-4" ng-show="servicoDeclarado.modalidade == \'IDENTIFICADO\'" ng-class="{\'has-error\' : editForm.cpfCnpj.$invalid && (editForm.$submitted || editForm.cpfCnpj.$touched)}"><label class="control-label" for="field_cpfCnpj">CPF ou CNPJ</label><div class="input-group"><input type="text" class="form-control" name="cpfCnpj" id="field_cpfCnpj" ui-br-cpfcnpj-mask ng-model="servicoDeclarado.dadosPessoais.cpfCnpj" required> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="searchPrestadorServico()"><span class="glyphicon glyphicon-search"></span></button></span></div><div ng-show="editForm.cpfCnpj.$invalid"><p class="help-block" ng-show="editForm.cpfCnpj.$error.required">Informe o CPF ou CNPJ</p><p class="help-block" ng-show="editForm.cpfCnpj.$error.cpf || editForm.cpfCnpj.$error.cnpj">CPF ou CNPJ inv\xE1lido</p></div></div></div><div ng-show="editForm.cpfCnpj.$valid || servicoDeclarado.modalidade == \'SEM_CPF\'" class="fadeInDown animated"><div class="row" ng-show="!isFisica()"><div class="form-group col-md-4"><label for="field_inscricaoMunicipal">Inscri\xE7\xE3o Municipal</label><input type="text" class="form-control" name="inscricaoMunicipal" id="field_inscricaoMunicipal" ng-model="servicoDeclarado.dadosPessoais.inscricaoMunicipal"></div><div class="form-group col-md-8"><label class="control-label" for="field_nomeFantasia">Nome Fantasia</label><input type="text" class="form-control" name="nomeFantasia" id="field_nomeFantasia" ng-model="servicoDeclarado.dadosPessoais.nomeFantasia"></div></div><div class="row"><div class="form-group col-md-4" ng-if="!isFisica()" ng-class="{\'has-error\' : editForm.inscricaoEstadual.$invalid && (editForm.$submitted || editForm.inscricaoEstadual.$touched)}"><label class="control-label" for="field_inscricaoEstadual">Inscri\xE7\xE3o Estadual</label><input type="text" class="form-control" name="inscricaoEstadual" id="field_inscricaoEstadual" ng-model="servicoDeclarado.dadosPessoais.inscricaoEstadualRg"></div><div class="form-group col-md-4" ng-if="isFisica() && servicoDeclarado.modalidade != \'SEM_CPF\'" ng-class="{\'has-error\' : editForm.rg.$invalid  && (editForm.$submitted || editForm.rg.$touched)}"><label class="control-label" for="field_rg">RG</label><input type="text" class="form-control" name="rg" id="field_rg" ng-model="servicoDeclarado.dadosPessoais.inscricaoEstadualRg"></div><div class="form-group {{isFisica() && servicoDeclarado.modalidade != \'SEM_CPF\' ? \'col-md-8\': \'col-md-8\'}}" ng-class="{\'has-error\' : editForm.nomeRazaoSocial.$invalid && (editForm.$submitted || editForm.nomeRazaoSocial.$touched)}"><label class="control-label" for="field_nomeRazaoSocial">{{isFisica() ? \'Nome \':\'Raz\xE3o Social\'}}</label><input type="text" class="form-control" name="nomeRazaoSocial" id="field_nomeRazaoSocial" ng-model="servicoDeclarado.dadosPessoais.nomeRazaoSocial" required><div ng-show="editForm.nomeRazaoSocial.$invalid"><p class="help-block" ng-show="editForm.nomeRazaoSocial.$error.required">Informe o Nome ou a Raz\xE3o Social</p></div></div><div ng-show="servicoDeclarado.modalidade === \'SEM_CPF\'" class="form-group col-md-4" ng-class="{\'has-error\' : editForm.nomeRazaoSocial.$invalid && (editForm.$submitted || editForm.nomeRazaoSocial.$touched)}"><label class="control-label" for="field_identificacaoFora">N\xBA. Identifica\xE7\xE3o</label><input type="text" class="form-control" name="ficaidentificacaoFora" id="field_identificacaoFora" ng-model="servicoDeclarado.dadosPessoais.numeroIdentificacao"></div></div><div class="row"><div class="form-group col-md-4"><label for="field_apelido">Apelido</label><input type="text" class="form-control" name="email" id="field_apelido" ng-model="servicoDeclarado.dadosPessoais.apelido"></div><div class="form-group col-md-5"><label for="field_email">e-Mail</label><input type="text" class="form-control" name="email" id="field_email" ng-model="servicoDeclarado.dadosPessoais.email"></div><div class="form-group col-md-3"><label for="field_telefone">Telefone</label><input type="text" class="form-control" name="telefone" id="field_telefone" ui-br-phone-number ng-model="servicoDeclarado.dadosPessoais.telefone"></div></div><div class="row fadeInDown animated" ng-show="servicoDeclarado.modalidade == \'SEM_CPF\'"><div class="form-group col-md-6"><label>Munic\xEDpio</label><input type="text" class="form-control" name="email" id="field_municipio_fora" ng-model="servicoDeclarado.dadosPessoais.municipio.nome"></div><div class="form-group col-md-6"><label for="field_servico_nome_pais">Pais</label><div class="input-group"><input type="text" class="form-control" name="field_pais_fora" id="field_pais_fora" disabled="disabled" value="{{servicoDeclarado.dadosPessoais.pais.nome}}"> <span class="input-group-btn"><button type="button" class="btn" ng-click="searchPais(servicoDeclarado.dadosPessoais)"><span class="glyphicon glyphicon-search"></span></button></span></div></div></div><div class="row fadeInDown animated" ng-show="servicoDeclarado.modalidade == \'IDENTIFICADO\'"><div class="form-group col-md-2"><label for="field_cep">Cep</label><input type="text" class="form-control" name="id" id="field_cep" ui-br-cep-mask ng-blur="loadEnderecoByCEP(servicoDeclarado.dadosPessoais.cep)" ng-model="servicoDeclarado.dadosPessoais.cep"></div><div class="form-group col-md-8" ng-show="notaFiscal.modalidade == \'SEM_CPF\'"><label for="field_nome_municipio">Munic\xEDpio</label><div class="input-group"><input type="text" class="form-control" name="nome_municipio" id="field_nome_municipio" disabled="disabled" ng-model="servicoDeclarado.dadosPessoais.municipio.nome"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="searchMunicipio(servicoDeclarado.dadosPessoaisPrestador)"><span class="glyphicon glyphicon-search"></span></button></span></div></div><div class="form-group col-md-2"><label for="field_estado_municipio">Estado</label><input type="text" class="form-control" name="estado_municipio" id="field_estado_municipio" disabled="disabled" ng-model="servicoDeclarado.dadosPessoais.municipio.estado"></div><div class="form-group col-md-12"><label for="field_logradouro">Logradouro</label><input type="text" class="form-control" name="logradouro" id="field_logradouro" ng-model="servicoDeclarado.dadosPessoais.logradouro"></div><div class="form-group col-md-6"><label for="field_bairro">Bairro</label><input type="text" class="form-control" name="bairro" id="field_bairro" ng-model="servicoDeclarado.dadosPessoais.bairro"></div><div class="form-group col-md-2"><label for="field_numero">N\xFAmero</label><input type="text" class="form-control" name="numero" id="field_numero" ng-model="servicoDeclarado.dadosPessoais.numero"></div><div class="form-group col-md-4"><label for="field_complemento">Complemento</label><input type="text" class="form-control" name="complemento" id="field_complemento" ng-model="servicoDeclarado.dadosPessoais.complemento"></div></div></div></div></div></div></div><div class="ibox float-e-margins animated fadeInDown" ng-show="servicoDeclarado.dadosPessoais.nomeRazaoSocial || servicoDeclarado.modalidade == \'NAO_IDENTIFICADO\'"><div class="ibox-content"><div class="row"><div class="col-md-12"><h3>Qual o servi\xE7o prestado?</h3></div></div><div class="row m-t-md"><div class="form-group col-md-2"><label for="field_prestadoNoPais">Foi prestado no pais?</label><div class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="prestadoNoPais" ng-model="servico.prestadoNoPais" ng-change="verificarExigibilidadeIss()" class="onoffswitch-checkbox" id="field_prestadoNoPais"><label class="onoffswitch-label" for="field_prestadoNoPais"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div ng-if="servico.prestadoNoPais" class="form-group col-md-4"><label for="field_servico_nome_municipio">Qual Municipio?</label><div class="input-group"><input type="text" class="form-control" name="nome_servico_municipio" id="field_servico_nome_municipio" disabled="disabled" value="{{servico.municipio.nome}}/{{servico.municipio.estado}}"> <span class="input-group-btn"><button type="button" class="btn" ng-click="searchMunicipio(servico)"><span class="glyphicon glyphicon-search"></span></button></span></div></div><div ng-if="!servico.prestadoNoPais" class="form-group col-md-4"><label for="field_servico_nome_pais">Qual Pais?</label><div class="input-group"><input type="text" class="form-control" name="nome_servico_pais" id="field_servico_nome_pais" disabled="disabled" ng-model="servico.pais.nome"> <span class="input-group-btn"><button type="button" class="btn" ng-click="searchPais(servico)"><span class="glyphicon glyphicon-search"></span></button></span></div></div><div class="form-group col-md-2"><label for="field_retencao">Reten\xE7\xE3o do ISSQN?</label><div class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="retencao" ng-change="verificarExigibilidadeIss()" ng-model="servicoDeclarado.issRetido" class="onoffswitch-checkbox" id="field_retencao"><label class="onoffswitch-label" for="field_retencao"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span> <span class="onoffswitch-switch"></span></label></div></div></div><div class="form-group col-md-4"><label translate="nfseApp.declaracaoPrestacaoServico.naturezaOperacao" for="field_naturezaOperacao">NaturezaOperacao</label><select class="form-control" name="naturezaOperacao" ng-model="servicoDeclarado.naturezaOperacao" ng-disabled="!permiteExigibilidade" ng-change="selecionouServico()" id="field_naturezaOperacao"><option value="TRIBUTACAO_MUNICIPAL">Tributa\xE7\xE3o Municipal</option><option value="ISENCAO">Is\xEAn\xE7\xE3o</option><option value="IMUNIDADE">Imunidade</option><option value="EXIGIBILIDADE_SUSPENSA_DECISAO_JUDICIAL">Exigibilidade Suspensa por Decis\xE3o Judicial</option><option value="EXIGIBILIDADE_SUSPENSA_PROCESSO_ADMINISTRATIVO">Exigibilidade Suspensa por Processo Administrativo</option><option value="NAO_INCIDENCIA">N\xE3o Incid\xEAncia</option><option value="EXPORTACAO">Exporta\xE7\xE3o</option></select></div></div><div class="row" ng-if="exigibilidadeSuspensa()"><div class="form-group col-md-8"><label class="control-label">N\xFAmero do Processo de Suspens\xE3o da Exigibilidade do ISSQN</label><input type="text" class="form-control" required name="processoSuspensa" id="field_processoSuspensa" ng-model="servico.processoSuspensao"><div class="margin"><p class="help-block" ng-show="exigibilidadeSuspensa() && editForm.processoSuspensa.$error.required">Informe o n\xFAmero do processo de suspens\xE3o da exigibilidade do ISSQN</p></div></div></div><div class="row"><div class="form-group col-md-12" ng-show="servicoDeclarado.itens.length > 0"><table class="table table-striped"><thead><tr><th colspan="6">Servi\xE7os j\xE1 adicionados</th></tr><tr><th>C\xF3digo</th><th>Descri\xE7\xE3o</th><th>Al\xEDquota</th><th>Base de C\xE1lculo</th><th>Valor ISS</th><th></th></tr></thead><tbody><tr ng-repeat="serv in servicoDeclarado.itens"><td class="col-md-1">{{serv.servico.codigo}}</td><td class="col-md-5">{{serv.nomeServico}}</td><td class="col-md-1">{{serv.servico.aliquota}}</td><td class="col-md-2">{{serv.baseCalculo | currency : \'R$ \'}}</td><td class="col-md-1">{{serv.iss | currency : \'R$ \'}}</td><td class="col-md-2"><div class="pull-right"><button type="submit" ng-click="removeServico($index)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button> <button type="submit" ng-click="editaServico($index)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-pencil"></span></button></div></td></tr></tbody></table></div></div><div collapse="mostrarValoresFinais" class="fadeIn"><div class="row"><div class="form-group col-md-8"><label class="center-block">Servi\xE7o</label><div class="input-group"><input class="form-control" readonly="readonly" id="field_servico_descricao" name="servico_descricao" value="{{servico.nomeServico}}"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="searchServico()"><span class="glyphicon glyphicon-search"></span></button></span></div></div><div class="form-group col-md-4" ng-class="{\'has-error\' : servico.aliquotaServico <= 0 && (editForm.$submitted || editForm.aliquota.$touched)}"><label class="control-label">Al\xEDquota</label><input type="text" class="form-control" ui-number-mask="" ng-change="calculaValoresServico(servico)" name="aliquota" id="servico_aliquota" ng-required="true" ng-model="servico.aliquotaServico"><div class="margin"><p class="help-block" ng-show="editForm.aliquota.$error.required">A Al\xEDquota deve ser informada.</p><p class="help-block" ng-show="servico.aliquotaServico <= 0">A Al\xEDquota deve ser maior que ZERO.</p></div></div></div><div class="row"><div class="form-group col-md-12"><label class="center-block">Discrimina\xE7\xE3o do servi\xE7o</label><textarea type="text" class="form-control" name="servico_aliquota" id="field_descriminacao_servico" ng-model="servico.descricao">\n                                        </textarea></div></div><div class="row"><div class="form-group col-md-2" ng-class="{\'has-error\' : servico.valorServico <= 0 && (editForm.$submitted || editForm.servico_aliquota.$touched)}"><label class="control-label">Valor do Servi\xE7o</label><input type="text" class="form-control" ui-money-mask="R$" ng-change="calculaValoresServico(servico)" name="servico_aliquota" id="field_servico_valor_servico" ng-model="servico.valorServico"><div class="margin"><p class="help-block" ng-show="servico.valorServico <= 0">O valor deve ser maior que ZERO (R$ 0,00)</p></div></div><div class="form-group col-md-1"><label class="center-block">Quantidade</label><input type="number" class="form-control" ng-class="{\'has-error\' : servico.quantidade <= 0 && (editForm.$submitted || editForm.servico_quantidade.$touched)}" ng-blur="calculaValoresServico(servico)" name="servico_quantidade" id="field_servico_quantidade" ng-model="servico.quantidade"><div class="margin"><p class="help-block" ng-show="servico.quantidade <= 0">O valor deve ser maior que ZERO (0)</p></div></div><div class="form-group col-md-2"><label class="center-block">Deducoes</label><input type="text" class="form-control" ui-money-mask="" ng-change="calculaValoresServico(servico)" name="servico_deducoes" id="field_servico_deducoes" ng-model="servico.deducoes"></div><div class="form-group col-md-3"><label class="center-block">Total do Servi\xE7o</label><input type="text" class="form-control" ui-money-mask="" disabled="disabled" name="servico_total_servico" id="field_servico_total_servico" ng-model="servico.total"></div><div class="form-group col-md-2"><label class="center-block">Base de Calculo</label><input type="text" class="form-control" ui-money-mask="" disabled="disabled" name="servico_base_calculo" id="field_servico_base_calculo" ng-model="servico.baseCalculo"></div><div class="form-group col-md-2"><label class="center-block">Valor do ISS</label><input type="text" class="form-control" ui-money-mask="" disabled="disabled" name="servico_ISS" id="field_servico_ISS" ng-model="servico.iss"></div></div></div></div></div><div class="ibox float-e-margins" ng-if="servicoDeclarado.tipoServicoDeclarado"><div class="ibox-content animated fadeIn" ng-show="!mostrarValoresFinais"><button class="btn btn-success" ng-disabled="!servico.servico || !servico.baseCalculo" ng-click="addServico(true)" type="button"><i class="fa fa-chevron-right"></i> Adicionar Servi\xE7o e Continuar</button></div><div class="ibox-content animated fadeIn" ng-show="mostrarValoresFinais"><div class="row"><div class="form-group"><div class="col-md-3"><small>Total dos Servi\xE7os</small><br><input type="text" readonly="readonly" class="form-control" value="{{servicoDeclarado.totalServicos | finance:\'R$ \'}}"></div><div class="col-md-3"><small>Dedu\xE7\xF5es</small><br><input type="text" readonly="readonly" class="form-control" value="{{servicoDeclarado.deducoes | finance:\'R$ \'}}"></div><div class="col-md-3"><small>Base de C\xE1lculo</small><br><input type="text" readonly="readonly" class="form-control" value="{{servicoDeclarado.baseCalculo | finance:\'R$ \'}}"></div><div class="col-md-3"><small>ISS</small><br><input type="text" readonly="readonly" class="form-control" value="{{servicoDeclarado.issCalculado | finance:\'R$ \'}}"></div></div></div><div class="row m-t-md"><div class="col-md-12"><button type="button" class="btn btn-default" data-dismiss="modal" ui-sref="servicoDeclarado"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-click="saveAndFinalize()" class="btn btn-success"><span class="glyphicon glyphicon-check"></span>&nbsp; <span>Salvar</span></button></div></div></div></div></form></div></div>');
$templateCache.put('app/entities/servico-declarado/servico-declarado-import.html','<div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><form name="editForm" role="form" novalidate><div class="form-group" ng-show="!arquivoSelecionado"><div class="col-md-8 col-md-offset-2 text-center"><label for="file-upload" class="custom-file-upload"><span class="fa fa-cloud-upload"></span> Selecionar Arquivo XML</label><input type="file" id="file-upload" name="file" ngf-select="uploadXmlFile($file)" ng-model="arquivo" ngf-max-size="15MB"></div></div><div ng-show="arquivoSelecionado"><div class="form-group col-md-12 border-bottom"><h3>Dados do Arquivo</h3></div><div class="form-group col-md-4"><label>Nome</label><input type="text" readonly="readonly" class="form-control" value="{{arquivoSelecionado.name}}"></div><div class="form-group col-md-4"><label>Tamanho</label><input type="text" readonly="readonly" class="form-control" value="{{arquivoSelecionado.size}}"></div><div class="form-group col-md-4"><label>Quantidade de RPS</label><input type="text" readonly="readonly" class="form-control" value="{{}}"></div><div class="form-group col-md-12"><button type="submit" class="btn btn-warning" ng-click="arquivoSelecionado = null"><span class="fa fa-times"></span>&nbsp;Cancelar</button> <button type="submit" class="btn btn-primary" ng-click="enviarArquivo()"><span class="glyphicon glyphicon-save"></span>&nbsp;Confirmar</button></div></div></form></div></div></div>');
$templateCache.put('app/entities/servico-declarado/servico-declarado.html','<div class="row"><div class="col-lg-12"><div class="row m-b-md"><div class="col-md-10"><span ng-if="filtrosSelecionados.length > 0"><h3>Filtros Dispon\xEDveis</h3></span></div><div class="col-md-2"><button class="btn btn-primary pull-right" ui-sref="servicoDeclarado.new"><span class="fa fa-plus"></span> <span>Declarar Servi\xE7o</span></button></div></div><div ng-repeat="filtro in filtrosSelecionados track by $index" class="row float-e-margins"><div class="col-md-4"><div><select class="form-control" id="filtro_campos" name="filtros" ng-model="filtro.atributo" ng-change="selecionouCampo(filtro)" ng-options="filtroDisponivel as filtroDisponivel.descricao  for filtroDisponivel in filtrosDisponiveis  track by filtroDisponivel.nomeAtributo"></select></div></div><div class="col-md-2"><div><select class="form-control" id="filtro_peracao" name="oprecoes" ng-model="filtro.operacao" ng-options="operacao.value as operacao.nome for operacao in filtro.atributo.operacoes"></select></div></div><div class="col-md-6"><div class="form-group input-group"><input ng-show="filtro.atributo.tipo === \'cpfcnpj\'" type="text" class="form-control" name="valorCpfCnpj" ng-model="filtro.valorString"> <input ng-show="filtro.atributo.tipo === \'decimal\'" type="number" class="form-control" ng-pattern="/^[0-9]+(\\.[0-9]{1,5})?$/" step="0.01" name="valorDecimal" ng-model="filtro.valorDecimal"> <input ng-show="filtro.atributo.tipo === \'inteiro\'" type="number" class="form-control" ng-model="filtro.valorInteger" name="valorInteger"> <input ng-show="filtro.atributo.tipo === \'texto\'" type="text" class="form-control" ng-model="filtro.valorString" name="valorString"><div ng-show="filtro.atributo.tipo === \'logico\'" class="switch"><div class="onoffswitch"><input type="checkbox" checked="checked" name="boolean" ng-model="filtro.valorLogico" class="onoffswitch-checkbox" id="field_boolean"><label class="onoffswitch-label" for="field_boolean"><span class="onoffswitch-inner"></span> <span class="onoffswitch-switch"></span> <span class="onoffswitch-switch"></span></label></div></div><div ng-show="filtro.atributo.tipo === \'enum\'" class="switch"><select class="form-control" name="enum" ng-model="filtro.valorString"><option value="SERVICO_PRESTADO">Servi\xE7os Prestados</option><option value="SERVICO_TOMADO">Servi\xE7os Tomados</option></select></div><input ng-show="filtro.atributo.tipo === \'data\'" type="date" ng-model="filtro.valorData" class="form-control"> <span class="input-group-btn"><button ng-click="removerFiltro($index)" class="btn btn-danger"><span class="fa fa-trash"></span></button></span></div></div></div><div class="row m-b-md"><div class="col-md-10 text-center"><a ng-click="adicionarFiltro()"><span class="fa fa-plus"></span> Adicionar filtros</a></div><div class="col-md-2"><button ng-click="loadAll()" ng-if="filtrosSelecionados.length > 0" class="btn btn-success btn-block"><span class="fa fa-search"></span> <span>Filtrar</span></button></div></div><div class="table-responsive"><table class="table table-striped small"><thead><tr><th></th><th>N\xFAmero</th><th><a ng-click="orderBy = \'coalesce(nota.emissao, sd.emissao)\'; sortReverse = !sortReverse; loadAll()"><span ng-show="orderBy == \'coalesce(nota.emissao, sd.emissao)\' && sortReverse" class="fa fa-caret-down"></span> <span ng-show="orderBy == \'coalesce(nota.emissao, sd.emissao)\' && !sortReverse" class="fa fa-caret-up"></span> Emiss\xE3o</a></th><th><a ng-click="orderBy = \'dec.competencia\'; sortReverse = !sortReverse; loadAll()"><span ng-show="orderBy == \'dec.competencia\' && sortReverse" class="fa fa-caret-down"></span> <span ng-show="orderBy == \'dec.competencia\' && !sortReverse" class="fa fa-caret-up"></span> Compet\xEAncia</a></th><th>Tipo</th><th>Tipo de Documento</th><th>Prestador</th><th>Tomador</th><th class="text-center">ISS Retido?</th><th class="text-right">Valor Servi\xE7os</th><th class="text-right">Base de Calculo</th><th class="text-right">Valor ISS</th><th class="text-center">Situa\xE7\xE3o</th></tr></thead><tbody><tr ng-repeat="servicoDeclarado in servicosDeclarados"><td class="dropdown"><button class="btn btn-white btn-sm dropdown-toggle" data-toggle="dropdown" type="button"><i class="fa fa-caret-down">Op\xE7\xF5es</button><ul class="dropdown-menu"><li><a ng-if="servicoDeclarado.origem == \'NFSE\' && servicoDeclarado.situacao == \'EMITIDA\'" ng-click="imprimirNota(servicoDeclarado.id)" class="dropdown-item"><i class="fa fa-print"></i> &ensp; Imprimir</a></li><li><a ng-click="cancelarServicoDeclarado(servicoDeclarado)" ng-if="servicoDeclarado.origem == \'SERVICO_DECLARADO\' && servicoDeclarado.situacao == \'EMITIDA\'" class="dropdown-item"><i class="fa fa-ban"></i> Cancelar</a></li></ul></td><td><a ng-if="servicoDeclarado.origem != \'NFSE\'" ui-sref="servicoDeclarado.detail({id:servicoDeclarado.id})">{{servicoDeclarado.numero}}</a> <span ng-if="servicoDeclarado.origem == \'NFSE\'">{{servicoDeclarado.numero}}</span></td><td>{{servicoDeclarado.emissao | date : \'dd/MM/yyyy\'}}</td><td>{{servicoDeclarado.competencia | date : \'MM/yyyy\'}}</td><td>{{\'nfseApp.TipoServicoDeclarado.\' + servicoDeclarado.tipo | translate}}</td><td>{{servicoDeclarado.origem == \'NFSE\' ? \'Nfs-e\' : servicoDeclarado.tipoDocumento}}</td><td><span ng-if="servicoDeclarado.cpfCnpjPrestador">({{servicoDeclarado.cpfCnpjPrestador | brCpfCnpj}})&ensp;</span> {{servicoDeclarado.nomePrestador}}</td><td><span ng-if="servicoDeclarado.cpfCnpjTomador">({{servicoDeclarado.cpfCnpjTomador | brCpfCnpj}})&ensp;</span> {{servicoDeclarado.nomeTomador}}</td><td class="text-center">{{servicoDeclarado.issRetido ? \'Sim\': \'N\xE3o\'}}</td><td class="text-right">{{servicoDeclarado.totalServicos | currency : \'R$ \'}}</td><td class="text-right">{{servicoDeclarado.baseCalculo | currency : \'R$ \'}}</td><td class="text-right">{{servicoDeclarado.issCalculado | currency : \'R$ \'}}</td><td class="text-center"><span class="label {{servicoDeclarado.situacao === \'CANCELADA\' ? \'label-danger\': \'label-primary\'}}">{{\'nfseApp.SituacaoNota.\' + servicoDeclarado.situacao | translate}}</span></td></tr></tbody></table><div class="col-md-12 text-right"><button class="btn btn-danger btn-outline" title="Clique para baixar os registros em PDF" ng-click="baixarPDF()"><i class="fa fa-download"></i> PDF</button> <button class="btn btn-primary btn-outline" title="Clique para baixar os registros em XLS" ng-click="baixarXls()"><i class="fa fa-download"></i> XLS</button></div><span nfse-app-pagination></div></div></div>');
$templateCache.put('app/entities/solicitacao-rps/solicitacao-rps-edit.html','<div class="row"><div class="col-lg-12"><form name="editForm" class="form-horizontal" role="form" novalidate><div class="form-group"><div class="col-md-3"><label for="quantidade">Quantidade Solicitada de RPS</label><input id="quantidade" type="number" class="form-control" name="quantidade" min="1" ng-model="solicitacaorps.quantidadeSolicitada"></div></div><div class="form-group"><div class="col-md-12"><label for="observacoes">Observa\xE7\xF5es</label><textarea type="text" ng-model="solicitacaorps.observacaoSolicitacao" class="form-control" id="observacoes" name="observacoes" maxlength="3000">\n                    <span>{{3000 - solicitacaorps.observacaoSolicitacao.length}}</span>\n                </div>\n            </div>\n\n            <div class="form-group">\n                <div class="col-md-12">\n                    <button type="button" class="btn btn-default" data-dismiss="modal" ui-sref="solicitacaorps">\n                        <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span>\n                    </button>\n\n                    <button type="submit" ng-click="save()" class="btn btn-success">\n                        <span class="glyphicon glyphicon-check"></span>&nbsp;\n                        <span>Solicitar</span></button></div></div></form></div></div>');
$templateCache.put('app/entities/solicitacao-rps/solicitacao-rps.html','<div class="row"><div class="col-lg-12"><div class="row"><div class="col-md-offset-8 col-md-4"><button class="btn btn-primary pull-right" ui-sref="solicitacaorps.new"><span class="fa fa-plus"></span> <span translate="nfseApp.solicitacaorps.home.createLabel">Create a new Solicita\xE7\xE3o RPS</span></button></div></div><div class="table-responsive"><table class="table table-striped small"><thead><tr><th>N\xFAmero</th><th>Solicitado em</th><th>Quantidade</th><th>Situa\xE7\xE3o</th><th>Analisada em</th><th></th></tr></thead><tbody><tr ng-repeat="sol in solicitacoes"><td>{{sol.id}}</td><td>{{sol.solicitadaEm |date:\'dd/MM/yyyy HH:mm\' }}</td><td>{{sol.quantidadeSolicitada}}</td><td>{{sol.situacao}}</td><td>{{sol.analisadaEm |date:\'dd/MM/yyyy HH:mm\'}}</td></tr></tbody></table><span nfse-app-pagination></div></div></div>');
$templateCache.put('app/entities/substituicaoNotaFiscal/substituicaoNotaFiscal-detail.html','<div><h2><span translate="nfseApp.substituicaoNotaFiscal.detail.title">SubstituicaoNotaFiscal</span> {{substituicaoNotaFiscal.id}}</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody></tbody></table></div><button type="submit" ui-sref="substituicaoNotaFiscal" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/entities/substituicaoNotaFiscal/substituicaoNotaFiscal-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="mySubstituicaoNotaFiscalLabel" translate="nfseApp.substituicaoNotaFiscal.home.createOrEditLabel">Create or edit a SubstituicaoNotaFiscal</h4></div><div class="modal-body"><div class="form-group"><label translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="substituicaoNotaFiscal.id" readonly="readonly"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/substituicaoNotaFiscal/substituicaoNotaFiscals.html','<div><h2 translate="nfseApp.substituicaoNotaFiscal.home.title">SubstituicaoNotaFiscals</h2><div class="container"><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="substituicaoNotaFiscal.new"><span class="glyphicon glyphicon-flash"></span> <span translate="nfseApp.substituicaoNotaFiscal.home.createLabel">Create a new SubstituicaoNotaFiscal</span></button></div><div class="col-md-8"><form name="searchForm" class="form-inline"><div class="form-group"><input type="text" class="form-control" ng-model="searchQuery" id="searchQuery" placeholder="query"></div><button class="btn btn-info" ng-click="search()"><span class="glyphicon glyphicon-search"></span> <span>Search a SubstituicaoNotaFiscal</span></button></form></div></div></div><div class="modal fade" id="deleteSubstituicaoNotaFiscalConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(substituicaoNotaFiscal.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="nfseApp.substituicaoNotaFiscal.delete.question" translate-values="{id: \'{{substituicaoNotaFiscal.id}}\'}">Are you sure you want to delete this SubstituicaoNotaFiscal?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="global.field.id">ID</th><th></th></tr></thead><tbody><tr ng-repeat="substituicaoNotaFiscal in substituicaoNotaFiscals"><td><a ui-sref="substituicaoNotaFiscal.detail({id:substituicaoNotaFiscal.id})">{{substituicaoNotaFiscal.id}}</a></td><td><button type="submit" ui-sref="substituicaoNotaFiscal.detail({id:substituicaoNotaFiscal.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span>&nbsp;<span translate="entity.action.view"> View</span></button> <button type="submit" ui-sref="substituicaoNotaFiscal.edit({id:substituicaoNotaFiscal.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button type="submit" ng-click="delete(substituicaoNotaFiscal.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete"> Delete</span></button></td></tr></tbody></table><nav><ul class="pager"><li ng-show="links[\'first\']" ng-click="loadPage(links[\'first\'])"><a href="#">&lt;&lt;</a></li><li ng-show="links[\'prev\']" ng-click="loadPage(links[\'prev\'])"><a href="#">&lt;</a></li><li ng-show="links[\'next\']" ng-click="loadPage(links[\'next\'])"><a href="#">&gt;</a></li><li ng-show="links[\'last\']" ng-click="loadPage(links[\'last\'])"><a href="#">&gt;&gt;</a></li></ul></nav></div></div>');
$templateCache.put('app/entities/substituicaoRPS/substituicaoRPS-detail.html','<div><h2><span translate="nfseApp.substituicaoRPS.detail.title">SubstituicaoRPS</span> {{substituicaoRPS.id}}</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="entity.detail.field">Field</th><th translate="entity.detail.value">Value</th></tr></thead><tbody><tr><td><span translate="nfseApp.substituicaoRPS.de">de</span></td><td><input type="text" class="input-sm form-control" value="{{substituicaoRPS.de.id}}" readonly="readonly"></td></tr><tr><td><span translate="nfseApp.substituicaoRPS.para">para</span></td><td><input type="text" class="input-sm form-control" value="{{substituicaoRPS.para.id}}" readonly="readonly"></td></tr></tbody></table></div><button type="submit" ui-sref="substituicaoRPS" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/entities/substituicaoRPS/substituicaoRPS-dialog.html','<form name="editForm" role="form" novalidate ng-submit="save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" id="mySubstituicaoRPSLabel" translate="nfseApp.substituicaoRPS.home.createOrEditLabel">Create or edit a SubstituicaoRPS</h4></div><div class="modal-body"><div class="form-group"><label translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="substituicaoRPS.id" readonly="readonly"></div><div class="form-group"><label translate="nfseApp.substituicaoRPS.de" for="field_de">de</label><select class="form-control" id="field_de" name="de" ng-model="substituicaoRPS.de.id" ng-options="rPS.id as rPS.id for rPS in rpss"></select></div><div class="form-group"><label translate="nfseApp.substituicaoRPS.para" for="field_para">para</label><select class="form-control" id="field_para" name="para" ng-model="substituicaoRPS.para.id" ng-options="rPS.id as rPS.id for rPS in rpss"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/substituicaoRPS/substituicaoRPSs.html','<div><h2 translate="nfseApp.substituicaoRPS.home.title">SubstituicaoRPSs</h2><div class="container"><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="substituicaoRPS.new"><span class="glyphicon glyphicon-flash"></span> <span translate="nfseApp.substituicaoRPS.home.createLabel">Create a new SubstituicaoRPS</span></button></div><div class="col-md-8"><form name="searchForm" class="form-inline"><div class="form-group"><input type="text" class="form-control" ng-model="searchQuery" id="searchQuery" placeholder="query"></div><button class="btn btn-info" ng-click="search()"><span class="glyphicon glyphicon-search"></span> <span>Search a SubstituicaoRPS</span></button></form></div></div></div><div class="modal fade" id="deleteSubstituicaoRPSConfirmation"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="confirmDelete(substituicaoRPS.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><p translate="nfseApp.substituicaoRPS.delete.question" translate-values="{id: \'{{substituicaoRPS.id}}\'}">Are you sure you want to delete this SubstituicaoRPS?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form></div></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="global.field.id">ID</th><th translate="nfseApp.substituicaoRPS.de">de</th><th translate="nfseApp.substituicaoRPS.para">para</th><th></th></tr></thead><tbody><tr ng-repeat="substituicaoRPS in substituicaoRPSs"><td><a ui-sref="substituicaoRPS.detail({id:substituicaoRPS.id})">{{substituicaoRPS.id}}</a></td><td>{{substituicaoRPS.de.id}}</td><td>{{substituicaoRPS.para.id}}</td><td><button type="submit" ui-sref="substituicaoRPS.detail({id:substituicaoRPS.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span>&nbsp;<span translate="entity.action.view"> View</span></button> <button type="submit" ui-sref="substituicaoRPS.edit({id:substituicaoRPS.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span>&nbsp;<span translate="entity.action.edit"> Edit</span></button> <button type="submit" ng-click="delete(substituicaoRPS.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete"> Delete</span></button></td></tr></tbody></table><nav><ul class="pager"><li ng-show="links[\'first\']" ng-click="loadPage(links[\'first\'])"><a href="#">&lt;&lt;</a></li><li ng-show="links[\'prev\']" ng-click="loadPage(links[\'prev\'])"><a href="#">&lt;</a></li><li ng-show="links[\'next\']" ng-click="loadPage(links[\'next\'])"><a href="#">&gt;</a></li><li ng-show="links[\'last\']" ng-click="loadPage(links[\'last\'])"><a href="#">&gt;&gt;</a></li></ul></nav></div></div>');
$templateCache.put('app/entities/syncElasticSearch/sync.html','<div class="row"><div class="col-lg-12"><button class="btn btn-primary btn-rounded btn-block" ng-click="sync()"><span class="fa fa-refresh"></span> <span>Sincronizar Elastic Search com Postgres</span></button></div></div>');
$templateCache.put('app/entities/tarifa-bancaria/tarifa-bancaria-search.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title">Pesquisa Tarifa Banc\xE1ria</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><div class="panel panel-default"><div class="panel-heading">Op\xE7\xF5es de Filtros</div><div class="panel-body"><div class="row"><div class="col-md-12"><div class="form-group col-md-2"><label>C\xF3digo</label><input class="form-control" ng-model="filtro.codigo"></div><div class="form-group col-md-10"><label>Descri\xE7\xE3o</label><input class="form-control" ng-model="filtro.descricao"></div></div></div><div class="row"><div class="col-md-12"><div class="col-md-6"><button class="btn btn-primary" ng-click="loadAll()"><span class="fa fa-search"></span> <span>Pesquisar</span></button> <button class="btn btn-default" ng-click="filtro = {}"><span class="fa fa-close"></span> <span>Limpar Filtros</span></button></div></div></div></div></div></div></div><div class="row m-t-md"><div class="col-md-12"><span nfse-app-pagination></span><div class="table-responsive"><table class="table table-striped small"><thead><tr><th class="col-md-2">C\xF3digo</th><th>Descri\xE7\xE3o</th><th></th></tr></thead><tbody><tr ng-repeat="tarifa in tarifas"><td class="col-md-2">{{tarifa.codigo}}</td><td>{{tarifa.descricao}}</td><td class="pull-right"><button type="submit" ng-click="ok(tarifa)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-check"></span></button></td></tr></tbody></table></div><span nfse-app-pagination></span></div></div></div>');
$templateCache.put('app/entities/template/template-detail.html','<div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h4 class="modal-title" id="templateLabel">Dados do template</h4></div><div class="ibox-content"><form name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="col-md-12"><div class="form-group"><label for="field_tipo">Tipo</label><input class="form-control" disabled="disabled" name="tipo" ng-model="template.tipo" id="field_tipo"></div><div class="form-group"><label for="field_template">Template</label><summernote name="template" id="field_template" ng-model="template.template"></summernote></div></div><div class="form-actions"><button type="submit" ui-sref="template" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div></form></div></div></div></div>');
$templateCache.put('app/entities/template/template-dialog.html','<div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h4 class="modal-title" id="templateLabel">Dados do Template</h4></div><div class="ibox-content"><form name="editForm" role="form" novalidate ng-submit="save()" show-validation><div class="col-md-12"><div class="form-group"><label for="field_tipo">Tipo</label><select class="form-control" name="tipo" ng-model="template.tipo" id="field_tipo"><option value="EMAIL_SOLICITACAO_ATIVACAO_CADASTRO">Envio de e-mail para ativa\xE7\xE3o do cadastro</option><option value="EMAIL_SOLICITACAO_ALTERACAO_SENHA">Envio de e-mail para alter\xE7\xE3o de senha</option><option value="NFSE">Nota Fiscal</option><option value="ITEM_SERVICO">Servi\xE7o da Nota Fiscal</option><option value="EMAIL_NOTAFISCAL">Envio de e-mail da Nota Fiscal</option><option value="TERMO_CREDENCIAMENTO">Termo de Credenciamento</option><option value="EMAIL_CREDENCIAMENTO">Email de Credenciamento</option><option value="EMAIL_SOLICITADO_ACESSO_SEM_CADASTRO">Envio de e-mail para confirma\xE7\xE3o de acesso para usu\xE1rio solicitado sem cadastro</option><option value="EMAIL_SOLICITANTE_ACESSO">Envio de e-mail para confirma\xE7\xE3o de acesso para usu\xE1rio solicitante</option><option value="EMAIL_SOLICITADO_ACESSO_COM_CADASTRO">Envio de e-mail para usu\xE1rio solicitado com cadastro</option></select></div><div class="form-group"><label for="field_template">Template</label><summernote name="template" id="field_template" ng-model="template.template"></summernote><div ng-show="editForm.template.$invalid"><p class="help-block" ng-show="editForm.template.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-actions"><button type="button" class="btn btn-default" ui-sref="template"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form></div></div></div></div>');
$templateCache.put('app/entities/template/templates.html','<div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><span translate="nfseApp.template.home.title">Form</span></div><div class="ibox-content"><div class="row"><div class="col-md-8"><search-box ng-model="searchQuery" search-method="search()"></search-box></div><div class="col-md-4"><button class="btn btn-primary pull-right" ui-sref="template.new"><span class="fa fa-plus"></span> <span translate="nfseApp.template.home.createLabel">Create a new Template</span></button></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th>C\xF3digo</th><th>Tipo</th><th></th></tr></thead><tbody><tr ng-repeat="template in templates"><td><a ui-sref="template.detail({id:template.id})">{{template.id}}</a></td><td>{{template.tipo}}</td><td><div class="pull-right"><button type="submit" ui-sref="template.detail({id:template.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="template.edit({id:template.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ng-click="delete(template.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table><nav><ul class="pager"><li ng-show="links[\'first\']" ng-click="loadPage(links[\'first\'])"><a href="#">&lt;&lt;</a></li><li ng-show="links[\'prev\']" ng-click="loadPage(links[\'prev\'])"><a href="#">&lt;</a></li><li ng-show="links[\'next\']" ng-click="loadPage(links[\'next\'])"><a href="#">&gt;</a></li><li ng-show="links[\'last\']" ng-click="loadPage(links[\'last\'])"><a href="#">&gt;&gt;</a></li></ul></nav></div></div></div></div></div>');
$templateCache.put('app/entities/tomador/tomador-detail.html','<div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h4 class="modal-title" id="myTomadorLabel"><span translate="nfseApp.tomador.detail.title">Tomador</span> {{tomador.id}}</h4></div><div class="ibox-content"><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="save()"><div class="form-group"><div class="col-md-3"><label for="field_cpfCnpj">CPF ou CNPJ</label><input type="text" class="form-control" name="cpfCnpj" id="field_cpfCnpj" ui-br-cpfcnpj-mask readonly="readonly" ng-blur="loadInPessoaRepoByCpfCnpj()" ng-model="tomador.dadosPessoais.cpfCnpj" required></div><div class="col-md-6"><label for="field_nomeRazaoSocial">Nome ou Raz\xE3o Social</label><input type="text" class="form-control" name="nomeRazaoSocial" id="field_nomeRazaoSocial" ng-model="tomador.dadosPessoais.nomeRazaoSocial" readonly="readonly" required></div><div class="col-md-3"><label for="field_inscricaoEstadualRg">Inscricao Estadual ou RG</label><input type="text" class="form-control" name="inscricaoEstadualRg" id="field_inscricaoEstadualRg" readonly="readonly" ng-model="tomador.dadosPessoais.inscricaoEstadualRg" required></div></div><div class="form-group"><div class="col-md-3"><label for="field_inscricaoMunicipal">Inscri\xE7\xE3o Municipal</label><input type="text" class="form-control" name="inscricaoMunicipal" id="field_inscricaoMunicipal" readonly="readonly" ng-model="tomador.dadosPessoais.inscricaoMunicipal"></div><div class="col-md-6"><label for="field_nomeFantasia">Nome Fantasia</label><input type="text" class="form-control" name="nomeFantasia" id="field_nomeFantasia" readonly="readonly" ng-model="tomador.dadosPessoais.nomeFantasia"></div><div class="col-md-3"><label for="field_apelido">Apelido</label><input type="text" class="form-control" name="apelido" id="field_apelido" readonly="readonly" ng-model="tomador.dadosPessoais.apelido"></div></div><div class="form-group"><div class="col-md-6"><label for="field_email">e-Mail</label><input type="text" class="form-control" name="email" id="field_email" ng-model="tomador.dadosPessoais.email" readonly="readonly"></div><div class="col-md-3"><label for="field_telefone">Telefone</label><input type="text" class="form-control" name="telefone" id="field_telefone" ui-br-phone-number ng-model="tomador.dadosPessoais.telefone" readonly="readonly"></div><div class="col-md-3"><label for="field_celular">Celular</label><input type="text" class="form-control" name="celular" id="field_celular" disabled="disabled" ui-br-phone-number ng-model="tomador.dadosPessoais.celular"></div></div><div class="hr-line-dashed"></div><div class="form-group"><div class="col-md-3"><label for="field_cep">Cep</label><input type="text" class="form-control" name="cep" id="field_cep" ui-br-cep-mask readonly="readonly" ng-model="tomador.dadosPessoais.cep" required></div><div class="col-md-9"><label for="field_logradouro">Logradouro</label><input type="text" class="form-control" name="logradouro" id="field_logradouro" ng-model="tomador.dadosPessoais.logradouro" readonly="readonly" required></div></div><div class="form-group"><div class="col-md-9"><label for="field_municipio">Munic\xEDpio</label><input type="text" class="form-control" name="municipio" id="field_municipio" ng-model="tomador.dadosPessoais.municipio.nome" readonly="readonly" required></div><div class="col-md-3"><label for="field_estado">Estado</label><input type="text" class="form-control" name="estado" id="field_estado" readonly="readonly" ng-model="tomador.dadosPessoais.municipio.estado" required></div></div><div class="form-group"><div class="col-md-6"><label for="field_bairro">Bairro</label><input type="text" class="form-control" name="bairro" id="field_bairro" readonly="readonly" ng-model="tomador.dadosPessoais.bairro"></div><div class="col-md-2"><label for="field_numero">N\xFAmero</label><input type="text" class="form-control" name="numero" id="field_numero" readonly="readonly" ng-model="tomador.dadosPessoais.numero" required></div><div class="col-md-4"><label for="field_complemento">Complemento</label><input type="text" class="form-control" name="complemento" id="field_complemento" readonly="readonly" ng-model="tomador.dadosPessoais.complemento"></div></div><div class="hr-line-dashed"></div><div class="form-actions"><button type="submit" ui-sref="tomador" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div></form></div></div></div></div>');
$templateCache.put('app/entities/tomador/tomador-edit.html','<div class="row"><div class="col-lg-12"><form name="editForm" class="form-horizontal" role="form" novalidate ng-submit="save()"><div class="form-group"><div class="col-md-3"><label for="field_cpfCnpj">CPF ou CNPJ</label><input type="text" class="form-control" name="cpfCnpj" id="field_cpfCnpj" ui-br-cpfcnpj-mask ng-disabled="tomador.id" ng-blur="loadInPessoaRepoByCpfCnpj()" ng-model="tomador.dadosPessoais.cpfCnpj" required><div ng-show="editForm.cpfCnpj.$invalid"><p class="help-block" ng-show="editForm.cpfCnpj.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.cpfCnpj.$error.exists" translate="nfseApp.dadosPessoais.validation.cpfCnpj.exists">J\xE1 existe</p><p class="help-block" ng-show="editForm.cpfCnpj.$error.cpf || editForm.cpfCnpj.$error.cnpj">CPF ou CNPJ inv\xE1lido</p></div></div><div class="col-md-6"><label for="field_nomeRazaoSocial">Nome ou Raz\xE3o Social</label><input type="text" class="form-control" name="nomeRazaoSocial" id="field_nomeRazaoSocial" ng-model="tomador.dadosPessoais.nomeRazaoSocial" required><div ng-show="editForm.nomeRazaoSocial.$invalid"><p class="help-block" ng-show="editForm.nomeRazaoSocial.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-3"><label for="field_inscricaoEstadualRg">Inscricao Estadual ou RG</label><input type="text" class="form-control" name="inscricaoEstadualRg" id="field_inscricaoEstadualRg" ng-model="tomador.dadosPessoais.inscricaoEstadualRg"></div></div><div class="form-group"><div class="col-md-3"><label for="field_inscricaoMunicipal">Inscri\xE7\xE3o Municipal</label><input type="text" class="form-control" name="inscricaoMunicipal" id="field_inscricaoMunicipal" ng-model="tomador.dadosPessoais.inscricaoMunicipal"></div><div class="col-md-6"><label for="field_nomeFantasia">Nome Fantasia</label><input type="text" class="form-control" name="nomeFantasia" id="field_nomeFantasia" ng-model="tomador.dadosPessoais.nomeFantasia"></div><div class="col-md-3"><label for="field_apelido">Apelido</label><input type="text" class="form-control" name="nomeFantasia" id="field_apelido" ng-model="tomador.dadosPessoais.apelido"></div></div><div class="form-group"><div class="col-md-6"><label for="field_email">e-Mail</label><input type="text" class="form-control" name="email" id="field_email" ng-model="tomador.dadosPessoais.email"></div><div class="col-md-3"><label for="field_telefone">Telefone</label><input type="text" class="form-control" name="telefone" id="field_telefone" ui-br-phone-number ng-model="tomador.dadosPessoais.telefone"><div ng-show="editForm.telefone.$invalid"><p class="help-block" ng-show="editForm.telefone.$error || editForm.telefone.$error">Telefone inv\xE1lido</p></div></div><div class="col-md-3"><label for="field_celular">Celular</label><input type="text" class="form-control" name="celular" id="field_celular" ui-br-phone-number ng-model="tomador.dadosPessoais.celular"><div ng-show="editForm.celular.$invalid"><p class="help-block" ng-show="editForm.celular.$error || editForm.celular.$error">Celular inv\xE1lido</p></div></div></div><div class="hr-line-dashed"></div><div class="form-group"><div class="col-md-2"><label for="field_cep">Cep</label><input type="text" class="form-control" name="id" id="field_cep" ui-br-cep-mask ng-blur="loadEnderecoByCEP(tomador.dadosPessoais.cep)" ng-model="tomador.dadosPessoais.cep"></div><div class="col-md-8"><label for="field_nome_municipio">Munic\xEDpio</label><div class="input-group"><input type="text" class="form-control" name="nome_municipio" id="field_nome_municipio" disabled="disabled" ng-model="tomador.dadosPessoais.municipio.nome"> <span class="input-group-btn"><button type="button" class="btn btn-info" ng-click="searchMunicipio()"><span class="glyphicon glyphicon-search"></span></button></span></div></div><div class="col-md-2"><label for="field_estado_municipio">Estado</label><input type="text" class="form-control" name="estado_municipio" id="field_estado_municipio" disabled="disabled" ng-model="tomador.dadosPessoais.municipio.estado"></div></div><div class="form-group"><div class="col-md-12"><label for="field_logradouro">Logradouro</label><input type="text" class="form-control" name="logradouro" id="field_logradouro" ng-model="tomador.dadosPessoais.logradouro"></div></div><div class="form-group"><div class="col-md-6"><label for="field_bairro">Bairro</label><input type="text" class="form-control" name="bairro" id="field_bairro" ng-model="tomador.dadosPessoais.bairro"></div><div class="col-md-2"><label for="field_numero">N\xFAmero</label><input type="text" class="form-control" name="numero" id="field_numero" ng-model="tomador.dadosPessoais.numero"></div><div class="col-md-4"><label for="field_complemento">Complemento</label><input type="text" class="form-control" name="complemento" id="field_complemento" ng-model="tomador.dadosPessoais.complemento"></div></div><div class="hr-line-dashed"></div><div class="form-actions"><button type="button" class="btn btn-default" ui-sref="tomador"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp; <span translate="entity.action.save">Save</span></button></div></form></div></div>');
$templateCache.put('app/entities/tomador/tomador-search.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title" id="myServicoLabel" translate="nfseApp.tomador.home.title">Create or edit a Servico</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><div class="form-group input-group"><input type="text" class="form-control" name="searchQuery" ng-enter="search()" ng-model="searchQuery" id="searchQuery" placeholder="{{\'global.form.search\' | translate}}"> <span class="input-group-btn"><button class="btn btn-info" type="button" ng-click="search()"><i class="fa fa-search"></i></button></span></div></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Apelido</th><th>Nome ou Raz\xE3o Social</th><th>Nome Fantasia</th><th>CPF ou CNPJ</th><th>e-Mail</th><th></th></tr></thead><tbody><tr ng-repeat="tomador in tomadors"><td>{{tomador.dadosPessoais.apelido}}</td><td>{{tomador.dadosPessoais.nomeRazaoSocial}}</td><td>{{tomador.dadosPessoais.nomeFantasia}}</td><td>{{tomador.dadosPessoais.cpfCnpj}}</td><td>{{tomador.dadosPessoais.email}}</td><td class="pull-right"><button type="submit" ng-click="ok(tomador)" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-check"></span></button></td></tr></tbody></table></div><span nfse-app-pagination></div>');
$templateCache.put('app/entities/tomador/tomadors.html','<div class="row"><div class="col-lg-12"><div class="row"><div class="col-md-8"><search-box ng-model="searchQuery" search-method="search()"></search-box></div><div class="col-md-4"><button class="btn btn-primary pull-right" ui-sref="tomador.new"><span class="fa fa-plus"></span> Criar novo tomador</button></div></div><div class="table-responsive"><table class="table table-striped small"><thead><tr><th>C\xF3digo</th><th>Apelido</th><th>Nome ou Raz\xE3o Social</th><th>Nome Fantasia</th><th>CPF ou CNPJ</th><th>E-mail</th><th></th></tr></thead><tbody><tr ng-repeat="tomador in tomadors"><td><a ui-sref="tomador.detail({id:tomador.id})">{{tomador.id}}</a></td><td>{{tomador.dadosPessoais.apelido}}</td><td>{{tomador.dadosPessoais.nomeRazaoSocial}}</td><td>{{tomador.dadosPessoais.nomeFantasia}}</td><td>{{tomador.dadosPessoais.cpfCnpj}}</td><td>{{tomador.dadosPessoais.email}}</td><td><div class="pull-right"><button type="submit" ui-sref="tomador.detail({id:tomador.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="tomador.edit({id:tomador.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ng-click="delete(tomador.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table><div class="col-md-12 text-right"><button class="btn btn-danger btn-outline" title="Clique para baixar as notas da tabela acima em formato de PDF" ng-click="baixarPDF()"><i class="fa fa-download"></i> PDF</button> <button class="btn btn-primary btn-outline" title="Clique para baixar as notas da tabela acima em formato de XLS" ng-click="baixarXls()"><i class="fa fa-download"></i> XLS</button></div><span nfse-app-pagination></div></div></div>');
$templateCache.put('app/entities/wait-report/wait-report.html','<div class="modal-body"><div ng-if="webReport == null || !webReport.finalizadoEm"><div class="text-center">O relat\xF3rio est\xE1 sendo gerado. Por favor aguarde...<br><img ng-src="/assets/images/ajaxloading.gif" width="50" height="50"></div></div><div ng-if="webReport != null && webReport.finalizadoEm"><div class="text-center">Relat\xF3rio pronto. Clique em <strong>Imprimir</strong> para visualizar o relat\xF3rio.</div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="cancel()">Cancelar</button> <button type="button" class="btn btn-success" ng-disabled="webReport == null || !webReport.finalizadoEm" ng-click="imprimir()">Imprimir</button></div>');
$templateCache.put('app/externo/fale-conosco/fale-conosco.html','<div><div class="row"><div class="col-md-12"><form class="form-horizontal" name="form" role="form" ng-submit="save()"><div class="ibox float-e-margins"><div class="ibox-title"><h4>Fale Conosco</h4></div><div class="ibox-content"><div class="row m-t-md"><div class="col-md-12 text-center"><a ng-click="atribuirTipo(\'DENUNCIA\')"><div class="col-md-2"><div ng-class="faleConosco.tipo == \'DENUNCIA\' ? \'widget p-lg text-center red-bg \' : \'widget silver-bg  p-lg text-center\'"><div class="m-b-md"><i class="fa fa-bullhorn fa-2x"></i></div><div class="m-t-xs"><h3 class="font-bold no-margins">DEN\xDANCIA</h3></div></div></div></a><a ng-click="atribuirTipo(\'RECLAMACAO\')"><div class="col-md-2"><div ng-class="faleConosco.tipo == \'RECLAMACAO\' ? \'widget p-lg text-center orange-bg\' : \'widget silver-bg p-lg text-center\'"><div class="m-b-md"><i class="fa fa-thumbs-o-down fa-2x"></i></div><div class="m-t-xs"><h3 class="font-bold no-margins">RECLAMA\xC7\xC3O</h3></div></div></div></a><a ng-click="atribuirTipo(\'SOLICITACAO\')"><div class="col-md-2"><div ng-class="faleConosco.tipo == \'SOLICITACAO\' ? \'widget p-lg text-center green-bg\' : \'widget silver-bg p-lg text-center\'"><div class="m-b-md"><i class="fa fa-file-text-o fa-2x"></i></div><div class="m-t-xs"><h3 class="font-bold no-margins">SOLICITA\xC7\xC3O</h3></div></div></div></a><a ng-click="atribuirTipo(\'SUGESTAO\')"><div class="col-md-2"><div ng-class="faleConosco.tipo == \'SUGESTAO\' ? \'widget p-lg text-center yellow-bg\' : \'widget silver-bg p-lg text-center\'"><div class="m-b-md"><i class="fa fa-commenting fa-2x"></i></div><div class="m-t-xs"><h3 class="font-bold no-margins">SUGEST\xC3O</h3></div></div></div></a><a ng-click="atribuirTipo(\'ELOGIO\')"><div class="col-md-2"><div ng-class="faleConosco.tipo == \'ELOGIO\' ? \'widget p-lg text-center blue-bg\' : \'widget silver-bg p-lg text-center\'"><div class="m-b-md"><i class="fa fa-thumbs-o-up fa-2x"></i></div><div class="m-t-xs"><h3 class="font-bold no-margins">ELOGIO</h3></div></div></div></a></div></div><div class="row m-t-md" ng-show="faleConosco.tipo"><div class="col-md-12"><div class="form-group"><div class="col-md-12"><label for="field_assunto">Assunto <span class="text-danger">*</span></label><input type="text" class="form-control" name="assunto" id="field_assunto" placeholder="Informe o Assunto" required ng-model="faleConosco.assunto"></div></div><div class="form-group"><div class="col-md-12"><label for="nome">Nome Completo<span class="text-danger">*</span></label><input type="text" class="form-control" name="nome" id="nome" placeholder="Informe seu nome completo" required ng-model="faleConosco.nome"></div></div><div class="form-group"><div class="col-md-6"><label>E-mail <span class="text-danger">*</span></label><input type="email" class="form-control" name="email" placeholder="informe o seu E-mail" required ng-model="faleConosco.email" minlength="5" maxlength="100"></div><div class="col-md-3"><label for="field_telefone">Telefone <span class="text-danger">*</span></label><input type="text" class="form-control" name="telefone" id="field_telefone" placeholder="Informe o Telefone" required ui-br-phone-number ng-model="faleConosco.telefone"></div></div><div class="form-group"><div class="col-md-12"><label for="field_mensagem">Mensagem <span class="text-danger">*</span></label><textarea type="text" ng-model="faleConosco.mensagem" class="form-control" id="field_mensagem" required name="telefone" maxlength="3000">\n                                    </div>\n                                </div>\n\n                                <hr>\n                                <div class="form-group">\n                                    <div class="col-md-1">\n                                        <button type="submit" ui-sref="login" class="btn btn-danger">\n                                            <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span>\n                                        </button>\n                                    </div>\n                                    <div class="col-md-3">\n                                        <button type="submit" ng-disabled="form.$invalid" class="btn btn-primary btn-block">\n                                            <span class="glyphicon glyphicon-arrow-right"></span>&nbsp;\n                                            Enviar</button></div></div></div></div></div></div></form></div></div></div>');
$templateCache.put('app/externo/legislacao/legislacao-detalhes.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title" id="myMunicipioLabel"><strong>{{legislacao.tipoLegislacaoDTO.descricao}}</strong><div class="font-bold">{{legislacao.nome}}</div></h4></div><div class="modal-body"><div class="row"><p class="font-bold">{{legislacao.sumula}}</p><div class="p-xs"><a class="btn btn-xs btn-success" style="color: white" href="/api/arquivo/{{legislacao.arquivoDTO.id}}" target="_blank"><i class="fa fa-download"></i> Download</a></div></div></div>');
$templateCache.put('app/externo/legislacao/legislacao.html','<div class="row"><div class="col-lg-12"><div ng-repeat="legislacao in legislacoes"><div class="col-lg-4"><div class="contact-box center-version text-center" style="border: none; background-color: transparent !important"><img class="img-circle" src="../../../assets/images/legislacao.png" width="100" height="100"><h3 class="m-b-xs"><strong>{{legislacao.tipoLegislacaoDTO.descricao}}</strong></h3><div class="font-bold">{{legislacao.nome}}</div><a class="font-bold" style="color: dodgerblue" ng-click="verDetalhes(legislacao)">Exibir S\xFAmula</a><div class="p-xs"><a class="btn btn-xs btn-success" style="color: white" href="/api/arquivo/{{legislacao.arquivoDTO.id}}" target="_blank"><i class="fa fa-download"></i> Download</a></div></div></div></div></div></div>');
$templateCache.put('app/externo/manual/manual-detalhes.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title" id="myMunicipioLabel"><strong>{{manual.tipoManualDTO.descricao}}</strong><div class="font-bold">{{manual.nome}}</div></h4></div><div class="modal-body"><div class="row"><p class="font-bold">{{manual.resumo}}</p><div class="p-xs"><a class="btn btn-xs btn-success" style="color: white" href="/api/arquivo/{{manual.arquivoDTO.id}}" target="_blank"><i class="fa fa-download"></i> Download</a></div></div></div>');
$templateCache.put('app/externo/manual/manual.html','<div class="row"><div class="col-lg-12"><div ng-repeat="manual in manuais"><div class="col-lg-4"><div class="contact-box center-version text-center" style="border: none; background-color: transparent !important"><img class="img-circle" src="../../../../assets/images/{{manual.arquivoDTO.nome &&\n                         !manual.arquivoDTO.nome.includes(\'.pdf\') ?  \'path.png\' :\'pdf-icon.png\'}}" width="100" height="100"><h3 class="m-b-xs"><strong>{{manual.tipoManualDTO.descricao}}</strong></h3><div class="font-bold">{{manual.nome}}</div><a class="font-bold" style="color: dodgerblue" ng-click="verDetalhes(manual)">Exibir Resumo</a><div class="p-xs"><a class="btn btn-xs btn-success" style="color: white" href="/api/arquivo/{{manual.arquivoDTO.id}}" target="_blank"><i class="fa fa-download"></i> Download</a></div></div></div></div></div></div>');
$templateCache.put('app/externo/nota-premiada/nota-premiada-detalhes-bilhete-premiado.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title" id="myMunicipioLabel"><strong>{{nota.descricao}}</strong><!--<div class="font-bold">{{legislacao.nome}}</div>--></h4></div><div class="modal-body"><div class="row" style="overflow-x: scroll;  max-height: 300px"><h1>Bilhetes Premiados</h1><div class="table-responsive"><table class="table table-striped table-hover small"><thead><tr><th>C\xF3digo do Bilhete</th><th>Pr\xEAmio</th><th>Pessoa</th><th>NFSe N\xFAmero</th><th>Emiss\xE3o</th><th></th></tr></thead><tbody><tr ng-repeat="bilhete in bilhetes | orderBy:\'-dataSorteio\'"><td>{{bilhete.id}}</td><td>{{bilhete.premio}}</td><td>{{bilhete.pessoa}}</td><td>{{bilhete.numeroNotaFiscal}}</td><td>{{bilhete.emissaoNotaFiscal | date : \'dd/MM/yyyy\'}}</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/externo/nota-premiada/nota-premiada-detalhes-bilhete.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title" id="myMunicipioLabel"><strong>{{nota.descricao}}</strong><!--<div class="font-bold">{{legislacao.nome}}</div>--></h4></div><div class="modal-body"><div class="row" style="overflow-x: scroll;  max-height: 300px"><h1>Todos os bilhetes</h1><div class="table-responsive"><table class="table table-striped table-hover small"><thead><tr><th>C\xF3digo do Bilhete</th><th>Pr\xEAmio</th><th>Pessoa</th><th>NFSe N\xFAmero</th><th>Emiss\xE3o</th><th>Prestador</th><th></th></tr></thead><tbody><tr ng-repeat="bilhete in bilhetes | orderBy:\'-dataSorteio\'"><td>{{bilhete.id}}</td><td>{{bilhete.premio}}</td><td>{{bilhete.pessoa}}</td><td>{{bilhete.numeroNotaFiscal}}</td><td>{{bilhete.emissaoNotaFiscal | date : \'dd/MM/yyyy\'}}</td><td>{{bilhete.prestador}}</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/externo/nota-premiada/nota-premiada-detalhes.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title" id="myMunicipioLabel"><strong>{{nota.descricao}}</strong><!--<div class="font-bold">{{legislacao.nome}}</div>--></h4></div><div class="modal-body"><div class="row"><div class="table-responsive"><table class="table table-striped table-hover small"><thead><tr><th>Data do Sorteio</th><th>Pr\xEAmio</th><th>Valor do pr\xEAmio (R$)</th><th>Quantidade</th><th></th></tr></thead><tbody><tr ng-repeat="premio in premios | orderBy:\'-dataSorteio\'"><td>{{premio.dataSorteio | date : \'dd/MM/yyyy\'}}</td><td>{{premio.premio}}</td><td>{{premio.valorPremio | currency : \'R$ \'}}</td><td>{{premio.quantidade }}</td></tr></tbody></table><span nfse-app-pagination></div></div></div>');
$templateCache.put('app/externo/nota-premiada/nota-premiada.html','<div class="row"><div class="col-lg-12"><div class="col-lg-6"><h3>Campanhas</h3><div ng-repeat="nota in notas"><div class="ibox"><div class="ibox-content"><div class="row"><div class="col-md-8 text-center"><i class="fa fa-trophy fa-5x"></i><h1 class="m-xs">{{nota.descricao}}</h1></div><div class="col-md-4 text-center"><a class="font-bold" ng-click="verDetalhes(nota)">Exibir pr\xEAmios</a><br><br><a ng-click="verBilhetesPremiados(nota)">Exibir bilhete(s) premiado(s)</a><br><a has-role="ROLE_USER" ng-click="verBilhetes(nota)">Exibir meus bilhete(s)</a><br><small><a class="text-muted text-danger" has-role="ROLE_USER" ng-click="anularParticipacaoCampanha(nota)"><i class="fa fa-ban"></i> N\xE3o quero participar</a></small><div class="p-xs"><a class="btn btn-xs btn-success" style="color: white" href="/api/arquivo/{{nota.arquivoDTO.id}}" target="_blank" ng-disabled="{{nota.arquivoDTO.id == null}}"><i class="fa fa-download"></i> Download legisla\xE7\xE3o</a></div></div></div></div></div></div></div><div class="col-lg-6"><h3>Calend\xE1rio de Sorteios</h3><div class="ibox"><div class="ibox-content"><div class="table-responsive"><table class="table table-striped table-hover small"><thead><tr><th>Data do Sorteio</th><th>Pr\xEAmio</th><th>Valor do pr\xEAmio (R$)</th><th>Quantidade</th><th></th></tr></thead><tbody><tr ng-repeat="premio in premios | orderBy:\'-dataSorteio\'"><td>{{premio.dataSorteio | date : \'dd/MM/yyyy\'}}</td><td>{{premio.premio}}</td><td>{{premio.valorPremio | currency : \'R$ \'}}</td><td>{{premio.quantidade }}</td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/externo/perguntas-respostas/perguntas-respostas.html','<div class="row"><div class="col-lg-12"><div class="form-group"><input type="text" class="form-control" ng-model="searchFilter" id="searchQuery" placeholder="Pesquisar ..."></div><div class="faq-item" ng-repeat="perguntaAndResposta in perguntasAndRespostas | filter:searchFilter"><div class="row"><a class="faq-question" data-toggle="collapse" href="#/perguntas-respostas#teste{{$index}}" aria-expanded="false">{{perguntaAndResposta.assuntoNfseDTO.descricao}} - {{perguntaAndResposta.pergunta}}?</a></div><div class="row"><div id="teste{{$index}}" class="panel-collapse collapse" aria-expanded="true" style=""><div class="faq-answer"><p>{{perguntaAndResposta.resposta}}</p></div></div></div></div></div></div>');
$templateCache.put('app/externo/pesquisa-cnae/pesquisa-cnae.html','<div class="row"><div class="col-md-5 text-center"><button class="btn btn-success" ng-class="{\'btn-outline\': !pesquisarPorCnae}" ng-click="pesquisarPorCnae = true" type="button"><i class="fa {{pesquisarPorCnae? \'fa-check-circle-o\':\'fa-circle-o\'}}"></i> Buscar CNAE por Servi\xE7o</button> <button class="btn btn-success" ng-class="{\'btn-outline\': pesquisarPorCnae}" ng-click="pesquisarPorCnae = false" type="button"><i class="fa {{!pesquisarPorCnae? \'fa-check-circle-o\':\'fa-circle-o\'}}"></i> Buscar Servi\xE7o por CNAE</button></div><div class="col-md-7"><search-box ng-model="filtro" search-method="buscarCneaOrServico()" disabled="true"></search-box></div><div class="col-12" ng-show="cnaes != null"><table class="table table-striped"><thead><tr><th>C\xF3digo</th><th>Descri\xE7\xE3o</th></tr></thead><tbody><tr ng-repeat="cnae in cnaes"><td>{{cnae.codigo}}</td><td>{{cnae.descricao}}</td></tr></tbody></table><span nfse-app-pagination></div><div class="col-md-12 text-right" ng-show="cnaes != null"><button class="btn btn-danger btn-outline" title="Clique para baixar as notas da tabela acima em formato de PDF" ng-click="baixar(\'pdf\')"><i class="fa fa-download"></i> PDF</button> <button class="btn btn-primary btn-outline" title="Clique para baixar as {{pesquisarPorCnae}} rnotas da tabela acima em formato de XLS" ng-click="baixar(\'xls\')"><i class="fa fa-download"></i> XLS</button></div></div>');
$templateCache.put('app/externo/reciboRetencaoIss/reciboRetencaoIss.html','<div class="row" ng-show="!pesquisou"><div class="col-md-12"><div class="row m-b-md"><div class="col-md-3"><div vc-recaptcha ng-model="recaptcha" size="normal" key="\'6LeDfJwUAAAAAK9fxbM4eNjCLljIns6edxAr6ixY\'"></div></div></div><div class="row m-b-md"><div class="form-group col-md-4"><label class="center-block" for="cpfCnpj">CPF/CNPJ (Prestador de Servi\xE7o)</label><div class="input-group"><input type="text" class="form-control" name="cpfCnpj" id="cpfCnpj" ui-br-cpfcnpj-mask="" ng-model="cpfCnpj"><div class="input-group-btn"><button type="button" ng-click="loadAll()" class="btn btn-success btn-block"><span class="fa fa-search"></span></button></div></div></div></div></div></div><div class="row" ng-show="pesquisou"><div ng-if="!notaFiscals || notaFiscals.length == 0"><div class="alert alert-warning">N\xE3o h\xE1 documentos declarados para o Prestador de Servi\xE7os com o CPF/CNPJ <strong>{{cpfCnpjTomador | brCpfCnpj}}</strong>.</div></div><div id="div-tabela-notas" class="table-responsive" ng-if="notaFiscals && notaFiscals.length > 0"><table class="table table-striped table-hover small"><thead><tr><th colspan="10">Prestador de Servi\xE7o: {{notaFiscals[0].cpfCnpjPrestador | brCpfCnpj}} - {{notaFiscals[0].nomePrestador}}</th></tr><tr><th colspan="10">Documentos declarados pelo Tomador de Servi\xE7o</th></tr><tr><th>CNPJ Tomador</th><th>Raz\xE3o Social do Tomador</th><th>N\xB0 do Documento</th><th>Emiss\xE3o</th><th class="text-right">Total Servi\xE7os</th><th class="text-right">Dedu\xE7\xF5es Legais</th><th class="text-right">Base Calculo</th><th class="text-right">ISS</th><th class="text-center">Situa\xE7\xE3o</th><th class="text-center">#</th></tr></thead><tbody><tr ng-repeat="notaFiscal in notaFiscals"><td>{{notaFiscal.cpfCnpjTomador | brCpfCnpj}}</td><td>{{notaFiscal.nomeTomador}}</td><td>{{notaFiscal.numero}}</td><td>{{notaFiscal.emissao | date : \'dd/MM/yyyy\'}}</td><td class="text-right">{{notaFiscal.totalServicos | currency : \'R$ \'}}</td><td class="text-right">{{notaFiscal.deducoes | currency : \'R$ \'}}</td><td class="text-right">{{notaFiscal.baseCalculo | currency : \'R$ \'}}</td><td class="text-right">{{notaFiscal.issCalculado | currency : \'R$ \'}}</td><td class="text-center"><span class="label label-primary">{{"nfseApp.SituacaoParcela." + notaFiscal.situacaoDebito | translate}}</span></td><td class="text-center"><button type="button" class="btn btn-xs" ng-disabled="!notaFiscal.permiteImpressao" ng-click="imprimirRecibo(notaFiscal.id)"><i class="fa fa-print"></i></button></td></tr></tbody></table><span nfse-app-pagination></div><div class="row m-b-md"><div class="col-md-3"><button ng-click="novaConsulta()" class="btn btn-success btn-block"><span class="fa fa-eraser"></span> <span>Nova Consulta</span></button></div></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><div class="ibox float-e-margins"><div class="ibox-title"><h4>Gerar nova senha</h4></div><div class="ibox-content"><div class="row"><div class="col-md-12"><div class="text-center"><div class="alert alert-danger" ng-show="keyMissing"><strong>A chave de redefini\xE7\xE3o de senha \xE9 inv\xE1lida.</strong></div><div class="alert alert-warning" ng-hide="success || keyMissing"><p>Escolha uma nova senha</p></div><div class="alert alert-danger" ng-show="error"><p>Sua senha n\xE3o pode ser reiniciada. A solicita\xE7\xE3o de "esqueci minha senha" \xE9 valida por 24 horas.</p></div><div class="alert alert-success" ng-show="success"><p><strong>Sua nova senha foi gerada.</strong> Acessa a p\xE1gina de <a href="#/login">login</a>, informe sua nova senha e tenha acesso ao sistema.</p></div><div class="alert alert-danger" ng-show="doNotMatch">As senhas informadas n\xE3o s\xE3o iguais.</div></div><div ng-hide="keyMissing"><form ng-show="!success" name="form" role="form" novalidate ng-submit="finishReset()" show-validation><div class="form-group"><label>Nova Senha</label><input type="password" class="form-control" name="password" placeholder="Nova Senha" ng-model="resetAccount.password" ng-minlength="5" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Informe a nova senha.</p><p class="help-block" ng-show="form.password.$error.minlength">Sua senha deve ter pelo menos 5 caracteres.</p><p class="help-block" ng-show="form.password.$error.maxlength">Sua senha n\xE3o pode ter mais de 50 caracteres.</p></div><password-strength-bar password-to-check="resetAccount.password"></password-strength-bar></div><div class="form-group"><label>Confirma\xE7\xE3o de Nova Senha</label><input type="password" class="form-control" name="confirmPassword" placeholder="Confirme sua nova senha" ng-model="confirmPassword" ng-minlength="5" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Informe a nova senha.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Sua senha deve ter pelo menos 5 caracteres.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Sua senha n\xE3o pode ter mais de 50 caracteres</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary btn-block">Gerar nova senha</button></form></div></div></div></div></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-lg-offset-2"><div class="ibox float-e-margins"><div class="ibox-title"><h4>Gerar nova senha</h4></div><div class="ibox-content"><div class="row"><div class="col-md-12"><div class="alert alert-warning" ng-hide="success"><p>Informe o seu usu\xE1rio de acesso.</p></div><form ng-show="!success" name="form" role="form" novalidate ng-submit="requestReset()" show-validation><div class="form-group"><label>Usu\xE1rio</label><input type="text" class="form-control" name="login" placeholder="Seu usu\xE1rio" ng-model="resetAccount.login" ng-maxlength="100" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required">Informe o usu\xE1rio.</p></div></div><div class="form-group"><div class="col-md-10"><button type="submit" ui-sref="login" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span>Voltar</span></button></div><div class="col-md-2"><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Continuar</button></div></div></form></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/notaFiscal/cancelamento/cancelamento.html','<div class="row"><div class="col-lg-12"><div class="row m-b-md"><div class="col-md-12"><search-box ng-model="searchQuery" search-method="loadAll()"></search-box></div></div><div id="div-tabela-notas" class="table-responsive"><table class="table table-striped table-hover small"><thead><tr><th>Op\xE7\xF5es</th><th>N\xFAmero</th><th>Emiss\xE3o</th><th>Tomador</th><th class="text-center">ISS Retido?</th><th class="text-right">Valor Servi\xE7os</th><th class="text-right">Base de Calculo</th><th class="text-right">Valor ISS</th><th>RPS</th></tr></thead><tbody><tr ng-repeat="notaFiscal in notaFiscals"><td class="dropdown"><button class="btn btn-white btn-sm dropdown-toggle" data-toggle="dropdown" type="button" ng-disabled="!notaFiscal.autorizarCancelamento"><i class="fa fa-caret-down">Op\xE7\xF5es</button><ul class="dropdown-menu"><li><a type="submit" ng-click="deferir(notaFiscal.id)" title="Clique para editar o documento" class="text-primary"><i class="fa fa-check"></i> Deferir</a></li><li><a type="submit" ng-click="indeferir(notaFiscal.id)" title="Clique para solicitar o cancelamento do documento" class="text-danger"><i class="fa fa-ban"></i> Indeferir</a></li></ul></td><td><a ui-sref="notaFiscal.detail({id:notaFiscal.id})">{{notaFiscal.numero}}</a></td><td>{{notaFiscal.emissao | date : \'dd/MM/yyyy\'}}</td><td><span ng-if="notaFiscal.modalidade == \'NAO_IDENTIFICADO\'">{{\'nfseApp.ModalidadeNota.\' + notaFiscal.modalidade | translate}}</span> <span ng-if="notaFiscal.cpfCnpjTomador">({{notaFiscal.cpfCnpjTomador | brCpfCnpj}})&ensp;</span> {{notaFiscal.nomeTomador}}</td><td class="text-center">{{notaFiscal.issRetido ? \'Sim\': \'N\xE3o\'}}</td><td class="text-right">{{notaFiscal.totalServicos | currency : \'R$ \'}}</td><td class="text-right">{{notaFiscal.baseCalculo | currency : \'R$ \'}}</td><td class="text-right">{{notaFiscal.iss | currency : \'R$ \'}}</td><td class="text-center"><a ui-sref="rPS.detail({id:notaFiscal.idRps})">{{notaFiscal.codigoRps}}</a></td></tr><tr><td colspan="4" class="text-right font-bold">Totais:</td><td class="font-bold">{{getTotalServicos() | currency : \'R$ \'}}</td><td class="font-bold">{{getTotalBaseCalculo() | currency : \'R$ \'}}</td><td class="font-bold">{{getTotalIss() | currency : \'R$ \'}}</td><td colspan="2"></td></tr></tbody></table><span nfse-app-pagination></div></div></div>');
$templateCache.put('app/entities/notaFiscal/carta-correcao/carta-correcao.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="cancel()">&times;</button><h4 class="modal-title" id="myServicoLabel">Carta de Corre\xE7\xE3o do Documento Emitido</h4></div><div class="modal-body"><form name="editForm" role="form" novalidate ng-show="operacaoNovo"><div class="row" ng-show="!continua"><div class="col-md-12 small text-center"><h3><i class="fa fa-exclamation-triangle"></i>&nbsp; Aten\xE7\xE3o</h3></div><div class="col-md-12"><p>A Carta de Corre\xE7\xE3o permite a regulariza\xE7\xE3o de erro ocorrido na emiss\xE3o da NFS-e, DESDE QUE O ERRO N\xC3O ESTEJA RELACIONADO COM:</p><p>I. As vari\xE1veis que determinam o valor do imposto tais como: base de c\xE1lculo, al\xEDquota, valor das dedu\xE7\xF5es, c\xF3digo de servi\xE7o, diferen\xE7a de pre\xE7o, quantidade e valor da presta\xE7\xE3o de servi\xE7os;</p><p>II. A corre\xE7\xE3o de dados cadastrais que implique qualquer altera\xE7\xE3o do prestador ou tomador de servi\xE7os;</p><p>III. O n\xFAmero da nota e a data de emiss\xE3o;</p><p>IV. A indica\xE7\xE3o de isen\xE7\xE3o ou imunidade relativa ao ISS;</p><p>V. A indica\xE7\xE3o da exist\xEAncia de a\xE7\xE3o judicial relativa ao ISS;</p><p>VI. A indica\xE7\xE3o do local de incid\xEAncia do ISS;</p><p>VII. A indica\xE7\xE3o da responsabilidade pelo recolhimento do ISS;</p><p>VIII. O n\xFAmero e a data de emiss\xE3o do Recibo Provis\xF3rio de Servi\xE7os - RPS.</p><br><p>A NFS-e dever\xE1 ser cancelada quando houver algum erro relacionado com os dados mencionados nos itens acima devendo ser emitida uma nova NFS-e com os dados corrigidos.</p></div></div><div ng-show="continua"><div class="row"><div class="form-group col-md-4"><label for="field_dataEmissao">Data de emiss\xE3o</label><input type="date" ng-model="carta.dataEmissao" required name="dataEmissao" id="field_dataEmissao" class="form-control"></div><div class="form-group col-md-4"><label>N\xFAmero Sequencial da CC-e</label><input class="form-control" value="gerado automaticamente" disabled="disabled"></div><div class="form-group col-md-4"><label>N\xFAmero da NFS-e</label><input class="form-control" ng-model="carta.numero" disabled="disabled"></div></div><div class="row"><div class="form-group col-md-4"><label>C\xF3digo de Verifica\xE7\xE3o</label><input class="form-control" value="gerado automaticamente" disabled="disabled"></div><div class="form-group col-md-8"><label>Identifica\xE7\xE3o do Tomador</label><input class="form-control" ng-model="carta.tomador" disabled="disabled"></div></div><div class="row"><div class="form-group col-md-12"><label>Descri\xE7\xE3o da Altera\xE7\xE3o</label><textarea class="form-control" ng-model="carta.descricaoAlteracao" required></textarea></div></div></div></form><div ng-show="!operacaoNovo"><table class="table table-striped"><thead><tr><th>Impress\xE3o</th><th>Sequencial</th><th>Data de Emiss\xE3o</th><th>Tomador</th></tr></thead><tbody><tr ng-repeat="cc in cartas"><td><button ng-click="imprimirCarta(cc.id)" class="btn btn-sm btn-success"><span class="glyphicon glyphicon-print"></span></button></td><td>{{cc.sequencialCartaCorrecao}}</td><td>{{formatDate(cc.dataEmissao)}}</td><td>{{cc.tomadorServicoNfse.dadosPessoais.nomeRazaoSocial}}</td></tr></tbody></table><span nfse-app-pagination></span></div></div><div class="modal-footer"><button class="btn btn-warning" ng-show="!continua && operacaoNovo" ng-click="continua = true"><span class="fa fa-check"></span>&nbsp; Continuar</button> <button type="submit" ng-click="enviarCarta()" ng-disabled="editForm.$invalid" ng-show="continua && operacaoNovo" class="btn btn-danger"><span class="fa fa-check"></span>&nbsp; <span>Enviar Carta</span></button> <button type="submit" ng-click="novaCarta()" ng-show="!operacaoNovo" class="btn btn-info"><span class="fa fa-check"></span>&nbsp; <span>Nova Carta</span></button></div>');
$templateCache.put('app/entities/notaFiscal/exportacaoxml/exportacao-xml.html','<div class="ibox animated fadeInDown"><div class="ibox-content"><div class="row"><div class="form-group col-md-3"><label>Tipo de Nota</label><select class="form-control" ng-required ng-model="tipoDocumento"><option value="EMITIDA">Emitidas</option><option value="RECEBIDA">Recebidas</option></select></div><div class="form-group col-md-3"><label>Filtro de Data</label><select class="form-control" ng-required ng-change="handleTipoData()" ng-model="tipoData"><option value="COMPETENCIA">Compet\xEAncia</option><option value="EMISSAO">Emiss\xE3o</option></select></div><div class="form-group col-md-3" ng-show="tipoData == \'COMPETENCIA\'"><label>Compet\xEAncia</label><select class="form-control" ng-required ng-model="competenciaMes" ng-options="mes as mes.descricao for mes in meses track by mes.numeroMes"></select></div><div class="form-group col-md-3" ng-show="tipoData == \'COMPETENCIA\'"><label>Ano</label><input class="form-control" ng-required maxlength="4" ng-model="competenciaAno"></div><div class="form-group col-md-3" ng-show="tipoData == \'EMISSAO\'"><label>Emiss\xE3o Inicial</label><input type="date" id="dataInicial" ng-model="dataInicial" class="form-control"></div><div class="form-group col-md-3" ng-show="tipoData == \'EMISSAO\'"><label>Emiss\xE3o Final</label><input type="date" ng-model="dataFinal" class="form-control"></div><div class="form-group col-md-3"><label>N\xB0 Nota Fiscal Inicial (Opcional)</label><input type="number" id="numeroNotaFiscalInicial" ng-model="numeroNotaFiscalInicial" class="form-control"></div><div class="form-group col-md-3"><label>N\xB0 Nota Fiscal Final (Opcional)</label><input type="number" id="numeroNotaFiscalFinal" ng-model="numeroNotaFiscalFinal" class="form-control"></div><div class="form-group col-md-3"><label>Tipo de XML</label><select class="form-control" ng-required ng-model="tipo"><option value="NORMAL">Agrupado</option><option value="INDIVIDUAL">Individual</option></select></div><div class="form-group col-md-3"><label>&nbsp;</label><button type="button" ng-click="exportarXml()" ng-show="!xml" class="btn btn-primary btn-outline btn-block"><span class="fa fa-code"></span> <span>Exportar XML</span></button></div></div><div class="row" ng-show="xml && xml.total > 0"><div class="col-md-12 text-center"><div class="progress m-b-1"><div style="width: {{baixarXml.percentual}}%" class="progress-bar progress-bar-striped progress-bar-animated"></div></div><div style="height: 50px" ng-show="xml.percentual < 100 || baixandoArquivo"><div class="sk-spinner sk-spinner-wave"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div><strong>{{xml.percentual}}%</strong><br><small>{{xml.calculados}}/{{xml.total}}</small><br><small ng-show="xml.percentual < 100">Gerando o XML, aguarde a finaliza\xE7\xE3o.</small> <strong ng-show="xml.percentual >= 100">XML Gerado.<br></strong><button type="button" ng-click="gerarArquivoXml()" ng-show="xml.percentual >= 100" class="btn btn-primary"><span class="fa fa-download"></span> <span>Baixar XML</span></button></div></div></div></div>');}]);})();